webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(896);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Full = __webpack_require__(897);

var _Full2 = _interopRequireDefault(_Full);

var _Login = __webpack_require__(925);

var _Login2 = _interopRequireDefault(_Login);

var _ManualLogin = __webpack_require__(989);

var _ManualLogin2 = _interopRequireDefault(_ManualLogin);

var _ResetPassword = __webpack_require__(1021);

var _ResetPassword2 = _interopRequireDefault(_ResetPassword);

var _Auth = __webpack_require__(1024);

var _Auth2 = _interopRequireDefault(_Auth);

var _submitForm = __webpack_require__(1026);

var _submitForm2 = _interopRequireDefault(_submitForm);

var _List = __webpack_require__(1035);

var _List2 = _interopRequireDefault(_List);

var _New = __webpack_require__(1040);

var _New2 = _interopRequireDefault(_New);

var _Train = __webpack_require__(1044);

var _Train2 = _interopRequireDefault(_Train);

var _Upload = __webpack_require__(1087);

var _Upload2 = _interopRequireDefault(_Upload);

var _ProcessedForms = __webpack_require__(1090);

var _ProcessedForms2 = _interopRequireDefault(_ProcessedForms);

var _processDoc = __webpack_require__(1098);

var _processDoc2 = _interopRequireDefault(_processDoc);

var _processForm = __webpack_require__(466);

var _processForm2 = _interopRequireDefault(_processForm);

var _modifyProcessType = __webpack_require__(1118);

var _modifyProcessType2 = _interopRequireDefault(_modifyProcessType);

var _Form = __webpack_require__(1135);

var _Form2 = _interopRequireDefault(_Form);

var _formsInsights = __webpack_require__(1192);

var _formsInsights2 = _interopRequireDefault(_formsInsights);

var _auditLogs = __webpack_require__(1196);

var _auditLogs2 = _interopRequireDefault(_auditLogs);

var _Trail = __webpack_require__(1199);

var _Trail2 = _interopRequireDefault(_Trail);

var _FeatureFlag = __webpack_require__(1202);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _Page = __webpack_require__(1212);

var _Page2 = _interopRequireDefault(_Page);

var _users = __webpack_require__(1215);

var _users2 = _interopRequireDefault(_users);

var _newUser = __webpack_require__(1221);

var _newUser2 = _interopRequireDefault(_newUser);

var _editUser = __webpack_require__(1226);

var _editUser2 = _interopRequireDefault(_editUser);

var _configurations = __webpack_require__(1229);

var _configurations2 = _interopRequireDefault(_configurations);

var _formStatus = __webpack_require__(1310);

var _formStatus2 = _interopRequireDefault(_formStatus);

var _accounts = __webpack_require__(1312);

var _accounts2 = _interopRequireDefault(_accounts);

var _newAccount = __webpack_require__(1315);

var _newAccount2 = _interopRequireDefault(_newAccount);

var _editAccount = __webpack_require__(1318);

var _editAccount2 = _interopRequireDefault(_editAccount);

var _models = __webpack_require__(1321);

var _models2 = _interopRequireDefault(_models);

var _main = __webpack_require__(1323);

var _main2 = _interopRequireDefault(_main);

var _profile = __webpack_require__(1325);

var _profile2 = _interopRequireDefault(_profile);

var _micpDemo = __webpack_require__(1328);

var _micpDemo2 = _interopRequireDefault(_micpDemo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const LogIn = () => import('@/views/auth/LogIn')
// const TrainTemplate = () => import('@/views/templates/Train')
// const uploadProcess = () => import('@/views/process/Upload')
// const processForm = () => import('@/views/forms/process')

// Views - Feature Flags


// Views - Reports


// Views - Templates


// Containers
_vue2.default.use(_vueRouter2.default);

// Gnext 2020 Medical Insurance Card Processing Demo


// Views - Pages


// Views - Audits


// Views - Process


// Views - Submission


// Views - Auth
// import Register from '@/views/auth/Register'


var router = new _vueRouter2.default({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/sign_in',
    name: 'Sign In',
    component: _Login2.default
  }, {
    path: '/log_in',
    name: 'Manual Login',
    component: _ManualLogin2.default
  }, {
    path: '/reset_password/:id/:token',
    name: 'ResetPassword',
    component: _ResetPassword2.default
  },
  // {
  //   path: '/sign_up',
  //   name: 'Register',
  //   component: Register
  // },
  {
    path: '/auth',
    name: 'Auth',
    component: _Auth2.default
  }, {
    path: '/submit/:tempDocId',
    name: 'submitForm',
    component: _submitForm2.default
  }, {
    path: '/medical_insurance_cards/demo',
    name: 'micpDemo',
    component: _micpDemo2.default,
    meta: { requiredAuth: true }
  }, {
    path: '/',
    redirect: '/dashboard',
    name: 'Home',
    component: _Full2.default,
    meta: { requiredAuth: true },
    children: [{
      name: 'Dashboard',
      path: '/dashboard',
      component: _main2.default
    }, {
      name: 'My Profile',
      path: '/profile',
      component: _profile2.default
    }, {
      path: '/templates',
      name: 'Templates',
      redirect: '/templates/list',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'list',
        name: 'Template Listing',
        component: _List2.default
      }, {
        path: 'new',
        name: 'New Template',
        component: _New2.default
      }, {
        path: ':id',
        name: 'Train',
        component: _Train2.default
      }]
    }, {
      path: '/process',
      redirect: '/process/upload',
      name: 'Form',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'upload',
        name: 'Upload Form',
        component: _Upload2.default
      }, {
        path: 'docs/:docId',
        name: 'Form Doc',
        component: _processDoc2.default
      }, {
        path: 'forms/:id',
        name: 'Verification',
        component: _processForm2.default
      }, {
        path: 'processed',
        name: 'Forms',
        component: _ProcessedForms2.default
      }, {
        path: 'modify/:id',
        name: 'Forms',
        component: _modifyProcessType2.default
      }]
    }, {
      path: '/reports',
      redirect: '/reports/form',
      name: 'Report',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'form',
        name: 'Reports',
        component: _Form2.default
      }, {
        path: 'insights',
        name: 'Reports Insights',
        component: _formsInsights2.default
      }, {
        path: 'logs',
        name: 'Audit Log Report',
        component: _auditLogs2.default
      }]
    }, {
      path: '/audits',
      redirect: '/audits/form',
      name: 'Audits',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'trail',
        name: 'Log History',
        component: _Trail2.default
      }]
    }, {
      path: '/admin',
      redirect: '/admin/users',
      name: 'Admin Route',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'users',
        name: 'Users',
        component: _users2.default
      }, {
        path: 'new',
        name: 'Add a New User',
        component: _newUser2.default
      }, {
        path: 'users/:id',
        name: 'Edit User',
        component: _editUser2.default
      }, {
        path: 'form_status',
        name: 'Form Status',
        component: _formStatus2.default
      }]
    }, {
      path: '/super_admin',
      redirect: '/super_admin/accounts',
      name: 'Super Admin',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'features',
        name: 'Features',
        component: _FeatureFlag2.default
      }, {
        path: 'accounts',
        name: 'Accounts',
        component: _accounts2.default
      }, {
        path: 'new',
        name: 'Add New Account',
        component: _newAccount2.default
      }, {
        path: 'accounts/:id',
        name: 'Edit Account',
        component: _editAccount2.default
      }, {
        path: 'models',
        name: 'MODELS',
        component: _models2.default
      }]
    }, {
      path: '/settings',
      redirect: '/settings/configure',
      name: 'Settings',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'configure',
        name: 'Configure',
        component: _configurations2.default
      }]
    }, {
      path: '/*',
      name: 'page-not-found',
      component: _Page2.default
    }]
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiredAuth;
  })) {
    if (to.query._sfdc_canvas_auth === 'user_approval_required') {
      next('/auth?redirect_to=' + to.path + '&service=salesforce&loginUrl=' + to.query.loginUrl);
    } else if (window.localStorage.getItem('idToken')) {
      if (window.localStorage.getItem('accountId') === '73') {
        if (window.localStorage.getItem('role') === 'admin' || to.path === '/medical_insurance_cards/demo') {
          next();
        } else {
          next('/medical_insurance_cards/demo');
        }
      } else {
        next();
      }
    } else if (to.path === '/sign_in') {
      next();
    } else {
      _vue2.default.toasted.show('Please login to access the requested page', {
        icon: 'key',
        type: 'error'
      });
      next('/sign_in?redirect_to=' + encodeURIComponent(to.fullPath));
    }
  } else {
    next();
  }
});

exports.default = router;

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  add: '<svg width="35" height="35" viewBox="0 0 22 28" fill="#ffffff">\n  <path d="M22 11.5v3c0 0.828-0.672 1.5-1.5 1.5h-6.5v6.5c0 0.828-0.672 1.5-1.5 1.5h-3c-0.828 0-1.5-0.672-1.5-1.5v-6.5h-6.5c-0.828 0-1.5-0.672-1.5-1.5v-3c0-0.828 0.672-1.5 1.5-1.5h6.5v-6.5c0-0.828 0.672-1.5 1.5-1.5h3c0.828 0 1.5 0.672 1.5 1.5v6.5h6.5c0.828 0 1.5 0.672 1.5 1.5z"></path>\n  </svg>',
  export: '<svg width="35" height="35" viewBox="0 0 32 32" fill="#ffffff">\n  <path d="M8 20c0 0 1.838-6 12-6v6l12-8-12-8v6c-8 0-12 4.99-12 10zM22 24h-18v-12h3.934c0.315-0.372 0.654-0.729 1.015-1.068 1.374-1.287 3.018-2.27 4.879-2.932h-13.827v20h26v-8.395l-4 2.667v1.728z"></path>\n  </svg>',
  templates: '<svg width="1.129cm" height="1.094cm" viewBox="0 0 32 32">\n<path fill-rule="evenodd"  fill="rgb(131, 146, 161)"\n d="M30.329,9.488 L25.848,9.488 L25.848,25.495 C25.848,28.186 23.765,30.375 21.205,30.375 C21.127,30.375 21.054,30.355 20.977,30.351 L20.977,30.375 L4.644,30.375 L4.644,30.375 C4.643,30.375 4.643,30.375 4.643,30.375 L4.449,30.375 L4.449,30.354 C1.980,30.244 -0.000,28.116 -0.000,25.495 L-0.000,23.003 C-0.000,22.438 0.436,21.979 0.974,21.979 L4.325,21.979 L4.449,3.713 C4.449,1.669 6.051,-0.000 8.021,-0.000 L27.602,-0.000 L27.602,0.000 C29.643,0.000 31.304,1.745 31.304,3.891 L31.304,8.464 C31.304,9.030 30.868,9.488 30.329,9.488 ZM1.948,24.027 L1.948,25.495 C1.948,27.056 3.157,28.327 4.643,28.327 L17.438,28.327 C16.892,27.527 16.561,26.553 16.561,25.495 L16.561,24.027 L1.948,24.027 ZM8.021,2.048 C7.126,2.048 6.397,2.798 6.397,3.720 L6.274,21.979 L17.535,21.979 C18.073,21.979 18.509,22.438 18.509,23.003 L18.509,25.495 C18.509,27.056 19.719,28.327 21.205,28.327 C22.691,28.327 23.900,27.056 23.900,25.495 L23.900,3.891 C23.900,3.221 24.077,2.599 24.362,2.048 L8.021,2.048 ZM29.355,3.891 C29.355,2.874 28.568,2.048 27.602,2.048 C26.635,2.048 25.848,2.874 25.848,3.891 L25.848,7.440 L29.355,7.440 L29.355,3.891 ZM20.328,20.034 L9.449,20.034 C8.911,20.034 8.475,19.576 8.475,19.010 C8.475,18.445 8.911,17.986 9.449,17.986 L20.328,17.986 C20.866,17.986 21.302,18.445 21.302,19.010 C21.302,19.576 20.866,20.034 20.328,20.034 ZM20.328,15.938 L9.449,15.938 C8.911,15.938 8.475,15.480 8.475,14.915 C8.475,14.349 8.911,13.891 9.449,13.891 L20.328,13.891 C20.866,13.891 21.302,14.349 21.302,14.915 C21.302,15.480 20.866,15.938 20.328,15.938 ZM20.328,11.843 L9.449,11.843 C8.911,11.843 8.475,11.385 8.475,10.819 C8.475,10.254 8.911,9.795 9.449,9.795 L20.328,9.795 C20.866,9.795 21.302,10.254 21.302,10.819 C21.302,11.385 20.866,11.843 20.328,11.843 ZM14.483,7.747 L9.449,7.747 C8.911,7.747 8.475,7.289 8.475,6.724 C8.475,6.158 8.911,5.700 9.449,5.700 L14.483,5.700 C15.021,5.700 15.457,6.158 15.457,6.724 C15.457,7.289 15.021,7.747 14.483,7.747 Z"/>\n</svg>',
  forms: '<svg width="1.094cm" height="1.094cm" viewBox="0 0 32 32">\n<path fill-rule="evenodd"  fill="rgb(131, 146, 161)"\nd="M29.042,30.375 L22.771,30.375 C22.079,30.375 21.517,29.809 21.517,29.110 L21.517,25.313 C21.517,24.614 22.079,24.047 22.771,24.047 L29.042,24.047 C29.735,24.047 30.296,24.614 30.296,25.313 L30.296,29.110 C30.296,29.809 29.735,30.375 29.042,30.375 ZM29.042,25.313 L22.771,25.313 L22.771,29.110 L29.042,29.110 L29.042,25.313 ZM25.279,27.844 L24.025,27.844 L24.025,26.578 L25.279,26.578 L25.279,27.844 ZM27.788,27.844 L26.534,27.844 L26.534,26.578 L27.788,26.578 L27.788,27.844 ZM29.042,12.656 L26.083,12.656 C25.803,12.656 25.558,12.470 25.480,12.199 C25.262,11.433 24.961,10.693 24.581,9.995 C24.446,9.748 24.489,9.440 24.686,9.241 L26.775,7.133 L23.228,3.553 L21.141,5.661 C20.943,5.860 20.639,5.904 20.395,5.767 C19.701,5.384 18.968,5.080 18.208,4.860 C17.939,4.782 17.755,4.534 17.755,4.252 L17.755,1.266 L12.738,1.266 L12.738,4.252 C12.738,4.534 12.553,4.782 12.285,4.860 C11.525,5.080 10.793,5.384 10.100,5.767 C9.856,5.904 9.552,5.860 9.354,5.661 L7.265,3.553 L3.717,7.133 L5.806,9.239 C6.004,9.439 6.047,9.746 5.912,9.993 C5.531,10.692 5.230,11.432 5.012,12.199 C4.935,12.470 4.689,12.656 4.410,12.656 L1.451,12.656 L1.451,15.188 L0.196,15.188 L0.196,12.656 C0.196,11.957 0.758,11.391 1.451,11.391 L3.948,11.391 C4.125,10.848 4.341,10.320 4.594,9.809 L2.830,8.028 C2.340,7.534 2.340,6.733 2.830,6.238 L6.378,2.658 C6.874,2.179 7.656,2.179 8.152,2.658 L9.914,4.436 C10.421,4.182 10.946,3.964 11.484,3.786 L11.484,1.266 C11.484,0.567 12.045,-0.000 12.738,-0.000 L17.755,-0.000 C18.447,-0.000 19.009,0.567 19.009,1.266 L19.009,3.786 C19.546,3.965 20.070,4.182 20.577,4.437 L22.341,2.658 C22.837,2.180 23.618,2.180 24.115,2.658 L27.662,6.238 C28.152,6.733 28.152,7.534 27.663,8.028 C27.663,8.028 27.663,8.028 27.662,8.029 L25.900,9.807 C26.153,10.318 26.369,10.847 26.546,11.389 L29.042,11.389 C29.735,11.389 30.296,11.955 30.296,12.654 L30.296,15.188 L29.042,15.188 L29.042,12.656 ZM3.959,13.922 L3.959,15.188 L2.705,15.188 L2.705,13.922 L3.959,13.922 ZM1.451,24.047 L7.721,24.047 C8.414,24.047 8.976,24.614 8.976,25.313 L8.976,29.110 C8.976,29.809 8.414,30.375 7.721,30.375 L1.451,30.375 C0.758,30.375 0.196,29.809 0.196,29.110 L0.196,25.313 C0.196,24.614 0.758,24.047 1.451,24.047 ZM1.451,29.110 L7.721,29.110 L7.721,25.313 L1.451,25.313 L1.451,29.110 ZM5.213,26.578 L6.467,26.578 L6.467,27.844 L5.213,27.844 L5.213,26.578 ZM2.705,26.578 L3.959,26.578 L3.959,27.844 L2.705,27.844 L2.705,26.578 ZM7.722,6.328 L7.722,7.594 L6.467,7.594 L6.467,6.328 L7.722,6.328 ZM12.111,15.188 L12.111,14.555 C12.111,12.807 13.515,11.391 15.246,11.391 C16.978,11.391 18.382,12.807 18.382,14.555 L18.382,15.188 L17.128,15.188 L17.128,14.555 C17.128,13.506 16.285,12.656 15.246,12.656 C14.207,12.656 13.365,13.506 13.365,14.555 L13.365,15.188 L12.111,15.188 ZM14.619,2.531 L15.873,2.531 L15.873,3.797 L14.619,3.797 L14.619,2.531 ZM21.517,14.555 L21.517,15.188 L20.263,15.188 L20.263,14.555 C20.263,11.759 18.017,9.492 15.246,9.492 C12.476,9.492 10.230,11.759 10.230,14.555 L10.230,15.188 L8.976,15.188 L8.976,14.555 C8.976,11.060 11.783,8.227 15.246,8.227 C18.710,8.227 21.517,11.060 21.517,14.555 ZM24.025,6.328 L24.025,7.594 L22.771,7.594 L22.771,6.328 L24.025,6.328 ZM26.534,13.922 L27.788,13.922 L27.788,15.188 L26.534,15.188 L26.534,13.922 ZM25.279,20.250 L15.873,20.250 L15.873,22.781 L14.619,22.781 L14.619,20.250 L5.213,20.250 L5.213,22.781 L3.959,22.781 L3.959,19.617 C3.959,19.268 4.240,18.985 4.586,18.985 L14.619,18.985 L14.619,14.555 L15.873,14.555 L15.873,18.985 L25.907,18.985 C26.253,18.985 26.534,19.268 26.534,19.617 L26.534,22.781 L25.279,22.781 L25.279,20.250 ZM12.111,24.047 L18.382,24.047 C19.074,24.047 19.636,24.614 19.636,25.313 L19.636,29.110 C19.636,29.809 19.074,30.375 18.382,30.375 L12.111,30.375 C11.418,30.375 10.857,29.809 10.857,29.110 L10.857,25.313 C10.857,24.614 11.418,24.047 12.111,24.047 ZM12.111,29.110 L18.382,29.110 L18.382,29.110 L18.382,25.313 L12.111,25.313 L12.111,29.110 ZM15.874,26.578 L17.128,26.578 L17.128,27.844 L15.874,27.844 L15.874,26.578 ZM13.365,26.578 L14.619,26.578 L14.619,27.844 L13.365,27.844 L13.365,26.578 Z"/>\n</svg>',
  uploadScan: '<svg width="1.199cm" height="1.094cm" viewBox="0 0 32 32">\n <path fill-rule="evenodd"  fill="rgb(131, 146, 161)"\n  d="M31.721,22.152 C30.239,23.766 28.246,24.731 26.114,24.883 C26.086,24.883 26.064,24.883 26.044,24.883 L20.856,24.883 C20.331,24.883 19.912,24.469 19.912,23.952 C19.912,23.434 20.331,23.021 20.856,23.021 L26.009,23.021 C29.379,22.765 32.112,19.786 32.112,16.359 C32.112,13.124 29.763,10.290 26.652,9.765 C26.232,9.697 25.911,9.359 25.869,8.938 C25.477,4.897 22.072,1.848 17.947,1.848 C14.878,1.848 12.053,3.614 10.746,6.352 C10.536,6.786 10.026,6.993 9.564,6.828 C9.187,6.690 8.781,6.621 8.369,6.621 C6.439,6.621 4.866,8.172 4.866,10.076 C4.866,10.497 4.936,10.890 5.076,11.262 C5.230,11.690 5.062,12.165 4.663,12.393 C2.950,13.379 1.888,15.200 1.888,17.152 C1.888,20.172 4.293,22.855 7.152,23.028 L13.137,23.028 C13.661,23.028 14.081,23.441 14.081,23.959 C14.081,24.476 13.661,24.890 13.137,24.890 L7.124,24.890 C7.103,24.890 7.089,24.890 7.068,24.890 C5.167,24.786 3.384,23.897 2.034,22.393 C0.720,20.924 -0.000,19.069 -0.000,17.159 C-0.000,14.793 1.168,12.572 3.090,11.193 C3.020,10.834 2.978,10.469 2.978,10.090 C2.978,7.159 5.397,4.772 8.369,4.772 C8.718,4.772 9.068,4.807 9.404,4.869 C10.180,3.531 11.277,2.393 12.599,1.552 C14.186,0.538 16.039,-0.000 17.940,-0.000 C20.401,-0.000 22.764,0.903 24.582,2.545 C26.218,4.021 27.288,5.966 27.652,8.097 C31.315,9.048 33.993,12.490 34.000,16.359 C34.000,18.497 33.196,20.552 31.721,22.152 ZM12.004,18.317 C11.767,18.317 11.522,18.221 11.340,18.041 C10.970,17.676 10.970,17.090 11.340,16.724 L16.339,11.793 C16.514,11.614 16.759,11.517 17.003,11.517 C17.248,11.517 17.493,11.621 17.668,11.793 L22.667,16.724 C23.037,17.090 23.037,17.676 22.667,18.041 C22.296,18.407 21.702,18.407 21.338,18.041 L17.947,14.697 L17.947,30.069 C17.947,30.586 17.528,31.000 17.003,31.000 C16.479,31.000 16.060,30.586 16.060,30.069 L16.060,14.697 L12.669,18.041 C12.487,18.228 12.242,18.317 12.004,18.317 Z"/>\n </svg>',
  reports: '<svg width="1.094cm" height="1.094cm" viewBox="0 0 32 32">\n<path fill-rule="evenodd"  fill="rgb(131, 146, 161)"\n d="M29.236,31.000 L7.602,31.000 C6.630,31.000 5.838,30.202 5.838,29.220 L5.838,24.138 C5.838,23.810 6.102,23.545 6.426,23.545 C6.751,23.545 7.014,23.810 7.014,24.138 L7.014,29.220 C7.014,29.547 7.278,29.813 7.602,29.813 L29.236,29.813 C29.560,29.813 29.824,29.547 29.824,29.220 L29.824,7.210 L26.238,7.210 C25.266,7.210 24.474,6.412 24.474,5.430 L24.474,1.811 L7.602,1.811 C7.278,1.811 7.014,2.077 7.014,2.405 L7.014,3.177 C7.547,3.060 8.099,2.998 8.666,2.998 C8.990,2.998 9.253,3.264 9.253,3.591 L9.253,10.834 C9.253,11.162 8.990,11.428 8.666,11.428 L1.488,11.428 C1.163,11.428 0.900,11.162 0.900,10.834 C0.900,7.519 2.950,4.679 5.838,3.536 L5.838,2.405 C5.838,1.423 6.630,0.625 7.602,0.625 L25.062,0.625 C25.218,0.625 25.368,0.687 25.478,0.799 L30.828,6.196 C30.938,6.308 31.000,6.459 31.000,6.616 L31.000,29.220 C31.000,30.202 30.209,31.000 29.236,31.000 ZM2.102,10.241 L8.078,10.241 L8.078,4.211 C4.912,4.494 2.383,7.046 2.102,10.241 ZM25.650,2.650 L25.650,5.430 C25.650,5.757 25.914,6.023 26.238,6.023 L28.993,6.023 L25.650,2.650 ZM26.808,14.740 C26.917,14.851 26.980,15.004 26.980,15.160 C26.980,15.316 26.917,15.469 26.808,15.579 C26.698,15.690 26.547,15.753 26.392,15.753 C26.237,15.753 26.086,15.690 25.976,15.579 C25.867,15.469 25.804,15.316 25.804,15.160 C25.804,15.004 25.867,14.851 25.976,14.740 C26.086,14.630 26.237,14.567 26.392,14.567 C26.547,14.567 26.698,14.630 26.808,14.740 ZM20.613,14.567 L23.715,14.567 C24.040,14.567 24.303,14.832 24.303,15.160 C24.303,15.487 24.040,15.753 23.715,15.753 L20.613,15.753 C20.288,15.753 20.025,15.487 20.025,15.160 C20.025,14.832 20.288,14.567 20.613,14.567 ZM27.794,10.058 L20.613,10.058 C20.288,10.058 20.025,9.792 20.025,9.464 C20.025,9.137 20.288,8.871 20.613,8.871 L27.794,8.871 C28.119,8.871 28.382,9.137 28.382,9.464 C28.382,9.792 28.119,10.058 27.794,10.058 ZM27.794,12.905 L20.613,12.905 C20.288,12.905 20.025,12.640 20.025,12.312 C20.025,11.985 20.288,11.719 20.613,11.719 L27.794,11.719 C28.119,11.719 28.382,11.985 28.382,12.312 C28.382,12.640 28.119,12.905 27.794,12.905 ZM11.712,28.623 C10.739,28.623 9.948,27.825 9.948,26.843 C9.948,25.862 10.739,25.064 11.712,25.064 C11.983,25.064 12.240,25.126 12.470,25.237 L14.627,23.060 C14.523,22.833 14.465,22.581 14.465,22.315 C14.465,21.333 15.256,20.535 16.228,20.535 C17.201,20.535 17.992,21.333 17.992,22.315 C17.992,22.543 17.949,22.761 17.871,22.962 L20.120,25.232 C20.348,25.123 20.604,25.061 20.873,25.061 C21.149,25.061 21.410,25.126 21.643,25.240 L25.030,21.822 C24.940,21.609 24.890,21.374 24.890,21.128 C24.890,20.147 25.681,19.349 26.654,19.349 C27.626,19.349 28.417,20.147 28.417,21.128 C28.417,22.110 27.626,22.908 26.654,22.908 C26.354,22.908 26.072,22.832 25.824,22.698 L22.469,26.084 C22.576,26.314 22.637,26.571 22.637,26.841 C22.637,27.822 21.845,28.621 20.873,28.621 C19.900,28.621 19.109,27.822 19.109,26.841 C19.109,26.564 19.172,26.301 19.285,26.067 L17.099,23.862 C16.842,24.010 16.545,24.095 16.228,24.095 C15.948,24.095 15.683,24.028 15.447,23.910 L13.302,26.075 C13.413,26.308 13.475,26.568 13.475,26.843 C13.475,27.825 12.684,28.623 11.712,28.623 ZM12.134,26.432 C12.131,26.429 12.128,26.427 12.125,26.424 C12.123,26.421 12.121,26.419 12.118,26.416 C12.013,26.314 11.869,26.250 11.712,26.250 C11.387,26.250 11.124,26.516 11.124,26.843 C11.124,27.171 11.387,27.437 11.712,27.437 C12.036,27.437 12.300,27.171 12.300,26.843 C12.300,26.684 12.236,26.538 12.134,26.432 ZM26.654,21.722 C26.978,21.722 27.242,21.455 27.242,21.128 C27.242,20.801 26.978,20.535 26.654,20.535 C26.330,20.535 26.066,20.801 26.066,21.128 C26.066,21.455 26.330,21.722 26.654,21.722 ZM20.873,27.434 C21.197,27.434 21.461,27.168 21.461,26.841 C21.461,26.514 21.197,26.248 20.873,26.248 C20.549,26.248 20.285,26.514 20.285,26.841 C20.285,27.168 20.549,27.434 20.873,27.434 ZM16.228,22.908 C16.552,22.908 16.816,22.642 16.816,22.315 C16.816,21.988 16.552,21.722 16.228,21.722 C15.904,21.722 15.640,21.988 15.640,22.315 C15.640,22.642 15.904,22.908 16.228,22.908 ZM6.842,21.563 C6.951,21.673 7.014,21.826 7.014,21.982 C7.014,22.138 6.951,22.291 6.842,22.402 C6.732,22.512 6.581,22.576 6.426,22.576 C6.272,22.576 6.120,22.512 6.011,22.402 C5.901,22.291 5.838,22.138 5.838,21.982 C5.838,21.826 5.901,21.673 6.011,21.563 C6.120,21.453 6.272,21.389 6.426,21.389 C6.581,21.389 6.732,21.453 6.842,21.563 ZM3.594,12.366 L10.183,12.366 L10.183,5.716 C10.183,5.388 10.447,5.123 10.771,5.123 C15.053,5.123 18.537,8.638 18.537,12.959 C18.537,17.280 15.053,20.796 10.771,20.796 C6.489,20.796 3.006,17.280 3.006,12.959 C3.006,12.632 3.269,12.366 3.594,12.366 ZM11.359,6.336 L11.359,11.527 L14.994,7.859 C13.991,7.011 12.735,6.459 11.359,6.336 ZM10.771,19.609 C14.405,19.609 17.361,16.626 17.361,12.959 C17.361,11.339 16.784,9.852 15.826,8.697 L11.187,13.379 C11.187,13.379 11.187,13.379 11.187,13.379 C11.080,13.486 10.934,13.553 10.771,13.553 L4.208,13.553 C4.506,16.943 7.336,19.609 10.771,19.609 Z"/>\n</svg>',
  settings: '<svg width="2.858cm" height="2.575cm" viewBox="0 0 85 70">\n <path fill-rule="evenodd"  fill="rgb(131, 146, 161)"\n  d="M74.250,24.333 L74.250,71.648 C74.250,72.396 73.647,73.000 72.900,73.000 C72.153,73.000 71.550,72.396 71.550,71.648 L71.550,24.333 L64.800,24.333 L64.800,5.407 L71.550,5.407 L71.550,1.352 C71.550,0.604 72.153,-0.000 72.900,-0.000 C73.647,-0.000 74.250,0.604 74.250,1.352 L74.250,5.407 L81.000,5.407 L81.000,24.333 L74.250,24.333 ZM78.300,8.111 L67.500,8.111 L67.500,21.630 L78.300,21.630 L78.300,8.111 ZM71.550,10.815 L74.250,10.815 C74.997,10.815 75.600,11.419 75.600,12.167 C75.600,12.914 74.997,13.518 74.250,13.518 L71.550,13.518 C70.803,13.518 70.200,12.914 70.200,12.167 C70.200,11.419 70.803,10.815 71.550,10.815 ZM71.550,16.222 L74.250,16.222 C74.997,16.222 75.600,16.826 75.600,17.574 C75.600,18.322 74.997,18.926 74.250,18.926 L71.550,18.926 C70.803,18.926 70.200,18.322 70.200,17.574 C70.200,16.826 70.803,16.222 71.550,16.222 ZM52.650,71.648 C52.650,72.396 52.047,73.000 51.300,73.000 C50.553,73.000 49.950,72.396 49.950,71.648 L49.950,40.556 L43.200,40.556 L43.200,21.630 L49.950,21.630 L49.950,1.352 C49.950,0.604 50.553,-0.000 51.300,-0.000 C52.047,-0.000 52.650,0.604 52.650,1.352 L52.650,21.630 L59.400,21.630 L59.400,40.556 L52.650,40.556 L52.650,71.648 ZM56.700,37.852 L56.700,24.333 L45.900,24.333 L45.900,37.852 L56.700,37.852 ZM49.950,27.037 L52.650,27.037 C53.396,27.037 54.000,27.641 54.000,28.389 C54.000,29.136 53.396,29.741 52.650,29.741 L49.950,29.741 C49.203,29.741 48.600,29.136 48.600,28.389 C48.600,27.641 49.203,27.037 49.950,27.037 ZM49.950,32.444 L52.650,32.444 C53.396,32.444 54.000,33.049 54.000,33.796 C54.000,34.544 53.396,35.148 52.650,35.148 L49.950,35.148 C49.203,35.148 48.600,34.544 48.600,33.796 C48.600,33.049 49.203,32.444 49.950,32.444 ZM31.050,71.648 C31.050,72.396 30.446,73.000 29.700,73.000 C28.953,73.000 28.350,72.396 28.350,71.648 L28.350,54.074 L21.600,54.074 L21.600,35.148 L28.350,35.148 L28.350,1.352 C28.350,0.604 28.953,-0.000 29.700,-0.000 C30.446,-0.000 31.050,0.604 31.050,1.352 L31.050,35.148 L37.800,35.148 L37.800,54.074 L31.050,54.074 L31.050,71.648 ZM35.100,51.370 L35.100,37.852 L24.300,37.852 L24.300,51.370 L35.100,51.370 ZM28.350,40.556 L31.050,40.556 C31.796,40.556 32.400,41.160 32.400,41.907 C32.400,42.655 31.796,43.259 31.050,43.259 L28.350,43.259 C27.603,43.259 27.000,42.655 27.000,41.907 C27.000,41.160 27.603,40.556 28.350,40.556 ZM28.350,45.963 L31.050,45.963 C31.796,45.963 32.400,46.567 32.400,47.315 C32.400,48.062 31.796,48.667 31.050,48.667 L28.350,48.667 C27.603,48.667 27.000,48.062 27.000,47.315 C27.000,46.567 27.603,45.963 28.350,45.963 ZM9.450,71.648 C9.450,72.396 8.846,73.000 8.100,73.000 C7.353,73.000 6.750,72.396 6.750,71.648 L6.750,67.593 L-0.000,67.593 L-0.000,48.667 L6.750,48.667 L6.750,1.352 C6.750,0.604 7.353,-0.000 8.100,-0.000 C8.846,-0.000 9.450,0.604 9.450,1.352 L9.450,48.667 L16.200,48.667 L16.200,67.593 L9.450,67.593 L9.450,71.648 ZM13.500,64.889 L13.500,51.370 L2.700,51.370 L2.700,64.889 L13.500,64.889 ZM6.750,54.074 L9.450,54.074 C10.197,54.074 10.800,54.678 10.800,55.426 C10.800,56.173 10.197,56.778 9.450,56.778 L6.750,56.778 C6.003,56.778 5.400,56.173 5.400,55.426 C5.400,54.678 6.003,54.074 6.750,54.074 ZM6.750,59.481 L9.450,59.481 C10.197,59.481 10.800,60.086 10.800,60.833 C10.800,61.581 10.197,62.185 9.450,62.185 L6.750,62.185 C6.003,62.185 5.400,61.581 5.400,60.833 C5.400,60.086 6.003,59.481 6.750,59.481 Z"/>\n </svg>',
  logs: '<svg width="2.928cm" height="2.505cm" viewBox="0 0 85 70">\n <path fill-rule="evenodd"  fill="rgb(131, 146, 161)"\n  d="M48.962,38.107 L58.385,45.203 L55.244,49.408 L43.728,40.735 L43.728,11.826 L48.962,11.826 L48.962,38.107 ZM78.212,53.274 C68.424,70.225 46.803,76.000 29.921,66.172 L32.552,61.628 C35.497,63.342 38.711,64.540 42.056,65.174 C58.375,68.262 74.097,57.482 77.173,41.097 C80.249,24.711 69.514,8.925 53.195,5.836 C36.876,2.748 21.154,13.527 18.078,29.913 L26.173,21.795 L29.874,25.511 L14.937,40.509 L-0.000,25.511 L3.701,21.795 L12.665,30.796 C15.011,13.186 29.960,0.029 47.654,-0.000 C53.875,0.002 59.985,1.653 65.367,4.786 C82.249,14.614 88.000,36.323 78.212,53.274 ZM22.232,51.668 L17.816,54.485 C16.802,52.888 15.919,51.211 15.175,49.471 L19.986,47.397 C20.619,48.879 21.370,50.307 22.232,51.668 ZM28.600,58.869 L25.281,62.942 C23.827,61.743 22.469,60.431 21.219,59.018 L25.145,55.528 C26.206,56.732 27.362,57.849 28.600,58.869 Z"/>\n </svg>',
  users: '<svg width="2.54cm" height="2.54cm" viewBox="0 0 85 70">\n <path fill-rule="evenodd"  fill="rgb(131, 146, 161)"\n  d="M42.768,52.836 C42.398,52.836 42.036,52.685 41.774,52.424 C41.511,52.162 41.362,51.799 41.362,51.429 C41.362,51.060 41.511,50.697 41.774,50.435 C42.036,50.172 42.398,50.023 42.768,50.023 C43.138,50.023 43.501,50.172 43.762,50.435 C44.024,50.697 44.174,51.060 44.174,51.429 C44.174,51.799 44.024,52.162 43.762,52.424 C43.499,52.685 43.138,52.836 42.768,52.836 ZM67.565,47.612 L66.385,47.612 L66.385,70.594 C66.385,71.370 65.756,72.000 64.979,72.000 L58.800,72.000 C58.797,72.000 58.794,72.000 58.791,72.000 C58.788,72.000 58.786,72.000 58.783,72.000 L52.604,72.000 C51.827,72.000 51.198,71.370 51.198,70.594 L51.198,47.612 L49.998,47.612 C47.565,47.612 45.584,45.643 45.563,43.215 C45.118,43.382 44.654,43.508 44.174,43.591 L44.174,46.085 C44.174,46.862 43.544,47.492 42.768,47.492 C41.991,47.492 41.361,46.862 41.361,46.085 L41.361,39.313 L30.674,39.313 L30.674,69.187 L34.612,69.187 L34.612,45.465 C34.612,44.688 35.241,44.059 36.018,44.059 C36.794,44.059 37.424,44.688 37.424,45.465 L37.424,69.187 L41.361,69.187 L41.361,56.960 C41.361,56.184 41.991,55.554 42.768,55.554 C43.544,55.554 44.174,56.184 44.174,56.960 L44.174,70.594 C44.174,71.370 43.544,72.000 42.768,72.000 L29.268,72.000 C28.491,72.000 27.862,71.370 27.862,70.594 L27.862,43.591 C27.369,43.506 26.893,43.375 26.437,43.201 C26.424,45.635 24.440,47.612 22.002,47.612 L20.802,47.612 L20.802,70.594 C20.802,71.370 20.173,72.000 19.396,72.000 L13.217,72.000 C13.214,72.000 13.212,72.000 13.209,72.000 C13.206,72.000 13.203,72.000 13.200,72.000 L7.021,72.000 C6.244,72.000 5.615,71.370 5.615,70.594 L5.615,47.612 L4.435,47.612 C1.989,47.612 -0.000,45.622 -0.000,43.177 L-0.000,31.667 C-0.000,26.568 3.458,22.263 8.152,20.969 C7.233,19.843 6.681,18.406 6.681,16.843 L6.681,15.560 C6.681,11.955 9.614,9.022 13.219,9.022 C16.824,9.022 19.757,11.955 19.757,15.560 L19.757,16.843 C19.757,18.407 19.204,19.844 18.285,20.970 C19.419,21.283 20.498,21.776 21.479,22.427 L21.479,21.383 C21.479,17.140 24.931,13.687 29.174,13.687 L30.082,13.687 C28.993,12.362 28.338,10.666 28.338,8.820 L28.338,7.680 C28.338,3.445 31.783,-0.000 36.018,-0.000 C40.252,-0.000 43.697,3.445 43.698,7.680 L43.698,8.820 C43.698,10.666 43.043,12.361 41.953,13.687 L42.862,13.687 C47.105,13.687 50.557,17.140 50.557,21.383 L50.557,22.402 C51.528,21.763 52.595,21.279 53.715,20.970 C52.796,19.844 52.243,18.407 52.243,16.843 L52.243,15.560 C52.243,11.955 55.176,9.022 58.781,9.022 C62.386,9.022 65.319,11.955 65.319,15.560 L65.319,16.843 C65.319,18.406 64.767,19.843 63.848,20.969 C68.542,22.263 72.000,26.568 72.000,31.667 L72.000,43.177 C72.000,45.622 70.010,47.612 67.565,47.612 ZM8.427,69.187 L11.793,69.187 L11.793,49.219 C11.793,49.147 11.801,49.077 11.811,49.008 L11.811,47.531 C11.811,46.755 12.441,46.125 13.217,46.125 C13.994,46.125 14.624,46.755 14.624,47.531 L14.624,69.187 L17.990,69.187 L17.990,42.046 L8.427,42.046 L8.427,69.187 ZM16.944,15.560 C16.944,13.506 15.273,11.834 13.219,11.834 C11.164,11.834 9.493,13.506 9.493,15.560 L9.493,16.843 C9.493,18.897 11.164,20.568 13.219,20.568 C15.273,20.568 16.944,18.897 16.944,16.843 L16.944,15.560 ZM23.625,41.333 C22.297,39.950 21.479,38.074 21.479,36.010 L21.479,26.103 C21.478,26.102 21.477,26.101 21.477,26.101 C19.908,24.372 17.671,23.381 15.339,23.381 L11.098,23.381 C6.529,23.381 2.812,27.098 2.812,31.667 L2.812,43.176 C2.812,44.071 3.540,44.799 4.435,44.799 L5.615,44.799 L5.615,32.838 C5.615,32.062 6.244,31.432 7.021,31.432 C7.798,31.432 8.427,32.062 8.427,32.838 L8.427,39.233 L17.990,39.233 L17.990,37.314 C17.990,36.538 18.619,35.908 19.396,35.908 C20.173,35.908 20.802,36.538 20.802,37.314 L20.802,44.799 L22.002,44.799 C22.897,44.799 23.625,44.071 23.625,43.176 L23.625,41.333 ZM40.885,7.680 C40.885,4.996 38.702,2.812 36.018,2.812 C33.334,2.812 31.151,4.996 31.151,7.680 L31.151,8.820 C31.151,11.504 33.334,13.687 36.018,13.687 C38.702,13.687 40.885,11.504 40.885,8.820 L40.885,7.680 ZM47.744,21.383 C47.744,18.690 45.554,16.500 42.861,16.500 L37.377,16.500 L37.377,20.343 C37.377,21.119 36.747,21.749 35.971,21.749 C35.194,21.749 34.565,21.119 34.565,20.343 L34.565,16.500 L29.174,16.500 C26.482,16.500 24.291,18.690 24.291,21.383 L24.291,36.010 C24.291,38.248 25.805,40.137 27.862,40.712 L27.862,21.383 C27.862,20.606 28.491,19.977 29.268,19.977 C30.044,19.977 30.674,20.606 30.674,21.383 L30.674,36.500 L41.361,36.500 L41.361,21.383 C41.361,20.606 41.991,19.977 42.768,19.977 C43.544,19.977 44.174,20.606 44.174,21.383 L44.174,40.712 C46.231,40.138 47.744,38.248 47.744,36.010 L47.744,21.383 ZM54.010,69.187 L57.376,69.187 L57.376,47.531 C57.376,46.755 58.006,46.125 58.782,46.125 C59.559,46.125 60.189,46.755 60.189,47.531 L60.189,49.008 C60.199,49.077 60.206,49.147 60.206,49.219 L60.206,69.187 L63.572,69.187 L63.572,42.046 L54.010,42.046 L54.010,69.187 ZM62.507,15.560 C62.507,13.506 60.835,11.834 58.781,11.834 C56.727,11.834 55.056,13.506 55.056,15.560 L55.056,16.843 C55.056,18.897 56.727,20.568 58.781,20.568 C60.835,20.568 62.507,18.897 62.507,16.843 L62.507,15.560 ZM69.187,43.177 L69.187,31.667 C69.187,27.098 65.470,23.381 60.901,23.381 L56.661,23.381 C54.345,23.381 52.123,24.359 50.557,26.066 L50.557,36.010 C50.557,38.093 49.724,39.984 48.375,41.371 L48.375,43.177 C48.375,44.071 49.103,44.799 49.997,44.799 L51.198,44.799 L51.198,37.315 C51.198,36.538 51.827,35.908 52.604,35.908 C53.380,35.908 54.010,36.538 54.010,37.315 L54.010,39.234 L63.572,39.234 L63.572,32.838 C63.572,32.062 64.202,31.432 64.979,31.432 C65.755,31.432 66.385,32.062 66.385,32.838 L66.385,44.799 L67.565,44.799 C68.459,44.799 69.187,44.071 69.187,43.177 L69.187,43.177 ZM35.970,27.004 C35.601,27.004 35.238,26.854 34.976,26.592 C34.715,26.331 34.564,25.968 34.564,25.598 C34.564,25.228 34.715,24.865 34.976,24.604 C35.238,24.342 35.601,24.192 35.970,24.192 C36.342,24.192 36.703,24.342 36.965,24.604 C37.228,24.865 37.377,25.228 37.377,25.598 C37.377,25.968 37.228,26.331 36.965,26.592 C36.703,26.854 36.342,27.004 35.970,27.004 Z"/>\n </svg>',
  bell: '<svg\n xmlns="http://www.w3.org/2000/svg"\n xmlns:xlink="http://www.w3.org/1999/xlink"\n width="0.847cm" height="0.847cm">\n<path fill-rule="evenodd"  fill="rgb(0, 0, 0)"\n d="M23.789,16.339 C23.671,16.482 23.501,16.556 23.330,16.556 C23.196,16.556 23.061,16.510 22.949,16.417 C20.899,14.702 20.414,12.940 20.151,9.873 C20.123,9.543 20.366,9.252 20.694,9.224 C21.022,9.195 21.311,9.440 21.339,9.770 C21.583,12.610 21.966,14.033 23.712,15.494 C23.965,15.706 24.000,16.084 23.789,16.339 ZM20.665,8.777 C20.623,8.786 20.581,8.791 20.540,8.791 C20.265,8.791 20.017,8.597 19.957,8.316 C19.936,8.215 19.912,8.113 19.887,8.014 C19.806,7.692 19.999,7.366 20.318,7.284 C20.637,7.203 20.962,7.397 21.043,7.718 C21.072,7.832 21.099,7.949 21.124,8.065 C21.193,8.389 20.987,8.708 20.665,8.777 ZM21.818,17.045 C22.040,17.173 22.223,17.371 22.368,17.629 C22.377,17.644 22.386,17.660 22.394,17.676 C22.539,17.954 22.641,18.300 22.694,18.706 C22.764,19.236 22.785,20.350 22.369,20.768 C22.257,20.881 22.106,20.944 21.948,20.944 L15.583,20.944 C15.297,22.675 13.799,24.000 11.998,24.000 C10.197,24.000 8.699,22.675 8.413,20.944 L2.049,20.944 C1.891,20.944 1.739,20.881 1.627,20.768 C1.211,20.350 1.233,19.237 1.302,18.707 C1.409,17.890 1.712,17.315 2.178,17.045 C3.787,16.110 4.762,13.567 5.073,9.487 C5.304,6.461 7.449,3.981 10.240,3.233 C10.032,2.906 9.910,2.518 9.910,2.101 C9.910,0.942 10.847,-0.000 11.998,-0.000 C13.150,-0.000 14.087,0.942 14.086,2.101 C14.086,2.517 13.965,2.906 13.756,3.233 C16.547,3.981 18.692,6.461 18.923,9.487 C19.234,13.567 20.209,16.110 21.818,17.045 ZM11.998,22.800 C13.139,22.800 14.099,22.009 14.366,20.944 L9.630,20.944 C9.897,22.009 10.857,22.800 11.998,22.800 ZM11.998,1.200 C11.504,1.200 11.103,1.604 11.103,2.101 C11.103,2.597 11.504,3.002 11.998,3.002 C12.492,3.002 12.894,2.597 12.894,2.101 C12.894,1.604 12.492,1.200 11.998,1.200 ZM19.366,16.144 L16.552,16.144 C16.223,16.144 15.956,15.875 15.956,15.544 C15.956,15.213 16.223,14.944 16.552,14.944 L18.794,14.944 C18.253,13.556 17.901,11.774 17.733,9.579 C17.503,6.564 14.984,4.202 11.998,4.202 C9.012,4.202 6.493,6.564 6.263,9.579 C5.914,14.141 4.773,16.923 2.774,18.084 C2.685,18.136 2.532,18.407 2.475,18.943 C2.441,19.263 2.454,19.548 2.479,19.744 L21.517,19.744 C21.542,19.548 21.555,19.263 21.521,18.943 C21.504,18.788 21.480,18.656 21.451,18.544 L14.324,18.544 C13.995,18.544 13.728,18.275 13.728,17.944 C13.728,17.613 13.995,17.344 14.324,17.344 L20.272,17.344 C19.938,17.008 19.636,16.608 19.366,16.144 ZM12.177,18.544 L11.819,18.544 C11.490,18.544 11.223,18.275 11.223,17.944 C11.223,17.613 11.490,17.344 11.819,17.344 L12.177,17.344 C12.506,17.344 12.773,17.613 12.773,17.944 C12.773,18.275 12.506,18.544 12.177,18.544 ZM2.068,15.037 C1.951,15.037 1.832,15.002 1.728,14.930 C1.458,14.740 1.391,14.366 1.579,14.095 C2.386,12.929 2.510,11.717 2.694,9.303 C2.720,8.973 3.005,8.726 3.335,8.751 C3.663,8.777 3.909,9.065 3.884,9.395 C3.688,11.957 3.541,13.360 2.558,14.780 C2.442,14.947 2.257,15.037 2.068,15.037 ZM1.292,16.197 C1.217,16.266 1.139,16.336 1.059,16.406 C0.946,16.506 0.806,16.556 0.666,16.556 C0.500,16.556 0.335,16.487 0.217,16.351 C-0.000,16.102 0.024,15.723 0.272,15.505 C0.345,15.440 0.417,15.375 0.486,15.312 C0.729,15.088 1.106,15.105 1.328,15.349 C1.551,15.593 1.534,15.973 1.292,16.197 Z"/>\n</svg>',
  ddBell: '<svg width="28" height="28" viewBox="0 0 28 28">\n<path d="M14.25 26.5c0-0.141-0.109-0.25-0.25-0.25-1.234 0-2.25-1.016-2.25-2.25 0-0.141-0.109-0.25-0.25-0.25s-0.25 0.109-0.25 0.25c0 1.516 1.234 2.75 2.75 2.75 0.141 0 0.25-0.109 0.25-0.25zM27 22c0 1.094-0.906 2-2 2h-7c0 2.203-1.797 4-4 4s-4-1.797-4-4h-7c-1.094 0-2-0.906-2-2 2.312-1.953 5-5.453 5-13 0-3 2.484-6.281 6.625-6.891-0.078-0.187-0.125-0.391-0.125-0.609 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.219-0.047 0.422-0.125 0.609 4.141 0.609 6.625 3.891 6.625 6.891 0 7.547 2.688 11.047 5 13z"></path>\n</svg>',
  ddSettings: '<svg width="32" height="32" viewBox="0 0 32 32">\n  <path d="M14 4v-0.5c0-0.825-0.675-1.5-1.5-1.5h-5c-0.825 0-1.5 0.675-1.5 1.5v0.5h-6v4h6v0.5c0 0.825 0.675 1.5 1.5 1.5h5c0.825 0 1.5-0.675 1.5-1.5v-0.5h18v-4h-18zM8 8v-4h4v4h-4zM26 13.5c0-0.825-0.675-1.5-1.5-1.5h-5c-0.825 0-1.5 0.675-1.5 1.5v0.5h-18v4h18v0.5c0 0.825 0.675 1.5 1.5 1.5h5c0.825 0 1.5-0.675 1.5-1.5v-0.5h6v-4h-6v-0.5zM20 18v-4h4v4h-4zM14 23.5c0-0.825-0.675-1.5-1.5-1.5h-5c-0.825 0-1.5 0.675-1.5 1.5v0.5h-6v4h6v0.5c0 0.825 0.675 1.5 1.5 1.5h5c0.825 0 1.5-0.675 1.5-1.5v-0.5h18v-4h-18v-0.5zM8 28v-4h4v4h-4z"></path>\n  </svg>',
  ddAdmin: '<svg width="30" height="28" viewBox="0 0 30 28">\n  <path d="M9.266 14c-1.625 0.047-3.094 0.75-4.141 2h-2.094c-1.563 0-3.031-0.75-3.031-2.484 0-1.266-0.047-5.516 1.937-5.516 0.328 0 1.953 1.328 4.062 1.328 0.719 0 1.406-0.125 2.078-0.359-0.047 0.344-0.078 0.688-0.078 1.031 0 1.422 0.453 2.828 1.266 4zM26 23.953c0 2.531-1.672 4.047-4.172 4.047h-13.656c-2.5 0-4.172-1.516-4.172-4.047 0-3.531 0.828-8.953 5.406-8.953 0.531 0 2.469 2.172 5.594 2.172s5.063-2.172 5.594-2.172c4.578 0 5.406 5.422 5.406 8.953zM10 4c0 2.203-1.797 4-4 4s-4-1.797-4-4 1.797-4 4-4 4 1.797 4 4zM21 10c0 3.313-2.688 6-6 6s-6-2.688-6-6 2.688-6 6-6 6 2.688 6 6zM30 13.516c0 1.734-1.469 2.484-3.031 2.484h-2.094c-1.047-1.25-2.516-1.953-4.141-2 0.812-1.172 1.266-2.578 1.266-4 0-0.344-0.031-0.688-0.078-1.031 0.672 0.234 1.359 0.359 2.078 0.359 2.109 0 3.734-1.328 4.062-1.328 1.984 0 1.937 4.25 1.937 5.516zM28 4c0 2.203-1.797 4-4 4s-4-1.797-4-4 1.797-4 4-4 4 1.797 4 4z"></path>\n  </svg>',
  ddLogout: '<svg width="25" height="28" viewBox="0 0 25 28">\n  <path d="M10 22.5c0 0.438 0.203 1.5-0.5 1.5h-5c-2.484 0-4.5-2.016-4.5-4.5v-11c0-2.484 2.016-4.5 4.5-4.5h5c0.266 0 0.5 0.234 0.5 0.5 0 0.438 0.203 1.5-0.5 1.5h-5c-1.375 0-2.5 1.125-2.5 2.5v11c0 1.375 1.125 2.5 2.5 2.5h4.5c0.391 0 1-0.078 1 0.5zM24.5 14c0 0.266-0.109 0.516-0.297 0.703l-8.5 8.5c-0.187 0.187-0.438 0.297-0.703 0.297-0.547 0-1-0.453-1-1v-4.5h-7c-0.547 0-1-0.453-1-1v-6c0-0.547 0.453-1 1-1h7v-4.5c0-0.547 0.453-1 1-1 0.266 0 0.516 0.109 0.703 0.297l8.5 8.5c0.187 0.187 0.297 0.438 0.297 0.703z"></path>\n  </svg>',
  ddUser: '<svg width="20" height="28" viewBox="0 0 20 28">\n  <path d="M20 21.859c0 2.281-1.5 4.141-3.328 4.141h-13.344c-1.828 0-3.328-1.859-3.328-4.141 0-4.109 1.016-8.859 5.109-8.859 1.266 1.234 2.984 2 4.891 2s3.625-0.766 4.891-2c4.094 0 5.109 4.75 5.109 8.859zM16 8c0 3.313-2.688 6-6 6s-6-2.688-6-6 2.688-6 6-6 6 2.688 6 6z"></path>\n  </svg>',
  docxlogo: '<svg width="89" height="55" viewBox="0 0 89 55">\n  <image id="D_o_c_x" data-name="D o c x" y="33" width="89" height="22" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFkAAAAWCAYAAACrBTAWAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4goSDwcitoUHggAAC49JREFUWMOtmXmQXUd1h7/T9777ltknkkcSWiJZFvIGY1nYlhyDkHCIbAyGoiBUkQpeIldK8UKIA6kCnOBUEkgoY6AiC9sV7MjgmCWmbAMONhJOolERK5GiJcLKJLJlLaORZn/bvbe780ffee++NzOSRvGp6nr3dp97+vTvnD7ndD9h1RdfRPmLsYaEHgEeZiqtAp5KvVfBrgHK7lXSvI8B17tuJejyX4H6Nl72INakGW8H+pLnPwA2p8b6kvHZUCtwN7AeWAZ0Af4MvBoYA44BLwFfASaaeLqBPwTeDSwCOs4iDyACRoA3EpkPASUfEw6gMr+ZYvws2IenAe4zwMomoeuBF9yjneybA3JHjcNaiCu/xM8DXDrNIibp4ib50SwBfgfwT0DPLL7pBBYDa4DbgMsT4AFW4AzdPQt5k2taBqwDfg+4RqGrDzovrgE6P5m4mW6Z2iV3uO8k/f1v14cV2GgIOIjKdGBts4BK6nm0aezULBf3WCPAAuKdvTXSQuCO1PtfTwFYPBB/Bnm+W28jLQEe9rH6MDbag8r2YvXk4DrgyRTzRqCtpjyQeO6tuC2UAkg+Un9WoMOnEgW7UiHpwsmaZO6GXTYfUe9qABggLr2M1QeBolMGAAM2i8pch5db42ROyjMbsPFDIBnEu7ERYAW6+t+Y8BXgjJODJMp4QA9edh0qs6hpnTf4WAMmegaV7U1J/DjYNMh/VFfeaECDBEnHbWC/lvAFwNo6IBp0dSveJOv/lyTBqGHnAbKywYtEQTzxJcKxB2rvDYayri+r+lDBdbVQZ+MsJgTJLEC8fF2eB7r8HOHIB2vfTmf8uBiQ7foXVPCuOtA277hN9NOmrfx+ap7LYlzsTZQvbUaHT6S22ydTq/sAkK0pZqMD2PgAKgOpoH3hZJOtqZpbKhmJW7A1j+HlSeZOgEnaJEjVkY1UBq+icqaXyumrqAzdiYlB+fkp85roq6gM1KZKyQOSsRATbWlyKKUQH0z8H9joSAo4D/hQ8vypBuV1dSs2/teUoKtxWbwZcDDRCzXA3zJS08nT9UfrmpcPCNog6AQV1IEW5YBSGVCZEcTfg/L3ovw9eMHreLlpbGvAyxky7U6el03SkAIR8HKuP9MOKhumwi6A8cG6bW3CJ1DBAymQ1oLdBvLhmoKmesDxxjvcuiZDktyEK+8+UAMYDTr8rvOaZJu/JZTET/Gc3lPjMw2GVeIAsNoBMqmfyDTfieOzWqYYUvm2luAzfl2eBVTC66KBNG9a382jwIR/jzUP1IFjIa4U6a37S/QPTlj8OjrajZe9OrHaRmAAyNQNEh7CRHtQmelj2FtB4oGNmXar2DjE2gSAxHtrsZckrnM1qFvqhjIDWLMFJJwCvonVtPJEHLjOOCBexqlTA1r5WAE80HE/XrQHr1ZlrAV5zs2RWNhUHwPlhJrqVrzstxJBHwLe26CXrj7qJs0lpdysPXninBwiYAVsBJKlwYPEuxvhj2uoNpeP1oLII2BX15EHrN0CZqLRMSyIuheRV6bKS35dKPKAO5s82fr1DgM2+inUqoxfS5qznCn/DBOfqE1uwu9i9RZEPKxtxZ22UgYJnwRJLH9BlUUv8JfUS69pYcaaL6Or/+7ibm0XAtyPO6ntxh0w0kq0I94asL11SQqsPoQpg7VnUJnYFb+T8uQjQD/wz7gafmoJ5+ZbklYPbNmvxykFJvoB2M9NuxwTPYqkYpnVE5h4F172+oa8gwJT3YPVp511LzjpLQE+d1YOFwJ/jK7uwMu+it+yGtNwULw2aTN9nMLDg7i8g7gEomJMbjt+4cYmecuSdn6kfIiLO+teIgpM/ComPo4K6icZlXFGM9GLDc7gQsZTNSDTzVafxliodkN1bpLRlT/NSSmXeu445wltSlOg/AKqANXypzDVYZTPDGXeDM1zYJjyMFH5S5TmQKkLouJ92Gpp9vJSMnXlBNHEPX6jRQ3o8p8Bn66VIS6J7cDqsVo8nuzX4ZPEpU0IOYwHOgB0TKn9cUwrH//1PsRv4ekj6yA7ViYYP4RNebaYIXQAUR6U7kfMoUZDAkqD15SHap6iodJyGtMKZuwAQ94KArmPjN2AJ4vwojYXtJtJQPsxVkbBHEWN/4wKW4haT//O0l2Ujc/3j646SFy+hFxpM5J9D6IWAu2c84LIjmDtUUz4ErryTawdEa64p2kX2albaRLUKWTACJS7wavS2jKCxBnWtp/g7oV7uXneYRB4/MiV3Hno/RC1QstgHcGwFUSzsuMkQ2GOss6ApBKkgvEwB6VuCEoQFFNTK5iYR7ZlkKeufI4F2RLfO7GCV0YW8D9RO8NxDsqdrYgV8iNOrgWqHaA9yBZDvLAKBsbmgVI88o5nuOuSvWDh669dzb37boVMEXKjk9i2cPYcobGUauVqUr5OBflsJBriPFRbkorHB9Hc2HOQzYteZV37m6hY0VaouGKu5JyGNth1soeP7fsoR0cXQLYIcRYk4vlV27i55wjVskeo/Skgn4xbeGZwJV89uprh8XmQG4M4B1qxYe5hvrbyJ1wxZ8jd2QlQhVIUMKhzbB9bxNZj72TXqbdDJgSJeHvhFPct+SXr244TeBoBfjRwKd35ET656LX6lVUB9Y9vLjWbD93EibgF/PL549SU6GcBsoU4h/hV1ncdBS0Q5/lEzz7uWPqfIBSo8h2ELjTLa2cVGMTyCwp8MY4Y/fbxXr5w5HqyFh6/8lk2XHQMyixC+BuE92Abrip/hccLBHxmdDzg0WNX8Sf97+WazqN8fukuNl7UD3AVJR5E2ADkkpPuOIqdBNxPxL7vDaxk04GbiDOa8Rv+FoIIQjZhuB/heTJ8GgOUuRXLF0L8/WdU26b5ncPV595czgd3fxT8CqgLO1DNzpMnLmLrFU+zaeX+upcKEAKaDoQRg2KEwn6waJTKEV3WRgUs3yTD3eRhbDTAUzEtBUNcVCixDyjsnxbJVsbJ7fQwoUYVuii+O0uMtmq9F5jtZKH/TBfL8sNIASiCNfSJcN0QLf0hfr8ALVSua6Xabqz8nfLs7bTCa6faeHZ8Jbcv+l+OVQoYZP4SzrzczcSlwD3AL4C9VXz66XlfmeDlxcEYb5RbWf1vt4LOzJwbzkH++bFZqHTS3fkGmxbtdxeHcX0oMZdJXn81TOHKUQpkiJnP6PI2Kocj8XrH4ywyZukK3NazRcFz4aEFoIx/yyCtLxk88oS0U34Q+HxF1NIoCrZ7keHitmHQMDaexYrQJtUVgiXEX36aNjSKVrKUqKwRscfEAKOwoq3E/W17OVCeS4tU0agTJ+m4LCDe1krl6wAR3sBxut5pYaCTIrG2dAclCl5EaXQBtJ9wydbOru4/T5CBKM9fLNzp7tjGmfF8oRHdwyhvY5iAGIV9PRkygkVEGI1zdFBBpJZgDUAHpbFOyoDgu9p7zClprEWjsJRCp7IvGosgiSbzGGUeowkXWGRAsFZwVw5xJCiJuFyO1w7RCW8tm/qY+G0MlzJoJ0MLXsaw/Yofcu/h97HrzMUu4RaGZwX2+YFc6eSSuf/FXYv3u8QwvWwBCNCXBehvpfqvB4hRQ+Pk8TEIFotCYYjxaKVKQEwG+wTYZ3H/G3bg/q+jSH6wSHYSeGyiQIwiy+iAj+4Cngd2exgF/BawOsL7yRAtN/loDMIcW6wrCt0++kfAb5yi/c8nyO1cxqkfB8RjwFqBPlcBwTXdJ+m7dhsvnlzKV964lp+fXg5iIT9CQ0k6A507JlsF1TZ+2PsdPrywn+q4PxPILUCfwBxgfroIjPD6TtFxV4XMPi/JiDoJ6DGKAuHlCxh+MiBelRZtkLhI9oUTdH7MIqHC0iSXTsobexj9ho++uKYyEOP1n6TjznHyOwRLgZAFDCNM3pTxDeD3i2S3Hafrd2M85jJ22xzGHwKOADfj/mQFC1kvhjxg4OXBZXy2/wZ2j/VApsK56P8AxA6iwGyM04QAAAAASUVORK5CYII="/>\n    <image id="icon" width="79" height="26" xlink:href="data:img/png;base64,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"/>\n  </svg>',
  logo: '<svg width="100" height="10" viewBox="0 0 100 105">\n  <image id="D_o_c_x" data-name="D o c x" x="2" y="25" width="90" height="60" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAYcAAAGHCAYAAABbHp5+AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAB3RJTUUH5gwNDiIkqnzoGAAAAAFvck5UAc+id5oAAIAASURBVHja7P3pnyTlleeJfs95zNw9InJfWTPZBQIhECAhIZX2papUVVLVdE9P19w7Pe/u/zRzP3fmzp2u6Z7qrqquTVXaJQQIEDsIxJpsmWQCucTm7mbPOffF85i7R2YCESmWSPL58nFiyQgPN3Oz5zxn+x1xd7fWcQEVwcwRERA4dnyRBx5+irt/cS+PP/4Yr7zyGidOnkAR2tZoYwuAEBAR3B1z0u8XCoVC4cPH0wcBQgioBiQI27Zs4+JLLuKGG6/gq1//PHfcfht7d+/EiTTNmEqVfughpPVb3N09pkUdBIuAOC+8cIi/+6ef8MOf3s2zv3uW2La4KBYjvbqHGagqIQTMwN3pbIL7R312CoVC4cJFRAhBGY/HQNrwmznRIqpjrr3uIF/7+lf45je+yo03Xs9cHYjW0tNwmnEArAUVaMbOAw8+xn/+T/+JH/3yHk4sriIaqOseAJ5cAzDQEAAhRsNxggbAcbOP+twUCoXCBYuIIEHwaCAgCNEtLd2xYTxeZvv2rdzx2dv4t//2+3zjq19kUIf0u/lRAVjreIQIPPDAo/wv/8v/h3vvvZfltqWem8ccordUEiBA27QpdOTJSzCy1yAKGEgLJbJUKBQKHwnmEBsjBKWq6uQ1tA1BAnXdx11YWhpz9y/u49TJU8Qm8kff+Sr9IF1UisocYnSaxnnqyWf4X//f/19+dc99uCu9/hxtjhGZGRYEFZ2YFncHSR4HgHtLMg4lrlQoFAofFSKglaQwkgmiigYhtilPXFc1Teu4G489+gT/6//6v7N9+za+/IXbCZrSFhWAB+GNN97kP/6Xv+Hn996La41IhbnjRAShrmrcnNg6IdRnJhYcHAekJKQLhULhI0XogkQxGhIdEaUKmgqHpCWooFoxbownn3qW//3/+Gt2797Lp284SOtQITBqG37+q3v46S9/weq4IdQVlVbE2BKkAsBj+kOCkLPXZ3k5nUvxUZ+YQqFQuLBxB80mIn0jfRBaIIIo5lBVfSwa9z/wCH//Tz/iwMH/wLb5gBrw8iuv8w9//48cfeMYVZ1KmWKMVFX1UR9foVAoFN43nLPt3kWFxZOn+NnPfs6jj/0WB3RlZch9993P448/QQgVGgJ1VeWcQqk6KhQKhY8fMvPI1U0ivHLoZX7y45/y9vFV9Nixt/jpT37O8tIKdd1DgDZGqrqiaZqP+ggKhUKh8L4xNQino6qMRmPuvfdeXn75ENWhl17h2d89mxwNS30M5obEWBLLhUKh8LFjNi8sgDIbajr8+mFeeOEl9PnnXmRpaYUq1ETz1GpNKlMNQT/qoygUCoXC+8rakFL3vU4CaTQa8eyzz6Gvv36E4eoYlWrS2BZUEfHSx1YoFAofS5SzhZjcoG0jr732GnrixCLNOCKigGbnopiFQqFQ+Hgzaxzy5xIwc04cP4kuL6/StgaEtT9cehUKhULhY4qA58eMFyGiuMPi4iJq0UgqGN0Pdr9bZDAKhULhQkJIndRN06Iimo1CCSUVCoXCxx857fO167+QtZlKjqFQKBQuYFwmjdOpYgnchcqx00JIMwkKL0ajUCgUPl74ms89WwaZ2AhHFCrBWKu30SWki2EoFAqFjyUyXfN91lg4qY1BU5p68s1CoVAoXOgkx6C0QBcKhULhDIpxKBQKhcIZFONQKBQKhTMoxqFQKBQKZ1CMQ6FQKBTOoBiHQqFQKJxBMQ6FQqFQOINiHAqFQqFwBtVH/QLef9I0I7OImWHmuJcOv0Kh8P4hWZ1ORAiqhNCNPICPS0fxpjcOIiCiWDQcpnOtPWmCyMz70caWtm3p9Sq2btvK1i1bGQz6VFWFhgBeptsVCoWN4d3/JkuP42bEaAyHQ06ePMnS0inaNqIaqHs1IVS0bcSBKlSYGdEMVT1v1qBNYRx8zWfdAt6dQk1T6txQUQTFzAjimBuCYGa0sWXLljkuvuQAl19+GVdceQUHLr+MHbt2MDc3oNfroUgZUVEoFDZIUqTr7IPjNOMxK6tDjh9/m5dfPsQLz7/Ayy+/zJEjbzAareDSx0WTIRElugFpDGfyOLqF6HRdu81jOjaFcQDw01Zt8TR0QiS9EUEDlSqWrTbqiDsxtiwszHPl1Tdw+2238OlbbuaKKw+wbftWFhbmqKqKUAl1VaGdxmChUCisl7xmuHfhpLTIj5uW4XCV8XjMW2+9zQsvPM/jjz3OQw8/zLMvHmI0GqNa0VqLA/26T9Ma7p4jIH7mHynGYT1IehM6n06gaRtEFVWhtYagcNHF+7jrrrv45re+zidvuJ75hTlCUKK3mLXE2GAG7XiMt8mgFAqFwnpxBHfBzXAcVSUExV1QDWzfvoPt23dw2WWXcdttn+GOz93Bj39+Nz//1X0cO3YMFSFoTRsjIIgqZzcMm4tNYhz8tI/5K3MEoa7rlGB2oxYlWouIc8MNn+CP//iP+MpXvsy+i/YggFlkNBymGRUKqskljDGiKNMkRaFQKLw3acVwJCS3wZ0UvSCFmNp2jFuKaOzcuZO77voCV1x9DZceOMg//MM/8dILh2jaESoB1eo032BzGgbYNMYB1p6k6UwJVQV3Yoz0ehXj8QjBueWWG/k3/+bP+cY3vs5g0Gc8Hqb4nht1rZhL0il3y9VKm/dNKBQKm5e0rjghBEQEs244jqTNakzxalHS+qTKJRfv53t/9ids27KN//LX/5XHH3+KulehCtFiyqN2a5LkbMYmW6I2RZ+DyGmGIc+0dsDcMXfAACNawyeuv4a//Mt/x5e//EV6/YrVlWXA0SCYt5jF9PMeMWtxN0RlM4XzCoXCeUX2H9xziXzyHGYNRVdJaWaMRiO2bJnjW9/+Bv/+3/87brjhOtp2hHtM0YxJIvrsUZPNwKYwDtCZgsTkdLnTti1OstptbLj8wCV8/8//lM/feQdzgx7j0RBRxz0S23GqJjDLyQqhMzPiXiqVCoXChhERQtA0RtNtspl10rqTbEIyGgiopA2vxYatW+b4yle+xJ/96XfZtWsnTTNmuvWdXfN800W8N41xWIsAimpAQ+d+Gf25mi/cdSdf+8ZXmF8YYLFBMJRc3QQEyXXEeSy2oqhINhOFQqGwcdxjjkikRTzllC07FNl70OmiryIoTmxGbFmY48tf/CJf+tJdVFUgxiYZGO/mN+dS2U22RG0S43BaWKmrFyPlHNwi5pEDl1/GV7/6B+zduwuLEbw7AM8Ho9MeCRcwAdP08M1VQ1woFM5/5B0+d4wgEMRoxyP2X7SXP/z2tzh48PJsHARRwT3X1wuTUNVmYZMYB1gTf3PorKnluuC5uQGf+cwt3HjjDTTNONUKA7gg+ZGeIn89+58r4roZw3qFQuFjiOIEAbcI3tLvVdx44w3c+fnPUtcVbpGqCgBEYjIOm6zMfpMYBz+tY7BDciOcsnvPbr7whTtZWBjgHmd+7mzegCAooJOPxWsoFArnxkarHR0V8NjgMRmGZjRk65Z5Pn/nnezbt4+V4eokR2FmqX9LNslynNkEryafePEcrzst/CMQqsBll1/Ktddfh7uh2llZnf5QzlNMDIEr4gE85I8f9qEWY1QofLzwdT5S7iFaM8lBpPJV4aorruSqq69CVBg3DaopdJ7yopuLTWAc8qLumoNA05Ps4pi3DAY9rr3mGrZt2YKIENvYtU5PWPv2pB4Hm3l8eA6bI7RAA6SS2u51mQnuAfEKMUVMUVPEmElOzRw/xhlHllMyrk4Uw7rKX2diEGUSagPB0uuQXN5bKGwQE0/pO+kKyiXfY4J3F6SQGk8l/cTstbZmu9fdt7l3YFYx2UTyI23+PFcYpoeveXz4yIYe5qBSAcpo1BCqgFlMUj9XXsHC/CDrxVVUWjEpsNxEbJImuHzVZeuZlsV0gblEBoOag5dfTk8riG3SSFpT/Ho6lh2FGVvsfEib+YjoKB9FwKnSazXFUUQqxB1rnSAp6GVieJWOOdVL5wvFbPqiZapI6+5EDFMnUCGenls9PUBBDKFN51EjLhGoPwIPqnC+44Cpp7xeqglEPV+ZAmnzkTc0njchVqXyECErKjshVKgq5jYRn0v9qZYMTQjpNnVLFUGeTJDO7Mi7+MJkIf1Q6j83WsziuAWEkNOnqZLJiFR94ZJL9lPXgabpNrkVMcYcAt88bA7j0NVwTd7wVLraXWhVHdi9Zxf9usdo2KAIftb4nL/z1x+az5a28pI9Is/mTsSR4Ii1uBlBSfK9nv4t5qqFiTwwoBrS92Z2WZINaBAQjXh0LCrqVb55u5sYPO/E0kctqrSFc0QmpeJdnbjPRoDdsoc6zR0mA5CiAe6OeSSoIKFCYuoXYI2BAaxFQyB0IZY23zc+9Z07z8KzURDfjAHctcZENVUvuThVHdizdxdVXeGM0lnzVMeaxgpsHu9+cxiHdyO3rW/dtp2qUkYAIqh2beybjYDbfPfi864HkIh0Bk9A6wrzSDTDXTCDoFXSbekueFW61by7yRzSTSYtmrvBFQhq4G1yTyWACFGUKIJJlX4PqErJVmGDaK4C7LyDFD5iqnKDp74iBJF6Uo0ec6l5qCuC1Hg02uioaG4gy4lbFBUHImqgImCWDEwOXZkLpmmTYyJESSHoOm6exfSd8JmohWpg69athBBwMyQk4yCaCm+8GIf1kDMQeRfRr2tinuqWTuRH/frOjnvASOJa4hGlRWkRIqKCBaN1Z+SR6OAhIFKjVoMGgiaPqIuKOU5QQQPEFto2lb4JglhLpSRBL3KdtDsmjksgimJaYSQPQj3itJtwp1XYzOhsIaF0Oawc5vEu/xBwyyFNVSQkTTQXQauQNdK66K7nDU56WjPwGOlJqu6Z9DBpwLNPYpq9BhUiimU9oko4r7xhlTQ+wGOW7p6ZXvNhZkbXwyY2Djmc6J3GkmExayRN9JY2H+liDjmgZNOHR8R94vE0ooS5eUR7jBshtsriiWWWFhdZXl5iOFxhOBwRY4NqyHMp+szPzbN12xZ2bZtjx5YBvSqAQhPHmESk6pLxsXM/EBQ1mYSbCoWNIAhq4DnZbBJJxRbgBKCHSIVRgQTcFSpoDVZWRpw8eYKTJ06ysrpC04xpmyZ7/0q/32d+foGFQZ+dW3ts3zJgMJgDF2Ke/giCiaXEOMnDEGbCXJtzKTgrk1KTHCL2nG9RSZLgm+kO3dTGoUPoYpgpTm8x4q1lXfRNhhguhnkEGpQUTsKTS43XSN1DQ5+hVxw+fJwXXnid1145yuHX3+Dw669z/MRxlpYWWV1eYTQaoRro9XoM5ubYsWMHe/fs4aJ9u7ji0r1cccVlXHrZfnZuX6Cua9yafJGlvI1aS4oFa07wFQobo6siTNuOnBKWLjmsIAGt+ogpq6tw4tQqh44d5YVXXuPVl1/h6JGjvH38bU4cf5vl5RVi22JuBFXm5hfYum0bO7Zu4dJ9O7jskn0cOHgFV1x+OXv37GZuUCEknSKIBMmhWY85h1azGbMO73VGNYeRWjNEAhoCbdtsqiM5L4wDWRtJVabDfzbVaZx9qY5ot+M33A3DEa1wD3gYMIzKCy+/xW8ef5qHH3+aF55/lVdfPcpoZZXRaDjZVeBOtFTBpJKWe5XXCCFQV8q2rXMcOHAxV111Gbfc8klu/fT17Nuzjflakdikqg9rwFsqrSYueqGwEbo5KRq6wTdKCDWNgUuNhD5jE944eoLHHnuJhx99iseefYFXjhzmxNtv0Y6TXESMkTbGyXyE1OT6dm4Ag34FW+YH7Nmzm2uvuZpbbrmZz3z6kxy4ZDdb5nqIjxFrEMbgY1TyPUX4qE/Rhs9o8hq6KuDJVLNNxXlhHGbHMXheLDdt0kEMlTGubRIOFGU4jlShj0mfF185xq8feop7HnycRx7/HUeOHKeNQKhRCUjYkktW0wU0eYOyUXR3GneaFpaOrfLK4ad44NGn+dX9j/CZ227krs/ewmduuo7L9u2kpsW9pSeCxyHRFareR32GCucZXbeQIbgEWheaGEACrfc4dnSRxx5/hnt//RiPPPI0Lx16jaVxxEOdhttInarsaqHqrW328lyXGjGW24bVReeNE4d56tnXuOc3T3HLp67nc7d+kjtvu4krL9/DfK1UCBZTU5ltznX1PbE8eyblGGUqB7SJOC+Mg8yWzW327JNHVFq0EqKBURHmFnjzxCoPPvwQP/7Zr7nv/sc5+uYp2hhA56gHPWzG2K0REum+OC2CJgiad22O8/Irxzl85Bc8+vCTfOGzn+YbX/oct9/8Cbb25/B2NNNgd54FaQsfPepIJbTuIBWuNZFAY4HHn3qRH//0V9x97wO8fOgITeNU9YDe3AKRQDfut0tGI6elXbuSVBwJfQSoKgePvHV8hZ/+/Nc8/ujj/ObBh/j21z7Hl+68hYt3z+NtJBCw8zCP9qG2aPwenBfG4Xxaz8QhmOKqtNRE+hw9tsw//ehX/Ne//RdeeukwrVWIDlBNHZTveoDvcAE5jgRFqwGxGaPVFhzjhRfe5I3DP+XZZ17kz//0m3z1rtvZu2MB0dlcRKGwfkwcUwOpGbdC6A9YHbb8/FcP87f/+CN+ff9DLK+MmZvfgtbkEmqdNlyuGZf8TitiUim1GHGDEGq0qvF2yOGjp3jzZ/dx6KWXePnl1/nud77CwYv3olXAY3t+ug7nAeeHcTiPUBSNNeYVIgOeP3SU//R3/8IPfvRLjh49hWgP7Q2yG+koEfc2VRJtYCcxkRDwrtGowiWgVc3S8hIPP/YSR9/8a147+jZ/+kdf59KLdhJ8TF1upMKGcKKnTvsQBoj0OXJskR/94jf81X/6R1548VWaqPT6OyFUtN4kZ8EdaDf0dywa6j5pnsMFo4fWAZGWZ196i2P/+Z94/a1FvvfdP+LTN1zJQAEfs1lzkOczxTj8PpwtL+4BsQprK547dJj/7T//HT/46a9YXDVCf2uu7hCCJqOAx1S5sEHpI6drva9RerhXWExyHXW/R4zLvHz4JP/xr/+JY6dO8e/+++9x48F9sLz83sdQKGQcsp5loAWOnTjFf/unn/NX//cPeP31t9FqC/35AdEjTRvRqgdEiDEt9OtFPFf25fJYl5xortBQpc2PCseXWv7hX+/ljeNj/sNf/jlf/sxBpGmJtvli9uc7xTi8Kz4J+HiOnfpESiB1d5q1uZNZQQPjVmlDzbMvvcH/9n/9Df/603s4tTymN7ed1lPZH25E88mUuxhb1HN8dr2vK3eImhsihlubOk5DDRIwr6mC8OZbi/z9P/8CndvG//znf8jVuxbyaEPDY5u6UclTqaQbnZSTZEju0yjexseFrl7N18i7dO92aqIUILqjIWAI0WvcK948MeTv/uHH/Ke//mdee+1teoPtmPaI7sQ8HhOPSCe85DPaYO9F7pae6jNJ1l8SRAIuiluFhIrF5SG/uu9RpO6xfcv3+NQ1lyKMkTgGb1Jlnyrmikk6Rs3XuJTd0LopxuFdcdRj7swMWBbSUpzgRsCSSysVY1ecwLCuePX4Cv+/f/kJf/eTnxKtoj+3QIw5IaxZbEwCsU2XLR4msmLrIneNG0l6Q9UJoQVrgXH6M5IWgVDNs3iy5V//+V62hj7/8/e/yb69W7BmjBCpghCbcaphl3SMpH/BUQJtVpktnP90DWSGUWdzUCUT4YZ6i3okBGFkEQkBMyF6n8XlyL/+6H7++m9+wCuvH0V681Ar5g3mjiqoG+KWdDMmO//1vzbv8hGah3SJz8xpFkIvKZuGukeMcM+9D9EfDPh//Yf/jhsv307djqjikKoKjEyI2qfVVOoa3JJSgRfjsF42YRfZZqMTFev2z4LnQeMxNoSgBFVchBZnpW35wU/v4x9/8EOGjWEuiAZEk8cxdbWT1ICTSgLTANp1Pib9oQHRTrPSUDWCRkJwnDbdtFKBVxw78jY/+Kcf8fN7HqAFWlPIWk6TubgzcshlqOrHlU4bybMoozIRcfCJEDchhNR4qhWRiocfe47/+7/+A4deOUzVn0s78yzTLZqNTm5OkzxreWMq13La9Z3F+bAs5md5hnMWrFRhtDrmFz+/j7/5+x/y9qkhWtWEENAgWGzXVANNN18bHdxz4VKMw3sykZ7MX2eHXDvF01T3raGHS81jjz3NP/3dP3HyzeMMBgvJoTUDM6qqyuGoiWIMoiks9H7hnepZXto1KHUVwJ3XXzvM3//jD3j8yRehqhhHGJtDqPJN6XkXGVGPOQZcbqSPFVMF+JlmtG5WSIoNRcAkMG6hJfDSa0f5u3/4Ib97/oXkTdY96nqQZxB0A0Vk7R/4EFANLJ1c4ic/+jm/uv8RxhZopU/rFaK9pHTqaQumbqhvvoE6m5liHN6T2Qt/urNChBAqWnNaEyKBw28c5+/+7l948flD1NU8sYVQ95M4mU+17lMcP85oL6Xnfl9wx83TdCnNhgmo65pQ9Xn8t8/xn//LP3FiqcWrCpMweRVZbBklZrHAJBhY+BhxxmKer2e3FPOXFKuPLhB6nFwc8s8/+iV33/cAaJ/eYCtN47PqRvmpzjbm94NFNFD15zh8+E3+69/+gKeee402zDGKAZcaXAjmqKUqKDXPwrLFRKyHYhzelYkpAGZ3HYbFlABGAhJ6DMdw7/2PcP+vH0asAg9YFNrGaKMR6iq5ydlFFgzNgnxrWsDfF5ygqRwwxpjUWnGMwMoIfnXfg9z74KNoL+2wokkWMpxq6AjJeyg15B8nZsfp5u90MtxY6tolbQ9MK0wrfvvci/zrj37G4vIIQh+pB7QxDfAJoZrp5JIP3XlI63xSQX7o0af44c/vZaUNROljk4mIEMwIOdFexCfXTzEO62JtWKkjyRUr0ZXDb7zNj39yD2+fWEbDANFeku82IWTp4emNyPS5HN7v3VY3YhFPHkTIE7YMBe1zfHHEj356N8feXoEq4FolEUPp6rKmarIlPvsxw9N89WkdXnqfO2fCPOUiIoGTy0N+9evf8MKh15AwAOnRtqB1HwlVygG4fCDX8LoPxxUJfYZjuPvXD/PEsy8TBn1MepNqu+A2nVxXAkvrphiHd6O7Y3wqdy0z8dk0jUppDR55/Hc89uRzuPRx78bqaBqNmG+k6Sb89Bvpfb5gu8lxpNGiooJKKqM1qYle8cRTv+Phx5/Jk0NTRYcBPvFsfCbkVfj4MBMOYqreK5I2Ewa4psDiK4ff4N77HyWa4hJwqTAHCQERxWLePIjPRJY+5CtGusKMPi+9epSf3fMbhgamaTyvYDP+f8mgbYRiHNaLTw1DV4nhOK4VJxdHPPz4M5xaGiM6l6L2lio+8NQL0ckcT7yFaXfR+/5SRabxZHfHzbKxUNAebWu8+dYJHnr0SZaWyVr8afSirwmlUTZaH0tmR9l61jvyXBqdQqWj1nnity/x8iuHCaGHVHW+ZCXNfLZOMt/XmBvoRnh+8BeOeapockkDgJZWGx556llePnISrVOYq5urMhUbL0veeiln6j3w0xLS02qlVHJnEnjx5aM89cwLtDFgJHd24m3LjEGZqo8BmsZbeff4EFZhDSA1beu0jfH0b5/l5VffQEIavYgoLprGMXbVWB/1G1B4n+lyDjPXtHiqmMtNniaBt0+u8ODDT7I6bJOcRZ51Pt0+pKIKJQ2xmvYPyFRT6QNGZ2dLqBJNeOXwGzz21LPIpIMrVQUinq/rsuStl3Km3gM5o+I/ueHuaefUts5Lr7zGS4deB+kj2k+LMKdXVE+0GPOXMzfSh3IzSa6aEtAKM+fQoZd58aVDeVHQLMkseYi7rFGKLXw88DWGIe1d0sJPHvicCpiPHHuLJ576La1Jkp43y+Wg+TEpqMiGYXKhd97wB3/tSG5SVSIhpPGkb775Fk8+8yzjCK6dl5/CZSbk8vNyXa+HYhzeC5fTFvhkHKIZjrK8usqhV15heWk1SQ5rPfnZ7r+z5xg6w9Aps34IGLg5VdUDUZaXlnjx+RdZHaVhRNNbfmooSnHHx5Hphmd6dacduITAuI289PJrHDv2NkHrvEGKSQ7DDXKzW5LHmL2+P+yLxXNJeJzoP43HDYdeeZU3315MSjWSXqMLxDz/obA+inF4D86+OOZJTjgnF5c4dOiV1D5mOp1UJ9kNX+N4+MyT5h3WxHP4oK/a2ZvYwZwYjZdfeYWTp04lcbPJjq/r3j49mlz4OCGTa9Um1W0Aw+GQQ4cO0YwjaMAtyWvMGoWuiZPTKto+1GtG0tyHGBvcYs6XKG++9SavHT6CaMheMdOxpsVrWDfFOLwns50OJC0kKlRr3AOLi6u8fvjoNDfRtfzP3iY+/e3TY71JyuDDajQzVCLRIiZKE4Ujb57gxOLqRM9GvZPRIGk4FdfhY4VkfaU1i3oOcZor7srKsOXwkTexKHkMZ9o0zP43SWjL6dd19+mHcd1kMUy3lJ2WpFt28uQSbxx7G7SHUWNJdi/5xF7Ks9dLEd57FyS33Xcx+dncgEsKw6ysjjl+/FQSuwuSpYdtOm8hP9Oam0Vnb9DJM37gx6NZFzzNua5o28hbiyOWR8k4iQtquSFKkidU+HghubfZPe+qPZWCdgbAqBi3xtsnlohR0FCjmsKRZ+W08lXBP8S1VxDRLBopKErbjlldGnJycZhzZj1UmtQMl8edFhGN9VHu/ndhOpl0JumWH+aAKE3TsrK8jATJi/7Zbg4566cfthCYCLjHLK2c5AdWl1dpmmame7TrJP3QXlbhQ2RyPc9Uznm30+8q1sxYWV7Cukqg2Uqksz4+IvLrUtV8G6XS7dFwyGg4TNf7xPAxI9ldWA/FOLwL73YZpZGbENsxo+EqoZuLsJkvvtk51VlOYLy6isUm6+6dVq/+Ub/ewvtON8eBM+Lv6d3WPIdhuLLMRN7bN6++lkva5EyUiXGa8Yg4HmXTNfXiXWaDxIX3ohiHd6HT6Dpb2H2283LtIJFNfOl1O8XJDZKS5tPiw+nr73LmJeXw8eO9rtCJP9DJuW/iMMw0szfNC6r4xIkvMt3nTjEO78Hk0jrt/lARxI06VAzm+qkL2s+DC7FrbBMBMwaDPlUIiM00FU1/+KN+tYX3mXe9Qj2rsyLMz82lxcGNzVzgI5CmIeZSEdzoVTV1r56E0KaqBl6q7zZAMQ7rYm1sVcTTeE13enXNloV5sIh73NQipimU1OUVHHdjYX6eflXnJtKYdlxrdGjKzfSx47TVvpOMl1z1oyJs2TI/kfLetMYhb3RijJMDEZzBoM/coJeKAdeMud2sB7I5KcbhXZncNqy5sDwp0eAwN9dn585tiHiaPrWJZy6nOnDJG0QjVML27VuZG9SIpSoryt7qAuH0fEO3FTB6dWDnju2EkDZC3UyQzYh7p7GU5qVoEBYW5tixdUu6pt2mITIvTZ0boRiHc8SioeJs27rAJRdfPJH1CrJ5Z9Q6aeiQqiICVVD2793Dtq1bceumvtkmNW2F94ezXJueC1nzznt+0OeSi/YTwmbONkwJqqhKzvsZO7ZvY/++PXj2KKZZiXJlb4RiHM6VLES2besWDh48gEoenLKJhy/LRLg4LQQhBA4cvJwdWxcwaznTRyod0hcEMiulYQwGPa688gCDXi9tGjbxKiEihKApB5grBvft3c0lF100s+GZTVeX63m9bOK3fTOx1gUXfLJTmZ8bcPDA5WzduoC1Ld4NV9+EiKbZ17FtwJwt27Zw1ZVXMOgDFifyxpOKpeKDfyx5JxmJlIeKVCFw+eWXsW//vjTxcLOGlXKrhogmUW6LDPp9Dh64nN07F8BaxC3LhGyCvozzjGIc3gOf5B0y3dhcEdyMKgQOHricg1deASSd+01qG5IchmjeDSoHDl7BlVccSN3d3s21ntlplXvpY8faS3Otj+hueJt6Bfbt3c0nb7oJrUIe6rNJ6ZpSY7rvdu/bx/U3XE9VkTWgSmfDuVKMw3ty9ktrIvTlxoHL9nPDJ64jVFVOVp+Nj/4CTck7J9Q1db/m+huu47JLd2LtmcLihY8rZ1p87UT3bBpW3LF1jttuvZH5+bmkXbRJmQwsyhPqLrv8Uj55wzXkKCmdOvKEcoGvm2Ic3oNOtjr1hDnBPMtpgGrAzNm2pc9nPnU9O7f1cRt2AX3M0pCRJA7ZAg3QknSVZsvrzmF7PlHRXHu1p6jx9KlVQTWHi7zFbUSonb17t3P7Z65nYS5JaqCCETDCpO1JztCIKnwc8DO+ljxfvEI0IG7MV3DLdRfziQM7IY6IMU0SNJtK8E1KSN+PFXeqhp81Af0s35yZbZ6vS5EKXBF1tiz0uPmma7nkom207QjU8sCqqUS+eHGH10sxDu+CC0Tt4rM2GSyi5lmILC2iVQjcetM13HrTVaivpDnMWaDIrMVsnBZoj6jHLH886VE+s1R2najbjOaT5NkT0mkKpD2VxZwHaYERKkMqGfLpT13FZ266Bm/BaYlAK4EoFZbFzIJ1KpaFjxXT2s6871ZMKkx6eVBVS4+Gay7ayVfvuI5+ZZNRDqoBi46Zz2gakTcrrH1s9GWZoCZ5ABGnbYCygcjXvLqBQfRUmk0cc+XBi/jKF2+jVgNGuFge8JM0ACTPgpey31kXxTism6lzOh2XmBROVWHv3m18/atfZM+e7VhssNhmLTPBLM9vJuAETp+UdVpWY4Mva0YvSRRH0wB4VRDBHGJM5alBHGXM7h3zfOUPvsCOrT3EDPGYZ0wXr/tjj0w/rLkC81ArEZ00jy3M9fj8Z2/l2qsPIrSIt1RBadsWM6fSmunkt99/JolMPs5smGTmMfHfk2iNCIi3xGbIXL/i83fezrVXHcDaFtUshz9ztNOpjsVzWA/FOLwH013GWuWkEDS347c0bUPdq/jc5z7F57/w2TxXtyUIVFVFCD3aViAMMJLGfHfqp0NTNo6jk2HuLsnh7pQ1oycZMg01UnXT5iLzPeUPvvR57rz908RRhDgmSNKjmVFc+r08msL5R1fe3G2C3J1oxjXXXMN3vvV1tm/pQbuKjVepayXUNY2BaZW9jorfb+HNHrro5CN5s2NokpBH8wYo4JI2P5WMqWTEZ277FF//8hfpKdnDP5Oy8dkYxTisi7U7DhcwIjGOCcEIEgkS2b9vO3/23W/yiWsO4s2QSoW2NfAKlz4mfUxqXOrkQZicZQbv+l9TZxiYGAZyvaqkgV3uWWZTiLHF45hPffIa/rs//Q67Fioqj4hFxPOQ+MkRTvsbyg11gSA5J52SCkCSpdiysMB3vvoFvvyFzxB0zHi8TF0lz9S1wiU/0DQ/QboQ0MavHCfNee6uxG5krWeP2yWk3Eg3ht1biCtcefke/uJPvsknrtqHxHGa22DvrCRbKrTXRzEO62BaJw1pZ2UYlqe4JePgNsJjw803XMW/+bNvc9HeHYxXFlOMNFRIqLEISJ11XHXtrIhzXYZl9jelG9qQxpTimMXU1yBw8MCl/Pl3v8VN1x5EmoZ+ZfSDQoxrDMP0Q7mLLiTMDDPLl5BTVRW4cdm+HfzFd7/GTTdcQdCGph3SjEcpdInmXf6kO4bf51qGvPkSYaoXDLgyzSXnkJE37NrW54+++SXuuuNTpC1Xi2J4207u29li1rLZWT/FOLwH07BSJ2Wdq5cEqlqIcYz5GKWh0siggm995Q6+90ffYK6viDfEdrymHDC57Xl31WX6Nvq6NHkK0T2/njyi1GLKd+R8iFmDW8O+i/bxJ3/0Hb76hTuorKHyBm/GaW8mpCQ5Z1NWKgbiwsFT/45DbA1VxWNEfcytn7ySf/f973LVwYtpx0u4N4hYnuNs2WFNFuL32Vf4xMjkjmftLEJXJRhxa3FrGAyUr/3BZ/n+H3+N3dt7iI0Qa8BT/1HSUurCVd2Eq5JZWy/FOLwLs5r2a6/6HOef+SyIU4lRecP+7Vv4sz/8On/0na+zZb7HeLiMeDcWdGa+dHftn4sLPmMU0lMYkKupxMBaVAzxhl27t/Ptb32FP/nDr7Jr6xzeDFFa1CIeGzTnEo2zCZOVG+lCQUSzcXBEJQs1QtCWrXOBr37xs3z/z/6QgwcvBh9CHCI0iHQLdkwaY3IOmkzTGUR58lw2EZ42L+qGxzFKxOOIuUHgrrs+y7//t9/jisv2QjtEvc3DihwNgS7Rnui86TJDer2UGdLvgXSDfDqXFxA0pe3MCZIm07o73rZU1NA2HLx0D//hL/+cuj/HP/3rz3n75Cnq3kKa3UuqGHQzXEBDwGxjt1NSoZSk5+TZeRYHbwniCGNs3HLRvt185zvf5C++/w0OXLSVuLqY1FfdCdpt06aji86UCilcKMhMRDEETSKNAkEAWnZs6/O9P/4G2hvwV3/997z00mG0miP0Bvl6NEQFc58YifWT76E89jOt6QY27W8ItFg7Yst8n7vuup3/8D/+OZ+8/jLieAnLRoQsfBltunWbjgKalu8W3ptiHN6LrhxuIrY6M+fAu16Hmc/dEMbUAtce3M9/+B/+hPn5Pv/wgx9z5OhxRCpC1c9tDmn3P33ujbyu5Ma7J00ZVVAMszHNeEi/Fi69ZC9/+id/yJ9+99tctGcBH43W7JzSkenk8GByGIjPvLZyO12wTNsYWqpK2bNjjj/59pdYWBjwH/+vv+W5519mtLxMrz9PXfdpm5g0ucLGgxLuhiVVeTT36ZhHsAbViMdVdm2b41vf/Arf//6fcON1l2JxNcm+zOxrPPc++KR8tTuSwkYoxuE9OduYxNnqJc9NO13HJqgaKg1NG7nq0l38z3/5J+zft5P/9o//yosvvcpwtAISEO3lbgnfuIFwSHkFMG+zKw5iY3ZsHXDj9dfw3e98na/9wefZvW0ObxokNriCuKzdQ8nMn565h8TPxWoVPm5YdjDFI9a07N8xz/e+/SV2Lszx337wE+5/4FFOLi5TaUherGrS8Npgd70GTd60peo5FQFLVXZ1gKuuOcC3vnYXf/bdb3Hp/l1gY9xbTHyiOEwu9EiJ8m7TBrnwe/IzhfemGId3Zaagc6bErivNELpuy2k9hLiDRFScIAoR9m3t8b3vfJlrrryMH//iPn5572945fVjjMZDJNRUoc65h/WSknWxHROtRVVoxmOqQc3V113NF++8la/d9VluvuEqtlSCxhWsHRHdQHuTpN+sgz2Z/ZZjtl16pUyDKxjJQIhF+nXA21XmUL75xdu47OL93HDddfz07gd45rlXaFpD6wq17hqaBnXe8+94CkVpEGIbiRapFPbt38PnbruR73zjLu78zA3snK9pV08QaqENOYnt4J6SFt3fVc9iATMVgSKSTUS5pt+LYhzWxWkX02lZ22nnJYDh7jTjEVXdA4HRqGH73Dxf+txNHDx4gGuvv4Ff3PsQTz39PMfePkGz2hBjl1wWRNPivyZm61lCzNJF7jjuLeKRwWCO/fv3c+stN/HlL36O22+6mv0756nN8GaFKkTMm66nm7VigjMlusJaLaXOVpT76ILGSQt3HQKKE2NDQFExPvWJK7nk0ku59oYb+Mndv+GJJ57ltcPHWF1ZpY1tbq7Lw3i6YulJAq+Thk/5imgNGlL5ahBl70V7ueGT1/G5227ia1/4FAcu2klPDNpValoUIZIbPPOF6l2ndy6u6DZvaw6mXM/rohiHd2Wm8e0dWu+7mOxkiRVBJIA50dJc3n6vxiQShyMu27uNv/jOXdzx6Rt47ImneeyJJ3nuxdd4+bW3WFlaZmVllRhj6qSIydCICKpphLqoUtcVg56zZ9s8Bw5cxlVXXsGnPn0zn/7U9ezduYWeOrQNZhEsMvJIVfXQPAj0TDqvZ6JHPr1xN+0A4cKHhUqnoZSSzaJKpRVtdIgjdi/UfPMLN/LpG67h8aee5ZHHnuC3z7/CK68f4fibbzMajTCLNG2Lt7OSFiAa0BCoA+wYONu29ti7dx/XXHU1N9/8KT598ye59KKdzPfAm5bWx6m3SDUlnbMMPaTXNzuIsWvsZMZQuJx5DxfOTjEO74GfLT4p3Y6HaY9O9z8BCEilObmb/Qpz1Fo0GnMO11+8hU9e9jm+ecd1/O7lIzx/5BSvvn6M1197nePH32ZxcZGVlRW8jWilVFVNvz9g2/Zt7NmzhwN7F7j2sh1cceByLr34ErZs3YKKYDbEmpk51iEprTbphU8PYeYITzu49N1iFAodMbdsxm6TVNFa7vmxCNbSDxUHdwYu/tw13HnTZbz45ilefP0or796hNcPv86Rw0dYPLVEO2oYNw0WHdHA3PwC27ZvZ+fWOa7au4UDF+/hwMEDXHbZ5ezcsZ1eXWHeYE0qBRf1NDNa89JlOskJzvbIrb2uO4mZj/pEnl8U4/D78K79YsJp3nOayetO07SIjKkGAy7au4Odu/dwM3ByyVk8dXJiGIbDYZ75LIQQqKqa+YUtbN+2lf3b59i9kNRTzZ22aYhtKiVUZouMigxG4f1ndgJI14kvGD2FXdvm2b5nBzfecIDhEE6cOMWbb77F6uoQi8Z43KS5IqoMBgPm5xfYOtdn/7Z5diwMqHuBtjWaZkxsYxa6tMnKv7ZE9vyYc30+UozDh4iTpI4lD0Qfj8eA4mqIBXbPKfu27ADZkWdSp9+TPJchRmjzKAiJLcPhMOvsJa0bydo4G6svLxTOHVWdNK2Zdz0Fhg1HuBsDgcv3bOGKi7aBTzdKM43PWMxy4AZmLaur46wQm6TybabPqPDhUYzDh4jbdPEOIYuVRUe8obIRIWqar+CO5VrvJLvttO64Zc9AUyerAdEMyQYnJf9kkqcoFD5ousogszS7RBAkCGINvVw2zXiMNYJ4CrUK0LqnwUG5XwcJRBeCKqEKKe9mcarWXfjQKcbhQyR5AAHHaNt20ujjHgk0iGUFgSxkJmhucusS0+l7gmI+1dA3M9xS+ElPr3IqFD5AzJMGk6hireE4waASQyVV18VoaJj2PqRGZsmTGbqEstG6Yh5QBxHr9PzWtisUPjSKcfgQ8VzpoYQ0MAXL5atOVSl5BiOinr2MJiW0lSzhIQhJOdMJiAaCJo17sySJYU4uGywUPli6JjcnhT1d84wSBVDwNl2XZO8g6xl3XZf5x1MbqECoQvKabZyNgWQhgne6nst1/kFSjMOHjafyO+1upJw0jj69WwRJ99ZM6/KaIenSiXb4tDNamJb0FQofAqmhrOtTWJsXiK641FClbX9KlVm6xjvZF++eJ380mwwuTeSOBemu81ljUK71D5piHD5EunDP6TmByUS304fb6vRGOSNU5LLmhimhpMJHQSogWnvdJs27QAQ6RyHh02tcpsZk+iPTjHXyltP1P336qZhe4YOnGIdNweldy2dyetX22T4vFDYNPjuoJ/9vzSwF57QJJyBdf06ZKbIZKMZhEyEbSLp1VR+FwuZkxjjMholmZIhFfE2/xBrPorMRpXPtI6MYh02CntHV+e54af4pbFLyiJF8TcNk0e92ND71IrqUtky8is5IyIyBgLIV+vApxmETkDRgzqFWr+QZCpsUpZu6BtNcwtQYZBnV3Ccx9RrWqAB3hmTCWcQvN+JuFzZEMQ6bhvUv9NNhQxv6tULhQ8SyPtds5dEsaxWHU86tE36R035FZj6unVRY7oEPjmIcNgNyTn5DobA5kc5H8Hf+gTUfMxu5CYrH8IFTioULhUKhcAbFOBQKhULhDIpxKBQKhcIZFONQKBQKhTMoxqFQKBQKZ1CMQ6FQKBTOoBiHQqFQKJxBMQ6FQqFQOINiHAqFQqFwBsU4FAqFQuEMinEoFAqFwhkU41AoFAqFMyjGoVAoFApnUIxDoVAoFM6gGIdCoVAonEExDoVCoVA4g2IcCoVCoXAGxTgUCoVC4QyKcSgUCoXCGRTjUCgUCoUzKMahUCgUCmdQjEOhUCgUzqAYh0KhUCicwaY0DnLa1w64zHyBnOWnCoVCYRMinj762m+7k5cxz19sLjancfDp0u/5P0Rwd8wdUUG0GIdCobBZccBmDIMgKLimnW62B4JgbhgRkc21pm0O4+D5HJ7FsrpP/8EFLBuKQqFQ2LQIZ1nUJIdABEdxPG2CBRzbdMva5jAO74BP/p/OmoiiqpgZbpvPDSsUCoV3RQRVRQAzx93z15I3wpuHTW0cRJJBEATcURGChmmcrlAoFM4nPBmFyRfMhNCLcVg/AiiC40SLmHnJNRQKhfMWxxmPx5gZKoq74+YphL7JNryb2jhAOmFmRtu2tG2bTmZ+FAqFwmblbCuUuzMejTCLqCrgmNumMwywyY2DiOAO46Zh8dQi46ZJp9DZdJn9QqFQWIMzyTGY5YpLMxYXF1PO1Lsf2Zxr2aY2DpZ7Gtqm4dChQzTtGJEcm9ukJ7RQKBRUBNWUK3WzyffGzZgjRw7TxggqIELQtAzLJuvd2sTGwYlmiApt0/K73z2LRYMuPlfCSoVCYZMiCJIXfTcIIWDurK6ucujQy4xGI6oQJlVKbpaMySZiExsHoVIlqLC8ssxLL77I0aPHcE8WuFAoFDYr5k5sWxyo6gqRFAE5dvQYL774AjHGafRDJAs/bK51bRMbh6570GnbhqPH3uDXv/41jhOCbsp280KhUAAwM8wM3GmaJhmH2PLQQw/xyssvJ0/CIuCISMqvbrLerU1tHKIbIPR6PVaWl7n7l7/k8OuvU/fqYhwKhcKmRQSqqiKEQLSICBx+/TC//OXdnDq1RAghNcK507YtqrrpQuWbyzjIjKBe1ldKXdE148b43TPP89Of3c3qsCVUNeATeY33dsik9M0VCoVzxN/xISqpUMYsfS0gKhhCBPpzc5xcXOLnv7ibJ596ilAFQBCtwIXYxtzPtbmoPuoXAExjbjNLvCC4aW6TDpg5JxYbfviT+/jEJz/DZz9zIyptEuIjuWSiiqjiZhPHojMwIBixGIhCobBBHMTWfEdgWlaPJG0knCACAo3B2J1QBUQDv3n0CX74k5+xuLTKoD+HWVZ/EHJVk6DTZ90UbA7jAJxVgluSgqGbELSPufPbp1/gr//Lf2Pvzi1cc+WlhEpoxu1EgcmjgcgaO5z+bT3eRaFQKGyMTjwvkqopQ6gg5LVLa556+ln+5m//G7979jmquofn+QOdKmvQ8FEfwlnZRMbhTEJIukpN21BXFe4wXF3l7rvvZte2mv/+33yP62+4AbMx0SIOxBipqjDJ/Kdu6ghsvjriQqFwPvDO82Nccm7UU3A75nB4VdWYw9NP/46/+o9/xX333kdsW6q6n0Phs8/n7/j8HyWb2jjgjmU99E4yo9/vsbK6wg/+5UfEpuFP/+x73HDD9czPzzMej2nx1DwnKfaXooJZPF11M3lthULhvEDecWPpDm3bIpIKZyQobs7SygpP/PZ3/M3f/C0//uFPiG1LXfdyuHvzGYKzsamNg5lhboRQIapY0yCqVFqxtLTKD3/4M157/Rjf/e4f87nP3cGu3Tupe0qMTTIMnaa6g7tMhgYVCoXC+nHE9azfd6A/mJv5nnLk6BHuvf8B/uGf/5XHH3uc8XhMXfVQrZJMt/k7GJvNtXPd1MZhNknt7ogGzC3P0QicPLnCgw8+wtFjb/HEU7/lC3fdydVXXcHOHdsIdaCqdNJ1mLyHYhgKhcJGkTTB7TTcnWgOITBaXeXIkTd48YUXuO+B+7nvvgd46eVXAejVfaI5IVdM+lnzn5vLMMAmNw4p0SOpmQQIqognmyta0etXmEdeeOFFDr9xhEcefZQbrr+Wa667hosv3s9FF+1h6/Zt9Hs1oaryG7z53oRCobCZyeM985JunlSim3HD4uIibxw5wiuvvsxzzz7Pk08+yWuvvsZw3FBVPVQD0YxKA20b0TywjE3W8HY2NrdxkLXOl7tPo0IOLmncnoaa4eqQ3z71NL975hkWti1w6SX72bd3D3MLc9R1oKp7qGzOqoBCobCZEfCQP0taSE3bMhoNWVpc5OjRoxw5+gbLS0t5TkMghBohpJLV7DFo11Zm+Tk3OZvaOLwbDpOsv4giWiFqRIucPHGKUydP8eSTTxOtwSymZjq0RJYKhcLGyF5D18Gsoogojs18LUjQlB/NhfOpZNUhz4smT7Q8k6QEkdg8C9R5axymOC75xEugqgPdAI0A9GQuvx+W3qzNc+4LhcJ5gMzkCtxS97OmNui88UxfmzueJX9ENBuH0xf9mdDHGR831+J0/hoHOf3k5q9c8si9gGjXHU0WuaIkpQuFwoZICWRHNYCmbuhu1RERzMFIFUiqaUmdhJPe45k3M+e1cTi9mWRapZreFrNu0pJmI7G534xCobD5MDcikYo8ndJSWXyQpI/kZmn2jEx0Gpg2zk3MCOfb+nP+Ggc4o2fBc7NKkjeRFBG0FGLqZHELhUJh3WSJC+2kfNxz+ChpInV5iKAh/Zt1QqCSl6fZNed0A3G68dhc69P5axz87F2LE19CQHNFE57cwolSVqFQKKyLvOFEJ5VKiq5Z10UUlZR0dgzzWQ/inZ/37J9vHs5f4/AOJ3SS7pmpCpg6DMUwFAqFjeCTDz5pyz1tYfcUeuq+3tikys1pGGCzzXMoFAqFwqagGIdCoVAonEExDoVCoVA4g2IcCoVCoXAGxTgUCoVC4QyKcSgUCoXCGRTjUCgUCoUzKMahUCgUCmdQjEOhUCgUzqAYh0KhUCicQTEOhUKhUDiDYhwKhUKhcAbFOBQKhULhDIpxKBQKhcIZFONQKBQKhTMoxqFQKBQKZ1CMQ6FQKBTOoBiHQqFQKJxBMQ6FQqFQOINiHAqFQqFwBsU4FAqFQuEMinEoFAqFwhkU41AoFAqFM6g+6hfw0eL5Ifnj7PfJ3+8e5zuOSzouF0d85phcZo7w43CshULh9+UCNg5+2gOQ/HleRHFNj8nPn68k4+fimBqOo53RM0HysaXD1vT9zmYWCoULkgssrOSAscYgrEEABZf84F1+9nxi9vULyRzkY0QmtiAZg+54Dfx8P+5CoXCuXKCew9rFcvLRT//exw2ZhpOcNaGliV2Y/OPsNz6u56NQKLwTF6hx6OjyCc7a3MLUeDiedtnnO6elVVIETUDS0SVD8XHwkgqFwvvBBWwc5LTPZSa/kL8nDhI/6hf6e3B64kAR10m4KDkHdpZkdDEQhcKFzgVsHODs4RJBRDBzZE0M/jwLrojk1w/ujpvnHANI/od0eDJJwLt3x5y8iPRzUlIPhcIFyAVqHM6+zKsK5o7haBA8J2bdI26eUrkym6fdjCU9KRCmoiBpYXefLv5BQCVgZsk5Epn4Celo0jGaGyKaktfFOhQKFxwXoHE4czF3N1QVDWAxEtuIqyIYToOK4OrTcEzeXYtszhh9KrKyiRHTfMjmjkcjmoJA0ICoEi2bha54SRTBiTFODEShULiwuACNwywGgCqIOq2NaNsx5k5d9dm5YysXXbSfvXv3sHPnTgaDXuoJkJSbkE26ZgrJjokIBgxXhpw8eYq333yb1187zJtvHadtW8xiboDLuRYRzAzDCBrAHfP8eaFQuKC4wIzD7GreNb4ZLk7btkRrGAz6XHnlldx6261ce/VVHLzscvbt2cOOnbsY9GtUIYQA+CYOt8gkf+Aow9URJ06c4M033+TlQ6/yzDO/49HHH+ell15maXkJlQrRgIYKN4itI+KohhxaKxQKFxoXmHGY7XaePto4JlTKFQev5LOfu4PPf/5z3HTTTezfu4faBWIyHm3bAlBriudbtHdIOZztm7/vInv6c/o7/pyqYjF5AFUIzG/fwo5tC1xx8FLuuONWjh8/yeNPPskDD/yG+3/9IM8+/wLDYUuFEEIPrYUYDURIASb7SN6tQqHw0XGBGYdZWYiUcI6xZX5hjs/deTt/+Mff5o47bmfb9q3E2LKyukgvptJPt5ToxYXYNnlXfsazZ3xt/5iD51+Q03/hNGmnd24789N+IX/3tB+ctPQJmEE783uGo3Vg67Z57vr857j55pu4/bbb+Jd//TE/+/ndvPXWCepaqKsB0Q0jJemL81AoXHhcMMZBRFBRmrYhSEomt23D9m3zfPObX+O/+zff56ZP3UB0Z3V1GQ2Kx4gZ0xJQDbn8MwVb9B1yDnKGcZCJcUjidzLzb/nT0wyHdIu6d58DWJa+cKwrMz3tNXTVSYKgCj5pblPUHYkQrcHd2bYwz5e+9DkuP3AJu/bs4J//+Ye89tobk3AUaLELhcIFygVjHCBV64g4ZhGVyO4d2/jOt7/O//Q//Y9cdvklNOOGZjwiCBCNIAFOq9bxHI06e+dD+kfJ5aRM9It8UjnUdVvPdl3LjI6TnP58E30nJs8tCJYfZ/Mx1no1nn8jhYgkCoiBOOPVFaSGyw/s49//5V+wdfs8f/Uf/5o3jhxHdUBQ+bj0hxcKhQ1ywRgHd8esRRXMjLoOfP1rX+H/+f/4Sw5cfhmj0QpN29It0I4gkhVKJ0+SP8o7FXdm74BwljW7+4aSXYi1r6/zMCY/7bkyipmksM4YGdZXLjX7Wv20X5F0LmIzZu+eXXz/z/6UlZUx/+f/8X+zvDymChXWRkQvMH3GQqFw4RgHAA2CxZZQKTfddBN/8Rd/wYGDl7O0tAQYlnf+aeFNC7FsOK4yI3kNTH2MLlDUhYqmSd5J0GiycMuMt3JavZBMn002GvTJNa4us8+ZGuXGo4adO3byve99j5dfPsIP/+UnWGw3cUVWoVD4ILmgtoTuERHYs3c33//zP+P6669nuDqmK/1M1oDUWQznmIgVjICj2QfRLqCTQjue/kUd1Dw9OiuknkdIOKbkh2CqxNMeJueeD/CzfMPdaNuW/Xv38u/++3/LFQcvB4+5bLdQKFxoXDjGYdL9C3fe+Vm+8tUv426Mm3FSJhVBNIWSJGtknEuN/0RyY+KFdP8ZEIGIEBEMzY/kRaTHNJuQfrb7bWae7/dRT117TOmkKEIVqtT0FluuvfpKvvXNr9Ofq3E7n4UHC4XCuXLhGAdSddHefXv46le/zPbtc4xGQ1QhxhZRsnHIHcPn2v4sjkuLS4OogURMWpw2KbxKmx7afR0RiajnB21+RJRIoCXMfK8SQ2hJhmajnG7uJIfNBI+OmxFEGPR6fPUrX+aqKw8yboZsPv2oQqHwQXPBGAdPNalc+4lr+OSNNzAeR1RBQ+cpcNqG/Nw0hUQdsnHw0BJ1DKHFtQWNmESitGseRot4i1qLekvwFvEG9RaxhkoMtTFqDT11KiLE9tyW7DN+SRFLmlLiqXi1VyuXXLSPO267dXLeCoXChcUFlJB2+oMe1157Nbt378KtTRNBLU4krCeJBsmJ43NYft1T7iB5JA0WI6FXEz2CKOZTCySdpJHP9DlM8tRdzRQQG4I57oZjVDn0NSmXXfcZ6HomfO03ST0guGERhJb5uR6fuPZqduzYxspqREvFUqFwQXHB3PHuztZtC1xz3TVogGgtbhGzSFUpvE8SEWluguUYPogEoqUMQ5SKKDVR+kTp00ifNj+ipu9F0sOocanR0CPG9DxBA9ZGMEPPyW84M1cxLbDNs6Wj4bGlVwmXX3Yxl112CTGWvEOhcKFxgXgOaUGcnxtw8OBlRIuppFUFa2cWTDmz/2CjCGCmWCuEMMBdaM2o6prQ62P5+W2m2lUcQn6Z04nWqaIp9SqPMLdU/ySBaJ4a+lQ25tyIr/E2utGgk74OQMQRN9SVfXt2c9H+fTzx5PPUdf2RvoOFQuHD5YIwDp4X2cFcnz17dmOWSlpDUNzfX+dJpUKoaceGhgpQgsJwZLz64issrw5BlShn9kNPA1lOsNTHMD8YcNkl+xn0akajhlBVuFuusHo/XvHaJ1FJj2gtC/Nz7NixA/MivFcoXGhcEMZhcrAhsGXLAqqpmDS2Me2U36GvQWbFj9aNIh6gjUDAJA3WeeaZQ/yff/XXvHr4CKHuEyX1QHjWR+ocFsHSzt0MJXLZZRfzl//+3/CpG66gHaWlPHpLHQS8PcczcWauQplOjENT30O/32NhYYHzxzasV7n2fOa9jnH2vfV1/P56/t4Hfx59pk30nY/rbK/pw66kO1ue72wymee/7MwFZRyCCP0QUPcUmjFLA3EEJp3NkAfgnCmGtx6ECD5GRAhVRRNheRi556Hf8uNfPMjJxRWkqnHRLG635pdxyX0PbmCRXS8c4YprP8X111+B1hXiY9RXUaozf39DeBIDnP7p9N1OQRZF60Bd1+fQ77HxxURcUZOZ3z4tZObTjvDJAFdNRjW3Fa45nvQsbRIbzH0l6TcrNv6unr4wzX6/63ufaaL0039uXWeAWaFFEZtZAlPni7viWmES0t/0FmU8eR2TYoPJhMI0q2T65gpYjXiPlGPr/m1tx3wOak4+n/bhnANrxurKaadm1lcWXDTfe6nHR3NPUOr/mS2i6K57nfn8gyOpEcTJ6zRJopSWz5Hn9wOmpkOIiJ/fuboLyjgoUJkjnuL5TkiXvjk56p/wLlN/LjumFnwF0QrTHq0FXn7jOHc/8Agnh5FqYff0YuoGUnfCe12XdJcbMGdpBX51/1N882t/wIF98xBH9MMQpaZh7vc8I9PjszxPGhxXQTzPnz6ngt6NN+mJh6wtlc/LGX/V0jhXZpYTt4nGlOcFzSczsTuj0D1aUid84Fx3m/5OQod54UxG3fNCFzZ4Brojc0L2HpOBSM+nKCZVaq/sQpKSDMC0Ai39fdRyMcT098nnafZVp9b4HKKc/NzUKDghf92ukXtZ35nqSqA9nwud/MusdyATw6aYBzyPqE3vV+oTSsLz+Shccyvoh9O5nzOE6MRLDxNlZPLGxDq5m0lFvBPsfPcbLjDjsOZuPVOw6B2+2hjRjADUdc0wGq0Zjz/+FE8+8SSiNUhIj+4viZ/2+VRsTwVijDz3uxe5555HufRPP08limpIooDnGlU666nJ4bUZccE0h/ocQwobOYkutJqy8iZdXcBa9128Ex7PylPuqEeCG0ZExHBPC9pE5JbOqwiT5ftcsK7mGMlS6dOzljzMLqWviDgRcA2neTLv8Tey9yMY6k7wToHXUI/5eBqCrOYmTaVVaFQmpdAppKn565Bfl4Cn73d6vs5M78rsHHTp5qSf7bGRt96pbYhIxFyJ0iNKlRf0zhuJk54eJZL22nMYIakGY0lKxquJoXUJuATMlW4zJ/m9/+DCS454IFrNrBS/CJONhzpIVnzuLlR3nbnPz08uLOMwywcUShVRkBqXihjh2LG3uefe+1g8dYq6vyP/VLfwne2iTjejImlgjwgn3n6bu391D1/74s0cvHiOZri6cdG9zYykHaJr14kxG0+eDTVNZ9IFc8S6sBHgLS6Sdp/59yZuP1UOJ51L7bajtJOBTepn8aTc8mrR5WwE1DbwHkneOVekUFAgSkQsdc2TO+fFI5rDjskUVTRSp9CK58XTFTxADju6p0VZ0bzhGCE+nJ5alxzBmzUQQBaEZyLvsjFMhIBOvQbPYb+8AZmGCJMhCO7UvgyeDHBUxUyI+TmQfFySDSCKk70r+SDDN2nD0WovhzYjYWIU2lxV2IWCuytGMCpm/dzzkQvXOHxQSEh7syhEVx5/6hkee/QJNNQp6ZxDIDCz7HU36ezTpLsdSdElnn7mdzz6+FNcetEdmNRY21J9bLpUnMAYsbjGLKR/OXMEUlcqQD5tIilHIzle7Qh4QEi7TpsJayR3ayOGNaI+zjf/2cNKlpJF+S0UggmyQU0qd81eWuf5VEmQsctlkDvoJaKejlejELqQmuTHJErZ5RscxIg5GGLepuKDHLoTnYmVd16i2MQbmkjMbwAj0OqWSXhwzfAr8g7bBZOKsaQBWuqR+bhC5ZGWCnfHvcoDtXL4K2+mxPMkE3dM7f1qUTr7+0JSSmtVEUmvUzpFA6YqBcnL6XJfiknnuZ2/FOPwviOY9ojUnDi1zH33/4Y333qbUG8lep7JLF0Yh7QAnFElNfuFolJx8sQSv7rvQe74zA3s2TmHMPpAb4oPFRfwHmtGIa2xEtMEaRfAMYGouScjJ5wlK96mzW+3m8u7NwlMBx+tf7EzFNM+0OWpZlm7MFuO2atBbTPHsA7Sby+nGLYEIhVRQ955C0KFuBE8izZapHKjjikkY5JmfZuAScxhuWQcfKYrv2uuTKc9b1Q0LdY66YJJUXQmBmJjagGO0Og8poEQGypvCD5GaSYLeyQQpcKoMalABfGAihElEEWJ2uU8ckbJW9SbtHv3dNxuffgA8w+pVsWTpE1OkicDEbMHp5gqTk0MFZEal4C6UcX2vPbwi3F4n4nZpWwJPP38IR565HGiB+qqh7Uz4hWdVoZ4crmzbHeXo04/ImjeDY4b49FHn+KZ515h+22foFKDGCe5AhFJ3dmberNyWh5BZipVvMasonPKVQCPeczp2gqablFrxHBNN2uVhQkdSzvrNb5Hrv5i46fHCUStEKD19FySDVaXQHdJFSw20eNKM8fXF7mUfGTLBFlMi7zUiPQwTQtnRECUIEKMaS+rliruemuqjTyHWlK1UyAiMS+m2VINZYFxNpSQ9xd5CJR1HlnO+XTeK+cQHlHxHA5rCD6i8iG1j9GsWBy1pvUeraRQbCQwCv20U5e0+3YNkxyIeqSyOAl1IW0KM3kPp17Xmd44XdK+RTzlUETSJsTzteESMEJWPahp83tWx4b6/UwKfgQU4/A+46Rd38mVEfc98Aivvf4GWvWTBIamHVH3k1NT0ek5gaoS3bBoWSEWKlEsKm+88Tb3PPAwN9x0LTsGNS7p50JIxsGwPL3OP5h75fc/OUxWImb28Q5Ciie7R1SEIKk6CXNEFHNy+W+Kz0dRTKv0sBZMCUQ8G4hObVbwSUlhqijZmLslkHbrIpjlhTYoWNqRuyjuSepdJVVcBZuGaNa7pAoN5DBFyLNFxA2XZrIv7lUV0caIp9BYDLBSp911t9NX01z0pgQCGKgJdb7sGgUNEXMnaJU8CyOFO7vqYWeyQ5nNAK0XxRjYEm4N4pFKyNVHU98w5FyOxhaRhtbBgxANomdPr8sf5XMB6fy7tHhOYtOF/D7AS9aAKDUiVaqU0tidpFQEkRPP4kYwQ7SdFBFs6r3ae1CMw/tK2uG1Irxw6AgPPPgww1Ek9ANmEOqaaUfZjGFQcsIw5t4LT7tEy2ERDZgLw8a4594H+crXvsjtNx1AYkqQukOMhqpO7uvNeVGm1UdVMTPMcgxZAo0I0Q0xw0Ou8xdHNOIS8xa3S2qmOnNyVU5QTTduhGjJ5ASZGkiZlHtO8z3rf8WeFlh1NEuL0LQolqvKBAi4S8ptdPIoYYN/ySsiO9On2VtSn3asW2yp2jE1LZoFGIeV0VaGUyFSgQtRK7DQ1QMR1JA2MrI0O8QmidTURBlyOMzMc/Pj7FjZrodj41kHbVcQb3CpaaWHaZ9IquAKIsloEPE4oopjAg0SJIeMBIkVEUVCjWigjSnpHyUAgZZB3kxFPuguTaMi6hwiEC2ikq4Fa5tc9uAEGmofA6upotjSdXE+U4zD+4yosLTacN8Dj/Dcc4eo+nOgaddhIjkGPtssZWBpf+buxLZBK6EKPRDBIrRmhKpHE4ccevl1fnXvQ3zqugPMkbWQJGSjoljbpmVQN595mCQ/J7vSHJFVpa0CDYpGcG0x91SZY22a4KfJc0CTYRCHQVxFo4DmyXt5J4+n4IVotwNP4aCuuW8jplMkNZ61FgkScif5OIWCRJJ3kwND0mU61Ilq65fpcsDncduaL408y8OTOGQKlSVJkyqHXtyTjHu/jbn3wXNoK2DaAw2MzVEVpAKLDZUb/bhKz0dElKYx0CotwAhu2b3wLgEskyqtc3i3kdCj8R4j6xHrBaL2aVFUBI1j+tJS1UPMVrOxipin8yyANW3ygipFPfV5RKkxrYgERCKVr0y8kg8MS+caCcRooIpqne/hXI7rDZWPU3jTI2MdMJYtG96MbCaKcXg/yTvJ14+8zb33Pcji0ipz23bj1Fjb7chSaCOFrT03TRkWIxrSnGucrGeUunljNOp+j2Y0ommF+x94mG9/9U5uvmIP49WGUKe5FDHJt276y7GNkaCBkF9ztIi7k9Z+B2uxdgw2SsOONNcauWAmmKdQz7Z2hcqMsdY02iPqHBYGaQHpDI9IrqPnHAIk6f1sPWAxYp4qgEK3u25TmWkKc1S50FaTcQjxtKazd/4LqTlvmMQUcYI3GG1eLFP/RujVjBun6s3RuiAE6jhkMF5Nir+qKUkvhuk4qetaAx4JalS5BDNYpHIIVVrc2tzzoJK8087hktmi30m8ab0Irj2iZBWCOCJgqA5ziXYy0AaY1nidmvvGOISUQQixRRghTQttm3pIADTneBREIpEGpeGD7HPotSvMt0PQmsYrWu2DDwi5dyNtdlI9mHoqbVX331fD8yOnGIf3EQFG45bHn3iaF154iaruJ9XXnFcTzfFTWVvBb54e3kaqWpP2UzTMIkoPFaVtHdWKNo556aVXuf/+33DzwW8RQkXbtFRVwNyoqhrBctf3+3VU7y9dQK01p4lOJS07Rq+xoC3b5mq29J25+chAI3MVDGpNBTVu+XcsGZXhCqvDyMlWOWE9ljwyzLFrkyRR0pmEzkBspIIIoLZV9oST7NzWo1YnxCE9WoLFHPtPHkIK2lQ5L2KTANZ7/bnuZ1wWidrVzMepF0JgJD1W6PHq28NUcy8DCHXKvcQuaeoENyrGhLahrw27tlTMVy11u0KPMSLOm6M5jg4HtLGlX/UQhHFsU1f8TJPa5I06hyY4ALdILQ275oQdtTGwE4Q4TqHPULPsNYdPtSyygPd30GifaEIlDuNl5mi4aEvFNjXqdpk6v39J+j7l7lxSOKfr+1h7hZ3tGvYzvjP9jdPKy5mWT9Q2Yq5dJlY9RtVW3hw2vLG6yjhspQ2DXAFW4fSI0hCsncktnr8U43COnHHj51j4W8dPcs99D3JycYm6N0c0sGhoNZj+YlcVYqlaacvWLfT623jryOu0TRK8S3lbTYYhx+crUaLB4tIKDzz4MH/0xVu57JKLGK8sIoSUPLR32rGei7GYCAWseZYzn/1s2kN+2g/LJB+iuSyROGagwuXblFs4wZX1Mru3Ddi1ULGtD1sqZ65K7VypFcRwS0ZlxQKvxO28Map5c6Xl9eXI6yvO4dGYt1thOUZaqSGESZlpSk7PyJa8F+5siSe5tX+MOw/sY/fWHj5eofaWylLsXqUr/kzXgElFMKfX2voch+5PSUw1+zNlCiZCoz1O6BzPvG385OhxFkc9TiK0VcBUWer1k0Hxhp439OOI+bjEZb2GL16+n2u29+ivrDJvLYjyyHiBHx2peOmN40R3tJ5LPXx5R96FPcW77u9z2QGnRXtPPeL2Sxa4dX/NruYU/dVT9ILTVjWHVnv86JlFnl5dYLkKSVnAjDkZU6+8wcG5lrsu2sMndgpbx6ss+Cq1pdxCKmPOXci585uuB7HLA3WNdrM3au4nEjyX/maD0Ol2zXTWdz8H4BpppGK1nuNUtY2HD4+494WTvNUqMfRoZYBJQEmlxippjO8HmSj/MCjGYd3kunVPshZ0CWOtiAZSVbTRePKZF3js8aexGPBeyDWCKWRiMS2Yoik+HcerbNna5wt33kx/fp4f/N0hxg1gcykxGGqMiFcNwcHNSHLgwu+eeYMHH32JvRddgtQDTFMlBxYRr5JWEZIWVDFMktu70cYckdT04+Ip9SZZniGXF0qeMwFZ5UdStbx4Eq1wS+Wopj3MFbfIPCMuqoZcsXXM1dvhhl3CJwfO/irQr1v60lDnvXjKyfjaUntLeYaL+j1WtIe3wuIIji2NeP7UiGdOVDxzsuKV1Yplm8fDzCwK0WmT2KwmnZ/NpqZcxZZa+NSuhuu2rdK04+yJOLU1+dgFjU4QiJLkFLqFbN3nOS8mjaZEbOUtao5Jy1JdMd/U3I+zTB+VAb3Y0poRQ4rFa07Qt1LTSs0WHXLjthF37hpTL6zStwZBOMgiW0X52xMrPDdW2npb6jEIfVoCWAprKSmkl460k75YP6068zrmtvmKr+5StreraNvSC46psnup5tFe4JlhRXRHaBAXgjXM+wp7ZZWbts1xx17Y3awwaMe5YglQMM19JZZzSGq5kS83QDqpMi2k6Yaq4FFzebgzDIGhKrVD1bT0iFhIciTuSmWpC59stBtVlno1r2vDm6vGAyzTyjxjNRollaFbi9iQ4KNci9h7X1egD5tiHN6FtfvhXH9P3k15qhSK5kjo0bpy9Pgpfnb3r3nrzSWqej4X2EhypT2iubNZUbxtCB65eM92/vyPv0zTLPPAz3/IG28Mk3YfFULApCFoUqn0qEissVhx+MgqP/vVE9x6++3s39fH4giRJkkkmEB3Q0vW0tGIe5YT39AZyNIWkoMlkmQ9xDzrUsZcPSN0xaRCJCSlcqJpcrk9oO2Q7bLCJ7eN+dy+yGf3tlw1P2JXGFFr1vvJ9kCISQrDZqTafLI1xC2yfXSC7XqSvrVIcNgJn91a89KeBZ5YqnnwmPHY0RO8MaxpwhxW9RnFZpJglU7gT5NW0+nOlYszlpqlsAWVyPbmbUYGTR6ZOvCIxlzREyEIGM2kLHkjpIXPacVxDQRrqcwgNohFap9nRXucqrexoluYs2XqOKKKxjjM514RodE+qzhRl5hjkR3NW4hZTnUZV8oK397Z59TBeRYPDXlxPCLM7aKRKuU8JGaZiDaV10oqHd6IcXABCxVCZH+zxP5hSx2XaavUbxcao/aa1vus6lbGUgOBNswxpiJW80SGiLRoHFHZajo/XVNeisPlGH+LdEKVnWdg+bW6Qx2TOoukooHknDkSlCYEapwqJkMs6sTcs6LJroBGgjl1o1RyilMKW6RPYEyoBQ9dHVzqpK98hZ6tYlLTSF0S0hcWEwEVNFSMW6PqBZom8uzzL/HgAw9j0QmVMhU468IiKd9glnb48/0+N1x/HTffeA0rK4t84rqreePIo5g1qQXfBA1dEEqmtegiNE3LI489wVPPPMuefTcStErlc53OT1eHzexCdS4J2Swt7kymxKXq207xM4U/3AOmyVvpeYvFyFgXaKp5HGXeVrhiboXP71rkD/a13LLH2V23EFuip8SlZ6MrIevrIFiuoBFN3lduASC00G9bVKayFl7BFm25ZmHE/m09rtg9x4Htyt2HRjy3BCsMJudATuu1mM7kPv2tzlsCj6g5PXMqkmRD3ZW7d93Ipim3kTWENnqmXaANxljTuVZAVVipYbGuWe4rS0EZqRCC0hOQNmv6zDYUdu+/Z3XXTikWMBe2zwtfuarirWHLqdeOc1J3MnIlxNXsLURanSNSEaw5hwVu+hrUHbWIWNdQx0QtfPpzqRKtqbYAc6i8zSkZs9zbwXJvzMBX2cqIyrrf8Zz+TZuU1Dza6bZOpx16TrAnrz2XGOe+j0ojvcqpHCpJFYMSIYTs9U5u3Rxqa6AnxkLtzDXOoIkMMMYqRElDvbBUMBG9nvzq+UwxDhulu+9Es45NoDFhaWXEA795hMOHj6K64yw3lGGxQUPAmzF1BQtbBnzus7ezbeuAulZu/8ytPPDA0wybliDJ3fYc7xB0crVJnit67M03ufe++7nllmvZNq+IpZr/dFOkCoq1L3zjN7kRclhBEUs3YedFdUmFlBwMSQZBBLOAIUSdw4F5W+KW7Ut865KWr+6JHAzLDGhgBNEqVDRXIwFVWkTcA0iFVYHWdI1+kQD9ypgjCci5C22TDrcKqcS1thH93gI7Duxi99bt/OrQiMfePMEbLNBQT4yD+XtMxciidF0iO7gT0oiBFPgOJJdBHG8DrjWIoRsWg0s74UoDrQZELAn+IVjdx6npY/SaFbQSBraMxiF22i18pkLXdD66w+S5r+mv8O0r+rzVRn725lFWwh4qxqi3uECjc0CN63jDSfy1fz+Xwq6VyDrLsUcG8RQ9bxjYKhURDQHpz+E+wNsmeUDdmZooe2gyzpWnYzVAqiSj0rZ4zAoC7il0aAIGlQv94NAmhdvUVAJVlRrxUmpQ0vvryRMfVfO0YTcuRrCa0DghQBU83yc9DKGlJml4lQ7pCwBf85lLajqjqtCqpsF54aXXuO/+hxm3RhhUM7IP02Y3zTLYaSBQwxVXXMnNN12fF7uKW275FAcO/Iynn30d0YBqb7r3z2502sJHEGfctjz40CM8/+If8OmbriSEXP4YPcsUpIXBkcnuemNITviFrIRpE12Zbs9tkpq/omRpZVGMrVSqSNOwq32Tz+0b8f0rI3fuWGYvq0lgz8gxZkuC2lkgLzoMm8DJFTjVBFapWGlT77B7Gu1ah8CgMrb1lS1zqZopVC29OM5yESBibBkucXk/su2i3VzcE3ZUQ/7lrQFvjGpCjIQQJntNETmrY5X6GXwadrI8JCknLEYIR4Y1Ywk0bYX358HHDGxlktBcx1mmMkMMVqoBI+1Tx5Y5W6XGeUv7vH1SqFtYsBFiMNeeYIQx7G1b97XbdV8rLWHccuNW+NbBBQ4vHefJFcPCXAobehK3M+3RSE2wMeGcpw6uj+Bj+vEU83GZBT9F34acWlzijfmKlUYZxIqeORN/XJJHZ16l0uE2eTjBlLqpmPeWHT2n78nLSx5myjetILy1XHFCK6wJzJsx72NGrTNq03PWMdAzMG1pEaItsGTbeKvdymttw2pvG2OvcImIN7kC0YB0b/q5W9RNQzEO60HI/QjT8kRXQasaJzAajfnNw0/w3Auv5Kqks+1FHQ1COxpTqzHXr/n8Z2/n0ot2I+ZUIhy49GJu/8ynef7FVxnHYVqwQsjyMjoptuuUXQzhtSNHuefXv+GmT15FXQ/w8TANDLLUPzENlXS6PxvDNZAqzwV1mwiQTfSEJGRZ5ZRkMFHaaguxWWVP8xpf3nOSf3e1cPuOMXPjFfAkSd1KOkuhMtDA67qTF5cHvPX2Cm8OlddOGcdWYMUrhjHrX7pTKdRBmauMHX3n4u01F++ouWzeuKQ/Yq8uMmjGSJuyLlviMoNxw2B+QLxiG4/ZAsfeFLzNZZVmxGiIyjucn24K2Gm7X4UxwnOLFf/6Mhy1ilUfYIMt2fPbsq7IUqeGWnkSqFsNc7TSo7YxCwY9H7OkwkujPq/pgGG1hV4QVGpibN+pfOwd/1jIWkVisI0ht++qOHZlD148xdOrzjhswQVqHzOmZhTm6eOE+MEaB0dpZcCyKLE/4IV2meZl5cE3nZ7NUVmVDLRKKmwgD1SyOjVNhlXUjV50to6NS2vhrqt3cGDbKr1mhb4aRGG53sJD463868srHO5vA5uj10YWbJUVbRhXAbN5KutRmxN1hPqQHk4jY5Z1ibfHyhv1PKvSpw2GM0QYpf4GjWBdbdz5vbye36/+w0ZyuFQACbQOY4dXjxzn1795jJXVlnqwI6etTy8ATTFgj2MkGAcvv4w7P3srcz2FOEa8Ytv8gLs+fzs/v/seXj1yHPMxQQZED3kqm0+Sb5rkfVgdtdx3/8N8+5tf5ror9uOEpEsknTR1V66n697Jrn3VISUjnUkCupNO7vIREkLu8LYkxxBHbIkn+IP9q/wP18Dnty0SRi2MA17nbl4CTb9mJVa8vGjcsxR46C3njeORU61ysq1Zsh5tmMO1l8JrbgSSdEXtLfOmbD0K2wbG5VuFG3f3uX0XXD+3zM56BRqQoVDPNfRVsWaMxVTNNVU3nImDnzW+1Inraa50mlZODbXmxfGAHx1pebHdwqjaidULrIwbguqGHDVlDDqm1T6OUtmIgUHfVmlDzagesNLfkaVURrkgYOPGXsyhETw4qsZ+WeVrlwSaqCy+uMpLq0B/C1iDSAtBJ8ViH9xeOIVOG3q0oUeshBOjeY4ddzjuIP00NVfStTiVYM+jZWUMYQX1hkFs2D1c4hODyMGD8+zvQ/DlHFkTRmGB38ZL+MfDr/FqvRXVnYQIg7jMUIfEKmC2QIh91JQYRlQsMu/LOEYrKXbZhPnUayIG3s13sCTSp45bD/z8Xl7P71f/YZNdxRQ6SRH9YRN5+LGnefKp31HVC8BshcLsLZVVKsWog3PLzZ/kE9ccJPgYYos7DKqaT1x7kBtvupbDb96Dx5Bmg3leiD1FNFP5BcTWoXVeOvQ6d9/zEAcv+0N6WtPaiNCpauZBK2KaRec2eounlTD9PxkHlyTwYDmUlE5NGkhT2yo7xivcvH3Ed690Pr1tRGjalPbtZrao02rg5dGAB97s8asjxrMnR7w1GjG0wDj0iGGeWA+w0M/5Fke8Tcqn3tJaYFnnOR4D46XAE0sND7+5wvO7V/n6xYHP76nZVRvmgaXQ55mlml+8tMrh44vg29GgWdspaT29G5GKRgONaM4FpNMYtWLcW+BEHTiu+2n7u0ErVFeo46lp6eU6TnGUijb0p3LaGojmjKybN17TUwcf0muXqW0VPLDxaZRdiDF5nlWMXBZW+YNL5jg2NFaeP8FxqxlTIR7p2SpizQdoGNJrEjcqS7IkEgN16K77VOhgQScbFReZGIdUwFbjIaC0tM2IJkSijEg1fw0DDI1pw9b3EQu2xJyv0Pd5LAl6EBR66rTa4p5yfiKpY99kjhWZz1IpuX9FLD3cJ+Xc3TQ+95z/2JBbt/koxmHddIYhf6aKiXL0rRPcfc8DvH1iifn5XYxj6m3Q3IwzCVW4YdHp1crOXVu4/TM3s3NbIK6uAmmcYh2EXdvn+ewdt3DP/Q9y8uQ4L2A1SaESum4fF4eQRiaeOLnMPfc+xDe+8iUuv3gLFldRzTLVDjlrmo9jo4nSTjU2zyemq3wJuFSIBGJsqGjoh5b+6Dg3Vif5k0vn+dRuoWparBW0Aq8iFpSTOuC3p2p+8hr86hi8MNxBi0JQvKppQz3R+fc8Mzj1VOSadk8DcVrt0UhFE+ZocQ6tvkV8/SSLJ4YcvUi55YqtbN22nedOwi+fO8l9R5xlVbSStfIQ70jKqbQaaKRHI4EgqbQRh7ptqHKJchq600BMpYw9X8l5n/Wc4lThIl5PKlwCgvoAvJeGO1kf8wq1JNdg+LlPQJMkUyGePIg6jjhQOd+8dIHFZecXx07ylu4iiFM1J1KzmX6wHb+zc7e7fJ1rp1mVVFzTLOl22uDmKeRp4sTsTbSqjMOYphoxDgNGssJYNU2mq5LfO9eeYqstMfB5WltFrKL2MSJDguVqPGtRr2msxVSQWDOZLREtTS2M3fKfJu+lnhDJr/98LmJNFOOwXmTGMJDKN8dN5OnfPc8jjz6BhjkivYlkg3VTq4B0NafqoaoOXHP1lXzyhmuITQs+ThUwUuPWMqiFmz91HVdeeTkPPfQMlZAbfaZSECKGiSN1TUBpV1d47vlDPPDQ41z0nc9T5cEvScMpp1z9nWLq78Vs1dM0nGQSMOlyEUliYGAr7GORr+wZ87V9yrzWNCi9nkADVMJSGPDA4jb+6/PGr4/1WKy2Mw49jBrRarI4dEn0SXVUdwq7GxBBtMbdCbZKrRAqYandymNLkVcPNTxk27jk0kt48fAJHn/lOEu6HQ+DDYbXZo4XofKpAzaQlvm4St+g54vZWCwTPOZ483rPeDJ+PRsloTmZGuFIhUsfkz54hYnTUONeU7GS8yEbeDc1V+8oeCM0SMrNyJibt8DKVQscWRny4MklvKoItsyIAcYcH1xgKQkmNtLP/RQ+6fuYztFuZ4bsxFTE4Ip7j9aFkQqWr58oIQ8TCrRSMdZUdeQiRK+oaKm9mfTndDO5IXdLe5oRojkUW0Vjvs2S45IzedJp/Qqt5Io+rXPYS1HGCKMP8Jx98BTj8C5MquUmX82UPrtw/OQi9953P2+9eYK63pmF0Xq4tWkZ76QaurJPcXq9ms999nYu3r+T8XCRudDmeL7TtGOkVi65aDe3febTPPb48/ik07arB0/GwbudkygS+hw/sczd99zPF+64kUsv6uPNav67Ib/grldioychknT0U0OcSZriZVIngbsYmQ+BXmyYG5/imr0Vt1/a4+LBkKVxk+THFWidJtT8dnnA3z6v/OjYDk5Vu+kHo9+eYBwiFsJpbvq0ZFZyOWRXqeJ50Qzi9NsVenGYlDNDxfGwn6MeeOHoPHOnnHYYiLqDUFcT470+upr3bvqXTyf3RcmVjvn1uSGM6PsyjrAqC5OF7r1PuiPSEFiisoYgaRZA9AqTPiItIuMsWJd+3rTFY9xwmWmjSkSpY6oIMBdMnBpnq4+5ZVePb15Zc/K5VV4egWnvHDcVG8NJ/QLJU0ihO/Vuwl/q0lemxkEwKnd6cZnWHdVA632CCfO2zJwtsxD7LMRV5lsjxBQSrGWEM6CVikb7uWS3l1VfW1wbxGuCpA1LIyk0lTq4k2FQma1BlDNkYmSm7+R8phiH92DSmTsZu5gWfBF47vnneeg3D4OEHHsPiFYp8TwVZkiP/BwXXbSfO+64lX4txHFEtM0tpRGt0o2xMD/g1ls/xQ9+fC+vHjqFVrkRp1vYxNNMhJh1+FFiG/nd757jqad/y6WX3Dp9vd1Q4Zl69/XTbZNjSsZiebhJkrFON3Oaf9azhh2Vcd1Fu9m3cwmaVQaxk82G1brm2dEC//hcy4OHW1bCPP3eABudIroikgfTuOVdW5Mb7SyXzKbdGVKlEIIHaEfUGH1NA+pN0+6zCVsZhzkWW0eXI3P06dfzuI9z38j6z4B6pG8jegZVVtvsnsBUGGmf1bDAkG2oCpWvIkCbFTvX/ae6cmCGuI1QsZn+gCRpMdEAcmPaa7L+g3GBMcqJUY+41HLJHqPfyZNY6k7f7qvcdUnF8bbH3z835CXbioc+H+wOWLLcSpO/TtP8dOZYmVwDilDn8x8JNiKKEbUmSi830IdcttvQs4aepRAQ4lTagqer1qSi1R7i/aRmS5V7VNLuXwi4GGPtsUSVmwlj6jOSaTWgT3SUmqRwtqaM/fylGIf3oltk84TgJC0dWM4zGw4fOUaoF2iBqu5laeesvJrFvdIIz8jcYI7P3HYrBy7fR4xGVaWkaK1VSnB6KplRgWuuuYpP3/JpXn3ll2megYSUQpyxOVJVeEPqnMZ54+jb/OrXD/HZ2z/BjoUe3o4m9qzrSN3QoTMVJesmJE93eCHJEiPQjpmzFQ7srLhm3wKDfkNcSiEYWoh95ZDu4V+OVvz88CmGVGz1k8SmpQ19Gt+GxNQIp9YSrCV4atZK4RXFpU5Kq1pjuQqkjqcIMqbRwFjmIDfsmSsSx/TJUtU2xjzmmPbsPAd/z+NXIj1vqF2TYZCpwpuLMpIeqzrPKlsIVQBvqdKbwvqF14SWeVoWiLJCj+VJZ7JpjbhSuxHyHAnxVLmTSoc38oYKLhXHVpRnXzVuna+5bK6lH9os2SKoRS7WFb56YMCR4YDDrzhLMUnCT+YmdNPv8jH6zOCjTnerc5zXf60ZlQ0n4aTphZurxUg5viid1lPKGo3FaMUZV4pJn4CzpMqqrtBKlXyQrsJski2L3Zd5pGwnlOd5gzI7JzoVTyyFfl4OYvZg2vzIc6UtVfF194vTI2krnb8exPmvK/sBkkxCKhsVMyoUbRWLfZ5+/k3uf+hFVsdzEBbSuE4ZQ1wGG+VJZqniQjTp1uzdv4fPf/42tmyB2EZEA6L9/DM54RshoOzevp0777id3fu24fEkqiuoDPNtUuPR0Zh2Qa6BGPosjuCBR57lqd+9jrCAtjUahVoEyf0JGzv+FI5SPA80MUzqVG4pwiAuU9uIysfs5xS37XY+sbDClmYxhSLE8aCc6i3wwMoefnpkwBHfiVV9gjrj3FHa89U0gD6HblzSRLMoaTeY5LfTblA9TnoCggZMK4bBiRghNvTaMRKHiIzoaUPdjphrx2nWck5wpra7VMU1SSSd8ehCcTVGj1aVJjiNZpVSF7Q15tohfTtO4DjIiKgDTOZJpVnrfXRdupJEGVXyRl4RVZSWnq8w50v0PTXXNdJPO+UNkE5BxUnr8eMTwt8c7vHMeECrdeoUNkGD07OGqxeW+OMDLd/YcpwdcZWWAbBKqFaREGm8QmRAMEcZ4zokhhYkEqydyKxs/J7T/Eh6XD7RdUpGXXL3f84QZOkK6LUjKkvaYk1IJiu4JcmNLJ2BQhuSflKkhzFH5StUnEQYJs/U+2nMq6SBTUJLZWMqa1LIz1rU0gxvsaTjJKapbNXrHO6sJ6/3fKZ4Du+FpCRwpQrR6YcFji4Z997/W559/k1Mt+E6QFhCfZQkD0JvGs4x8DaN/fzEdVdx4/UHSFEiSVLe5LnAGlGp8NYIPWW+p9x60zXccN1Bfnn4V7hFtBoQ23SDa7TUDSyChzq37w945fDb/OyXv+HWa69ma6iTPr4ZKtB6ew6hUMnFLclzMKnyDs2obQVMqbXlkrrhxh3OxXqCwepymr9QO0MXjtg8Dx6FZ0/VNNUA9RVMA6OwlTquUtsSLYNpWGCS+J99sUl8cCKzQVLPbKXCQ5MSuo0RLBLritUA1gp9lL4pQ7eJBpSvCbEJZw+35R2rByI1rQhNAA9Cr0shRaVnkTlZoseAhh7IHK4VxOG6E98OqDTULBNsGfVVXFOYzLMooEskVetUjLVmGLZQMaQXm3X9je4PSRshVLyoW3jyFaMe1Oy6KHBAlxFL41hDZRBX+eSC8e8PKithCz9fHKaYvED0iGrAI8l1CQbapBBkrCY9NRsIeKXzLd08iXe8FXOOJxmepBIcqH1EFZcZ4cmIScxT4mIyDpa66wkTG0hMAUlqHwFjRHpgffAe6itpGrl0Ho3zziHZJK0xeyQfF4rn8K54p3cHebCKScWrrx/jgft/w+KpU4Qq4G7UvSqNZFRBqypdSm4EIjZeYff2eT5/26fYt6uPj1Ovg7ctbpZE81KWO6mZxpbancv2beWzt3ySLXN1muplaYFum5h2nF2qMC+WIsJodcgD9z/IS4deJdQDkIomRqoqTPSENoSsqRlJ3/Ku8Sfv8axl11zF7i2Ceq6Jz7MJhh44eipy6MhxRpEkk5ErjiZ/IH/cuJLppG4JT4M1iVLlyqL0eas1Yx3Q6hytJuOjeezmu9/InRpskh7XHPs2JG1EA1hVM6rnaHRA6z2ipXlrkKSng4/X9ai8QeMIbVYINiIQU++FVoyoGOscI11gNT/GOkcTBnme8kYuZ6dizDwjgiivL9f89GXlV0crToQ+VIaMIZqwYn3E4eZ9LX90dcv1c8cIrdHEOaLX9EPEbIUmBKL0Ea/otS0CqU8lKUZ+oKyRa+o8vu5dnfT5MEkYd3Mf0m0tM787Y8hk7dOsa+7Hx5RiHN6FdJEIqhXj6Eg9YHF1zKNPPsXTTz9Nv1cj4lhscXfaGNGQYt5JCjJ19AZGXHvFJXz2puvoR2A8QtoxuKVFYGbH1K+UnrcwWmWAcOenb+DqA5egcYzHhhACKQedXe3Jgp/jvg6vv36E+x96lMaUseXaDs/aThtgVibbyPFbz3ISHnNZrVMT2betx855RWOS96ZO5YltFXj9RMNbi8OUUJSuLFRzgs/z4PlzeXdyx7Y77kqUimaS2K1wqWi0xzAMGOs8rQzSa3ajK0RMdCEAeYe/0RI8VQa5CDELso2qipHUtJZmHNcqBG+gHSa9HWvX9cCa1LsQekg9R9Q+DT3G2mcs/RxCqsGh8jF9W2IQT6ZGuA2+n5VGKhshrdNUe3l6cRc/fBV+czIwqkK6pKKipgSceRtx5+6TfPOSFfZVDaEVlB4Wh4Q6EkMqtyXWhJiuyTb3FZzLWNZzxdf5vbP963tnni5MSljp3XDw2Gns17RS8dapE9x7/0OcPLVIPbeLpo3Ze3CacUvVU1xBs3EwG7FtvuaOT13PlRftRkfDJItshmqKOUcnjflsGjy2BKDnqQHryov38NlbbuTJJ58mVPPE6IRen4l+PWnp7opwRALLKyvce//DfOWLn+PaKy5hPExLYTJeG7nYux2VYxJyWWGqOccs76OVQTD2b6vYWrWEJuZKEGcchWWpeflEy1I7wHqpLDJVneSErfhMTHljpEFEebobmkczZkmPLLXsIilfIORBRQ3iNpGK7s7g2kVgpqtdumIEIRjEzkAoRHG8bahHKwwiaDukigYxzZreyNJo0uRE6JA4XsW0D9pDtD8xnCk5PqT2IUqb0yMbOG+z6RUPRLazHAJPLK7wjy+vstCf49NbGwZNw/xoRK2OiLHHFvnqZVs4Ohzww0OLHBsHGm2p+j2ILWKKWJJ5SSoVbWrAvIAX1o8DxTi8C5r3lzE6UvVZGcGTz77EY08+jebpYqp5AXEIVXdzSHZdk9bKZfsv4a47bmGhp9AMUfFUWRcqGiPXr6cwQoxjgjh1CLi07Jjvcedtn+af//VnHFuMdPMHmIw59LzYde6x0lrg6ede5v5HnuLqqy+Fqk6TstqNzxhQj2kGhXTKrCkp7HjSxsfpq7F3QejFYTIamqvSVTg+El5biqx6Xui8xZiR3Miy5xvvJ+1KdZM+v6NEzUYhh7owS8nC1G88mU6XjFwSDjx7H8Ik9gB0LYCKuuDuOShm1DZibyVcv6Vhty0RZIU5j7j2WGTAVELh3UhBsWDH6dsb1D6mrZ1RfwdvhgGvDGHVk4RGo4PcMS400s/NYesvT3by6NGgROljMdCvAyd8gbvfXkRe61FducBt4W3mhi0SwAeOWstVgyF/cmmfZgl+9hYcZo5UKNeg3sfp0+oAkVWCLOXyzsL5TDEO74YkDyCFQypOLK/w4188wLG3TlHVc0mQTB1rGxBPIZ9u6bC0BM7PzXHTJ2/ghk9ch7ctghMthVxMK1p3hEAbhZ6GvN41mDnmkSr0+MR11/GZz9zGP/7oHsIg0LaGzuQQpCuhc0ACoj3ePrnMPfc/xl1f+DwX7dlCjA0aNt7rkPILqQZcxHLVUswFPQHcGNSwredUMTdvaU4dK5wcwfEmMNZeGtcZbRJSCp6qWpx3T0SenVRnDoJa8rKSN5CqZSqPqdTWk8JOiFUe2Z0a+lSrJE3SNZZ1vUyT+FbqEUkyHalxTFwIboTc7zDwMddshe9fv42mHtCzEb04xFRYEs0dIOtjYLAlNgRzmqrmRG+OR04pP3pxkZeHPUxTwj5Jo6d+jtqGqI82dD23QRiGQJSanib11ZH0OCx7+fGbkb29hssumueiegloMU8J534z5tO9k9iBLSy3q/x4yTnhFZVKLm2tQGrMVqjCeDLvpHD+UozDe+C5P6gV4ZkXXuW+3zxC65pGfQozTTp5cRFNBiXfGfsvupgvfeUP2L6zj4+SIUiKGAKqBM8tPl1YyOvcEZqSpiaBfRfP8/kv3sUvHvgti8stElIJo0s31IdJaV/a0wbGrfLwk7/locd/y7e+ekcKi6hsuA+ui81PG7qSvAB5wI+706uUuSoSxDAXGu9q04VhK6xQEbWXqnImdUiek9eSvZJz8B2U3FHddY8blY/ptcvM2Qo9ItFiaprTmugV49CjQdCgaQSpSg7bJMG0WU0cycfRaBIYDA4Su+YsIfz/2fuvZkuOLM8X+63lHhF7H5U6E0gktC6gBAqFUt3VXS2mp3vuNV7akNeMxgcajQ98uF+Ixic+04xG4wwvZ+7cqeme7i6goLXWyERqddRWEe6++OAee+9MVKEy0ZU11Z1nmZ0UR+wTETvCl6+1/sKMw67jhwdniEaGNsPHDpiR3OSGq6HlwT4Rghcu1xNaKt6SXS6Ghqlnye2s51DcvMpuJ8JMHaJkhdsUMe8Ifp0LwXj29AUecTV/efc+1tjKHuAqSGcMQ8d394+4fFfDyS863pgZsTmU5SJiRy2JSCwbFLl5Ga+9+IOKveTwNdGTx2KCyztj/vH5Vzl/aQutVoip7/amOZope8EYknJJLU7Zf+QYh0/czamLu9BlKKaJZRvMHglU0BOup/sYczJQLD3zI8ePc+c993LlzQ/wbpgTEEtDYysKrOQBoVM4d2GTZ198hR88/STH9jWQbv5plSIhkQoyxi0xcwOZ2Syi+JJFrU92YkiEkKClyuzTIo0hBQ7irM0SHPi57ejNRZbFlpgVXyHgbcohP+G4axnqDEsdnSpOKiZpwKlUcXmWSDG7rIn09L4em7R0HJLPpxd1c8my5HX//SZogI20ixPmom1Q4J03HdnJzMdAY7CWYGhjBimSrJrDaEzyUPiboElKakOJJCKdOpJmrJcCn4+U//lLRfcf4kf7PcfsXG6nIaCJVZ3xoyOJz9oBV07u8Fm3D0kVlbTUYUashYkMiandGzn8M4+95PB1YbmPr+r47OSXPPf8q3RBaYZDYtvC0kJikh9aK4qOeeygXLqyzf/z//2/UEkRD5sPYaWwWzNYkt5pLYth512sZnB2G4RWakajKSoOLOaWiJaZQ+oF8TJqhwLntNDx+lvv8v6HH3P0h0+WfvmNh/QzB1KBTS7gndGkKKeCaNalxGReHWgv5EoWFTAyw1gL6zTvlkNGGWnNXOrjht+a3EbSlOXIRfNvqmXEo4cbfn7PEdZlF2FC64zGai5OV/n/nvZsX5pilmUS+h1uXtNlPrPozx+x/D4VP2JMyvtCJq2RQQApZtlp9QmcZTD9TeS6JEJSxWu2hlXvcc5hKWWpaOlFJPrasE/0Nw5nFcAno7KE0BFcAj9AiVQxi9FNrOKlHc/4U/CPbfCvhlfQIjrXu18e8R1/dU/DpVjz774cM7HEoBKYbdHFNYLfj1nslRL34p9p7CWHrwkrrY4uBF5/620+//wUopmIlqd1izZEbzWpApUIloQQjDOnz/PZpydxLu/pRYpekPRYE8PMkcyXxai0cZaA1ykK6gdYhLpucl8/RVSvxWrPiUSSB9veDzhz5gLPvfAiT3/7Qdabb9JWypziTCArLFVikWKoyerVeaiaF01FUzZuDwYqmRuSl7Y4H2ZLYV33FcnNshwMIWpGJDkUTR1oR8OYE2uOHx5vOCiFTayJYQqcGhnPXsnyJCklVH15rXwEzP/uVVF78pPNpRUgbwTQ/B2dVOzqIVJs8KmFuqN2U+p2Nm/5/fZzgU5rWjdgYDMMo/XrTGXImCkTXWOiG0v3hGXyV5zdnH2nQZ2MQYwkTQRvub0UjCplAmFyFVsor11sOb6SuP++DR5sJlTtjOCK2GAyHlht+Td3r7I1nfLyuS12UkOrSkdNSnXWytqLf9axlxy+JgRwqpw9dYGXX3qNLia0qglJEM06OnMM6ZxwY5h15A6DEEJeRDPXIJaiPhQSWSptlpxMTPvFvezPS7tJnaNrs1Wld+Q+MOS5xxyc2C9vmsX/Upb1Hk9nvPbq63zyyQ955ruP0oWOm6n3pRe/k0VPvv99STxYIEawWFirWQUik8ZUcE4Q5/M5pVjmFRSCYJdlzul3xTf35mR3NpmLmSsdjU0YzhJro8Q+dwVhRjBoIqxNx/hwlBSL10WRLBExTOUrlYuUr/Wy4b2kRuZvwFTg0qzi9M6QcTcAGdBWHWI1jXVFi+m33WFW5hpDogxYTTtU1rKD8MFI2JINptU+Oh0ihCzAR5rzTW5KWsnAx8QwGEmN5IxKWrxFJAodQ0wDKjMCiRe/nHBPvcGhE8odNmWMYE0uIKppx7fqEf/2REM7nvD3V1t2m7uQaj8aCgHO/ZrTXXpUft2X9uIPJ26z5LB0V1qP9FnsFCG7gsUYMxJIlUmXeOPdD3jn3Q9RrbEkhZ8Q5mWz9QV/2VnH0GbJDV8TDVxVZ/FsASyQVSXLQknKEFEtDlciBUFTZNvKmqR1hcVIiBFfrBuTyRK6BrJqaoQUcFVF7GZ4cXx5+izPvvAqTz7+MJU6Uoxz/2SZk5X6BXrRDulF1PLAvE9DC9VJI5FSpA2RcfQZ8262WBRVqFRo1PAEAuWamSKWiWOqKVci8/fg69Qsr+MmlG9LUtp6hfPQpC57R8sMLFKbIDETyCoJaLnOghAKomkhz75UWkk+V7GFv0BOSkInMFXHZ9vKf/l4m4u7O2hdM6mFiQGycsPV/5/u5AAAgABJREFUUIaYVgiwloxBikzCLpdUudCtEzWLvrnUUdkEb7O8OSitvZt9BNRsTlLLLO2ISEWnA8R2qGRGiolLqeYXpxtOsM1fnxggPtCliKjgZ7AhI55ebzl//wofm+PidECFo4oTkqZyGy/kLqQgL/r3qxeqozRUl3nze/HfPm6j5GCgWRist87UMtAkdfnzknDOE7oWVzV0onxyeYu/f/kdrm5OwW2gLrdQUmwXr2cOkgOpC8IlltmwIikSQ9G/UZ0zjpnDNxcIlGvchOgH4qUHrZr1bBBUFZcgJbf0cFFaUi1mLSIVFqdoXbO52/Hc65/z8y+u8uT9R7AwwYsQy4OeDEx8dmIrl6r3LkjiiXi8tWCWZREsJ6LKZmia0YbIWTZ4RI1hmGSBOwW0YtUPOCYzPk6R3eoAHRUaHVUs0tySsmmNZU2e+WLyFQZrT3CTOcmtCqXt5/shbcM0rZNsQpPa7JVMLmWiwrRymMuzAXN+ztQ26W1I41KikuxZYTWkUNpmueIQU3yE2mASlRc2ay6Moa6MsR8yw9/0sDirnBo1A7x5ohnBD+hchZOEplnxKFYSdT9hurnf0Sc2V4bpUbJHtATQXj5eSazQoiRf8+loyv/rtOIOHOaPB5usdTtUncxBBau0/ODoCh+mdc5/HtkcXWTIjIBDQgJpEenmcuxJhZkTggZEZngyFDdqVYAcexCnP5S4vZKDREwiQoX03srFvEUUTCJdCLjKo05oO+PNj0/yy5feRKQpdpCOEBbJxOa7HUVSWfC1ykPcWJi1c72W+d6csrX+ylHKdYfcI2oW81olpryYaPl/rjZS2erH7A1hhvOCak3XwYefXOT5Vz/goRNHGVY1qWvxqqQYEQRxvYoQcy2hrHufJS80ddn9SlypMQwnHV4DXTS+nDZMD64ybKfzvKfA4ca4d9DyehwxknVaWaVKDiMQLWKEpbllOcmyq+zt36QMuhe+FPm6+dJeC96ywKpVzGSFJG0WQDRBTDGXiKrMpGCiUszJobSIKLIgvX9EPhIlWVYHFXNAyDOVmBNnFYWYsnz7ZrOfbRxDmbGr+0laU8Vp1v2/sTuTPiF1rOb7cclDxlmWK8nhM/IL0LkJ041HVOicoClXHpgjStnQ0CIC0YYkv0pnASdT3hoPaT439lcDfrgW8ZNRPrIo4I0jvuVP7vJc7QL/+ME5xtEh9SEwIalhmua3erCcnKImRAK+yJAn8exhX/+w4jbTVvqqfo70TyJZ7TRZZi6HKGxuj3npxVc5d+Ysvq6JVghsSEEN9btZitBX3vEWG3J6F4T+33bd537bx9f9TOn6sySIkM9NFNFsuel9ndda59m6epWXXnyZM+cvgasJ88Tj8vzkusuUSiEj82uUv3QtEwBQZZaUM1cnTHTY984gCi4GjlRbPHwgsl8j2hlJmqLLbwSFTgZ0ukGSJo/ni3m8yfK/y/smy0eQ5ZRFwpwXMkcT9SY5S4ZHzlJB6SxkHb46iF7+++tieUGWuaib9Il8fqw3c1fK/O+e/X5LWixz9v5vHgH0/89ILCEafHRxwn86VfFeOEDXFHSZQvSCEHjAbfFvT+zw8zs6VtIEiwFxFaGIB1pRIo69D3ie6KPSw7e/CfR3L25l3EaVA3wlOchieeiF6Vw1oIuZzPbhx5/z8kuvMahXEHUkM8wS3jsgFtgoZUcbS4vJbnjH+M2j91W2pV0n9LtqUSGEmJFCZrmdlRLvvfc+b73zAXcfP0bla9p2QuXzoHl5dnptd8uKYuyyZAeltZSRSDM857Z3udStcrSqSDFXA1U0Vt2YRw+tcu+647PNaXa1w0jakQgkydLJSpt9selbS/3v7Elui/euT48Zq1887lI/f9Gi7bQYMEvpCNXp5uQmbvb9uDZR/1Ne6/cbX/19S+dgGbW3xQp/d6FhUHWs373KwxpQNYI4JEQO2BUONh4eHnB1Ennh4g6mmQ3fJk9VZgrz93WpleoskVK4YXTXXvx+4jZKDl8VV5Olv9U5uphx92jNLBjP/uoVzp65SNWsEaJRN0NCygZAlHZEnwekIPpZIrDd0khl4Zsv2PlsEpJl9UOiarKvRAwRJ47LV7f51Uuv8cc/+SGH1huQlmQpW42639CgsIVmqc3lILRwKnKbaWoVF2bCx1cCx49toNJSpxkVU1wU7lzpeOLIGu9szejaCckZuBazDrWKKkbmPGHpYaR5LiPXcTOWx+/XNGRMy397c/mye18qrlxKt2gBkt/y/3/GIYCrGFNzqdvgF6cucsw7Dtw15LCM0ZRnU5UGZNry7VXj39w34Mq4o5tMcbHCuwwISClXQ9lBUAshz+Xk/U9Oqnvxu47bKDlcv6/LWkQytxDMQmwJh5nno09P8spr79IFQVxCxGNiuLoidGXALJolFQok1VIgxg7STWDP/wknIyjOVYirsCWsh5kgvsZ6oTwxsEgXjdffep+3PviUnz3zLdRVxNSVPFeaYkVEcI5YoidesfSvMguQjJqaUnMl1Lxzfsajxw6w33dYd4lhNUFNGJJ46njN+xdh58olxiuDbBxDxMcWb1PaYmyTo08SORLMF/W+LWQYUXppaE9fNSU8UYtsdO+wV86pT6F7S9DNhJCkIVBjruHLbpX/9csJx4c1Pz+S2BenOTkXAujKtOWnB5SLD+znvc8nDGctjUGFkZJkzoz2A39PpGKhrbX37vwhxW2VHHLI0j57sfvuQoc2NeqHXN3s+OVzr/PZF+dQrUk4nHO03Yzaub4Phahm9mrK6qur60OeePwJ1ldr7BtIVdz4KWTY7Nb2hPc+/IjxaAZaoy6bBiUyDyOFgIhl+XAMU8+Z81f5xX99lu8+8Sj7m4r54Hc+x1jKCr/h+hVXZyim7EEqtmzIB1e3ODkZsLHucZ1lwkMyBinx+HrHHx1vODva5aMU2fEDVBowaGJH1GpuJjQ/gB5mW3peMke65mMMvb4TC7OkhCeKoyOrj3qzrF/VfxTC3t4SdGNhCB3Zu7uxGUkqPtgd8h9PthxsBvxkLfMkUhQ6zdf7qLT88XE4FBqO6Qg/y57qzgynRizk0ogjUBHx9O58/4Jqrn/2cXslh/kwrO83lJ1KbsmDOVISTp25zK9eeJ3NzQl+ZV9xajPEQYyz3FJSMrQ0BEgR7xNPPPEQ/9P/9f/E8YOrpHgrkRdZauGz05f5v/3f/x+88frbqCjqhsQguW+fBMRhRJKlQhRzTNqWF19+nfc/+pwffvtBLIETm1+aPNO1Hig1h7Yu7+zmQ2pS2cF7Rjbg5Gibt8+NeGworEqY6xDVFjjcbvLjOw5zrhty4eSUK6HGNxuYdGVpyLIhffIRWbS5FhivQvooVV9UV1AurgCbUv6dli0eo9OMQOo0c/Dm1dVearjxEILUCMpK3CYBEype2xpy6IsxRx4Y8OBqi6ZISoJJAiIn6h3WjwkHppY1p+bq5QUyXPS68qbAX7Nl24s/jLi9ksN1patJkYZIhjpHRBlNAq+++T7vffg5vl4lG4fnZJIVATLLOaG5ekiZILWxPuCPf/wUTz1xglUFSemWLkHmlUOH1/jh09/m/XfeJVgghYCZzxVNouBz43xYaihIzfkLV3j2+Zd44uF7GbpCaZbFdUkFhtrz64TspQxa5D8yusQsa0AFU1odcnXW8ObJK/zRmnDv/oT2hUACFwN3NSN+fO86nwTH5bMdu23AV0MiLViXFUIB1OPFEROkXzvcz7yGpBlmK9FwKeJSpKGjKc5tSJb9QAyvEM2VFsYeZPJGI2tYeSDRpDFIYmQV58MKf38psdEI/9sHax5wu9QWsSRED2tMWKnB9zpUoZR+LvMdDIgi2VZVyvO1l7T/oOI2Sw6wvDuZ737NQD3iHJcuX+WFF1/j6uaI4cpBQswIJbTv6mcxPEtGNNCUDTRP3HmEZ556jEaNOB2XXfCtO4cUazYGnh99/wn+9hdH+ezkBaADdaXrIpmwRenTWyJLKTeMp1u88NJr/PWf/ZTvPHoPoZ1y/W56mTOdbY965jbl3AqxSSpEK5JzzPw6X2yNeP3LCfcNHHesO3SauQH4RBXH3D3c5q8eOoK5jtdOb7LdNgQ0W3FiuX6whEVfmOgL+fPr30YRw4onxMASjbWspB0GcUJtCY1pzjnM82rHzUkP7sWcYmmZCVFLovbGjqxyMjb8L+c2ObDasXF8yDEZIQ5m5qjbmJV6+4oh5cSQ5xNkpnSB/BZrqL264Q8sbrPkcB1ayRYcBxC6kHj/w095+90PUG3oInM4JVkdaf7TXnPrxswYDiu+9+RjPHz/XaQwQQnc2roBLApOKx669y6+950n+PTzL1GXDYbikkVjD3kFy2KAJjg8X3x+ildff5MnH70nf69ZuRS26Mkvif+ZLFKFmKEpEgHnwTlHMEP9kO20yi8vjdnYcPz5ygbH6ylM2zwH8ZH9tskzA+H4AwMe8xN+eeoyn00qZsljfoCvaoIIXQpzp8mvIv4L6kWzJWedOpowZSWMWbVtVuOUVRxqkZQ0o61+j5vSf0kNEsWorcVQJrpCSywbqYouNXzeGn/7xQWOVTU/PwYbMkNmZU7Uy5urQUPpWZaqb85DiTja8sxUfFPq1b+U6/2HFLdRcri2aF2+mdQpeMfVy1v86lcvcuXSVVy9jy4oXhaqq4t2hORNdEhYihw6fIgf/OApNtYawnSLherzrbhl+w58gthyYGOVHzz1HX7xX59lZxQwSXPkyDKOU0ofP+EQrRiNd3jhhZf48z96hnvvOkLbzZZUP1mWLppzGhaR5pVRtKwOG6Jlz4Rqg7eS0p0PrK44/uz4gH2DTaaxw9WR1W7G2vgix7Xm3uOee1eEX1yG9y47rrRKF0NuJYnHsOK2R7HH7Elt+Si6FDKbO87w3YgDNTx05CAPHtmisp0iTtcjnXIy/10nCSOrz3YmBDIDOM6x/N88rieo9QlH5/w6u6YG/vpX+k0gg77d+NX7q8eGSWknRdcw1v10ZAK8s4BLM6J43t9p+I9fTDmyssLTq5GB7YIIyeVaOxaLcB9t7g2R5kcXUJtREWgLG/+bXKlr+T75+su133LNdyzDv5ev9YKIeP1P3H5xGyUHcjM9WpkdLAaqZo4Q4ZNPv+Cll1/JbQ1JqNN560mWhDJAkJSIoWPQeB596AG+/dijpFmLJDJ7+hZvZfKmq2O1GfLkYw/zxGOP8dwLbyIakDk0sK92LCcNLaBBg66NvP3ue7z48qucOP7X4ByWsuGL9g5zacFF9r1CqZF7NJKfeLOYfQwAxBHdKlfcAd6e7PK3n11gzYSn7lxBh2O8JdbM0JAgTDk+gJ8fG7Jy9AB3b+7j08uJc1e22J7OGCfHOMIs5p53ljvJ7muC4SUykJY1jRxYE+4/VvPQoVUeOFLzeDXKxkP9jETLbhWIqiTnC2djIbqoS8vGIowFhuvaesAKv6RKkaMyQlUZaseqZjitl/aGy5WMppaFuKHI/Gd7ZV5D6UyYxqxDFMUREFQUIc5/VR66F70osSIaaHMSo5RWY2apV6g4HDN6t7+M/rK5HSyApDbbqlZDOioSERe3smifCDuyyutXI0c/aVm9v+bx1ZWs76WGJkimJLLrXkZ+MIeAZ9kXymJ+s1OHvGHL84uKJBnSrRZR4jVkTilVixYCnhJxxWLVqDBzqPVINpvzbW47EYmluG2SgyD45NGgODGSBTKM02NUbG11PP/8W5w5exFzFeImRSgvI5Xm4npQ7skWL4HD+/fx06e/y/H96/i2JZknubwY3apNRyYSMbcYvfuOw/zkB0/x2htv08ZJhnSKzNtEi+qhRegQzXLeV3ZG/P0Lr/LDn/6Y40cOQDulcoK0kVqtILiUpIISMgPZIomKIG5ew2hss7kPiYii0RHTgHeuJOqwQ/RDnrirYb8E0Da3GFw2D9qXZjwz2OGB44mLB+HidsuF3cj5XePCTmCrNSJV0cESvGS/jHXteHBlwvFB5PB6xZ0bDfuHMxoNDLsRfbPbkhGdEJ0w9cq21XRVneUdVIq/RGaTm6X5jhn6ZLgwO4qic5OdWBzkjlcd//tjV9mKDl95zCYQ001Y8OTf55NQRSGo0TlIEhfJmIqZDTg9Ft6+NOU8G+y4NVqr8Hh8muAsZt6AVHQYXW/OZAl62o0vi7IJQRpaXQenNGEXb4Gpawha4SwwiNs467KtkA2xWOFDy0AiJgkTIboKI+Erx05b8eyZMdLs5189di8P1Gc4OLlEPQNVIzWJVHiKLgp1ArVIVCHIAImyxHO50auWDbSSOFrdT9AGl0IWhCSQJJX2VXnUoxWdM09t26ykq0zcASIrVKnGxYBKl3/OWZ7ZpYpel+12qyJum+QAZSFTIVlHtICrHCaeYBWffP4lv3zuNdrgwPt5HZ/iQugtb0USYpGUWoYV3H33UX78w+9QOdCoWFpo19zayES00LWsrg75/ve/zf1/d4J33vsU7x0iC2KY9bIaCClFzAmuGtJZy5sffMpr73zM4Z89gxOXW0SzCVI7nEqurUSu2Z2aZBZyvqYsVEtLlYEFoigXdYNXNkfEjyfMWOG7xw7g/JQ6jVCNqAneIodnVzioV3lAPeGgZ3e/stU5tlplHDzBtPAYckujdjAUOFzBwcpY8VOII4gGneXKpgjgBjdgpitcGkXevxy5sNvRMUDFiqd29upm3s5YajIUz4TM6BWSlJos5R1mJYl7VzuO3mdMnCM5R5NaNPbNlxt6FxEElxwuOoJLBBdJkhVrJWVAwA41b15WLm2PuNQlotREaVCLeGY4AjPWiOoxg5kMmKkR1eOIJM3QXgx8SllWvciiOALOQvap0AZJgrMOZ4GgNaYeMcGFWWkXlRmUZKe6CoiinOtqfnnOIYfW+B9ObHBQrkCIaJXrslaz5KXrHFhRrpW+OnH0Qos3/jwbVeoI0tDpACwnNm8daolQFGDr/qVVCKJE8TgL1GnMRA6QqMFq1LK8Sqj6yiGVihWMcNsNNm6b5JBduzq6KiN3Uq2YcyRz7E4CL7z6Fh9/foZkQ5xbpesiztWYFb38uVpoxElCvMMPle/94Dvcec8RZnQ46VC3GAbfyojFAzi6CnPG8fvu5DtPf4/3Pj2Vfax79c5e/wkWonRmhDhGgcuXd3juhdf4wfe/zcG1hpnNcANPKxG9wdb5tZ1biJWyC0R/kNR6Xrh4mc2ZcX53yA/u2s9dzQ6Hqh3oxhlgFQ3tQGNHJR3DGo54IVWeZD6jXJLNm8JO845wG5hItkltYkJ7LwwBE0/rhmzKOmfGA948ucU/nhpzwWYkrfDaa/vYUmL4NedmfXotBK2C8/WW8g5YYb1JtAqdBRppcS4Sb/LRmqvAasry2ZYytirmKqVykbXaA55ZqAnNOqKK67bmVq5ivSlRbrNMnWPiatb8GFNh4rJUSWWJQZzQxF28OiprceQ20gJmqmR9Xpcv6dz1UPp9CZA9OcwSJhXmG65OWt7+9DSPugl3Hmi4YzgjkmhVaZ2SktCoEFMm1qjl+ZVIXAKH3FgIveVpJMSQLcXLtTCgE8/MeSqXlQzUCzOt6LQiSE7288q6v3ZLAJW5OvBtyt6+bZIDGFESLRGnktEWEcRXnL54kRdefpPZDLRaQWSFlFpE66zZA7k3ar0xDYgaBw7v4wc/fhqpoZ21eO2o1WVM9y0+F9NE0gC+orOW4XrNd7//bX7xD89z/vRlqopSMWSeRlYmV7yvMCIhtDSVMmtHvPnOe3x88hQ/efphJjuB9ZWKLnSYpWxTcTOHJoBTOjNirAnVESZpjfH2Lhc/nHFyJ/HMiXWePFxx2BfngBQxp0utOENihNShZEc1m/fjiy6fQoPPj26RMDcH5h2dNuzqGmfCGm9dSLx2esKHl+DL2TqTus7CsUj2ZyYz5FkS6rv2ZIAiZH49xkAk81xoBa/TLNxoqVh73ziU2YCkMhcLdDHhTNBkuXKQGS6NSZ1gUTAZgK7O+/W9gqunpY5jnLUM04g61ngLGXKM0KS+CsoIpCaNcLEq84Xe4zyQpehdnlipzzMlS5jmxKOlNSWiiHlSSiSp0BqmccZnmyP+9pMp6w+t8rODQ3waE6TDJcNHK7v7KWoB8HQyJHqP0nIzfg4GtN6IYlmORcFiwEjFz91j1kDSzEeKABUdDR2+JEC51tQK5qZb1rttsfz37RO3UXIQ1PuFlYtonk+HyOuvvckHH35EikbdKF3bZlSIZThlL2mX766OZFOEjiefeJT77z+OqBEJiE/EaEDFLRJcnp8LUqqH1JJwNE3FY4/cx6MP38+F0+dIsR8yxjLsU5CKGAIpzvBOgUjXdZw5c5rnnv0VT3/nIZz3jGd59kDvTHcTz4UYaIhUOJIJLQ4G+9lyQybdJptndzi5M+Wjo/Dk0RXuXW844POgui7+2liH4PIiW+YG+Vjyg5vKznU15iyRtKLzNVNxbKaG87OaT0eOd650vHluyhe7nh3ZT7cyRNXhynAyWZrDK3995LaSt5B9qnt514yjLQzw/LNOcz+bYJDK997oZlNydZK0LPK9EF2RDXEa8TbDmaehZciUcRjTaRGvE5eBAQQqm1CnCStpxMASlWX3PUmRJkVa9UxdVX5PVzY/pXVoCU2x7Ji1DPHz7KovroSEpMJIL055lpSgZLModbQB3rrasv9U5LBvePiAUKct6tDRCBCVNdtlmLrsyeGEKD7Pw27iXjOEIJ4kmt0Sy7yhto7KOmoCtQVqMyrL17PCCFrRSbXkXx4BlzcgvUx8/9ZZnvv8E8Fn/yzjtkoOYg6HQ8RIMQDK2TNn+NVz/8jO1Ys4HZK6neJxkHdbecZQepBmZP/nloOH1vmTP3qa/asDJAW8ZjXUlCJ6s9aN3+hsFEmaEUYuo6mOHdzHT37wHd588UW2dzdRNyhGNblvbVYVO8qASiLFKUrLdGfMS8//ivd+/hO+++RDTEdTxFVg8dq21A2FUYdIbUZyms1emNH5DvPKBavZ3plyctTyxiXPvQfWuHdN+fbKiHuGHauNo1LBpSynoZKyMbWUxbcY9mAQzdPi2Y4V56dDvhgpH4+Ej7eNz3cC52bK1bBC8CuYHxDNSr89y1CLZP+FlBKI5LbUVy90nj2pp9MKc4mkjlY9VYo4i7kq01y9OM0S4/3w9be/j3nhiSKZREzG3zhAXGkRqWMiFdEZyoRhvMRKVzH2a2UB9yTiHE0nQNCKiV9nq0qspm0Eo9OKHb/KlXrIVENuGYkjUiGSUW1qsdznC6FDEcNIYFKmb2ku0SIoojWmkY6EqUNqZbeLvH/uCi/plGGzxon1NVRGaOxQ77CUxfgGccJMdjHCNWKLN/oM+K7BcEU/LNJYRxMD3rKEfnKJzueNhTij9ULrGjptiOIX59h7sUjvoVLwaZJuz8zAbZUcwEJGLDmFLmXNIWeBbz/+EEcPHkWaNWZdQuuKYAF1WeZ5ITCUH10lceTwfp759mMMMGwWqBCIgsrv55KKCRU1jryTjl1gzXt+/qPvMrryv2Frewf11dKNLQSrEG2KAUKLWMyNmThlfW2AhA4NMPQDvBkhyKKtdqPHBVTJILbEmKCGICFbUCq0JoR6H6MuceYKvLlZc7BOfHttxP2rgYNrFQdWBqzXsKKJRhNeHb7KkiBtMGYxkRKMW+PyKHB6d8qZqXFqWvPlxHGxa5jqGuaavBtP4NuEl1TAy/2xLg+f+UrPW0SYyhofxjX+17ORL9wuVRJabRjpkDq11MU+tcMRxdNIQMUI8/vlBu/N8ud8gV9ol9DhGeuQL3YdJ52xXQ2YqcsiLqV9lQUHPYmK5CpOp4r/eq7hzFZgNWaA65QBrSmnRokraZXgs0/JzIalnaT0CsNSZmzOwtzzeaGMuwyPdXn4L0okFKsGx0gdX8yM/3pxxFlfcdehDWpbo2pHNJI4F1b4xCITv58k9U214RbXzEgScwdAPYZjyiqbHOaUG/IPl9b5fBqoQ4WmLAS5K+u8c3VKpxVJqzmrI/u5L6DE+XZYEEhvx7h9koMJzpQqKRqNFHLpfs+xo/yf/4//O4yapJ6IkTT3MEUirm8rlQEcUPq7ghNFutwTd6ZgFaaUQdctjqS4vG/DkqCScNLx0Ikj/E//l/9D8ZwoA7XSGYrmManzjV/KZV/gjpoML8AsUJc+c34JvalHIw8zI1psIC0mvOY+cLKsJpuoSb6m1ZqRVVwKgS+vBlauCgM19g8cBwbKqodaIrU6mrohmTKeJWYhD6RHccKVUcvmJDFTpatWmNkqnW9AB7iUVUI1RXzKPenOpyIOt3iPvo6XMtJ13pqtce7j8xyPgtMBE11lV9ZxaUptU8Sg1ZpOco9fJXBTC4qBt4hPiSSeUBb63pPCnGTXPBwTv87M10Sr8CnhUptvBzxBaoIOieL4rB1y6dMJG1Q0uo6hhKRU3Q4pRS5Xhwl+hUzojKiFzP2wWPgNZcAtGVWWXQHtKwdukooSMKTiL54Qog6ITc3baYv3zlZwYRVUqdKUijEtDSNbYVJtQGpxacySldSNPgSEqiOJ0YknasPMNpj4FUbWceaL3F5SW80zFKnQ2NG0V2i9x7Qq3uOpcHz65KB5vhILnHVuTnR7xW2THMQEZ5IXeyHvJMRQBakzENqkLGKuA+mK0o/2wjy59WCuDLgkK68W8s58h229BPYtDtPyu4vsRUG3YNBkCmsezLE4niSRZNlYJzOHNRN/TDI8M1lui6Wikmm22MHeRLTlrhIcmjTDNLM8VZFOyK2q5DLE0gS2OchWWofQUk0j9TSjapylTCxEc3IzT8KRvCNUkY4AteHEo84jplQJzFrmfXN1zLQpM6MZX3nQf8MpZtE5pTPHbvRcDRXReUa2xo7sw1uNT3Vu41hDJ4My1F2QD2/wzcSnQB0jSSo6GRClIajLfAdaxLLEhJOOmi6/L6kQEem9MApbWIQpDcE8Y2vmCKRkQkWD18jMrRRFWwjS5M1N2UG7Ita4kF4h32vWs9N7f+9e5XbOK8bKwFottwQ7hIk5QueJNDgRHF1+PQHPDGWMY0zMBJibegZ8V2fxRVGiWvaIL85yu2lG5q0LUfLgurbImtQFrbRk8Su9InAhIVKqpTx1ubnj+hcSt01yYP5G9/jl4vRsgoWcCPL6H5HYgbble9x8IaYwVSW5wsTsORDLUuC59/n7iMzyzbsb7R3UUgKLWIyLyqFXxsSVYW9/LnknbyaFxKboXHmVb1RNG9nEPrmcQB2aZwb9eoKhGkEDwixbfYrSyRpJ10AiwRIpJWZmeMks4NClzGJ1FSI++zXgERVqbZE0RWOLI7fLkkFwjiQVQZSgOeHVob2pxzyzsROVGKYZIx+kIrk6D8r7+0kqROtyr+R766aum3REDZg1mDQgDSKKFlOkfGdFXOxyxWCZPNbKYE52VCI+TUsVm6U2nGTntQyuMJKrmUoNKC7FshBmRrXSFVmU3plvUTVLkaTo218p43rpdbfmqJ/yQ70nNppwqcOlKWYBlQmiIwwPsfhraJyzuW926mCFIKkCkiJYRjw5ZqhkMhxkBHISQdUTXEMnOWHkKHOouYf54ubvLX+vVUi4PeK2SQ4muT9pGnO7Q3Ppn8SVXb/Od8m5rHYgrvAcSl/mGi9jueZGMoksidb/Hs4HUr+I97+zIEjmySpZr4YMFBLgMo67fyH608sLXSIgWsRF5BuqyxaZjYQrvgulWuvhwGKoBSR1meBGjettSHstJ9E5SgkVVEBdytIMCSrzuFhMZFLKO2vNi1sSw9SIqkQNpIIuMuWG1+2MeLWCDBM6UWZUtFQE8agEKlHEQtl4lIpBuOlZTVJHK+REWg5SrSQeBdQhVgE+69ml7GVhLgvIO0uIBSpm+QSTlHtBUOuo0gxJkanfR3BDfGox2ozYMQrZr696rEidu+wmaH3V198yGQ5bVv+5CrD2FbYJnTYEVZyb4gGfDG8BkZbkAsmyRH60AUkcpoImWexjbvAZaH2RhilVTYbdxnJPVUjyc2RVHqdnAmeYVxksbRiX20eLedTtlRIWcdskByim9tohGkla2isiGfVjHsGVwVRGNmGQUjPfoecy0/rOZIFWzuXgoN/h/R7QDRkF1N/QJV2V3X8G/JdjSEtVwvzeX+yYmJ9LIko+h6yx0EsP3Jw7lwA+V/K5H42RCvwzFqJRblcoajUkX5iuEZUZokqw/L19qyRZQjTRW08ghoqR4qScX54jJLHsDkeV0UhJqJLhpEMkFh7jzSS7vo1i8x0kZLimqOakRFcYyqn4XcdcjeLm/IMb+C0kjQRnaIz4OMMVFrZZxDRgMW9kktWY1SQ8RovaZF4Va5kfZe0kV+CaFUIiaou3QJIKZx2VTRAs+22XwWxWa+qrhqw/lUSpUsKlLH+RJD8HPawYYmGMK9r3580wQubhSMI0y3qIekyN5CKWKgyPxH7wXqr0mwy1NG95GX2RnKu8ZEpyebOUr07xZjHDJMxJrTkBLMFX+w1JeUZk3hm4veK2Sg5IXqhEsvBY2Usj0u/WpFySRQmdkdFaisrCGyDlXXb/oLBMlZFSgfymHccCK/Nbj/f6kMVX+qqlL3ZzNa9z5qrMZTOWqh279kiBzMgtP52viyHav3JfOdxcNeRTHngnlx3ZkhTES9ZLyHOO6ACfZzrJkDjDSQfmFrvUntGdm1UlqWSxNi8QdZoN78gyKIYjFD0oRxZHdGZzgpcJtOq48U29oJZ3vJBZxyYODyTLkhM9I1ct4Gw2H6qaVTd81TL3bfkOysNR7RfZaCRVoAJzGd1DhUpZzG2xAUhSfPWkIuiguLgJgZh5DalDCyO6F55MtkRkKFzwzAl38+uwuPeWatWygopQHPgW3+HTDEsdMRmWlIgnUmegRFnQ1XR+3bAMLb+ZRVjI7PrrDG5Loa/l3iv8dnGYuTw9SAVLlsqzahQIaznVJKXNVa6DSKmqb68EcRslhx6w7rKgXur7oloW11gWSuaYbgC0bINhsbguRIbmS68t/Y4sO5zRPlbE0xYixeVGLqzc+Q1dblIpvdw5hE7mX1qcRu6zlDlB/5KydBw97T+VrXYfaSk39YliOVmU4bTlAZz1cMWbxZAU0b9k/RRGkLh0SftzLdfaVBDxmVgusjD3mbOW8/GkmErCs/mXSyNwntz7a5BtOKQsEKV1KJbfm5vIdY6IxAlGhrWaOCQFKhshFoj03te6VMfZfKh5ExcN1+W3JZnQ9ecmVU7S8/chIDLOGxoCFAXeHmWzgOQamloqCeW69DydREJppRgsSL+JyIin/laUkhjLodH1siTllllu//S1q9GTFcvmwhQJg1zJlmQkFiG4cq8lTNpy/suw65sJmd/F1zyHVqYE5ZzdfGNX5l6WIEjpFuQ5Wf81F/MrCjLnQtxuiQFuq+TAnCks5tDUyyHkp1Cu761fU1Ze/7mlf/a7p/6/i0+Vv6UQab5yMPMF8toXXU5Ads2Xlo9QbbGYf+UlpL+5r/t9c+SSXPtpemTGso6/lB3ezUsW57V/8TvkmiR23TGVL5gsCSdcs7AuesA9BWuOyrGl11n6isxfM3/GvvKaNx5CxvqDksqCmj/X5q9Kbz2al6Z/ysRpvuBKj5T6dcfTD4z7s9VrvtpfrpxOY9mRX3ctRYqxzrXX7vqENt+6LL+f1/513cFdD3aVMifp771Y7qv+mI1eeC8nkJuP5WO+/trLUtq6/qsLQGGPTFq8ii597aaT/L+guL2SwzxuQtrgG7y2LPXyex154Nrkkvrv7b9gi6Xl1z2Acu0Cm3eCNzsN+CY3+h8iAei/1TEt/175mq/d6rjZ9/23ncutjK+7Znvxhxy3aXK4dZG7QssPxNIe+ppSfFG6fuXLffu2tAd65Q5dfqHblNK/F3uxF7+f2EsOv+u4Zuj71YV/ORksGiaLVs+y21z+f2/xyXIf5Q9yP78Xe7EX/3JiLzncgtBCDkqFidSjQbJsRT+MXcA6l0fCC0XIMlwVg5R6LMr8Z/6p/e292Iu92Iuvi73k8DuPMnOQ7KGgWtO1iappUO/m40Odg57KIFhsvuwvc+4sGd1sBimgCN4LDqMLdjvb2+7FXuzFLY695PA7DpknB82m7GRD+902sXnxKuPJtJjCL8MBe3jrAopnBW0zqGqOHt6HczUpTIvJCtmo/ZvOmPdiL/ZiL35L7CWH33H02PsMN3cEE8xXfPLxKf4///4/8uXps/iqziSgpVQAC9ZB32xSIsfvOMr/+G//ex578AQhRSyFBQ9gL/ZiL/biFsVecvgdh+WiAUPouogMBuyOAy+98Q7/7j/8ZzY3R6irYM5mvo6xPMdVZ62cY0cPceKee3n04ROIVqQQM+VK9Cal3fZiL/ZiL2489pLD7zyseOpmpctkyrmLV/jl86+wtTPFDzagSHJcy0fLPAcprOBsutKxuT3l+Zff4F/92c+4Y99qZh07RYtd5l7sxV7sxa2IvZHm7ziyr66RkuGqinEbePu9D3jjzfcQN8C0IemApA3RDYkyIElDksH880kHWbZZB7QdvPfeRzz/0hvgBOcrUsoJaC/2oo+9fcJe/K5jr3K4BaFz43flytVtfvnL59na3KFq9hEti7f18t5zgr9JoU0XgcAs0oD6AVevjnj2uZf52TPf467DQ8J0kqsL6dVXFwPta8N+y/9vRfSYq1TOTstn9DpWuhXI7w1KIlu6jjUiWUxtLn/Qi88tpBGWYb+9tlUPFf41oiPzo1/+e3GcX/3eX39djYXW0/JP2Fd+p11zIFlZdjF/Koq0sriGUCSp59pZ+fPeuqxThBA1K7EaglpELXs0zEX5emkVu/ZYrjmu645Wlq7fV7/ffsO/Zf6+W/FllnKeWb32+s2NzN+bWx7SX+FIr0xsRaxvWZKk96e4XTEfe8nhVoQJokIMxkcffMobr72NSkNKWTk0r+JZhEzLQ57MARE0Itq7UjnMBownE95+5wteffND7vjLp6BK0NlcwK7XDbpGP3XJyKQcFL+f29xQa1EiEZ8XcPFzFdw565uYZbWtGC/1GN7rYqHWk/0N+jNNCEmqbE2JZAXRIiInlhVNKY5mWUo6K+km1yvnck2iWlavzceqJe/Gcoy/KQH3MuBLeqWWJa/zW1AWQ7uW7DhfDCVvEowuGyAVifS8HHus94YuCDeXAmJdvn5kZdsqjWjSmCgVI9lHp0MSjooJdZrgrCOJY0aVVWw1Zr+H/tTnlHwtPiHl/Itmi5bk81Udov78e2BFWWj78xNHEiWJ7z0VESLOuvl7v7gWbv57b/X9mW+1iEoE6YCIKUQqTLKst5igscgp7tmE7sXvJMouKURhc7zL8y+8zJXLW3i/RpcUnFuSNl74QywURnuRMi2LjMOouXDhKi++/Do/+dGj7FtxiAsQF3Ld8wVPCnFu/lpLXGuR30/xQJbY1vLvvNuNi51kWXQSDhFXWOCxLDILZ7F51VEE9OarWVG5FTqUDkNxUPypHf23z0UFKcz0IkmeFUPLMlR2hmKlRlDDmZEklUXESHM/j+sFT/r3sZ8fFZ0TsWI527ubGVYSRD6kvEway1LQJXH2leBcPLFcNVtUQFnSOxLKblfESnUQF8qzRZk017BxUbn198dcLZjiJ97re5W/y3H1fJuEW0oKv6buspTfBekX/TQXhzSyUVOWXI+LD3qV3XwdnbUsawv/7kOK37XPd5eQfTokq96KGKm/JwxcMlxx+4u6ZxO6F//ESAgmFeY9H3/+BS+89BrRwFc1Xbe8A5F5IllexJAsI5wdtvLQuaoqZrNd3n7nXT78+AueeepBYhgjkq7hRixi2Rug/9fNSVV/81CiDghUaDG/UWvzQiFZjjqJJ5nP7Q/xRARPS29PmRei4tol+d8mWrT58zVUaxmkzayYatm25prduOl8oTFcMUcyNF3rT7FQcC1JbO4GWJRwJcs2L79P18Z1u2khmxy5yQKbLL2Cbr4+1reELC/GUpK2WlUqyUTvEqIlaVrxeNaSGPqKMVus+mxRKq4kwpB3vpYTVNLiECFZJltSWjqefLJ5J59Tn7tGUj237+LXSJ33QIq5RIwIWlj9CcvObPM2akkaSz4hvR6wWjeXCb914bGUq02V4t1SFA2k3Gv53ik+2Kn4Sd2G09m95PA7jj45TAK89OpbfHHqDCYDQkyI+KXuSd7FLKqFsuujd9/VsoPOEhymji++PMOzL77Kk08+ghef/a77jeavWbzyurcs8Xrrs4OhtG5IFIdLHVWaUtkUYYZPZbGykM1oMJKVnTdhqQ+dpcJNQvZhMCnJYdHHVgtoWhi99EbyOVuWZNJLaYvLXgtm1LFDMEKxtg5L4wGxvFN0EapoOMvJoXW21CHPq+ay5PO17XsrS2KYJ/v+upgsFqJ5vdfLu5srrZXiqdGbG6VYasvsMij9jr4khrxwV7QS57ag0rfT6IBc+RSfOKooVCb5/AWig6S930M+Lx8TPhq+/L91CdGl+0uunVlcvzlZviLzGUlJTH0dl4uKJTMqURLVUtV7K0LAHOby5isWY6nle3exUUu5elSd+7zcbrGXHH7HIeIIWvHRydP86uU36BLgKkJIiL92gLz4IZs/OPk27Ae4iqoSU8Q7x/buiF+9+Bp/+Vd/zuP3H8PanUKsmOebRaJY2upc+/De2gRh5J121Jq8w0+opLl9Zd9K6Ntg0jvpiVsswGY5WdjC9Ki36VycS64wotT5+xadboSUIb8ipS/fJ90yYCwXKwlElWJHanOLy7yE27ztlIf//dktVx4yT+Z9RZOvvyJhyS+kLOaW9Jp3orf2pNQ9sVSMOfmUDUOpFhaHotn1bm7Sk4jiQGsAoghKKL7WXbFq1dLPn99uuQMmUmY3pXVnhmazbzTNb61yTZYJm9cPp+Xa90WUxdLSz1yuvWbWD+3nyRH4fQykJYFMy7XT7A4392QpHuCkeXJY9Gr32kp78Q1CREgp5b81S2U8/8qbvPvBp6gbEnGoq65BgJil3Bay7IdMaRFp4UYgbvHwCCQzVD2ffnGGXz7/Og/c8zcMnJJiRK/p3vY3M1zTvze9ppS/ZdeCRB0npDgrCKOEiSMwIBaznL71Y8XsPbdWsv0nZT6hVr4iuT+tFpeWDiPi6XQfSSvUAlgsSSLNv09K+6JvW5gaM+276vmaSFC0DLX7NlBQI4kxy2/UHOHTGz9J2QkvijVdLDaUdkSIqEg5TxYG9wZYxPXnWHrvQYVW45wEmdsbS62lct36aiHPVgyXZvl6SG84JKUK60pSKcdQHNqCM8yRr5Jl/3Qtx95XmcmM1hldHuTMr7lJmnvGlRu/XIM+OeYFNInmRCeCt4CmDrOY0XXlHMwWKV7KOaZbvQALeQDtxmWrUGPJY6ZoAmcBlYhJJKkRxUolVyFxwO02lN5LDt8wes9fEcE5R+g6fF0TknDq3FVeePkttrbH1M1+wCHqSHPWWsIs5IXTDDQBHTr3QTZEFTEhWZj7OJh4dnZmPPvCG/zpH/+QR0+skmLIc8xkOCdYtOzJ3M8z8lEuhrK3OJREnbbxKRBMCFJhBV6ZxOXed9GHWgaQWmmzLRxacw849+M94RrrUIjiCH3ipcoPdcoPd36RuPTKuSUTBdrKQBTXKRqVKnl89Hn3KDkxdGpMXcJcXvJ9kNzeKUb2InmY2R9z3oErvSOcFERQHn72VaDMk5RKgtRlfSyDeZqUQCqonT7V52on4iQRUygOt7kd4+mgG2OuxtyAZJqPrSSeXInKvKVkGJ03WidIFDQIPjp89GixWU0qdJroNBId4IwqCC4YyWLZ1Gh+X4QCwS4zDcvVroknaZXtRmNb3rbyM+ozeilFHCkPoWNAMYJkdNutjbioVkp1DoqjVzrOm4CkjhZIrkLNUfVFxG0Ue8nhG4aZoeowS4QQcN7j1BHaxNsffMbb73yIugHqChwxJVQ8MQZUjcoplgIikZRaoEO0gaRIyhaO2bqz7FidYp1gVHz04Re88vp7PHrvTyFGYiq7alsaMs6RMswLB/h93OBGZYGKGYpHUIJUJLN8vpBN5VOLt0CjCSc9BDKjfaxAW5NZGU57Ao7kakzrAo11eZYQ8vDWeZ+77DHj+lUVTblZQ1kixYRoiqjiXB46KHmn70pLyYgkujwXIVERWe06XCK3x8oyixklD+edsuTfnxdLB1r4LFrN5wPRAHU4g1gmLZW4Mpg2HKHMofpFMluCqgXq1BK7CaijcgOCKRUzrN2hqw8QXFN4Hz2aq2/X+TkfREl5zoPgnetfHkmGI6EixBQxAskCRq7GmrZjEGNBRS3YCGZGTKW2KdWCieaqrlonSYWnw0lOVLFc/6SegKASURNcmlGV5B6Kp/utiwAxlJlUud7JcCnibYaXQLSEpQrTGtEhKcl8s3E7xV5y+MYheRdnQgyJpqlJKbG9O+VXL7/BpcubNPWQkAx1gqVicG653SCly4wkhqtD6sEKVy5cRcWh0tDFgKrinGEWoLQynB9y+fIOz7/4Gv/6T7/DwX1rdNMpapBiRExyw8GW5fx+f2EoM1llRpPRMaooiSbuomHKisw4ODAOVB0brmXNJ1aqvLNEBVFHBNoojIMwio7d6Nhsle1uxjjWdOYJRfXWl8VJU01MQrS8O+0HxwqFF5DwJgxbnysTNZBI50NmDFhGVfkwYximDNRYE8eBOnKomTLw0FSOyuVF1lKGBncxMQnGLArTzhhPI1eCcCUN6XRAZzWBzHhX1xDF0aaISMJXec4iKeFToIqhgBYchgcCapGhtNy5Cqvqsi+0Tgmm1BpoW+WLScsV6zBpFsnfpLShKqy0oDRFmgSpU9BcAUUfSQSCRTwRF6cMwpR9FljxykajHFqZsuE76kppvOLKfMJKAp+GxDTCLAqTWWR7BufbfYxliC/3eMIz0xXMPF20UlUBFmhoOb7mWPNTKJXGrWnh9IgsSFIRJGXGTErUqaVKEzyBJMKsqtmRil3xXNieEWAOLrhdYi85/BMiJcs71EoJIRu5v//BR7zy8mtUg1XA0U07mqHgVYmxw3vJPeZ2QtM41CtPP/N9moHxi//ff56zhhVBxRBJpFSQOAJ5iFbx3nuf8spr7/EXf/ojVGpiNNxivrdAi/+e72dDmUpDUoe3GVXYZiXucHwYOHEgcXzQcd8+4fgq7PeJVYWB74EreTWPKJ0J4+jYSY7NznN55rgwTpzfnXBpp+XqOLA5g6lVmB/QxiFTqxE3AHUEs3nrL496I86gDo4uJkINNJC0IzIhhV3WbcqJNeXeWriv8dyz5jm64tgYKk0Vqb1RK2UEnRE2s6hM2sg0GtMA22Pj9BQ+mrWcH7VcHAU2Y8UorjB1K4gfErVCnUfE0YWYKxlTcpWjRHEkcXgLOOs40gR+eN9BHjlc06QRhJZkgviKs6PIf3p/h83xFKq1jCqKC0BDEg84lICzxCA5CDCVgAyUVEUiU0Iao92Iw03inlq4r1HuHTbctaocXFWGjVA7ofbgpeeF5N8zaYVJSEyTMZrC5bHx0bTlzLhjZ3uXnWnHbqrZ0Q12KiM6h6nDpYimKetV4nt37eMnB3bYCGPiraweTNCUIdKdRoJkJnmdplRxmnkNzjMbKFeS55OtGf9l6xKfsZ8k9fXYtH/RsZccvmGo5gUihggiqArj8Zi///t/4OK5C/h6nRAi9WAwZ4N6ESxFooU8hCZy8NBh/vpv/oLQXuXFX77A7mYEApVrMBIxtCAxayqp0rUJpObyhU2efe4Vvv/d73J4/4CuC3n3nUobaqmnn70h5PfSM81wS0HijCZtc6Le5ZH1Kd87LDxxGE4MjINVywoBHyNi5GuRllA9PYLHK60oLRWtNoyp2JwZl7Y7zu5G3t0UPr4y5dLoKtuyAtV+WoWOYW45ab69LcWlwSdgRmYudKSwQ8Uuh5qOR/Y7vn+44cmNivu14zATaukQN0OlMLSXGOmGEUUwD+aF5JRZULai40JQzo2Ez68aH28FPt3c5MvpLrtxndatYraCuYoYQcXn4TV9G80ViRWjSjP2yZjHNvbxo6OBwWSHqpuiXphUq7zrK55jjA8Vvinw1oKYAo9JVeC9ZWBvSjLBSW7npTjGpy3W/Yx7DxhPHqp56uCARwfGnQTWGaOuRTSgc3+pnriXW0WpEWwlX4OAY9Q5vh+FizPh0hXHySuBT7amfLyb6FqhrRz4FZwFmtTR6JS7VwN/cnDEoXazQJB/1zFniCKFXBpd5m9oYW07ixAy0q9tZlyVCUei8Va8yBeyRtKG33cl/t8y9pLDN40eomiL/uvHH3/CKy+/giXyYq0O5xwpQQp5mGgxIBJQzYnikUcf4anvPMJ4dJmHH32Yl3/1Fl5zMkk909TnwbSZA1zerU063njtLT58/1MO/+hbeOcz9nDOn7B5sdFjlOw6fPqNnueN/MiC5xtZDxdZ6ba5fyPyR/cNefpQzQPNmMNuyiC10KWCglGCKp0IvhCOmPe0rfTkYdWmGCOSCicqTzykjA43PNSu8/Yl+PD8Lh9vJr6cjrgaPFBhzhciHYgEEglTY+oVS9DQ0kx32Z9GPHKg4um7DvDkEXhgdcph3WWlnaCpy1vkSFlgbelMc1/flywcYx7s1CbcIR13eaXd17C5UfPFpOHNy8Jbl43PdoUz4yk7U0jVEApSKHPM8rA2zwgyK9tbxzCO2B8uc2gaGOxuUkVDHUyqXQ6kdQZhgreV/k3Og3zL9VKPaqKwyie10TUebxEXx6y225xoIt89vI+n7xrw0PqUu5oJ++KEqpsBIQ+sulKL9jCjkhycCa4M5wOCl8iaOPbVHQ/WnnYNLhwb8v5WxUuXa97YGvLRKDAKUyx21BLQboJ2Y3xqIfaIqH/Sw8nXMPbKPdEVMMECazb/USIpRsx71HlS6sDdPkmhj73k8HVhPZ9VsKV+Y0+vCt2Muqox33Bpa8zfPv8Wp87toG4fSQSnQmineF+TxEjicNWAFKdgU4aV8sfff4I7V2tm9QY/+f4TvP7iG8QUwHzp2WfWbJzNQMC5hmSKUfPF6U2ee+ktvv2tb7F/qEhocUUCIInm4y7IIP8NB2rOUkG+9Iingr83m+/OowmVCtZNqdOII+05njnq+cnD+3jySORO3WZ1Msa3hW5qmpGTtRGdMFOPsw6ROEcjkXrYZ34jJGVZC2czKoNaZjzhEnfdvcbDhw/yypWGv/tkl83tQhab8yrifHGMqnQ+KxbpbMaBOOJnRyr+6p6KJw4l1nVMHXbwaYq0mhNDnUD7af4Sw73g8vtjtAgWDSdGlRLSCUMLDN2UQ6tDjq+s88jRDV6+qPz9x1t8ujsluEFOYJKHwlY4fFIkLzJqJvfcvLWshDGVhfx7g1Bbx8Bm4GtarUv7MeGWdLXUQtG3yj3+oJFQOeqYqEYjHltJ/PVdA3563HFsZczAdqlnI7QL+T2opMxn5Nqee683VNjUlsBSlqCopcPHBAmGybFeew4dhTsPrXP3+AC/+KzjzbMjgpSkmBTTor81Tzy//eE0KFWQQdKC/KNoWuYEkZLOKQouZvg4gKkjSb9xkjKbynDn5GFmjuBcoZ3cSkmPP9zYSw5fExlHnqF7AZeZpIWY5SWQ4hT1jpk5Pjq3zd+++jmXJw3NSp0x+ikgFrHYIeJJUpNUiTHQOOHBE0f44yfv45DOaF3gR088yL8/doDPzoxRt4JIhRlYCGiqMkyQDH1NrmG7Tbzw2gf86z87zdOP3YlYi0okqRLEkdAsYWGGT6FIQdzcvsxZxKcIllsWKrFIVsSMHHJDuqTUzpDpmENs8sNDyn/3wJBvHetYjZvU3ST3p8Xl2UKU+U58hmOEhxjxZcibKx9FnEMVROIcJeNIWDA0GPtmu2zoLm54hMsH99GcnM177S5llI8SEEJeAKLQpESVphxMuzx1zPM3D1X8ZOUKTQpYSiQvWCi7ba8EdXTJFaRNXox68lgPEvVqVNK3qizv/jEqSxADdbfNXW5Csx65GtZ5wY0xXSF6R5egchBToNdD1dRR2RQDpjpkrCu0kisJnGCuX8gEmyVG1Rq7fh8qOXmqhdK3z5DWLAcvWJTMfE4tq3GH+4Ydf/7gCv/62C7HuYS1KbfHDDTlhdGcoxUlxNyuigVp1Ws6iSQ8UKnhpVdbFVrzOI24aOis46B2rNQdbn/Fx03k4zhiUu2njUrnh4RmlbYaYSkj027g4SwDdw9xhusiEgEM84Z0DnNGp45QeUw9g25KpSELQpYEVDQL5oTIiBKrhtYq1A1wcUwti63R7RR7yeFrQpY+lsPESCniXH6QdkczXn7tXT754hxar5TdbxFb65EdkgfYlrLMwXDQ8JMf/YD77zqGCy21Re6/+y5+8Mz3OfkfnsWsICksY8m1YOgzQiRleB0VX54+xwuvvMZ3Hz6W30wpjFeYC+31/fZvdP6FfSz9MLxfwBQChlmiUk+abbNfJjy0IfzlY/v43sYuG9MdpAsZIulh0lQEGTKeBEZTY3MC56JytquZtKtYyguaIzLwxnqlbNSJA3XkcB05WEXWXcBpAJcJEd1MiAIXLm9yeXMXk4N5xoOVIWwsJDYFcziE9bDLdzZG/JvH7+DRjW2ayRQCUElBPDmqxrjkhpwceS5PPePOGE87Jm0ilGsrKVF7Yd/AszFU1hvHSlOx5oR9bsKa7FKnDumMNsK4bTl35SpbkynR7SOIklRJ0kNZ5+ISJaG5zAlYkiafd/01t8nMIBRWfq35mLK/uC6qPJZFAz2VddwZL/IXD+3np/c0HE4XYdohkuX7uuQQL0wHjpOzhrMjx27nGU8Do1mgTb1qV954rA0c+4bKxiCf/0rlWHOJfYxYczv4mEgdzELk6s4m5y/NiKzQ4YCKzgnnxsJbuwMOhLW5ZONvi3xtatZm29xTTdjXADHNRRWTU7at5uSoZiJDBpbPvZO6MPSvFQlPorRSYWGVqXlmppweJbb9kJwCb6/qYS85fE0siyX0+HYRgwRdNJxW4GouXL7KC8+/yGh7m6bZyJh++nK0/8g4f3WCpI4jhw/x0z/6ESurK8wmmyCJ/Qf28Sd/+jP+y3NvcfnSBOeZJ5e+gu9DRFCn7Gxv89yvnue/+/NneOD4AVKYFKtSmctE/9N2Pf3wdSEUWPbv2dPaWmqfqMNV7mimPH33Ko8fbtmYbuNigi4TwOJgyFnbx+ezho8vbvHZxV0uTZTN0HA5rnFRDjCWGhdn1GnCmrYcrDoOyJgjfsZ9a8I9a8aJFced+xr2rwqD1DHWIWfDBh+e32ZzEnFrdR4SW5w3A7LkRKHCWeTuYctf3Q1PHZyxOh3nXbDL71lXDdiqBny50/LyJc87mxWXSnKYzGAaikqrKpISlQorjbLiYG3g2L8+5MRK4vE14759DQerlkpbpm6Nk+OGd89f4nJXEYarRKrCeO5ZD7/GM8F+wzs3b7n1Sfw3vXfXfiEmY58P/OSY8ecnEsfdDnQhVyQYJhXjwRqnZvDO2cTLl2u+3HFsB5fPf5ZrMSskTbHISuMYelithY2VmsNrNQ+utjyyvsY9qxWrOkEq5RzrvHU68NGVjulgg05XwBzjNOGNLza5eGFMnW58CU4Y0RJ3WOJv7lvhqbsUPxshKWEOOvGcGlf8h/cmfBkNp4qYyxVXnxzK8yXk+UObAslP6Khp8Uy6Aac4RJKKveSwF/Pod98ZEnq9LEXWqG+D8fZ7H/Duu+/lGyylLDJG/j7oJaczM9Y7RRW+9cRjPPrwQ4QYkXKzVs7xrUcf5PFHH+LZi6/gimkLZRY6P4651g90bctHH33Kr158lbv/h7/KAm5FJ1/MrjmXb3b+FMlmmSeIhCt4cUMs4MKUgzrmwdXA9+9wHHDbufUUfW7qNo7Lts4LFyv+/sKEj64mzm5XtGkV84fo9ACd99nYRmpEGq7GjgsWaOKQOjasb7Xs8x1HVhx3H13jwQMV39k3Y31jgw+uKp9e6TIKSFwRI+w1gKywdhWxxIqN+Nb+yI/vhPXJJaqY5SdIGW103tZ46ZLnHz+PvHFFucoKbfKZvFXed9ShollOwhI6DVg7QVNgWM84Ure8N5jy6JGGe/Y33HXoAM3KEd4+fYmPt2DsNghuhc6yxIRZLwp+a0NI1NZyRzXlZ/c0PDjYxSYtvvd3EGHkBrwzWuOXJ6e8cKbjZNswsYZgrqgOOUQzDBcxLCV8F7HxDOKMWjs2msg71YhH98Mjhzwn9u3j2NFDnBwLb106y5asM3PrTK3GO2GaIp9eHfPpVYfo+g2fT8KDOe7VCd+6a4VHq5rhbEKVEqpZyXYr1Lx1cYf3unVitUZMoL1apcUMF+8rdFG6AOYqzDV0OMTX4BRL36z6/ucce8nht4TNh9ELAg0iiK9J4jlz5jL/+NxLbG3u4KsNYgg4vxB7Q3SphA2kEDl8eJ0fP/Nd9q9XdJMxdRHks5TYtzbkj378fd548x3GowlQZSb20jBUyO0pdbknvDOa8A/PvsBPfvQ0J44dBGmv1cQpCeoGPdd+zTVY3qj2MhGGK2qevhtxtGr5zpGKBwZjfJxgTpEWaJSdasCLpyP/8bNNXpnUbLsN0uoAlTVSWqcNHm8TGongHWaeGJWZDOjcGiIH2bKW06FFdzqaqXDsXMcfH47cczjxxoWW02MlNatZ6LAI/V1b8yk1U+6ptnjiQOJQ3aLTjtonJOah63Z0PHtB+HefdLy/u8GuP0AnFV5jhgkXBrCZEM0wTTgtMoJak2LLbop0rePKRPjo6i53rMIjxz1H7jReP9dxvhsQqn0ESpIhIqn7vaQGtchBtvjWWuS+DWMQpgTJCykiBBU+3Pb8+88iz55VLtgxZtV6nrHR+0S4OVzWLOWKSwzVAcQZ09TRhcg4GGd3dnj33IR7Dgx5uBUutvDhptANDtHS0KGoOJJviLZG0CHmqhveyVhBZU3paJ0Sk+BSwidDNR9zXXtSNaTzxxj7/XRJcWpl45S5H9f0B+osKS++pjPoItSaqGzMXuWwF9dEKtt2KQnCLBURM09njvc+OcVLr74FZAcp1aLpab1aZ69jb1n3J8144J5H+N6Tj+AcBEeR887MosY7vv+dR3jgvuO8/trb1M3GXP+lf00pxyGiiPNMO+OdDz/jlTff546/+pMyYwjzBceKYc2vE4S9kbCiFzQXWRMp41jBW6RKLYd8x7fvWONw2sQitKpoLbRNzQc7Df/w5ZR3tjy7w8MkV889DLAWLx2VjfAhgPhirlMG2NmLi6Q1UlVgkVmMzEaRv98Zc/BCYMvW2JE1khsQYwYNuLmJTm9gI9RxyoODqzx6cI0YLTOUuyxtFRv46JLn704Zb+6sMakPk5pVYjvDxVFGUpGK3pMuxPgsZoFBAXUZhTWjYaL72Qk7bE9GnP5kiwNXhO0Wxm6dTmtiMqoqI9+sm2WBwVs48MyCgIHDdoXv7mtYrYTOstCjzUC8cTU6fnVaePZCw2lbwYaHCAiu3c0sfckILkEzTU0KJDlluXnnBArDeywr7NqASZxw7sKID0fnYbjGpTBk6hpMlNo7NAZijKhWoAtV2hsJMUNjoPGRgSTqwpvQWFBGKeFSV2TPM5gAyY6LGRU2FwKZK7OikGKHBMOpI6V421qF7iWHr4uihmqWqNXRhZAF7Yo+zKWrI55/7W0uXN4GaYjB8LXDMtm+CKEJToSM8YisDj0/+N63OHHHIWJMiJMCAcx6PxWJu+88xNPfeYx3334b1Zj1gJxbSCiTd0Yp9ZgUz4Uruzz/ytv88JmnObpvWLSWusKVAHxWcL3ZBWihuGnz/83/ZYAlBgoHh8KJNWHQTemi0FZKbByXdYXXrkbe2zV2q31E1nCRDF2lJWkgOodLofTOAlKWH0sBVYfDSCHDNJU8h1FVLoYNroyUVK3QVR6zqqSsJUvLvrWHMZCO+4aBE+uJGJXQ060EdmzAa1cq3tuqmfp9IEYIWYPHtM48iVIJytzyFLBsiJrIiwlApGFGQ+0GKEOm7TZb20bC02lDkpLyUotaC5J3sLmvfetCSRzxLQ+vVwycMGuFQdGx6nB8PGp48QJcSGvgMjQ2SoVqlbmV/cZgbueZk0U2pUpZpkNzG6+jJlVDRtIxCTtsT1skCBMZ9jKIeMvOcCklRBNqWb31xh9Pw8cpjUxorMKnUDZx5I5iQXWpJZQZPk1RrRELZc7QS8n3H0VQ0xIS83yiWvImv91iLzl8TRhZ618RUsrCYL5qiEV2+KPPz/Crl97AtMEs92GVQlIuypqptHcyHSly/OhhfvaTp6m9kWILluUTUmmH1B72rQx45vtP8F/+7u84deYq4rN8s/oKi5EUE5UTQgyYU6pmlWm3y6tvvcf7n5zk2DOP48wTZlOMVKbaWc3pZt/wNHdgg17Arlf8BIcg1N5xYHXAQAKEhEuCU6OrYRvh850pF7s87MUaXIpUKXsmtw5MNUty91DWvuIyIIbM74C8a+3x6+rpmkPMsmRcNkSyYv04T2ZLuHkzBh6ObtSsVaApoSHhPcSknAlrvLNlXO08dR2owg471SE6N4Qi0Nb7M1yzUIiU61Dc1ICgmf8RUmKaGqpqnWDZdjQW1raTCKlFrMNLfz1v6c2MAvuHFYdXMvTYzHKLpYJda3hvvMIn2wFrlGHcJsqQzh8E57FY+AHXtCfL35Lvg0CZcxXYM84xS4L6jSyrjoFqfo9Sm9WDLWa4MsC8xXNjkdk+LT61iLm8/RLB+XzCQZXgKnAOiYZayHySObshK94uQ0+UMqQmlYqot0j13G71w15y+JowMtHLVUqaBrxmsb3OhNG048VX3uKLL84So0d8g8VUZLmLwmhZVGMKKJG6Eb7/3W/x2AMnqIi0YYbzGRMvBnSBxjsGXnjsoXv47pOPcersL1GvpGCIy2gTsVSYsHl7ZKLgBnx5+iLPv/Qmz3z7MfY3eYbhK6WLeXfmnId4c65W86F8kfvIXgG9H7Sbu4w1g0EmYaXMmWpiwrqA6oTZbEa0rFpLMbzBfIFq9t7WWfgtFR9og7l3QbYedXMOg5UEIFHmw+ecUuKcK5CPffEwZ5MfResGM2hSpLIM3G+14oquc6EboUTWbZc6bTOxdQLDYpyTuRI9IGFZnETmtVT+mlooi2G2A43iyb4WPZw0gwp6oht26/el/RFKVWHe4cKM2hIuGtGUXT/gXLfKbneFlcGMQbrCzPazzcG8YFp7nQTLAoVXXCCWkFUKdAUlRuEVKFJmQXlzEa57r/pZ1s09n/39F8XTijBTh7eEE2WmFRNZoZUJQaolM6UFnbOvCyKLc5u/n70R1S1/d/4wYy85fG3k/USMEadk8byUSKJ8ceo8L7z8Om0AEUftKlJo8+0qZHSDF7yvsGBYlzh4YIOf/8lPGVagqcViB5WiLqNWnEVSN8Wp4+iBdX70zFM898rbbO7kmzS0HZDbVCZ5DhJTThBOGkJqeeGlV/nrP32Gpx+/l8rl1w69dHdxDruZ858zwy0TnLIhSir0r6yt06FEzQqlcx8Yg8aMVQtsAAMztlNuGUTVzEkVX1pJjiAeE5vvzvOvlPlxz3vC5TO5ICjmOpQdqPTey8sA3oXsuZkwtoo2RtZDXOozK97lVktjM1zUokOUfRe8TYsf87VNOZtfJebHbYXRbal4PxSDiuy21s+gFrOQ3jlPbnGC6JfxKTW7yUMoInNWINKqDCtlKJEuTtEYkDqj0dRmVDa9Fkt93fnD0pctV4Jz/2+ykKDQS1WE+U69NzAycQto3A2ekFk2fYrirvlQzRVML6Uei6ZBZqNfm4BMXAEw9P4sJTEsORCaLW8Gbp+4DW2zbyIk47nbrittpaxp33aB5196mY8++QxxNVoNCNHwztOLi/aSxlgmvznvefxb3+Lb33oETR2xm9DUjhC6okSgWYcpBJwFBhU89dSTPPDQA7TtrPRLBO8zGcdiPh4DXD0gpszXPf3lGZ577nlmk2k2IWpnVE2N854udDd9CUz6AXRxaCPviqW0w8R5Ap7RzGhx4PoeUF6Y1024a6VhQz1x1hJddiMLLjuLuQguKJEhM12lk1WCNCSpi/hc3mk7i3jr8NZSpVluJRQLysJrzS0CW9qJFge0PESNJEvsBiWqx+liaatCx2Hb5KG1yECN3ejZlnVMhCq19PaRrvye/qP//5xk2JPvLOLTDEfWJjLJFYSVXW7CkfBlYauIUs2F9m5lGDCOysQ8zvWfEVyE9TjlvsGIu9YcbUzsyhpTa/B0aOrKOf6m8y9+19Zfg2zi4202b9tQEqMVtvHC2jWjgyKlbbNMDfq6j/LeZZmYvIwpgcoiVTR8itSpo7YZfp6Mft3sQMrrLF4rgy6Ufmtxu0l197GXHL4uljgOWfA0oxzOnD3L8y+8yM72TvEOyEYuiTwoncPizIghEFNk/cAGP3j6KQ7sW8tOYJaKEmeuTFJMWOy5AxFNkbvuOMpTT32PatCQLKEuO6OlmHBarBYLwkNchaHsjia88OJLfHnmbJZ5MMvDQmMxrLuh6Ntj5WyE3BYoi/C8KBdHSMrm7izj9p1gPhHL4jtUx0NHDnB8dZUGw6wjacBch9JRp5aVrqWOM3xZUHzq0NRmpcwU0XStb3O/0OZBY0CtK8fVLzhf5XcIRkiBzXGbj3NhEI2PkTvsCt8/Gjiy0TD1a1zVA6QkeAKRmk4GtDKglWbpY0AnAzot3g3lI4ni6HKVZakgr2RJcbW37cwe2IGaOBdyuHVhIoxmHbttP4cqbyHGehjzxMoOT945QKoB29VBdlNNbS0I+dyuvwY05XNDWs0fna4QtCb7Z3RoAUSkkqwXC3QPbhAy6NTPNwE3+iHFW1tJ2TgqzWhixMfshV3HwDCNqFNXjiWW9JxtVKX/sJLsLBQXvWsH1djNtWL/pcRecviaEMvuUI6IVjVRh+x2njfe+5z3P/gi21Oqw2LAaXbRyro6K6hfwYmgdHhaHrj7GE89+QgimdWpzhFizI5cZP/kKBFxmrXpxBhUjh9970nuvesoqZtAMmIE0yEmA0SqjFaaTREniHOEqHz0+QWefe1DxrFGmzVSiNCNqf3NLD9LEtpFqVLmD7onUeVyO3RImrG7u8vWLDLzTX5ky2kNQ8ej+xN/fFfNd9Y7DrSXqcKIGBOdOJJmDRz6qoSMYlJrwbJDHhJzf1mUoDWtGxJcg9LibQpkUcPsxlZ2kEyobIK3FkMIOmDEgPPjwPmpp5V1MC0GX8Za6vj+/jF/c2fL91enrMcpXWhpnaMVR6sVravofEPrBrSySidrRN0gskagIagQXMCY0MQR3jqiCa1VBBmAVqhFKptQ25jKWtSyx3aae0Dfqps5p8LdLnJmN7Fj6yA1xCLdkRL3NhP+1Z0zfn5gygmdQDthatCqZyYVrVZ0rqZzTUkGq3SyTtR1IoMs4+GMIB1qE2prEUtZkkQ8phV5JpMTR16My8xFFjOMmzyt8ncshk3GtfuD5XZkmmuj5dmHLT7S9Uzz8o8CH78dY2/m8DWhFvBpVgTXhnRuhXNXdnjulQ+4cGlEVa9jybLBiiXUCUEcyCBbYtoEz5RhE/nuY/fw4N1HIXW5wJ0T6xJOsqy0kfK8Vno55Mgj9xzj6Sce4rMPPkH9CskNQCq61BY4ZC7jLbVZjM0NuDKK/N0L7/OTn/0pD9y5ioQZ3mZoNJI0N04yYsEQX/SIHUkbkg6yhLhNqOgYzaZ8fnXKPevrHLYZtYWsZRRnHG4u8+d3r7O+0nDX+RHvbM84ORKm6jOyRyDpMFdBKdcFxSZsLgaacerZ9N20HE/syMqlTWbLSobIquWEDEakZiY1rVthROJCd4nPdxruOXCEI5xFmeUtUhDu9FP+x2PC3S7xny40PD+uuWgRui4LJnpP1GxViiiaPGouzyNSRLVDfF6kfIhlJlKT3BARh8UpdWqpZUYPpO1kQHcT78k3jX7msJscJ0eOs+EgK2oM0xWkyFE3MfHDtW027jbub1b4u03P+9ER2ixKGL3HfJWvgXkkeVzyqFH8uwNSBdQFJBiCK0xqyXwKi1hMaLEbxYxExJHvlSJ1eVPnlZZAEfO2VZZYpVNlokNanRLNlY1DD3P+ut+z8OtY/v/tFnvJ4WvCUsrLSzVkEo2owkefnuTV197JhDQtMsGSiW9CXsCEWKB6HU477rnrGD/9wfdYHXjopvPXV5HiH7xYfPO4Iu9VNAX2rQ746TNP8fd//yuubE1QbQrgKJuWIPlhi3O/aEcXjI8/PcXrb3/AvUe/DzFRV5plNW7yPs87rLQY0PYddnGYViRraOOQS6Hm9XMz7jp2lMEgsTLdyrM/nzAJHB3u8PO7Iw8fUN69lHj3YuSzScXFWc3lMOBSqphYHjyreER8wa9k3LkjUBGRuIuElMeamtsaXHP9yteo6fvZhhYl2cClifHB+QkP1yscGq6gaVa8qvNUZV9j/PQux+GDjse3dvnkSsvVK4lL0fFl9FywAVM3RLXJznIGLkaiCZZqEusESez4DgqZr6EDa4lxionkKqLf3orkNtrvwaM4JwfPp1dbPrnUcuzggGHjMLK3QTa+ER49CKv7Ku7fibx+9QIXL3ZsToQz5jkXajbdEHMDVD2VGXUEYiQ4D2mFoOuMXNZWNRNqEpImxJR5DFEbYtEqskKn9GnWr+o3fU42X8zlK1/rJyP2jfb/t2dS6GMvOXxdiAOp8gJjys7umOeff5nz587jq7rwGa7Dr1gHRKpaiJMZVQUPP3Q/T33nSWIXcdbjq7M2D0Uu/3poYF46ErWv+NajD/PkE4/xX//xJTTUOD8sbdAl5bX+kAWcKlcuX+H551/mZ08/zpH9A1LqiGY31UfsYX79sHE+TTEIBlEd+FV2LOF0yptXdzl8Vjh89yFOOMGYYMxyRzl2HJAtNgZw9/GKZ47UnBo7Tm0JJ3cjH022Od8KOzNju4UJNZ0Oyi41y0x4jIrcPzbxTGWFKBVVmuIsD45zC6kmUZVWTa4A6zjBWcultMIrZ8Y8MFBO3DdkPztEC1AZwRTtjDXb5anhiEdWOrYOC+e3Gj4fw/vjKR9Mp5zrttkNFdOQsOggNQQZElJNN4OZDUh+H96m1GEX342ynIMqnTS0WueF2GIe3NIWePCt7PIaJo6RW+eDzREvn9rk3pU11lcHSAhZkVbBOsXHlvvcJnceCPxkX8elwzWnRzUfjTvem8z4fDZms/NMgtB2EbWGmIbAKl0QWjydruEFfNzFhxE+dXhRolZ00hAlAyuUDp9mmZiWnTZ+948xt/sy/81iLzl8TYgqRkUb8oP18Sef8+KLLxNCRH1zjQFQH07yHjTFrFh66OARfvqTH3LwiKcdJZzUCAX3vtTX7FtJeTeZd1QqDucq7rjjIH/0xz/i1TfeY2c0xUtFlxKivmcP9Udc/hSm0xlvvPEWb737AX/xp98lzibwDSqHpasx78n2aKxogmlNxxBfH+XLUPPLUy0nfGTjaM2+KuDaKVVK9KMVVdhwHatDODao+PZaYjwbc2UauDgzzk2Nz0eOzyY1X3ZrXAyrbIaa1jwzq3A2xDsD9bRuZa53pRZwRLqC/ul0laSKWqAJIUMxBXab43zQXuEfz45Zb+B7R1bZN5hS01J1RpVCnqMAjcLBWjl2p+OBpPygTVyYRs6OhfNT4+RuxZlxxflJxeU2MLVtJG6RbEhwR/AkvCTEAhYSUg2gcDfmM4YyVL8Z8tc3CgPDMa2PcCbs56XL5zh0aoKeqDixb42BTtEYqSygKSBhSqXGmoOjB5QTBx1PhsSfzCLnJh1nJxVnJw1fbFdcmNVcmBo7YYymCSkJyR9BdUAlGeVmsQOtsiIAkmdN5PsoSaky9pbwP6jYSw5fGxmDHVF2Zx3Pv/QqJ0+dRl1GKPUQuH5RnyPYUyTGKU3jueOuEzzwyKNc3uqwLs4HYDJPDX1ZLGWBSDk5CCQJJAkEER565EHuuvdu3n37Q1JsEfmqvnxPvFMVUoDz5y/yy1+9yFNPPcKB9VVSO7v53rYVXafiidcX6xn5EUjJZ7ayX2crCe9vX+V//myXUQc/vLPiodrjwyzbTAaHePKcRAKwzVCFw6twz8AIBhN1XOo8p6fGqdmUL8aJT3cc52cDzo+Vy1PHJNbZzEYyvLR3fUsF+ZLEkzQLxGVkVV6gIjDVVaz2vLz1JeHTXXZ0wHeOee70IzasRVLf3hGIgs0iKuPs0TBQTgwgbHgm0XG1G3C+rTg1Mk6OWs7NWs7vzjg7dlwNU6ahv4SOgCdZ5plo6hBdQDw7aSBJIc7doigUghkNqV7ns8mU//zlRToRflKvcO8KHGKGS12m+IsUBxzBmNFUHSuVcKQSHl4RZgl2k+fitObMzPHFKHBmPOHceMa5UcfFdsLObJjlW9QTdeFLIQR8KvMsSxnKi0eLzPpe/GHEXnL4mkilZ5nU8dnJz/nViy8zayNaD4nJzelVi917gX6K5QSicHV3zH/4xT+yUmsmuJGTQx+9VERBW7NIDnkpjuIwdexME21IuKrO2++ljWbPG8oCeQKa0edtF3n5tbd47+Mv+PEzj5O6vre9gDFaymS6X9+RzXjvhM+IGsujP7GE1w5Ljs5CFigziOZIus5LY+PcF7t8OY38xbEBTwwS+yzrQRESksiVhDeCGgnDC1QK3owVHzmxrjy9z7GVKs7NPKdmHZ/uVHy6o5zaHnFmN3FllgfE/ZzBXFMWGilyHCFrOFmkt3XxqQP1XKkO8vKOsfnRjFMjzzNHV3l0peHIMFDHDmu7fEU9eCNDjS23AIfWsZoCR2TMQ6tKu+7YwnEhCF/uwskd4/PtLT693HFmBFfSCkHXQJoybJ8V7Z/sZBZMS5vp1t7PQnaBi6JM6w0+6wKTL7c4Pe344fGG7x2ouLsOrFUd0nWkmFCfUGd4S1hQxIzaYJAmHLCWuxvhO0PP7kHHFRPOToyTO8oXOxM+vTrli82OS6FmW9bAr+W2pwUshdID9XT9+Zf50l78YcRecviaMBOSesZd5OU33uHDjz9HXJ19aee47eUnuvzbeQRHF1o++/xLTn15FkcihTZbK35FgmEJbmexePamoutSSD7aZPc315A021Y6MlPaMs8rJ6ZCulP1REucPnuBF15+kye//QgD8Rgxw26LEqwVIyH9NfahOd05klSkgkMn86HzwD0vw0hxyXISEa3YcQf5oBuyeXrC59uBH+wb8NSByP0rgUO+pfZTRCKuSF+rzxIOPVLJp7xI1LSsyIyjTcUjKx3PbFRsRs+5rY63zk157ornZDtgayZM3Qbmh5j4nLzipNiE5sohUCEYK2k3D599xRU7yGu7Y8593vHJFnz38IDHDxr3rSb2NTOG1jG0aVaLtZz0TUvzQ/PFVksMktDgOOwrHjlYsXPQc3oGn21XvHW+483LY05OAle7SPCrqHpCTHhRnCQsdEukvFsXYsZKGpFshjnHuFrnk5nj8rkJJ8fw0SHhiYOJh/fD0bpjNbUMmVHZjLrLd4RpEWlSyfM1SXgz9idlQxx3r9V8d73hQlBOjpUPLhmvn2/5YHubCykyYQ1zDaGw3xsnWNdSBFF+j0/3Xvy22EsOXxMmQlLl3KWrvPjKG2xvj6gH+wkJXOWyBHCJuUQDC8amuAFdjLRtR+82tZAH+DVSAfNVpzTnpacLAXSIqzNWvBizJFtoCaswV85EBOdqLCWmbcuLL7/Bn/35z3jywTshzRCnxK5DUZx3WLI5buQr12COGfLkPX7PRg6lrhIsusLyzv7PngGm+zkbVrhyacLbWx3PbiYe3eh4bF/H/as1x1ci+3zAW4uGRC0lIfaCN4nc0jLBhcCqa1lV407vePyA44l1x4ndIc+fF948M+bkTBjFAeo8kgzPrJDjLLOQNcNFq5RnL0ET5j2d28fptuPy2SnvXoncu994+IDjsQ3H/UPjLl9xSMbUGvM8SXLlZQozcmXnRKiS4boOFwONTtkYeO69s+HR/Z7HLwsvnIu8fOEqZ0KibQ5j1ZBoAW8zVpggyei4taqs0KPPAkFS9hOvV9mKQ97eavlia8ZLFyIPHFQe2+94aK3hnmrAHW7EqnRUEsv5GzgIkugsO/15jCpEtJtRpY6VWrljf83D6xWPHqp57QI8f3aX93dm7MpR8GskE0JoqW2Ks0QrA+w2tOP8Q4295PA1IapMu8Rb737Mu+9+hPomq01KlZFM1mOmr3OJsgUTVNQhc4vBZeEyrnsGFjIPQEEy5d6v9vBRc/PXzj+ykNG+7sCJKVL5ASF2fPzZKZ598TUef/A4rrRIVBVRwTlHG9ts+fhrBuw9lLWIHmQnsDlIMJTqIkDvlIbiZjMET1KhdQ2nkuPcjvHapOLQZse9jfLQcMajg8h9g4rjA2F9YNQ+UTnwEhEX0ZjnE0Ry79sZEiOExIEKfnIcDh9Y5cBQ+YfPp3w+vUpLKtVDnAsEQsHDiyfRgMwQneJtjE/gpGYq65wKypmtxJtbO5zwOzy+Yty/ahxdU46vOO5YUQ54o1FBHASvdJaw2DKUyKpLmc1thm8j623HmvMcv9NxfHXA/oHyX85M+aTdxYZHidFwITBgSkopQ0FvYRhKkFWC1IhMcExxFvBWYVJzOQ25MhU+PD/j5fObPNS0PL5q3LkOx1aU46sVR2plVRNOwSphJkpMHXXsWNVInUtXJEaaScedohzaV3PPas2RoWfwZeKFy9vMdAjVkDCbMKSjSjOCVnOI6178t4+95PAbIy+Bl67s8txzL3Lx4lV8tUIqO/eUoDiKLDWIikZ8P9Djq/LG1+eDa1TLSuUw17qbw1rL0NrmgpJLBNAe/Gdz4beUjGhQqceSZ2d3wnPPv8zf/NmPeOToCqHr8N5neY/4m/H1Arh5374uh+ky6HJ+ACVxSJ5PZLJRjTPJ7QgdE2npxLNNzdXZKp/u1rwUxtwlygODyIlVY3W1Yv96xZ1rxjE/5ZBOOFIFNuouK8lGwaLSaXbrCgYbsy2+NTRWHt7Ae88vPtjiy1lLHByko2gWoUX0LYEoM11FpKaSlto6mtjSxIB36+y6VbZV2UoVm7OK87u7vMwEWWs4vDLgzuGA47Xn+FA4vpo4stKy4cesuoDTiGrCxIhJQAXXGRJb9mF8dyPS1Bu0lWf3s23OtRXqh4hKIXKxdDPcunu6k1VmuorXRG0TKhsziKVlWO1jR2s2ZchWUK5u7fLZ1V1oPKtrQ+4cDrmzqTjeOI6vGHesRg4OpqzoLrUG1BtoJIpmqfskaIgMbMp9VUt95yrarLNrgTe3rtDqoeJnkt+j5Tp5L/7bx15y+A0hAiFEPvzoM15+9XUQR0yCaG4nOSntn57t2X8k8tDXeptQuPahv/7mtyUZ6B5q2qOfsn+B9YqR1qtHFjjg/LWvf818nG0XqX1N2074tMBwH/3v/xTvHNGMlLJhUJ8ovvpcGt4CVZrhrC7DaVe0gvr2WU5gWQHTEbVCXJN9kdMIl2bUaYokR0pCdEM6v8FmdYhJmPDlZJd6Z4yosDF03LGSuKOquGeQuH/dc99azR2rxoFBokmWB5kOXDKqrsOnqzy4ZrQn1tjZ8XSnJpwLY6I/RNCmaDCFwpyeAg3JkRFWUuEVmqi4GHEyQ+sBqR7QRccWQ3asYwR8vOuorgprEY5VkbsGU+6ox5xYnXDvAeHEPsfhoWfV1zQYLo4Z1gGCQCusMuOR4S5/ce+QzUnkl6cvstVu0EnN2K9lz+OblFO/9i2/sUXVpZT9IySbROVrJLgEGjvEOVxVYdU6u67B2lVGanSt8vbYM+yMgwJ3DWbc2Yw53uxyz77AvQeUY6s1+6qKQe3wacpAy4ytUzQl7hzs8uNjA3ZtlfG723w6jrRulakOcH4lt2l/D/Lle3FjcZslh8Ui/duI8aLC9taIF158hbNnz1PXK8SUGdHqFm2ia2SwrReYTnOY6nz4LNf95uWHeflr9tXPzW0KrTSriplQzz1YPh8kt8N6TkIyQCs2t3Z4/vkX+csffosTx++gG0/I0tLFAWsuNz0vW+a+1462IH7yPCPhQPSa327iCQVC6mUGNmMGdKzjZB+Q5SbqpJjOSGqYN8Y6YOKVQWiJk8TlieMDt8bAr7N2MXDHIPDQfuOJAx3fPZS4r9phZTaFKIiCSxEbb3FPbfzkvlXOjeHi+QnR++xJDFQxw27rOGUldUxRpk6YuXVSUlIEZ4IKVLQZlVXMeZCKKmUrUWdGIHKmDZxuIyKe1Z0hB65G7qgjj+yr+dbR/Tyyz7jLX6aJOziL+c2JsOZmfKvZ5vIdFZevznhzx7ha3cnU7aMmUMUtvtHOOUPkrrsRrvuPgVqiSdsM05iRZr2psRuSnFCX6q+SiEmGs2YUWIU3Q2M+f8XYjpGtUeC9sVD5Afu2I4fPB+5bER4/tM7jh1e4f7jNYbmCi7OinZSZ5Hf5ET8+KJw51LE7vsLpVDOp9iFuQBXGqM249RXUXtxI3EbJoVfGlGz5YYudOQgppQwtRLCCkf/o5BleeOUdQnD42iHekWLEidF12RUuJSn5IRvq+KrKA1xb0Pr//+292bck13Xm99v7nIjIvFPNAwpAYSZAkBhIgCApUrOWJLZoqdu9Wt3Lqx9sLy8/2v+P/eD2Wrb1oJbUbkmtXpTcFCmSGAkQIMbCVChUFapQw51vZkbEOdsP50Rm3kKRBNgsssgb31q36k55MyIy8uyz9/729+2612W+X3AddDun+VVf5h7bzc1ZUpMh5OZ19jzoFmwzw3mhbQ1XVDTtiJdff5/nXj3L0RMngQYvNU4scfs1aepHEllKzXAxSYZMvGZ3rYiRPCWSeFl3oArR4dShBiVjHGOCpZlmkzJddUt6URYDLtN+A8kfw4ol2mi0ZtTi2IlwaSdwejvww43Is5drvrxW84dHaz43aBiQG8NiSIzssx3uXSy4f7/nlUuBdbOpzlIRtxPH31U4TcKGmOGN1DfRXMIzwzWgmryrDaWJhgWIlixFzUsaspOCVhfYIHJ+XPPm5oTXNpQXVgs+e9j47dsP8nhVs6zb1CjiFK0jB9nk8cWSUwcLTm0L+IU0FBk/uZy6mKTyniUple6WmpVnbMoBkjzaHjS5pZnlflKU5GGQWVjaJn1UEYeaoyGVKQ3DYiCqgVMaHdBKRVC4Ehre3ZjwxnrgpfWKe696vnLbCr9+IHCXfEhUo/UOZ0K5PeJuqfnS4QEvXoh8QAU6IEst9biJsIeCw0xIDvLil0XvzIQ21+mtKGjVszWe8NTzL3Hm7CV8uTx7nJMsMuZRU0IbiAKqyZUsDfVY3sjZjz+Yn3SwHeYziy62xIDPu/nYGqIFFlOTOcSIiCU2k8sWn1Jy7sNtvvX9t/nCE1/iUDVAQ41ToY0NUaoUFLNZjdCiFmhVmfiSymlqN2erRTFFTIHOpCVdz0R+FTQtMUlMUGrIomizqXJBQifU7GmlzN9Nfg0FDaaOsQy5Kktc3glcfO8qo60d3K0ln9vf4DVgmspbRdNyyI25a98CB0vjfGjRdkTJNoXtsKX7GfllnBku1vh2TMEEn324U7O6RKMnmp+OJJqDVnNXRzsnvDTrUXSUZi2I5RIXTLm4Ce+MRqxPYP8tjkf3KY0rCSKUbc2gNY76mjuWCwa+IJqjaEY4G7F7J/CT7w8FJHaBQXP20Hki2PR2mTkTGBP1NK7E2YQyTChCgzNLZVMKhAINST3VLBn3BeeIKkQJhI6IYBE1wRkYA6IfsmHCxkQ5/WHD+VFAbhWOHvBUAxj7Em1aFkPDkrXctRA4MCigrpC2pei8H/aod8LNiD0VHHY1ctldZFLnqNuYzdSFs+cu8Mxz32c8GuOLhSw9kduGuXQTYyatxgi0iEQmox0Q/yOz+5/FOXQlH1GHrwZYyAqXFvGaF+XObEjz3lGUST3hBy++zOtvvsdXH7kLokdIiqKdM5F0fYS809QILqSyilq37uSlJi/MUwZVludoZCnV+rM2PrSZ+jo3/JezDssOYS6OcilHp9PjRmJV4Svq4LgQhX+8tIkzo9y3wgPlOkU9IY/pMXANh5c8B5YVVrOFKp2bXZKKHoQNfJ7RAKWRQRaCGxClSBmXBbyN8SS572BDOte5dOwydZFLL0cKkqaeYMpq0/D8+6vcNWk4+uCQAyseG+XMwKUrc3RRObzgeGe7yZ4P4ROvi9PS5XV7W/P3Sr7HLVKxTRF2puXJKKnv0FIRssGSmOHjhJIxSovZgGjVNHOdTfTbXEBK5284RlF56+oG3x5vcfddjkfuGaAWiXWDeaAVFr1x8sCA8mLLODZIbJGfw6xHj4+PvRUcrsGsjZzZNnmyeDRpeOGll3nrzXcyDfV6D86LsVO8czSTwGCx5MEH72F5UKQy1Q1EjMrOxDh95gzjnRrvK8yMGONujZq5KpVzjgvnz/Ptf/ouj95/OweqkrZuQRwqmjINizP9JBQXoWyNooWZOUsaAIziE1e+22dbRAQaGRIp8bHGSWd60wUKy9pCPlk4apJ8dnGShtWkopVy2kQmtrh2i8otoa7i4mgfT64Ld+6scMtiy+E4xgs4Ii60LFXG4tBjq5YWPqos6iY4a5IAnIXk/0BBIInmNVolCiwBDRMkRhx16lnkBXBqAJPlT7qNvpoS8/yHmaAirIYBT69uc+/WIl9ZqhkySppQGBZh/wD2ly26voO44qN05J/6jv7xP09GOZ35jiNmI6NGholMAEny3JJFqGOCN5IG1JwBzvz5GzJHHU7BvZUBb25XfHu94Ggz5DZdo5A4lQcvEI4vC/7cdsoypaOF97hZsGeDQ9fDMyDEVAZSX9IC5z74kG9/52k2NnbwxZHrvuU68bmmnuAqw7nIAw/ez//8P/4bbllZILQ3UCcHoZWCMxc3+N/+93/HG6++gdMSr54mBsBNnb6mrY2sqT8ajXny6Wf42u9+hS88dBfj8Q6FdykbyrRUEZlWq70JPkARc3Yikj0YOotLydPOAaVODl2WZpI11jjq5MKVxeU6U8+IJl67ljlzGKZ+g1vCRHBxwiBsoTahCjWelohSeceOec5vGzsHC0Sy/4MJrol4neCo8vCbzwtXk68aTHSF1iISM9PMslw0kdjpVVmLCbQU2XqynhrEdMTi3eMqiqKYaW7aF0zKg5wl8nZd8Vh7lRVp0ZxtBCXbWY6RsIP6pW4ffoPveaXONqyaNadSltAiMiYQiEj2PLCshVTkRvaImRVqnB1rJkcYQrRUZkMUKxZYDYd5sxlzuVFOFoGSCDENEGJGRYM024hfQLteUI+bBnsyOHQ+5rHb+WhyUTPxNAF++MpbvPTia2nYbZcpyNxEQwypjGKB2DYsr5R8+YlH+eoTD7CSB81uHITWCSdub3jxhUd57+23GU+2KcolvCtp42yhmbUr0knHKJw7f5Enn/sBn77/DspqgWhZR4iY25cdOXdeB9+mpYuYCznJ+zj1IbzVFO0mziaYNAQGdL7DnWbUtEUqSYnUR/LQXxIwNClpXO495H6Kk6SRRDAkRIZuwjBuMoigEpPRUrApe0lywxvpMhRFrUw19yjUsghmFDaioE5q/xZQazPXPmuRZOkSo8iLv+WQoNdc2O46zco8Jh5MGEVPq0Wydw1AyKHFCw1KjHnqOr88NzQ6GIDSygITXUTbZNJUUKPW4GgJ1uSMIr0u6cgcaMdMm4lF7r4GXUcjl5xEMfMoNWNrwPu0+YiGRcU8BIEmpLl7lz22e9xc2JPBYR4mTIXq2mhcWt3imed/yJW1LarBfuZH3OZXBJX0lnAOCA0njh/jiUc/Qwk0o51srH7jtkLRD1iuHF/+wsN86x+/yXunLxBDg4hPrmPTWnAXpJI5EeIYNw1Pff8FfuOrT/DQ/bdS77RJEBDSdKsmymoQaEVolakndMQS60uUaIKXJHO90O6wT7ZZdDWrdWCkIbO+HI05TIrk9GaC0aI2xseI5sNrdUArml3BQPOkeKDA1BPxOK3xYYeFsMpRX1E5sDr1QAiSPAnwNB2zWDLzjAofJ/g4oVAoVChcoB6NUAVzBa2S5UgULNLZ/xiSfZ5ddsXLLhedGq+RhQtzyciSZpVnwkK7yhFdpvKG1bMMx9SxJQNqMQrvaUnssp/t3TIXbabCipEqjikwhpXQjsfEWKeNkZaEvAFIXIokB4MYAU+Ubghy/hrMnkKnB58ECp0YvtngoG2x4vclhVdLjDCJSu0rNqNHy2Kaq3ySfnyPG489FByu1a2Y+SZEhGBKa8Lrb77HCy+9irgBJtkn+dpHpgFYVCXRMn3goc98ivvuvhVrA1iYLhY35kwE2hanA+658zifvu8uzp75gLQ1Dah0E7cwy3by8FyEOkTefOd9nv7Bq9x3762AQyxMXddAp85gjVPqQmic5IZxLjlJmgvwMTJsaw6HEQ8drTh5cIXvn9/m7a0xo9YT/SLBLdJo1+yMOJtkH+URRRwhoWUsi4hLTW3JVFkTR01JrRVRS6q4TTtaZf9QOTJIvPsYQMXAlFYdl8eeq6MG0cyVstQjwYxhWOVEs8V9tx9jsHKAN86MubjZsBmHNH6ZWgpUU9/BW0Soc4ks5AVWp83t7hokCuwsQxILuNgyDBvcX27wqSLg2hRqXGYQ1Tg+qCuu1E1yKhPNJZufXbbZSaGYJRquSuolHKgvcse+AXfddw/vfxg5fXGLq41j7JdpdIEgFaqGC+AzYw0JudSWPCimZcfpKH9MZSrL2lMxUNqEY/ESnxsGDsbUnzPp8g9hta04t6OMgxKdpmwrl7N63BzYQ8GBeSZoCgzdTiVLB29tTHjq2Rc5e/YCvlgimO9UKZhRP9J7OMaAcwq0HD1ygCcee5iD+xagHaVBsRteQA6U0nD84ApfevxzPPnU82xPYt71zm3BdtGz0mRz08CV1U2efuEVfus3fo2ThxegTk5qaQpbU5kHJThHq0roehhTP/ikxSqTEcN2i9uHNb9++zHuP+K5ZaXku2fWefvDDS43DSLFzCvZF2ioMasQS45tahOiddPMs51plIJWKyYywHB422HRBR6+dR93LQdcO0rnGQ0KY9MNeHMVPtioMZ+yjxjT4ihEVuI2n9XL/NEd+6kORk4tLPD86cucujrh/HjMTrmfmgXMFZgOCNGlDklmXCVmlkuzFZm5o9krwsUasQZngTJuc0I3+M0TngeHY1xtaR5GIjhhpBVvbyoXdpLGrahPF/VncM9MSRZzoozRDBWjIHIiXuUPDi3x2btqzu4veWmgvPTBNme2J6zKCmO/QqACLVLbOfo0/0Eg5VNJiDGdf8oGVELyqAipPOWsYTms8eiBwFePCgfCFjGkrEOc0HrHBzsFb28Etlsw70BdvgZ9cLhZsKeCwzT17wRROyVRFZpovHPmA5559vuEqKhWWEy0vvmBtfnk30JAxbj/U/fy6EOfxtPStpNsdn9jLR+xiIQJi9Uin3v4Qe67925+8PJbea2M131+A9Q5impI00547Y23efaFlznxe1+kFEFitwP206sVMjPJkEzhzA3JGIkxMrSaJXa4d7/jkcPCcbvAkWNDTg4dr+/zvHZ1wqmty5ytR6zJCmNdJogykQGtK3G6iNDgLCLikn1kppMWEvA2gXaCxJbjxTaPHVW+eptyV7mJhDbz+YV66Hk/LvD6urIeq1QeCRNKV6GqaAtLLvK5I55HFlaxuMOdJyruK41TV+HFi5ucHrWcHVes1QNCsYz5CpW08BuJxdVJLCpKDG1qxktIVNx2Qiktx4oRXzxiPHHCs1KMaCHNCSJM1PNBWOStVdhmAK4EUWK0H2t5/1PdJTEiohSumLKJ7lhWnjgcOdq8w20rFffcFXhov/LyxZrX1lZ5fzLi4mTARBYIxQKqCzhLfYnkdx5zH8phFhKbTGNim4URhbUsuYYHVmp+646Ku1cmFNbSaHrDNaKsuSHvbHoujIToh6AudaQ+oY1tjxuLPRUcrkXWScVE2drc4amnn+Hdd9/Dl4u0LagvEFqgYx7JVC+py6gXhkMef/zznLjlILHdQghZFfQGHrgITg0LNRIKbrvlKF/+0hO89OpbSUhPio8ME0lukotTXOEJZlz68DL/9L2n+crjn+Hkfo9MRrn6m8obUQSiR6NLImoxBwextNjESEnD4UXhwVuHHCs22De6wpIJBxcHfPrOiseOFby+Fnjlyjpvb2xxblywEQbsWEmTefHEtLioQZRk3lPFMUu2yZAJCx4OL5U8eKzkN28d8tlqlaXxmKB5vMsbazrkxUue19aMUbkvzYBkZ7UQUvlv/9IC956MLMiIwrawiePwovLgsuNzB5XX12p+eKXh1MaIi82EzaZkkpv7QUiquDhUPaouSYLHGhdGlFazr1KO7V/koYMVv3/LFrcO1iAkI6OIsaMlH+oKP7ikvH2lpnUrKdiE5C3+M7k16PQbNUlgiBAtEkLAO8ftt6xwdH/NUljHGxxAufOY4+EVx1vrwstrI165OuHMaMTVsMOo8YRuQ2UpKIgWiCarW4kTtJ3g45hFFzi4MuCuAwv85rGCzx9Yp7AWAhQaafCs+iGn6hVeutiw3ji0rKhDQESnopI9bg7syeDQsUPSzZhqp2fPnePJ7z3JZNLghx6zJLUtEqeZrnX/mBFiwBfKybtu5wuPPYKziMUa7wwL3YT0jTt+n+UOJs2E4WCRz3/uYW697du88+5FXCnsbm/mTkEePGubNOw3qUe89tobvHHqTU5+4f5EC41xl0KoM4e2Dhckc9/TNJx0xjdhzLEDJXceq6ias7jQptmI2LDADgcXSu5bKnn8oOPMRsvZ7RHnNjc5tx25WjsmUmE4ilATTdjRRVSFZRlzxNY47sfcsb/k1iORkwfhzoVAsTpKx+YjOAhOeH9Tef58zTtbi+zoApW1VE4IoWYyjiwveI4fO8yhQwJxRCWBMIq4IrIgcGSl4O6Vis8eGfLedsHpjYYL61tcHkU2o2diQt0mNVjLcyFeApW2LLmWgwM4cXDIySMF967A3TrBhUg0RScgRaRxnjdGizx1tuHKTiCWYBZQ73HqIbS7XrO5l+HHYqraO/3aaEOLV4dTYVzXiMH+Qwe45YRSlOfxRIo2ULTCwEVWSs/tx0vuPzTg88cLzmwJ769v8eFmzVorjMxRt0ITUy9KxKFiVGXLUBv2FcaxFc/tRzx3HCy5v9rgkNU0reDb1LZgAJdtkacveU5d3qG1JUJMZVDnXKIX/1RB8ic/piu39bHn42NvBYddOmS5xIQwnjQ8/4MXefuddynKAW0EX1aZuz27pSKkYJLLuYVXHnvsUe666zhNM6KUCDFkPvyNLSuZ5WkBBe/grjtP8Nhjn+P0mW+QlOS6l1amVEvRrC8VI845lJJLH17iqaee4dc+cycHBgUxZM2iPE6unQZRAE9H8bQ09CUR5wyjZXO8RbtgSaMpzzMJUE5qSjdhX+m456BjcgC2amGthrVW2AwNk1awEJlIwXYxRH3Fih9wXIYcV+NQAWU5xrsJuhUQNcxBVAVVruzAD86MePOysSNHCW5IDJtYbHHiKFwSIqzbwPokcMugZBzAFwGKCBMH0rBfA4vDwN2Dkp39wqhp2WpgtQmMW5i0kbrNhRURBh4WC1gp4MDAWConDN0mVQxIPWbsCqwwhpMWc45LjeOp9xt+8MEEcnYjUdIUeDYmmt2knXhiV8iS2e5kvndGctlIdGHPrNeU5FMUj/MFxEiMNVvjlvGyx+fNgqsCEgXaSOXGnHSBo/taHln27BxqGbWR1UbZalsmbWTcJq9vsWTrulDCUgH7C2NfNWGxGDFw4OoxTTTGVcVCU+PM2MHx6qXIt9/d4UpdUg4WmLSWe3c/bTN6rkw8/0afplDTMdc04C2SlY3W/Nv4AAAhC0lEQVR7/CTsseCQSiNIpihqmm14/8PLPPX8a6xttpQLK8Q6okXErMlDPSXTN6UlQxeLgUMHDvGFLzzCYAhxIrTikszELobQjUDawUUtwJcYsH9lgScee5hv/uOTXL60TqGOkPy5AAiZymghAB6LBtEz2hrx/PNv8ubvrfL4Z++kaQsK57FgeDE0jFBrQCoCyfEtdl15C9R4Tl3Z4W9PBdbuOsyn9ztui1fZHzeTrEgUaEFdoJKWClgphBMDBU0N2doEM6VRZSLbIGMKaVmyCZU10Bg0Kea1pvgB1Dpg3R/i3FrLy++t8p3zNZeaIb5KQ1ZRKsahwauihTBuJrz+wSbfCCO271jmthXH0XKbpXYzSViboa1RhVFycnNCXFCCujSTECDGON0YiIEXw6tlNwYDC8keLpIlsY26HDJeVN7bdvyXc8Z3z0YuNssMqv3JGlWB2GKxzlMlkaBKawM0NpRxTBnGuFARTFP2BhDzXaZGEbYpbURwB4khUsYGp0JtnrEtYK5E4zara6s81a6yFAo+dWw/JwYT9sd1qkmTxPciuNiwKDWLTjhYKWHB0Upi8sUs06I5ODhI/QZJAQqJ0EaoZcru2jFhe7jCeu149kPj704bp9YKJn6Fwi1CCKlt1OZj+AR7e8NAI8ErtXOYa2aB1CVdqCiBaDVKjekSUTwudL/X48dhzwSHVC1NJu5meQfhC0aN8MPX3+GV109jlLmU1AJ1moSV1FyWzNNWMwgNzhoefvBeHrj3dpo6ccLNhFLLdFdOO943AmnAS3zydg4RnFPuv+8kD37qdr5z6SISPUqFURLFY5ku2dFECQGNhljJ2bNX+Nb3Xub++++mqpaYNDVKQ6mgtoNITXRlCg6Z5iqSfRx0yMUm8q0PJrzZLPDQrSv87uKEh4oJiwOhGoI0SVtJySqikSlts9BAoYApMTbAdqKxklhTnYBclLToa2G0KGux4vmNZZ4+O+GVsxucm3gm1RK+G+aSguiSj7ajRcRxoS7527MVp3aUR24d8OjBgntKz9Fii0Gscdm7GnNYgNYg5Iazj0nyevqGiaTFMHbb1jQ9Lk7yJl8x9Vxth7y+OeQ777d851zL+WYZG+5nO3taKy1iNS6zntTS+TVaUGVKaEWDWcVYSrxNcF1pU4RWNc1vWE0jBdCmHg4gMmQiC2DKgBFtgBdXSz5oHJ/dcjx6bJlPLzpu99usyAgXWzTm7CWm2cImGqIthRkSIUvyMRtMYMpaSjt4lwx8EvuBJhacbld47kPlH9+b8Mpawbg4SOuGNK0gokCD4xrZl4/1ngYVyZTngqAt3SbOxGjzQKdaoKBhBNl7vcfHwZ4JDl2mqZKNOA28c1w4c57vfPtbnD39DrgFRltr6f2O0rYNWJ4OjamcpBYgNhw9vMJXv/gIR/dVSGyIoca7PN9gN5pzIaBGlJAZKYlVdfTwMl98/DM898yTbG5dRPxCnvD1KRhKBGmnEggSIxobVieR7/3Tf+G3v/oQn3ngJNDii5iG6giJoWJTTi+m2YDI0hvT3IBRgNOXR6yu77A23OCN/crJYyvcfmiB/UuBxTCiCmOqOMFbTOykqT6PZV1DS8eYqbLTrr5XVD0UwjhEPlw1Xr+6zTcun+fVzSGr9YAdN6Bx2alvytSSmUgh0Mgi79sKl9Ya3t4Z8fJizSOHPZ/Zv8JdCw1HfMOyS3RUaQNljJjmyeiYB+0kzlhu5EuiaSo4aqIAT8yxZQMujpVXLtc8fW6bl9eVD20/rV/MAnWJait0gXMmSSFm+RaypBgsjrFfYLtMm5tBmKAKY1exM1qicaPUCwg5fIuluYM8fd2VVaKUXHFDLkwGnH1/m1cvj/nsAXjk0AKfWiq4paw5ULUMpIUQ8CGmgNnRvjuugpubFJ9+qkmbTIRWlJ1YshYK3rkMz15Y4/sXIqfrRXbcIlFLUoiJiQab/chtviz2cd4FBkVrOFOwBdQNiLqGEmljQeP3Y7aMt5KiVUrSe6YXfv142DvBAaYWmkXpmYSG2NbEesQthw/wR3/w20ixQDBFfHIbEI3J68BScNC8e1SMW44d4vGH7mPBGbFtiNLiCBB1Wsq5kRDS4p00kzwhCitLA770pc9y5r3fYm1jG/FVHi7K0tISMQm5LGB5YCsgseXooRXq8TqhHVOVSbJ7Uu/86NZJViltY5vF5hLraL0OPDOqeG0Djq3B7QcjdxwYcHJ5gaNVzX43YVFrFrSlJDGeXGwYWpP1jvJ0tiq1ekZSsk3JRuu5tAPn1xpOX6x5+2rg1YmyJhXBLdK6kiAFrWW7yTyNmzSfEkUyihL8EmOnnG82ufJh4J21MS+tCPesFNyz4jm5NODooGVZaoYqVM7QnEWiirmkWhst2SBFVaLzTMyz3Rg7tXGp9ry54Xj3yoS3Lo14f6SsyzJ1uUAQRyfMkUQ0aoQWS6vu9LWVLNwYxDGWAeu6zGU/ZCQVvtkBYOKHfLitjJyjlYIQklS7o5u/aBMFFc1eDkqQBZpihTUbsLmxyrmNDV67bNy7z3PvinLnMpxYCBzwDQsSGDihkJSN4EC9pZ4PSoipNBud0lKwE5SdOrLeCO/teN5ZM976cId311ouhiE75ZDWlXmQMB8fKUtN44TuExV7BEGjQiyZxEU2KDHZRHRMLUPW9BbW4pCWJSQWlJbmj+KcDXuPH409ExwkL6Jta3hTxIxQ19x98gT/03//3xGsoAnJuMdUqNtI6QVPm5WoJTUPLW2cigKGlSeMtvC+xecBMkRpfi68CMNig6qmc8umnZ+6+xb+1//lf0giaJKDQlb0j5K2foKgmXmkJPE5R2RxWOC0pakniM/XbKqLYHP/QifTHHIJSKXAuVQc2PGHuIJydn2bVzfGHPlgi1sW4diCcWwABwaOA8OCpVIonDGIE47HHYYWmETYicIWjg2p+LCpOLutnK8r3t90nN+G9cZTS0GoFHLZL5L9K7qZd5OsmdTVEVN9fFFGhDZlKpNiH+fiIpeuTnjpyojDVeDEonF86Dg6KDkydByqYJ9zFBLxXnFF0h6qg9KYZxw9my2sjmBtu2F91HBhHHl7I7LWOMa2n3qwRKtDJpRE6TzCc9ZAi0o7J4Wdjr+zmg3qWGs9r1wYsTVu8G2NtZGAoEXNhe3I1bZEygVUU4A2a4CYlG1jmxr3+Z6stEHjJjFEohuwZgVbOzVvbY85cKHm+ELkxNBxbGAcGRYcHioHipahNDgnFIWmQbYo1FGprWA7KOsTWN0OrI0aVsfGO1stH4yEnbBA7YY0gyVqKpq85KT8vaOJh5+qB2AC0RWsB8cPL2zj2m0WJy0eYYfIdjXm9A6sMqDWghADdkM55r9a2DPBoaP7qXqaSY2FQFEo6hzlvgHqSkKURA8nUVWdRHz2ZkiLTe49IKga9XhECA3qNXlLhzivV3lDoamekbVTE5feQsPAORYPLoK6OdvPXFwQy/yshNRczVLUMQnWxZCMXERLikKn8iHzsmv50URL/g9RCwRHkFSzb2SYzHOkxGzC+WbEpcvblDZhUQMLpbJUOgalwymoFAzcEZx4mhipQ6SOqbe7WUdWR4GxGDtRGFmB+QpxFTHrHSkhZXiSs4Rp47ij7yY+j4sNg3gVs0grA4IOaWWJcVxi3SKXQsvbq2OqqxOWtGG5FJZdYMUJhRrOe1yRugN1EBpSxrBVC1s1bLcwCanJ3ohipcsmQmmq2PIibXkgTYiYJGkNsfQ76YXKil5Z1+jyWPj+e+u8fHqCSKqbN1GpfGTSRD50t2BVhUryr5OYMkO1gLMazE/DThm3qGKgkYLghgQZMLIFtsxYt8jZ7QnV1pihTVj2sFzAiq8ZqsOp4gsPTnNwcDTi2QmOzQlsNTBuoY5Qi2LeY6UjmEvnL2kjY1OPj9TINzECn5y+YSJMSuVKU/D0B+u8dWGLMu5QOM9Wu0VTBTZtiS2taAYVTcgzOn3a8LGwd4KDGU0baEPEq+CcohKJzRijTRLb5pJ8Ny3eG2Y1bdaZF4QYs6mLaWKFeA/iaWM3kVxMd+k3GoLDSUXnD+DyztnalhjaTlP8+tdi13VJb1gnpJq1KuoqYlDaFuo65DdTZ/Ay93iZ0WSxvDCpS7r/1iASiSbUUhG8Z8ISmxawBqizkJ8ZrRVM/H6Cq1Lz2JJSqutc1yQzgYDKg0pDiJGJVERxENupJLjrsoV8bnQLsyT/7yJGnEvZYeIYWHJy04IJwljSc69Zi2sjOqnxYQusTd7cWXAwxOwe5woiJdEVSaXWK6qSKb4BCxFi1jYSMEIWZex6Fy6VMiUFiJkmbjrfKAW1W+JyGBNbhxQVQUsmCFU7gTBhXCxi6mZKwaLpeXLDOzXMI1GEGMETcZr26q1ZElF0idxQx8hObFm3lksYrm5xo21cGE9nggwlRgg4ovdEKkK+huYc5h3eZTfCmM5fiGjX96LNx5n1vrIp0ycdDooYwSutX+BSG1lrDS8VimckQmSR2gqKagFUiW2LokjTZw8fB3smOAA0bWBja5tDh5fSxLClUgGQ+P15J0NeIGwqW5whmYlipEXCZYG67KGQnKwyXfZGY1o4tSzxQfZlzsqX0/mM+WxhN4NqmlgYRBOIivoyZ0CO0Xib7VHdSdDSFT4ks0GkE6GzLLltqUSl1kLXxIa0AIoSM9cl7fizDqwmJ7nCjKLj+kucmg11AxPRirw4Tffc2UhokrSNOjMam8mOh44cqll6W4rs9haxOLsW3loshJl9t6TX11BwEdW04HSceZfsxkFymUIiJnVaNE1pgqdhkP24LQeGHBSmcwuZ3SQuN7az1Sdku8x0vYM4cAMaLYleiK4iSEUolRAnlOWYqMN07fOim7oVqTmeOsgpcEYcI7+SKNwhz02I4IhIrCFO6DZCudOe+G2uxLnMX81lOieCl4hpGtwzbei804M5airarJfkyUQD0hyQSg74WaspbysSBfwTrNtmJEtcVcwtErRKPobikmeIFsn/2gRpIxIti2Jqnzt8DOyp4DCejLl0+TKHji4RW0NdUlatJw0qSTpYpXsTpEQ3LWJJjXL6hhEFyTQ/ZMo+gc7t4MYjLWQOSPTabqivG9eb1XBt+nmytsylDdLpRJupd6oWtK0gUqLi2Ni4wsbGNqJurhjVuaDN9VW62JEDRfrMTee2OqaTkCipU3+IHEDUWso4Ts5vaCp/ZbpxYklq0vIhudUl2eiYaZ1tLqVMcxg6Vdn0/KmcGEVonWMsFQK42OJjjVqNi4lK2akmpX5N8oJAoGEIMv1L+XxjVo7NpSsLCCG9Ipomo7vGMMSZTercPJt1UtUieVc9u4emU/mS2rZRs4eG+kRN1lyCCrmLlN320rfSsYcpfTndy1GUiS7Q+CEqAR8bHBNcHOOtC6VJJiOS6M8mmkydKNI5d+feccLzIi+xc4hL198LSXolP38qIcXpAFpSN+7kaHJWap+s4KNAESQFOlGgnOZLooK2OezkjYOi05Jdj5+MPREcJC8yG1sbvHvmXR58+J6kEhkiMweu6Vs/3aSi2SkuvUlm2+z5TGK3EF/6Vjft+XM7u+tsttxcsJgXDVQ6j+guo9j1WFGa1ijKtFReuHSZs+c+wLndFMPpImDXe25JDmw5CEwXhbz4umt2z11hSq3t3KvnPDQ6eWzLf4NpZqQScNbisgXobOwwlZE6PpDlHXgqs2RtILI2lDU4q/E0uLyspI2Az6q6RpSKxg2STPt0OjlOz0st5l3xzO4GwMdJLocxvd6z+Kr5uGRaktt9HeczPZIJkTjy9EJebNN17NhPLosmpsKVT9mWdEv1nHhEF4AkIrS4mBhTnnmPb5c9JlLGl3y2i7nX3abXYGqdKrb7NbVAycybPHOK85tm5uvdXZ25uPkJ7nwocrOiC2RTel3I98xcmTGdvxJ6db+PhT0RHDpsbm1y6s1T/KH9DuqUugmpXu9LYki70ykrpyudZPvHhOn+mK5ayjS0pH9/fmSIWV26WwA7CHOGLMz/zOXySCQVH0JuUuc2ugS65CLEwPkL5znz/vs5OHSIc88vu0JGQhbDIy1ayNxC3y2oU4e42W41UNCKz8+QlHJn3gndQidzz9UFAaZ/P6KYuTwwJ3PBIUmNSGwobGe6sGluDKfndDkw+bwY50ayCEqTF0TyGj+/EHbSFfMZ2tyCyCwEdqtfhF2N/kS7lTwfkxdg6cK7TrOf9FypJyPR6Cw5NUupdOlGN/TY3aOz+zRSxB28jVPTnu78u/KOzLylJYkiRnG5l1MzDVo2FVXvXq25rVU3VzLLXKfaTya5TyXTY529orsD4sdFClA5bEnW/sqZQve6Q5el5bvNYk9l/RjYM8FBRKibmtdPvcb5C+e59bYjtHGSmnfisKioZWZSftOlGmnyB2buZp+J8X00b8CUn8eUjelMPXX63NMj7AaU5hfTtGuOOdCZ5IlWTaHBsg+EFA71kfXVdV5741W2tzcpqxXmF7tpsSZPxc63qbu9d6qb50VCIPlMQKqF5+KWzcJs0DLJdefj3dU0n9uRzgfkSJH7GN3rpbNFUbqprWx8L+l/H9PcbAoGSWKkzSY2abGdaWd1DW7relFcG6DYtdDN7U+n5ZmUfebJculKerMA21GKxdyuM55to7vnyYu5NXirUQsEqWhlgFqTTXlSAztSpEY9lstZ7XTBLuIoXY9s9YqkGYVuFmZ2N+U8zAKOOl0Dk7ljml/WU4nJ5u6DrjcVkemOPk3Xk+mks9cyXQPAPvnsctA4HUgkD1CqtRizMlsUJeCzJ3amcX+S5sYexR4KDkqk5a133uaFH7zIbXf8YZLkjkLTBFw2N5G8A0l2jzptEs7q2TOBMCPpzMxg+ac3mrGUy0IyL1Y2e87O3rIrXXS17qkDcD6/NBQ3l/2IIS41WN878y5PP/s91O/Omq7hOl0nU7JpRtAFy2l9eWox6dJ+fZrxXKdRTle+6uQc4u6vUVopMcnB4ZprnhbTZlbzppvEzU53dLX0kqCpO5CG5iIiLRqbGd20e9bp3EiX0XTZid91icxyUKHbPug0QGTdjXQusdttzws1zoqcNve9bL2Eszb3Cpp0hayYZmJdAzmSbFzBcNY1eecyPTNMUnCIJJZVUJeOtMuorElzEtOd92x0rzunWYFRZ2ox1uVwqZ80y/461tjsr3V9itkm55O9bwwIPm1wZi56EWctZi2WfcijOoI4gqRh1iLc2Hfnrwr2THBIUFZXt/jud5/jS1/+CocOrjAZTeiayJbrrpJF5dRSczTtiiDd+btvqyxAOsP0ixu9M5HcYN6dHUx/BuxeuRNFV5IGSGq4y3zjOr3pnRSMdiY89eQznDl9Nklz7DqXuTrxdfZfuy7PHDVRTOZ+OP+4rtMwu2QylxHNl61kVwYnqAlxmiFcW7GOeYeYhvWISdwvSadoXjzTgpi8FMJcP2G+GzJXostN8vlr/aMWmRQ05n8v31ddMLbuVdLZ35NZQI0yW8wVyxU6AfPpbCX5aqf1OGc+ljY3KqkBTmaPzf0VAiWSS0bp/LPeVZZmTLdHd7d3RZlZEe3a7GF2N8zICXTWrNe8JrPSkc3KdLsCwidfsgXBouy6j8Vc2k90RBJL945anJYFe/xk7KngoOJo2pbnnv0B3/rmk/yLf/5HSbiLBmLE50UzhkDh3XSiMtEaP7pAdg2+n/+t1u3Yr5+Gd2uyxt3fE8nZgkVU0xBbNEuS0ekRCJ4Xnn+eb/znb0LwuaQ2j1lv4Xq09B93LWaxarf7wI/HNY3L+WuA5Yb0/HFdezRpQZ3Vvme/mpRFA90Mxe5r6BL3yD66Idh9JWaltvkDtF09krmAZ9f+BfeRv2rXMWpKj02ZSyt+9+9nhlf3dWr6h+s+zyzzycHHDEeT5JKmv5syMxMlTM//+u1i+RHnn34o1/xeuM75//R7eAFckHyHzm+MNJ9vDsxmOGTamO+zho+HPdO37/aXTh2XL1/hL//ir3jhhZepKjerWSKEaDifapMW5278T/xsN/Ljx6Nj484fi8zTXTWJtMVoqOR6vShFUfHuu6f5y3//H3jnnfcwEwp/PZ2om+Htde0x/KTr9FMe88fqH13vNbmR12h39rL7ex/nsT/u+K45F/npd/U/LwjXuyLXXpv5zKXHx8EeCg5GDAGnjhACr7/2On/2//wZb731LssrFc572pCaptGSQJ96P9ds/WX5mJ3xtU1ki2HaS4lmaeJXHRZhUA24fPkqf/7nf8H3nnwKFU+MQvzJsahHjx6/gtgzwUEAp0oIbZLtDoGnvvck//f/9We89eZ7qHqqQYUvSpo2gnPJqesXfeCfGNfbNWeekGZ1ztjiXEq7YwTnSi5cuMSf//lf8Z/+9u/Z3hzjfUmSCvlFn0+PHj1+EdgzPQeVNDXZhobCl9T1hO3tHf7hH/4/tne2+dN/9a947PMP4ctBordGo21Dbpf98oWI6yFKVz9OH1U1oG5aTr31Ln/zH/8Tf/M3f8fmxjaD4SIijjYkPSGL4b/2qXv06PFLhj0THMwiMeRhI6AoSppmwsbmFv/4zW+xdnWNr3/9n/HFL36Bo0cPoYVgwYhtnTj6ZljMU8WZaSK/kGb0j4dAVr60XbIVSaLBgU//xwjr65s888z3+Y9//Xc898wLbG3tUBQVMSbN/uRtfLOdYY8ePX4e2DPBAZiu5DHErJzpEYy2iTzz7LOcPXuWH778Co8//nnuv/9ebjl+C6XzqCgqQsxBovM5uGnzCZFpIOumpc3SVHTd1lxdu8prb5zimae/z5Pfe4q33n6XGJSqGqTBraRohqrmAbAePXrsNeyh4NAJm+Xp2hgzb1xwXiDA6dNn+PDSZZ5++lnuv/9TfPqBT3Hytts5euQwBw8eoBoMUFF8oaikpvXNx+Kw6XGpCiFEtnd22NjY4PLVy5w5+x5vvfkWL7/yBufeP89oPMG7CpzLkg6CaOb09yJlPXrsWeyh4AC7p3xnNaEQjWhCUQ5oQ+Td02c4ffo9vvvd73H0yBEOHTzAysoKZVXhncN5nxRNg92MsYHO7B1LGkmjnR22trfY2Fjn/AfnuHJ5laIcoFIQo6fwZX5YN/wUZ7NO9l/HRe/Ro8cvJ/ZYcIDdC11eDPNsjnqPU0U00LYtWztjNt99j1NvvU1oQqJ/ShpwkjzQerNV5Luzi3kaVJ3DubTAqwhOhcFgCedKQkzD0iFIkiYiay6lv5CHJRx8QhOWHj16/PJjbwWH+SnQOWkJUcFJGobr9DVVXdKEL0pciFBZ8uhFkpWmgPs5COz9tKfZ9UYkexJYDBATnVdECW0aCPSlp2mT1MK0wZ4NbNLUayfx0KNHj70ED/MyADfnYvczx5zaJXPsI1UlWEwDcN0YfuftgKWGNJJoscz/jZsLkhoiM8YSZN2kbuhtTufUOvWcjw77dZIMN+dZ9ujR40YiZw7z6p55ceh2xb9KJQW5/jckn2sM6Ro4cblZPbcDJ7N4bDYrcHOyPC0bnXRBLJ8bSXI5hMy4Upd6C8Hy6aTgkNy4XBZPs6kqbY8ePfYW/EclF+Y//xUKDD8S1zoydEFx7uu5z+UmLSVd93zmZbrnVWem3sJMew3zOvxpQ/DLOB3eo0ePnxWu2RbelFvhHj169Ojxc0ZfM+jRo0ePHh9BHxx69OjRo8dH0AeHHj169OgB7O7AKsyalmRGTrTOorBvSfbo0aPHnkB2gY2ZhqlO0/BXdrxMwYEZN75Hjx49euwNmEWMpMjsq0GZjF8ylz/FCcPozLj7ANGjR48ev+rohma9OoqiQhcXl3BOiSGkoScRNJeXrKe29ujRo8eeQKcS4ZxjcXEJPXL0KFVV0YaWELOykCTpiD5r6NGjR4+9AVFBVEGFY8ePovfcfQ8rK/um82/JPQz0pp8E7tGjR48eP0uENlIWBffdex969923c+TIYbx3Waj0WpaS/YSPHj169Ojxy4PkDokoSHJ7FDEsBmKsWdm3xP3334sev+Ugjz3+MM4bZg0i4FxBjNk5TdprPgIQ8v9x9iHd533A6NGjR4+bFSaeSEkUn1fsiEiL2ZiyMD7z6Xu4567b8Pv3LfO7v/sb/P0//AMXLlxBxVJz2kA1+SZ/1CAnz85NbTdl9vXNKVXao0ePHj2AAIi4ZEFghlPBaDFrOHLoEL/3O7/JieNH8N4pn/70/fzu7/w2//4v/l8mdUMMkXIwJIYGVDsHmLk/r7uNc3b9rMsgevTo0aPHTQURFCPGgHOACTEGBKMsCh793Of48q/9Gl4l+TkcOriPP/mTr/PyK6d47rkXKMshXoxxDKjMK2zMf37toHU2i5E4cxHr0aNHjx43ERIT1Wky+rLYgLUgxh0nT/JH/+xr3H7bMdpoabX3KnzmgXv513/6L7njjtuI7YS6HuGcIyJENH/INV9/9KObre7Ro0ePHjcXDCPEGqdGjDUQsNiwsrzIH//x1/n1r3wRB7RtwBsQzFhcHPCHv/+brK+v8+/+j/+TDy5cwomCeq41kNkN2fW5mWLiftHXoEePHj32Nub92qaGZeDUaJoRjuQCue/QAb7+9a/x3/6L/4YD+xZS1qDgu45BNDh4YIk//Zdfp61r/vKv/ppTb7+L8wPUOUQdgiRRJotZbqNrTNuM2Sq5H/GrZC/ao0ePHr9ksGQFOXWvtBhBDO9gNBkhTrn11lv52tf+gH/7b/+UE7ccJFiacRPnkGjBLMvxGUmD7/Kldb7x99/iP/z1f+alV15nfX0dXxQURUGMlvoQuxrS+YGxE/DrA0OPHj16/CJhQIwR1dQTDqEBiwgjisJ44IEH+Od/8sf84dd+j1uPHyZEcDrrLEu01mI0VB1mgln6he3thhdffZO/+8Y3+e53v8f5c+cYjUc0TUtZlMmf2GzGXBVFxTHVfe3Ro0ePHr8wmHUdYKNtW0SUleVFjh9f5vHHPssf/MHv88QTj7O0UBEtKbJ61enWXswaCxZRNJeJJGUBJELqxStb/PClV3ju+y9w6o03OHfuPKura2xubtI2LW2IxJj1v0VzBtIHhx49evT4RUIEqqpieXmZffv2ceLW27jnnjt49OH7+OITj3Li+FEAmmA4gWgRr246vyZmbXJwMENN8lyDYiagU4Iqq2vbnP/gAmfeP8e5s+e4dPkKbdMQQiTEmOpZCEgfGnr06NHjF4XOqk1VqaqKw4cPc/Lkbdx+++0cO3qQ/fuXKZzMZRakPjKpgtT1DMSssWgR7aLAdKgtZRGNgajhM001ArE1mtD5Pcy1wbun6pmsPXr06PELRWfa45yjcLtVLqIli4Zkz5B6E84pMjfX9v8DK6QsxMyjUxIAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjItMTItMTNUMTQ6MzQ6MTUrMDA6MDDOXI/WAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIyLTEyLTEzVDE0OjM0OjE1KzAwOjAwvwE3agAAAABJRU5ErkJggg=="/>\n  </svg>',
  wpLogo: '<svg width="89" height="55" viewBox="0 20 150 100">\n  <image id="D_o_c_x" data-name="D o c x" y="20" width="150" height="100" xlink:href="data:img/png;base64,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"/>\n  </svg>',
  es: '<svg width="199.881" height="196.247" viewBox="0 0 1485 1458">\n  <image width="1485" height="1458" xlink:href="data:img/png;base64,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"/>\n  </svg>',
  fr: '<svg width="199.813" height="197.231" viewBox="0 0 2476 2444">\n  <image width="2476" height="2444" xlink:href="data:img/png;base64,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"/>\n  </svg>',
  en: '<svg width="199.217" height="199.872" viewBox="0 0 10946 10982">\n  <image width="10946" height="10982" xlink:href="data:img/png;base64,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"/>\n  </svg>',
  upload: '<svg viewBox="0 0 26 28" height="35" width="35" fill="#ffffff">\n  <path d="M20 23c0-0.547-0.453-1-1-1s-1 0.453-1 1 0.453 1 1 1 1-0.453 1-1zM24 23c0-0.547-0.453-1-1-1s-1 0.453-1 1 0.453 1 1 1 1-0.453 1-1zM26 19.5v5c0 0.828-0.672 1.5-1.5 1.5h-23c-0.828 0-1.5-0.672-1.5-1.5v-5c0-0.828 0.672-1.5 1.5-1.5h6.672c0.422 1.156 1.531 2 2.828 2h4c1.297 0 2.406-0.844 2.828-2h6.672c0.828 0 1.5 0.672 1.5 1.5zM20.922 9.375c-0.156 0.375-0.516 0.625-0.922 0.625h-4v7c0 0.547-0.453 1-1 1h-4c-0.547 0-1-0.453-1-1v-7h-4c-0.406 0-0.766-0.25-0.922-0.625-0.156-0.359-0.078-0.797 0.219-1.078l7-7c0.187-0.203 0.453-0.297 0.703-0.297s0.516 0.094 0.703 0.297l7 7c0.297 0.281 0.375 0.719 0.219 1.078z"></path>\n  </svg>',
  clone: '<svg fill="#ffffff" height="15" width="15" viewBox="0 0 28 28">\n  <path d="M26 25.5v-17c0-0.266-0.234-0.5-0.5-0.5h-17c-0.266 0-0.5 0.234-0.5 0.5v17c0 0.266 0.234 0.5 0.5 0.5h17c0.266 0 0.5-0.234 0.5-0.5zM28 8.5v17c0 1.375-1.125 2.5-2.5 2.5h-17c-1.375 0-2.5-1.125-2.5-2.5v-17c0-1.375 1.125-2.5 2.5-2.5h17c1.375 0 2.5 1.125 2.5 2.5zM22 2.5v2.5h-2v-2.5c0-0.266-0.234-0.5-0.5-0.5h-17c-0.266 0-0.5 0.234-0.5 0.5v17c0 0.266 0.234 0.5 0.5 0.5h2.5v2h-2.5c-1.375 0-2.5-1.125-2.5-2.5v-17c0-1.375 1.125-2.5 2.5-2.5h17c1.375 0 2.5 1.125 2.5 2.5z"></path>\n  </svg>',
  broom: '<svg height="15" width="15" fill="#0e2547" viewBox="0 0 640 512"><path d="M256.47 216.77l86.73 109.18s-16.6 102.36-76.57 150.12C206.66 523.85 0 510.19 0 510.19s3.8-23.14 11-55.43l94.62-112.17c3.97-4.7-.87-11.62-6.65-9.5l-60.4 22.09c14.44-41.66 32.72-80.04 54.6-97.47 59.97-47.76 163.3-40.94 163.3-40.94zM636.53 31.03l-19.86-25c-5.49-6.9-15.52-8.05-22.41-2.56l-232.48 177.8-34.14-42.97c-5.09-6.41-15.14-5.21-18.59 2.21l-25.33 54.55 86.73 109.18 58.8-12.45c8-1.69 11.42-11.2 6.34-17.6l-34.09-42.92 232.48-177.8c6.89-5.48 8.04-15.53 2.55-22.44z"></path></svg>',
  ddAccounts: '<svg viewBox="0 0 32 32">\n                <path d="M16 0c-8.837 0-16 2.239-16 5v4c0 2.761 7.163 5 16 5s16-2.239 16-5v-4c0-2.761-7.163-5-16-5z"></path>\n                <path d="M16 17c-8.837 0-16-2.239-16-5v6c0 2.761 7.163 5 16 5s16-2.239 16-5v-6c0 2.761-7.163 5-16 5z"></path>\n                <path d="M16 26c-8.837 0-16-2.239-16-5v6c0 2.761 7.163 5 16 5s16-2.239 16-5v-6c0 2.761-7.163 5-16 5z"></path>\n               </svg>',
  eye: '<svg height="20" fill="#666" width="20" viewBox="0 0 28 28">\n  <path d="M26 15c-1.484-2.297-3.516-4.266-5.953-5.516 0.625 1.062 0.953 2.281 0.953 3.516 0 3.859-3.141 7-7 7s-7-3.141-7-7c0-1.234 0.328-2.453 0.953-3.516-2.438 1.25-4.469 3.219-5.953 5.516 2.672 4.125 6.984 7 12 7s9.328-2.875 12-7zM14.75 9c0-0.406-0.344-0.75-0.75-0.75-2.609 0-4.75 2.141-4.75 4.75 0 0.406 0.344 0.75 0.75 0.75s0.75-0.344 0.75-0.75c0-1.781 1.469-3.25 3.25-3.25 0.406 0 0.75-0.344 0.75-0.75zM28 15c0 0.391-0.125 0.75-0.313 1.078-2.875 4.734-8.141 7.922-13.687 7.922s-10.813-3.203-13.687-7.922c-0.187-0.328-0.313-0.688-0.313-1.078s0.125-0.75 0.313-1.078c2.875-4.719 8.141-7.922 13.687-7.922s10.813 3.203 13.687 7.922c0.187 0.328 0.313 0.688 0.313 1.078z"></path>\n  </svg>',
  eyeSlash: '<svg height="20" fill="#666" width="20" viewBox="0 0 28 28">\n  <path d="M8.672 20.859l1.219-2.203c-1.813-1.313-2.891-3.422-2.891-5.656 0-1.234 0.328-2.453 0.953-3.516-2.438 1.25-4.469 3.219-5.953 5.516 1.625 2.516 3.922 4.625 6.672 5.859zM14.75 9c0-0.406-0.344-0.75-0.75-0.75-2.609 0-4.75 2.141-4.75 4.75 0 0.406 0.344 0.75 0.75 0.75s0.75-0.344 0.75-0.75c0-1.797 1.469-3.25 3.25-3.25 0.406 0 0.75-0.344 0.75-0.75zM20.422 6.016c0 0.031 0 0.109-0.016 0.141-3.297 5.891-6.563 11.813-9.859 17.703l-0.766 1.391c-0.094 0.156-0.266 0.25-0.438 0.25-0.281 0-1.766-0.906-2.094-1.094-0.156-0.094-0.25-0.25-0.25-0.438 0-0.25 0.531-1.094 0.688-1.359-3.031-1.375-5.578-3.719-7.375-6.531-0.203-0.313-0.313-0.688-0.313-1.078 0-0.375 0.109-0.766 0.313-1.078 3.094-4.75 7.922-7.922 13.687-7.922 0.938 0 1.891 0.094 2.812 0.266l0.844-1.516c0.094-0.156 0.25-0.25 0.438-0.25 0.281 0 1.75 0.906 2.078 1.094 0.156 0.094 0.25 0.25 0.25 0.422zM21 13c0 2.906-1.797 5.5-4.5 6.531l4.375-7.844c0.078 0.438 0.125 0.875 0.125 1.313zM28 15c0 0.406-0.109 0.734-0.313 1.078-0.484 0.797-1.094 1.563-1.703 2.266-3.063 3.516-7.281 5.656-11.984 5.656l1.156-2.063c4.547-0.391 8.406-3.156 10.844-6.937-1.156-1.797-2.641-3.375-4.406-4.594l0.984-1.75c1.937 1.297 3.891 3.25 5.109 5.266 0.203 0.344 0.313 0.672 0.313 1.078z"></path>\n  </svg>',
  history: '<svg viewBox="0 0 24 28">\n  <path d="M24 14c0 6.609-5.391 12-12 12-3.578 0-6.953-1.578-9.234-4.328-0.156-0.203-0.141-0.5 0.031-0.672l2.141-2.156c0.109-0.094 0.25-0.141 0.391-0.141 0.141 0.016 0.281 0.078 0.359 0.187 1.531 1.984 3.828 3.109 6.312 3.109 4.406 0 8-3.594 8-8s-3.594-8-8-8c-2.047 0-3.984 0.781-5.437 2.141l2.141 2.156c0.297 0.281 0.375 0.719 0.219 1.078-0.156 0.375-0.516 0.625-0.922 0.625h-7c-0.547 0-1-0.453-1-1v-7c0-0.406 0.25-0.766 0.625-0.922 0.359-0.156 0.797-0.078 1.078 0.219l2.031 2.016c2.203-2.078 5.187-3.313 8.266-3.313 6.609 0 12 5.391 12 12zM14 9.5v7c0 0.281-0.219 0.5-0.5 0.5h-5c-0.281 0-0.5-0.219-0.5-0.5v-1c0-0.281 0.219-0.5 0.5-0.5h3.5v-5.5c0-0.281 0.219-0.5 0.5-0.5h1c0.281 0 0.5 0.219 0.5 0.5z"></path>\n  </svg>',
  notFound: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 730 397">\n  <image id="Vector_Smart_Object" data-name="Vector Smart Object" width="730" height="397" xlink:href="data:img/png;base64,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"/>\n  <text id="Oops_You_re_lost." data-name="Oops! You&apos;re lost." class="cls-1" transform="translate(141.283 124.263) scale(3.454)" fill="#666">Oops! You&apos;re lost.</text>\n  <text id="The_page_you_are_looking_for_was_not_found." data-name="The page you are looking for was not found." class="cls-2" transform="translate(204.453 149.898) scale(1)" fill="#666">The page you are looking for was not found.</text>\n</svg>',
  ddModels: '<svg height="40" viewBox="-25 0 511 511.99975" width="40"><path fill="black" d="m443.378906 212.929688c4.6875-7.484376 10.765625-22.558594 8.507813-48.679688-1.800781-20.847656-10.40625-33.328125-17.304688-40.128906-4.578125-4.503906-9.035156-7.207032-12.042969-8.703125-2.480468-6.65625-8.964843-22.261719-20.125-37.261719-18.382812-24.707031-41.148437-36.582031-66.148437-34.628906-2.058594-4.683594-5.574219-11.578125-10.835937-18.480469-12.480469-16.386719-28.78125-25.046875-47.136719-25.046875-15.921875 0-29.335938 6.921875-38.792969 20.023438-3.378906 4.679687-6.222656 10.136718-8.542969 16.316406-12.050781-31.976563-35.484375-36.339844-47.324219-36.339844-18.359374 0-34.660156 8.660156-47.140624 25.046875-5.253907 6.898437-8.769532 13.792969-10.832032 18.472656-19.097656-1.527343-36.671875 4.921875-52.335937 19.210938-3.066407 2.800781-3.28125 7.554687-.484375 10.625 2.796875 3.066406 7.554687 3.285156 10.621094.484375 13.734374-12.53125 29.152343-17.492188 45.832031-14.734375 3.6875.609375 7.246093-1.570313 8.386719-5.121094.121093-.390625 12.878906-38.949219 45.953124-38.949219 25.015626 0 39.15625 24.195313 39.8125 68.128906v343.703126c-.003906.390624-.507812 39.210937-21.128906 58.933593-8.328125 7.964844-18.625 11.601563-31.480468 11.121094-28.113282-1.058594-34.207032-11.96875-41.261719-24.597656-4.132813-7.394531-8.816407-15.773438-17.890625-21.769531-7.03125-4.640626-16.214844-7.351563-25.9375-10.222657-23.355469-6.898437-49.824219-14.714843-59.292969-51.363281-5.796875-22.445312-1.480469-40.773438 2.007813-50.453125 6.042968 4.035156 14.3125 9.378906 19.34375 11.894531 3.667968 1.832032 8.253906.300782 10.085937-3.363281 1.859375-3.714844.351563-8.230469-3.359375-10.085937-5.925781-2.960938-18.820312-11.632813-24.226562-15.367188-4.695313-5.714844-13.175782-22.480469-14.636719-49.3125-1.3125-24.074219 7.636719-40.429688 13.324219-48.277344 5.132812 4.335938 13.078124 10.386719 22.074218 14.882813 3.667969 1.832031 8.253906.300781 10.085938-3.363281 1.859375-3.714844.351562-8.230469-3.363282-10.085938-11.597656-5.800781-21.578124-15.007812-23.773437-17.101562-.210937-.234376-.4375-.460938-.691406-.671876-3.84375-3.851562-10.433594-17.484374-8.300781-42.121093 1.46875-17.015625 8.273437-26.648438 14.050781-31.859375 1.792969 7.238281 5.820312 16.734375 14.617187 27.179687 2.636719 3.132813 7.457032 3.546875 10.59375.910157 3.175782-2.675782 3.582032-7.417969.90625-10.59375-12.3125-14.621094-12.535156-26.015626-12.402344-28.59375 1.027344-2.949219 5.289063-14.511719 13.039063-26.988282 2.1875-3.527344 1.105469-8.164062-2.421875-10.351562-3.53125-2.191406-8.164062-1.109375-10.355469 2.421875-7.261719 11.699219-11.710937 22.519531-13.667969 27.757812-8.058593 4.015625-26.5625 16.644531-29.34375 48.824219-2.257812 26.121094 3.820313 41.195312 8.503907 48.675781-7.039063 9.003907-19.558594 29.539063-17.890625 60.171875 1.625 29.851563 10.773437 47.40625 15.796875 54.925782-4.34375 9.707031-12.535157 33.808593-4.554688 64.703124 11.597657 44.898438 45.121094 54.800782 69.59375 62.027344 8.617188 2.542969 16.753907 4.945313 21.90625 8.351563 6.023438 3.976562 9.28125 9.804687 13.050781 16.554687 7.695313 13.769532 17.269532 30.910156 53.824219 32.289063 12.164063.457031 24.359375-2.25 34.59375-9.003907 2.800781-1.847656 5.421875-3.960937 7.847657-6.277343 8.675781-8.300781 14.433593-18.945313 18.25-29.402344 3.820312 10.457031 9.578124 21.101563 18.253906 29.402344 8.597656 8.222656 19.546875 13.332031 31.335937 14.820312 3.679688.464844 7.398438.597657 11.105469.457031 36.554688-1.375 46.128906-18.515624 53.820312-32.285156 3.773438-6.75 7.03125-12.578125 13.054688-16.554687 5.15625-3.40625 13.289062-5.808594 21.90625-8.351563 11.109375-3.28125 23.703125-7 35.414062-14.132812 3.546876-2.160156 4.667969-6.785156 2.507813-10.332032-2.15625-3.546874-6.785156-4.671874-10.332031-2.511718-10.03125 6.109375-21.121094 9.386718-31.847656 12.554687-4.972657 1.46875-9.800782 2.898438-14.273438 4.5625v-26.898437c11.046875-3.253906 19.136719-13.480469 19.136719-25.566406 0-14.699219-11.957031-26.65625-26.65625-26.65625s-26.65625 11.957031-26.65625 26.65625c0 12.085937 8.089843 22.3125 19.136719 25.566406v35.058594c-6.925782 5.695312-10.929688 12.855468-14.515626 19.269531-6.347656 11.363281-11.925781 21.328125-33.457031 23.984375v-39.480469c0-4.152344-3.367187-7.515625-7.519531-7.515625s-7.519531 3.363281-7.519531 7.515625v39.898437c-9.550781-.910156-17.511719-4.5-24.207031-10.890624-20.5-19.5625-21.160157-58.308594-21.164063-58.972657v-17.253906h33.742187c4.152344 0 7.519532-3.367187 7.519532-7.519531s-3.367188-7.519532-7.519532-7.519532h-33.742187v-50.195312h35.574219l29.121094 22.253906c3.257812 2.488282 8.050781 1.84375 10.539062-1.410156 2.519531-3.300781 1.890625-8.019531-1.410156-10.539062l-31.140625-23.796876c-1.3125-1-2.917969-1.542968-4.566407-1.542968h-38.117187v-49.132813h22.378906c3.253907 11.046875 13.480469 19.136719 25.566407 19.136719 14.699218 0 26.65625-11.957031 26.65625-26.65625s-11.957032-26.65625-26.65625-26.65625c-12.085938 0-22.3125 8.089844-25.566407 19.136719h-22.378906v-49.128907h38.117187c1.648438 0 3.253907-.542968 4.566407-1.546874l31.140625-23.796876c3.300781-2.519531 3.929687-7.238281 1.410156-10.539062-2.519531-3.296875-7.238281-3.929688-10.539062-1.40625l-29.121094 22.25h-35.574219v-58.667969h33.742187c4.152344 0 7.519532-3.367187 7.519532-7.519531 0-4.148438-3.367188-7.515625-7.519532-7.515625h-33.742187v-44.117187c.648437-43.941407 14.785156-68.144532 39.808594-68.144532 30.292969 0 43.328125 31.691406 45.597656 37.921875v36.011719c-11.050781 3.253906-19.136719 13.484375-19.136719 25.570312 0 14.699219 11.957032 26.65625 26.652344 26.65625 14.699219 0 26.65625-11.957031 26.65625-26.65625 0-12.085937-8.089844-22.3125-19.136719-25.570312v-30.539062c19.148438-.960938 36.347657 8.574218 51.214844 28.417968 7.136719 9.53125 12.21875 19.53125 15.359375 26.648438h-16.652344c-4.152344 0-7.519531 3.363281-7.519531 7.515625 0 4.152343 3.367187 7.519531 7.519531 7.519531h26.296875c3.925781 1.722656 19.441407 10.183594 21.761719 37.011719 1.855469 21.492187-2.917969 34.605469-6.71875 40.164062h-32.128906c-2.941406-11.523437-13.40625-20.074219-25.832032-20.074219-14.699218 0-26.65625 11.957032-26.65625 26.65625 0 14.699219 11.957032 26.65625 26.65625 26.65625 11.742188 0 21.730469-7.636718 25.273438-18.203124h32.871094c4.445312 5.261718 15.269531 20.488281 15.96875 44.429687h-54.976563c-4.15625 0-7.519531 3.367187-7.519531 7.515625 0 4.152344 3.363281 7.519531 7.519531 7.519531h54.234375c-2.246094 19.953125-8.328125 33.304688-12.570312 39.503907h-51.578125c-4.152344 0-7.515625 3.367187-7.515625 7.519531 0 4.152343 3.363281 7.519531 7.515625 7.519531h50.53125c3.453125 8.039062 10.152343 28.414062 3.488281 54.21875-1.976562 7.65625-4.8125 14.464844-8.429688 20.234375-2.203124 3.519531-1.136718 8.160156 2.382813 10.363281 3.476563 2.175782 8.1875 1.089844 10.363281-2.378906 4.433594-7.078125 7.878906-15.308594 10.246094-24.457031 7.976562-30.898438-.210938-54.996094-4.554688-64.707031 5.023438-7.515626 14.171876-25.074219 15.796876-54.925782 1.667968-30.628906-10.851563-51.167968-17.894532-60.167968zm-100.609375 179.5c0-6.40625 5.210938-11.617188 11.617188-11.617188s11.617187 5.210938 11.617187 11.617188-5.210937 11.621093-11.617187 11.621093-11.617188-5.214843-11.617188-11.621093zm-56.34375-131.359376c6.40625 0 11.621094 5.210938 11.621094 11.617188 0 6.410156-5.214844 11.621094-11.621094 11.621094s-11.617187-5.210938-11.617187-11.621094c0-6.40625 5.210937-11.617188 11.617187-11.617188zm56.601563-146.53125c0 6.40625-5.214844 11.617188-11.621094 11.617188s-11.617188-5.210938-11.617188-11.617188 5.210938-11.621093 11.617188-11.621093 11.621094 5.214843 11.621094 11.621093zm29.199218 109.367188c-6.40625 0-11.617187-5.210938-11.617187-11.617188s5.210937-11.617187 11.617187-11.617187 11.617188 5.210937 11.617188 11.617187-5.210938 11.617188-11.617188 11.617188zm0 0"/><path fill="black" d="m341.28125 265.171875c-4.152344 0-7.515625 3.367187-7.515625 7.515625 0 4.152344 3.363281 7.519531 7.515625 7.519531h20.007812c4.15625 0 7.519532-3.367187 7.519532-7.519531 0-4.148438-3.363282-7.515625-7.519532-7.515625zm0 0"/><path fill="black" d="m86.296875 397.664062c-4.105469-.664062-7.957031 2.121094-8.621094 6.222657-.664062 4.097656 2.121094 7.957031 6.222657 8.621093.125.019532 12.835937 2.125 25.863281 8.265626 16.183593 7.628906 24.933593 17.527343 26.015625 29.425781.355468 3.90625 3.632812 6.839843 7.480468 6.839843.226563 0 .457032-.011718.6875-.03125 4.136719-.378906 7.183594-4.035156 6.808594-8.167968-3.71875-40.886719-61.976562-50.773438-64.457031-51.175782zm0 0"/><path fill="black" d="m180.804688 369.902344c-3.855469-1.542969-8.230469.328125-9.777344 4.179687-.457032 1.132813-10.925782 28.113281 7.933594 57.300781 2.222656 3.441407 6.953124 4.460938 10.394531 2.234376 3.488281-2.253907 4.488281-6.90625 2.234375-10.394532-14.464844-22.390625-6.957032-42.628906-6.59375-43.578125 1.519531-3.84375-.347656-8.199219-4.191406-9.742187zm0 0"/><path fill="black" d="m182.527344 120.949219c-3.21875 2.625-3.703125 7.359375-1.078125 10.578125.273437.335937 27.082031 34.230468 6.0625 95.398437-1.351563 3.929688.738281 8.207031 4.664062 9.554688 3.878907 1.335937 8.222657-.792969 9.554688-4.667969 23.707031-68.988281-7.296875-108.152344-8.625-109.785156-2.625-3.21875-7.359375-3.703125-10.578125-1.078125zm0 0"/><path fill="black" d="m215.457031 273.078125c-1.628906-3.820313-6.039062-5.597656-9.863281-3.972656-13.054688 5.550781-24.800781 4.992187-34.914062-1.667969-7.898438-5.199219-12.03125-12.335938-12.132813-12.507812-2.019531-3.613282-6.578125-4.917969-10.203125-2.910157-3.632812 2.007813-4.949219 6.585938-2.9375 10.21875.226562.40625 5.636719 10.050781 16.390625 17.351563 6.363281 4.316406 15.375 8.351562 26.835937 8.351562 6.773438 0 14.40625-1.410156 22.847657-5 3.820312-1.628906 5.601562-6.042968 3.976562-9.863281zm0 0"/><path fill="black" d="m56.074219 277.402344c-1.664063 3.800781.066406 8.234375 3.863281 9.902344.160156.070312 16.003906 7.117187 29.890625 20.394531 4.382813 4.191406 8.074219 8.503906 11.070313 12.921875.125.207031.257812.410156.402343.609375 8.734375 13.179687 11.320313 27.324219 7.671875 42.230469-.988281 4.03125 1.484375 8.101562 5.515625 9.089843 3.980469.972657 8.117188-1.535156 9.089844-5.515625 2.839844-11.609375 2.683594-22.980468-.367187-33.875 8.039062 2.78125 15.40625 3.804688 21.902343 3.804688 17.480469 0 28.621094-7.414063 29.375-7.933594 3.425781-2.347656 4.320313-7.046875 1.972657-10.46875-2.347657-3.425781-7-4.3125-10.425782-1.964844-.921875.609375-22.625 14.476563-53.332031-5.316406-3.554687-5.09375-7.820313-10.027344-12.808594-14.757812-15.808593-14.992188-33.199219-22.675782-33.933593-22.996094-3.796876-1.660156-8.222657.074218-9.886719 3.875zm0 0"/><path fill="black" d="m75.164062 201.160156c-2.40625 3.375-1.617187 8.066406 1.746094 10.480469.296875.210937 29.511719 21.585937 29.910156 57.949219.046876 4.121094 3.402344 7.433594 7.515626 7.433594h.085937c4.152344-.042969 7.480469-3.449219 7.433594-7.597657-.484375-44.195312-34.769531-69.007812-36.230469-70.039062-3.378906-2.398438-8.054688-1.601563-10.460938 1.773437zm0 0"/><path fill="black" d="m117.636719 89.113281c-3.472657-2.277343-8.132813-1.304687-10.410157 2.167969-1.113281 1.699219-27.117187 42.144531-12.195312 85.398438 1.335938 3.871093 5.683594 5.988281 9.5625 4.652343 3.921875-1.351562 6.007812-5.632812 4.652344-9.558593-2.5625-7.429688-3.621094-14.835938-3.707032-21.925782 18.085938 33.6875 50.632813 45.179688 52.34375 45.761719 3.871094 1.320313 8.195313-.8125 9.523438-4.675781 1.347656-3.917969-.738281-8.191406-4.65625-9.550782-1.769531-.613281-42.894531-15.390624-52.167969-61.710937 4.054688-12.039063 9.082031-19.941406 9.226563-20.160156 2.269531-3.472657 1.296875-8.125-2.171875-10.398438zm0 0"/><path fill="black" d="m150.890625 88.046875c-4.0625.867187-6.65625 4.859375-5.789063 8.921875.753907 3.53125 3.871094 5.953125 7.34375 5.953125.519532 0 1.046876-.054687 1.574219-.167969 27.300781-5.8125 39.703125-21.6875 45.296875-33.980468 6.03125-13.261719 5.523438-25.234376 5.496094-25.738282-.203125-4.132812-3.691406-7.304687-7.839844-7.121094-4.132812.179688-7.34375 3.6875-7.179687 7.824219.054687 1.457031.941406 35.828125-38.902344 44.308594zm0 0"/></svg>',
  Models: '<svg height="511pt" viewBox="-25 0 511 511.99975" width="511pt" xmlns="http://www.w3.org/2000/svg"><path fill="rgb(131, 146, 161)" d="m443.378906 212.929688c4.6875-7.484376 10.765625-22.558594 8.507813-48.679688-1.800781-20.847656-10.40625-33.328125-17.304688-40.128906-4.578125-4.503906-9.035156-7.207032-12.042969-8.703125-2.480468-6.65625-8.964843-22.261719-20.125-37.261719-18.382812-24.707031-41.148437-36.582031-66.148437-34.628906-2.058594-4.683594-5.574219-11.578125-10.835937-18.480469-12.480469-16.386719-28.78125-25.046875-47.136719-25.046875-15.921875 0-29.335938 6.921875-38.792969 20.023438-3.378906 4.679687-6.222656 10.136718-8.542969 16.316406-12.050781-31.976563-35.484375-36.339844-47.324219-36.339844-18.359374 0-34.660156 8.660156-47.140624 25.046875-5.253907 6.898437-8.769532 13.792969-10.832032 18.472656-19.097656-1.527343-36.671875 4.921875-52.335937 19.210938-3.066407 2.800781-3.28125 7.554687-.484375 10.625 2.796875 3.066406 7.554687 3.285156 10.621094.484375 13.734374-12.53125 29.152343-17.492188 45.832031-14.734375 3.6875.609375 7.246093-1.570313 8.386719-5.121094.121093-.390625 12.878906-38.949219 45.953124-38.949219 25.015626 0 39.15625 24.195313 39.8125 68.128906v343.703126c-.003906.390624-.507812 39.210937-21.128906 58.933593-8.328125 7.964844-18.625 11.601563-31.480468 11.121094-28.113282-1.058594-34.207032-11.96875-41.261719-24.597656-4.132813-7.394531-8.816407-15.773438-17.890625-21.769531-7.03125-4.640626-16.214844-7.351563-25.9375-10.222657-23.355469-6.898437-49.824219-14.714843-59.292969-51.363281-5.796875-22.445312-1.480469-40.773438 2.007813-50.453125 6.042968 4.035156 14.3125 9.378906 19.34375 11.894531 3.667968 1.832032 8.253906.300782 10.085937-3.363281 1.859375-3.714844.351563-8.230469-3.359375-10.085937-5.925781-2.960938-18.820312-11.632813-24.226562-15.367188-4.695313-5.714844-13.175782-22.480469-14.636719-49.3125-1.3125-24.074219 7.636719-40.429688 13.324219-48.277344 5.132812 4.335938 13.078124 10.386719 22.074218 14.882813 3.667969 1.832031 8.253906.300781 10.085938-3.363281 1.859375-3.714844.351562-8.230469-3.363282-10.085938-11.597656-5.800781-21.578124-15.007812-23.773437-17.101562-.210937-.234376-.4375-.460938-.691406-.671876-3.84375-3.851562-10.433594-17.484374-8.300781-42.121093 1.46875-17.015625 8.273437-26.648438 14.050781-31.859375 1.792969 7.238281 5.820312 16.734375 14.617187 27.179687 2.636719 3.132813 7.457032 3.546875 10.59375.910157 3.175782-2.675782 3.582032-7.417969.90625-10.59375-12.3125-14.621094-12.535156-26.015626-12.402344-28.59375 1.027344-2.949219 5.289063-14.511719 13.039063-26.988282 2.1875-3.527344 1.105469-8.164062-2.421875-10.351562-3.53125-2.191406-8.164062-1.109375-10.355469 2.421875-7.261719 11.699219-11.710937 22.519531-13.667969 27.757812-8.058593 4.015625-26.5625 16.644531-29.34375 48.824219-2.257812 26.121094 3.820313 41.195312 8.503907 48.675781-7.039063 9.003907-19.558594 29.539063-17.890625 60.171875 1.625 29.851563 10.773437 47.40625 15.796875 54.925782-4.34375 9.707031-12.535157 33.808593-4.554688 64.703124 11.597657 44.898438 45.121094 54.800782 69.59375 62.027344 8.617188 2.542969 16.753907 4.945313 21.90625 8.351563 6.023438 3.976562 9.28125 9.804687 13.050781 16.554687 7.695313 13.769532 17.269532 30.910156 53.824219 32.289063 12.164063.457031 24.359375-2.25 34.59375-9.003907 2.800781-1.847656 5.421875-3.960937 7.847657-6.277343 8.675781-8.300781 14.433593-18.945313 18.25-29.402344 3.820312 10.457031 9.578124 21.101563 18.253906 29.402344 8.597656 8.222656 19.546875 13.332031 31.335937 14.820312 3.679688.464844 7.398438.597657 11.105469.457031 36.554688-1.375 46.128906-18.515624 53.820312-32.285156 3.773438-6.75 7.03125-12.578125 13.054688-16.554687 5.15625-3.40625 13.289062-5.808594 21.90625-8.351563 11.109375-3.28125 23.703125-7 35.414062-14.132812 3.546876-2.160156 4.667969-6.785156 2.507813-10.332032-2.15625-3.546874-6.785156-4.671874-10.332031-2.511718-10.03125 6.109375-21.121094 9.386718-31.847656 12.554687-4.972657 1.46875-9.800782 2.898438-14.273438 4.5625v-26.898437c11.046875-3.253906 19.136719-13.480469 19.136719-25.566406 0-14.699219-11.957031-26.65625-26.65625-26.65625s-26.65625 11.957031-26.65625 26.65625c0 12.085937 8.089843 22.3125 19.136719 25.566406v35.058594c-6.925782 5.695312-10.929688 12.855468-14.515626 19.269531-6.347656 11.363281-11.925781 21.328125-33.457031 23.984375v-39.480469c0-4.152344-3.367187-7.515625-7.519531-7.515625s-7.519531 3.363281-7.519531 7.515625v39.898437c-9.550781-.910156-17.511719-4.5-24.207031-10.890624-20.5-19.5625-21.160157-58.308594-21.164063-58.972657v-17.253906h33.742187c4.152344 0 7.519532-3.367187 7.519532-7.519531s-3.367188-7.519532-7.519532-7.519532h-33.742187v-50.195312h35.574219l29.121094 22.253906c3.257812 2.488282 8.050781 1.84375 10.539062-1.410156 2.519531-3.300781 1.890625-8.019531-1.410156-10.539062l-31.140625-23.796876c-1.3125-1-2.917969-1.542968-4.566407-1.542968h-38.117187v-49.132813h22.378906c3.253907 11.046875 13.480469 19.136719 25.566407 19.136719 14.699218 0 26.65625-11.957031 26.65625-26.65625s-11.957032-26.65625-26.65625-26.65625c-12.085938 0-22.3125 8.089844-25.566407 19.136719h-22.378906v-49.128907h38.117187c1.648438 0 3.253907-.542968 4.566407-1.546874l31.140625-23.796876c3.300781-2.519531 3.929687-7.238281 1.410156-10.539062-2.519531-3.296875-7.238281-3.929688-10.539062-1.40625l-29.121094 22.25h-35.574219v-58.667969h33.742187c4.152344 0 7.519532-3.367187 7.519532-7.519531 0-4.148438-3.367188-7.515625-7.519532-7.515625h-33.742187v-44.117187c.648437-43.941407 14.785156-68.144532 39.808594-68.144532 30.292969 0 43.328125 31.691406 45.597656 37.921875v36.011719c-11.050781 3.253906-19.136719 13.484375-19.136719 25.570312 0 14.699219 11.957032 26.65625 26.652344 26.65625 14.699219 0 26.65625-11.957031 26.65625-26.65625 0-12.085937-8.089844-22.3125-19.136719-25.570312v-30.539062c19.148438-.960938 36.347657 8.574218 51.214844 28.417968 7.136719 9.53125 12.21875 19.53125 15.359375 26.648438h-16.652344c-4.152344 0-7.519531 3.363281-7.519531 7.515625 0 4.152343 3.367187 7.519531 7.519531 7.519531h26.296875c3.925781 1.722656 19.441407 10.183594 21.761719 37.011719 1.855469 21.492187-2.917969 34.605469-6.71875 40.164062h-32.128906c-2.941406-11.523437-13.40625-20.074219-25.832032-20.074219-14.699218 0-26.65625 11.957032-26.65625 26.65625 0 14.699219 11.957032 26.65625 26.65625 26.65625 11.742188 0 21.730469-7.636718 25.273438-18.203124h32.871094c4.445312 5.261718 15.269531 20.488281 15.96875 44.429687h-54.976563c-4.15625 0-7.519531 3.367187-7.519531 7.515625 0 4.152344 3.363281 7.519531 7.519531 7.519531h54.234375c-2.246094 19.953125-8.328125 33.304688-12.570312 39.503907h-51.578125c-4.152344 0-7.515625 3.367187-7.515625 7.519531 0 4.152343 3.363281 7.519531 7.515625 7.519531h50.53125c3.453125 8.039062 10.152343 28.414062 3.488281 54.21875-1.976562 7.65625-4.8125 14.464844-8.429688 20.234375-2.203124 3.519531-1.136718 8.160156 2.382813 10.363281 3.476563 2.175782 8.1875 1.089844 10.363281-2.378906 4.433594-7.078125 7.878906-15.308594 10.246094-24.457031 7.976562-30.898438-.210938-54.996094-4.554688-64.707031 5.023438-7.515626 14.171876-25.074219 15.796876-54.925782 1.667968-30.628906-10.851563-51.167968-17.894532-60.167968zm-100.609375 179.5c0-6.40625 5.210938-11.617188 11.617188-11.617188s11.617187 5.210938 11.617187 11.617188-5.210937 11.621093-11.617187 11.621093-11.617188-5.214843-11.617188-11.621093zm-56.34375-131.359376c6.40625 0 11.621094 5.210938 11.621094 11.617188 0 6.410156-5.214844 11.621094-11.621094 11.621094s-11.617187-5.210938-11.617187-11.621094c0-6.40625 5.210937-11.617188 11.617187-11.617188zm56.601563-146.53125c0 6.40625-5.214844 11.617188-11.621094 11.617188s-11.617188-5.210938-11.617188-11.617188 5.210938-11.621093 11.617188-11.621093 11.621094 5.214843 11.621094 11.621093zm29.199218 109.367188c-6.40625 0-11.617187-5.210938-11.617187-11.617188s5.210937-11.617187 11.617187-11.617187 11.617188 5.210937 11.617188 11.617187-5.210938 11.617188-11.617188 11.617188zm0 0"/><path fill="rgb(131, 146, 161)" d="m341.28125 265.171875c-4.152344 0-7.515625 3.367187-7.515625 7.515625 0 4.152344 3.363281 7.519531 7.515625 7.519531h20.007812c4.15625 0 7.519532-3.367187 7.519532-7.519531 0-4.148438-3.363282-7.515625-7.519532-7.515625zm0 0"/><path fill="rgb(131, 146, 161)" d="m86.296875 397.664062c-4.105469-.664062-7.957031 2.121094-8.621094 6.222657-.664062 4.097656 2.121094 7.957031 6.222657 8.621093.125.019532 12.835937 2.125 25.863281 8.265626 16.183593 7.628906 24.933593 17.527343 26.015625 29.425781.355468 3.90625 3.632812 6.839843 7.480468 6.839843.226563 0 .457032-.011718.6875-.03125 4.136719-.378906 7.183594-4.035156 6.808594-8.167968-3.71875-40.886719-61.976562-50.773438-64.457031-51.175782zm0 0"/><path fill="rgb(131, 146, 161)" d="m180.804688 369.902344c-3.855469-1.542969-8.230469.328125-9.777344 4.179687-.457032 1.132813-10.925782 28.113281 7.933594 57.300781 2.222656 3.441407 6.953124 4.460938 10.394531 2.234376 3.488281-2.253907 4.488281-6.90625 2.234375-10.394532-14.464844-22.390625-6.957032-42.628906-6.59375-43.578125 1.519531-3.84375-.347656-8.199219-4.191406-9.742187zm0 0"/><path fill="rgb(131, 146, 161)" d="m182.527344 120.949219c-3.21875 2.625-3.703125 7.359375-1.078125 10.578125.273437.335937 27.082031 34.230468 6.0625 95.398437-1.351563 3.929688.738281 8.207031 4.664062 9.554688 3.878907 1.335937 8.222657-.792969 9.554688-4.667969 23.707031-68.988281-7.296875-108.152344-8.625-109.785156-2.625-3.21875-7.359375-3.703125-10.578125-1.078125zm0 0"/><path fill="rgb(131, 146, 161)" d="m215.457031 273.078125c-1.628906-3.820313-6.039062-5.597656-9.863281-3.972656-13.054688 5.550781-24.800781 4.992187-34.914062-1.667969-7.898438-5.199219-12.03125-12.335938-12.132813-12.507812-2.019531-3.613282-6.578125-4.917969-10.203125-2.910157-3.632812 2.007813-4.949219 6.585938-2.9375 10.21875.226562.40625 5.636719 10.050781 16.390625 17.351563 6.363281 4.316406 15.375 8.351562 26.835937 8.351562 6.773438 0 14.40625-1.410156 22.847657-5 3.820312-1.628906 5.601562-6.042968 3.976562-9.863281zm0 0"/><path fill="rgb(131, 146, 161)" d="m56.074219 277.402344c-1.664063 3.800781.066406 8.234375 3.863281 9.902344.160156.070312 16.003906 7.117187 29.890625 20.394531 4.382813 4.191406 8.074219 8.503906 11.070313 12.921875.125.207031.257812.410156.402343.609375 8.734375 13.179687 11.320313 27.324219 7.671875 42.230469-.988281 4.03125 1.484375 8.101562 5.515625 9.089843 3.980469.972657 8.117188-1.535156 9.089844-5.515625 2.839844-11.609375 2.683594-22.980468-.367187-33.875 8.039062 2.78125 15.40625 3.804688 21.902343 3.804688 17.480469 0 28.621094-7.414063 29.375-7.933594 3.425781-2.347656 4.320313-7.046875 1.972657-10.46875-2.347657-3.425781-7-4.3125-10.425782-1.964844-.921875.609375-22.625 14.476563-53.332031-5.316406-3.554687-5.09375-7.820313-10.027344-12.808594-14.757812-15.808593-14.992188-33.199219-22.675782-33.933593-22.996094-3.796876-1.660156-8.222657.074218-9.886719 3.875zm0 0"/><path fill="rgb(131, 146, 161)" d="m75.164062 201.160156c-2.40625 3.375-1.617187 8.066406 1.746094 10.480469.296875.210937 29.511719 21.585937 29.910156 57.949219.046876 4.121094 3.402344 7.433594 7.515626 7.433594h.085937c4.152344-.042969 7.480469-3.449219 7.433594-7.597657-.484375-44.195312-34.769531-69.007812-36.230469-70.039062-3.378906-2.398438-8.054688-1.601563-10.460938 1.773437zm0 0"/><path fill="rgb(131, 146, 161)" d="m117.636719 89.113281c-3.472657-2.277343-8.132813-1.304687-10.410157 2.167969-1.113281 1.699219-27.117187 42.144531-12.195312 85.398438 1.335938 3.871093 5.683594 5.988281 9.5625 4.652343 3.921875-1.351562 6.007812-5.632812 4.652344-9.558593-2.5625-7.429688-3.621094-14.835938-3.707032-21.925782 18.085938 33.6875 50.632813 45.179688 52.34375 45.761719 3.871094 1.320313 8.195313-.8125 9.523438-4.675781 1.347656-3.917969-.738281-8.191406-4.65625-9.550782-1.769531-.613281-42.894531-15.390624-52.167969-61.710937 4.054688-12.039063 9.082031-19.941406 9.226563-20.160156 2.269531-3.472657 1.296875-8.125-2.171875-10.398438zm0 0"/><path fill="rgb(131, 146, 161)" d="m150.890625 88.046875c-4.0625.867187-6.65625 4.859375-5.789063 8.921875.753907 3.53125 3.871094 5.953125 7.34375 5.953125.519532 0 1.046876-.054687 1.574219-.167969 27.300781-5.8125 39.703125-21.6875 45.296875-33.980468 6.03125-13.261719 5.523438-25.234376 5.496094-25.738282-.203125-4.132812-3.691406-7.304687-7.839844-7.121094-4.132812.179688-7.34375 3.6875-7.179687 7.824219.054687 1.457031.941406 35.828125-38.902344 44.308594zm0 0"/></svg>',
  featureflag: '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="m5.5 23.5c-.276 0-.5-.224-.5-.5v-22c0-.276.224-.5.5-.5s.5.224.5.5v22c0 .276-.224.5-.5.5z"/><path d="m5.5 14.5c-.096 0-.191-.027-.274-.082-.141-.093-.226-.25-.226-.418v-13c0-.168.085-.325.226-.418s.319-.106.473-.041l15 6.5c.183.079.301.26.301.459s-.118.38-.301.459l-15 6.5c-.064.027-.132.041-.199.041zm.5-12.738v11.477l13.242-5.739z"/></svg>',
  eversana: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="424px" height="74px" viewBox="0 0 424 74" enable-background="new 0 0 424 74" xml:space="preserve">  <image id="image0" width="424" height="74" x="0" y="0"\n    xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAagAAABKCAMAAADZlzDPAAAABGdBTUEAALGPC/xhBQAAACBjSFJN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" />\n</svg>',
  mckesson: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1200px" height="380px" viewBox="0 0 1200 380" enable-background="new 0 0 1200 380" xml:space="preserve">\n<image id="image0" width="1200" height="380" x="0" y="0"\n    xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABLAAAAF8CAYAAADfM0KnAAAABGdBTUEAALGPC/xhBQAAACBjSFJN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\nMC0wOS0wNFQwNjo1ODozMCswMjowMJFQ8xcAAAAASUVORK5CYII=" />\n</svg>'
};

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39197026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(1085);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39197026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_614f2201_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(906);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_614f2201_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _vuex2 = _interopRequireDefault(_vuex);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _templates = __webpack_require__(992);

var _templates2 = _interopRequireDefault(_templates);

var _forms = __webpack_require__(993);

var _forms2 = _interopRequireDefault(_forms);

var _cryptojs_utils = __webpack_require__(319);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
  state: {
    idToken: null,
    refreshToken: null,
    accountId: null,
    accountName: 'Default',
    accounts: [],
    email: null,
    role: null,
    endDate: null,
    notifications: [],
    userId: null,
    selectedRoles: [],
    userRoleOrder: null,
    mode: null,
    refs: {},
    validationErrors: '',
    exportFormDocID: null,
    rotatedDocFormDocId: null,
    otherMedErrors: [],
    accountLogo: null,
    prevFormsTab: null,
    localTime: null,
    selectTriageStatus: [],
    selectAgentStatus: [],
    selectUnmatchStatus: [],
    loginLoading: false
  },
  mutations: {
    authUser: function authUser(state, userData) {
      state.idToken = userData.idToken;
      state.refreshToken = userData.refreshToken;
      state.email = userData.email;
      state.userId = userData.userId;
      state.selectedRoles = userData.selectedRoles;
      state.userRoleOrder = userData.userRoleOrder;
    },
    logOut: function logOut(state) {
      state.idToken = null;
      state.refreshToken = null;
      state.email = null;
      state.role = null;
      state.endDate = null;
      state.userId = null;
      state.accountId = null;
    },
    setMetaData: function setMetaData(state) {
      state.role = window.localStorage.getItem('role');
      state.refreshToken = window.localStorage.getItem('refreshToken');
      state.endDate = window.localStorage.getItem('endDate');
      state.accountId = parseInt((0, _cryptojs_utils.decryptParams)(window.localStorage.getItem('accountId')));
      state.accountName = (0, _cryptojs_utils.decryptParams)(window.localStorage.getItem('accountName'));
      state.i18n.locale = window.localStorage.getItem('lang') || 'en';
      state.mode = window.localStorage.getItem('mode') || 'default';
      state.accountLogo = window.localStorage.getItem('accountLogo');
      var tab = window.localStorage.getItem('prevFormsTab');
      state.prevFormsTab = tab !== null && tab !== 'null' ? parseInt(tab) : null;
      state.localTime = window.localStorage.getItem('localTime');
      state.selectTriageStatus = JSON.parse(window.localStorage.getItem('selectTriageStatus'));
      state.selectAgentStatus = JSON.parse(window.localStorage.getItem('selectAgentStatus'));
      state.selectUnmatchStatus = JSON.parse(window.localStorage.getItem('selectUnmatchStatus'));
    },
    setToken: function setToken(state, data) {
      window.localStorage.setItem('idToken', data.idToken);
      state.idToken = data.idToken;
    },
    setNotification: function setNotification(state, userData) {
      if (userData.messages.length > 0) {
        state.notifications = userData.messages;
      }
    },
    deleteNotification: function deleteNotification(state, index) {
      state.notifications.splice(index, 1);
    },
    setExportFormDocID: function setExportFormDocID(state, data) {
      window.localStorage.setItem('exportFormDocID', data);
      state.exportFormDocID = data;
    },
    setRotatedDocFormDocId: function setRotatedDocFormDocId(state, data) {
      window.localStorage.setItem('rotatedDocFormDocId', data);
      state.rotatedDocFormDocId = data;
    },
    setSelectedRoles: function setSelectedRoles(state, data) {
      state.selectedRoles = data;
    },
    setUserRoleOrder: function setUserRoleOrder(state, data) {
      state.userRoleOrder = data;
    },
    setLocalTime: function setLocalTime(state, data) {
      window.localStorage.setItem('localTime', data);
      state.localTime = data;
    },
    setPrevFormsTab: function setPrevFormsTab(state, data) {
      window.localStorage.setItem('prevFormsTab', data);
      state.prevFormsTab = data;
    },
    setselectTriageStatus: function setselectTriageStatus(state, selectTriageStatus) {
      window.localStorage.setItem('selectTriageStatus', JSON.stringify(selectTriageStatus));
      state.selectTriageStatus = selectTriageStatus;
    },
    setselectAgentStatus: function setselectAgentStatus(state, selectAgentStatus) {
      window.localStorage.setItem('selectAgentStatus', JSON.stringify(selectAgentStatus));
      state.selectAgentStatus = selectAgentStatus;
    },
    setselectUnmatchStatus: function setselectUnmatchStatus(state, selectUnmatchStatus) {
      window.localStorage.setItem('selectUnmatchStatus', JSON.stringify(selectUnmatchStatus));
      state.selectUnmatchStatus = selectUnmatchStatus;
    },
    setValidationErrors: function setValidationErrors(state, data) {
      window.localStorage.setItem('validationErrors', data);
      state.validationErrors = data;
    },
    setRefs: function setRefs(state, data) {
      window.localStorage.setItem('refs', data);
      state.refs = data;
    },
    setOtherMedErrors: function setOtherMedErrors(state, data) {
      window.localStorage.setItem('otherMedErrors', data);
      state.otherMedErrors = data;
    },
    setIsLoginLoading: function setIsLoginLoading(state, data) {
      state.loginLoading = data.loginLoading;
    }
  },
  actions: {
    // signUp ({commit}, signUpData) {
    //   let data = new window.FormData()
    //   data.append('username', signUpData.username)
    //   data.append('email', signUpData.email)
    //   data.append('password', signUpData.password)
    //   Vue.axios.post('users', data)
    //     .then(res => {
    //       Vue.toasted.show(this._vm.$i18n.translate('COMMON.MSG_SUCESS_ACC'))
    //       router.push('sign_in')
    //     })
    //     .catch(error => {
    //       Vue.toasted.show(this._vm.$i18n.translate('COMMON.MSG_SIGNUP_FAIL')),
    //         { icon: 'chain-broken', type: 'error' })
    //       console.log(error)
    //     })
    // },
    updateToken: function updateToken(_ref, payload) {
      var commit = _ref.commit;

      commit('setToken', { idToken: payload.token });
    },
    ssoLogin: function ssoLogin(_ref2, payload) {
      var _this = this;

      var commit = _ref2.commit;

      var data = new window.FormData();
      var authData = payload.authData,
          redirectpath = payload.redirectpath;
      var username = authData.username,
          accessToken = authData.accessToken;

      if (!(username && accessToken)) {
        throw new Error('Login Failed');
      }
      data.append('auth[ms_access_token]', accessToken);
      _vue2.default.axios.post('azureAD', data, { headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0'
        } }).then(function (res) {
        if (res.data.status === 'created') {
          commit('authUser', {
            idToken: res.data.token.token,
            refreshToken: res.data.refresh_token,
            email: username,
            userId: res.data.user_id,
            selectedRoles: res.data.selected_roles,
            userRoleOrder: res.data.user_role_order
          });
          window.localStorage.setItem('idToken', res.data.token.token);
          window.localStorage.setItem('refreshToken', res.data.refresh_token);
          window.localStorage.setItem('accountId', (0, _cryptojs_utils.encryptParams)(res.data.account_id));
          window.localStorage.setItem('accountName', (0, _cryptojs_utils.encryptParams)(res.data.account_name));
          window.localStorage.setItem('role', res.data.role);
          window.localStorage.setItem('endDate', res.data.end_date);
          window.localStorage.setItem('email', (0, _cryptojs_utils.encryptParams)(username));
          window.localStorage.setItem('userId', res.data.user_id);
          window.localStorage.setItem('selectedRoles', JSON.stringify(res.data.selected_roles));
          window.localStorage.setItem('userRoleOrder', res.data.user_role_order);
          window.localStorage.setItem('mode', 'default');
          window.localStorage.setItem('accountLogo', res.data.account_logo);
          window.localStorage.setItem('localTime', res.data.local);
          commit('setMetaData');
          _vue2.default.toasted.show(_this._vm.$i18n.translate('COMMON.MSG_LOGIN_SUCESS') + username, { icon: 'user-circle', type: 'success' });
        } else {
          _vue2.default.toasted.show(res.data.msg, { icon: 'user-times', type: 'error' });
        }
        if (redirectpath) {
          _router2.default.push(redirectpath);
        } else {
          _router2.default.push('/process/processed');
        }
      }).catch(function (error) {
        if (error && error.status === 404) {
          console.log('Unauthorized, Do nothing');
          _vue2.default.toasted.show(_this._vm.$i18n.translate('COMMON.MSG_USER_NF'), { icon: 'user-times', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this._vm.$i18n.translate('COMMON.MSG_LOGIN_FAIL'), { icon: 'chain-broken', type: 'error' });
          _router2.default.replace('sign_in');
        }
      });
    },
    logIn: function logIn(_ref3, payload) {
      var _this2 = this;

      var commit = _ref3.commit;

      commit('setIsLoginLoading', { loginLoading: true });
      var authData = payload.authData,
          redirectpath = payload.redirectpath;

      var data = new window.FormData();
      data.append('auth[email]', authData.email);
      data.append('auth[password]', authData.password);
      _vue2.default.axios.post('user_token', data, { headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0'
        } }).then(function (res) {
        commit('setIsLoginLoading', { loginLoading: false });
        if (res.data.status === 'created') {
          commit('authUser', {
            idToken: res.data.token.token,
            refreshToken: res.data.refresh_token,
            email: authData.email,
            userId: res.data.user_id,
            selectedRoles: res.data.selected_roles,
            userRoleOrder: res.data.user_role_order
          });
          window.localStorage.setItem('idToken', res.data.token.token);
          window.localStorage.setItem('refreshToken', res.data.refresh_token);
          window.localStorage.setItem('accountId', (0, _cryptojs_utils.encryptParams)(res.data.account_id));
          window.localStorage.setItem('accountName', (0, _cryptojs_utils.encryptParams)(res.data.account_name));
          window.localStorage.setItem('role', res.data.role);
          window.localStorage.setItem('endDate', res.data.end_date);
          window.localStorage.setItem('email', (0, _cryptojs_utils.encryptParams)(authData.email));
          window.localStorage.setItem('userId', res.data.user_id);
          window.localStorage.setItem('selectedRoles', JSON.stringify(res.data.selected_roles));
          window.localStorage.setItem('userRoleOrder', res.data.user_role_order);
          window.localStorage.setItem('mode', 'default');
          window.localStorage.setItem('accountLogo', res.data.account_logo);
          window.localStorage.setItem('localTime', res.data.local);
          commit('setMetaData');
          _vue2.default.toasted.show(_this2._vm.$i18n.translate('COMMON.MSG_LOGIN_SUCESS') + authData.email, { icon: 'user-circle', type: 'success' });
          if (res.data.account_id === 73) {
            _router2.default.push('/medical_insurance_cards/demo');
          } else {
            if (redirectpath) {
              _router2.default.push(redirectpath);
            } else {
              _router2.default.push('/process/processed');
            }
          }
        } else {
          _vue2.default.toasted.show(res.data.msg, { icon: 'user-times', type: 'error' });
        }
      }).catch(function (error) {
        commit('setIsLoginLoading', { loginLoading: false });
        if (error && error.status === 404) {
          console.log('Unauthorized, Do nothing');
          _vue2.default.toasted.show(_this2._vm.$i18n.translate('COMMON.MSG_USER_NF'), { icon: 'user-times', type: 'error' });
        } else if (error && error.status === 503) {
          _vue2.default.toasted.show(_this2._vm.$i18n.translate('COMMON.MSG_SERVER_UA'), { icon: 'user-times', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this2._vm.$i18n.translate('COMMON.MSG_LOGIN_FAIL'), { icon: 'chain-broken', type: 'error' });
          _router2.default.replace('sign_in');
        }
      });
    },
    autoLogin: function autoLogin(_ref4) {
      var commit = _ref4.commit;

      var token = window.localStorage.getItem('idToken');
      var email = window.localStorage.getItem('email');
      var decryptedEmail = email ? (0, _cryptojs_utils.decryptParams)(email) : email;
      var userId = window.localStorage.getItem('userId');
      var selectedRoles = JSON.parse(window.localStorage.getItem('selectedRoles'));
      var userRoleOrder = window.localStorage.getItem('userRoleOrder');
      if (!token) {
        return;
      }
      commit('authUser', {
        idToken: token,
        email: decryptedEmail,
        userId: userId,
        selectedRoles: selectedRoles,
        userRoleOrder: userRoleOrder
      });
    },
    updateNotification: function updateNotification(_ref5, state) {
      var _this3 = this;

      var commit = _ref5.commit,
          rootState = _ref5.rootState;

      _vue2.default.axios.get('/notifications/', { headers: { Authorization: 'Bearer ' + rootState.idToken } }).then(function (res) {
        commit('setNotification', {
          messages: res.data
        });
      }).catch(function (error) {
        if (error.status === 401) {
          return _this3.getters.appMode === 'default' ? _router2.default.replace('/sign_in') : '';
        } else {
          _vue2.default.toasted.show(_this3._vm.$i18n.translate('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    logOut: function logOut(_ref6) {
      var commit = _ref6.commit;

      _vue2.default.axios.get('/users/logout', {
        headers: {
          Authorization: 'Bearer ' + window.localStorage.getItem('idToken'),
          'Cache-Control': 'no-cache, no-store',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      }).then(function (res) {
        return console.log('Successfully logged out');
      }).catch(function (err) {
        return console.log(err);
      });
      commit('logOut');
      window.localStorage.clear();
      window.localStorage.setItem('logout-event', Date.now());
      _vue2.default.toasted.show(this._vm.$i18n.translate('COMMON.MSG_LOGOUT'), { icon: 'hand-stop-o', type: 'success' });
      _router2.default.replace('/log_in');
    },
    setMetaData: function setMetaData(_ref7) {
      var commit = _ref7.commit;

      commit('setMetaData');
    }
  },
  getters: {
    isAuthenticated: function isAuthenticated(state) {
      return state.idToken !== null;
    },
    currentUserEmail: function currentUserEmail(state) {
      return state.email;
    },
    currentUserId: function currentUserId(state) {
      return state.userId;
    },
    refs: function refs(state) {
      return state.refs;
    },
    exportFormDocID: function exportFormDocID(state) {
      return state.exportFormDocID;
    },
    rotatedDocFormDocId: function rotatedDocFormDocId(state) {
      return state.rotatedDocFormDocId;
    },
    idToken: function idToken(state) {
      return state.idToken;
    },
    refreshToken: function refreshToken(state) {
      return state.refreshToken;
    },
    accountId: function accountId(state) {
      return state.accountId;
    },
    accountName: function accountName(state) {
      return state.accountName;
    },
    isSuperAdmin: function isSuperAdmin(state) {
      return state.role === 'super admin';
    },
    isAdmin: function isAdmin(state) {
      return state.role === 'admin';
    },
    isAgent: function isAgent(state) {
      return state.role === 'agent';
    },
    trialUser: function trialUser(state) {
      return state.role === 'trial user';
    },
    userRole: function userRole(state) {
      return state.role;
    },
    endDate: function endDate(state) {
      return state.endDate;
    },
    selectedRolesData: function selectedRolesData(state) {
      return state.selectedRoles;
    },
    userRoleOrder: function userRoleOrder(state) {
      return state.userRoleOrder;
    },
    isAdminRole: function isAdminRole(state) {
      return state.role === 'super admin' || state.role === 'admin';
    },
    appMode: function appMode(state) {
      return state.mode;
    },
    accountLogo: function accountLogo(state) {
      return state.accountLogo;
    },
    prevFormsTab: function prevFormsTab(state) {
      return state.prevFormsTab;
    },
    selectTriageStatus: function selectTriageStatus(state) {
      return state.selectTriageStatus;
    },
    selectAgentStatus: function selectAgentStatus(state) {
      return state.selectAgentStatus;
    },
    selectUnmatchStatus: function selectUnmatchStatus(state) {
      return state.selectUnmatchStatus;
    },
    localTime: function localTime(state) {
      return state.localTime;
    },
    otherMedErrors: function otherMedErrors(state) {
      return state.otherMedErrors;
    },
    isLoginLoading: function isLoginLoading(state) {
      return state.loginLoading;
    }
  },
  modules: {
    templates: _templates2.default,
    forms: _forms2.default
  }
});

/***/ }),
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Language_vue__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Language_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Language_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Language_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Language_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dce5b9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Language_vue__ = __webpack_require__(946);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Language_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dce5b9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Language_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchBar_vue__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchBar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchBar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchBar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6698b3bd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchBar_vue__ = __webpack_require__(1038);
function injectStyle (ssrContext) {
  __webpack_require__(1037)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6698b3bd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchBar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6698b3bd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 186 */,
/* 187 */,
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */,
/* 190 */
/***/ (function(module, exports) {

module.exports = "../../static/img/exclamation.1746616.png";

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_AnimatedNumber_vue__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_AnimatedNumber_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_AnimatedNumber_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_AnimatedNumber_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_AnimatedNumber_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3e310b42_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_AnimatedNumber_vue__ = __webpack_require__(1140);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_AnimatedNumber_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3e310b42_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_AnimatedNumber_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _formInput = __webpack_require__(811);

var _formInput2 = _interopRequireDefault(_formInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _formInput2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _formFile = __webpack_require__(818);

var _formFile2 = _interopRequireDefault(_formFile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _formFile2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 252 */,
/* 253 */,
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _modal = __webpack_require__(835);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _modal2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _progress = __webpack_require__(857);

var _progress2 = _interopRequireDefault(_progress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _progress2.default; //
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 260 */,
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _table = __webpack_require__(862);

var _table2 = _interopRequireDefault(_table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _table2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 262 */,
/* 263 */,
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//

exports.default = {
  name: 'app',
  created: function created() {
    this.$store.dispatch('autoLogin');
  }
};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _nav = __webpack_require__(899);

var _nav2 = _interopRequireDefault(_nav);

var _fab = __webpack_require__(900);

var _fab2 = _interopRequireDefault(_fab);

var _components = __webpack_require__(901);

var _vuex = __webpack_require__(5);

var _Sessionlogout = __webpack_require__(921);

var _Sessionlogout2 = _interopRequireDefault(_Sessionlogout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'full',
  components: {
    AppHeader: _components.Header,
    AppFooter: _components.Footer,
    PageTitle: _components.PageTitle,
    ResponsiveNav: _components.ResponsiveNav,
    Sessionlogout: _Sessionlogout2.default
  },
  data: function data() {
    return {
      nav: _nav2.default.items,
      fab: _fab2.default,
      visible: false
    };
  },

  methods: {
    toggleVisible: function toggleVisible() {
      this.visible = !this.visible;
    },
    hideMenu: function hideMenu() {
      this.visible = false;
    }
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['appMode']), {
    name: function name() {
      if (this.$route.path.includes('/process/modify/')) {
        return 'Triaging';
      } else {
        return this.$route.name;
      }
    },
    isSessionTimeout: function isSessionTimeout() {
      return false;
    }
  }),
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('setMetaData');
  }
};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
};

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//

exports.default = {
  name: 'c-footer',
  computed: {
    currentYear: function currentYear() {
      return new Date().getFullYear();
    }
  }
};

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _micpHeaderAccount = __webpack_require__(270);

var _micpHeaderAccount2 = _interopRequireDefault(_micpHeaderAccount);

var _HeaderDropdownAccnt = __webpack_require__(910);

var _HeaderDropdownAccnt2 = _interopRequireDefault(_HeaderDropdownAccnt);

var _NavItem = __webpack_require__(912);

var _NavItem2 = _interopRequireDefault(_NavItem);

var _svg = __webpack_require__(28);

var _svg2 = _interopRequireDefault(_svg);

var _vuex = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'c-header',
  props: {
    navItems: Array
  },
  components: {
    MicpHeaderAccount: _micpHeaderAccount2.default,
    HeaderDropdownAccnt: _HeaderDropdownAccnt2.default,
    NavItem: _NavItem2.default
  },
  created: function created() {
    if (this.isAgent) {
      this.headerItems = this.navItems.filter(function (item) {
        return item.name === 'FORMS';
      });
    } else {
      this.headerItems = this.navItems;
    }
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['trialUser', 'endDate', 'accountId', 'accountLogo', 'isAdmin', 'isAgent']), {
    getAccountLogo: function getAccountLogo() {
      if (this.accountLogo === 'null' || this.accountLogo === null) {
        return false;
      } else {
        return true;
      }
    }
  }),
  data: function data() {
    return {
      svg: _svg2.default,
      headerItems: []
    };
  },

  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      this.$emit('showNavBar');
    }
  }
};

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_micpHeaderAccount_vue__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_micpHeaderAccount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_micpHeaderAccount_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_micpHeaderAccount_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_micpHeaderAccount_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46a071b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_micpHeaderAccount_vue__ = __webpack_require__(909);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_micpHeaderAccount_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46a071b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_micpHeaderAccount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//

var _vuex = __webpack_require__(5);

var _svg = __webpack_require__(28);

var _svg2 = _interopRequireDefault(_svg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'header-dropdown-accnt',
  data: function data() {
    return {
      svg: _svg2.default
    };
  },

  methods: {
    logOut: function logOut() {
      this.$store.dispatch('logOut');
    }
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['isAdmin', 'currentUserEmail']), {
    isAdminRole: function isAdminRole() {
      return this.isAdmin;
    }
  })
};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vuex = __webpack_require__(5);

var _svg = __webpack_require__(28);

var _svg2 = _interopRequireDefault(_svg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'micp-header-account',
  data: function data() {
    return {
      svg: _svg2.default
    };
  },

  methods: {
    logOut: function logOut() {
      this.$store.dispatch('logOut');
    }
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['isAdmin', 'isSuperAdmin', 'currentUserEmail']), {
    isAdminRole: function isAdminRole() {
      return this.isAdmin || this.isSuperAdmin;
    }
  })
};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svg = __webpack_require__(28);

var _svg2 = _interopRequireDefault(_svg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    name: String,
    url: String,
    iconUrl: String,
    svgIcon: String
  },
  data: function data() {
    return {
      svg: _svg2.default
    };
  }
}; //
//
//
//
//
//
//

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    visible: Boolean,
    navItems: Array
  },
  methods: {
    hideMenu: function hideMenu() {
      this.$emit('hideMenu');
    }
  }
};

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Fab = __webpack_require__(918);

var _Fab2 = _interopRequireDefault(_Fab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    title: String,
    fabList: Object
  },
  computed: {
    fabExists: function fabExists() {
      return this.fabList[this.title] !== undefined;
    }
  },
  components: {
    Fab: _Fab2.default
  }
}; //
//
//
//
//
//

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vuex = __webpack_require__(5);

exports.default = {
  props: {
    fabList: Object,
    routeName: String
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['isAdminRole']), {
    getFabLink: function getFabLink() {
      return this.fabList[this.routeName];
    }
  }),
  methods: {
    download: function download(routeName) {
      // Event emission happens from here, corresponding events are caught on respective components.
      if (routeName === 'Reports') {
        this.$root.$emit('exportReports', true);
      } else if (routeName === 'Log History') {
        this.$root.$emit('exportLogs', true);
      }
    }
  }
};

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'SessionLogout',
  data: function data() {
    return {
      sessionTimeout: 15 * 60 * 1000,
      popupDuration: 5 * 60 * 1000,
      sessionTimer: null,
      popupTimer: null,
      countdownInterval: null,
      showPopup: false,
      countdownTime: 0
    };
  },
  mounted: function mounted() {
    this.startSessionTimeout();
    this.initializeActivityListeners();
  },
  beforeDestroy: function beforeDestroy() {
    this.clearTimers();
    this.removeActivityListeners();
  },

  methods: {
    startSessionTimeout: function startSessionTimeout() {
      var _this = this;

      this.sessionTimer = setTimeout(function () {
        _this.showPopup = true;
        _this.startPopupTimer();
      }, this.sessionTimeout);
    },
    resetInactiveTimer: function resetInactiveTimer() {
      clearTimeout(this.sessionTimer);
      this.startSessionTimeout();
    },
    updateLastActiveLoacalStorage: function updateLastActiveLoacalStorage() {
      window.localStorage.setItem('last-active-session-event', Date.now());
    },
    initializeActivityListeners: function initializeActivityListeners() {
      var _this2 = this;

      window.addEventListener('click', function (event) {
        _this2.updateLastActiveLoacalStorage();
        _this2.resetInactiveTimer();
      });
      window.addEventListener('keydown', this.resetInactiveTimer);
      window.addEventListener('storage', function (event) {
        if (event.key === 'last-active-session-event') {
          _this2.extendSession();
        }
      });
    },
    startPopupTimer: function startPopupTimer() {
      var _this3 = this;

      this.popupTimer = setTimeout(function () {
        _this3.logoutSession();
      }, this.popupDuration);
      this.startCountdown();
    },
    startCountdown: function startCountdown() {
      var _this4 = this;

      this.countdownTime = Math.floor(this.popupDuration / 1000);
      clearInterval(this.countdownInterval);
      this.countdownInterval = setInterval(function () {
        _this4.countdownTime--;
        if (_this4.countdownTime <= 0) {
          clearInterval(_this4.countdownInterval);
        }
      }, 1000);
    },
    handleContinueSession: function handleContinueSession() {
      this.extendSession();
      this.updateLastActiveLoacalStorage();
    },
    extendSession: function extendSession() {
      clearTimeout(this.popupTimer);
      clearInterval(this.countdownInterval);
      this.showPopup = false;
      this.resetInactiveTimer();
    },
    logoutSession: function logoutSession() {
      this.clearTimers();
      this.removeActivityListeners();
      this.$store.dispatch('logOut');
      this.$router.push('/log_in');
    },
    clearTimers: function clearTimers() {
      clearTimeout(this.sessionTimer);
      clearTimeout(this.popupTimer);
      clearInterval(this.countdownInterval);
    },
    removeActivityListeners: function removeActivityListeners() {
      window.removeEventListener('click', this.resetInactiveTimer);
      window.removeEventListener('keydown', this.resetInactiveTimer);
    },
    formatTime: function formatTime(seconds) {
      var minutes = Math.floor(seconds / 60);
      var remainingSeconds = seconds % 60;
      var formattedMinutes = minutes.toString().padStart(2, '0');
      var formattedSeconds = remainingSeconds.toString().padStart(2, '0');
      return formattedMinutes + ':' + formattedSeconds;
    }
  }
};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validators = __webpack_require__(32);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _svg = __webpack_require__(28);

var _svg2 = _interopRequireDefault(_svg);

var _Footer = __webpack_require__(128);

var _Footer2 = _interopRequireDefault(_Footer);

var _Language = __webpack_require__(174);

var _Language2 = _interopRequireDefault(_Language);

var _msalAutologin = __webpack_require__(947);

var _msalAutologin2 = _interopRequireDefault(_msalAutologin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'Login',
  data: function data() {
    return {
      user: {
        email: '',
        password: ''
      },
      svg: _svg2.default,
      event: null
    };
  },

  components: {
    Footer: _Footer2.default,
    Language: _Language2.default
  },
  computed: {
    currentYear: function currentYear() {
      return new Date().getFullYear();
    }
  },
  mixins: [_msalAutologin2.default],
  methods: {
    loginSubmit: function loginSubmit() {
      var redirectUrl = this.$route.query.redirect_to;

      var payload = { authData: this.user, redirectpath: redirectUrl };
      this.$store.dispatch('logIn', payload);
    },
    loginOnEnter: function loginOnEnter(event) {
      if (event.keyCode === 13) {
        this.loginSubmit();
      }
    },
    forgotPasswordClicked: function forgotPasswordClicked() {
      _router2.default.push('/forgot_password');
    }
  },
  validations: {
    user: {
      email: {
        required: _validators.required,
        email: _validators.email
      },
      password: {
        required: _validators.required
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener('keyup', this.loginOnEnter);
  },
  destroyed: function destroyed() {
    window.removeEventListener('keyup', this.loginOnEnter);
  }
};

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svg = __webpack_require__(28);

var _svg2 = _interopRequireDefault(_svg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'language-dropdown',
  data: function data() {
    return {
      langMaps: { 'en': 'English', 'fr': 'Français', 'es': 'Español' },
      svg: _svg2.default
    };
  },

  methods: {
    setLang: function setLang(lang) {
      this.$i18n.set(lang);
      window.localStorage.setItem('lang', lang);
    },
    getLang: function getLang() {
      return this.$i18n.locale() || 'en';
    }
  },
  computed: {
    selectedLang: function selectedLang() {
      return this.langMaps[this.getLang()];
    },
    selectedFlag: function selectedFlag() {
      return this.svg[this.getLang()];
    }
  }
}; //
//
//
//
//
//
//
//
//
//

/***/ }),
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  clientid: "ec0f8031-29f6-45f6-91ed-5f5f3eb35f12",
  redirecturl: "https://nova-prod.wilcodocx.com/sign_in",
  authority: "https://login.microsoftonline.com/f35a6974-607f-47d4-82d7-ff31d7dc53a5",
  graphscopes: ['openid', 'profile', 'User.Read']
};

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _validators = __webpack_require__(32);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _svg = __webpack_require__(28);

var _svg2 = _interopRequireDefault(_svg);

var _Footer = __webpack_require__(128);

var _Footer2 = _interopRequireDefault(_Footer);

var _Language = __webpack_require__(174);

var _Language2 = _interopRequireDefault(_Language);

var _msal = __webpack_require__(991);

var _msal2 = _interopRequireDefault(_msal);

var _vuex = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Login',
  data: function data() {
    return {
      user: {
        email: '',
        password: ''
      },
      svg: _svg2.default
    };
  },

  components: {
    Footer: _Footer2.default,
    Language: _Language2.default
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['isLoginLoading']), {
    currentYear: function currentYear() {
      return new Date().getFullYear();
    }
  }),
  methods: {
    msLogin: function msLogin() {
      var msal = new _msal2.default(this.$route.query.redirect_to);
      msal.signIn();
    },
    loginSubmit: function loginSubmit() {
      var redirectUrl = this.$route.query.redirect_to;

      var payload = { authData: this.user, redirectpath: redirectUrl };
      this.$store.dispatch('logIn', payload);
    },
    loginOnEnter: function loginOnEnter(event) {
      if (event.keyCode === 13) {
        this.loginSubmit();
      }
    },
    forgotPasswordClicked: function forgotPasswordClicked() {
      _router2.default.push('/forgot_password');
    }
  },
  validations: {
    user: {
      email: {
        required: _validators.required,
        email: _validators.email
      },
      password: {
        required: _validators.required
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener('keyup', this.loginOnEnter);
  },
  destroyed: function destroyed() {
    window.removeEventListener('keyup', this.loginOnEnter);
  }
};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.encryptParams = encryptParams;
exports.decryptParams = decryptParams;

var _cryptoJs = __webpack_require__(320);

var _cryptoJs2 = _interopRequireDefault(_cryptoJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function encryptParams(param) {
  try {
    var encryptedText = _cryptoJs2.default.AES.encrypt(param.toString(), "el+Wp8rTW1hOJCr6XHJa2xMRo24NgT0wl+I1tWWQO0E=").toString();
    return encryptedText;
  } catch (error) {
    console.error(error);
    return param;
  }
}

function decryptParams(encryptedText) {
  try {
    var bytes = _cryptoJs2.default.AES.decrypt(encryptedText, "el+Wp8rTW1hOJCr6XHJa2xMRo24NgT0wl+I1tWWQO0E=");
    var originalText = bytes.toString(_cryptoJs2.default.enc.Utf8);
    return originalText;
  } catch (error) {
    console.error(error);
    return encryptedText;
  }
}

/***/ }),
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _validators = __webpack_require__(32);

var _svg = __webpack_require__(28);

var _svg2 = _interopRequireDefault(_svg);

var _Language = __webpack_require__(174);

var _Language2 = _interopRequireDefault(_Language);

var _Footer = __webpack_require__(128);

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ResetPassword',
  data: function data() {
    return {
      resetPassword: '',
      confirmResetPassword: '',
      svg: _svg2.default
    };
  },

  components: {
    Footer: _Footer2.default,
    Language: _Language2.default
  },
  computed: {
    currentYear: function currentYear() {
      return new Date().getFullYear();
    }
  },
  methods: {
    loginClicked: function loginClicked() {
      console.log(this.$t('COMMON.MSG_EXPIRED'));
    },
    changePassword: function changePassword() {
      var _this = this;

      var token = this.$route.params.token.replace(/%0D/g, '');
      var data = new window.FormData();
      data.append('token', token);
      data.append('id', this.$route.params.id);
      data.append('password', this.resetPassword);
      _vue2.default.axios.post('/forgot_password/reset_password', data).then(function (response) {
        if (response.data.status === 'success') {
          _vue2.default.toasted.show(_this.$t('AUTH.PASSWORD_UPDATED'), { icon: 'chain-broken', type: 'success' });
          console.log(_this.$t('COMMON.MSG_EXPIRED'));
        } else if (response.data.status === 'expired') {
          _vue2.default.toasted.show(_this.$t('AUTH.LINK_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this.$t('AUTH.LINK_USED'), { icon: 'chain-broken', type: 'error' });
        }
      }, function (error) {
        _vue2.default.toasted.show(_this.$t('ERROR.COMMON'), { icon: 'chain-broken', type: 'error' });
        console.log(error);
      });
    }
  },
  validations: {
    resetPassword: {
      required: _validators.required,
      minLength: (0, _validators.minLength)(6)
    },
    confirmResetPassword: {
      required: _validators.required,
      sameAsPassword: (0, _validators.sameAs)('resetPassword')
    }
  },
  mounted: function mounted() {
    window.addEventListener('keyup', this.loginOnEnter);
  },
  destroyed: function destroyed() {
    window.removeEventListener('keyup', this.loginOnEnter);
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _cryptojs_utils = __webpack_require__(319);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Auth',
  data: function data() {
    return {};
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['idToken'])),
  created: function created() {
    var code = this.$route.query.code;
    if (code) {
      var service = window.localStorage.getItem('service');
      this.completeOauth(this.$route.query, service);
    } else {
      var _service = this.$route.query.service;
      var redirectTo = this.$route.query.redirect_to;
      var loginUrl = this.$route.query.loginUrl || '';
      window.localStorage.setItem('service', _service);
      window.localStorage.setItem('redirectTo', redirectTo);
      this.redirectToService(_service, loginUrl);
    }
  },

  methods: {
    redirectToService: function redirectToService(service, loginUrl) {
      _vue2.default.axios.post('/auth/' + service, { 'loginUrl': loginUrl }).then(function (res) {
        if (res.data.link) {
          window.location = res.data.link;
        }
      });
    },
    completeOauth: function completeOauth(query, service) {
      var _this = this;

      var payload = {
        'query': JSON.stringify(query),
        'service': service
      };
      _vue2.default.axios.post('/auth/' + service + '/done', payload, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.data.status === 'success') {
          if (res.data.service === 'salesforce') {
            _this.authenticateUser(res);
          } else {
            var redirectTo = window.localStorage.getItem('redirectTo');
            window.localStorage.removeItem('service');
            window.localStorage.removeItem('redirectTo');
            window.location.href = redirectTo;
          }
        } else {
          window.localStorage.clear();
          _vue2.default.toasted.show(res.data.msg || _this.$t('COMMON.MSG_ERROR'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    authenticateUser: function authenticateUser(res) {
      var _this2 = this;

      var data = new window.FormData();
      data.append('auth[unique_id]', res.data.unique_id);
      _vue2.default.axios.post('/user_token', data).then(function (res) {
        if (res.data.status === 'created') {
          window.localStorage.setItem('idToken', res.data.token.token);
          window.localStorage.setItem('accountId', (0, _cryptojs_utils.encryptParams)(res.data.account_id));
          window.localStorage.setItem('accountName', (0, _cryptojs_utils.encryptParams)(res.data.account_name));
          window.localStorage.setItem('role', res.data.role);
          window.localStorage.setItem('endDate', res.data.end_date);
          window.localStorage.setItem('email', res.data.email);
          window.localStorage.setItem('userId', res.data.user_id);
          window.localStorage.setItem('selectedRoles', JSON.stringify(res.data.selected_roles));
          window.localStorage.setItem('userRoleOrder', res.data.user_role_order);
          window.localStorage.setItem('mode', 'service');
          _this2.$store.dispatch('autoLogin');
          _this2.$store.dispatch('setMetaData');
          var redirectTo = window.localStorage.getItem('redirectTo');
          window.localStorage.removeItem('service');
          window.localStorage.removeItem('redirectTo');
          window.location.href = redirectTo;
        }
      });
    }
  }
};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _formDataTree = __webpack_require__(1028);

var _formDataTree2 = _interopRequireDefault(_formDataTree);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      templateLoaded: false,
      templateDoc: {},
      dataBus: new _vue2.default(),
      formData: {},
      singleSelectGroups: {},
      formErrors: {},
      showErrors: false
    };
  },
  created: function created() {
    var _this = this;

    this.dataBus.$on('updateFormField', function (templateId, id, value, parentId, parentType) {
      _this.updateFormField(templateId, id, value, parentId, parentType);
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    _vue2.default.axios.get('/submissions/' + this.$route.params.tempDocId).then(function (res) {
      if (res.data.success) {
        var templateDoc = res.data.templateDoc;
        var formData = {};
        var singleSelectGroups = {};
        templateDoc.templates.forEach(function (template) {
          console.log('template = ', template);
          if (template.mappings) {
            _this2.initializeSingleSelectGroups(singleSelectGroups, template.mappings.children);
            formData[template.id] = _this2.initializeFormData({}, template.mappings.children);
          }
        });
        _this2.templateDoc = templateDoc;
        _this2.formData = formData;
        _this2.singleSelectGroups = singleSelectGroups;
        _this2.templateLoaded = true;
      } else {
        _vue2.default.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' });
      }
    }).catch(function (error) {
      console.log(error);
    });
  },

  components: {
    'form-data-tree': _formDataTree2.default
  },
  methods: {
    initializeFormData: function initializeFormData(formData, mappings) {
      var _this3 = this;

      mappings.forEach(function (child) {
        if (child.map_type === 'shape') {
          formData[child.id] = child.data_type === 'checkbox' ? false : '';
        } else if (child.data_type !== 'table_column' || child.data_type !== 'table_row' || child.data_type !== 'table_entry' || child.data_type !== 'table_header') {
          _this3.initializeFormData(formData, child.children);
        }
      });
      return formData;
    },
    initializeSingleSelectGroups: function initializeSingleSelectGroups(singleSelectGroups, mappings) {
      var _this4 = this;

      mappings.forEach(function (child) {
        if (child.map_type === 'group') {
          if (child.data_type === 'single_select') {
            singleSelectGroups[child.id] = child.children.map(function (option) {
              return option.id;
            });
          } else {
            _this4.initializeSingleSelectGroups(singleSelectGroups, child.children);
          }
        }
      });
      return singleSelectGroups;
    },
    updateFormField: function updateFormField(templateId, id, value, parentId, parentType) {
      var _this5 = this;

      if (parentType === 'single_select') {
        this.singleSelectGroups[parentId].forEach(function (optionId) {
          if (optionId !== id && _this5.formData[templateId][optionId]) {
            _this5.formData[templateId][optionId] = false;
          }
        });
      }
      this.formData[templateId][id] = value;
    },
    validateFormEntry: function validateFormEntry(formErrors, templateId, mappings) {
      var _this6 = this;

      mappings.forEach(function (child) {
        if (child.map_type === 'shape') {
          if (child.required && !_this6.formData[templateId][child.id]) {
            formErrors[child.id] = true;
          }
        } else {
          if ((child.data_type === 'single_select' || child.data_type === 'multi_select') && child.required) {
            formErrors[child.id] = true;
            child.children.forEach(function (option) {
              if (_this6.formData[templateId][option.id]) {
                formErrors[child.id] = false;
              }
            });
          } else if (child.data_type !== 'table_column' || child.data_type !== 'table_row' || child.data_type !== 'table_entry' || child.data_type !== 'table_header') {
            _this6.validateFormEntry(formErrors, templateId, child.children);
          }
        }
      });
      return formErrors;
    },
    validateFormData: function validateFormData() {
      var _this7 = this;

      this.formErrors = {};
      var formErrors = {};
      this.templateDoc.templates.forEach(function (template) {
        if (template.mappings) {
          _this7.validateFormEntry(formErrors, template.id, template.mappings.children);
        }
      });
      var errors = Object.values(formErrors).filter(Boolean).length;
      this.formErrors = errors > 0 ? formErrors : {};
      this.showErrors = errors > 0;
      return errors === 0;
    },
    submitForm: function submitForm() {
      var _this8 = this;

      var isValid = this.validateFormData();
      if (isValid) {
        this.templateLoaded = false;
        _vue2.default.axios.post('/submissions/submit', { templateDocId: this.templateDoc.id, formData: JSON.stringify(this.formData) }).then(function (res) {
          _vue2.default.toasted.show(res.data.msg);
          var templateDoc = Object.assign({}, _this8.templateDoc);
          _this8.templateDoc = {};
          _this8.formData = {};
          _this8.formErrors = {};
          _this8.showErrors = false;
          _this8.resetData(templateDoc);
        }).catch(function (error) {
          console.log('error', error);
        });
      }
    },
    resetData: function resetData(templateDoc) {
      var _this9 = this;

      setTimeout(function () {
        var formData = {};
        templateDoc.templates.forEach(function (template) {
          formData[template.id] = _this9.initializeFormData({}, template.mappings.children);
        });
        _this9.templateDoc = templateDoc;
        _this9.formData = formData;
        _this9.templateLoaded = true;
      }, 1000);
    }
  }
};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vue2Datepicker = __webpack_require__(98);

var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);

var _vueSignaturePad = __webpack_require__(1030);

var _vueSignaturePad2 = _interopRequireDefault(_vueSignaturePad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueSignaturePad2.default); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'form-data-tree',
  props: ['templateId', 'mappings', 'dataBus', 'showErrors', 'formErrors'],
  data: function data() {
    return {
      options: {
        penColor: '#000000'
      }
    };
  },

  components: {
    'date-picker': _vue2Datepicker2.default
  },
  methods: {
    shouldShowError: function shouldShowError(id) {
      return this.showErrors && this.formErrors[id];
    },
    undoSignature: function undoSignature(id) {
      this.$refs['signaturePad_' + id][0].undoSignature();
    },
    resetSignature: function resetSignature(id) {
      this.$refs['signaturePad_' + id][0].clearSignature();
    },
    saveSignature: function saveSignature(id) {
      var _$refs$0$saveSignatur = this.$refs['signaturePad_' + id][0].saveSignature(),
          data = _$refs$0$saveSignatur.data;

      this.dataBus.$emit('updateFormField', this.templateId, id, data || '');
    },
    updateFormField: function updateFormField(event, id, dataType) {
      var parentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var parentType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      var value = dataType === 'checkbox' ? event.target.checked : event.target.value && event.target.value.trim();
      this.dataBus.$emit('updateFormField', this.templateId, id, value, parentId, parentType);
    }
  }
};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _SearchBar = __webpack_require__(185);

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'list',
  data: function data() {
    return {
      seletedTemplateId: '',
      seletedTemplateTitle: '',
      templatesLoaded: false,
      templateLoadingContents: [1, 2, 3, 4, 5, 6],
      tableFields: [{ key: 'id', sortable: true, label: 'TEMPLATE_VIEW.ID' }, { key: 'title', sortable: true, label: 'COMMON.NAME' }, { key: 'total_pages', sortable: true, label: 'TEMPLATE_VIEW.TOTAL_PAGES' }, { key: 'brand', sortable: true, label: 'TEMPLATE_VIEW.BRAND' }, { key: 'updated_at', sortable: true, label: 'TEMPLATE_VIEW.UPDATED_AT' }, { key: 'actions', label: 'COMMON.ACTIONS' }],
      users: [],
      gridView: false,
      filter: null,
      pages: [],
      selectedPageNo: null,
      fields: [],
      selectedField: null,
      sortDesc: true,
      sortBy: 'updated_at'
    };
  },

  components: {
    SearchBar: _SearchBar2.default
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var _this = this;

    next(function (vm) {
      if (vm.isAdminRole) {
        next();
      } else {
        _router2.default.replace('/Not-Found-404');
        _vue2.default.toasted.show(vm.$t('COMMON.UNAUTHORIZED'), { icon: 'chain-broken', type: 'error' });
      }
      _vue2.default.axios.get('template_docs', { headers: { Authorization: 'Bearer ' + vm.idToken }, params: { time_zone_offset: vm.localTime === 'true' ? new Date().getTimezoneOffset() : null } }).then(function (res) {
        vm.templatesLoaded = true;
        vm.$store.commit('fetchTemplates', res.data.template_docs);
      }).catch(function (error) {
        if (error && error.status === 401) {
          _vue2.default.toasted.show(vm.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(vm.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          next(false);
        }
      });
    });
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['templateList', 'noTemplates', 'idToken', 'isAdminRole', 'localTime'])),
  watch: {
    selectedPageNo: function selectedPageNo(newSelected, oldSelected) {
      if (newSelected) {
        this.fetchFields();
      }
    }
  },
  methods: _extends({}, (0, _vuex.mapActions)(['removeTemplate']), {
    confirmModal: function confirmModal(temp) {
      this.seletedTemplateId = temp.id;
      this.seletedTemplateTitle = temp.title;
      this.$refs.tempModal.show();
    },
    deleteTemplate: function deleteTemplate() {
      this.removeTemplate({ id: this.seletedTemplateId });
      this.seletedTemplateId = '';
      this.seletedTemplateTitle = '';
    },
    toggleViews: function toggleViews(viewType) {
      this.gridView = viewType === 'grid';
    },
    templateApi: function templateApi(id) {
      var exportRef = this.$refs['export-rems-' + id];
      var spinnerRef = this.$refs['spinner-rems-' + id];
      exportRef.style.display = 'none';
      spinnerRef.style.display = 'inherit';
      _vue2.default.axios.post('/rems/rems_sf/rems_export_template_mappings', { id: id }, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        spinnerRef.style.display = 'none';
        exportRef.style.display = 'inherit';
        _vue2.default.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' });
      }).catch(function (err) {
        console.log(err);
        spinnerRef.style.display = 'none';
        exportRef.style.display = 'inherit';
        _vue2.default.toasted.show('failed during export', { icon: 'chain-broken', type: 'error' });
      });
    },
    setFilter: function setFilter(filter) {
      this.filter = filter;
    },
    enableForm: function enableForm() {
      var payload = {
        template_doc_id: this.seletedTemplateId,
        is_public: true,
        template_mapping_id: this.selectedField
      };
      this.changeStatus(payload);
    },
    disableForm: function disableForm(templateDocId) {
      var payload = {
        template_doc_id: templateDocId,
        is_public: false
      };
      this.changeStatus(payload);
    },
    openSubmitFormStatusModal: function openSubmitFormStatusModal(currentTemplates, status) {
      this.seletedTemplateId = currentTemplates.id;
      var templates = currentTemplates.templates;
      this.selectedPageNo = null;
      this.pages = [{ text: 'Select Page', value: null, disabled: true }].concat(templates.map(function (template) {
        return { text: 'Page ' + template.original_page_no, value: { id: template.id, latest_revision_id: template.latest_revision_id } };
      }));
      this.$refs.submitFormStatus.show();
    },
    changeStatus: function changeStatus(payload) {
      var _this2 = this;

      _vue2.default.axios.post('template_docs/modify_status', payload, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.data.success) {
          _this2.$store.state.templateList = _this2.templateList.map(function (template) {
            if (template.id === res.data.template_doc.id) {
              template.is_public = res.data.template_doc.is_public;
            }
            return template;
          });
          _this2.$refs.submitFormStatus.hide();
          _vue2.default.toasted.show('Updated Sucessfully');
        } else {
          _vue2.default.toasted.show(res.data.msg, { type: 'error' });
        }
      }).catch(function (error) {
        console.log(error);
        _vue2.default.toasted.show(_this2.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
      });
    },
    fetchFields: function fetchFields() {
      var _this3 = this;

      _vue2.default.axios.get('templates/fetch_mappings_for_title', { headers: { Authorization: 'Bearer ' + this.idToken }, params: this.selectedPageNo }).then(function (res) {
        _this3.fields = res.data.mappings.map(function (field) {
          return { text: field.key, value: field.id };
        });
        _this3.selectedField = _this3.fields[0]['value'];
      }).catch(function (error) {
        console.log(error);
        _vue2.default.toasted.show(_this3.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
      });
    }
  })
};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svg = __webpack_require__(28);

var _svg2 = _interopRequireDefault(_svg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      svg: _svg2.default,
      showClear: false
    };
  },

  props: {
    title: String
  },
  methods: {
    emitInput: function emitInput(input) {
      this.$emit('filterInput', input);
      if (input !== '') this.showClear = true;else this.showClear = false;
    },
    clearFilter: function clearFilter() {
      this.$refs.searchInput.$el.value = '';
      this.emitInput('');
      this.showClear = false;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _validators = __webpack_require__(32);

var _vuex = __webpack_require__(5);

var _vue2Dropzone = __webpack_require__(186);

var _vue2Dropzone2 = _interopRequireDefault(_vue2Dropzone);

__webpack_require__(188);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'new-template',
  components: { vueDropzone: _vue2Dropzone2.default },
  data: function data() {
    return {
      template: {
        title: '',
        description: '',
        accountId: '',
        uploading: false,
        brand: ''
      },
      brands: [],
      isDropzoneBlank: false,
      preferredMethod: 'upload',
      clone: {
        accounts: [],
        templates: [],
        selectedTemplate: null,
        selectedFromAccount: null,
        selectedToAccount: null
      },
      dropzoneOptions: {
        url: "/api" + '/template_docs',
        dictDefaultMessage: this.$t('FORMS.DROP_TEMP_SCANNED'),
        autoProcessQueue: false,
        thumbnailWidth: 100,
        thumbnailHeight: 150,
        maxFilesize: 20,
        maxFiles: 1,
        timeout: 300000,
        acceptedFiles: 'application/pdf, image/*, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,application/rtf, application/x-rtf, text/rtf, text/richtext, application/msword, application/doc, application/x-soffice',
        headers: { 'Authorization': '' },
        init: function init() {
          this.on('addedfile', function (file) {
            file.previewElement.querySelector('.dz-details').style.backgroundColor = '#0b192d';
            var removeButton = document.createElement('div');
            removeButton.className = 'removeFormButton';
            removeButton.style.cssText = 'opacity:1;z-index:1000;position:absolute;top:5px;right:5px;color:white;';
            removeButton.innerHTML = '<i class="fa fa-trash"></i>';
            var _this = this;

            removeButton.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();

              _this.removeFile(file);
            });

            file.previewElement.appendChild(removeButton);
          });
        }
      }
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'accountId', 'isSuperAdmin', 'isAdminRole']), {
    canShowDropZone: function canShowDropZone() {
      this.dropzoneOptions.headers['Authorization'] = 'Bearer ' + this.idToken;
      return this.idToken !== '';
    },
    disableSave: function disableSave() {
      return !(this.$v.$invalid && !this.$v.$dirty || !this.$v.$invalid);
    },
    disableClone: function disableClone() {
      return !(this.clone.selectedToAccount && this.clone.selectedTemplate && this.clone.selectedToAccount);
    },
    brandNames: function brandNames() {
      return this.brands.map(function (brand) {
        return brand.name;
      });
    }
  }),
  created: function created() {
    var _this2 = this;

    if (this.isSuperAdmin) {
      _vue2.default.axios.get('/admin/accounts', { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        var accounts = res.data.accounts.map(function (account) {
          return { value: account.id, text: account.name };
        });
        accounts.unshift({ value: null, text: _this2.$t('TEMPLATE.SELECT_ACCOUNT') });
        _this2.clone.accounts = accounts;
      }).catch(function (err) {
        if (err.status === 401) {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this2.$t('COMMON.MSG_EXPIRED'));
        }
      });
    }
  },
  mounted: function mounted() {
    this.fetchBrands();
  },

  methods: {
    fetchBrands: function fetchBrands() {
      var _this3 = this;

      this.loading = true;
      _vue2.default.axios.get('/brands').then(function (res) {
        _this3.brands = res.data;
      });
    },
    onExceedingMaxFiles: function onExceedingMaxFiles() {
      _vue2.default.toasted.show(this.$t('COMMON.MSG_TEMP_FILE_LIMIT'), { icon: 'chain-broken', type: 'error' });
    },
    sendingEvent: function sendingEvent(file, xhr, formData) {
      if (this.template.title) {
        formData.append('title', this.template.title);
      } else {
        formData.append('title', file.name);
      }
      formData.append('account_id', this.accountId);
      formData.append('image', file);
      formData.append('brand', this.template.brand);
    },
    onAddingFile: function onAddingFile() {
      this.$refs.formProcessDropZone.dropzone.files.length ? this.isDropzoneBlank = false : this.isDropzoneBlank = true;
    },
    onError: function onError(error) {
      var _this4 = this;

      this.$refs.uploadText.innerText = this.$t('COMMON.SAVE');
      this.template.uploading = false;
      this.$nextTick(function () {
        _this4.$v.$reset();
      });
      var errorMessage = JSON.parse(error.xhr.response).errors;
      _vue2.default.toasted.show(errorMessage, { icon: 'chain-broken', type: 'error' });
    },
    onSuccess: function onSuccess() {
      _vue2.default.toasted.show(this.$t('COMMON.MSG_TEMP_NAME_SUCCESS'), { type: 'success' });
      _router2.default.push({ path: '/templates/list' });
    },

    formUpload: function formUpload() {
      if (this.$refs.formProcessDropZone.dropzone.files.length === 1 && this.template.title) {
        var myDropzone = this.$refs.formProcessDropZone.dropzone;
        this.uploadStart();
        myDropzone.processQueue();
        myDropzone.on('complete', function (file) {
          myDropzone.removeFile(file);
        });
      } else if (this.$refs.formProcessDropZone.dropzone.files.length > 1) {
        this.$v.template.$touch();
        this.onExceedingMaxFiles();
      } else {
        this.$refs.formProcessDropZone.dropzone.files.length ? this.isDropzoneBlank = false : this.isDropzoneBlank = true;
        this.$v.template.$touch();
      }
    },
    uploadStart: function uploadStart() {
      this.$refs.uploadText.innerText = this.$t('FORMS.UPLOADING');
      this.template.uploading = true;
    },
    onRemovingFile: function onRemovingFile() {
      var myDropzone = this.$refs.formProcessDropZone.dropzone;
      myDropzone.files.length ? this.isDropzoneBlank = false : this.isDropzoneBlank = true;
      if (myDropzone.getRejectedFiles().length > 0 && myDropzone.getAcceptedFiles().length < myDropzone.options.maxFiles) {
        myDropzone.getRejectedFiles()[0]['status'] = 'queued';
        myDropzone.getRejectedFiles()[0]['previewTemplate']['classList'].remove('dz-error');
        myDropzone.getRejectedFiles()[0]['previewTemplate']['classList'].remove('dz-complete');
        myDropzone.getRejectedFiles()[0]['accepted'] = true;
      }
    },
    onReset: function onReset() {
      var _this5 = this;

      this.template = { title: '', description: '', file: '' };
      this.$refs.templateFile.reset();
      this.disableButton = false;
      this.$nextTick(function () {
        _this5.$v.$reset();
      });
    },

    updatePreferredMethod: function updatePreferredMethod(method) {
      this.preferredMethod = method;
    },
    handleAccountChange: function handleAccountChange() {
      var _this6 = this;

      this.clone.tempates = [];
      this.clone.selectedTemplate = null;
      _vue2.default.axios.get('/template_docs/list_docs?account_id=' + this.clone.selectedFromAccount, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        var templateDocs = res.data.template_docs.map(function (template) {
          return { value: template.id, text: template.title };
        });
        templateDocs.unshift({ value: null, text: _this6.$t('TEMPLATE.SELECT_TEMPLATE') });
        _this6.clone.templates = templateDocs;
      });
    },
    cloneNewTemplate: function cloneNewTemplate() {
      var data = {};
      data['template_doc_id'] = this.clone.selectedTemplate;
      data['account_id'] = this.clone.selectedToAccount;
      _vue2.default.axios.post('/template_docs/clone', data, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.data.status === 'success') {
          _vue2.default.toasted.show(res.data.msg);
        } else {
          _vue2.default.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' });
        }
      });
    }
  },
  validations: {
    template: {
      title: {
        required: _validators.required,
        maxLength: (0, _validators.maxLength)(30),
        minLength: (0, _validators.minLength)(3),
        valid: function valid(value) {
          var regexExp = /^[a-zA-Z0-9 _-]*$/.test(value);
          return regexExp;
        }
      },
      brand: {
        required: _validators.required
      }
    }
  }
};

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _fetchTemplate = __webpack_require__(1046);

var _fetchTemplate2 = _interopRequireDefault(_fetchTemplate);

var _konvaCreator = __webpack_require__(1047);

var _konvaCreator2 = _interopRequireDefault(_konvaCreator);

var _drawShape = __webpack_require__(1048);

var _drawShape2 = _interopRequireDefault(_drawShape);

var _KonvaEditor = __webpack_require__(1049);

var _KonvaEditor2 = _interopRequireDefault(_KonvaEditor);

var _populateMapping = __webpack_require__(1050);

var _populateMapping2 = _interopRequireDefault(_populateMapping);

var _konvaTransformer = __webpack_require__(1051);

var _konvaTransformer2 = _interopRequireDefault(_konvaTransformer);

var _zoom = __webpack_require__(1052);

var _zoom2 = _interopRequireDefault(_zoom);

var _tools = __webpack_require__(1053);

var _tools2 = _interopRequireDefault(_tools);

var _contextMenu = __webpack_require__(1054);

var _contextMenu2 = _interopRequireDefault(_contextMenu);

var _keyBindings = __webpack_require__(1055);

var _keyBindings2 = _interopRequireDefault(_keyBindings);

var _editorHistory = __webpack_require__(1059);

var _editorHistory2 = _interopRequireDefault(_editorHistory);

var _themes = __webpack_require__(1060);

var _themes2 = _interopRequireDefault(_themes);

var _utils = __webpack_require__(1061);

var _utils2 = _interopRequireDefault(_utils);

var _templateMappings = __webpack_require__(1062);

var _templateMappings2 = _interopRequireDefault(_templateMappings);

var _newMapping = __webpack_require__(1065);

var _newMapping2 = _interopRequireDefault(_newMapping);

var _newGrouping = __webpack_require__(1068);

var _newGrouping2 = _interopRequireDefault(_newGrouping);

var _newNpiGrouping = __webpack_require__(1071);

var _newNpiGrouping2 = _interopRequireDefault(_newNpiGrouping);

var _templateMappings3 = __webpack_require__(1074);

var _templateMappings4 = _interopRequireDefault(_templateMappings3);

var _groupMappings = __webpack_require__(1075);

var _groupMappings2 = _interopRequireDefault(_groupMappings);

var _groupShapes = __webpack_require__(1076);

var _groupShapes2 = _interopRequireDefault(_groupShapes);

var _contextMenu3 = __webpack_require__(1077);

var _contextMenu4 = _interopRequireDefault(_contextMenu3);

var _saveEditor = __webpack_require__(1080);

var _saveEditor2 = _interopRequireDefault(_saveEditor);

var _editMapping = __webpack_require__(1081);

var _editMapping2 = _interopRequireDefault(_editMapping);

var _pagination = __webpack_require__(338);

var _pagination2 = _interopRequireDefault(_pagination);

var _barcode = __webpack_require__(1083);

var _barcode2 = _interopRequireDefault(_barcode);

var _npiGroupMappings = __webpack_require__(1084);

var _npiGroupMappings2 = _interopRequireDefault(_npiGroupMappings);

var _Switch = __webpack_require__(70);

var _Switch2 = _interopRequireDefault(_Switch);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _vuex = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = {
  name: 'train',
  data: function data() {
    return {
      mappingData: null,
      file: '',
      text: '',
      info: '',
      imagename: '',
      imageFileName: '',
      mappingPayload: {},
      isFileSelected: false,
      update_esm_status: true
    };
  },

  mixins: [_fetchTemplate2.default, _konvaCreator2.default, _drawShape2.default, _KonvaEditor2.default, _populateMapping2.default, _konvaTransformer2.default, _zoom2.default, _tools2.default, _contextMenu2.default, _keyBindings2.default, _editorHistory2.default, _themes2.default, _utils2.default, _templateMappings4.default, _groupMappings2.default, _groupShapes2.default, _saveEditor2.default, _pagination2.default, _barcode2.default, _npiGroupMappings2.default],
  components: {
    'template-mappings': _templateMappings2.default,
    'new-mapping': _newMapping2.default,
    'new-grouping': _newGrouping2.default,
    'new-npiGrouping': _newNpiGrouping2.default,
    'context-menu': _contextMenu4.default,
    'edit-mapping': _editMapping2.default,
    'c-switch': _Switch2.default
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (to.query.version) {
        vm.fetchTemplateWithOutGaurd(to.query.version);
      }
      if (vm.isAdminRole) {
        next();
      } else {
        _router2.default.replace('/not-Found-404');
        _vue2.default.toasted.show(vm.$t('COMMON.UNAUTHORIZED'), { icon: 'chain-broken', type: 'error' });
      }
    });
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['isAdminRole']), {
    orderOptionsForNewMapping: function orderOptionsForNewMapping() {
      return [].concat(_toConsumableArray(Array(this.updatedNoOfMappings + 1).keys())).map(function (index) {
        return index + 1;
      });
    },
    orderOptionsForUpdateMapping: function orderOptionsForUpdateMapping() {
      return [].concat(_toConsumableArray(Array(this.updatedNoOfMappings).keys())).map(function (index) {
        return index + 1;
      });
    }
  }),
  methods: {
    autoCorrectSwitchChange: function autoCorrectSwitchChange(event) {
      this.trainTemplate.auto_correct_flag = event;
      console.log('template_doc_id: ', this.trainTemplate);
      var apiData = new window.FormData();
      apiData.append('auto_correct_flag', this.trainTemplate.auto_correct_flag);
      apiData.append('template_doc_id', this.trainTemplate.template_doc_id);
      _vue2.default.axios.post('template_docs/save_auto_correct_flag', apiData, { headers: { Authorization: 'Bearer ' + this.idToken } });
    },
    saveDataFunction: function saveDataFunction() {
      if (this.update_revision_id_status && (this.esm_status || this.sv_status || this.cv_status)) {
        this.$refs.updateEsmAlert.show();
      } else {
        this.update_esm_status = false;
        this.saveData(this.update_esm_status, this.esm_status, this.sv_status, this.cv_status);
      }
    },
    dontSaveEsmData: function dontSaveEsmData() {
      this.$refs.updateEsmAlert.hide();
      this.update_esm_status = false;
      this.saveData(this.update_esm_status, this.esm_status, this.sv_status, this.cv_status);
    },
    showDeleteModal: function showDeleteModal() {
      this.$refs.deleteMappings.show();
    },
    hideDeleteModal: function hideDeleteModal() {
      this.$refs.deleteMappings.hide();
      this.canDelete = false;
    },
    showImportModal: function showImportModal() {
      this.$refs.importModal.show();
    },
    hideImportModal: function hideImportModal() {
      this.$refs.importModal.hide();
    },
    saveImportMappings: function saveImportMappings() {
      var _this = this;

      _vue2.default.axios.post('template_mappings/import_mappings', this.mappingPayload, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _vue2.default.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' });
        _this.$refs.importModal.hide();
        if (!res.data.error) {
          _router2.default.go();
        }
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this.$t('COMMON.MSG_EXPIRED'));
        } else if (error.status === 500) {
          _vue2.default.toasted.show(_this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },

    mappingDownload: function mappingDownload() {
      var _this2 = this;

      _vue2.default.axios.get('template_mappings/export_mappings', { headers: { Authorization: 'Bearer ' + this.idToken }, params: { id: this.$route.params.id, revision_id: this.revisionVersionSelected } }).then(function (res) {
        _this2.mappingData = res;
        var data = JSON.stringify(_this2.mappingData.data.mappings);
        var templateName = _this2.trainTemplate.title.replace(/\s+/g, '_');
        var filename = templateName + '_version' + _this2.revisionVersionSelected + '.txt';
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(data));
        element.setAttribute('Download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this2.$t('COMMON.MSG_EXPIRED'));
        } else if (error.status === 500) {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    handleFileUpload: function handleFileUpload() {
      var _this3 = this;

      this.file = this.$refs.file.files[0];
      this.isFileSelected = true;
      var reader = new window.FileReader();
      reader.onload = function (evt) {
        _this3.text = JSON.parse(evt.target.result);
        var payload = {
          template_id: _this3.$route.params.id,
          revison_id: _this3.revisionVersionSelected,
          template_name: _this3.trainTemplate.title,
          mapping_data: _this3.text
        };
        _this3.mappingPayload = payload;
      };
      reader.readAsText(this.file);
    }
  }
};

/***/ }),
/* 331 */,
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  props: ['templateMappings', 'mappings', 'isLatestVersion'],
  data: function data() {
    return {
      listTypes: [{ value: null, text: 'Please select data type' }, { value: 'alpha', text: 'Alphabets' }, { value: 'alphanumeric', text: 'Alphanumeric' }, { value: 'alphanumeric_with_space', text: 'Alphanumeric With Spaces' }, { value: 'numeric_with_decimal', text: 'Numeric With Decimal' }, { value: 'checkbox', text: 'Checkbox' }, { value: 'city', text: 'City' }, { value: 'cod', text: 'COD' }, { value: 'date', text: 'Date' }, { value: 'email', text: 'Email' }, { value: 'fax', text: 'Fax' }, { value: 'npi', text: 'NPI' }, { value: 'numeric', text: 'Numeric' }, { value: 'phone', text: 'Phone' }, { value: 'signature', text: 'Signature' }, { value: 'state', text: 'State' }, { value: 'text', text: 'Text' }, { value: 'zip', text: 'ZIP' }],
      updateMapping: {
        key: null,
        type: null,
        description: null,
        required: false,
        extract: true,
        extract_by_words: false,
        redact_field: true,
        show_field: true,
        sensitiveData: false,
        order: null,
        uniqId: null
      },
      containerHeight: 0
    };
  },

  computed: {
    blankTemplateMappings: function blankTemplateMappings() {
      return this.mapTreeData && this.mapTreeData.length === 0;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$root.$on('setHeightMappings', function (Height) {
      _this.containerHeight = Height;
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('setHeightMappings', this.containerHeight);
  },

  methods: {
    editMapping: function editMapping(node) {
      this.$emit('nodeSelected', node);
    },
    highlight: function highlight(node) {
      this.removeHighlight();
      if (node.type !== 'Layer') {
        this.mappings.find('Rect').forEach(function (shape) {
          if (shape.attrs.key && node.title.toLowerCase() === shape.attrs.key.toLowerCase()) {
            shape.setAttrs({
              fillEnabled: true,
              name: 'selected',
              fill: 'yellow',
              opacity: 0.5
            });
          } else if (shape.attrs.parentKey && node.title.toLowerCase() === shape.attrs.parentKey.toLowerCase()) {
            shape.setAttrs({
              fillEnabled: true,
              name: 'selected',
              fill: shape.index > 0 ? '#63c2de' : 'yellow',
              opacity: 0.5
            });
          }
        });
      }
      this.mappings.draw();
    },
    removeHighlight: function removeHighlight() {
      this.mappings.find('.selected').forEach(function (shape) {
        shape.setAttrs({
          name: '',
          fillEnabled: false,
          opacity: 1.0
        });
      });
    },
    customTemplate: function customTemplate(node, ctx) {
      var _this2 = this;

      var h = this.$createElement;

      var titleClass = node.required ? 'node-title node-title-required' : 'node-title';
      var order = node.order ? ' - (' + node.order + ')' : '';
      if (this.isLatestVersion) {
        return h('span', { 'class': titleClass, domProps: {
            'innerHTML': node.title + (node.date_format ? ' (' + node.date_format + ')' : '') + order
          },
          on: {
            'mouseover': function mouseover() {
              return _this2.highlight(node);
            },
            'click': function click() {
              return _this2.editMapping(node);
            }
          }
        });
      } else {
        return h('span', { 'class': titleClass, domProps: {
            'innerHTML': node.title + (node.date_format ? ' (' + node.date_format + ')' : '') + order
          },
          on: {
            'mouseover': function mouseover() {
              return _this2.highlight(node);
            }
          }
        });
      }
    }
  }
};

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vuex = __webpack_require__(5);

var _vueMultiselect = __webpack_require__(36);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { Multiselect: _vueMultiselect2.default },
  props: ['mappingsKeys', 'showNewMapping', 'orderOptions', 'mappingsOrderValues'],
  data: function data() {
    return {
      mapping: {
        key: null,
        type: null,
        category: 'default',
        order: null,
        case: null,
        description: null,
        required: false,
        extract: true,
        extract_by_words: false,
        redact_field: false,
        show_field: true,
        sensitive_data: false,
        key_alias: [],
        isKeyUnique: false,
        dateFormat: null,
        date_category: null
      },
      mappingCategories: [{ value: 'default', text: this.$t('DATA_TYPE.DEFAULT') }, { value: 'block', text: this.$t('DATA_TYPE.BLOCK') }],
      caseCategories: [{ value: null, text: this.$t('TEMPLATE.SELECT_CASE') }, { value: 'capitalize', text: this.$t('DATA_TYPE.CAPITALIZE') }, { value: 'upper_case', text: this.$t('DATA_TYPE.UPPER_CASE') }, { value: 'lower_case', text: this.$t('DATA_TYPE.LOWER_CASE') }],
      listTypes: [{ value: null, text: this.$t('TEMPLATE.SELECT_DATA_TYPE') }, { value: 'alpha', text: this.$t('DATA_TYPE.ALPHA') }, { value: 'alphanumeric', text: this.$t('DATA_TYPE.ALPHANUM') }, { value: 'alphanumeric_with_space', text: this.$t('DATA_TYPE.ALPHANUMSPC') }, { value: 'numeric_with_decimal', text: this.$t('DATA_TYPE.NUMERICDEC') }, { value: 'checkbox', text: this.$t('DATA_TYPE.CHECKBOX') }, { value: 'city', text: this.$t('DATA_TYPE.CITY') }, { value: 'cod', text: 'COD' }, { value: 'date', text: this.$t('DATA_TYPE.DATE') }, { value: 'email', text: 'Email' }, { value: 'fax', text: 'Fax' }, { value: 'npi', text: 'NPI' }, { value: 'numeric', text: this.$t('DATA_TYPE.NUMERIC') }, { value: 'phone', text: 'Phone' }, { value: 'signature', text: 'Signature' }, { value: 'state', text: this.$t('DATA_TYPE.STATE') }, { value: 'text', text: this.$t('DATA_TYPE.TEXT') }, { value: 'zip', text: 'ZIP' }],
      dateFormatList: [{ value: null, text: this.$t('TEMPLATE.SELECT_DATE_FORMAT') }, { value: 'dd mm yyyy', text: 'dd mm yyyy' }, { value: 'mm dd yyyy', text: 'mm dd yyyy' }, { value: 'yyyy mm dd', text: 'yyyy mm dd' }, { value: 'yyyy dd mm', text: 'yyyy dd mm' }],
      dateCategoryList: [{ value: 'normal_date', text: 'Normal Date' }, { value: 'dob', text: 'DOB' },
      // { value: 'expire_date', text: 'Expiration Date' },
      { value: 'future_date', text: 'Future Date' }],
      canExtract: true,
      canShowRequired: false,
      aliasOptions: [],
      selectedAliasData: [],
      requiredNATypes: [undefined, null]
    };
  },

  watch: {
    showNewMapping: function showNewMapping() {
      if (this.showNewMapping) {
        if (this.isAdminRole) {
          this.resetData();
          this.mapping.order = this.orderOptions.length;
          this.$refs.mapModalRef.show();
        } else {
          this.$refs.agnetNewMappingModal.show();
        }
      } else {
        this.$refs.mapModalRef.hide();
      }
    },
    'mapping.key': function mappingKey(key) {
      this.mapping.isKeyUnique = key ? this.mappingsKeys.indexOf(key.toLowerCase().replace(/\s/g, '')) === -1 : false;
    },
    'mapping.type': function mappingType(type) {
      if (type === 'date') {
        this.mapping.date_category = 'normal_date';
        _vue2.default.toasted.show('Date Category auto selected to Normal Date', { type: 'info' });
      } else {
        this.mapping.date_category = null;
      }
    }
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['isAdminRole'])),
  methods: {
    clearDrawing: function clearDrawing() {
      this.$refs.agnetNewMappingModal.hide();
      this.$emit('cancelled');
    },
    focusOnInput: function focusOnInput() {
      this.$refs.fieldKey.focus();
    },
    resetData: function resetData() {
      this.mapping.key = null;
      this.mapping.type = null;
      this.mapping.category = 'default';
      this.mapping.order = null;
      this.mapping.case = null;
      this.mapping.description = null;
      this.mapping.required = false;
      this.mapping.extract = true;
      this.mapping.extract_by_words = true;
      this.mapping.redact_field = true;
      this.mapping.show_field = true;
      this.mapping.sensitive_data = false;
      this.mapping.key_alias = [];
      this.mapping.dateFormat = null;
      this.mapping.date_category = null;
      this.aliasOptions = [];
      this.selectedAliasData = [];
    },
    createNewMapping: function createNewMapping() {
      this.mapping.key_alias = this.selectedAliasData;
      this.$emit('created', this.mapping);
    },
    cancelMapping: function cancelMapping() {
      this.$refs.mapModalRef.hide();
      this.$emit('cancelled');
    },
    cancelNewMapping: function cancelNewMapping() {
      this.$emit('cancelled');
    },
    handleRequired: function handleRequired() {
      this.dateFormat = null;
      if (this.mapping.type === 'signature') {
        this.mapping.required = true;
        this.canShowRequired = true;
        this.canExtract = true;
      } else if (this.requiredNATypes.includes(this.mapping.type)) {
        this.mapping.required = false;
        this.canShowRequired = false;
      } else {
        this.mapping.required = false;
        this.canShowRequired = true;
        this.canExtract = true;
      }
    },
    addTag: function addTag(newTag) {
      this.selectedAliasData.push(newTag);
      this.aliasOptions.push(newTag);
    }
  }
};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vuex = __webpack_require__(5);

exports.default = {
  props: ['mappingsKeys', 'showNewGrouping', 'groupChildren', 'orderOptions', 'mappingsOrderValues'],
  data: function data() {
    return {
      group: {
        name: null,
        type: null,
        required: false,
        isNameUnique: false,
        order: null
      },
      groupTypes: [{ value: null, text: 'Please select type' }, { value: 'logical', text: this.$t('DATA_TYPE.LOGICAL') }, { value: 'name', text: this.$t('DATA_TYPE.NAME') }, { value: 'combine_data', text: this.$t('DATA_TYPE.COMBINE_DATA') }, { value: 'checkbox_text', text: this.$t('DATA_TYPE.CHECKBOX_TEXT') }, { value: 'single_select', text: this.$t('DATA_TYPE.EITHER') }, { value: 'multi_select', text: this.$t('DATA_TYPE.MULTI_CHOICE') }, { value: 'table_header', text: this.$t('DATA_TYPE.TABLE_HEADER') }, { value: 'table_entry', text: this.$t('DATA_TYPE.TABLE_ENTRY') }, { value: 'table_row', text: this.$t('DATA_TYPE.TABLE_ROW') }, { value: 'table_column', text: this.$t('DATA_TYPE.TABLE_COLUMN') }, { value: 'section', text: this.$t('DATA_TYPE.SECTION') }],
      canShowRequired: false,
      selectedChildren: []
    };
  },

  computed: _extends({
    validateGroupInfo: function validateGroupInfo() {
      return !!this.group.name && !!this.group.type && this.group.isNameUnique;
    }
  }, (0, _vuex.mapGetters)(['isAdminRole'])),
  watch: {
    showNewGrouping: function showNewGrouping() {
      if (this.showNewGrouping) {
        if (this.isAdminRole) {
          this.group.name = null;
          this.group.type = null;
          this.group.required = false;
          this.group.order = this.orderOptions.length;
          this.selectedChildren = this.groupChildren.map(function (child, index) {
            return child.attrs.uniq_id;
          });
          this.$refs.mapGroupRef.show();
        } else {
          this.$refs.agnetNewGroupingModal.show();
        }
      } else {
        this.$refs.mapGroupRef.hide();
      }
    },
    'group.name': function groupName(key) {
      this.group.isNameUnique = key ? this.mappingsKeys.indexOf(key.toString().toLowerCase().replace(/\s/g, '')) === -1 : false;
    }
  },
  methods: {
    focusOnInput: function focusOnInput() {
      this.$refs.groupName.focus();
    },
    clearGrouping: function clearGrouping() {
      this.$refs.agnetNewGroupingModal.hide();
      this.$emit('cancelled');
    },
    createNewGrouping: function createNewGrouping() {
      var selectedChildren = this.selectedChildren;
      this.$emit('created', this.group, selectedChildren);
      this.selectedChildren = [];
    },
    cancelGrouping: function cancelGrouping() {
      this.$refs.mapGroupRef.hide();
      this.$emit('cancelled');
    },
    cancelNewGrouping: function cancelNewGrouping() {
      this.$emit('cancelled');
    },
    handleRequired: function handleRequired() {
      if (this.group.type === 'single_select' || this.group.type === 'multi_select') {
        this.canShowRequired = true;
      } else {
        this.group.required = false;
        this.canShowRequired = false;
      }
    }
  }
};

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _validators = __webpack_require__(32);

var _vuex = __webpack_require__(5);

exports.default = {
  props: ['mappingsKeys', 'showNewNpiGrouping', 'templateMappings'],
  data: function data() {
    return {
      key: null,
      group: {
        npi: null,
        firstName: null,
        lastName: null,
        name: null,
        city: null,
        state: null,
        zip: null
      },
      groupTypes: [{ value: null, text: this.$t('COMMON.MSG_SELECT_TYPE') }],
      isKeyUnique: false
    };
  },

  validations: {
    group: {
      npi: {
        required: _validators.required
      }
    }
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['isAdminRole'])),
  watch: {
    key: function key(_key) {
      this.isKeyUnique = _key ? this.mappingsKeys.indexOf(_key.toLowerCase().replace(/\s/g, '')) === -1 : false;
    },
    showNewNpiGrouping: function showNewNpiGrouping() {
      var _this = this;

      if (this.showNewNpiGrouping) {
        if (this.isAdminRole) {
          this.key = null;
          this.group.npi = null;
          this.group.firstName = null;
          this.group.lastName = null;
          this.group.name = null;
          this.group.city = null;
          this.group.state = null;
          this.group.zip = null;
          var mappings = this.templateMappings.find('Rect').filter(function (shape) {
            return shape.attrs.edit_type === 'created';
          });
          mappings = mappings.map(function (map) {
            return map.attrs;
          });
          mappings.map(function (child) {
            if (!child.parentDataType) {
              _this.groupTypes.push({ value: child.key, text: child.key });
            }
          });
          this.$refs.mapGroupRef.show();
        } else {
          this.$refs.agnetNewNpiGroupingModal.show();
        }
      } else {
        this.groupTypes = [{ value: null, text: 'Please select type' }];
        this.$refs.mapGroupRef.hide();
      }
    }
  },
  methods: {
    focusOnInput: function focusOnInput() {
      this.$refs.groupName.focus();
    },
    clearGrouping: function clearGrouping() {
      this.$refs.agnetNewNpiGroupingModal.hide();
      this.$emit('cancelled');
    },
    createNewNpiGrouping: function createNewNpiGrouping() {
      this.$emit('created', this.key, this.group);
    },
    cancelNpiGrouping: function cancelNpiGrouping() {
      this.$refs.mapGroupRef.hide();
      this.$emit('cancelled');
    },
    cancelNewNpiGrouping: function cancelNewNpiGrouping() {
      this.$emit('cancelled');
    }
  }
};

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      top: '0px',
      left: '0px'
    };
  },

  props: ['viewMenu', 'disableCut', 'disableCopy', 'disablePaste', 'disableDelete', 'pageX', 'pageY'],
  watch: {
    viewMenu: function viewMenu() {
      if (this.viewMenu) {
        var vm = this;
        _vue2.default.nextTick(function () {
          var largestWidth = window.innerWidth - vm.$refs.rightMenu.offsetWidth - 25;
          if (vm.pageX > largestWidth) vm.left = largestWidth;
          vm.top = vm.pageY + 'px';
          vm.left = vm.pageX + 'px';
        });
      }
    }
  },
  methods: {
    cut: function cut() {
      this.$emit('cut');
    },
    copy: function copy() {
      this.$emit('copy');
    },
    paste: function paste() {
      this.$emit('paste');
    },
    destroy: function destroy() {
      this.$emit('delete');
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _validators = __webpack_require__(32);

var _vuex = __webpack_require__(5);

var _vueMultiselect = __webpack_require__(36);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { Multiselect: _vueMultiselect2.default },
  props: ['mappingsKeys', 'orderOptions', 'showEditMapping', 'canvasElement', 'npiGroups', 'stage'],
  data: function data() {
    return {
      oldGroup: {
        npi_group_name: null,
        npi: null,
        first_name: null,
        last_name: null,
        name: null,
        city: null,
        state: null,
        zipcode: null
      },
      group: {
        npi_group_name: null,
        npi: null,
        first_name: null,
        last_name: null,
        name: null,
        city: null,
        state: null,
        zipcode: null
      },
      element: {
        replacedNpiMappings: [],
        key: null,
        oldKey: null,
        originalKey: null,
        type: null,
        category: null,
        originalOrder: null,
        order: null,
        case: null,
        description: null,
        required: false,
        extract: true,
        extract_by_words: false,
        redact_field: true,
        show_field: true,
        sensitive_data: false,
        key_alias: [],
        path: null,
        el_type: null,
        dateFormat: null,
        date_category: null,
        parentDataType: null,
        parentKey: null
      },
      npiFields: [{ value: null, text: 'Please select type' }],
      mappingCategories: [{ value: 'default', text: this.$t('DATA_TYPE.DEFAULT') }, { value: 'block', text: this.$t('DATA_TYPE.BLOCK') }],
      caseCategories: [{ value: null, text: this.$t('TEMPLATE.SELECT_CASE') }, { value: 'capitalize', text: this.$t('DATA_TYPE.CAPITALIZE') }, { value: 'upper_case', text: this.$t('DATA_TYPE.UPPER_CASE') }, { value: 'lower_case', text: this.$t('DATA_TYPE.LOWER_CASE') }],
      listTypes: [{ value: null, text: this.$t('TEMPLATE.SELECT_DATA_TYPE') }, { value: 'alpha', text: this.$t('DATA_TYPE.ALPHA') }, { value: 'alphanumeric', text: this.$t('DATA_TYPE.ALPHANUM') }, { value: 'alphanumeric_with_space', text: this.$t('DATA_TYPE.ALPHANUMSPC') }, { value: 'numeric_with_decimal', text: this.$t('DATA_TYPE.NUMERICDEC') }, { value: 'checkbox', text: this.$t('DATA_TYPE.CHECKBOX') }, { value: 'city', text: this.$t('DATA_TYPE.CITY') }, { value: 'cod', text: 'COD' }, { value: 'date', text: this.$t('DATA_TYPE.DATE') }, { value: 'email', text: 'Email' }, { value: 'fax', text: 'Fax' }, { value: 'npi', text: 'NPI' }, { value: 'numeric', text: this.$t('DATA_TYPE.NUMERIC') }, { value: 'phone', text: 'Phone' }, { value: 'signature', text: 'Signature' }, { value: 'state', text: this.$t('DATA_TYPE.STATE') }, { value: 'text', text: this.$t('DATA_TYPE.TEXT') }, { value: 'zip', text: 'ZIP' }],
      dateFormatList: [{ value: null, text: this.$t('TEMPLATE.SELECT_DATE_FORMAT') }, { value: 'dd mm yyyy', text: 'dd mm yyyy' }, { value: 'mm dd yyyy', text: 'mm dd yyyy' }, { value: 'yyyy mm dd', text: 'yyyy mm dd' }, { value: 'yyyy dd mm', text: 'yyyy dd mm' }],
      dateCategoryList: [{ value: 'normal_date', text: 'Normal Date' }, { value: 'dob', text: 'DOB' },
      // { value: 'expire_date', text: 'Expiration Date' },
      { value: 'future_date', text: 'Future Date' }],
      groupTypes: [{ value: null, text: 'Please select type' }, { value: 'npi', text: this.$t('DATA_TYPE.NPI') }, { value: 'logical', text: this.$t('DATA_TYPE.LOGICAL') }, { value: 'name', text: this.$t('DATA_TYPE.NAME') }, { value: 'combine_data', text: this.$t('DATA_TYPE.COMBINE_DATA') }, { value: 'checkbox_text', text: this.$t('DATA_TYPE.CHECKBOX_TEXT') }, { value: 'single_select', text: this.$t('DATA_TYPE.EITHER') }, { value: 'multi_select', text: this.$t('DATA_TYPE.MULTI_CHOICE') }, { value: 'table_header', text: this.$t('DATA_TYPE.TABLE_HEADER') }, { value: 'table_entry', text: this.$t('DATA_TYPE.TABLE_ENTRY') }, { value: 'table_row', text: this.$t('DATA_TYPE.TABLE_ROW') }, { value: 'table_column', text: this.$t('DATA_TYPE.TABLE_COLUMN') }, { value: 'section', text: this.$t('DATA_TYPE.SECTION') }],
      aliasOptions: [],
      selectedAliasData: [],
      requiredNAtypes: [undefined, null, 'npi', 'logical', 'combine_data', 'checkbox_text', 'table_row', 'table_column', 'table_header', 'table_entry'],
      canShowRequired: false,
      canExtract: true,
      requiredNA: false,
      isKeyUnique: true,
      isMappingNpiGroup: false,
      isMappingPartOfNpiGroup: false
    };
  },

  validations: {
    group: {
      npi: {
        required: _validators.required
      }
    }
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['isAdminRole'])),
  watch: {
    'element.key': function elementKey(newLabel, oldLabel) {
      // this.element.oldKey is null at data initialization only
      if (newLabel) {
        if (this.isMappingNpiGroup || this.isMappingPartOfNpiGroup) {
          for (var key in this.group) {
            if (this.group[key] === this.element.oldKey) {
              this.group[key] = this.element.key;
              this.oldGroup[key] = this.element.key;
              this.element.oldKey = this.element.key;
            }
          }
        }
        this.isKeyUnique = this.checkIfKeyUnique();
      } else {
        this.isKeyUnique = false;
      }
    },
    showEditMapping: function showEditMapping() {
      if (this.showEditMapping) {
        if (this.isAdminRole) {
          var elemAttrs = this.canvasElement.attrs;
          var parentAttrs = this.canvasElement.parent.attrs;
          this.element = {
            replacedNpiMappings: [],
            key: elemAttrs.key,
            oldKey: elemAttrs.key,
            originalKey: elemAttrs.key,
            originalOrder: elemAttrs.order,
            type: elemAttrs.dataType,
            category: elemAttrs.category,
            order: elemAttrs.order,
            case: elemAttrs.case,
            description: elemAttrs.description,
            required: elemAttrs.required,
            extract: elemAttrs.extract,
            extract_by_words: elemAttrs.extract_by_words,
            redact_field: elemAttrs.redact_field,
            show_field: elemAttrs.show_field,
            sensitive_data: elemAttrs.sensitive_data,
            key_alias: elemAttrs.key_alias || [],
            path: elemAttrs.path,
            el_type: this.canvasElement.nodeType,
            dateFormat: elemAttrs.dateFormat,
            date_category: elemAttrs.date_category,
            parentDataType: elemAttrs.parentDataType,
            parentKey: elemAttrs.parentKey
          };
          this.selectedAliasData = JSON.parse(JSON.stringify(this.element.key_alias));
          this.aliasOptions = JSON.parse(JSON.stringify(this.element.key_alias));
          this.isMappingNpiGroup = elemAttrs.dataType === 'npi' && elemAttrs.map_type === 'group';
          this.isMappingPartOfNpiGroup = parentAttrs.dataType === 'npi' && parentAttrs.map_type === 'group';
          this.npiFields = [{ value: null, text: 'Please select type' }];
          // if mapping being edited is npi group
          if (this.isMappingNpiGroup) {
            var npiGroup = this.npiGroups.filter(function (mapping) {
              return mapping['npi_group_name'] === elemAttrs.key || mapping['npi_group_name'] === parentAttrs.key;
            });
            if (npiGroup && npiGroup.length > 0) {
              npiGroup = npiGroup[0];
              this.group = {
                npi_group_name: npiGroup.npi_group_name,
                npi: npiGroup.npi,
                first_name: npiGroup.first_name,
                last_name: npiGroup.last_name,
                name: npiGroup.name,
                city: npiGroup.city,
                state: npiGroup.state,
                zipcode: npiGroup.zipcode
              };
              this.oldGroup = {
                npi_group_name: npiGroup.npi_group_name,
                npi: npiGroup.npi,
                first_name: npiGroup.first_name,
                last_name: npiGroup.last_name,
                name: npiGroup.name,
                city: npiGroup.city,
                state: npiGroup.state,
                zipcode: npiGroup.zipcode
              };
              this.insertGroupFields();
            }
          }
          this.$refs.mapEditModalRef.show();
        } else {
          this.$refs.agnetEditMappingModal.show();
        }
      } else {
        this.$refs.mapEditModalRef.hide();
      }
    }
  },
  methods: {
    addTag: function addTag(newTag) {
      this.selectedAliasData.push(newTag);
      this.aliasOptions.push(newTag);
    },
    npiFieldChanged: function npiFieldChanged(type) {
      if (this.oldGroup[type]) {
        this.element.replacedNpiMappings.push(this.oldGroup[type]);
      }
    },
    editDrawing: function editDrawing() {
      this.$refs.agnetEditMappingModal.hide();
      this.$emit('cancelled');
    },
    checkIfKeyUnique: function checkIfKeyUnique() {
      var normalisedOriginalKey = this.element.originalKey.toLowerCase().replace(/\s/g, '');
      var normalisedNewKey = this.element.key.toLowerCase().replace(/\s/g, '');
      if (normalisedOriginalKey !== normalisedNewKey) {
        return this.mappingsKeys.indexOf(normalisedNewKey) === -1;
      } else {
        return true;
      }
    },
    insertGroupFields: function insertGroupFields() {
      var _this = this;

      var npiFields = [];
      this.stage.find('Rect').forEach(function (shape) {
        var shapeAttrs = shape.attrs;
        if (shapeAttrs.edit_type === 'created') {
          if (!shapeAttrs.parentDataType || shapeAttrs.parentKey === _this.canvasElement.attrs.key) {
            npiFields.push({ value: shapeAttrs.key, text: shapeAttrs.key });
          }
        }
      });
      this.npiFields = this.npiFields.slice().concat(npiFields);
    },
    modalTitle: function modalTitle() {
      return this.element.el_type === 'Shape' ? this.$t('TEMPLATE.UPDATE_MAP') : this.$t('TEMPLATE.UPDATE_GRP');
    },
    focusOnInput: function focusOnInput() {
      this.$refs.updateFieldKey.focus();
    },
    updateMapping: function updateMapping() {
      if (this.requiredNA === true) this.element.required = false;
      this.element.key_alias = this.selectedAliasData;
      this.$emit('updated', this.element, this.group, this.oldGroup);
    },
    cancelMapping: function cancelMapping() {
      this.$refs.mapEditModalRef.hide();
      this.$emit('cancelled');
    },
    cancelUpdateMapping: function cancelUpdateMapping() {
      this.$emit('cancelled');
    },
    checkIfElementPartOfSelectGroup: function checkIfElementPartOfSelectGroup(element) {
      var parentNodeType = this.canvasElement.parent.nodeType;
      var parentDataType = this.canvasElement.parent.attrs.dataType;
      var isElementPartOfSelectGroup = false;
      if (parentNodeType === 'Group') {
        if (parentDataType === 'single_select' || parentDataType === 'multi_select') {
          isElementPartOfSelectGroup = true;
        }
      }
      return isElementPartOfSelectGroup;
    },
    handleRequired: function handleRequired() {
      // selectGroup = either single_select or multi_select group
      var elementType = this.element.type;
      this.element.dateFormat = this.element.type === 'date' ? this.element.dateFormat : null;
      this.element.date_category = this.element.type === 'date' ? this.element.date_category : null;
      var isElementPartOfSelectGroup = this.checkIfElementPartOfSelectGroup(this.element);

      if (elementType === 'checkbox' && isElementPartOfSelectGroup) {
        this.requiredNA = false;
        this.canShowRequired = false;
      } else if (elementType === 'npi' && this.element.el_type === 'Shape') {
        this.requiredNA = false;
        this.canShowRequired = true;
      } else if (this.requiredNAtypes.includes(this.element.type)) {
        this.requiredNA = true;
        this.canShowRequired = false;
      } else {
        this.requiredNA = false;
        this.canShowRequired = true;
        this.canExtract = true;
      }
    }
  }
};

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _lodash = __webpack_require__(45);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      currentPage: 0,
      pageType: 'templates',
      prevPage: 0,
      nextPage: 1,
      allPageIdMap: {},
      totalPages: 1
    };
  },

  computed: {
    canGoToPrev: function canGoToPrev() {
      return this.prevPage < 0;
    },
    getCurrentPage: function getCurrentPage() {
      return this.currentPage + 1;
    },
    canGoToNext: function canGoToNext() {
      if (this.allPageIdMap) {
        return this.nextPage >= _lodash2.default.size(this.allPageIdMap);
      }
    }
  },
  methods: {
    setPagination: function setPagination(pageType) {
      this.pageType = pageType;
      this.currentPage = this.getPageNo(this.id);
      this.prevPage = this.currentPage - 1;
      this.nextPage = this.currentPage + 1;
      this.totalPages = _lodash2.default.size(this.allPageIdMap);
    },
    goToPage: function goToPage(id) {
      var saveData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (id != null) {
        if (this.currentIndex && this.currentIndex > 0 && saveData) {
          this.saveData();
        }
        if (this.pageType !== 'process/forms') {
          _router2.default.push({ path: '/' + this.pageType + '/' + this.getcurrentDocId(id) });
        } else {
          if (this.checkIdRelatedFormDoc()) {
            _router2.default.push({ path: '/' + this.pageType + '/' + this.getcurrentDocId(id) });
          }
        }
      }
    },
    checkIdRelatedFormDoc: function checkIdRelatedFormDoc() {
      if (this.id in this.allPageIdMap) {
        return false;
      }
      return true;
    },
    getPageNo: function getPageNo(currentDocId) {
      return this.allPageIdMap[currentDocId];
    },
    getcurrentDocId: function getcurrentDocId(pageNo) {
      return _lodash2.default.invert(this.allPageIdMap)[pageNo];
    }
  }
};

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
};

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vue2Dropzone = __webpack_require__(186);

var _vue2Dropzone2 = _interopRequireDefault(_vue2Dropzone);

__webpack_require__(188);

var _lodash = __webpack_require__(45);

var _lodash2 = _interopRequireDefault(_lodash);

var _validators = __webpack_require__(32);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _vuex = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// import pdf from 'vue-pdf'
exports.default = {
  name: 'upload-for-process',
  components: { vueDropzone: _vue2Dropzone2.default },
  data: function data() {
    return {
      form: {
        title: '',
        description: '',
        file: '',
        forced_template_doc_id: null,
        match_type: null,
        accountId: '',
        uploading: false
      },
      disableUpload: false,
      file_length: 0,
      isDropzoneBlank: false,
      isPdf: false,
      pdfpasswordInput: '',
      pdfPasswordState: null,
      pdfcurrentFileName: '',
      isPdfLoaded: false,
      isPasswordSubmit: false,
      pdfcurrentPassword: '',
      pdfsources: [],
      pdfPasswords: [],
      checked: true,
      zipPasswords: [],
      currentFile: '',
      passwordInput: '',
      zipPasswordState: null,
      option_keys: [],
      matchOptions: [{ text: 'Select', value: null, disabled: true }],
      templateOptions: [],
      dropzoneOptions: {
        url: "/api" + '/form_docs',
        dictDefaultMessage: this.$t('FORMS.DROP_SCANNED'),
        autoProcessQueue: false,
        thumbnailWidth: 100,
        thumbnailHeight: 150,
        parallelUploads: 5,
        maxFilesize: 30,
        maxFiles: 5,
        timeout: 300000,
        acceptedFiles: 'application/pdf, image/*, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,application/rtf, application/x-rtf, text/rtf, text/richtext, application/msword, application/doc, application/x-soffice, .xlsx, .xls, .zip',
        headers: { 'Authorization': '' },
        init: function init() {
          this.on('addedfile', function (file) {
            file.previewElement.querySelector('.dz-details').style.backgroundColor = '#0b192d';
            var removeButton = document.createElement('div');
            removeButton.className = 'removeFormButton';
            removeButton.style.cssText = 'opacity:1;z-index:1000;position:absolute;top:5px;right:5px;color:white;';
            removeButton.innerHTML = '<i class="fa fa-trash"></i>';
            var _this = this;

            removeButton.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();

              _this.removeFile(file);
            });

            file.previewElement.appendChild(removeButton);
          });
        }
      },
      showContentPlaceholder: false,
      canShowImgPreview: false,
      previewImageUrl: '',
      files: 0
    };
  },

  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.isAdminRole) {
        next();
      } else {
        _router2.default.replace('/not-Found-404');
        _vue2.default.toasted.show(vm.$t('COMMON.UNAUTHORIZED'), { icon: 'chain-broken', type: 'error' });
      }
    });
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'accountId', 'isAdminRole']), {
    canShowDropZone: function canShowDropZone() {
      this.dropzoneOptions.headers['Authorization'] = 'Bearer ' + this.idToken;
      return this.idToken !== '';
    },
    disableButton: function disableButton() {
      return !(this.$v.$invalid && !this.$v.$dirty || !this.$v.$invalid) || this.disableUpload;
    },
    setOptions: function setOptions() {
      var _this2 = this;

      this.matchOptions = [{ text: this.$t('UPLOAD_DROPDOWN.SELECT'), value: null, disabled: true }];
      this.matchOptions = this.matchOptions.concat(this.option_keys.map(function (processType) {
        return { text: _this2.$t('UPLOAD_DROPDOWN.' + processType.key), value: processType.value };
      }));
      return this.matchOptions;
    },
    pdfinvalidFeedback: function pdfinvalidFeedback() {
      if (this.pdfpasswordInput.length > 4) {
        return '';
      } else {
        return this.$t('COMMON.WRONG_PASSWORD');
      }
    }
  }),
  methods: {
    onSuccess: function onSuccess(file, message, xhr) {
      _router2.default.push({ path: '/process/processed', query: { status: 'processing' } });
    },
    onAddingFile: function onAddingFile(file) {
      this.isDropzoneBlank = !this.$refs.formProcessDropZone.dropzone.files.length;
      if (['application/zip', 'application/octet-stream', 'application/x-zip-compressed', 'multipart/x-zip'].indexOf(file.type) >= 0) {
        this.checkZipPassword(file);
      }
    },
    checkZipPassword: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
        var apiData, invalid;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.zipPasswords[file.upload.uuid] = '';
                apiData = new window.FormData();

                apiData.append('password', '');
                apiData.append('file', file);
                this.disableUpload = true;
                _context.next = 7;
                return this.postZip(apiData, 0);

              case 7:
                invalid = _context.sent;

                if (!invalid) {
                  this.currentFile = file;
                  this.$refs['zip-password-modal'].show();
                } else {
                  this.disableUpload = false;
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function checkZipPassword(_x) {
        return _ref.apply(this, arguments);
      }

      return checkZipPassword;
    }(),
    postZip: function postZip(apiData, flag) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _vue2.default.axios.post('/form_docs/check_zip_password', apiData, { headers: { Authorization: 'Bearer ' + _this3.idToken } }).then(function (response) {
          if (response.data.status === 'Wrong Password' && flag) {
            _vue2.default.toasted.show(_this3.$t('COMMON.WRONG_PASSWORD'), { icon: 'chain-broken', type: 'error' });
            resolve(false);
          } else if (response.data.status === 'Correct Password' && flag) {
            _this3.zipPasswords[_this3.currentFile.upload.uuid] = _this3.passwordInput;
            _this3.disableUpload = false;
            resolve(true);
          } else if (response.data.status === 'Wrong Password' && flag === 0) {
            resolve(false);
          } else {
            resolve(true);
          }
          _this3.zipPasswordState = null;
          _this3.passwordInput = '';
        }, function () {
          _this3.$refs.formProcessDropZone.dropzone.removeFile(_this3.currentFile);
          _this3.zipPasswordState = null;
          _this3.passwordInput = '';
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_PROCESS_FAIL'), { icon: 'chain-broken', type: 'error' });
          _this3.disableUpload = false;
          resolve(true);
        });
      });
    },
    checkZipFormValidity: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var valid, apiData, pwdValid;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                valid = this.$refs['zip-form'].checkValidity();

                this.zipPasswordState = valid;

                if (valid) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt('return', false);

              case 6:
                apiData = new window.FormData();

                apiData.append('password', this.passwordInput);
                apiData.append('file', this.currentFile);
                _context2.next = 11;
                return this.postZip(apiData, 1);

              case 11:
                pwdValid = _context2.sent;
                return _context2.abrupt('return', pwdValid);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function checkZipFormValidity() {
        return _ref2.apply(this, arguments);
      }

      return checkZipFormValidity;
    }(),
    handleZipFormSubmit: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this4 = this;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.checkZipFormValidity();

              case 2:
                if (_context3.sent) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt('return');

              case 4:
                this.$nextTick(function () {
                  _this4.$refs['zip-password-modal'].hide();
                });

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleZipFormSubmit() {
        return _ref3.apply(this, arguments);
      }

      return handleZipFormSubmit;
    }(),
    invalidFeedback: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.checkZipFormValidity();

              case 2:
                if (!_context4.sent) {
                  _context4.next = 6;
                  break;
                }

                return _context4.abrupt('return', '');

              case 6:
                return _context4.abrupt('return', this.$t('COMMON.WRONG_PASSWORD'));

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function invalidFeedback() {
        return _ref4.apply(this, arguments);
      }

      return invalidFeedback;
    }(),
    handleZipPasswordSubmit: function handleZipPasswordSubmit(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleZipFormSubmit();
    },
    handleEnter: function handleEnter() {
      this.handleZipFormSubmit();
    },
    cancel: function cancel() {
      this.$refs.formProcessDropZone.dropzone.removeFile(this.currentFile);
      this.zipPasswordState = null;
      this.passwordInput = '';
      this.disableUpload = false;
    },
    resetZipModal: function resetZipModal() {
      this.zipPasswordState = null;
    },

    handleMatchSelect: function handleMatchSelect() {
      if (this.form.match_type === -4 && this.templateOptions.length > 0) {
        this.previewImageUrl = this.axios.defaults.baseURL.replace('/api', '') + this.templateOptions[0].image_url;
        this.form.forced_template_doc_id = this.templateOptions[0].value;
        this.canShowImgPreview = true;
      } else {
        this.form.forced_template_doc_id = this.form.match_type;
        this.canShowImgPreview = false;
      }
    },
    handleTemplateSelect: function handleTemplateSelect() {
      var thisObj = this;
      var selectedOpt = _lodash2.default.find(this.templateOptions, function (topt) {
        return topt.value === thisObj.form.forced_template_doc_id;
      });
      this.previewImageUrl = this.axios.defaults.baseURL.replace('/api', '') + selectedOpt.image_url;
    },

    formUpload: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this, myDropzone;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this = this;

                if (this.$refs.formProcessDropZone.dropzone.files.length && (this.form.match_type || this.form.match_type === 0)) {
                  myDropzone = this.$refs.formProcessDropZone.dropzone;

                  this.uploadStart();
                  myDropzone.processQueue();
                  myDropzone.on('complete', function (file) {
                    if (this.getUploadingFiles().length === 0) {
                      _this.uploadEnd();
                    }
                    myDropzone.removeFile(file);
                  });
                } else if (this.$v.$invalid) {
                  this.$v.form.$touch();
                } else {
                  this.isDropzoneBlank = true;
                }

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function formUpload() {
        return _ref5.apply(this, arguments);
      }

      return formUpload;
    }(),
    fetchProcessTypes: function fetchProcessTypes() {
      var _this5 = this;

      _vue2.default.axios.get('/settings/process_types/account_process_types', { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this5.option_keys = res.data.account_process_types.map(function (processType) {
          return { key: processType.key, value: processType.value };
        });
      }).catch(function (error) {
        if (error.status === 401) {
          console.log(_this5.$t('COMMON.MSG_EXPIRED'));
        } else if (error.status === 500) {
          _vue2.default.toasted.show(_this5.$t('COMMON.MSG_PROCESS_FAIL'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    fetchTemplateOptions: function fetchTemplateOptions() {
      var _this6 = this;

      _vue2.default.axios.get('/template_docs/list_options', { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        _this6.templateOptions = response.data.template_docs;
      }, function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this6.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this6.$t('COMMON.MSG_EXPIRED'));
        } else if (error.status === 500) {
          _vue2.default.toasted.show(_this6.$t('COMMON.MSG_PROCESS_FAIL'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    sendingEvent: function sendingEvent(file, xhr, formData) {
      if (this.form.title && this.checked) {
        formData.append('title', this.form.title);
      } else {
        formData.append('title', file.name);
      }
      formData.append('account_id', this.accountId);
      // formData.append('key', this.pdfPasswords[file.name])
      formData.append('forced_template_doc_id', this.form.forced_template_doc_id);
      formData.append('password', this.zipPasswords[file.upload.uuid]);
    },
    uploadStart: function uploadStart() {
      this.form.uploading = true;
      this.showContentPlaceholder = true;
      this.$refs.uploadText.innerText = this.$t('FORMS.UPLOAD_PROCESS');
    },
    uploadEnd: function uploadEnd() {
      this.showContentPlaceholder = false;
      this.$refs.uploadText.innerText = this.$t('COMMON.UPLOAD');
    },
    onExceedingMaxFiles: function onExceedingMaxFiles() {
      _vue2.default.toasted.show(this.$t('COMMON.MSG_FILE_LIMIT'), { icon: 'chain-broken', type: 'error' });
    },
    onRemovingFile: function onRemovingFile() {
      this.file_length = this.$refs.formProcessDropZone.dropzone.files.length;
      this.isDropzoneBlank = !this.$refs.formProcessDropZone.dropzone.files.length;
      var myDropzone = this.$refs.formProcessDropZone.dropzone;
      if (myDropzone.getRejectedFiles().length > 0 && myDropzone.getAcceptedFiles().length < myDropzone.options.maxFiles) {
        myDropzone.getRejectedFiles()[0]['status'] = 'queued';
        myDropzone.getRejectedFiles()[0]['previewTemplate']['classList'].remove('dz-error');
        myDropzone.getRejectedFiles()[0]['previewTemplate']['classList'].remove('dz-complete');
        myDropzone.getRejectedFiles()[0]['accepted'] = true;
      }
    }
  },
  created: function created() {
    console.log('created');
    this.fetchProcessTypes();
    this.fetchTemplateOptions();
  },

  validations: {
    form: {
      match_type: {
        required: _validators.required
      }
    }
  }
};

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _lodash = __webpack_require__(45);

var _lodash2 = _interopRequireDefault(_lodash);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _vueInfiniteLoading = __webpack_require__(109);

var _vueInfiniteLoading2 = _interopRequireDefault(_vueInfiniteLoading);

var _FormsSearchBar = __webpack_require__(1093);

var _FormsSearchBar2 = _interopRequireDefault(_FormsSearchBar);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'processed-form',
  components: {
    FormsSearchBar: _FormsSearchBar2.default,
    InfiniteLoading: _vueInfiniteLoading2.default
  },
  data: function data() {
    return {
      filter: '',
      errorMessage: '',
      polling: null,
      formsLoaded: false,
      templateOptions: [],
      previewImageUrl: '',
      forced_template_doc_id: null,
      canShowImgPreview: false,
      match_type: null,
      option_keys: [],
      matchOptions: [{ text: 'Select', value: null, disabled: true }],
      tableFields: [{ key: 'group_id', label: 'WORKFLOW.GROUP_ID', sortable: true, tdClass: 'text-left small-cell-width', thClass: 'text-left small-cell-width' }, { key: 'title', label: 'WORKFLOW.TITLE', sortable: true, tdClass: 'text-left large-cell-width', thClass: 'text-left large-cell-width' }, { key: 'total_page_count', label: 'WORKFLOW.PAGE_COUNT', sortable: true, tdClass: 'text-left small-cell-width', thClass: 'text-left small-cell-width' }, { key: 'forms_doc_status', label: 'WORKFLOW.SF_STATUS', sortable: true, tdClass: 'text-left medium-cell-width', thClass: 'text-left medium-cell-width' }, { key: 'created_at', label: 'WORKFLOW.CREATED_AT', sortable: true, tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' },
      // { key: 'match_type', label: 'WORKFLOW.MATCH', sortable: true },
      // { key: 'product', label: 'WORKFLOW.PRODUCT' },
      { key: 'download_link', label: 'WORKFLOW.ACTIONS', tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' }, { key: 'updated_at', label: 'WORKFLOW.UPDATED_AT', sortable: true, tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' }],
      tabIndex: 0,
      sortBy: 'group_id',
      sortDesc: true,
      order: 1,
      infiniteId: 1,
      distance: Infinity,
      lastFormId: -1,
      processedData: [],
      tabs: null,
      show: false,
      disable_tab: false,
      newFormsProcessed: 0,
      latestFormId: -1,
      updatedLatestFormId: 0,
      fhirValues: {},
      validationErrors: [],
      selectedFormTitle: '',
      selectedFormDocId: '',
      processing: this.$route.query.status === 'processing',
      eventBus: new _vue2.default(),
      searchType: 'title',
      esm_status: '',
      tm_status: '',
      processed_form_info: '',
      id: '',
      confidenceRangeCondition: '',
      confidenceFromValue: 0,
      confidenceToValue: 100,
      confidenceLimitValue: 100,
      dateRangeType: 'Today',
      fromDate: '',
      toDate: '',
      engagementProgram: null,
      productType: '',
      formDocStatus: [['1', '2', '3', '4', '6', '7', '8', '10', '11', '12']],
      salesforceResponse: null,
      formDocumnetStatus: {
        1: 'New',
        2: 'In Progress',
        3: 'Partially Completed',
        4: 'Completed',
        5: 'Rejected',
        6: 'Recalled',
        7: 'Integration Success',
        8: 'Integration Failed',
        9: 'Document Moved To SF',
        10: 'Validated',
        11: 'Pending',
        12: 'Triaged'
      },
      formDocStatusEnums: {
        NEW: 1,
        INPROGRESS: 2,
        PARTIALLY_COMPLETED: 3,
        COMPLETED: 4,
        REJECTED: 5,
        RECALLED: 6,
        PCSUCCESS: 7,
        PCFAILED: 8,
        DOCUMENT_MOVED_TO_SF: 9,
        VALIDATED: 10,
        PENDING: 11,
        TRIAGED: 12
        // PCPARTIAL: 7
      },
      latestFormStatus: '',
      refreshShowTriagingTab: false,
      currentFormDoc: null,
      errorKeyAbsent: false
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'isAdmin', 'isAdminRole', 'accountId', 'selectedRolesData', 'userId', 'userRole', 'userRoleOrder', 'prevFormsTab', 'localTime', 'selectTriageStatus', 'selectAgentStatus', 'selectUnmatchStatus']), {
    checkAuth: function checkAuth() {
      var order = parseInt(this.order);
      var userRoleOrder = parseInt(this.userRoleOrder);
      return order === userRoleOrder;
    },
    setOptions: function setOptions() {
      var _this = this;

      this.matchOptions = [{ text: this.$t('UPLOAD_DROPDOWN.SELECT'), value: null, disabled: true }];
      this.matchOptions = this.matchOptions.concat(this.option_keys.map(function (processType) {
        return { text: _this.$t('UPLOAD_DROPDOWN.' + processType.key), value: processType.value };
      }));
      return this.matchOptions;
    }
  }),
  watch: {
    tabIndex: function tabIndex() {
      if (this.order === 1) {
        // Agent Tab
        this.tableFields = [{ key: 'group_id', label: 'WORKFLOW.GROUP_ID', sortable: true, tdClass: 'text-left small-cell-width', thClass: 'text-left small-cell-width' }, { key: 'title', label: 'WORKFLOW.TITLE', sortable: true, tdClass: 'text-left large-cell-width', thClass: 'text-left large-cell-width' }, { key: 'document_type', label: 'WORKFLOW.DOCUMENT_TYPE', sortable: true, tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' }, { key: 'processed', label: 'WORKFLOW.PROCESS_PAGE_COUNT', sortable: true, tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' },
        // { key: 'match_type', label: 'WORKFLOW.MATCH', sortable: true },
        { key: 'created_at', label: 'WORKFLOW.CREATED_AT', sortable: true, tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' }, { key: 'forms_doc_status', label: 'WORKFLOW.SF_STATUS', sortable: true },
        // { key: 'sf_export_status', label: 'WORKFLOW.SF_STATUS', sortable: true, tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' },
        // { key: 'product', label: 'WORKFLOW.PRODUCT' },
        { key: 'download_link', label: 'WORKFLOW.ACTIONS', tdClass: 'text-left xmedium-cell-width', thClass: 'text-left xmedium-cell-width' }, { key: 'updated_at', label: 'WORKFLOW.UPDATED_AT', sortable: true, tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' }];
      } else if (this.order === -1) {
        // Unmatched Tab
        this.tableFields = [{ key: 'group_id', label: 'WORKFLOW.GROUP_ID', sortable: true, tdClass: 'text-left small-cell-width', thClass: 'text-left small-cell-width' }, { key: 'title', label: 'WORKFLOW.TITLE', sortable: true, tdClass: 'text-left large-cell-width', thClass: 'text-left large-cell-width' }, { key: 'processed', label: 'WORKFLOW.MATCHED_PAGE_COUNT', sortable: true, tdClass: 'text-left small-cell-width', thClass: 'text-left small-cell-width' }, { key: 'forms_doc_status', label: 'WORKFLOW.SF_STATUS', sortable: true, tdClass: 'text-left medium-cell-width', thClass: 'text-left medium-cell-width' }, { key: 'rejected', label: 'WORKFLOW.REJECT_PAGE_COUNT', sortable: true, tdClass: 'text-left small-cell-width', thClass: 'text-left small-cell-width' },
        // { key: 'match_type', label: 'WORKFLOW.MATCH', sortable: true },
        { key: 'created_at', label: 'WORKFLOW.CREATED_AT', sortable: true, tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' }, { key: 'download_link', label: 'WORKFLOW.ACTIONS', tdClass: 'text-left xmedium-cell-width', thClass: 'text-left xmedium-cell-width' }, { key: 'updated_at', label: 'WORKFLOW.UPDATED_AT', sortable: true, tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' }];
      } else {
        // Triaging
        this.tableFields = [{ key: 'group_id', label: 'WORKFLOW.GROUP_ID', sortable: true, tdClass: 'text-left small-cell-width', thClass: 'text-left small-cell-width' }, { key: 'title', label: 'WORKFLOW.TITLE', sortable: true, tdClass: 'text-left large-cell-width', thClass: 'text-left large-cell-width' }, { key: 'total_page_count', label: 'WORKFLOW.PAGE_COUNT', sortable: true, tdClass: 'text-left small-cell-width', thClass: 'text-left small-cell-width' }, { key: 'forms_doc_status', label: 'WORKFLOW.SF_STATUS', sortable: true, tdClass: 'text-left medium-cell-width', thClass: 'text-left medium-cell-width' }, { key: 'created_at', label: 'WORKFLOW.CREATED_AT', sortable: true, tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' }, { key: 'download_link', label: 'WORKFLOW.ACTIONS', tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' }, { key: 'updated_at', label: 'WORKFLOW.UPDATED_AT', sortable: true, tdClass: 'text-left semi-medium-cell-width', thClass: 'text-left semi-medium-cell-width' }];
      }
    }
  },
  created: function created() {
    var _this2 = this;

    var _$route$query = this.$route.query,
        caseId = _$route$query.caseId,
        fileId = _$route$query.fileId,
        contentDocumentId = _$route$query.contentDocumentId,
        signatureDate = _$route$query.signatureDate;

    contentDocumentId = contentDocumentId === 'undefined' ? null : contentDocumentId;
    signatureDate = signatureDate === 'undefined' ? null : signatureDate;
    if (caseId && fileId) {
      this.pullMckessonDocument(caseId, fileId);
    } else if (caseId && (contentDocumentId || signatureDate)) {
      this.pullExistingPatientDoc(caseId, contentDocumentId, signatureDate);
    } else if (caseId) {
      this.pullDocument(caseId);
    }
    this.tabs = [{ name: 'Triaging', role_order: -2 }];
    var tabElement = _lodash2.default.slice(this.selectedRolesData, 0, this.userRoleOrder);
    this.tabs = this.tabs.concat(tabElement);
    if (_lodash2.default.isEmpty(tabElement) && this.isAdminRole) {
      this.tabs.push({ name: 'admin', role_order: 1 });
      this.$store.commit('setUserRoleOrder', 1);
    }
    this.tabs.push({ name: 'Unmatched', role_order: -1 });
    if (this.prevFormsTab === null) {
      this.tabIndex = 0;
      this.order = -2;
      this.infiniteId = -2;
    } else {
      this.tabIndex = this.prevFormsTab;
      this.order = this.tabs[this.tabIndex].role_order;
      this.infiniteId = this.tabs[this.tabIndex].role_order;
    }
    this.tabs = this.tabs.map(function (tab) {
      if (tab.role_order === 1 && _this2.isAdminRole) {
        return { name: 'Admin', role_order: 1 };
      } else {
        return tab;
      }
    });
    this.handleFilterChanges();
    this.$store.commit('setRefs', this.$refs);
    this.$store.commit('setPrevFormsTab', this.tabIndex);
    this.fetchProcessTypes();
    this.fetchTemplateOptions();
    this.fetchNewForms();
    this.polling = setInterval(function () {
      _this2.fetchNewForms();
    }, 10000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.polling);
    this.$store.dispatch('updateProcessedData', []);
  },

  methods: {
    pullDocument: function pullDocument(caseId) {
      var _this3 = this;

      _vue2.default.axios.post('form_docs/document', { 'inbound_doc_case_id': caseId }, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        var error = res.data.error;

        if (error) {
          _vue2.default.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' });
          _this3.$router.replace('/process/processed');
        } else {
          _this3.processing = true;
          _vue2.default.toasted.show('Document is getting processed', { icon: 'chain-broken', type: 'success' });
          _this3.$router.replace('/process/processed?status=processing');
        }
      }).catch(function (err) {
        if (err.status === 401) {
          console.error('Session Exipred');
        } else {
          _vue2.default.toasted.show('Error in pulling the Document', { icon: 'chain-broken', type: 'error' });
        }
        console.log(err);
      });
    },
    pullMckessonDocument: function pullMckessonDocument(caseId, fileId) {
      var _this4 = this;

      _vue2.default.axios.post('form_docs/mckessonDocument', { 'inbound_doc_case_id': caseId, 'content_version_id': fileId }, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        var error = res.data.error;

        if (error) {
          _vue2.default.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' });
          _this4.$router.replace('/process/processed');
        } else {
          _this4.processing = true;
          _vue2.default.toasted.show('Document is getting processed', { icon: 'chain-broken', type: 'success' });
          _this4.$router.replace('/process/processed?status=processing');
        }
      }).catch(function (err) {
        _vue2.default.toasted.show('Error in pulling the Document', { icon: 'chain-broken', type: 'error' });
        console.log(err);
      });
    },
    pullExistingPatientDoc: function pullExistingPatientDoc(caseId, contentDocumentId, signatureDate) {
      var _this5 = this;

      _vue2.default.axios.post('form_docs/existing_patient_doc', { 'inbound_doc_case_id': caseId, 'content_document_id': contentDocumentId, 'signature_date': signatureDate }, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        var error = res.data.error;

        if (error) {
          _vue2.default.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' });
          _this5.$router.replace('/process/processed');
        } else {
          _this5.processing = true;
          _vue2.default.toasted.show('Document is getting processed', { icon: 'chain-broken', type: 'success' });
          _this5.$router.replace('/process/processed?status=processing');
        }
      }).catch(function (err) {
        _vue2.default.toasted.show('Error in pulling the Document', { icon: 'chain-broken', type: 'error' });
        console.log(err);
      });
    },
    showRejectFormModal: function showRejectFormModal(form) {
      this.currentFormDoc = form;
      this.$refs.rejectFormDoc.show();
    },
    handleFilterChanges: function handleFilterChanges() {
      if (this.order === -2) {
        if (this.selectTriageStatus && this.selectTriageStatus.length >= 0) {
          this.formDocStatus = this.selectTriageStatus.map(function (obj) {
            return obj.value;
          });
        } else {
          this.formDocStatus = ['1', '2', '3', '4', '6', '12', '5'];
        }
      } else if (this.order === 1) {
        if (this.selectAgentStatus && this.selectAgentStatus.length >= 0) {
          this.formDocStatus = this.selectAgentStatus.map(function (obj) {
            return obj.value;
          });
        } else {
          this.formDocStatus = ['2', '6', '7', '8', '10', '11', '5'];
        }
      } else {
        if (this.selectUnmatchStatus && this.selectUnmatchStatus.length >= 0) {
          this.formDocStatus = this.selectUnmatchStatus.map(function (obj) {
            return obj.value;
          });
        } else {
          this.formDocStatus = ['2', '6', '7', '8', '10', '11', '5'];
        }
      }
    },
    hideRejectFormDocModal: function hideRejectFormDocModal() {
      this.currentFormId = null;
      this.$refs.rejectFormDoc.hide();
    },
    hideEscalatedFormDocModal: function hideEscalatedFormDocModal() {
      this.$refs.escalatedFormDoc.hide();
      this.errorMessage = null;
    },

    rejectForm: function rejectForm(form) {
      var _this6 = this;

      var res = {
        formDocId: form.id
      };
      _vue2.default.axios.post('form_docs/reject_form_docs', res, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this6.processedData.map(function (data) {
          if (data.id === form.id) {
            form.is_rejected = true;
            form.forms_doc_status = res.data.status;
            if (data.time_status === true) {
              var stillUtc = _moment2.default.utc(res.data.updatedat).toDate();
              var localTime = (0, _moment2.default)(stillUtc).local().format('MMMM DD,YYYY HH:mm');
              form.updated_at = localTime;
            }
          }
        });
        _this6.hideRejectFormDocModal();
        _vue2.default.toasted.show(res.data.message, { icon: 'chain-broken', type: 'success' });
        _vue2.default.toasted.show('Form will remain in the system for ' + res.data.retention_time + ' hours', { icon: 'chain-broken', type: 'success' });
      }).catch(function (err) {
        console.log(err);
        _vue2.default.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' });
      });
    },
    changeRejectStatus: function changeRejectStatus(formDoc) {
      var _this7 = this;

      var res = {
        formDocId: formDoc.id
      };
      _vue2.default.axios.post('form_docs/recall_form_docs', res, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (formDoc.status === 'TRIAGING') {
          _this7.$router.push('/process/modify/' + formDoc.id);
        } else {
          _this7.$router.push('/process/forms/' + formDoc.first_form_id);
        }
        formDoc.forms_doc_status = res.data.status;
        _vue2.default.toasted.show(res.data.message, { icon: 'chain-broken', type: 'success' });
      }).catch(function (err) {
        console.log(err);
        if (err.status === 400 && err.data.status === 5) {
          _this7.errorMessage = err.data.message;
          _this7.$refs.escalatedFormDoc.show();
          formDoc.first_form_id = null;
        } else {
          _vue2.default.toasted.show(err.data.message, { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    showSalesforceReport: function showSalesforceReport(title, formDocId, data) {
      var _this8 = this;

      _vue2.default.axios.get('form_docs/' + formDocId + '/get_salesforce_response', { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this8.salesforceResponse = res.data.salesforce_resp;
        _this8.$refs.salesforceReport.show();
      }).catch(function (error) {
        if (error.status === 401) {} else if (error.status === 500) {
          _vue2.default.toasted.show(_this8.$t('COMMON.MSG_PROCESS_FAIL'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    viewRecord: function viewRecord(data) {
      window.open(data.salesforce_urls.case_url, '_blank');
    },
    fetchProcessTypes: function fetchProcessTypes() {
      var _this9 = this;

      _vue2.default.axios.get('/settings/process_types/account_process_types', { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this9.option_keys = res.data.account_process_types.map(function (processType) {
          return { key: processType.key, value: processType.value };
        });
      }).catch(function (error) {
        if (error.status === 401) {
          console.log(_this9.$t('COMMON.MSG_EXPIRED'));
        } else if (error.status === 500) {
          _vue2.default.toasted.show(_this9.$t('COMMON.MSG_PROCESS_FAIL'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    fetchTemplateOptions: function fetchTemplateOptions() {
      var _this10 = this;

      _vue2.default.axios.get('/template_docs/list_options', { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        _this10.templateOptions = response.data.template_docs;
      }, function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this10.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        }
        console.log(error);
      });
    },
    downloadEligibilityReport: function downloadEligibilityReport(id) {
      _vue2.default.axios.post('/forms/get_eligibility_report', { form_doc_id: id }, { headers: { Authorization: 'Bearer ' + this.idToken }, responseType: 'blob' }).then(function (res) {
        var url = window.URL.createObjectURL(new window.Blob([res.data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'eligibility.pdf');
        document.body.appendChild(link);
        link.click();
      }).catch(function (err) {
        return console.log(err);
      });
    },
    handleMatchSelect: function handleMatchSelect() {
      if (this.match_type === -4 && this.templateOptions.length > 0) {
        this.previewImageUrl = this.axios.defaults.baseURL.replace('/api', '') + this.templateOptions[0].image_url;
        this.forced_template_doc_id = this.templateOptions[0].value;
        this.canShowImgPreview = true;
      } else {
        this.forced_template_doc_id = this.match_type;
        this.canShowImgPreview = false;
      }
    },
    handleTemplateSelect: function handleTemplateSelect() {
      var thisObj = this;
      var selectedOpt = _lodash2.default.find(this.templateOptions, function (topt) {
        return topt.value === thisObj.forced_template_doc_id;
      });
      this.previewImageUrl = this.axios.defaults.baseURL.replace('/api', '') + selectedOpt.image_url;
    },
    fetchNewForms: function fetchNewForms() {
      var _this11 = this;

      console.log(this.lastFormId);
      _vue2.default.axios.get('/form_docs/new_forms?latest_form=' + this.latestFormId, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        // update latestFormId only on first call
        if (_this11.latestFormId === -1) {
          _this11.latestFormId = res.data.latest_form;
        }
        _this11.updatedLatestFormId = res.data.latest_form;
        if (_this11.lastFormId !== _this11.updatedLatestFormId && res.data.new_forms === 0) {
          _this11.latestFormId = res.data.latest_form;
        }
        _this11.newFormsProcessed = res.data.new_forms;
        _this11.esm_status = res.data.esm_status;
        _this11.tm_status = res.data.tm_status;
        _this11.latestFormStatus = res.data.status;
        _this11.refreshShowTriagingTab = res.data.all_triaging;
      }).catch(function (error) {
        console.log('Error while Polling :', error);
      });
    },

    handleRefresh: function handleRefresh() {
      var userRoleOrder = parseInt(this.userRoleOrder);
      if (this.$route.query.status === 'processing') {
        this.processing = false;
        // if (this.esm_status === 'no') {
        //   Vue.toasted.show(this.$t('COMMON.ESM'))
        // }
        // if (this.tm_status === 'no') {
        //   Vue.toasted.show(this.$t('COMMON.TM'))
        // }
        this.$router.replace('/process/processed');
      }
      if (this.refreshShowTriagingTab) {
        this.tabIndex = 0;
        this.refreshTab(this.tabIndex, -2);
      } else {
        if (this.latestFormStatus === 'unmatched') {
          this.tabIndex = this.tabs.length - 1;
        } else {
          this.tabIndex = Number(this.userRoleOrder);
        }
        this.refreshTab(this.tabIndex, userRoleOrder);
      }
    },
    infiniteHandler: function infiniteHandler($state) {
      var _this12 = this;

      var vm = this;
      var order = this.order;
      var lastFormId = this.lastFormId;
      var filter = this.filter;
      var searchType = this.searchType;
      var dateRangeType = this.dateRangeType;
      var fromDate = dateRangeType === '' ? '' : (0, _moment2.default)(this.fromDate).format('YYYY-MM-DD HH:mm:ss');
      var toDate = dateRangeType === '' ? '' : (0, _moment2.default)(this.toDate).format('YYYY-MM-DD HH:mm:ss');
      var productType = this.productType;
      var status = order > 0 ? 'stage_' + order : order === -1 ? 'unmatched' : 'TRIAGING';
      var params = {
        forms_doc_status: this.formDocStatus,
        time_zone_offset: this.localTime === 'true' ? new Date().getTimezoneOffset() : null
      };
      _vue2.default.axios.get('/form_docs/status_forms/?status=' + status + '&lastFormId=' + lastFormId + '&searchType=' + searchType + '&filter=' + encodeURIComponent(filter.toString()) + '&dateRangeType=' + dateRangeType + '&fromDate=' + fromDate + '&toDate=' + toDate + '&productType=' + productType + '&engagement_program=' + this.engagementProgram, { headers: { Authorization: 'Bearer ' + vm.idToken }, params: params }).then(function (res) {
        var formDocs = res.data.form_docs;
        formDocs.map(function (element) {
          if (element.form_doc_lock === true) {
            element._rowVariant = 'gray-700';
          } else if (_this12.formDocumnetStatus[element.forms_doc_status] === 'Integration Failed') {
            element._rowVariant = 'danger';
          } else {
            element._rowVariant = 'none';
          }
        });
        if (formDocs.length && _this12.filter === res.data.meta.filter) {
          _this12.sortBy = 'group_id';
          _this12.sortDesc = true;
          if (lastFormId === -1) {
            _this12.processedData = formDocs;
          } else {
            _this12.processedData = _this12.processedData.slice().concat(formDocs);
          }
          _this12.$store.dispatch('updateProcessedData', _this12.processedData);
          _this12.formsLoaded = true;
          _this12.disable_tab = false;
          _this12.distance = 100;
          _this12.latestFormId = Math.max(_this12.latestFormId, _this12.processedData[0].id);
          _this12.newFormsProcessed = _this12.updatedLatestFormId - _this12.latestFormId;
          _this12.lastFormId = formDocs[formDocs.length - 1]['id'];
          $state.loaded();
          if (_this12.$store.getters.exportFormDocID) {
            var data = _this12.processedData.filter(function (data) {
              return data.id === parseInt(_this12.$store.getters.exportFormDocID);
            });
            if (data && data.length > 0) {
              _this12.$nextTick(function () {
                _this12.$store.commit('setExportFormDocID', null);
                _this12.processJson(data[0], 'salesforce');
              });
            }
          } else if (_this12.$store.getters.rotatedDocFormDocId) {
            var _data = _this12.processedData.filter(function (data) {
              return data.id === parseInt(_this12.$store.getters.rotatedDocFormDocId);
            });
            if (_data && _data.length > 0) {
              _this12.$nextTick(function () {
                _this12.$store.commit('setRotatedDocFormDocId', null);
                _this12.processRotatedDoc(_data[0], 'rotated_docs_sf');
              });
            }
          }
        } else if (!formDocs.length) {
          _this12.formsLoaded = true;
          _this12.disable_tab = false;
          _this12.distance = 100;
          $state.complete();
        }
      }).catch(function (error) {
        console.log(error);
        if (error.status === 401) {
          console.log(_this12.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this12.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          _this12.disable_tab = false;
        }
      });
    },
    multipleUser: function multipleUser(id) {
      if (this.isAdminRole) {
        this.$refs.lockedFormDocWarning.show();
        this.id = id;
      }
    },
    releaseFormDoc: function releaseFormDoc() {
      var _this13 = this;

      _vue2.default.axios.get('/forms/update_form_doc_lock', { headers: { Authorization: 'Bearer ' + this.idToken }, params: { id: this.id } }).then(function (res) {
        _this13.processedData = _this13.$store.getters.getProcessedData;
        var form = _this13.processedData.filter(function (temp) {
          return temp.id === _this13.id;
        });
        form[0].form_doc_lock = false;
        form[0]._rowVariant = 'none';
        _this13.$store.dispatch('updateProcessedData', _this13.processedData);
      }).catch(function (error) {
        console.log(error);
      });
    },
    stayWithFormDoc: function stayWithFormDoc() {
      this.$refs.lockedFormDocWarning.hide();
    },
    handleTabChange: function handleTabChange(order) {
      this.resetFilterValues();
      this.eventBus.$emit('resetFilterModalValues');
      this.disable_tab = true;
      this.formsLoaded = false;
      this.$store.commit('setPrevFormsTab', this.tabIndex);
      this.order = order;
      this.distance = Infinity;
      this.lastFormId = -1;
      this.processedData = [];
      this.$store.dispatch('updateProcessedData', []);
      this.infiniteId = order;
      this.handleFilterChanges();
    },
    resetFilterValues: function resetFilterValues() {
      this.filter = '';
      this.searchType = 'title';
      this.dateRangeType = 'Today';
      this.fromDate = '';
      this.toDate = '';
      this.productType = '';
      this.formDocStatus = '';
    },
    allowedExports: function allowedExports(matchType, tabIndex, status) {
      var formDocStatus = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var allowedExportButtons;
      var currTabIndex = 1;
      currTabIndex = Number(this.userRoleOrder);
      if (currTabIndex === tabIndex) {
        switch (matchType.split(',')[0]) {
          case 'Auto':
          case 'Manual':
            allowedExportButtons = status === 'accepted' || this.formDocumnetStatus[formDocStatus] === 'Integration Failed' ? ['analysis', 'download', 'csv', 'salesforce', 'rems', 'edi_837', 'ftp', 'otrf', 'ehr', 'fhir', 'delete', 'reject', 'recall'] : ['analysis', 'download', 'rems', 'delete', 'reject', 'recall'];
            break;
          case 'Insurance card':
          case 'Multipage insurance card':
          case 'Drivers License/Voter ID':
            allowedExportButtons = status === 'accepted' ? ['analysis', 'download', 'salesforce', 'edi_837', 'ftp', 'delete'] : ['analysis', 'download', 'delete'];
            break;
          case 'Plain Text':
          case 'Lease Document':
            allowedExportButtons = status === 'accepted' ? ['analysis', 'download', 'edi_837', 'ftp', 'delete'] : ['analysis', 'download', 'delete'];
            break;
          case 'Invoice':
          case 'Excel Workbook':
            allowedExportButtons = status === 'accepted' ? ['analysis', 'download', 'csv', 'quickbooks', 'edi_837', 'ftp', 'delete'] : ['analysis', 'download', 'delete'];
            break;
          default:
            allowedExportButtons = ['analysis', 'download', 'delete', 'reject', 'recall'];
        }
      } else if (this.order === -1) {
        if (this.formDocumnetStatus[formDocStatus] === 'Integration Failed') {
          if (status === 'unmatched_accepted') {
            allowedExportButtons = ['analysis', 'download', 'salesforce', 'reject', 'recall'];
          }
        } else if (this.formDocumnetStatus[formDocStatus] === 'Validated') {
          if (status === 'unmatched_accepted') {
            allowedExportButtons = ['analysis', 'download', 'salesforce', 'reject', 'recall'];
          }
        } else {
          allowedExportButtons = ['analysis', 'download', 'moveToMatched', 'reprocess', 'reject', 'recall'];
        }
      } else if (this.order === -2) {
        if (status === 'TRIAGING') {
          allowedExportButtons = ['reject', 'recall', 'rotated_docs_sf'];
        }
      } else {
        allowedExportButtons = ['analysis', 'download', 'moveToMatched'];
      }
      return allowedExportButtons;
    },
    getCSS: function getCSS(matchType, tabIndex, status, type) {
      var allowedExportButtons = this.allowedExports(matchType, tabIndex, status);
      return {
        'first-button': allowedExportButtons.indexOf(type) === 0,
        'last-button': allowedExportButtons.indexOf(type) === allowedExportButtons.length - 1
      };
    },
    setFilter: function setFilter(filter) {
      this.filter = filter;
    },

    getTabName: function getTabName(name) {
      if (name === 'unmatched') {
        return this.$t('PROFILE.ROLES.UNMATCHED');
      } else if (name === 'admin') {
        return this.$t('PROFILE.ROLES.ADMIN');
      } else {
        return name;
      }
    },
    refreshTab: function refreshTab(tabIndex, order) {
      this.filter = '';
      this.tabIndex = tabIndex;
      this.disable_tab = true;
      this.formsLoaded = false;
      this.newFormsProcessed = 0;
      this.order = order;
      this.latestFormId = this.updatedLatestFormId;
      this.distance = Infinity;
      this.lastFormId = -1;
      this.processedData = [];
      this.$store.dispatch('updateProcessedData', []);
      this.eventBus.$emit('resetFilter');
      this.$refs.infiniteLoading[this.tabIndex].$emit('$InfiniteLoading:reset');
    },
    applyFilters: function applyFilters(searchType, searchText, dateRangeType, fromDate, toDate, engagementProgram, productType, formDocStatus) {
      this.filter = searchText;
      this.searchType = searchType;
      this.dateRangeType = dateRangeType;
      this.fromDate = fromDate;
      this.toDate = toDate;
      this.formDocStatus = formDocStatus;
      // this.productType = productType
      this.disable_tab = true;
      this.formsLoaded = false;
      this.distance = Infinity;
      this.lastFormId = -1;
      this.processedData = [];
      this.$store.dispatch('updateProcessedData', this.processedData);
      this.$refs.infiniteLoading[this.tabIndex].$emit('$InfiniteLoading:reset');
    },
    processExport: function processExport(form, type) {
      if (type === 'quickbooks') {
        this.authenticateQB(form, type);
      } else {
        this.processJson(form, type);
      }
    },
    authenticateQB: function authenticateQB(form, type) {
      var _this14 = this;

      _vue2.default.axios.post('auth/verify', { service: type }, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.data.verified) {
          _this14.processJson(form, type);
        } else {
          _router2.default.push('/auth?redirect_to=' + window.location.href + '&service=quickbooks');
        }
      });
    },
    processedApiRems: function processedApiRems(templateId, formDocId) {
      var exportRef = this.$refs['export-rems-' + formDocId][0];
      var spinnerRef = this.$refs['spinner-rems-' + formDocId][0];
      exportRef.style.display = 'none';
      spinnerRef.style.display = 'inherit';
      _vue2.default.axios.post('/rems/rems_sf/rems_export_processed_results', { formDocId: formDocId, templateId: templateId }, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        spinnerRef.style.display = 'none';
        exportRef.style.display = 'inherit';
        _vue2.default.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' });
      }).catch(function (err) {
        console.log(err);
        spinnerRef.style.display = 'none';
        exportRef.style.display = 'inherit';
        _vue2.default.toasted.show('failed during export', { icon: 'chain-broken', type: 'error' });
      });
    },
    processRotatedDoc: function processRotatedDoc(form, type) {
      var _this15 = this;

      var data = { ids: form.form_ids };
      var exportRef = this.$refs['export-rotated_docs_sf-' + form.id][0];
      var spinnerRef = this.$refs['spinner-rotated_docs_sf-' + form.id][0];
      exportRef.style.display = 'none';
      spinnerRef.style.display = 'inherit';
      _vue2.default.axios.post('exports/' + form.id + '/' + type, data, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        spinnerRef.style.display = 'none';
        exportRef.style.display = 'inherit';
        if (res.data.status === 'success') {
          var message = res.data.message;
          _this15.processedData.map(function (data) {
            if (data.id === form.id) {
              form.sf_export_status = true;
              form.forms_doc_status = res.data.forms_doc_status;
              form.processed = 0;
              form.first_form_id = null;
            }
            return data;
          });
          form._rowVariant = 'none';
          _vue2.default.toasted.show(message);
          if (_this15.is_export_error_modal) {
            _this15.$refs.exportErrorModal.show();
          }
        } else {
          if (res.data.status === 'failed') {
            form._rowVariant = 'danger';
            form.sf_export_status = false;
            form.forms_doc_status = res.data.forms_doc_status;
            _this15.validationErrors = res.data.errors;
            _this15.$refs.validationErrorModal.show();
          }
          _vue2.default.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (error) {
        console.log(error);
        spinnerRef.style.display = 'none';
        exportRef.style.display = 'inherit';
        _vue2.default.toasted.show(_this15.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
      });
    },
    processJson: function processJson(form, type) {
      var _this16 = this;

      var data = { ids: form.form_ids };
      var exportRef = this.$refs['export-' + type + '-' + this.tabIndex + '-' + form.id][0];
      var spinnerRef = this.$refs['spinner-' + type + '-' + this.tabIndex + '-' + form.id][0];
      exportRef.style.display = 'none';
      spinnerRef.style.display = 'inherit';
      _vue2.default.axios.post('exports/' + form.id + '/' + type, data, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        spinnerRef.style.display = 'none';
        exportRef.style.display = 'inherit';
        res.data.errors = res.data.errors.filter(function (item) {
          return item.key !== 'sign/date_missing';
        });
        if (res.data.status === 'success') {
          var type = res.data.type;
          var message = res.data.message;
          var mimeType = void 0;
          var fileType = void 0;
          var blob = void 0;
          var link = void 0;
          switch (type) {
            case 'download':
              var processedData = res.data.form;
              mimeType = type === 'download' ? 'application/json' : 'text/plain';
              fileType = type === 'download' ? '.json' : '.txt';
              blob = new window.Blob([JSON.stringify(processedData)], { type: mimeType });

              link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = form.title + fileType;
              document.body.appendChild(link);
              link.click();
              // case 'ftp':
              //   let processedData = res.data.form
              //   let mimeType = (type === 'download') ? 'application/json' : 'text/plain'
              //   let fileType = (type === 'download') ? '.json' : '.txt'
              //   let blob = new window.Blob([JSON.stringify(processedData)], { type: mimeType })

              //   let link = document.createElement('a')
              //   link.href = window.URL.createObjectURL(blob)
              //   link.download = form.title + fileType
              //   document.body.appendChild(link)
              //   link.click()
              break;
            case 'csv':
              var csvData = res.data.csv_data;
              mimeType = 'text/plain';
              fileType = '.csv';
              blob = new window.Blob([csvData], { type: mimeType });
              link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = form.title + fileType;
              document.body.appendChild(link);
              link.click();
              break;
            case 'edi_837':
              var processedDataHL7 = res.data.form;
              mimeType = type === 'download' ? 'application/json' : 'text/plain';
              fileType = type === 'download' ? '.json' : '.txt';
              blob = new window.Blob([processedDataHL7], { type: mimeType });
              link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = form.title + fileType;
              document.body.appendChild(link);
              link.click();
              break;
            case 'otrf':
              var processedDataOTRF = res.data.result;
              mimeType = type === 'download' ? 'application/json' : 'text/plain';
              fileType = type === 'download' ? '.json' : '.txt';
              blob = new window.Blob([processedDataOTRF], { type: mimeType });

              link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = form.title + fileType;
              document.body.appendChild(link);
              link.click();
              break;
            case 'salesforce':
              _this16.processedData.map(function (data) {
                if (data.id === form.id) {
                  form.sf_export_status = true;
                  form.forms_doc_status = res.data.forms_doc_status;
                  form.processed = 0;
                  form.first_form_id = null;
                }
                return data;
              });
              form._rowVariant = 'none';
              _vue2.default.toasted.show(message);
              if (_this16.is_export_error_modal) {
                _this16.$refs.exportErrorModal.show();
              }
              if (res.data.errors.length > 0) {
                _this16.validationErrors = res.data.errors;
                _this16.errorKeyAbsent = true;
                _this16.$refs.validationErrorModal.show();
              }
              break;
            case 'quickbooks':
            case 'ehr':
              _vue2.default.toasted.show(message);
              break;
            case 'fhir':
              _this16.fhirValues = JSON.parse(res.data.fhir_data);
              _this16.$refs.fhirModal.show();
              break;
          }
        } else {
          switch (res.data.type) {
            case 'salesforce':
              if (res.data.status === 'failed') {
                form._rowVariant = 'danger';
                form.sf_export_status = false;
                form.forms_doc_status = res.data.forms_doc_status;
                _this16.validationErrors = res.data.errors;
                _this16.$refs.validationErrorModal.show();
                // this.refreshTab(0, 1)
              }
              break;
          }
          _vue2.default.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (error) {
        console.log(error);
        spinnerRef.style.display = 'none';
        exportRef.style.display = 'inherit';
        _vue2.default.toasted.show(_this16.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
      });
    },
    clearFhirData: function clearFhirData() {
      this.fhirValues = {};
    },
    clearValidationErrorData: function clearValidationErrorData() {
      this.validationErrors = [];
    },
    clearExportErrorData: function clearExportErrorData() {
      this.$refs.exportErrorModal.hide();
      this.is_export_error_modal = false;
      this.exportErrors = [];
      this.med_status_array = [];
    },
    confirmReprocess: function confirmReprocess(data) {
      this.selectedFormTitle = data.title;
      this.selectedFormDocId = data.id;
      this.match_type = null;
      this.canShowImgPreview = false;
      this.previewImageUrl = '';
      this.forced_template_doc_id = null;
      this.$refs.reprocessModal.show();
    },
    reprocessFormDoc: function reprocessFormDoc() {
      var _this17 = this;

      var data = {};
      data.title = this.selectedFormTitle;
      data.forced_template_doc_id = this.forced_template_doc_id;
      data.account_id = this.accountId;
      _vue2.default.axios.post('/form_docs/' + this.selectedFormDocId + '/reprocess', data, {
        headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _vue2.default.toasted.show(_this17.$t('COMMON.MSG_REPROS'));
        _this17.handleRefresh();
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this17.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this17.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    moveToMatched: function moveToMatched(item) {
      var _this18 = this;

      _vue2.default.axios.get('/form_docs/' + item.id + '/change_unmatched_status', { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.status === 200) {
          _vue2.default.toasted.show('Form Update Success');
        } else if (res.status === 201) {
          _vue2.default.toasted.show(_this18.$t('COMMON.UNMATCH'), { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    processedformsInfoModal: function processedformsInfoModal(data) {
      var _this19 = this;

      var payload = {
        formDocId: data.id
      };
      _vue2.default.axios.post('/form_docs/processed_form_info', payload, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this19.processed_form_info = res.data.processed_form_info;
        _this19.$refs.processedformsInfo.show();
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this19.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this19.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    showFormInfo: function showFormInfo() {
      this.$refs.processedformsInfo.hide();
    },
    confirmDelete: function confirmDelete(data) {
      this.selectedFormTitle = data.title;
      this.selectedFormDocId = data.id;
      this.$refs.formDelModal.show();
    },
    deleteFormDoc: function deleteFormDoc() {
      var _this20 = this;

      var formDocId = this.selectedFormDocId;
      _vue2.default.axios.delete('/form_docs/' + formDocId, {
        headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.status === 200) {
          var deletedFormDoc = parseInt(res.data.formDocId[0]);
          _this20.processedData = _this20.processedData.slice(0).filter(function (doc, index) {
            return doc.id !== deletedFormDoc;
          });
          _this20.$store.dispatch('updateProcessedData', _this20.processedData);
          _vue2.default.toasted.show(res.data.status);
        }
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this20.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this20.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    }
  }
};

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _svg = __webpack_require__(28);

var _svg2 = _interopRequireDefault(_svg);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _vuex = __webpack_require__(5);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vueMultiselect = __webpack_require__(36);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { Multiselect: _vueMultiselect2.default },
  data: function data() {
    return {
      svg: _svg2.default,
      showClear: false,
      showCheck: true,
      currDate: (0, _moment2.default)().format('YYYY-MM-DD').toString(),
      deleteFilter: '',
      fromDate: '',
      toDate: '',
      deletableForms: [],
      invalidInputs: false,
      selectedForms: [],
      selectedAll: false,
      matchOptions: [],
      search_type: 'title',
      filterToDate: '',
      filterFromDate: '',
      searchText: '',
      dateRangeDropDown: null,
      productType: '',
      searchPlaceholder: this.$t('WORKFLOW.SEARCH'),
      dateRangeOptions: [{ value: null, text: 'Select Date Range' }, { value: 'last_hour', text: 'Last Hour' }, { value: 'last_6_hour', text: 'Last 6 Hour' }, { value: 'today', text: 'Today' }, { value: 'yesterday', text: 'Yesterday' }, { value: 'this_week', text: 'This Week' }, { value: 'last_week', text: 'Last Week' }, { value: 'this_month', text: 'This Month' }, { value: 'custom_range', text: 'Custom Range' }],
      shortcuts: [{ text: 'last_hour', fromDate: (0, _moment2.default)().subtract(1, 'hour'), toDate: (0, _moment2.default)() }, { text: 'last_6_hour', fromDate: (0, _moment2.default)().subtract(6, 'hour'), toDate: (0, _moment2.default)() }, { text: 'today', fromDate: (0, _moment2.default)().startOf('day'), toDate: (0, _moment2.default)() }, { text: 'yesterday', fromDate: (0, _moment2.default)().subtract(1, 'day').startOf('day'), toDate: (0, _moment2.default)().subtract(1, 'day').endOf('day') }, { text: 'this_week', fromDate: (0, _moment2.default)().startOf('week'), toDate: (0, _moment2.default)() }, { text: 'last_week', fromDate: (0, _moment2.default)().subtract(1, 'week').startOf('week'), toDate: (0, _moment2.default)().subtract(1, 'week').endOf('week').endOf('day') }, { text: 'this_month', fromDate: (0, _moment2.default)().startOf('month'), toDate: (0, _moment2.default)().endOf('month') }],
      productOptions: [],
      engagementPrograms: [],
      selectedEngagementProgram: null,
      defaultTriagestatus: [{ value: 1, text: 'New' }, { value: 2, text: 'In Progress' }, { value: 3, text: 'Partially Completed' }, { value: 4, text: 'Completed' }, { value: 6, text: 'Recalled' }, { value: 12, text: 'Triaged' }, { value: 7, text: 'Integration Success' }, { value: 8, text: 'Integration Failed' }, { value: 5, text: 'Rejected' }],
      selectedTriageStatus: [],
      defaultAgentstatus: [{ value: 11, text: 'Pending' }, { value: 2, text: 'In Progress' }, { value: 10, text: 'Validated' }, { value: 6, text: 'Recalled' }, { value: 7, text: 'Integration Success' }, { value: 8, text: 'Integration Failed' }, { value: 5, text: 'Rejected' }],
      selectedAgentStatus: [],
      defaultUnmatchedstatus: [{ value: 11, text: 'Pending' }, { value: 2, text: 'In Progress' }, { value: 10, text: 'Validated' }, { value: 6, text: 'Recalled' }, { value: 7, text: 'Integration Success' }, { value: 8, text: 'Integration Failed' }, { value: 5, text: 'Rejected' }],
      selectedUnmatchStatus: [],
      triageStatuses: [{ value: 1, text: 'New' }, { value: 2, text: 'In Progress' }, { value: 3, text: 'Partially Completed' }, { value: 4, text: 'Completed' }, { value: 5, text: 'Rejected' }, { value: 6, text: 'Recalled' }, { value: 9, text: 'Document Moved To SF' }, { value: 12, text: 'Triaged' }, { value: 7, text: 'Integration Success' }, { value: 8, text: 'Integration Failed' }],
      formDocumnetStatuses: [{ value: 11, text: 'Pending' }, { value: 2, text: 'In Progress' }, { value: 10, text: 'Validated' }, { value: 7, text: 'Integration Success' }, { value: 8, text: 'Integration Failed' }, { value: 5, text: 'Rejected' }, { value: 6, text: 'Recalled' }, { value: 9, text: 'Document Moved To SF' }],
      unmatchStatuses: [{ value: 11, text: 'Pending' }, { value: 2, text: 'In Progress' }, { value: 10, text: 'Validated' }, { value: 7, text: 'Integration Success' }, { value: 8, text: 'Integration Failed' }, { value: 5, text: 'Rejected' }, { value: 6, text: 'Recalled' }, { value: 9, text: 'Document Moved To SF' }]
    };
  },

  props: ['title', 'eventBus', 'order', 'tabIndex'],
  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'userRoleOrder', 'selectTriageStatus', 'selectAgentStatus', 'selectUnmatchStatus']), {
    checkAuth: function checkAuth() {
      var order = parseInt(this.$props.order);
      var userRoleOrder = parseInt(this.userRoleOrder);
      return order === -2 || order === -1 || order <= userRoleOrder;
    },
    setOptions: function setOptions() {
      this.matchOptions = [{ text: this.$t('WORKFLOW.TITLE'), value: 'title' }];
      return this.matchOptions;
    }
  }),
  watch: {
    selectedForms: function selectedForms() {
      this.selectedAll = this.deletableForms.length > 0 && this.deletableForms.length === this.selectedForms.length;
    },
    deleteFilter: function deleteFilter() {
      this.handleFilterUpdate();
    },
    fromDate: function fromDate() {
      this.handleFilterUpdate();
    },
    toDate: function toDate() {
      this.handleFilterUpdate();
    },
    search_type: function search_type() {
      if (this.search_type === 'faxnum') {
        this.searchPlaceholder = this.$t('WORKFLOW.ENTER_FAX_NUMBER');
      } else {
        this.searchPlaceholder = this.$t('WORKFLOW.SEARCH');
      }
    }
  },
  /*
  created () {
    Vue.axios.get('/form_docs/fetch_product_types', { headers: { Authorization: `Bearer ${this.idToken}` } })
      .then(res => {
        if (res.status === 200) {
          this.productOptions = [{ value: '', text: 'Select Product' }].concat(res.data.product_list)
        }
      }).catch(error => {
        console.log(error)
        if (error.status === 401) {
          Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
        } else {
          Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
        }
      })
  },
  */
  created: function created() {
    this.setSelectedStatuses();
  },
  mounted: function mounted() {
    this.eventBus.$on('resetFilter', this.clearFilter);
    this.eventBus.$on('resetFilterModalValues', this.resetFilters);
  },

  methods: {
    clearFilter: function clearFilter() {
      this.$refs.searchInput.$el.value = '';
      this.$emit('filterInput', '');
      this.applyFilters();
    },
    resetbutton: function resetbutton() {
      this.selectedTriageStatus = this.defaultTriagestatus;
      this.$store.commit('setselectTriageStatus', this.selectTriageStatus);
      this.selectedAgentStatus = this.defaultAgentstatus;
      this.$store.commit('setselectAgentStatus', this.selectAgentStatus);
      this.selectedUnmatchStatus = this.defaultUnmatchedstatus;
      this.$store.commit('setselectUnmatchStatus', this.selectUnmatchStatus);
      this.resetFilters(false);
    },
    resetFilters: function resetFilters() {
      var isTabChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (isTabChange) {
        this.setSelectedStatuses();
      }
      this.search_type = 'title';
      this.searchText = '';
      this.searchPlaceholder = this.$t('WORKFLOW.SEARCH');
      this.selectedDocStatus = [{ value: 1, text: 'New' }, { value: 2, text: 'In Progress' }, { value: 6, text: 'Recalled' }];
      this.selectedFormStatus = [{ value: 11, text: 'Pending' }, { value: 2, text: 'In Progress' }, { value: 10, text: 'Validated' }, { value: 6, text: 'Recalled' }, { value: 7, text: 'Integration Success' }, { value: 8, text: 'Integration Failed' }];
      this.selectedDocLockStatus = '';
      this.fromDate = '';
      this.toDate = '';
      this.dateRangeDropDown = null;
      this.toDatePlaceholder = 'mm/dd/yyyy';
      this.fromDatePlaceholder = 'mm/dd/yyyy';
      this.filterToDate = '';
      this.filterFromDate = '';
    },
    setSelectedStatuses: function setSelectedStatuses() {
      if (this.selectTriageStatus && this.selectTriageStatus.length >= 0) {
        this.selectedTriageStatus = this.selectTriageStatus;
      } else {
        this.selectedTriageStatus = this.defaultTriagestatus;
      }
      if (this.selectAgentStatus && this.selectAgentStatus.length >= 0) {
        this.selectedAgentStatus = this.selectAgentStatus;
      } else {
        this.selectedAgentStatus = this.defaultAgentstatus;
      }
      if (this.selectUnmatchStatus && this.selectUnmatchStatus.length >= 0) {
        this.selectedUnmatchStatus = this.selectUnmatchStatus;
      } else {
        this.selectedUnmatchStatus = this.defaultUnmatchedstatus;
      }
    },
    showModal: function showModal() {
      this.$refs.MultiFormDelModal.show();
    },
    hideModal: function hideModal() {
      this.$refs.MultiFormDelModal.hide();
    },
    showFilterModal: function showFilterModal() {
      this.$refs.filterModal.show();
    },
    filterModalApply: function filterModalApply() {
      this.applyFilters();
      this.$refs.filterModal.hide();
    },
    applyFilters: function applyFilters() {
      var _this = this;

      var values = [];
      if (this.order === -2) {
        values = this.selectedTriageStatus.map(function (status) {
          return status.value;
        });
        this.$store.commit('setselectTriageStatus', this.selectedTriageStatus);
      } else if (this.order === 1) {
        values = this.selectedAgentStatus.map(function (status) {
          return status.value;
        });
        this.$store.commit('setselectAgentStatus', this.selectedAgentStatus);
      } else {
        values = this.selectedUnmatchStatus.map(function (status) {
          return status.value;
        });
        this.$store.commit('setselectUnmatchStatus', this.selectedUnmatchStatus);
      }
      var date = this.shortcuts.filter(function (type) {
        if (type.text === _this.dateRangeDropDown) return type;
      });
      var fromDate = null;
      var toDate = null;
      if (date.length > 0) {
        fromDate = date[0].fromDate.format('YYYY-MM-DD HH:mm:ss');
        toDate = date[0].toDate.format('YYYY-MM-DD HH:mm:ss');
      } else {
        fromDate = this.filterFromDate;
        toDate = (0, _moment2.default)(this.filterToDate).endOf('day');
      }
      this.$emit('applyFilters', this.search_type, this.searchText, this.dateRangeDropDown, fromDate, toDate, this.selectedEngagementProgram, this.productType, values);
    },
    filterModalClose: function filterModalClose() {
      this.$refs.filterModal.hide();
    },
    onHidden: function onHidden() {
      this.deleteFilter = '';
      this.fromDate = '';
      this.toDate = '';
      this.showCheck = true;
      this.$refs.deleteTitleFilter.$el.value = '';
      this.$refs.deleteFromDate.$el.value = '';
      this.$refs.deleteToDate.$el.value = '';
    },

    handleSelectAll: function handleSelectAll() {
      if (this.selectedAll) {
        this.selectedForms = this.deletableForms.map(function (form) {
          return form.id;
        });
      } else {
        this.selectedForms = [];
      }
    },
    handleFilterUpdate: function handleFilterUpdate() {
      this.showCheck = true;
      this.deletableForms = [];
      this.selectedForms = [];
      this.selectedAll = false;
      this.invalidInputs = false;
    },
    checkDeletableForms: function checkDeletableForms() {
      var _this2 = this;

      var filter = this.deleteFilter;
      var fromDate = this.fromDate;
      var toDate = this.toDate;
      var isValid = fromDate && toDate && filter || fromDate && toDate || filter && !fromDate && !toDate;
      if (isValid) {
        var vm = this;
        var order = this.$props.order;
        var status = order > 0 ? 'stage_' + order : 'unmatched';
        _vue2.default.axios.get('/form_docs/deletable_forms?status=' + status + '&filter=' + encodeURIComponent(filter.toString()) + '&fromDate=' + this.fromDate + '&toDate=' + this.toDate, { headers: { Authorization: 'Bearer ' + vm.idToken } }).then(function (res) {
          if (res.status === 200) {
            _this2.deletableForms = res.data.form_docs;
            _this2.showCheck = false;
          }
        }).catch(function (error) {
          console.log(error);
          if (error.status === 401) {
            _vue2.default.toasted.show(_this2.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          } else {
            _vue2.default.toasted.show(_this2.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      } else {
        this.invalidInputs = true;
      }
    },
    deleteMultiForms: function deleteMultiForms() {
      var _this3 = this;

      var vm = this;
      _vue2.default.axios.post('/form_docs/destroy_multi', { ids: this.selectedForms }, { headers: { Authorization: 'Bearer ' + vm.idToken } }).then(function (res) {
        if (res.status === 200) {
          _this3.$refs.MultiFormDelModal.hide();
          _vue2.default.toasted.show(res.data.status + ' ' + res.data.deleted + ' forms.');
          _this3.$emit('refreshTab', _this3.$props.tabIndex, _this3.$props.order);
        }
      }).catch(function (error) {
        console.log(error);
        if (error.status === 401) {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    }
  }
};

/***/ }),
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _processForm = __webpack_require__(466);

var _processForm2 = _interopRequireDefault(_processForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    processForm: _processForm2.default
  },
  data: function data() {
    return {
      formId: null
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['idToken'])),
  created: function created() {
    var _this = this;

    var vm = this;
    _vue2.default.axios.get('/form_docs/' + this.$route.params.docId, { headers: { Authorization: 'Bearer ' + vm.idToken } }).then(function (res) {
      if (res.status === 200) {
        _this.formId = res.data.form_doc.first_form_id;
      }
    }).catch(function (error) {
      if (error.status === 404) {
        _vue2.default.toasted.show(_this.$t('COMMON.MSG_FORM_REQ'), { icon: 'chain-broken', type: 'error' });
      } else {
        _vue2.default.toasted.show(_this.$t('COMMON.MSG_FETCH_ERR'), { icon: 'chain-broken', type: 'error' });
      }
    });
  }
};

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processForm_vue__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processForm_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processForm_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processForm_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46419a40_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processForm_vue__ = __webpack_require__(1116);
function injectStyle (ssrContext) {
  __webpack_require__(1099)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46419a40"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processForm_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46419a40_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _konva = __webpack_require__(69);

var _konva2 = _interopRequireDefault(_konva);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _processedDataTree = __webpack_require__(1100);

var _processedDataTree2 = _interopRequireDefault(_processedDataTree);

var _pagination = __webpack_require__(338);

var _pagination2 = _interopRequireDefault(_pagination);

var _validators = __webpack_require__(1115);

var _validators2 = _interopRequireDefault(_validators);

var _validators3 = __webpack_require__(32);

var _moment2 = __webpack_require__(0);

var _moment3 = _interopRequireDefault(_moment2);

var _lodash = __webpack_require__(45);

var _lodash2 = _interopRequireDefault(_lodash);

var _svg = __webpack_require__(28);

var _svg2 = _interopRequireDefault(_svg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = {
  props: ['formId'],
  data: function data() {
    return {
      id: this.formId || this.$route.params.id,
      imgBase: "/api".replace('/api', ''),
      konvaStage: '',
      formData: {},
      treePath: {},
      dataBus: new _vue2.default(),
      updatedData: [],
      checkedUpdatedData: [],
      spareFormData: {},
      baseLayer: null,
      scrollHeight: 10000,
      editorDataLoaded: false,
      serviceValidationErrorMessage: [],
      requiredFieldsValidationError: [],
      isSignatureValidated: null,
      isServiceValidated: null,
      formValidations: null,
      processedDataLoaded: false,
      newFieldLabel: null,
      newFieldValue: null,
      svg: _svg2.default,
      showMessage: false,
      isFormDocValid: true,
      pageLevelErrors: [],
      minConf: 0,
      maxConf: 100,
      formUpdateLogs: [],
      isLogsLoaded: false,
      updateFields: [{ key: 'index', label: 'Version' }, { key: 'updated_by', label: 'Updated By' }, { key: 'field', label: 'Field' }, { key: 'original', label: 'Original Text' }, { key: 'updated', label: 'Updated Text' }, { key: 'updated_at', label: 'Updated Date & Time' }],
      filterOn: ['field'],
      filter: null,
      updateLogsFilterOptions: [{ value: null, text: 'all' }, { value: 'Gender', text: 'Gender' }, { value: 'Phone', text: 'Phone' }, { value: 'Name', text: 'Name' }],
      logsCurrentPage: 1,
      showAddDataButton: true,
      logsPerPage: 5,
      totalUpdateLogs: 0,
      tableHeaders: [],
      originalPEVs: {},
      updatedPEVs: {},
      dataPages: [{ text: 'Select Page Number', value: null }],
      selectedPageNum: 0,
      showInsClaim: false,
      verification_start: false,
      updatedPEVIds: [],
      invoice: {
        selectedAccount: null,
        selectedAccountingUnit: null,
        totalAmount: null,
        description: ''
      },
      invoiceSign: {
        accounts: [],
        accountingUnits: []
      },
      selectedTablePath: null,
      currentHoverIndex: null,
      prev_form_id: null,
      next_form_id: null,
      navigatingPage: 0,
      templateOptions: [],
      selectedTemplate: null,
      previewImageUrl: '',
      templatePageOptions: [],
      selectedTemplatePage: null,
      pagePrevImgUrl: '',
      autoCorrectFlag2: false,
      autoCorrectFlag1: false,
      editOnly: false,
      salesForeceValidationError: null,
      processValueText: '',
      dataPresent: true,
      isOpenCompareUploaded: false,
      image_url: '',
      original_image_url: '',
      toShowOriginalImage: false,
      ishideUnhideClicked: false
    };
  },
  created: function created() {
    var _this = this;

    // Toggle sidebar for this page
    // TODO: Move to a common place. Remove duplicates
    window.addEventListener('scroll', this.handleScroll);

    var classList = document.body.classList;
    if (!classList.contains('sidebar-minimized')) {
      classList.toggle('sidebar-minimized');
      classList.toggle('brand-minimized');
    }

    var vm = this;
    this.dataBus.$on('updateData', function (value) {
      var updateIds = value.map(function (val) {
        return val.id;
      });
      var uniqUpdateData = vm.updatedData.filter(function (item) {
        return updateIds.indexOf(item.id) === -1;
      });
      vm.updatedData = uniqUpdateData;
      value.forEach(function (val) {
        vm.updatedData.push(val);
      });
    });
    this.dataBus.$on('setFocus', function (path) {
      vm.highlightText(path);
    });
    this.dataBus.$on('deleteData', function (pvId) {
      vm.deleteFormData(pvId);
    });
    this.dataBus.$on('enableResize', function (path) {
      vm.enableTransformer(path);
    });
    this.dataBus.$on('saveResize', function (data) {
      vm.updateResize(data);
    });
    this.dataBus.$on('resetResize', function () {
      vm.resetTransformersAndShapes();
    });
    this.dataBus.$on('showTable', function (path) {
      _this.selectedTablePath = path;
      _this.displayHeader(_this.selectedTableData['children'][0]);
      _this.hoverRow(_this.selectedTableData['children'][1], 0);
      _this.$refs.TableDataModal.show();
    });
    return this.fetchForm();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  components: {
    'processed-data-tree': _processedDataTree2.default
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'userRole', 'userRoleOrder', 'selectedRolesData', 'appMode', 'isAdminRole']), {
    combinedErrors: function combinedErrors() {
      return [].concat(_toConsumableArray(this.serviceValidationError));
    },

    processData: function processData() {
      if (this.formData.processed_tree_data) {
        return this.formData.processed_tree_data;
      } else {
        return [];
      }
    },
    docId: function docId() {
      return this.formData.form_doc_id;
    },
    currentFormId: function currentFormId() {
      return this.formData.id;
    },
    formStatus: function formStatus() {
      return this.formData.form_status;
    },
    docStatus: function docStatus() {
      return this.formData.form_doc_status;
    },
    checkauth: function checkauth() {
      var status = 'stage_' + this.userRoleOrder;
      return this.appMode === 'default' ? this.docStatus === 'unmatched' || this.docStatus === status && (this.formData.template_id === '-6' || this.formData.template_id === '-15' || this.formData.template_id === '-16' || this.formData.template_id === '-17' || this.formData.template_id === '-18' || this.formData.template_id === '-2' || this.formStatus === status) : true;
    },
    processDone: function processDone() {
      return parseInt(this.userRoleOrder) >= this.selectedRolesData.length ? this.$t('FORMS.ACCEPT') : this.$t('FORMS.VERIFY');
    },
    avgConfidenceScore: function avgConfidenceScore() {
      var _this2 = this;

      var confidences = [];
      var confidencesForEachForm = [];
      this.processData.forEach(function (eachParent) {
        if (eachParent) {
          confidencesForEachForm = _this2.getConfidenceScores([], eachParent);
        }
        confidences.push.apply(confidences, _toConsumableArray(confidencesForEachForm));
      });
      var totalConfidence = 0;
      for (var i = 0; i < confidences.length; i++) {
        totalConfidence += confidences[i] * 100;
      }
      return confidences.length > 0 ? Math.round(totalConfidence / confidences.length) : 0;
    },
    confidenceVariant: function confidenceVariant() {
      if (this.avgConfidenceScore <= 40) {
        return 'danger';
      } else if (this.avgConfidenceScore <= 70 && this.avgConfidenceScore > 40) {
        return 'warning';
      } else if (this.avgConfidenceScore <= 90 && this.avgConfidenceScore > 70) {
        return 'secondary';
      } else {
        return 'success';
      }
    },
    shouldShowSignInvoice: function shouldShowSignInvoice() {
      return parseInt(this.formData.template_id) === -6 && parseInt(this.formData.template_id === -16) && parseInt(this.formData.template_id === -17) && this.formData.form_doc_status === 'stage_1' && !this.isInvoiceVerified;
    },
    shouldShowApproveInvoice: function shouldShowApproveInvoice() {
      return parseInt(this.formData.template_id) === -6 && parseInt(this.formData.template_id === -16) && parseInt(this.formData.template_id === -17) && this.userRoleOrder > 1 && !this.isInvoiceApproved && this.formData.form_doc_status !== 'accepted';
    },
    isInvoiceVerified: function isInvoiceVerified() {
      var signDetails = this.formData.sign_details;
      return signDetails && !!signDetails.verification_details;
    },
    isInvoiceApproved: function isInvoiceApproved() {
      var signDetails = this.formData.sign_details;
      return signDetails && !!signDetails.approval_details;
    },
    selectedTableData: function selectedTableData() {
      var _this3 = this;

      return this.formData.processed_tree_data[0].children.filter(function (child) {
        return child.path === _this3.selectedTablePath && child.map_type !== 'shape';
      })[0];
    },
    hideExpandCollapse: function hideExpandCollapse() {
      var hasSection = false;
      this.formData.processed_tree_data.forEach(function (pageData) {
        if (pageData && pageData.children) {
          pageData.children.forEach(function (children) {
            if (children.data_type === 'section') {
              hasSection = true;
            }
          });
        }
      });
      return hasSection;
    }
  }),
  watch: {
    processData: {
      handler: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var _this4 = this;

          var treePath;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  treePath = {};

                  this.processData.forEach(function (processDataForEachForm) {
                    if (processDataForEachForm) {
                      treePath = _this4.fetchTreePath(processDataForEachForm, treePath);
                    }
                  });
                  this.treePath = treePath;
                  _context.next = 5;
                  return this.getImageUrls(true).then(function (response) {
                    _this4.createCanvas();
                  });

                case 5:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function handler() {
          return _ref.apply(this, arguments);
        }

        return handler;
      }()
    },
    '$route': function $route() {
      this.id = this.$route.params.id;
      this.fetchForm();
    },
    selectedPageNum: function selectedPageNum() {
      if (this.selectedPageNum !== this.getCurrentPage - 1) {
        this.saveAndGoToPage(this.selectedPageNum);
      }
    },
    processValueText: function processValueText() {
      var _this5 = this;

      var checkMatchSection = false;
      var checkDataPresent = false;
      this.formData.processed_tree_data.forEach(function (sectionData) {
        if (sectionData && sectionData.children) {
          sectionData.children.forEach(function (children) {
            if (children.data_type === 'section') {
              children.children.forEach(function (child) {
                if (child.data_type === 'name') {
                  child.children.forEach(function (innerchild) {
                    if (innerchild.key.toLowerCase().includes(_this5.processValueText.toLowerCase())) {
                      innerchild.show_field = true;
                      checkMatchSection = true;
                    } else {
                      innerchild.show_field = false;
                    }
                  });
                } else {
                  if (child.key.toLowerCase().includes(_this5.processValueText.toLowerCase())) {
                    child.show_field = true;
                    checkMatchSection = true;
                  } else {
                    child.show_field = false;
                  }
                }
              });
              if (checkMatchSection) {
                children.show_section = true;
                checkDataPresent = true;
              } else {
                children.show_section = false;
              }
            } else {
              if (children.data_type === 'name') {
                children.children.forEach(function (innerchild) {
                  if (innerchild.key.toLowerCase().includes(_this5.processValueText.toLowerCase())) {
                    innerchild.show_field = true;
                    checkDataPresent = true;
                  } else {
                    innerchild.show_field = false;
                  }
                });
              } else if (children.key.toLowerCase().includes(_this5.processValueText.toLowerCase())) {
                children.show_field = true;
                checkDataPresent = true;
              } else {
                children.show_field = false;
              }
            }
            checkMatchSection = false;
          });
        }
      });
      this.dataPresent = checkDataPresent;
    }
  },
  filters: {
    moment: function moment(date) {
      return (0, _moment3.default)(date).format('DD MMMM YYYY HH:mm:ss');
    }
  },
  mixins: [_pagination2.default, _validators2.default],
  methods: {
    expandAllSections: function expandAllSections() {
      this.formData.processed_tree_data.forEach(function (data) {
        if (data && data.children) {
          data.children.forEach(function (child) {
            if (child.data_type === 'section') {
              child.show_section = true;
            }
          });
        }
      });
    },
    collapseAllSections: function collapseAllSections() {
      this.formData.processed_tree_data.forEach(function (data) {
        if (data && data.children) {
          data.children.forEach(function (child) {
            if (child.data_type === 'section') {
              child.show_section = false;
            }
          });
        }
      });
    },
    showRejectFormModal: function showRejectFormModal() {
      this.$refs.rejectFormDoc.show();
    },
    hideRejectFormDocModal: function hideRejectFormDocModal() {
      this.$refs.rejectFormDoc.hide();
    },

    handleScroll: function handleScroll() {
      this.$root.$emit('bv::hide::popover');
    },
    rejectForm: function rejectForm() {
      var _this6 = this;

      var payload = {
        formDocId: this.formData.form_doc_id
      };
      _vue2.default.axios.post('form_docs/reject_form_docs', payload, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this6.hideRejectFormDocModal();
        _this6.$router.push('/process/processed');
        _vue2.default.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' });
        _vue2.default.toasted.show('Form will remain in the system for ' + res.data.retention_time + ' hours', { icon: 'chain-broken', type: 'success' });
      }).catch(function (err) {
        console.log(err);
      });
    },
    hoverRow: function hoverRow(row, index) {
      if (index !== this.currentHoverIndex) {
        this.displayRow(row.x_pos, row.y_pos, row.width, row.height);
        this.currentHoverIndex = index;
      }
    },

    logsPagination: function logsPagination(selectedPage) {
      this.showUpdateLogs(selectedPage);
    },
    getChildren: function getChildren(children, key) {
      var result = [];
      children.forEach(function (child) {
        if (child[key] === 'true') {
          result.push(child.key);
        }
      });
      return result;
    },
    generateLogVersions: function generateLogVersions(logsCount, pageNumber) {
      var logsPerPage = this.logsPerPage;
      var startVersion = logsCount - logsPerPage * (pageNumber - 1);
      return Array(logsPerPage).fill().map(function (element, index) {
        return startVersion - index;
      });
    },
    showUpdateLogs: function showUpdateLogs(pageNumber) {
      var _this7 = this;

      this.$refs['formUpdateLogsTable'].show();
      _vue2.default.axios.get('/form_update_logs/fetchUpdatesPagination', { headers: { Authorization: 'Bearer ' + this.idToken }, params: { form_doc_id: this.docId, form_id: this.id, page: pageNumber, size: this.logsPerPage } }).then(function (response) {
        var versions = _this7.generateLogVersions(response.data.count, pageNumber);
        _this7.totalUpdateLogs = response.data.count;
        _this7.logsCurrentPage = pageNumber;
        var logs = response.data.updates;
        var tableData = [];
        _this7.isLogsLoaded = true;
        var updateLogsFiltersMap = {};
        logs.forEach(function (log, logIndex) {
          log.updates_data.forEach(function (update) {
            if (!update.children) {
              tableData.push({
                index: versions[logIndex],
                updated_by: log.updated_by,
                field: update.key,
                original: [update.value_before],
                updated: [update.value_after],
                updated_at: (0, _moment3.default)(log.created_at).format('MM/DD/YYYY, h:mmA')
              });
            } else {
              tableData.push({
                index: logs.length - logIndex,
                updated_by: log.updated_by,
                field: update.key,
                original: _this7.getChildren(update.children, 'value_before'),
                updated: _this7.getChildren(update.children, 'value_after'),
                updated_at: (0, _moment3.default)(log.created_at).format('MM/DD/YYYY, h:mmA')
              });
            }
            updateLogsFiltersMap[update.key] = true;
          });
          if (logIndex !== logs.length - 1) {
            tableData.push({
              index: '',
              updated_by: '',
              field: '',
              original: [],
              updated: [],
              updated_at: ''
            });
          }
        });
        var updateLogsFilterOptions = Object.keys(updateLogsFiltersMap).map(function (key) {
          return {
            value: key,
            text: key
          };
        });
        updateLogsFilterOptions.push({ value: null, text: 'all' });
        _this7.updateLogsFilterOptions = updateLogsFilterOptions;
        _this7.formUpdateLogs = tableData;
      }).catch(function (_error) {
        _this7.closeUpdateLogs();
        _vue2.default.toasted.show('faild fetching form update logs', { icon: 'chain-broken', type: 'error' });
      });
    },
    closeUpdateLogs: function closeUpdateLogs() {
      this.formUpdateLogs = [];
      this.$refs['formUpdateLogsTable'].hide();
    },


    displayRow: function displayRow(Xpos, Ypos, width, height, callback) {
      var canvas = document.getElementById('table-row-canvas');
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext('2d');
      var image = new window.Image();
      image.src = this.imgBase + this.formData.image_url;
      image.onload = function () {
        ctx.drawImage(image, Xpos, Ypos, width, height, 0, 0, width, height);
        if (callback) {
          callback();
        }
      };
    },

    confirmChanges: function confirmChanges() {
      this.$refs.saveFieldsAlertModel.hide();
      this.saveData(true);
      this.goToPage(this.navigatingPage);
    },

    saveAndGoToPage: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(newPage) {
        var _this8 = this;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.selectedPageNum = newPage;
                this.id = this.getcurrentDocId(newPage);
                this.editorDataLoaded = false;
                this.goToPage(newPage);
                this.setPagination('process/forms');
                this.editorDataLoaded = true;
                _context2.next = 8;
                return this.getImageUrls(true).then(function (response) {
                  _this8.createCanvas();
                });

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function saveAndGoToPage(_x) {
        return _ref2.apply(this, arguments);
      }

      return saveAndGoToPage;
    }(),
    cancelNavigation: function cancelNavigation(currentPage) {
      this.updatedData = [];
      this.selectedPageNum = currentPage - 1;
      this.goToPage(this.navigatingPage);
    },


    downloadEligibility: function downloadEligibility() {
      var _this9 = this;

      this.verification_start = true;
      this.$refs.verification_spin.innerText = this.$t('FORMS.CHECKING_ELIG_BTN_LABEL');
      _vue2.default.axios.post('/forms/check_eligibility', { form_doc_id: this.formData.form_doc_id }, { headers: { Authorization: 'Bearer ' + this.idToken }, responseType: 'blob' }).then(function (res) {
        _this9.verification_start = false;
        _this9.$refs.verification_spin.innerText = _this9.$t('FORMS.CHECK_ELIG_BTN_LABEL');
        _this9.showMessage = true;
      }).catch(function (err) {
        return console.log(err);
      });
    },

    displayHeader: function displayHeader(BoundingBox) {
      var canvas = document.getElementById('table-header-canvas');
      canvas.width = BoundingBox.width;
      canvas.height = BoundingBox.height;
      var ctx = canvas.getContext('2d');
      var image = new window.Image();
      image.src = this.imgBase + this.formData.image_url;
      image.onload = function () {
        ctx.drawImage(image, BoundingBox.x_pos, BoundingBox.y_pos, BoundingBox.width, BoundingBox.height, 0, 0, BoundingBox.width, BoundingBox.height);
      };
    },

    highlightInRow: function highlightInRow(cell, row, index) {
      this.displayRow(row.x_pos, row.y_pos, row.width, row.height, function () {
        var diff = cell.x_pos - row.x_pos;
        var canvas = document.getElementById('table-row-canvas');
        var context = canvas.getContext('2d');
        context.beginPath();
        context.globalAlpha = 0.5;
        context.rect(diff, 0, cell.width, cell.height);
        context.fillStyle = '#FFFF00';
        context.fill();
        context.stroke();
      });
    },

    closeTableModal: function closeTableModal() {
      this.selectedTablePath = null;
      this.currentHoverIndex = null;
      this.$refs.TableDataModal.hide();
    },

    getConfidenceScores: function getConfidenceScores(scores, parent) {
      var _this10 = this;

      if (parent.children) {
        parent.children.forEach(function (child) {
          scores = _this10.getConfidenceScores(scores, child);
        });
      } else if (parent.edited && parent.is_system_generated) {
        return scores;
      } else if (parent.edited) {
        scores.push(1);
      } else if (parent.current_value == null || parent.current_value.length < 1) {
        return scores;
      } else if (parent.data_type === 'checkbox') {
        return scores;
      } else if (parent.confidence) {
        scores.push(parent.confidence);
      }
      return scores;
    },

    createCanvas: function createCanvas() {
      var vm = this;
      var imgObj = new window.Image();
      imgObj.crossOrigin = 'Anonymous';
      imgObj.src = this.toShowOriginalImage ? this.imgBase + this.formData.original_image_url : this.imgBase + this.formData.image_url;

      imgObj.onload = function () {
        var stage = new _konva2.default.Stage({
          container: 'canvasShow',
          width: imgObj.width,
          height: imgObj.height
        });

        vm.baseLayer = new _konva2.default.Layer({});
        var baseImg = new _konva2.default.Image({
          image: imgObj,
          width: stage.width(),
          height: stage.height()
        });

        vm.baseLayer.add(baseImg);
        if (vm.processData[vm.selectedPageNum]) {
          vm.buildMapTree(vm.processData[vm.selectedPageNum], vm.processData[vm.selectedPageNum].children);
        }
        stage.add(vm.baseLayer);
        stage.draw();

        var container = document.getElementById('canvasShow');
        var scaleScore = container.offsetWidth / stage.width();
        vm.fillScore = stage.width() / container.offsetWidth;

        stage.width(stage.width() * scaleScore);
        stage.height(stage.height() * scaleScore);
        stage.scale({ x: scaleScore, y: scaleScore });
        stage.draw();

        vm.scaleScore = scaleScore;
        vm.konvaStage = stage;
        vm.updateScrollHeight();
        vm.addCropLayer();
      };
    },

    updateScrollHeight: function updateScrollHeight() {
      var imageHeight = document.getElementById('canvasShow').offsetHeight;
      var footerHeight = document.querySelector('.process-data > .card-footer').offsetHeight;
      this.scrollHeight = imageHeight - footerHeight - 50;
    },

    addCropLayer: function addCropLayer() {
      var vm = this;

      var cropImg = new window.Image();
      cropImg.src = vm.baseLayer.toDataURL();
      cropImg.onload = function () {
        vm.cropLayer = new _konva2.default.Layer({});
        vm.cropWindow = new _konva2.default.Rect({
          fillPatternImage: cropImg,
          fillPatternScale: {
            x: vm.fillScore,
            y: vm.fillScore
          }
        });
        vm.konvaStage.add(vm.cropLayer);
        vm.cropLayer.add(vm.cropWindow);
        vm.cropWindow.hide();
        vm.konvaStage.draw();
      };
    },

    /** For more visibility, we add padding to the bounding box **/
    buildMapTree: function buildMapTree(parent, children) {
      var vm = this;
      var startIndexPadding = 10;
      var dimensionPadding = 15;
      if (children) {
        children.forEach(function (child) {
          if (child.map_type === 'group') {
            var group = new _konva2.default.Rect({
              id: child.path,
              x: child.x_pos - startIndexPadding,
              y: child.y_pos - startIndexPadding,
              width: child.width + dimensionPadding,
              height: child.height + dimensionPadding
            });
            vm.baseLayer.add(group);

            vm.buildMapTree(child, child.children);
          } else {
            var shape = new _konva2.default.Rect({
              id: child.path,
              x: child.x_pos - startIndexPadding,
              y: child.y_pos - startIndexPadding,
              width: Number(child.width) + dimensionPadding,
              height: Number(child.height) + dimensionPadding
            });
            vm.baseLayer.add(shape);
          }
        });
      }
    },

    highlightText: function highlightText(path) {
      var _this11 = this;

      if (!this.toShowOriginalImage) {
        this.resetTransformersAndShapes();
        var nodePaths = this.treePath[path].slice();
        nodePaths.forEach(function (nodePath, index) {
          var shape = _this11.baseLayer.findOne('#' + nodePath);
          if (shape) {
            shape.setAttrs({
              name: 'selected',
              stroke: 1,
              fill: index > 0 ? '#63c2de' : '#FFFF00',
              opacity: 0.5
            });
          }
        });
        this.baseLayer.draw();
      }
    },
    enableTransformer: function enableTransformer(path) {
      this.resetTransformersAndShapes();
      var shape = this.baseLayer.findOne('#' + path);
      shape.setAttrs({
        name: 'selected',
        fill: '#FFFF00',
        opacity: 0.5
      });
      var transformer = new _konva2.default.Transformer({
        rotateEnabled: false,
        keepRatio: false
      });
      this.baseLayer.add(transformer);
      transformer.attachTo(shape);
      this.baseLayer.draw();
    },
    resetTransformersAndShapes: function resetTransformersAndShapes() {
      var resetFill = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'white';

      this.buildMapTree(this.processData, this.processData.children);

      this.baseLayer.find('Transformer').destroy();
      var shapes = this.baseLayer.find('.selected');
      shapes.each(function (shape) {
        var currentFill = shape.attrs.fill;
        if (currentFill === '#FFFF00' || currentFill === '#63c2de' || currentFill === resetFill) {
          shape.setAttrs({
            name: '',
            fill: 'white',
            opacity: 0
          });
        }
      });
      this.baseLayer.draw();
    },
    updateResize: function updateResize(data) {
      var selected = this.konvaStage.findOne('#' + data.path);
      this.cropWindow.setAttrs({
        width: selected.width() * selected.scaleX(),
        height: selected.height() * selected.scaleY(),
        fillPatternOffset: {
          x: selected.x() * this.scaleScore,
          y: selected.y() * this.scaleScore
        }
      });
      this.cropWindow.show();
      data.current_img_enc = this.cropWindow.toDataURL().replace('data:image/png;base64,', '');
      this.cropWindow.hide();
      data.x_pos = selected.x();
      data.y_pos = selected.y();
      data.width = selected.width() * selected.scaleX();
      data.height = selected.height() * selected.scaleY();

      this.cropLayer.draw();
      this.resetTransformersAndShapes();
      this.updateChunks(data);
    },


    slider: function slider() {
      this.minConf = Math.min(this.minConf, this.maxConf);
      this.maxConf = Math.max(this.minConf, this.maxConf);
    },

    fetchTreePath: function fetchTreePath(node) {
      var _this12 = this;

      var treePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      treePath[node['path']] = [node['path']];
      if (node.children) {
        node.children.forEach(function (child) {
          treePath[node['path']].push(child['path']);
          _this12.fetchTreePath(child, treePath);
        });
      }
      return treePath;
    },
    goBackToFormsPage: function goBackToFormsPage() {
      _router2.default.push('/process/processed');
    },

    getImageUrls: function getImageUrls(a) {
      var _this13 = this;

      return new Promise(function (resolve, reject) {
        _vue2.default.axios.get('/forms/get_image_urls', { headers: { Authorization: 'Bearer ' + _this13.idToken }, params: { id: _this13.id } }).then(function (response) {
          if (a === true) {
            _this13.formData.original_image_url = response.data.original_image_url;
            _this13.formData.image_url = response.data.image_url;
            _this13.formData.template_id = response.data.template_id;
            _this13.formData.revision_id = response.data.revision_id;
          }
          resolve(true);
        }).catch(function (error) {
          if (error.status === 401) {
            return _this13.appMode === 'default' ? _router2.default.replace('/sign_in') : '';
          }
        });
      });
    },

    sortChildrenByOrder: function sortChildrenByOrder(children) {
      var valuesWithOrder = children.filter(function (val) {
        return val.order !== null;
      }).sort(function (a, b) {
        return a.order - b.order;
      });
      var valuesWithOutOrder = children.filter(function (val) {
        return val.order === null;
      });
      return valuesWithOrder.concat(valuesWithOutOrder);
    },
    sortProcessedTreeData: function sortProcessedTreeData(data) {
      var _this14 = this;

      data.children = this.sortChildrenByOrder(data.children);
      data.children.forEach(function (child) {
        if (child.children) {
          _this14.sortProcessedTreeData(child);
        }
      });
    },


    fetchForm: function fetchForm() {
      var _this15 = this;

      this.editorDataLoaded = false;
      this.processedDataLoaded = false;
      // this.getImageUrls()
      _vue2.default.axios.get('/forms/' + this.id, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        if (response.data.message) {
          _this15.$refs.multipleUserAlert.show();
        } else {
          var formData = response.data.form;
          var treePath = {};
          var isMatched = formData.is_matched;
          _this15.isLogsLoaded = false;
          var scrollableContent = document.getElementsByClassName('scrollable-content');
          if (scrollableContent.length > 0) {
            scrollableContent[0].scrollTop = 0;
          }
          if (response.data.form.template_id === '-7') {
            _this15.tableHeaders = formData['processed_tree_data']['headers'];
            _this15.originalPEVs = JSON.parse(formData['processed_tree_data']['original_entries']);
            _this15.updatedPEVs = JSON.parse(formData['processed_tree_data']['updated_entries']);
          }
          _this15.formData = formData;
          _this15.showAddDataButton = formData.enable_add_data;
          _this15.formData.short_export_error = _this15.formData.export_error ? _this15.formData.export_error.split(',')[1] : '';
          console.log('Salesforce Export Error: ', _this15.formData.export_error);
          _this15.dataPages = _this15.getDataPages(formData);
          _this15.allPageIdMap = response.data.form.all_processed_form_ids;
          formData.processed_tree_data.forEach(function (element) {
            if (element) {
              treePath = isMatched ? _this15.fetchTreePath(element, treePath) : null;
              _this15.sortProcessedTreeData(element);
            }
          });
          _this15.spareFormData = JSON.parse(JSON.stringify(formData));
          _this15.treePath = treePath;
          _this15.setPagination('process/forms');
          _this15.editorDataLoaded = true;
          _this15.processedDataLoaded = true;
          _this15.next_form_id = parseInt(formData.next_form);
          _this15.prev_form_id = parseInt(formData.prev_form);
          if (formData.template_id === '-6' || formData.template_id === '-16' || formData.template_id === '-17') {
            _this15.fetchInvoiceSignDetails();
          }
          formData.processed_tree_data.children.map(function (data) {
            if (data.data_type === 'npi') {
              _this15.showInsClaim = true;
            }
          });
        }
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this15.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          return _this15.appMode === 'default' ? console.log(_this15.$t('COMMON.MSG_EXPIRED')) : '';
        }
      });
    },

    getDataPages: function getDataPages(formData) {
      if (formData.template_id === '-8' || formData.template_id === '-9' || formData.template_id === '-10') {
        return formData.pages_with_data.map(function (pageNum) {
          return { text: pageNum + 1, value: pageNum };
        });
      } else {
        return Object.values(formData.all_processed_form_ids).map(function (index) {
          return { text: index + 1, value: index };
        });
      }
    },

    fetchInvoiceSignDetails: function fetchInvoiceSignDetails() {
      var _this16 = this;

      _vue2.default.axios.get('/form_docs/invoice_sign_details', { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this16.invoiceSign.accounts = [{ 'text': 'Select Account', value: null }].concat(res.data.accounts);
        _this16.invoiceSign.accountingUnits = [{ 'text': 'Select Accounting Unit', value: null }].concat(res.data.accounting_units);
      }).catch(function (error) {
        console.log(error);
      });
    },


    showSaveData: function showSaveData() {
      if (this.isSignatureValidated && this.formValidations) {
        this.updateFormStatus();
      } else if (this.isSignatureValidated === false) {
        _vue2.default.toasted.show(this.$t('FORMS.VALIDATE_SIGNATURE'), { icon: 'chain-broken', type: 'error' });
      }
      this.saveData(this.resParams);
    },

    saveData: function saveData(isValid) {
      var _this17 = this;

      var pvIDs = [];
      // let count = 0
      var formData = new window.FormData();
      if (this.formData.template_id === '-7') {
        var updatedPEVs = {};
        this.updatedPEVIds.forEach(function (pevId) {
          updatedPEVs[pevId] = _this17.updatedPEVs[pevId];
        });
        formData.append('formData', JSON.stringify(updatedPEVs));
      } else {
        formData.append('formData', JSON.stringify(this.updatedData));
      }
      this.processedDataLoaded = false;
      // this.editorDataLoaded = false
      this.updatedData.map(function (element) {
        pvIDs.push(element.id);
      });
      var data = { records: this.formData.processed_tree_data };
      var filteredProcessedTreeData = data.records.filter(function (itm) {
        return pvIDs.indexOf(itm.pv_id) > -1;
      });

      for (var i = 0; i < filteredProcessedTreeData.length; i++) {
        for (var j = 0; j < this.updatedData.length; j++) {
          if (filteredProcessedTreeData[i].pv_id === this.updatedData[j].id) {
            this.updatedData[j].data_type = filteredProcessedTreeData[i].data_type;
            this.updatedData[j].template_mapping_id = filteredProcessedTreeData[i].tm_id;
          }
        }
        if (filteredProcessedTreeData[i].data_type === 'text') {
          this.autoCorrectFlag1 = true;
        }
      }

      // check if the value is already present in dataset
      if (this.formData.auto_correct && this.formData.auto_correct.length > 0) {
        for (i = 0; i < this.updatedData.length; i++) {
          // 25360 25348
          for (j = 0; j < this.formData.auto_correct.length; j++) {
            // 25360,25348
            if (this.updatedData[i].template_mapping_id === this.formData.auto_correct[j].template_mapping_id) {
              this.updatedData[i].present_in_dict = true;
              break;
            } else {
              this.updatedData[i].present_in_dict = false;
            }
          }
          if (this.updatedData[i].present_in_dict === false && this.updatedData[i].data_type === 'text') {
            this.autoCorrectFlag2 = true;
          }
        }
      } else {
        this.autoCorrectFlag2 = true;
      }
      if (this.autoCorrectFlag2 && this.autoCorrectFlag1 && this.formData.template_auto_correct_flag) {
        this.$refs.fieldInvalidModal.hide();
        this.$refs.autoCorrectModal.show();
      } else {
        this.$refs.fieldInvalidModal.hide();
        this.editOnly = true;
        this.saveAutoCorrectStatus();
      }
      window.scrollTo(0, 0);
    },

    saveAutoCorrectStatus: function saveAutoCorrectStatus() {
      var _this18 = this;

      var payload = {};
      if (!this.editOnly) {
        var checkedIdArray = [];
        this.$refs.CheckboxClicks.map(function (element) {
          if (element.checked === true) {
            checkedIdArray.push(element.id);
          }
        });
        for (var i = 0; i < this.updatedData.length; i++) {
          if (checkedIdArray.includes(String(this.updatedData[i].id))) {
            this.checkedUpdatedData.push({ id: this.updatedData[i].id, key: this.updatedData[i].key, new_record: this.updatedData[i].new_record, form_id: this.updatedData[i].form_id, current_value: this.updatedData[i].current_value, edit_status: true });
          } else {
            if (this.updatedData[i].data_type === 'text') {
              this.checkedUpdatedData.push({ id: this.updatedData[i].id, key: this.updatedData[i].key, new_record: this.updatedData[i].new_record, form_id: this.updatedData[i].form_id, current_value: this.updatedData[i].current_value, edit_status: false });
            }
          }
        }
        payload = {
          updatedData: this.updatedData,
          checkedUpdatedData: this.checkedUpdatedData
        };
      } else {
        this.editOnly = false;
        payload = {
          updatedData: this.updatedData,
          checkedUpdatedData: []
        };
      }
      _vue2.default.axios.patch('/forms/' + this.id, payload, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        _vue2.default.toasted.show(response.data.status, { type: response.data.error ? 'error' : 'success' });
        if (_this18.exportFormFlag) {
          _this18.updateFormDocStatus();
        }
        _this18.updatedData = [];
        _this18.checkedUpdatedData = [];
        _this18.updatedPEVIds = [];
        _this18.processedDataLoaded = true;
        _this18.editorDataLoaded = true;
        _this18.autoCorrectFlag2 = false;
        _this18.autoCorrectFlag1 = false;
        // window.location.reload()
        // this is temporary fix, canavas is not rendering after update
        // if (document.getElementById('canvasShow')) { this.createCanvas() }
      }).catch(function (error) {
        console.log(error);
        if (error.status === 401) {
          _vue2.default.toasted.show(_this18.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this18.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this18.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
        _this18.processedDataLoaded = true;
        _this18.editorDataLoaded = true;
        if (document.getElementById('canvasShow')) {
          _this18.createCanvas();
        }
      });
    },
    dontSaveAutoCorrectStatus: function dontSaveAutoCorrectStatus() {
      this.$refs.autoCorrectModal.hide();
      this.editOnly = true;
      this.saveAutoCorrectStatus();
    },
    validateToExport: function validateToExport() {
      var _this19 = this;

      this.processedDataLoaded = false;
      _vue2.default.axios.post('/form_docs/' + this.formData.form_doc_id + '/validate', {}, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this19.processedDataLoaded = true;
        _this19.isFormDocValid = res.data.valid;
        _this19.pageLevelErrors = res.data.errors.slice(0, 10);
        _this19.$refs.errorsAcknowledgementModal.show();
      }).catch(function (error) {
        console.log(error);
        _vue2.default.toasted.show(_this19.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
      });
    },

    cancelExport: function cancelExport() {
      this.isFormDocValid = true;
      this.pageLevelErrors = [];
      this.processedDataLoaded = true;
      this.$refs.errorsAcknowledgementModal.hide();
    },

    exportDataToService: function exportDataToService() {
      var _this20 = this;

      this.processedDataLoaded = false;
      window.scrollTo(0, 0);
      _vue2.default.axios.post('/service/process_forms/' + this.id + '/export', {}, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this20.processedDataLoaded = true;
        _this20.isFormDocValid = true;
        _this20.pageLevelErrors = [];
        _this20.$refs.errorsAcknowledgementModal.hide();
        if (res.data.status === 'success') {
          _vue2.default.toasted.show(res.data.msg);
        } else {
          _vue2.default.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' });
        }
        _this20.updatedData = [];
        _this20.processedDataLoaded = true;
      }).catch(function (error) {
        console.log(error);
        _vue2.default.toasted.show(_this20.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
      });
    },

    updateChunks: function updateChunks(data) {
      var _this21 = this;

      var updateData = new window.FormData();
      updateData.append('x_pos', data.x_pos);
      updateData.append('y_pos', data.y_pos);
      updateData.append('width', data.width);
      updateData.append('height', data.height);
      updateData.append('current_img', data.current_img_enc);
      this.processedDataLoaded = false;
      _vue2.default.axios.patch('/form_chunks/' + data.chunk_id, updateData, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        _vue2.default.toasted.show(_this21.$t('FORMS.MSG_SUCESS'));
        _this21.processedDataLoaded = true;
      }, function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this21.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this21.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this21.$t('COMMON.MSG_RETRY'));
        }
        _this21.processedDataLoaded = true;
      });
    },
    filterData: function filterData(data, param, value) {
      var vm = this;
      var filteredData = _lodash2.default.map(data.children, function (child) {
        if (child.hasOwnProperty('children')) {
          vm.filterData(child, param, value);
          return child;
        } else if (child[param] !== value) {
          return child;
        }
      });
      _lodash2.default.set(data, 'children', _lodash2.default.compact(filteredData, null));
    },
    deleteFormData: function deleteFormData(pvId) {
      var _this22 = this;

      this.processedDataLoaded = false;
      _vue2.default.axios.delete('processed_values/' + pvId, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        _this22.filterData(_this22.processData, 'pv_id', pvId);
        _vue2.default.toasted.show(_this22.$t('FORMS.MSG_DEL'));
        _this22.processedDataLoaded = true;
      }, function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this22.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this22.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this22.$t('COMMON.MSG_RETRY'));
        }
        _this22.processedDataLoaded = true;
      });
    },


    showSignInvoice: function showSignInvoice() {
      if (this.isInvoiceApproved) {
        var approvalDetails = this.formData.sign_details.approval_details;
        this.invoice.selectedAccount = approvalDetails.account;
        this.invoice.selectedAccountingUnit = approvalDetails.accounting_unit;
        this.invoice.totalAmount = approvalDetails.amount;
      } else if (this.isInvoiceVerified) {
        var verificationDetails = this.formData.sign_details.verification_details;
        this.invoice.selectedAccount = verificationDetails.account;
        this.invoice.selectedAccountingUnit = verificationDetails.accounting_unit;
        this.invoice.totalAmount = verificationDetails.amount;
      }
      this.$refs.signInvoiceModal.show();
    },

    hideSignInvoice: function hideSignInvoice() {
      this.$refs.signInvoiceModal.hide();
      this.$v.invoice.$reset();
      this.invoice = { selectedAccount: null, selectedAccountingUnit: null, totalAmount: null, description: '' };
    },

    signInvoice: function signInvoice(event) {
      var _this23 = this;

      event.preventDefault();
      this.$v.$touch();
      if (!this.$v.invoice.$invalid) {
        this.editorDataLoaded = false;
        this.processedDataLoaded = false;
        var signDetails = new window.FormData();
        var signUrl = this.isInvoiceVerified ? '/form_docs/' + this.docId + '/approve_sign' : '/form_docs/' + this.docId + '/sign_invoice';
        signDetails.append('account', this.invoice.selectedAccount);
        signDetails.append('accounting_unit', this.invoice.selectedAccountingUnit);
        signDetails.append('amount', this.invoice.totalAmount);
        signDetails.append('description', this.invoice.description);
        signDetails.append('date', (0, _moment3.default)().format('DD-MM-YYYY').toString());
        _vue2.default.axios.post(signUrl, signDetails, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
          if (res.data.success) {
            _this23.hideSignInvoice();
            _vue2.default.toasted.show(_this23.isInvoiceVerified ? _this23.$t('INVOICE.APPROVAL_SUCCESSFUL') : _this23.$t('INVOICE.SIGN_SUCCESSFUL'));
            if (parseInt(_this23.id) === res.data.first_form_id) {
              _this23.formData.image_url = res.data.image_url;
              _this23.formData.original_image_url = res.data.image_url;
              _this23.formData.sign_details = res.data.sign_details;
              _this23.processedDataLoaded = true;
              _this23.editorDataLoaded = true;
              _this23.createCanvas();
            } else {
              _this23.goToPage(0);
            }
          } else {
            _vue2.default.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' });
          }
        }).catch(function (error) {
          console.log(error);
          if (error.response.status === 401) {
            _vue2.default.toasted.show(_this23.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
            console.log(_this23.$t('COMMON.MSG_EXPIRED'));
          } else {
            _vue2.default.toasted.show(_this23.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      }
    },
    exportSalesforce: function exportSalesforce() {
      this.$store.commit('setExportFormDocID', this.formData.form_doc_id);
      _router2.default.push({ path: '/process/processed' });
    },
    acceptFormDoc: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var isSignatureValidated;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                isSignatureValidated = this.validateSignature();
                _context3.t0 = isSignatureValidated;

                if (!_context3.t0) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 5;
                return this.formsSignatureValidate();

              case 5:
                _context3.t0 = _context3.sent;

              case 6:
                if (!_context3.t0) {
                  _context3.next = 10;
                  break;
                }

                this.updateFormDocStatus(true);
                _context3.next = 11;
                break;

              case 10:
                if (isSignatureValidated === false) {
                  _vue2.default.toasted.show(this.$t('FORMS.VALIDATE_SIGNATURE'), { icon: 'chain-broken', type: 'error' });
                } else {
                  _vue2.default.toasted.show(this.$t('Form Validations Error'), { icon: 'chain-broken', type: 'error' });
                }

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function acceptFormDoc() {
        return _ref3.apply(this, arguments);
      }

      return acceptFormDoc;
    }(),

    acceptForm: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var isSignatureValidated, formValidations;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.formData.template_id !== '-6' || this.formData.template_id !== '-16' || this.formData.template_id !== '-17')) {
                  _context4.next = 13;
                  break;
                }

                isSignatureValidated = this.validateSignature();

                if (!isSignatureValidated) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 5;
                return this.sfFieldValidations();

              case 5:
                _context4.t0 = _context4.sent;
                _context4.next = 9;
                break;

              case 8:
                _context4.t0 = false;

              case 9:
                formValidations = _context4.t0;

                if (isSignatureValidated && formValidations) {
                  this.updateFormStatus();
                } else {
                  if (isSignatureValidated === false) {
                    _vue2.default.toasted.show(this.$t('FORMS.VALIDATE_SIGNATURE'), { icon: 'chain-broken', type: 'error' });
                  } else {
                    _vue2.default.toasted.show(this.$t('FORMS.ACCEPT_PERMISSION_ERROR'), { icon: 'chain-broken', type: 'error' });
                    _router2.default.push('/process/processed');
                  }
                }
                _context4.next = 14;
                break;

              case 13:
                if (this.updatedData.length > 0) {
                  this.saveData(true);
                } else {
                  this.updateFormStatus();
                }

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function acceptForm() {
        return _ref4.apply(this, arguments);
      }

      return acceptForm;
    }(),

    updateFormStatus: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this24 = this;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _vue2.default.axios.patch('/forms/' + this.currentFormId + '/update_status', {}, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
                  var form = response.data.form;
                  _this24.formData.form_status = form.status;
                  _vue2.default.toasted.show(_this24.$t('FORMS.MSG_ACCEPT'));
                  _this24.get_pages();
                }).catch(function (error) {
                  if (error.response.status === 401) {
                    _vue2.default.toasted.show(_this24.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
                    console.log(_this24.$t('COMMON.MSG_EXPIRED'));
                  } else {
                    _vue2.default.toasted.show(_this24.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
                  }
                });

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function updateFormStatus() {
        return _ref5.apply(this, arguments);
      }

      return updateFormStatus;
    }(),

    get_pages: function get_pages() {
      var _this25 = this;

      return new Promise(function (resolve, reject) {
        var status = 'stage_' + _this25.userRoleOrder;
        _vue2.default.axios.post('/form_docs/' + _this25.docId + '/get_unaccepted_pages', { status: status }, { headers: { Authorization: 'Bearer ' + _this25.idToken } }).then(function (response) {
          var pages = response.data.pages;
          if (pages.length > 0) {
            _this25.goToPage(pages[0].page - 1);
          } else {
            console.log('update form docs Status');
            _this25.updateFormDocStatus();
          }
        });
      });
    },
    formsSignatureValidate: function formsSignatureValidate() {
      var _this26 = this;

      return new Promise(function (resolve, reject) {
        _vue2.default.axios.post('/form_docs/' + _this26.docId + '/validate', {}, { headers: { Authorization: 'Bearer ' + _this26.idToken } }).then(function () {
          var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(response) {
            var errors, isSignatureError, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, error, isSfFieldValid, _isSfFieldValid;

            return regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    errors = response.data.errors;

                    if (!(response.data.valid === false)) {
                      _context6.next = 40;
                      break;
                    }

                    isSignatureError = false;
                    _iteratorNormalCompletion = true;
                    _didIteratorError = false;
                    _iteratorError = undefined;
                    _context6.prev = 6;
                    _iterator = errors[Symbol.iterator]();

                  case 8:
                    if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                      _context6.next = 19;
                      break;
                    }

                    error = _step.value;

                    if (!(error.page !== _this26.getCurrentPage)) {
                      _context6.next = 16;
                      break;
                    }

                    if (!(_this26.pageErrors(error.errors) === true)) {
                      _context6.next = 16;
                      break;
                    }

                    isSignatureError = true;
                    _vue2.default.toasted.show('Please Approve Signature in Another Page', { icon: 'chain-broken', type: 'error' });
                    _this26.goToPage(error.page - 1);
                    return _context6.abrupt('break', 19);

                  case 16:
                    _iteratorNormalCompletion = true;
                    _context6.next = 8;
                    break;

                  case 19:
                    _context6.next = 25;
                    break;

                  case 21:
                    _context6.prev = 21;
                    _context6.t0 = _context6['catch'](6);
                    _didIteratorError = true;
                    _iteratorError = _context6.t0;

                  case 25:
                    _context6.prev = 25;
                    _context6.prev = 26;

                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }

                  case 28:
                    _context6.prev = 28;

                    if (!_didIteratorError) {
                      _context6.next = 31;
                      break;
                    }

                    throw _iteratorError;

                  case 31:
                    return _context6.finish(28);

                  case 32:
                    return _context6.finish(25);

                  case 33:
                    if (!(isSignatureError === false)) {
                      _context6.next = 38;
                      break;
                    }

                    _context6.next = 36;
                    return _this26.sfFieldValidations();

                  case 36:
                    isSfFieldValid = _context6.sent;

                    if (isSfFieldValid) {
                      resolve(true);
                    } else {
                      resolve(false);
                    }

                  case 38:
                    _context6.next = 44;
                    break;

                  case 40:
                    _context6.next = 42;
                    return _this26.sfFieldValidations();

                  case 42:
                    _isSfFieldValid = _context6.sent;

                    if (_isSfFieldValid) {
                      resolve(true);
                    } else {
                      resolve(false);
                    }

                  case 44:
                  case 'end':
                    return _context6.stop();
                }
              }
            }, _callee6, _this26, [[6, 21, 25, 33], [26,, 28, 32]]);
          }));

          return function (_x4) {
            return _ref6.apply(this, arguments);
          };
        }()).catch(function (error) {
          console.log(error);
          if (error.response.status === 401) {
            _vue2.default.toasted.show(_this26.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
            console.log(_this26.$t('COMMON.MSG_EXPIRED'));
          } else {
            _vue2.default.toasted.show(_this26.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      });
    },
    pageErrors: function pageErrors(errors) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = errors[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var error = _step2.value;

          if (error.type === 'Signature' && error.current_value === 'pending') {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    sfFieldValidations: function sfFieldValidations() {
      var _this27 = this;

      this.processedDataLoaded = false;
      return new Promise(function (resolve, reject) {
        _vue2.default.axios.post('/form_docs/validate_sf_fields', { id: Object.keys(_this27.allPageIdMap) }, { headers: { Authorization: 'Bearer ' + _this27.idToken } }).then(function (response) {
          // if (response.data.status === 'failed') {
          //   this.salesForeceValidationError = response.data.message
          //   this.$refs.slaesForceAlertModal.show()
          //   this.processedDataLoaded = true
          //   resolve(false)
          // } else if (response.data.status === 'success') {
          //   this.processedDataLoaded = true
          //   resolve(true)
          // } else
          if (response.data.status === 'Error') {
            resolve(false);
          } else {
            resolve(true);
          }
        }).catch(function (error) {
          if (error.response.status === 401) {
            _vue2.default.toasted.show(_this27.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
            console.log(_this27.$t('COMMON.MSG_EXPIRED'));
          } else {
            _this27.processedDataLoaded = true;
            _vue2.default.toasted.show(_this27.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      });
    },
    updateFormDocStatus: function updateFormDocStatus() {
      var _this28 = this;

      var acceptAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _vue2.default.axios.patch('/form_docs/' + this.docId + '/update_status', { status: this.userRole, accept_all: acceptAll }, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        if (acceptAll) {
          _vue2.default.toasted.show(_this28.$t('FORMS.MSG_ACCEPT'));
        }
        _this28.exportFormFlag = true;
      }).catch(function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this28.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this28.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this28.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },


    hideModal: function hideModal() {
      this.$refs.newFieldModal.hide();
    },

    addNewField: function addNewField() {
      var nodeId = this.processData.children.length + 1;
      var newNode = {
        color_code: this.formData.top_conf_color,
        confidence: 1,
        current_value: this.newFieldValue,
        edited: true,
        id: null,
        key: this.newFieldLabel,
        map_type: 'shape',
        original_value: '',
        path: '1.0',
        pv_id: 'new_' + nodeId,
        new_record: true,
        form_id: this.id
      };

      this.processData.children.push(newNode);
      this.updatedData.push({ id: newNode.pv_id, key: newNode.key, new_record: true, form_id: newNode.form_id, current_value: newNode.current_value });
      this.newFieldLabel = null;
      this.newFieldValue = null;
      this.$refs.newFieldModal.hide();
    },

    showExportError: function showExportError() {
      this.$refs.exportErrorModal.show();
    },

    showCompareModal: function showCompareModal() {
      this.$refs.compareCardsModal.show();
      this.isOpenCompareUploaded = true;
    },
    onHideCompareModal: function onHideCompareModal() {
      this.isOpenCompareUploaded = false;
    },


    editedPEV: function editedPEV(entryId, entryHeader) {
      return this.originalPEVs[entryId][entryHeader] !== this.updatedPEVs[entryId][entryHeader];
    },

    manualData: function manualData() {
      this.fetchTemplateOptions();
      this.$refs.addDataModal.show();
    },

    fetchTemplateOptions: function fetchTemplateOptions() {
      var _this29 = this;

      _vue2.default.axios.get('/template_docs/list_options', { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        _this29.templateOptions = response.data.template_docs;
      }, function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this29.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        }
        console.log(error);
      });
    },
    handleSelectedTemp: function handleSelectedTemp() {
      var _this30 = this;

      var selectedTemp = this.templateOptions.filter(function (temp) {
        return temp.value === _this30.selectedTemplate;
      })[0];
      this.previewImageUrl = this.axios.defaults.baseURL.replace('/api', '') + selectedTemp.image_url;
      this.fetchTemplatePageOptions();
    },
    fetchTemplatePageOptions: function fetchTemplatePageOptions() {
      var _this31 = this;

      _vue2.default.axios.get('/template_docs/' + this.selectedTemplate + '/list_page_options', { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this31.templatePageOptions = res.data.templates;
      }).catch(function (err) {
        return console.log(err);
      });
    },
    handleSelectTemplatePage: function handleSelectTemplatePage() {
      var _this32 = this;

      var selectedPage = this.templatePageOptions.filter(function (page) {
        return page.value === _this32.selectedTemplatePage;
      })[0];
      this.pagePrevImgUrl = this.axios.defaults.baseURL.replace('/api', '') + selectedPage.image_url;
    },
    fetchTemplateMappings: function fetchTemplateMappings() {
      var _this33 = this;

      _vue2.default.axios.post('/processed_values/unmatched_processed_values', { form_ids: Object.keys(this.formData.all_processed_form_ids), template_ids: this.templatePageOptions }, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this33.fetchForm();
        _this33.showAddDataButton = false;
      }).catch(function (err) {
        return console.log(err);
      });
    },

    updateExcelData: function updateExcelData(event, entryId, entryHeader) {
      var updatedValue = {};
      updatedValue[entryHeader] = event.target.value;
      var updatedEntry = Object.assign({}, this.updatedPEVs[entryId]);
      updatedEntry = Object.assign(updatedEntry, updatedValue);
      var updatedPEV = {};
      updatedPEV[entryId] = updatedEntry;
      this.updatedPEVs = Object.assign(this.updatedPEVs, updatedPEV);
      if (this.updatedPEVIds.indexOf(entryId) === -1) {
        this.updatedPEVIds = this.updatedPEVIds.slice().concat([entryId]);
      }
    },

    redirectToMatchedTemplate: function redirectToMatchedTemplate() {
      _router2.default.push('/templates/' + this.formData.template_id + '?version=' + this.formData.revision_id);
    },

    updateTableData: function updateTableData(event, cellValue) {
      cellValue.current_value = event.target.value;
      var updateData = [{
        id: cellValue.pv_id,
        key: cellValue.key,
        new_record: cellValue.new_record,
        form_id: cellValue.form_id,
        current_value: cellValue.current_value
      }];
      this.dataBus.$emit('updateData', updateData);
    },

    hideUnhideScreen: function hideUnhideScreen() {
      this.ishideUnhideClicked = !this.ishideUnhideClicked;
      var canvas = document.getElementById('canvasShow');
      if (this.ishideUnhideClicked) {
        canvas.style.height = window.innerHeight / 2 + 'px';
        canvas.style.overflowY = 'scroll';
        canvas.style.overflowX = 'hidden';
        this.updateScrollHeight();
      } else {
        canvas.style.removeProperty('height');
        canvas.style.removeProperty('overflowY');
        this.updateScrollHeight();
      }
    },
    showOriginalImage: function showOriginalImage(stat) {
      if (stat === 0) {
        this.toShowOriginalImage = true;
      } else {
        this.toShowOriginalImage = false;
      }
      this.createCanvas();
    }
  },

  validations: {
    invoice: {
      selectedAccount: {
        required: _validators3.required
      },
      selectedAccountingUnit: {
        required: _validators3.required
      },
      totalAmount: {
        required: _validators3.required,
        minVal: (0, _validators3.minValue)(0)
      }
    }
  }

};

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vueMultiselect = __webpack_require__(36);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _dateField = __webpack_require__(1102);

var _dateField2 = _interopRequireDefault(_dateField);

var _contentEditable = __webpack_require__(1105);

var _contentEditable2 = _interopRequireDefault(_contentEditable);

var _processMultiSelectData = __webpack_require__(1108);

var _processMultiSelectData2 = _interopRequireDefault(_processMultiSelectData);

var _processSingleSelectData = __webpack_require__(1111);

var _processSingleSelectData2 = _interopRequireDefault(_processSingleSelectData);

var _validators = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { Multiselect: _vueMultiselect2.default, ContentEditable: _contentEditable2.default, processMultiSelectData: _processMultiSelectData2.default, processSingleSelectData: _processSingleSelectData2.default, dateField: _dateField2.default },
  props: ['processedData', 'autoCorrectFlag', 'dataBus', 'isInsCard', 'groupLabel', 'minConf', 'maxConf', 'imgBase', 'currentPage', 'imgUrl', 'dataPresent', 'processValueText', 'docStatus'],
  name: 'processed-data-tree',
  data: function data() {
    return {
      selectedPvId: '',
      selectedFieldKey: {},
      newLabelName: null,
      selectedLabel: { id: null, key: null }
    };
  },

  computed: {
    borderColor: function borderColor() {
      return function (edited, colorCode) {
        return edited ? null : colorCode;
      };
    },
    isNewField: function isNewField() {
      return this.selectedLabel.new_record === undefined;
    }
  },
  validations: {
    newLabelName: {
      required: _validators.required
    }
  },
  methods: {
    showTable: function showTable(path) {
      this.dataBus.$emit('showTable', path);
    },

    inputChanged: function inputChanged(data) {
      var updateData = [{ id: data.content.pv_id, key: data.content.key, new_record: data.content.new_record, form_id: data.content.form_id, current_value: data.newValue }];
      var newValue = data.newValue.trim();
      var originalValue = data.content.original_value ? data.content.original_value.trim() : '';
      if (newValue !== originalValue) {
        data.content.edited = true;
        data.content.is_system_generated = false;
      } else {
        data.content.edited = false;
      }
      this.dataBus.$emit('updateData', updateData);
    },

    checkChanged: function checkChanged(data) {
      var updateData = [{ id: data.pv_id, key: data.key, current_value: data.current_value }];
      if (data.current_value !== data.original_value) {
        data.edited = true;
        data.is_system_generated = false;
      } else {
        data.edited = false;
      }
      this.dataBus.$emit('updateData', updateData);
    },

    showFieldCanvas: function showFieldCanvas(imgBase, imgUrl, path) {
      var selectedNode = this.processedData.filter(function (node) {
        return path === node.path;
      });
      var x = selectedNode.x_pos,
          y = selectedNode.y_pos,
          width = selectedNode.width,
          height = selectedNode.height;

      var canvas = document.getElementById('canvas_' + path);
      if (canvas) {
        if (height / 50 > 4) {
          canvas.parentElement.style.maxHeight = '100px';
          canvas.style.maxHeight = height / 4 + 'px';
        } else {
          canvas.parentElement.style.maxHeight = '75px';
          canvas.style.maxHeight = '50px';
        }
        canvas.height = height;
        canvas.width = width;
        var image = new window.Image();
        image.src = imgBase + imgUrl;
        var ctx = canvas.getContext('2d');
        image.onload = function () {
          ctx.drawImage(image, x, y, width, height, 0, 0, width, height);
        };
      }
    },

    inputFocused: function inputFocused(path) {
      this.dataBus.$emit('setFocus', path);
      this.showFieldCanvas(this.imgBase, this.imgUrl, path);
    },

    selectChanges: function selectChanges(data) {
      this.dataBus.$emit('updateData', data);
    },

    hasContent: function hasContent() {
      return this.processedData && this.processedData.length > 0;
    },

    reviewField: function reviewField(data, status) {
      var updateData = [{ id: data.pv_id, status: status }];
      this.dataBus.$emit('updateData', updateData);
      data.status = status;
    },
    enableResize: function enableResize(data) {
      this.dataBus.$emit('enableResize', data.path);
      data.show_actions = true;
    },
    saveResize: function saveResize(data) {
      this.dataBus.$emit('saveResize', data);
      data.chunk_edited = true;
      data.show_actions = false;
    },
    resetResize: function resetResize(data) {
      this.dataBus.$emit('resetResize');
      data.show_actions = false;
    },
    deleteConfirmModal: function deleteConfirmModal(data) {
      this.selectedPvId = data.pv_id;
      this.selectedFieldKey = data.key;
      this.$refs.fieldDeleteModal.show();
    },
    deleteField: function deleteField() {
      this.dataBus.$emit('deleteData', this.selectedPvId);
      this.selectedPvId = '';
      this.selectedFieldKey = '';
    },
    setLabelValue: function setLabelValue(data) {
      this.selectedLabel = data;
      this.newLabelName = data.key;
    },


    hideChangeModal: function hideChangeModal() {
      this.$refs.changeLabelModal.hide();
    },

    changeName: function changeName() {
      var _this = this;

      if (this.isNewField) {
        var updateData = new window.FormData();
        updateData.append('label_name', this.newLabelName);
        _vue2.default.axios.patch('/processed_values/' + this.selectedLabel.pv_id + '/update_label', updateData, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
          _vue2.default.toasted.show(_this.$t('FORMS.MSG_LABEL'));
        }, function (error) {
          console.error(error);
          _vue2.default.toasted.show(_this.$t('COMMON.MSG_RETRY'));
        });
      }
      this.selectedLabel.key = this.newLabelName;
      this.$refs.changeLabelModal.hide();
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue2Datepicker = __webpack_require__(98);

var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['content', 'imgBase', 'imgUrl'],
  name: 'date-field',
  components: { 'date-picker': _vue2Datepicker2.default },
  data: function data() {
    return {
      date: this.content.current_value
    };
  },

  methods: {
    handleDateInput: function handleDateInput(value) {
      var newValue = new Date(value).getTime();
      var currentValue = new Date(this.content.current_value).getTime();
      if (newValue !== currentValue) {
        this.content.current_value = value;
        this.$emit('update', { content: this.content, newValue: value });
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ['content', 'imgBase', 'imgUrl', 'currentPage', 'docStatus'],
  data: function data() {
    return {
      showOriginalText: this.content.key === 'Plain Text'
    };
  },

  computed: {
    fieldEdited: function fieldEdited() {
      return this.content.edited;
    },
    borderColor: function borderColor() {
      return this.fieldEdited ? '#170c9e' : this.content.color_code;
    },
    hidePopOver: function hidePopOver() {
      if (this.docStatus === 'unmatched' || this.docStatus === 'unmatched_accepted') {
        return false;
      }
      if (this.content.path.split('.')[0] === this.currentPage.toString()) {
        return true;
      }
    },
    backgroundColor: function backgroundColor() {
      return this.content.invalid ? '#F8CECD' : null;
    }
  },
  methods: {
    isNewLine: function isNewLine(letter) {
      return letter === '\n';
    },

    editedContent: function editedContent() {
      var html = '';
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.content.current_value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var letter = _step.value;

          if (this.isNewLine(letter)) {
            html += '<span><br /></span>';
          } else {
            html += '<span>' + letter + '</span>';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return html;
    },
    showFieldCanvas: function showFieldCanvas(imageBase, imageUrl, path) {
      var _content = this.content,
          x = _content.x_pos,
          y = _content.y_pos,
          width = _content.width,
          height = _content.height;

      var canvas = document.getElementById('canvas_' + path);
      height = Math.ceil(height) + 1;
      if (height / 50 > 4) {
        canvas.parentElement.style.maxHeight = '100px';
        canvas.style.maxHeight = height / 4 + 'px';
      } else {
        canvas.parentElement.style.maxHeight = '75px';
        canvas.style.maxHeight = '50px';
      }
      canvas.width = width;
      canvas.height = height;
      var image = new window.Image();
      image.src = imageBase + imageUrl;
      var ctx = canvas.getContext('2d');
      image.onload = function () {
        ctx.drawImage(image, x, y, width, height, 0, 0, width, height);
      };
    },
    setColor: function setColor(character) {
      if (this.fieldEdited) {
        return null;
      }
      return character['score'] <= 0.60 ? '#f86c6b' : '#3e515b';
    },

    contentFocused: function contentFocused(event) {
      if (this.docStatus === 'unmatched' || this.docStatus === 'unmatched_accepted') {
        return;
      }
      if (this.content.path.split('.')[0] === this.currentPage.toString()) {
        this.$emit('focused', this.content.path);
        this.showFieldCanvas(this.imgBase, this.imgUrl, this.content.path);
      }
    },
    contentBlurred: function contentBlurred(event) {
      var newValue = event.target.innerText === '\n' ? '' : event.target.innerText;
      if (newValue !== this.content.current_value) {
        this.content.current_value = newValue;
        this.$emit('update', { content: this.content, newValue: newValue });
      }
    }
  }
};

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(45);

var _lodash2 = _interopRequireDefault(_lodash);

var _vueMultiselect = __webpack_require__(36);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ['content', 'imgBase', 'imgUrl'],
  name: 'process-multi-select-data',
  components: { Multiselect: _vueMultiselect2.default },
  computed: {
    selectedValues: function selectedValues() {
      var items = this.content.children;
      if (items[0].pv_id === null) {
        _lodash2.default.each(items, function (item) {
          _lodash2.default.each(item.children, function (i) {
            if (i.data_type === 'checkbox') {
              item.current_value = i.current_value;
            }
            if (item.data_type === 'checkbox_text' && i.data_type !== 'checkbox') {
              if (i.current_value !== '') {
                item.key = i.current_value.trim();
              }
            }
          });
        });
      }
      var selected = _lodash2.default.filter(items, function (c) {
        return c.current_value === 'true';
      });
      return _lodash2.default.map(selected, function (opt) {
        return { tm_id: opt.tm_id, id: opt.pv_id, text: opt.key };
      });
    },
    optionsForSelect: function optionsForSelect() {
      return _lodash2.default.map(this.content.children, function (c) {
        return { tm_id: c.tm_id, id: c.pv_id, text: c.key };
      });
    },
    orgSelectedOptions: function orgSelectedOptions() {
      return _lodash2.default.filter(this.content.children, function (c) {
        return c.original_value === 'true';
      });
    }
  },
  methods: {
    isEdited: function isEdited() {
      var items = this.content.children;
      if (items[0].pv_id === null) {
        _lodash2.default.each(items, function (item) {
          _lodash2.default.each(item.children, function (i) {
            if (i.data_type === 'checkbox') {
              item.original_value = i.original_value;
            }
          });
        });
      }
      var ocrSelectedOptions = _lodash2.default.filter(items, function (c) {
        return c.original_value === 'true';
      });
      var userSelectedOptions = _lodash2.default.filter(items, function (c) {
        return c.current_value === 'true';
      });
      var ocredIds = _lodash2.default.map(ocrSelectedOptions, 'tm_id').sort();
      var selectedIds = _lodash2.default.map(userSelectedOptions, 'tm_id').sort();
      return !_lodash2.default.isEqual(ocredIds, selectedIds);
    },
    orgSelectedOptionsText: function orgSelectedOptionsText() {
      return _lodash2.default.map(this.orgSelectedOptions, 'key').join(', ');
    },
    optionRemoved: function optionRemoved(option) {
      var removedElement = _lodash2.default.find(this.content.children, function (el) {
        return el.tm_id === option.tm_id;
      });
      if (removedElement.pv_id === null) {
        _lodash2.default.each(removedElement.children, function (el) {
          if (el.data_type === 'checkbox') {
            el.current_value = 'false';
          }
        });
      }
      removedElement.current_value = 'false';
      if (removedElement.pv_id === null) {
        var checkboxItems = _lodash2.default.filter(removedElement.children, function (c) {
          return c.data_type === 'checkbox';
        });
        var items = _lodash2.default.map(checkboxItems, function (c) {
          return { id: c.pv_id, current_value: 'false' };
        });
        this.$emit('dataUpdate', items);
      } else {
        this.$emit('dataUpdate', [{ id: option.id, current_value: 'false' }]);
      }
    },
    optionAdded: function optionAdded(selected) {
      var addedElement = _lodash2.default.find(this.content.children, function (el) {
        return el.tm_id === selected.tm_id;
      });
      if (addedElement.pv_id === null) {
        _lodash2.default.each(addedElement.children, function (el) {
          if (el.data_type === 'checkbox') {
            el.current_value = 'true';
          }
        });
      }
      addedElement.current_value = 'true';
      if (addedElement.pv_id === null) {
        var checkboxItems = _lodash2.default.filter(addedElement.children, function (c) {
          return c.data_type === 'checkbox';
        });
        var items = _lodash2.default.map(checkboxItems, function (c) {
          return { id: c.pv_id, current_value: 'true' };
        });
        this.$emit('dataUpdate', items);
      } else {
        this.$emit('dataUpdate', [{ id: selected.id, current_value: 'true' }]);
      }
    },
    showFieldCanvas: function showFieldCanvas(imageBase, imageUrl, path) {
      var _content = this.content,
          x = _content.x_pos,
          y = _content.y_pos,
          width = _content.width,
          height = _content.height;

      var canvas = document.getElementById('canvas_' + path);
      if (height / 50 > 4) {
        canvas.parentElement.style.maxHeight = '100px';
        canvas.style.maxHeight = height / 4 + 'px';
      } else {
        canvas.parentElement.style.maxHeight = '75px';
        canvas.style.maxHeight = '50px';
      }
      canvas.width = width;
      canvas.height = height;
      var image = new window.Image();
      image.src = imageBase + imageUrl;
      var ctx = canvas.getContext('2d');
      image.onload = function () {
        ctx.drawImage(image, x, y, width, height, 0, 0, width, height);
      };
    },
    inputFocused: function inputFocused() {
      // document.activeElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
      this.$emit('focused', this.content.path);
      this.showFieldCanvas(this.imgBase, this.imgUrl, this.content.path);
    }
  }
};

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(45);

var _lodash2 = _interopRequireDefault(_lodash);

var _vueMultiselect = __webpack_require__(36);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ['content', 'imgBase', 'imgUrl'],
  name: 'process-multi-select-data',
  components: { Multiselect: _vueMultiselect2.default },
  computed: {
    selectedOption: function selectedOption() {
      var items = this.content.children;
      if (items[0].pv_id === null) {
        _lodash2.default.each(items, function (item) {
          _lodash2.default.each(item.children, function (i) {
            if (i.data_type === 'checkbox') {
              item.current_value = i.current_value;
            }
            if (item.data_type === 'checkbox_text' && i.data_type !== 'checkbox') {
              if (i.current_value !== '') {
                item.key = i.current_value.trim();
              }
            }
          });
        });
      }

      var selectedChild = _lodash2.default.find(this.content.children, function (c) {
        return c.current_value === 'true';
      });

      if (selectedChild) {
        return { tm_id: selectedChild.tm_id, id: selectedChild.pv_id, text: selectedChild.key };
      }
    },
    optionsForSelect: function optionsForSelect() {
      return _lodash2.default.map(this.content.children, function (c) {
        return { tm_id: c.tm_id, id: c.pv_id, text: c.key };
      });
    },
    orgSelectedOption: function orgSelectedOption() {
      return _lodash2.default.find(this.content.children, function (c) {
        return c.original_value === 'true';
      });
    }
  },
  methods: {
    isEdited: function isEdited() {
      var items = this.content.children;
      if (items[0].pv_id === null) {
        _lodash2.default.each(items, function (item) {
          _lodash2.default.each(item.children, function (i) {
            if (i.data_type === 'checkbox') {
              item.original_value = i.original_value;
            }
          });
        });
      }

      var ocrSelectedOption = _lodash2.default.find(this.content.children, function (c) {
        return c.original_value === 'true';
      });
      var userSelectedOption = _lodash2.default.find(this.content.children, function (c) {
        return c.current_value === 'true';
      });
      if (ocrSelectedOption && userSelectedOption) {
        return !(ocrSelectedOption.pv_id === userSelectedOption.pv_id);
      } else if (userSelectedOption) {
        return true;
      } else {
        return ocrSelectedOption !== undefined;
      }
    },
    optionRemoved: function optionRemoved(option) {
      var removedElement = _lodash2.default.find(this.content.children, function (el) {
        return el.tm_id === option.tm_id;
      });
      if (removedElement.pv_id === null) {
        _lodash2.default.each(removedElement.children, function (el) {
          if (el.data_type === 'checkbox') {
            el.current_value = 'false';
          }
        });
      }
      removedElement.current_value = 'false';

      if (removedElement.pv_id === null) {
        var checkboxItems = _lodash2.default.filter(removedElement.children, function (c) {
          return c.data_type === 'checkbox';
        });
        var item = _lodash2.default.map(checkboxItems, function (c) {
          return { id: c.pv_id, current_value: 'true' };
        })[0];
        this.$emit('dataUpdate', [{ id: item.id, current_value: 'false' }]);
      } else {
        this.$emit('dataUpdate', [{ id: option.id, current_value: 'false' }]);
      }
    },
    optionAdded: function optionAdded(selected) {
      var addedElement = _lodash2.default.find(this.content.children, function (el) {
        return el.tm_id === selected.tm_id;
      });
      var removedElement = _lodash2.default.find(this.content.children, function (c) {
        return c.current_value === 'true';
      });
      var updateData = [];
      if (addedElement.pv_id === null) {
        _lodash2.default.each(addedElement.children, function (el) {
          if (el.data_type === 'checkbox') {
            el.current_value = 'true';
          }
        });
      }
      addedElement.current_value = 'true';

      if (addedElement.pv_id === null) {
        var checkboxItems = _lodash2.default.filter(addedElement.children, function (c) {
          return c.data_type === 'checkbox';
        });
        var item = _lodash2.default.map(checkboxItems, function (c) {
          return { id: c.pv_id, current_value: 'true' };
        })[0];
        updateData.push({ id: item.id, current_value: 'true' });
      } else {
        updateData.push({ id: selected.id, current_value: 'true' });
      }

      if (removedElement) {
        removedElement.current_value = 'false';
        if (removedElement.pv_id === null) {
          _lodash2.default.each(removedElement.children, function (el) {
            if (el.data_type === 'checkbox') {
              el.current_value = 'false';
            }
          });
          var _checkboxItems = _lodash2.default.filter(removedElement.children, function (c) {
            return c.data_type === 'checkbox';
          });
          var _item = _lodash2.default.map(_checkboxItems, function (c) {
            return { id: c.pv_id, current_value: 'true' };
          })[0];
          updateData.push({ id: _item.id, current_value: 'false' });
        } else {
          updateData.push({ id: removedElement.pv_id, current_value: 'false' });
        }
      }

      this.$emit('dataUpdate', updateData);
    },
    showFieldCanvas: function showFieldCanvas(imageBase, imageUrl, path) {
      var _content = this.content,
          x = _content.x_pos,
          y = _content.y_pos,
          width = _content.width,
          height = _content.height;

      var canvas = document.getElementById('canvas_' + path);
      if (height / 50 > 4) {
        canvas.parentElement.style.maxHeight = '100px';
        canvas.style.maxHeight = height / 4 + 'px';
      } else {
        canvas.parentElement.style.maxHeight = '75px';
        canvas.style.maxHeight = '50px';
      }
      canvas.width = width;
      canvas.height = height;
      var image = new window.Image();
      image.src = imageBase + imageUrl;
      var ctx = canvas.getContext('2d');
      image.onload = function () {
        ctx.drawImage(image, x, y, width, height, 0, 0, width, height);
      };
    },
    inputFocused: function inputFocused() {
      // document.activeElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
      this.$emit('focused', this.content.path);
      this.showFieldCanvas(this.imgBase, this.imgUrl, this.content.path);
    }
  }
};

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vueSmoothDnd = __webpack_require__(1120);

var _helpers = __webpack_require__(1121);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _vueMultiselect = __webpack_require__(36);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _validators = __webpack_require__(32);

var _vueUuid = __webpack_require__(1122);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var columnNames = ['Unmatched Pages', 'Templates'];
var cardColors = ['azure', 'beige', 'bisque', 'blanchedalmond', 'burlywood', 'cornsilk', 'gainsboro', 'ghostwhite', 'ivory', 'khaki'];
var pickColor = function pickColor() {
  var rand = Math.floor(Math.random() * 10);
  return cardColors[rand];
};
var scene = {
  type: 'container',
  props: {
    orientation: 'horizontal'
  },
  children: (0, _helpers.generateItems)(columnNames.length, function (i) {
    return {
      id: 'column' + i,
      type: 'container',
      name: columnNames[i],
      props: {
        orientation: 'vertical',
        className: 'card-container'
      },
      children: (0, _helpers.generateItems)(2, function (j) {
        return {
          type: 'draggable',
          id: '' + i + j,
          props: {
            className: 'card',
            style: { backgroundColor: pickColor() }
          },
          data: 'yes'
        };
      })
    };
  })
};
exports.default = {
  name: 'Cards',
  components: { Container: _vueSmoothDnd.Container, Draggable: _vueSmoothDnd.Draggable, Multiselect: _vueMultiselect2.default, uuid: _vueUuid.uuid },
  data: function data() {
    return {
      loading: false,
      scene: scene,
      showTooltip: false,
      upperDropPlaceholderOptions: {
        className: 'cards-drop-preview',
        animationDuration: '150',
        showOnTop: true
      },
      dropPlaceholderOptions: {
        className: 'drop-preview',
        animationDuration: '150',
        showOnTop: true
      },
      matchedPages: [],
      nonMatchedPages: [],
      dLCards: [],
      icCards: [],
      allPages: [],
      angle: 0,
      rotateAllAngle: 0,
      modelOpen: false,
      rotationSave: false,
      selectedImage: {},
      selectedColumn: '',
      templateOptions: [],
      formType: null,
      selectedTitleDocs: {},
      isFirstEditButtonClicked: false,
      previewImageUrl: '',
      forced_template_doc_id: '',
      processButtonDisabled: false,
      CheckboxClicks: '',
      text: '',
      vaildFormsData: false,
      traigeStatus: {
        NEW: 1,
        INPROGRESS: 2,
        PARTIALLY_COMPLETED: 3,
        COMPLETED: 4,
        REJECTED: 5,
        RECALLED: 6,
        TRIAGED: 12
      },
      // productList: [],
      selectedProduct: [],
      groupDocs: {
        'Templates': [],
        'Insurance': [],
        'Driving': []
      },
      inBoundDocumentCaseId: '',
      showResult: true,
      editAttachmentsEnabled: null,
      editInsCardsEnabled: null,
      isEditedDocKey: null,
      isEditedDoc: false,
      disableSaveButton: true,
      columnCount: 1,
      editedCheckedBoxes: [],
      formDocTitle: '',
      isRotatedDoc: false,
      formDoc: null,
      selectAllUnmatched: false,
      selectAllTemplates: false,
      rotationAngle: 0
    };
  },
  beforeDestroy: function beforeDestroy() {
    var _this = this;

    this.scene.children.map(function (column) {
      if (column.type === 'container') {
        column.children.map(function (element) {
          if (element.data.form && _this.editAttachmentsEnabled && _this.selectedTitleDocs[_this.editAttachmentsEnabled].attachment_formIds.includes(element.data.form.id)) {
            element.data.form.process = true;
            element.data.form.isAttachment = true;
          }
          if (element.data.form && _this.editInsCardsEnabled && _this.selectedTitleDocs[_this.editInsCardsEnabled].insurance_ids.includes(element.data.form.id)) {
            element.data.form.process = true;
            element.data.form.isInsurance = true;
          }
        });
      }
    });
    this.editAttachmentsEnabled = null;
    this.editInsCardsEnabled = null;
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'userRole', 'userRoleOrder', 'selectedRolesData', 'appMode']), {
    setFormTypeOptions: function setFormTypeOptions() {
      var matchOptions = [{ value: null, text: 'Select Document Type' }];
      matchOptions.push.apply(matchOptions, _toConsumableArray(this.templateOptions));
      return matchOptions;
    },
    isSecondEditButtonDisabled: function isSecondEditButtonDisabled() {
      var _this2 = this;

      return function (key) {
        return _this2.selectedTitleDocs !== null && (_this2.editAttachmentsEnabled !== key && _this2.editAttachmentsEnabled !== null || _this2.isFirstEditButtonClicked);
      };
    }
  }),
  mounted: function mounted() {
    this.updateSavebutton();
  },
  created: function created() {
    var _this3 = this;

    this.$refs.CheckboxClicks = [];
    _vue2.default.axios.get('/form_docs/' + this.$route.params.id, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
      _this3.isRotatedDoc = res.data.form_doc.is_rotated;
      _this3.formDoc = res.data.form_doc;
      if (res.data.form_doc.forms_doc_status === 1) {
        _this3.setDocumentStatus(_this3.traigeStatus['INPROGRESS']);
      }
      _this3.inBoundDocumentCaseId = res.data.form_doc.inbound_doc_case_id;
      var pages = res.data.forms.map(function (eachFormData) {
        var newForm = eachFormData.form;
        newForm.image_thumbnail = eachFormData.image_thumbnail;
        newForm.image_url = eachFormData.image_path;
        newForm.original_title = eachFormData.form.title;
        newForm.angle = eachFormData.form.rotation_angle;
        newForm.process = false;
        newForm.isEdited = false;
        newForm.isAttachment = false;
        newForm.isInsurance = false;
        newForm.rotation = eachFormData.form.rotation_angle;
        return newForm;
      });
      var keys = Object.keys(res.data.form_doc.saved_triage_docs);
      _this3.selectedTitleDocs = res.data.form_doc.saved_triage_docs;
      var sceneColumns = {};

      var _loop = function _loop(key) {
        var _sceneColumns$value$s;

        var value = _this3.selectedTitleDocs[key];
        if (sceneColumns[value.sceneColumn] === undefined) {
          sceneColumns[value.sceneColumn] = [];
        }
        var validFormIds = value.formIDs.filter(function (formId) {
          return !value.attachment_formIds.includes(formId) && !value.insurance_ids.includes(formId);
        });
        (_sceneColumns$value$s = sceneColumns[value.sceneColumn]).push.apply(_sceneColumns$value$s, _toConsumableArray(validFormIds));
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          _loop(key);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      _this3.productList = res.data.product_list;
      _this3.formDocTitle = res.data.form_doc.title;
      // this.productList = res.data.product_list
      _this3.allPages = pages;
      console.log('allPages = ', pages);
      _this3.matchedPages = pages.filter(function (form) {
        return sceneColumns.column1 && sceneColumns.column1.includes(form.id) || form.closest_template_id > 0 && form.template_diff !== null && parseInt(form.template_diff) <= 3;
      });
      // this.matchedPages = pages.filter(form => (sceneColumns.column1 && sceneColumns.column1.includes(form.id)) || (form.closest_template_id === null && form.template_diff == null))
      _this3.matchedPages.forEach(function (element) {
        var index = pages.indexOf(element);
        pages.splice(index, 1);
      });
      console.log('matchedPages = ', _this3.matchedPages);
      _this3.dLCards = pages.filter(function (form) {
        return sceneColumns.column3 && sceneColumns.column3.includes(form.id) || form.closest_template_id === -5;
      });
      _this3.dLCards.forEach(function (element) {
        var index = pages.indexOf(element);
        pages.splice(index, 1);
      });
      console.log('dLCards = ', _this3.dLCards);
      _this3.icCards = pages.filter(function (form) {
        return sceneColumns.column2 && sceneColumns.column2.includes(form.id) || form.closest_template_id === -2;
      });
      _this3.icCards.forEach(function (element) {
        var index = pages.indexOf(element);
        pages.splice(index, 1);
      });
      console.log('icCards = ', _this3.icCards);
      _this3.nonMatchedPages = pages.filter(function (form) {
        return form.closest_template_id === null || form.template_diff === '200.0' || form.template_diff && parseInt(form.template_diff) >= 3;
      });
      _this3.nonMatchedPages.map(function (formPage) {
        formPage.closest_template_id = null;
        return formPage;
      });
      console.log('nonMatchedPages = ', _this3.nonMatchedPages);
      var newScean = {
        type: 'container',
        props: {
          orientation: 'horizontal'
        },
        children: (0, _helpers.generateItems)(columnNames.length, function (i) {
          return {
            id: 'column' + i,
            type: 'container',
            name: columnNames[i],
            props: {
              orientation: 'vertical',
              className: 'card-container'
            },
            children: (0, _helpers.generateItems)(res.data.forms.length, function (j) {
              if (i === 1) {
                return {
                  type: 'draggable',
                  id: '' + i + j,
                  props: {
                    className: 'card',
                    style: { backgroundColor: pickColor() }
                  },
                  data: { name: 'template', found: true, form: _this3.matchedPages[j] }
                };
              } else if (i === 2) {
                return {
                  type: 'draggable',
                  id: '' + i + j,
                  props: {
                    className: 'card',
                    style: { backgroundColor: pickColor() }
                  },
                  data: { name: 'ic cards', found: true, form: _this3.icCards[j] }
                };
              } else if (i === 3) {
                return {
                  type: 'draggable',
                  id: '' + i + j,
                  props: {
                    className: 'card',
                    style: { backgroundColor: pickColor() }
                  },
                  data: { name: 'dLCards', found: true, form: _this3.dLCards[j] }
                };
              } else {
                return {
                  type: 'draggable',
                  id: '' + i + j,
                  props: {
                    className: 'card',
                    style: { backgroundColor: pickColor() }
                  },
                  data: { name: 'others', found: true, form: _this3.nonMatchedPages[j] }
                };
              }
            })
          };
        })
      };
      _this3.scene = newScean;
      _this3.setSavedTriageDocs();
      _this3.validAllForms();
      _this3.sortDraggablesForms();
      _vue2.default.axios.get('/template_docs/list_options', { headers: { Authorization: 'Bearer ' + _this3.idToken } }).then(function (response) {
        _this3.templateOptions = response.data.template_docs;
        // let templates = this.matchedPages
        // this.matchedPages = templates.map(page => {
        //   let templateDoc = this.templateOptions.filter(templateDoc => templateDoc.templates.includes(page.closest_template_id))
        //   page.template_doc_id = templateDoc.length > 0 ? templateDoc[0].value : '-1'
        //   return page
        // })
      }, function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this3.$t('COMMON.MSG_EXPIRED'));
        } else if (error.status === 500) {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_PROCESS_FAIL'), { icon: 'chain-broken', type: 'error' });
        }
      });
    }).catch(function (err) {
      return console.log(err);
    });
  },

  validations: {
    text: {
      maxLength: (0, _validators.maxLength)(15),
      valid: function valid(value) {
        var regexExp = /^[a-zA-Z0-9 _-]*$/.test(value);
        return regexExp;
      }
    }
  },
  methods: {
    toggleSelectAll: function toggleSelectAll(columnName, columnIds, selectAllClicks, selectAllColumn) {
      var _this4 = this;

      this.scene.children.map(function (column) {
        if (column.type === 'container' && column.name === columnName) {
          column.children.map(function (element) {
            if (element.data.form) {
              columnIds.push(element.id);
            }
          });
        }
      });
      selectAllClicks.map(function (element) {
        if (element.checked && columnIds.length > 0) {
          selectAllColumn = true;
          _this4.disableSaveButton = false;
        } else if (element.checked === false || columnIds.length === 0) {
          selectAllColumn = false;
          _this4.disableSaveButton = true;
          _this4.formType = null;
        }
      });
      if (selectAllColumn) {
        var checkedIdArray = [];
        this.$refs.CheckboxClicks.map(function (element) {
          if (columnIds.includes(element.id)) {
            element.checked = true;
            checkedIdArray.push(element.id);
          }
        });
        if (columnName === 'Templates') {
          this.documentAutoMatching(checkedIdArray);
        } else {
          this.disableSaveButton = true;
          this.formType = null;
        }
      } else if (selectAllColumn === false) {
        this.$refs.CheckboxClicks.map(function (element) {
          if (columnIds.includes(element.id)) {
            element.checked = false;
          }
        });
        this.disableSaveButton = true;
      }
    },
    selectAllUnmatchedPages: function selectAllUnmatchedPages() {
      var columnIds = [];
      this.toggleSelectAll('Unmatched Pages', columnIds, this.$refs.selectAllUnmatchedClicks, this.selectAllUnmatched);
    },
    selectAllTemplatePages: function selectAllTemplatePages() {
      var columnIds = [];
      this.toggleSelectAll('Templates', columnIds, this.$refs.selectAllTemplateClicks, this.selectAllTemplates);
    },
    documentAutoMatching: function documentAutoMatching(checkedIdArray) {
      var templatesContainer = this.scene.children.find(function (child) {
        return child.type === 'container' && child.name === 'Templates';
      });
      if (!templatesContainer) return null;
      var matchingChild = templatesContainer.children.find(function (child) {
        return checkedIdArray[0] === child.id && child.data.form.closest_template_id;
      });
      if (!matchingChild) return null;
      var closestTemplateId = matchingChild.data.form.closest_template_id;
      var matchingTemplate = this.templateOptions.find(function (templateDoc) {
        return templateDoc.templates.includes(closestTemplateId);
      });
      if (matchingTemplate && checkedIdArray.length === matchingTemplate.templates.length) {
        this.disableSaveButton = false;
        this.formType = matchingTemplate.value;
      } else {
        this.disableSaveButton = false;
        this.formType = null;
      }
    },
    exportRotatedDoc: function exportRotatedDoc() {
      this.$store.commit('setRotatedDocFormDocId', this.formDoc.id);
      _router2.default.push({ path: '/process/processed' });
    },
    setSavedTriageDocs: function setSavedTriageDocs() {
      var _this5 = this;

      var keys = Object.keys(this.selectedTitleDocs);
      this.columnCount = keys.length === 0 ? 1 : Number(keys[keys.length - 1]) + 1;
      this.scene.children.map(function (column) {
        if (column.type === 'container') {
          column.children.map(function (element) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var key = _step2.value;

                if (element.data.form && _this5.selectedTitleDocs[key].formIDs.includes(element.data.form.id)) {
                  if (_this5.selectedTitleDocs[key].attachment_formIds.includes(element.data.form.id)) {
                    element.data.form.isAttachment = true;
                  }
                  if (_this5.selectedTitleDocs[key].insurance_ids.includes(element.data.form.id)) {
                    element.data.form.isInsurance = true;
                  }
                  if (_this5.selectedTitleDocs[key].formType === 'cover_page') {
                    element.data.form.process = true;
                    element.data.coverPage = true;
                    element.data.form.title = _this5.selectedTitleDocs[key].title;
                    _this5.disableCoverPageCheckBox = true;
                    _this5.coverPageSelected = true;
                  } else if (_this5.selectedTitleDocs[key].formType === 'attachments') {
                    element.data.form.process = true;
                    element.data.form.title = _this5.selectedTitleDocs[key].title;
                    element.data.form.patient_id = _this5.selectedTitleDocs[key].patient_id;
                    element.data.form.case_no = _this5.selectedTitleDocs[key].case_no;
                    element.data.form.record_type = _this5.selectedTitleDocs[key].record_type;
                    element.data.form.tags = _this5.selectedTitleDocs[key].tags;
                  } else {
                    element.data.form.process = true;
                    element.data.form.title = _this5.selectedTitleDocs[key].title;
                  }
                  _this5.selectedTitleDocs[key].forms.map(function (form) {
                    if (element.data.form.id === form.id) {
                      element.data.form.product = form.product;
                      element.data.form.tags = form.tags;
                      element.data.form.template_doc_id = form.template_doc_id;
                      element.data.form.closest_template_id = form.closest_template_id;
                    }
                  });
                  element.data.form.uuid = _this5.selectedTitleDocs[key].uuid;
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          });
        }
      });
    },
    updateSavebutton: function updateSavebutton() {
      var checkedIdArray = [];
      this.$refs.CheckboxClicks.map(function (element) {
        if (element.checked === true) {
          checkedIdArray.push(element.id);
        }
      });
      if (this.$v.text.$error === true || checkedIdArray.length === 0) {
        this.disableSaveButton = true;
      } else if (this.isRotatedDoc && checkedIdArray.length > 0) {
        this.disableSaveButton = false;
      } else {
        this.disableSaveButton = false;
      }
    },
    sortDraggablesForms: function sortDraggablesForms() {
      this.scene.children.map(function (column) {
        if (column.type === 'container') {
          column.children.sort(function (a, b) {
            if (a.data.form && a.data.form.process === false && b.data.form && b.data.form.process === false) {
              return column.children.indexOf(a) - column.children.indexOf(b);
            }
            if (a.data.form && a.data.form.process === false) {
              return -1;
            }
            if (a.data.form && a.data.form.process === true) {
              return 1;
            }
            return 0;
          });
        }
      });
    },

    checkUnmatchedPages: function checkUnmatchedPages(checkedIdArray) {
      var containerIndex = this.scene.children.findIndex(function (item) {
        return item.type === 'container' && item.id === 'column0';
      });
      var container = this.scene.children[containerIndex];
      if (container) {
        var hasMatchingChild = container.children.some(function (child) {
          return checkedIdArray.includes(child.id);
        });
        if (hasMatchingChild) {
          return false;
        }
      }
      return true;
    },
    CheckboxSave: function CheckboxSave() {
      var _this6 = this;

      this.isSaveButtonClicked = true;
      this.isFirstEditButtonClicked = false;
      var checkedIdArray = [];
      this.$refs.CheckboxClicks.map(function (element) {
        if (element.checked === true) {
          checkedIdArray.push(element.id);
        }
      });
      if (checkedIdArray.length > 0) {
        if (!this.checkUnmatchedPages(checkedIdArray) && !this.isRotatedDoc) {
          this.$refs.unmatchedPagesAlert.show();
          return;
        } else if (this.formType) {
          var documentType = this.templateOptions.find(function (templateDoc) {
            return templateDoc.value === _this6.formType;
          });
          if (documentType && documentType.templates.length !== checkedIdArray.length) {
            this.isFirstEditButtonClicked = true;
            return _vue2.default.toasted.show('The selected document type has more or fewer pages than the selected forms.', { type: 'error', duration: 5000 });
          }
        } else if (!this.isRotatedDoc && this.formType === null) {
          return _vue2.default.toasted.show('Document type is required', { type: 'error' });
        }
        var title = this.text.trim().replace(/ /g, '_');
        var isValidTemplates = true;
        var docDetails = {};
        var uniqueId = _vueUuid.uuid.v1();
        docDetails['title'] = title;
        docDetails['forms'] = [];
        docDetails['pages'] = [];
        docDetails['formIDs'] = [];
        docDetails['template_doc'] = [];
        docDetails['attachment_pages'] = [];
        docDetails['attachment_formIds'] = [];
        docDetails['force_template_id'] = [];
        docDetails['sceneColumn'] = [];
        docDetails['tags'] = [];
        docDetails['insurance_ids'] = [];
        docDetails['insurance_pages'] = [];
        console.log('docDetails = ', docDetails);
        this.scene.children.map(function (column) {
          if (column.type === 'container') {
            _this6.extractFormTypeData(column.name, column.children);
            column.children.map(function (element) {
              if (checkedIdArray.indexOf(element.id) >= 0) {
                if (_this6.formType) {
                  docDetails['forms'].push(element.data.form);
                  docDetails['formIDs'].push(element.data.form.id);
                  // docDetails['product'] = this.formType !== 'attachments' ? (this.isVerified ? this.selectedProduct : 'Pharmacy') : this.selectedProduct
                  docDetails['formType'] = _this6.formType;
                  docDetails['column'] = { text: column.name, value: column.name === 'Insurance cards' ? '-2' : '0' };
                  docDetails['pages'].push(element.data.form.original_page_no);
                  docDetails['force_template_id'] = _this6.formType;
                  docDetails['sceneColumn'] = column.id;
                  docDetails['template_doc'] = _this6.templateOptions.filter(function (template) {
                    return template.value === _this6.formType;
                  });
                  if (!_this6.isEditedDoc) {
                    docDetails['uuid'] = uniqueId;
                  }
                  if (column.name === 'Templates' && docDetails['template_doc'].length < 1 && _this6.formType !== 'attachments') {
                    isValidTemplates = false;
                  } else {
                    element.data.form.title = title;
                    element.data.form.process = true;
                    element.data.form.isEdited = false;
                    // element.data.form.product = this.formType !== 'attachments' ? (this.isVerified ? this.selectedProduct : 'Pharmacy') : this.selectedProduct
                    element.data.form.template_doc_id = _this6.formType;
                    element.data.form.uuid = uniqueId;
                  }
                }
              }
            });
          }
        });
        if (isValidTemplates) {
          if (this.isEditedDoc) {
            var _docDetails$formIDs;

            var attachementsFormIds = this.selectedTitleDocs[this.isEditedDocKey]['attachment_formIds'];
            (_docDetails$formIDs = docDetails['formIDs']).push.apply(_docDetails$formIDs, _toConsumableArray(attachementsFormIds));
            docDetails['attachment_formIds'] = this.selectedTitleDocs[this.isEditedDocKey]['attachment_formIds'];
            docDetails['attachment_pages'] = this.selectedTitleDocs[this.isEditedDocKey]['attachment_pages'];
            this.selectedTitleDocs[this.isEditedDocKey] = {};
            this.selectedTitleDocs[this.isEditedDocKey] = docDetails;
            this.selectedTitleDocs[this.isEditedDocKey]['template_doc'] = docDetails['column'] && docDetails['column'].text !== 'Insurance cards' ? this.formType === 'cover_page' ? { text: 'Cover Page', value: true } : this.formType === 'attachments' ? { text: 'Attachments', value: true } : docDetails['template_doc'][0] : docDetails['column'];
          } else {
            this.selectedTitleDocs[this.columnCount] = {};
            this.selectedTitleDocs[this.columnCount] = docDetails;
            this.selectedTitleDocs[this.columnCount]['template_doc'] = docDetails['column'] && docDetails['column'].text !== 'Insurance cards' ? this.formType === 'cover_page' ? { text: 'Cover Page', value: true } : this.formType === 'attachments' ? { text: 'Attachments', value: true } : docDetails['template_doc'][0] : docDetails['column'];
            this.columnCount = this.columnCount + 1;
          }
        } else {
          this.scene.children.map(function (column) {
            if (column.type === 'container') {
              _this6.extractFormTypeData(column.name, column.children);
              column.children.map(function (element) {
                if (checkedIdArray.indexOf(element.id) >= 0 && element.data.form) {
                  element.data.form.process = false;
                  element.data.form.isEdited = false;
                }
              });
            }
          });
        }
        if (this.isEditedDoc && isValidTemplates) {
          var remainingFormIDs = this.selectedTitleDocs[this.isEditedDocKey]['formIDs'].filter(function (formID) {
            return !_this6.selectedTitleDocs[_this6.isEditedDocKey]['formIDs'].includes(formID);
          });
          this.scene.children.map(function (column) {
            if (column.type === 'container') {
              _this6.extractFormTypeData(column.name, column.children);
              column.children.map(function (element) {
                if (element.data.form && docDetails['attachment_formIds'].includes(element.data.form.id)) {
                  element.data.form.title = title;
                }
                if (element.data.form && remainingFormIDs.includes(element.data.form.id)) {
                  element.data.form.process = false;
                  element.data.form.isEdited = false;
                }
              });
            }
          });
          // if (this.selectedEditTitle !== this.isEditedDocKey) {
          //   delete this.selectedTitleDocs[this.selectedEditTitle]
          // }
        }
        this.scene.children.map(function (column) {
          if (column.type === 'container') {
            _this6.extractFormTypeData(column.name, column.children);
            column.children.map(function (element) {
              if (checkedIdArray.indexOf(element.id) >= 0) {
                if (_this6.text !== '') {
                  element.data.form.title = _this6.text;
                  element.data.form.process = true;
                  element.data.form.product = _this6.selectedProduct;
                }
              }
            });
          }
        });
        this.validAllForms();
        this.CheckboxClear();
        this.saveSelectedDocs();
      }
    },
    CheckboxClear: function CheckboxClear() {
      this.$refs.CheckboxClicks.map(function (element) {
        element.checked = false;
      });
      if (!(this.editAttachmentsEnabled || this.editInsCardsEnabled)) {
        this.editedCheckedBoxes = [];
      }
      this.text = '';
      this.selectedProduct = [];
      this.formType = null;
      if (this.isEdited) {
        this.selectedTitleDocs[this.isEditedDocKey]['isEdited'] = false;
      }
      this.isSaveButtonClicked = true;
      this.isFirstEditButtonClicked = false;
      this.isEditedDoc = false;
      this.disableSaveButton = true;
      this.selectAllUnmatched = false;
      this.selectAllTemplates = false;
      this.sortDraggablesForms();
    },
    handleTemplateSelect: function handleTemplateSelect() {
      var _this7 = this;

      var templateDoc = this.templateOptions.filter(function (templateDoc) {
        return templateDoc.value === _this7.forced_template_doc_id;
      });
      this.previewImageUrl = this.axios.defaults.baseURL.replace('/api', '') + templateDoc[0].image_url;
    },
    loadingImage: function loadingImage(e, data) {
      // this.angle = data.angle
      // var img = e.target
      // img.style.transform = 'rotate(' + this.angle + 'deg)'
    },
    rotateSelectedImgs: function rotateSelectedImgs(angle) {
      var _this8 = this;

      var checkedIdArray = [];
      var checkedFormIds = [];
      var origPageNos = [];
      this.$refs.CheckboxClicks.map(function (element) {
        if (element.checked === true) {
          checkedIdArray.push(element.id);
        }
      });
      this.scene.children.map(function (column) {
        if (column.type === 'container') {
          column.children.map(function (ele) {
            if (ele.data.form && checkedIdArray.includes(ele.id)) {
              checkedFormIds.push(ele.data.form.id);
              origPageNos.push(ele.data.form.original_page_no);
            }
          });
        }
      });
      if (checkedIdArray.length > 0) {
        this.loading = true;
        this.rotateAllAngle = angle;
        _vue2.default.axios.post('form_docs/rotate_all_images', { ids: checkedFormIds, rotation_angle: this.rotateAllAngle, original_page_nos: origPageNos, form_doc_id: '' + this.$route.params.id }, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
          if (res.data.error) {
            _vue2.default.toasted.show(_this8.$t('FORMS.IMAGE_ROTATE_FAIL'), { icon: 'chain-broken', type: 'error' });
          } else {
            _vue2.default.toasted.show(_this8.$t('FORMS.IMAGE_ROTATE_SUCCESS'), { type: 'success' });
          }
          var imageData = res.data.image_data;
          _this8.scene.children.map(function (column) {
            if (column.type === 'container') {
              column.children.map(function (element) {
                if (element.data.form) {
                  imageData.map(function (data) {
                    if (data.form_id === element.data.form.id) {
                      element.data.form.rotation = data.rotation_angle;
                      element.data.form.angle = data.rotation_angle;
                      element.data.form.rotation_angle = data.rotation_angle;
                    }
                  });
                }
              });
            }
          });
          _this8.rotateAllAngle = 0;
          _this8.CheckboxClear();
        }).catch(function (err) {
          _vue2.default.toasted.show(_this8.$t('FORMS.IMAGE_ROTATE_FAIL'), { icon: 'chain-broken', type: 'error' });
          console.log(err);
        }).finally(function () {
          _this8.loading = false;
        });
      } else {
        this.$refs.rotatePagesAlert.show();
      }
    },

    imageRotateLeft: function imageRotateLeft() {
      var img = document.getElementById(this.selectedImage.id);
      this.angle = this.angle - 90;
      this.rotationSave = true;
      img.style.transform = 'rotate(' + this.angle + 'deg)';
    },
    imageRotateRight: function imageRotateRight() {
      var img = document.getElementById(this.selectedImage.id);
      this.angle = this.angle + 90;
      this.rotationSave = true;
      img.style.transform = 'rotate(' + this.angle + 'deg)';
    },
    closeRotationTemplateImage: function closeRotationTemplateImage() {
      this.angle = 0;
      this.modelOpen = false;
      this.rotationSave = false;
      this.$refs['viewFullImage'].hide();
    },
    saveRotationTemplateImage: function saveRotationTemplateImage() {
      var _this9 = this;

      if (this.rotationSave) {
        var previousAngle = this.angle - this.selectedImage.rotation_angle;
        _vue2.default.axios.post('form_docs/rotate_image', { id: this.selectedImage.id, rotation_angle: previousAngle, original_page_no: [this.selectedImage.original_page_no] }, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
          _vue2.default.toasted.show(_this9.$t('FORMS.IMAGE_ROTATE_SUCCESS'), { type: response.data.error ? 'error' : 'success' });
          _this9.scene.children.map(function (column) {
            if (column.type === 'container') {
              column.children.map(function (element) {
                if (element.data.form && element.data.form.id === _this9.selectedImage.id) {
                  console.log('element = ', element, _this9.selectedImage.id);
                  element.data.form.angle = response.data.rotation_angle;
                  element.data.form.rotation = response.data.rotation_angle;
                  element.data.form.rotation_angle = response.data.rotation_angle;
                }
              });
            }
          });
          _this9.angle = 0;
          _this9.modelOpen = false;
          _this9.rotationSave = false;
        }).catch(function (err) {
          _vue2.default.toasted.show(_this9.$t('FORMS.IMAGE_ROTATE_FAIL'), { icon: 'chain-broken', type: 'error' });
          console.log(err);
        });
      }
      this.$refs['viewFullImage'].hide();
    },
    onColumnDrop: function onColumnDrop(dropResult) {
      var scene = Object.assign({}, this.scene);
      scene.children = (0, _helpers.applyDrag)(scene.children, dropResult);
      this.scene = scene;
    },
    onCardDrop: function onCardDrop(columnId, dropResult) {
      if (dropResult.removedIndex !== null || dropResult.addedIndex !== null) {
        var _scene = Object.assign({}, this.scene);
        var column = _scene.children.filter(function (p) {
          return p.id === columnId;
        })[0];
        var columnIndex = _scene.children.indexOf(column);
        var newColumn = Object.assign({}, column);
        newColumn.children = (0, _helpers.applyDrag)(newColumn.children, dropResult);
        _scene.children.splice(columnIndex, 1, newColumn);
        this.scene = _scene;
        this.disableSelectAllOnCardDrop(this.scene);
      }
      if (dropResult.addedIndex !== null && this.isEditedDoc === false) {
        this.sortDraggablesForms();
      }
    },
    disableSelectAllOnCardDrop: function disableSelectAllOnCardDrop(scene) {
      var templateContainer = scene.children.filter(function (column) {
        return column.name === 'Templates';
      });
      var unmatchedContainer = scene.children.filter(function (column) {
        return column.name === 'Unmatched Pages';
      });
      var isTemplateFormsPresent = templateContainer[0].children.filter(function (item) {
        return item.data.form;
      });
      var isUnmatchedFormsPresent = unmatchedContainer[0].children.filter(function (item) {
        return item.data.form;
      });
      if (isTemplateFormsPresent.length === 0) {
        this.selectAllTemplates = false;
      }
      if (isUnmatchedFormsPresent.length === 0) {
        this.selectAllUnmatched = false;
      }
    },
    getCardPayload: function getCardPayload(columnId) {
      var _this10 = this;

      return function (index) {
        return _this10.scene.children.filter(function (p) {
          return p.id === columnId;
        })[0].children[index];
      };
    },
    dragStart: function dragStart() {},
    log: function log() {
      var _console;

      (_console = console).log.apply(_console, arguments);
    },
    viewFullImage: function viewFullImage(data, column) {
      this.selectedImage = data;
      this.selectedColumn = column;
      this.forced_template_doc_id = data.template_doc_id;
      var templateDoc = this.templateOptions.filter(function (templateDoc) {
        return templateDoc.templates.includes(data.closest_template_id);
      });
      this.previewImageUrl = templateDoc.length > 0 ? this.axios.defaults.baseURL.replace('/api', '') + templateDoc[0].image_url : '';
      data.templateDoc = templateDoc.length > 0 ? templateDoc[0] : {};
      this.modelOpen = true;
      this.angle = data.angle;
      this.$refs['viewFullImage'].show();
    },
    showModal: function showModal() {
      this.$refs['viewFullImage'].show();
    },
    hideModal: function hideModal() {
      this.$refs['viewFullImage'].hide();
    },
    extractFormTypeData: function extractFormTypeData(column, data) {
      data = data.filter(function (image) {
        return image.data.found && image.data.form && image.data.form.template_doc_id !== 'attachments' && !image.data.coverPage && !image.data.form.isAttachment;
      });
      data = data.map(function (data) {
        return data.data;
      });
      return data;
    },
    doProcess: function doProcess() {
      var _this11 = this;

      var res = {};
      var attachedPages = {};
      var insurancePages = {};
      this.processButtonDisabled = true;
      this.scene.children.map(function (column) {
        if (column.type === 'container') {
          column.children.map(function (element) {
            if (element.data.form && element.data.form.isAttachment === true) {
              if (attachedPages[element.data.form.uuid] === undefined) {
                attachedPages[element.data.form.uuid] = [];
              }
              attachedPages[element.data.form.uuid].push(element.data.form.id);
            }
            if (element.data.form && element.data.form.isInsurance === true) {
              if (insurancePages[element.data.form.uuid] === undefined) {
                insurancePages[element.data.form.uuid] = [];
              }
              insurancePages[element.data.form.uuid].push(element.data.form.id);
            }
          });
          res[column.name.replace(/ /g, '_')] = _this11.extractFormTypeData(column.name, column.children);
        }
      });
      res['Attachments'] = attachedPages;
      res['insurance_cards'] = insurancePages;
      res.Templates.forEach(function (template) {
        template.form.title = _this11.formDocTitle;
      });
      _vue2.default.axios.post('form_docs/process_docs', { res: res, triage_doc_id: this.$route.params.id, inbound_doc_case_id: this.inBoundDocumentCaseId }, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this11.processButtonDisabled = false;
        if (res.data.status) {
          _this11.$router.push('/process/processed?status=processing');
        } else {
          _vue2.default.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (err) {
        _this11.processButtonDisabled = false;
        console.log(err);
      });
    },
    saveSelectedDocs: function saveSelectedDocs() {
      var _this12 = this;

      // 2 - INPROGRESS, 3 - Partially Completed
      var statusID = null;
      if (this.vaildFormsData) {
        statusID = this.traigeStatus['TRIAGED'];
      } else if (Object.keys(this.selectedTitleDocs).length > 0) {
        statusID = this.traigeStatus['PARTIALLY_COMPLETED'];
      } else {
        statusID = this.traigeStatus['INPROGRESS'];
      }
      _vue2.default.axios.post('form_docs/save_triage_docs', { selected_docs: this.selectedTitleDocs, triage_doc_id: this.$route.params.id, status_id: statusID }, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this12.validAllForms();
      }).catch(function (err) {
        console.log(err);
      });
    },
    rejectForm: function rejectForm() {
      var _this13 = this;

      var res = {
        formDocId: '' + this.$route.params.id
      };
      _vue2.default.axios.post('form_docs/reject_form_docs', res, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this13.hideRejectFormDocModal();
        _this13.$router.push('/process/processed');
        _vue2.default.toasted.show('Form will remain in the system for ' + res.data.retention_time + ' hours', { icon: 'chain-broken', type: 'success' });
      }).catch(function (err) {
        console.log(err);
        _vue2.default.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' });
      });
    },
    setDocumentStatus: function setDocumentStatus(status) {
      _vue2.default.axios.post('form_docs/set_traige_document_status', { triage_doc_id: this.$route.params.id, status: status }, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {}).catch(function (err) {
        console.log(err);
      });
    },
    showRejectFormModal: function showRejectFormModal() {
      this.$refs.rejectFormDoc.show();
    },
    hideRejectFormDocModal: function hideRejectFormDocModal() {
      this.$refs.rejectFormDoc.hide();
    },
    disableCheckboxOnEditedDoc: function disableCheckboxOnEditedDoc() {
      this.isEditedDoc && this.updateDisableCheckBox();
    },
    updateDisableCheckBox: function updateDisableCheckBox() {
      var _this14 = this;

      if (this.selectedProduct === null && !['attachments', 'cover_page'].includes(this.formType)) {
        this.disableSaveButton = true;
      } else {
        var _checkedIdArray = [];
        this.$refs.CheckboxClicks.map(function (element) {
          if (element.checked === true) {
            _checkedIdArray.push(element.id);
          }
        });
        if (_checkedIdArray.length > 0) {
          this.disableSaveButton = false;
        } else if (this.$v.text.$error === true || _checkedIdArray.length === 0 || this.formType === null || this.formType === 'attachments' && this.patientId === null && !this.hcoCaseNo && !this.physcianCaseNo) {
          this.disableSaveButton = true;
        } else {
          this.disableSaveButton = true;
        }
      }
      var unmatchedColumnIds = [];
      var templateColumnIds = [];
      this.scene.children.map(function (column) {
        if (column.type === 'container' && column.name === 'Unmatched Pages') {
          column.children.map(function (element) {
            if (element.data.form) {
              unmatchedColumnIds.push(element.id);
            }
          });
        } else if (column.type === 'container' && column.name === 'Templates') {
          column.children.map(function (element) {
            if (element.data.form) {
              templateColumnIds.push(element.id);
            }
          });
        }
      });
      var checkedIdArray = [];
      this.$refs.CheckboxClicks.map(function (element) {
        if (element.checked === true) {
          checkedIdArray.push(element.id);
        }
      });
      if (checkedIdArray.length === 0) {
        this.selectAllUnmatched = false;
        this.selectAllTemplates = false;
      } else {
        var selectedUnmatchedIds = unmatchedColumnIds.filter(function (element) {
          return checkedIdArray.includes(element);
        });
        var selectedTemplateIds = templateColumnIds.filter(function (element) {
          return checkedIdArray.includes(element);
        });
        if (unmatchedColumnIds.length === selectedUnmatchedIds.length) {
          this.selectAllUnmatched = true;
        } else {
          this.selectAllUnmatched = false;
        }
        if (templateColumnIds.length === selectedTemplateIds.length) {
          this.selectAllTemplates = true;
        } else {
          this.selectAllTemplates = false;
        }
      }
      if (templateColumnIds.length === 0) {
        this.selectAllTemplates = false;
      }
      if (unmatchedColumnIds.length === 0) {
        this.selectAllUnmatched = false;
      }
      var inRemPages = 0;
      var i = 0;
      for (i = 0; i < this.scene.children.length; i++) {
        if (this.scene.children[i].type === 'container' && this.scene.children[i].name === 'Unmatched Pages') {
          var j = 0;
          for (j = 0; j < this.scene.children[i].children.length; j++) {
            if (checkedIdArray.indexOf(this.scene.children[i].children[j].id) >= 0) {
              inRemPages += 1;
              this.formType = this.isRotatedDoc ? 'rotatedDoc' : null;
            }
          }
          break;
        }
      }
      if (inRemPages !== checkedIdArray.length) {
        this.disableCoverPageCheckBox = true;
        // this.disableAttchments = checkedIdArray.length !== 1
      } else {
        this.disableCoverPageCheckBox = this.coverPageSelected === true;
        this.disableAttchments = false;
      }

      if (checkedIdArray.length === 0 && this.editedCheckedBoxes.length === 0) {
        this.formType = null;
      } else if (!checkedIdArray) {
        this.disableCoverPageCheckBox = true;
        for (var _i = 1; _i < this.scene.children.length; _i++) {
          if (this.scene.children[_i].type === 'container' && this.scene.children[_i].name === 'Templates') {
            for (var _j = 0; _j < this.scene.children[_i].children.length; _j++) {
              if (checkedIdArray.indexOf(this.scene.children[_i].children[_j].id) >= 0) {
                (function () {
                  var form = _this14.scene.children[_i].children[_j].data.form;
                  var templateId = _this14.templateOptions.filter(function (templateDoc) {
                    return templateDoc.templates.includes(form.closest_template_id);
                  });
                  if (templateId[0] && _this14.formType !== templateId[0].value || templateId[0] === undefined) {
                    _this14.formType = null;
                  }
                })();
              }
            }
          }
        }
      } else if (checkedIdArray.length >= 1) {
        this.documentAutoMatching(checkedIdArray);
      } else if (this.coverPageSelected === false) {
        this.disableCoverPageCheckBox = false;
      }
    },
    addInsPages: function addInsPages(data, key) {
      var _this15 = this;

      if (this.editInsCardsEnabled !== null) {
        this.selectedTitleDocs[key]['formIDs'] = this.selectedTitleDocs[key]['formIDs'].filter(function (id) {
          return !_this15.selectedTitleDocs[key]['insurance_ids'].includes(id);
        });
        this.selectedTitleDocs[key]['insurance_ids'] = [];
        this.selectedTitleDocs[key]['insurance_pages'] = [];
      }
      var scrollableContent = document.getElementsByClassName('scrollable-content');
      if (scrollableContent.length > 0) {
        scrollableContent[0].scrollTop = 0;
      }
      var checkedIdArray = [];
      this.$refs.CheckboxClicks.map(function (element) {
        if (element.checked === true) {
          checkedIdArray.push(element.id);
        }
      });
      if (checkedIdArray.length > 0) {
        if (checkedIdArray.length > 1 || this.selectedTitleDocs[key]['insurance_pages'].length === 1) {
          this.$refs.multipleInsAlert.show();
          return;
        } else {
          this.scene.children.map(function (column) {
            if (column.type === 'container') {
              column.children.map(function (element) {
                if (checkedIdArray.indexOf(element.id) >= 0) {
                  element.data.form.title = data.title;
                  element.data.form.uuid = data.uuid;
                  element.data.form.isInsurance = true;
                  element.data.form.process = true;
                  element.data.form.isEdited = false;
                  _this15.selectedTitleDocs[key]['formIDs'].push(element.data.form.id);
                  _this15.selectedTitleDocs[key]['insurance_ids'].push(element.data.form.id);
                  _this15.selectedTitleDocs[key]['insurance_pages'].push(element.data.form.original_page_no);
                }
              });
            }
          });
        }
      }
      this.editInsCardsEnabled = null;
      this.validAllForms();
      this.CheckboxClear();
      this.saveSelectedDocs();
    },
    addAttachments: function addAttachments(patientDetails, title) {
      var _this16 = this;

      if (this.editAttachmentsEnabled !== null) {
        this.selectedTitleDocs[title]['formIDs'] = this.selectedTitleDocs[title]['formIDs'].filter(function (id) {
          return !_this16.selectedTitleDocs[title]['attachment_formIds'].includes(id);
        });
        this.selectedTitleDocs[title]['attachment_pages'] = [];
        this.selectedTitleDocs[title]['attachment_formIds'] = [];
      }
      var scrollableContent = document.getElementsByClassName('scrollable-content');
      if (scrollableContent.length > 0) {
        scrollableContent[0].scrollTop = 0;
      }
      var checkedIdArray = [];
      this.$refs.CheckboxClicks.map(function (element) {
        if (element.checked === true) {
          checkedIdArray.push(element.id);
        }
      });
      if (checkedIdArray.length > 0) {
        this.scene.children.map(function (column) {
          if (column.type === 'container') {
            column.children.map(function (element) {
              if (checkedIdArray.indexOf(element.id) >= 0) {
                element.data.form.title = patientDetails.title;
                element.data.form.uuid = patientDetails.uuid;
                element.data.form.process = true;
                element.data.form.isAttachment = true;
                element.data.form.isEdited = false;
                _this16.selectedTitleDocs[title]['attachment_pages'].push(element.data.form.original_page_no);
                _this16.selectedTitleDocs[title]['formIDs'].push(element.data.form.id);
                _this16.selectedTitleDocs[title]['attachment_formIds'].push(element.data.form.id);
              }
            });
          }
        });
      }
      this.editAttachmentsEnabled = null;
      this.validAllForms();
      this.CheckboxClear();
      this.saveSelectedDocs();
    },
    editInsPages: function editInsPages(data, key) {
      var _this17 = this;

      this.editInsCardsEnabled = key;
      this.scene.children.map(function (column) {
        if (column.type === 'container') {
          column.children.map(function (element) {
            if (element.data.form && data.insurance_ids.includes(element.data.form.id)) {
              element.data.form.process = false;
              element.data.form.isInsurance = false;
              element.data.form.isEdited = true;
              _this17.editedCheckedBoxes.push(element.data.form.id);
              _vue2.default.nextTick(function () {
                _this17.checkmarkEditedAttachments(element.id);
              });
            }
          });
        }
      });
      this.saveSelectedDocs();
      this.sortEditedAttachedPages();
      this.CheckboxClear();
    },
    editAttachments: function editAttachments(patientDetails, key) {
      var _this18 = this;

      this.editAttachmentsEnabled = key;
      this.scene.children.map(function (column) {
        if (column.type === 'container') {
          column.children.map(function (element) {
            if (element.data.form && patientDetails.attachment_formIds.includes(element.data.form.id)) {
              element.data.form.process = false;
              element.data.form.isAttachment = false;
              element.data.form.isEdited = true;
              _this18.editedCheckedBoxes.push(element.data.form.id);
              _vue2.default.nextTick(function () {
                _this18.checkmarkEditedAttachments(element.id);
              });
            }
          });
        }
      });
      this.saveSelectedDocs();
      this.sortEditedAttachedPages();
      this.CheckboxClear();
    },
    checkmarkEditedAttachments: function checkmarkEditedAttachments(id) {
      this.$refs.CheckboxClicks.map(function (element) {
        if (element.id === id) {
          element.checked = true;
        }
      });
    },
    sortEditedAttachedPages: function sortEditedAttachedPages() {
      var _this19 = this;

      this.scene.children.map(function (column) {
        if (column.type === 'container' && _this19.editAttachmentsEnabled || column.type === 'container' && _this19.editInsCardsEnabled) {
          column.children.sort(function (a, b) {
            if (a.data.form && b.data.form) {
              if (a.data.form.isEdited === true && b.data.form.isEdited === true) {
                return column.children.indexOf(a) - column.children.indexOf(b);
              }
              if (a.data.form.isEdited === false) return 1;
              if (a.data.form.isEdited === true) return -1;
              return column.children.indexOf(a) - column.children.indexOf(b);
            } else {
              return 0;
            }
          });
        }
      });
    },
    removeAttachments: function removeAttachments(patientDetails, key) {
      var _this20 = this;

      if (key === this.editAttachmentsEnabled) {
        this.editAttachmentsEnabled = null;
      }
      this.scene.children.map(function (column) {
        if (column.type === 'container') {
          column.children.map(function (element) {
            if (element.data.form && patientDetails.attachment_formIds.includes(element.data.form.id)) {
              element.data.form.process = false;
              element.data.form.isAttachment = false;
              element.data.form.isEdited = false;
            }
          });
        }
      });
      this.selectedTitleDocs[key]['formIDs'] = this.selectedTitleDocs[key]['formIDs'].filter(function (id) {
        return !_this20.selectedTitleDocs[key]['attachment_formIds'].includes(id);
      });
      this.selectedTitleDocs[key]['attachment_pages'] = [];
      this.selectedTitleDocs[key]['attachment_formIds'] = [];
      this.vaildFormsData = false;
      this.saveSelectedDocs();
      this.CheckboxClear();
    },
    removeInsPages: function removeInsPages(data, key) {
      var _this21 = this;

      if (key === this.editInsCardsEnabled) {
        this.editInsCardsEnabled = null;
      }
      this.scene.children.map(function (column) {
        if (column.type === 'container') {
          column.children.map(function (element) {
            if (element.data.form && data.insurance_ids.includes(element.data.form.id)) {
              element.data.form.process = false;
              element.data.form.isInsurance = false;
              element.data.form.isEdited = false;
            }
          });
        }
      });
      this.selectedTitleDocs[key]['formIDs'] = this.selectedTitleDocs[key]['formIDs'].filter(function (id) {
        return !_this21.selectedTitleDocs[key]['insurance_ids'].includes(id);
      });
      this.selectedTitleDocs[key]['insurance_pages'] = [];
      this.selectedTitleDocs[key]['insurance_ids'] = [];
      this.vaildFormsData = false;
      this.saveSelectedDocs();
      this.CheckboxClear();
    },
    removePages: function removePages(patientDetails, key) {
      this.scene.children.map(function (column) {
        if (column.type === 'container') {
          column.children.map(function (element) {
            if (element.data.form && patientDetails.formIDs.includes(element.data.form.id)) {
              element.data.form.process = false;
              element.data.form.isEdited = false;
            }
          });
        }
      });
      this.$delete(this.selectedTitleDocs, key);
      if (this.editAttachmentsEnabled === key) {
        this.editAttachmentsEnabled = null;
      }
      this.validAllForms();
      this.CheckboxClear();
      this.saveSelectedDocs();
    },
    editPages: function editPages(patientDetails, key) {
      var _this22 = this;

      this.editedCheckedBoxes = [];
      this.isFirstEditButtonClicked = true;
      this.scene.children.map(function (column) {
        if (column.type === 'container') {
          _this22.extractFormTypeData(column.name, column.children);
          column.children.map(function (element) {
            if (element.data.form && patientDetails.formIDs.includes(element.data.form.id) && !patientDetails.attachment_formIds.includes(element.data.form.id) && !patientDetails.insurance_ids.includes(element.data.form.id)) {
              element.data.form.isEdited = true;
              // TODO: PDX-285
              _this22.editedCheckedBoxes.push(element.data.form.id);
            } else if (element.data.form) {
              element.data.form.isEdited = false;
            }
          });
        }
      });
      Object.keys(this.selectedTitleDocs).map(function (docTitle) {
        _this22.selectedTitleDocs[docTitle]['isEdited'] = false;
      });
      this.selectedTitleDocs[key]['isEdited'] = true;
      this.text = patientDetails['title'];
      this.isEditedDoc = true;
      this.disableSaveButton = false;
      this.isEditedDocKey = key;
      // this.selectedEditTitle = key
      this.formType = patientDetails['formType'];
      this.isPatientIdSelected = Boolean(patientDetails['patient_id']);
      this.selectedForceTemplate = patientDetails['force_template_id'];
      this.sortEditedForms();
    },
    sortEditedForms: function sortEditedForms() {
      var _this23 = this;

      this.scene.children.map(function (column) {
        if (column.type === 'container' && _this23.isEditedDoc) {
          column.children.sort(function (a, b) {
            if (a.data.form && b.data.form) {
              if (a.data.form.isEdited === true && b.data.form.isEdited === true) {
                return column.children.indexOf(a) - column.children.indexOf(b);
              }
              if (a.data.form.isEdited === false) return 1;
              if (a.data.form.isEdited === true) return -1;
              return column.children.indexOf(a) - column.children.indexOf(b);
            } else {
              return 0;
            }
          });
        }
      });
    },

    validAllForms: function validAllForms() {
      // validate the all forms in templates,IC and DL
      var validAllForms = true;
      this.scene.children.map(function (column) {
        if (column.type === 'container' && ['Templates', 'Insurance cards', 'Drivers License', 'Unmatched Pages'].includes(column.name)) {
          column.children.map(function (element) {
            if (element.data.form) {
              if (element.data.form.process === false) {
                validAllForms = false;
              }
            }
          });
        }
      });
      this.vaildFormsData = validAllForms;
    },
    getResultCss: function getResultCss(value) {
      return value['isEdited'] && this.isEditedDoc ? 'edit-result' : 'result';
    },
    clearEditedAttachedPages: function clearEditedAttachedPages() {
      var _this24 = this;

      if (this.editAttachmentsEnabled || this.editInsCardsEnabled) {
        this.scene.children.map(function (column) {
          if (column.type === 'container') {
            column.children.map(function (element) {
              if (element.data.form && _this24.selectedTitleDocs[_this24.editAttachmentsEnabled] && _this24.selectedTitleDocs[_this24.editAttachmentsEnabled].attachment_formIds.includes(element.data.form.id)) {
                element.data.form.process = true;
                element.data.form.isAttachment = true;
                element.data.form.isEdited = false;
              }
              if (element.data.form && _this24.selectedTitleDocs[_this24.editInsCardsEnabled] && _this24.selectedTitleDocs[_this24.editInsCardsEnabled].insurance_ids.includes(element.data.form.id)) {
                element.data.form.process = true;
                element.data.form.isInsurance = true;
                element.data.form.isEdited = false;
              }
            });
          }
        });
        this.editAttachmentsEnabled = null;
        this.editInsCardsEnabled = null;
      }
    }
  }
};

/***/ }),
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vueCuteTimeline = __webpack_require__(1138);

var _animatedNumberVue = __webpack_require__(191);

var _animatedNumberVue2 = _interopRequireDefault(_animatedNumberVue);

var _vuex = __webpack_require__(5);

var _LineChart = __webpack_require__(1141);

var _LineChart2 = _interopRequireDefault(_LineChart);

var _Switch = __webpack_require__(70);

var _Switch2 = _interopRequireDefault(_Switch);

var _vueMultiselect = __webpack_require__(36);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _vue2Datepicker = __webpack_require__(98);

var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);

var _vueInfiniteLoading = __webpack_require__(109);

var _vueInfiniteLoading2 = _interopRequireDefault(_vueInfiniteLoading);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(45);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'reports-form',
  data: function data() {
    return {
      option_keys: [],
      reportCards: [],
      showReportCards: false,
      processWorkflowStat: null,
      lineData: [],
      lineLabels: [],
      showChart: false,
      processTypes: [],
      templates: [],
      filterProcessed: true,
      filterRejected: true,
      processedForms: [],
      selectedProcessType: null,
      selectedTemplate: null,
      distance: Infinity,
      lastFormId: -1,
      sortBy: 'id',
      sortDesc: true,
      showProcessedForms: false,
      tableFields: [{ key: 'id', sortable: true }, { key: 'title', label: 'COMMON.TITLE', sortable: true }, { key: 'pages', label: 'ANALYTICS.PAGES', sortable: false }, { key: 'confidence_score', label: 'ANALYTICS.CONFIDENCE', sortable: true }, { key: 'identified', label: 'ANALYTICS.IDENTIFIED', sortable: true }, { key: 'rejection_reason', label: 'ANALYTICS.REJECTED', sortable: true }],
      dateRange: [(0, _moment2.default)().subtract(1, 'months'), (0, _moment2.default)()],
      dateRangeCSV: [(0, _moment2.default)().subtract(1, 'months'), (0, _moment2.default)()],
      selectedDateFilterType: 'day',
      selectedDateFilterTypeCSV: 'day',
      filterOptions: [],
      teams: [],
      teamID: null,
      users: null,
      userID: null,
      expUserID: null,
      expTeamID: null

    };
  },

  components: {
    'line-chart': _LineChart2.default,
    'c-switch': _Switch2.default,
    'date-picker': _vue2Datepicker2.default,
    Timeline: _vueCuteTimeline.Timeline,
    TimelineItem: _vueCuteTimeline.TimelineItem,
    AnimatedNumber: _animatedNumberVue2.default,
    Multiselect: _vueMultiselect2.default,
    InfiniteLoading: _vueInfiniteLoading2.default
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'selectedRolesData', 'userRoleOrder', 'isAdminRole', 'currentUserId']), {
    setOptions: function setOptions() {
      var _this = this;

      this.processTypes = [{ text: this.$t('ANALYTICS.SELECT_PROCESS_TYPE'), value: null, disabled: true }];
      this.processTypes = this.processTypes.concat(this.option_keys.map(function (processType) {
        return { text: _this.$t('UPLOAD_DROPDOWN.' + processType.key), value: processType.value };
      }));
      return this.processTypes;
    },
    setFilterOptions: function setFilterOptions() {
      this.filterOptions = [{
        text: this.$t('COMMON.' + 'SELECT'),
        value: null,
        disabled: true
      }, {
        text: this.$t('COMMON.' + 'WEEK'),
        value: 'week'
      }, {
        text: this.$t('COMMON.' + 'DAY'),
        value: 'day'
      }];
      return this.filterOptions;
    }
  }),
  watch: {
    dateRange: function dateRange() {
      if (this.dateRange[0] && this.dateRange[1]) {
        this.fetchReceivedFormsReport();
      }
    },
    selectedDateFilterType: function selectedDateFilterType() {
      this.fetchReceivedFormsReport();
    },
    teamID: function teamID() {
      this.filterByTeam();
    },
    userID: function userID(newUserID, oldUserID) {
      this.filterByUser();
    },
    expTeamID: function expTeamID() {
      this.teamID = this.expTeamID;
      this.expUserID = null;
    }
  },
  created: function created() {
    var roles = _lodash2.default.slice(this.selectedRolesData, 0, this.userRoleOrder);
    this.roles = roles.map(function (role) {
      return role.id;
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$root.$on('exportReports', function (status) {
      _this2.dateRangeCSV = _this2.dateRange;
      _this2.selectedDateFilterTypeCSV = _this2.selectedDateFilterType;
      _this2.expUserID = _this2.userID;
      _this2.expTeamID = _this2.teamID;
      _this2.$refs.downloadReportsModal.show();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('exportReports', this.status);
  },

  methods: {
    generateCSV: function generateCSV() {
      this.download_reports();
    },
    hidedownloadReportsModal: function hidedownloadReportsModal() {
      this.$refs.downloadReportsModal.hide();
    },
    formatNumber: function formatNumber(value) {
      return value.toFixed(0);
    },
    pCardFilter: function pCardFilter(processType) {
      this.selectedProcessType = processType;
      this.filterProcessed = true;
      this.selectedTemplate = null;
      this.fetchProcessedForms();
      var offset = document.getElementById('recent-forms').offsetTop - 100;
      window.scroll({
        top: offset,
        left: 0,
        behaviour: 'smooth'
      });
    },
    pSwitchChanged: function pSwitchChanged() {
      this.filterProcessed = !this.filterProcessed;
      this.fetchProcessedForms();
    },
    rSwitchChanged: function rSwitchChanged() {
      this.filterRejected = !this.filterRejected;
      // For rejected switch to be on, no template should be selected
      if (this.filterRejected) {
        this.selectedTemplate = null;
      }
      this.fetchProcessedForms();
    },
    filterProcessedFormsByType: function filterProcessedFormsByType() {
      this.selectedTemplate = null;
      this.fetchProcessedForms();
    },
    filterProcessedFormsByTemplate: function filterProcessedFormsByTemplate() {
      // Whenever a template is selected, rejected switch to be off
      if (this.selectedTemplate) {
        this.filterRejected = false;
      }
      this.fetchProcessedForms();
    },
    filterByUser: function filterByUser() {
      this.fetchReports();
      this.fetchTemplates();
      this.fetchProcessedForms();
    },
    filterByTeam: function filterByTeam() {
      if (this.isAdminRole) {
        this.userID = null;
        this.fetchReports();
        this.fetchTemplates();
        this.fetchReceivedFormsReport();
        this.fetchProcessedForms();
      }
    },
    fetchReports: function fetchReports() {
      var _this3 = this;

      _vue2.default.axios.get('reports', { headers: { Authorization: 'Bearer ' + this.idToken }, params: { teamID: this.teamID, roles: this.roles, userID: this.userID, userRoleOrder: this.userRoleOrder } }).then(function (res) {
        var categoryProcessDetails = res.data.category_process_details;
        _this3.option_keys = res.data.process_types.map(function (processType) {
          return { key: processType.key, value: processType.value };
        });
        if (_this3.isAdminRole) {
          _this3.users = [{ text: 'All', value: null }].concat(res.data.users.map(function (user) {
            return { text: user.username, value: user.id };
          }));
        } else {
          _this3.users = res.data.users.map(function (user) {
            return { text: user.username, value: user.id };
          });
        }
        _this3.showChart = true;
        _this3.showReportCards = true;
        _this3.fetchCardDetails(categoryProcessDetails);
      }).catch(function (error) {
        console.log(error);
        if (error.status === 401) {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    fetchTemplates: function fetchTemplates() {
      var _this4 = this;

      _vue2.default.axios.get('template_docs', { headers: { Authorization: 'Bearer ' + this.idToken }, params: { teamID: this.teamID, userID: this.userID } }).then(function (res) {
        _this4.processWorkflowStat = res.data.processed_forms;
        _this4.templates = [{
          text: _this4.$t('TEMPLATE.SELECT_TEMPLATE'),
          value: null
        }].concat(res.data.template_docs.map(function (templateDoc) {
          return { value: templateDoc.id, text: templateDoc.title };
        }));
      }).catch(function (error) {
        console.log(error);
        if (error.status === 401) {
          _vue2.default.toasted.show(_this4.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this4.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    fetchReceivedFormsReport: function fetchReceivedFormsReport() {
      var _this5 = this;

      var filterBy = this.selectedDateFilterType;
      var startDate = (0, _moment2.default)(this.dateRange[0]).format('YYYY-MM-DD');
      var endDate = (0, _moment2.default)(this.dateRange[1]).format('YYYY-MM-DD');
      _vue2.default.axios.get('reports/received_forms', { headers: { Authorization: 'Bearer ' + this.idToken }, params: { startDate: startDate, endDate: endDate, filterBy: filterBy, teamID: this.teamID } }).then(function (res) {
        var reportsData = res.data.reports;
        _this5.lineData = reportsData.line_data;
        _this5.lineLabels = reportsData.line_labels;
      }).catch(function (error) {
        console.log(error);
        if (error.status === 401) {
          _vue2.default.toasted.show(_this5.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this5.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    fetchProcessedForms: function fetchProcessedForms() {
      this.processedForms = [];
      this.distance = Infinity;
      this.lastFormId = -1;
      this.showProcessedForms = false;
      this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
    },
    infiniteHandler: function infiniteHandler($state) {
      var _this6 = this;

      var params = {
        process_type: this.selectedProcessType,
        template_doc_id: this.selectedTemplate,
        processed: this.filterProcessed,
        rejected: this.filterRejected,
        last_form_id: this.lastFormId,
        team_id: this.teamID,
        user_id: this.userID
      };
      _vue2.default.axios.get('reports/processed_forms', { headers: { Authorization: 'Bearer ' + this.idToken }, params: params }).then(function (res) {
        var forms = res.data.forms;
        if (forms.length > 0) {
          _this6.processedForms = _this6.processedForms.slice().concat(forms);
          _this6.lastFormId = forms[forms.length - 1]['id'];
          _this6.distance = 100;
          _this6.showProcessedForms = true;
          _this6.sortBy = 'id';
          _this6.sortDesc = true;
          $state.loaded();
        } else {
          _this6.distance = 100;
          _this6.showProcessedForms = true;
          $state.complete();
        }
      }).catch(function (error) {
        console.log(error);
        if (error.status === 401) {
          _vue2.default.toasted.show(_this6.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this6.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    fetchCardDetails: function fetchCardDetails(categoryProcessDetails) {
      this.reportCards = [{ id: 1, value: categoryProcessDetails['enrollment forms'].total, icon: 'fa fa-file-text', key: 'ENROLLMENT_FORMS', text: 'enrollment forms', received: categoryProcessDetails['enrollment forms'].total, processed: categoryProcessDetails['enrollment forms'].processed, rejected: categoryProcessDetails['enrollment forms'].rejected, bg: 'bg-primary', tc: 'text-primary' }, { id: 2, value: categoryProcessDetails['insurance cards'].total, icon: 'fa fa-id-card', key: 'INSURANCE', text: 'insurance cards', received: categoryProcessDetails['insurance cards'].total, processed: categoryProcessDetails['insurance cards'].processed, rejected: categoryProcessDetails['insurance cards'].rejected, bg: 'bg-success', tc: 'text-success' }, { id: 3, value: categoryProcessDetails['drivers license'].total, icon: 'fa fa-id-card-o', key: 'DL', text: 'drivers license', received: categoryProcessDetails['drivers license'].total, processed: categoryProcessDetails['drivers license'].processed, rejected: categoryProcessDetails['drivers license'].rejected, bg: 'bg-info', tc: 'text-info' }, { id: 4, value: categoryProcessDetails['invoice'].total, icon: 'fa fa-file-text-o', key: 'INVOICE', text: 'invoice', received: categoryProcessDetails['invoice'].total, processed: categoryProcessDetails['invoice'].processed, rejected: categoryProcessDetails['invoice'].rejected, bg: 'bg-warning', tc: 'text-warning' }, { id: 5, value: categoryProcessDetails['lease documents'].total, icon: 'fa fa-file-text', key: 'LEASE', text: 'lease documents', received: categoryProcessDetails['lease documents'].total, processed: categoryProcessDetails['lease documents'].processed, rejected: categoryProcessDetails['lease documents'].rejected, bg: 'bg-danger', tc: 'text-danger' }, { id: 6, value: categoryProcessDetails['license agreement'].total, icon: 'fa fa-file-text-o', key: 'SLA', text: 'license agreement', received: categoryProcessDetails['license agreement'].total, processed: categoryProcessDetails['license agreement'].processed, rejected: categoryProcessDetails['license agreement'].rejected, bg: 'bg-danger', tc: 'text-danger' }];
    },
    download_reports: function download_reports() {
      var _this7 = this;

      var title = 'reports_';
      if (this.teams.length > 0) {
        var teamName = this.teams.filter(function (team) {
          return team.value === _this7.expTeamID;
        })[0]['text'];
        var userName = this.users.filter(function (user) {
          return user.value === _this7.expUserID;
        })[0]['text'];
        teamName = teamName.replace(/ /g, '_');
        userName = userName.replace(/ /g, '_');
        if (teamName === 'All' && userName === 'All') {
          teamName = userName = '';
          title = title + 'All';
        } else {
          title = title + teamName + '_' + userName;
        }
      }
      var payload = {
        filterBy: this.selectedDateFilterTypeCSV,
        startDate: (0, _moment2.default)(this.dateRangeCSV[0]).format('YYYY-MM-DD'),
        endDate: (0, _moment2.default)(this.dateRangeCSV[1]).format('YYYY-MM-DD'),
        teamID: this.expTeamID,
        userID: this.expUserID
      };
      _vue2.default.axios.post('reports/download.csv', payload, { headers: { 'Authorization': 'Bearer ' + this.idToken } }).then(function (res) {
        var csvData = res.data;
        var downloadLink = document.createElement('a');
        downloadLink.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData);
        downloadLink.download = title + '_' + (0, _moment2.default)().format() + '.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        _this7.$refs.downloadReportsModal.hide();
        downloadLink.remove();
      }).catch(function (error) {
        console.log(error);
        if (error.status === 401) {
          _vue2.default.toasted.show(_this7.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this7.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    }
  }
};

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _animejs = __webpack_require__(1139);

var _animejs2 = _interopRequireDefault(_animejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    value: {
      type: [Number, String],
      required: true
    },
    formatValue: {
      type: Function,
      default: function _default(value) {
        return value;
      }
    },
    easing: {
      type: String,
      default: 'linear'
    },
    duration: {
      type: Number,
      default: 1000
    },
    update: Function,
    begin: Function,
    complete: Function,
    run: Function,
    delay: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      animatedValue: 0
    };
  },
  mounted: function mounted() {
    this.animateValue(this.value);
  },

  watch: {
    value: function value(_value) {
      this.animateValue(_value);
    }
  },
  methods: {
    animateValue: function animateValue(value) {
      var begin = this.begin,
          easing = this.easing,
          duration = this.duration,
          complete = this.complete,
          update = this.update,
          run = this.run,
          delay = this.delay;

      (0, _animejs2.default)({
        targets: this,
        animatedValue: value,
        duration: duration,
        easing: easing,
        update: update,
        begin: begin,
        complete: complete,
        run: run,
        delay: delay
      });
    }
  }
}; //
//
//

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueChartjs = __webpack_require__(1142);

exports.default = {
  extends: _vueChartjs.Line,
  props: ['lineData', 'lineLabels'],
  mounted: function mounted() {
    this.render();
  },

  watch: {
    lineData: function lineData() {
      this.render();
    }
  },
  methods: {
    render: function render() {
      this.renderChart({
        labels: this.lineLabels,
        datasets: [{
          label: this.$t('ANALYTICS.TOTAL_FORMS'),
          backgroundColor: '#20a8d8',
          data: this.lineData
        }]
      }, { responsive: true, maintainAspectRatio: false });
    }
  }
};

/***/ }),
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _animatedNumberVue = __webpack_require__(191);

var _animatedNumberVue2 = _interopRequireDefault(_animatedNumberVue);

var _vuex = __webpack_require__(5);

var _vue2Datepicker = __webpack_require__(98);

var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);

var _vueInfiniteLoading = __webpack_require__(109);

var _vueInfiniteLoading2 = _interopRequireDefault(_vueInfiniteLoading);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _svg = __webpack_require__(28);

var _svg2 = _interopRequireDefault(_svg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'reports-form',
  data: function data() {
    return {
      processedForms: [],
      distance: Infinity,
      lastFormId: -1,
      sortBy: 'id',
      sortDesc: true,
      showProcessedForms: false,
      tableFields: [{ key: 'id', sortable: true }, { key: 'title', label: 'WORKFLOW.TITLE', sortable: false }, { key: 'username', lavel: 'COMMON.USERNAME', sortable: false }, { key: 'total_page_count', label: 'ANALYTICS.PAGES', sortable: false }, { key: 'average_confidence', label: 'ANALYTICS.CONFIDENCE', sortable: true }, { key: 'total_fields', label: 'ANALYTICS.TOTAL_FIELDS', sortable: false }, { key: 'transcribed_fields', label: 'ANALYTICS.TRANSCRIBED_FIELDS', sortable: false }, { key: 'edited_fields', label: 'ANALYTICS.EDITED_FIELDS', sortable: false }, { key: 'accuracy_percentage', label: 'ANALYTICS.ACCURACY_PERCENTAGE', sortable: false }, { key: 'status', label: 'COMMON.STATUS', sortable: false }, { key: 'created_at', label: 'WORKFLOW.CREATED_AT', sortable: false }, { key: 'updated_at', label: 'WORKFLOW.UPDATED_AT', sortable: false }, { key: 'document_recieved_at', label: 'WORKFLOW.DOC_RECIEVED_AT', sortable: false }, { key: 'time_difference', label: 'WORKFLOW.TIME_DIFF', sortable: false }],
      dateRange: [(0, _moment2.default)(), (0, _moment2.default)()],
      formsDateRange: [(0, _moment2.default)(), (0, _moment2.default)()],
      dailyReports: [],
      formsProcessed: [],
      svg: _svg2.default,
      processedFormsStatus: ['pending', 'in_progress', 'rejected', 'recalled', 'validated', 'integration_success', 'integration_failed', 'document_moved_to_sf'],
      triagedFormsStatus: ['new_doc', 'in_progress', 'partially_completed', 'completed', 'triaged', 'recalled', 'rejected', 'integration_success', 'integration_failed', 'document_moved_to_sf'],
      unmatchedFormsStatus: ['pending', 'in_progress', 'validated', 'rejected', 'recalled', 'integration_success', 'integration_failed', 'document_moved_to_sf'],
      processedFormsCounts: [],
      triageFormsCounts: [],
      unmatchedFormsCounts: []
    };
  },

  components: {
    'date-picker': _vue2Datepicker2.default,
    AnimatedNumber: _animatedNumberVue2.default,
    InfiniteLoading: _vueInfiniteLoading2.default
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'isAdminRole'])),
  created: function created() {
    this.fetchFormStatusReports();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.isAdminRole) {
        next();
      } else {
        _router2.default.replace('/Not-Found-404');
      }
    });
  },

  methods: {
    formatNumber: function formatNumber(value) {
      return value.toFixed(0);
    },
    fetchFormStatusReports: function fetchFormStatusReports() {
      var _this = this;

      var startDate = (0, _moment2.default)(this.formsDateRange[0]).format('YYYY-MM-DD');
      var endDate = (0, _moment2.default)(this.formsDateRange[1]).format('YYYY-MM-DD');
      var params = { start_date: startDate, end_date: endDate };
      _vue2.default.axios.post('reports/forms_status_reports', params, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this.processedFormsCounts = res.data.processed_forms;
        _this.triageFormsCounts = res.data.triage_forms;
        _this.unmatchedFormsCounts = res.data.unmatched_forms;
      }).catch(function (error) {
        console.error(error);
        if (error.status === 401) {
          _vue2.default.toasted.show(_this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    fetchProcessedForms: function fetchProcessedForms() {
      this.dailyReports = [];
      this.distance = Infinity;
      this.lastFormId = -1;
      this.showProcessedForms = false;
      this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
    },
    dailyReportsInfinetHandler: function dailyReportsInfinetHandler($state) {
      var _this2 = this;

      var payload = {
        last_form_id: this.lastFormId,
        start_date: (0, _moment2.default)(this.dateRange[0]).format('YYYY-MM-DD'),
        end_date: (0, _moment2.default)(this.dateRange[1]).format('YYYY-MM-DD')
      };
      _vue2.default.axios.get('reports/daily_report', { headers: { Authorization: 'Bearer ' + this.idToken }, params: payload }).then(function (res) {
        var forms = res.data.forms_processed;
        if (forms.length > 0) {
          _this2.distance = 100;
          _this2.dailyReports = _this2.dailyReports.slice().concat(forms);
          _this2.lastFormId = forms[forms.length - 1]['id'];
          _this2.formsProcessed = res.data.processed_by_agent_assist;
          _this2.showProcessedForms = true;
          _this2.sortBy = 'id';
          _this2.sortDesc = true;
          $state.loaded();
        } else {
          _this2.distance = 100;
          _this2.showProcessedForms = true;
          $state.complete();
        }
      }).catch(function (error) {
        console.error(error);
        if (error.status === 401) {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    downloadFormsInsights: function downloadFormsInsights() {
      var _this3 = this;

      var payload = {
        start_date: (0, _moment2.default)(this.dateRange[0]).format('YYYY-MM-DD'),
        end_date: (0, _moment2.default)(this.dateRange[1]).format('YYYY-MM-DD')
      };
      var title = 'reports_';
      _vue2.default.axios.post('reports/form_insights.csv', payload, { headers: { 'Authorization': 'Bearer ' + this.idToken } }).then(function (res) {
        var csvData = res.data;
        var downloadLink = document.createElement('a');
        downloadLink.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData);
        downloadLink.download = title + '_' + (0, _moment2.default)().format() + '.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
      }).catch(function (error) {
        console.error(error);
        if (error.status === 401) {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    }
  }
};

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _vueInfiniteLoading = __webpack_require__(109);

var _vueInfiniteLoading2 = _interopRequireDefault(_vueInfiniteLoading);

var _moment2 = __webpack_require__(0);

var _moment3 = _interopRequireDefault(_moment2);

var _vue2Datepicker = __webpack_require__(98);

var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);

var _vuex = __webpack_require__(5);

var _vueMultiselect = __webpack_require__(36);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = {
  name: 'audit-log-report',
  data: function data() {
    var _this = this;

    return {
      tableFields: [{ key: 'actions', label: 'Actions', sortable: false }, { key: 'id', sortable: true, thStyle: { width: '3%' } }, { key: 'title', label: 'WORKFLOW.TITLE', sortable: true, thStyle: { width: '17%' } }, { key: 'username', lavel: 'COMMON.USERNAME', sortable: true, thStyle: { width: '10%' } }, { key: 'document_type', lavel: 'WORKFLOW.DOCUMENT_TYPE', sortable: true, thStyle: { width: '7%' } }, { key: 'total_page_count', label: 'ANALYTICS.PAGES', sortable: true, thStyle: { width: '4%' } }, { key: 'total_fields', label: 'ANALYTICS.TOTAL_FIELDS', sortable: false }, { key: 'average_confidence', label: 'FORMS.CON_SCORE', sortable: true, thStyle: { width: '7%' } }, { key: 'transcribed_fields', label: 'ANALYTICS.TRANSCRIBED_FIELDS', sortable: false }, { key: 'edited_fields', label: 'ANALYTICS.EDITED_FIELDS', sortable: false }, { key: 'status', label: 'COMMON.STATUS', sortable: true, thStyle: { width: '5%' } }, { key: 'accuracy_percentage', label: 'ANALYTICS.ACCURACY_PERCENTAGE', sortable: true, thStyle: { width: '10%' } }, { key: 'actions', label: 'Actions', sortable: false }, { key: 'time_difference', label: 'WORKFLOW.TURN_AROU_TIME', sortable: true, thStyle: { width: '8%' } }, { key: 'created_at', label: 'WORKFLOW.CREATED_AT', sortable: true, thStyle: { width: '10%' } }, { key: 'updated_at', label: 'WORKFLOW.UPDATED_AT', sortable: true, thStyle: { width: '10%' } }, { key: 'document_recieved_at', label: 'WORKFLOW.DOC_RECIEVED_AT', sortable: true, thStyle: { width: '10%' } }],
      logFields: [{ key: 'version', label: 'Version', thStyle: { width: '1%' } }, { key: 'file_name', label: 'File Name', thStyle: { width: '20%' } }, { key: 'field_name', label: 'Field Name', thStyle: { width: '20%' } }, { key: 'original_text', label: 'Original Text', thStyle: { width: '20%' } }, { key: 'modified_text', label: 'Modified Text', thStyle: { width: '20%' } }, { key: 'updated_by', label: 'Updated By', thStyle: { width: '20%' } }, { key: 'updated_at', label: 'Updated Date & Time', thStyle: { width: '20%' } }, { key: 'original_confidence_score', label: 'Original Confidence Score', thStyle: { width: '10%' } }, { key: 'modified_confidence_score', label: 'Modified Confidence Score', thStyle: { width: '10%' } }],
      sortBy: 'id',
      sortDesc: true,
      showProcessedForms: false,
      dailyReports: [],
      distance: Infinity,
      lastFormId: -1,
      dateRange: [(0, _moment3.default)().startOf('week'), (0, _moment3.default)()],
      userOptions: [],
      usernames: null,
      searchFilter: '',
      auditLogs: [],
      logsCurrentPage: 1,
      logsPerPage: 13,
      formDocId: null,
      isLogsLoaded: false,
      shortcuts: [{ text: 'Today',
        onClick: function onClick() {
          _this.dateRange = [(0, _moment3.default)().startOf('day'), (0, _moment3.default)()];
          return Date();
        }
      }, {
        text: 'This Week',
        onClick: function onClick() {
          _this.dateRange = [(0, _moment3.default)().startOf('week'), (0, _moment3.default)()];
          return new Date();
        }
      }, {
        text: 'Previous Week',
        onClick: function onClick() {
          _this.dateRange = [(0, _moment3.default)().subtract(1, 'weeks').startOf('week'), (0, _moment3.default)().subtract(1, 'weeks').endOf('week').startOf('day')];
          return new Date();
        }
      }, {
        text: 'This Month',
        onClick: function onClick() {
          _this.dateRange = [(0, _moment3.default)().startOf('month'), (0, _moment3.default)()];
          return new Date();
        }
      }, {
        text: 'Previous Month',
        onClick: function onClick() {
          _this.dateRange = [(0, _moment3.default)().subtract(1, 'month').startOf('month'), (0, _moment3.default)().subtract(1, 'month').endOf('month').startOf('day')];
          return new Date();
        }
      }]
    };
  },

  components: {
    'date-picker': _vue2Datepicker2.default,
    InfiniteLoading: _vueInfiniteLoading2.default,
    Multiselect: _vueMultiselect2.default
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'accountId', 'isAdminRole', 'localTime']), {
    setUsernames: function setUsernames() {
      var usernames = [];
      var updatedUsersArray = this.userOptions.map(function (user) {
        return {
          value: Number(user.id),
          text: user.username
        };
      });
      usernames.push.apply(usernames, _toConsumableArray(updatedUsersArray));
      return usernames;
    },
    logsRow: function logsRow() {
      return this.auditLogs.length;
    }
  }),
  filters: {
    moment: function moment(date) {
      return (0, _moment3.default)(date).format('DD MMMM YYYY HH:mm:ss');
    }
  },
  created: function created() {
    this.fetchUsers();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.isAdminRole) {
        next();
      } else {
        _router2.default.replace('/Not-Found-404');
      }
    });
  },

  methods: {
    dailyReportsInfinetHandler: function dailyReportsInfinetHandler($state) {
      var _this2 = this;

      var payload = {
        last_form_id: this.lastFormId,
        start_date: (0, _moment3.default)(this.dateRange[0]).format('YYYY-MM-DD'),
        end_date: (0, _moment3.default)(this.dateRange[1]).format('YYYY-MM-DD'),
        time_zone_offset: this.localTime === 'true' ? new Date().getTimezoneOffset() : null
      };
      if (this.usernames) {
        var userIds = [];
        this.usernames.forEach(function (user) {
          userIds.push(Number(user.value));
        });
        payload.user_ids = userIds;
      }
      if (this.searchFilter) {
        payload.search_query = this.searchFilter;
      }
      _vue2.default.axios.get('reports/daily_report', { headers: { Authorization: 'Bearer ' + this.idToken }, params: payload }).then(function (res) {
        var forms = res.data.forms_processed;
        if (forms.length > 0) {
          _this2.distance = 100;
          _this2.dailyReports = _this2.dailyReports.slice().concat(forms);
          _this2.lastFormId = forms[forms.length - 1]['id'];
          _this2.formsProcessed = res.data.processed_by_agent_assist;
          _this2.showProcessedForms = true;
          _this2.sortBy = 'id';
          _this2.sortDesc = true;
          $state.loaded();
        } else {
          _this2.distance = 100;
          _this2.showProcessedForms = true;
          $state.complete();
        }
      }).catch(function (error) {
        console.error(error);
        if (error.status === 401) {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    fetchProcessedForms: function fetchProcessedForms() {
      this.dailyReports = [];
      this.distance = Infinity;
      this.lastFormId = -1;
      this.showProcessedForms = false;
      this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
    },
    generateLogVersions: function generateLogVersions(logsCount, pageNumber) {
      var logsPerPage = this.logsPerPage;
      var startVersion = logsCount - logsPerPage * (pageNumber - 1);
      return Array(logsPerPage).fill().map(function (element, index) {
        return startVersion - index;
      });
    },
    showLogs: function showLogs(formDocId, selectedPage) {
      var _this3 = this;

      this.$refs.formLogsTable.show();
      var payload = {
        form_doc_id: formDocId,
        time_zone_offset: this.localTime === 'true' ? new Date().getTimezoneOffset() : null
      };
      this.formDocId = formDocId;
      _vue2.default.axios.get('reports/audit_log', { headers: { Authorization: 'Bearer ' + this.idToken }, params: payload }).then(function (res) {
        var versions = _this3.generateLogVersions(res.data.result.length, selectedPage);
        _this3.logsCurrentPage = 1;
        _this3.isLogsLoaded = true;
        var fileName = res.data.file_name;
        var logs = res.data.result;
        var updatedLogs = [];
        logs.forEach(function (log, logIndex) {
          log.updates_data.forEach(function (update) {
            updatedLogs.push({
              version: versions[logIndex],
              file_name: fileName,
              field_name: update.key,
              original_text: update.value_before,
              modified_text: update.value_after,
              updated_by: log.updated_by,
              updated_at: (0, _moment3.default)(log.created_at).format('MM/DD/YYYY, h:mm A'),
              original_confidence_score: update.original_confidence_score ? update.original_confidence_score : '',
              modified_confidence_score: update.modified_confidence_score ? update.modified_confidence_score : ''
            });
          });
        });
        _this3.auditLogs = updatedLogs;
      }).catch(function (err) {
        console.error(err);
        if (err.status === 401) {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    logsPagination: function logsPagination(selectedPage) {
      this.showLogs(this.formDocId, selectedPage);
    },
    downloadFormLogs: function downloadFormLogs(formDocId, fileName) {
      var _this4 = this;

      var payload = {
        form_doc_id: formDocId,
        time_zone_offset: this.localTime === 'true' ? new Date().getTimezoneOffset() : null
      };
      var title = fileName + '_View Log';
      _vue2.default.axios.post('reports/audit_log_csv.csv', payload, { headers: { 'Authorization': 'Bearer ' + this.idToken } }).then(function (res) {
        var csvData = res.data;
        var downloadLink = document.createElement('a');
        downloadLink.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData);
        downloadLink.download = title + '.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
      }).catch(function (error) {
        console.error(error);
        if (error.status === 401) {
          _vue2.default.toasted.show(_this4.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this4.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    downloadAllFormLogs: function downloadAllFormLogs() {
      var _this5 = this;

      var payload = {
        time_zone_offset: this.localTime === 'true' ? new Date().getTimezoneOffset() : null,
        start_date: (0, _moment3.default)(this.dateRange[0]).format('YYYY-MM-DD'),
        end_date: (0, _moment3.default)(this.dateRange[1]).format('YYYY-MM-DD'),
        search_query: this.searchFilter
      };
      if (this.usernames) {
        var userIds = [];
        this.usernames.forEach(function (user) {
          userIds.push(Number(user.value));
        });
        payload.user_ids = userIds;
      }
      var title = 'AuditLogReport_View Log' + payload.start_date + '_' + payload.end_date;
      _vue2.default.axios.post('reports/audit_view_all_logs.csv', payload, { headers: { 'Authorization': 'Bearer ' + this.idToken } }).then(function (res) {
        var csvData = res.data;
        var downloadLink = document.createElement('a');
        downloadLink.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData);
        downloadLink.download = title + '.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
      }).catch(function (error) {
        console.error(error);
        if (error.status === 401) {
          _vue2.default.toasted.show(_this5.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this5.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    downloadFormsInsights: function downloadFormsInsights() {
      var _this6 = this;

      var payload = {
        start_date: (0, _moment3.default)(this.dateRange[0]).format('YYYY-MM-DD'),
        end_date: (0, _moment3.default)(this.dateRange[1]).format('YYYY-MM-DD'),
        time_zone_offset: this.localTime === 'true' ? new Date().getTimezoneOffset() : null
      };
      if (this.usernames) {
        var userIds = [];
        this.usernames.forEach(function (user) {
          userIds.push(Number(user.value));
        });
        payload.user_ids = userIds;
      }
      if (this.searchFilter) {
        payload.search_query = this.searchFilter;
      }
      var title = 'Audit log report for the period_';
      _vue2.default.axios.post('reports/form_insights.csv', payload, { headers: { 'Authorization': 'Bearer ' + this.idToken } }).then(function (res) {
        var csvData = res.data;
        var downloadLink = document.createElement('a');
        downloadLink.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData);
        downloadLink.download = title + payload.start_date + ' and ' + payload.end_date + '.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
      }).catch(function (error) {
        console.error(error);
        if (error.status === 401) {
          _vue2.default.toasted.show(_this6.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this6.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    fetchUsers: function fetchUsers() {
      var _this7 = this;

      var roleId = -1;
      var accountId = -1;
      _vue2.default.axios.get('/admin/users/users_by_roles?role_id=' + roleId + '&account_id=' + accountId, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this7.userOptions = res.data.users;
      }).catch(function (error) {
        console.error(error);
        if (error.status === 401) {
          _vue2.default.toasted.show(_this7.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else if (error.status === 403) {
          _vue2.default.toasted.show(_this7.$t('COMMON.UNAUTHORIZED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this7.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    filterBySearch: function filterBySearch(value) {
      this.searchFilter = value;
    },
    clearFilters: function clearFilters() {
      this.lastFormId = -1;
      this.dailyReports = [];
      this.searchFilter = '';
      this.usernames = null;
      this.$refs.searchInput.$el.value = '';
      this.dateRange = [(0, _moment3.default)().startOf('week'), (0, _moment3.default)()];
      this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
    }
  }
};

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _vuex = __webpack_require__(5);

var _SearchBar = __webpack_require__(185);

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _vue2Datepicker = __webpack_require__(98);

var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);

var _vueInfiniteLoading = __webpack_require__(109);

var _vueInfiniteLoading2 = _interopRequireDefault(_vueInfiniteLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'audit-trails',
  data: function data() {
    return {
      filter: null,
      trailsData: [],
      logsLoaded: false,
      tableFields: [{ key: 'email', sortable: true }, { key: 'action', label: 'COMMON.ACTION', sortable: true }, { key: 'path', label: 'TRAILS.PATH', sortable: true }, { key: 'location', label: 'TRAILS.LOCATION', sortable: true }, { key: 'ip', sortable: true, label: 'IP' }, { key: 'logged_at', label: 'TRAILS.LOGGED_AT', sortable: true }],
      dateRange: [(0, _moment2.default)().subtract(1, 'week'), (0, _moment2.default)()],
      verifyDays: false,
      sortBy: 'id',
      sortDesc: true,
      distance: Infinity,
      lastLogId: -1
    };
  },

  components: {
    SearchBar: _SearchBar2.default,
    DatePicker: _vue2Datepicker2.default,
    InfiniteLoading: _vueInfiniteLoading2.default
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'isAdminRole']), {
    getTrailsData: function getTrailsData() {
      return this.trailsData;
    }
  }),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (!vm.isAdminRole) {
        _router2.default.replace('/Not-Found-404');
      }
    });
  },
  created: function created() {
    this.distance = Infinity;
    this.lastLogId = -1;
    this.logsLoaded = false;
  },
  mounted: function mounted() {
    var _this = this;

    this.$root.$on('exportLogs', function (status) {
      _this.$refs.downloadLogsModal.show();
    });
    this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('exportLogs', this.status);
  },

  methods: {
    verifyDateRange: function verifyDateRange() {
      var startDate = (0, _moment2.default)(this.dateRange[0]);
      var endDate = (0, _moment2.default)(this.dateRange[1]);
      var difference = endDate.diff(startDate, 'days');
      if (difference > 31) {
        this.verifyDays = true;
      } else {
        this.verifyDays = false;
      }
    },
    hidedownloadLogsModal: function hidedownloadLogsModal() {
      this.$refs.downloadLogsModal.hide();
    },
    setFilter: function setFilter(filter) {
      this.filter = filter;
    },
    infiniteHandler: function infiniteHandler($state) {
      var _this2 = this;

      var params = {
        last_log_id: this.lastLogId
      };
      _vue2.default.axios.get('activity_logs', { headers: { Authorization: 'Bearer ' + this.idToken }, params: params }).then(function (res) {
        var logs = res.data;
        if (logs.length > 0) {
          _this2.trailsData = _this2.trailsData.slice().concat(logs);
          _this2.lastLogId = logs[logs.length - 1]['id'];
          _this2.distance = 100;
          _this2.logsLoaded = true;
          _this2.sortBy = 'id';
          _this2.sortDesc = true;
          $state.loaded();
        } else {
          _this2.distance = 100;
          _this2.logsLoaded = true;
          $state.complete();
        }
      }).catch(function (error) {
        console.log(error);
        if (error.status === 401) {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this2.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    download_logs: function download_logs() {
      var _this3 = this;

      var payload = {
        startDate: (0, _moment2.default)(this.dateRange[0]).format('YYYY-MM-DD'),
        endDate: (0, _moment2.default)(this.dateRange[1]).format('YYYY-MM-DD')
      };
      _vue2.default.axios.post('activity_logs/download', payload, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        var csvData = res.data;
        var mimeType = 'text/plain';
        var blob = new window.Blob([csvData], { type: mimeType });

        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'logs_' + (0, _moment2.default)().format() + '.csv';
        document.body.appendChild(link);
        link.click();
        _this3.$refs.downloadLogsModal.hide();
        link.remove();
      }).catch(function (error) {
        console.log(error);
        if (error.status === 401) {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    }
  }
};

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vuex = __webpack_require__(5);

var _featureFlagService = __webpack_require__(1204);

var _TableLoading = __webpack_require__(1205);

var _TableLoading2 = _interopRequireDefault(_TableLoading);

var _vueMultiselect = __webpack_require__(36);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _Switch = __webpack_require__(70);

var _Switch2 = _interopRequireDefault(_Switch);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _FeaturesSearchBar = __webpack_require__(1208);

var _FeaturesSearchBar2 = _interopRequireDefault(_FeaturesSearchBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  components: {
    TableLoading: _TableLoading2.default,
    Multiselect: _vueMultiselect2.default,
    SearchBar: _FeaturesSearchBar2.default,
    cSwitch: _Switch2.default
  },
  data: function data() {
    return {
      featureFlag: {
        isLoading: false,
        isError: false,
        data: []
      },
      sortBy: 'id',
      sortDesc: false,
      searchName: '',
      description: '',
      account: '',
      searchLastEditedby: [],
      searchIsEnabled: {
        enabled: false,
        value: undefined
      },
      filter: null,
      editedOptions: [],
      editedByValue: [],
      tableFields: [{ key: 'id', sortable: true }, { key: 'name', label: 'Name', sortable: false }, { key: 'description', label: 'description', sortable: false }, { key: 'account_name', label: 'account_name', sortable: false }, { key: 'last_edited_by', label: 'Last Edited By', sortable: false }, { key: 'is_enabled', label: 'Status', sortable: false }]
    };
  },
  created: function created() {
    this.getFeatureFlagData();
  },

  computed: _extends({
    filteredFeatureFlags: function filteredFeatureFlags() {
      var _this = this;

      if (this.featureFlag.data.length) {
        var filteredFlags = this.featureFlag.data;
        if (this.searchName.length) {
          filteredFlags = filteredFlags.filter(function (flag) {
            return flag.name.toLowerCase().includes(_this.searchName.toLowerCase());
          });
        }
        if (this.description.length) {
          filteredFlags = filteredFlags.filter(function (flag) {
            return (flag.description ? flag.description.toLowerCase() : '').includes(_this.description.toLowerCase());
          });
        }
        if (this.account.length) {
          filteredFlags = filteredFlags.filter(function (flag) {
            return flag.account_name.toLowerCase().includes(_this.account.toLowerCase());
          });
        }
        if (this.editedByValue.length) {
          var tempFilteredFlags = [];
          filteredFlags.forEach(function (element) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = _this.editedByValue[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var selectedEditedOption = _step.value;

                if (selectedEditedOption.title === element.last_edited_by) {
                  tempFilteredFlags.push(element);
                  break;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          });
          filteredFlags = tempFilteredFlags;
        }
        if (this.searchIsEnabled.value !== undefined) {
          var tempSearchIsEnabled = this.searchIsEnabled.value === 'true';
          filteredFlags = filteredFlags.filter(function (flag) {
            return flag.is_enabled === tempSearchIsEnabled;
          });
        }
        return filteredFlags;
      }
      return [];
    },
    sortedFeatureFlags: function sortedFeatureFlags() {
      return this.filteredFeatureFlags.sort(function (a, b) {
        return a.id - b.id;
      });
    }
  }, (0, _vuex.mapGetters)(['idToken'])),
  methods: {
    setFilter: function setFilter(filter) {
      this.filter = filter;
    },
    editByUserName: function editByUserName(value) {
      this.editedByValue = value;
    },
    getFeatureFlagData: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var tempEditedByOptions;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                this.featureFlag.isLoading = true;
                _context.next = 4;
                return (0, _featureFlagService.getAllFeatureFlags)(this.idToken);

              case 4:
                this.featureFlag.data = _context.sent;
                tempEditedByOptions = new Set();

                this.featureFlag.data.forEach(function (element) {
                  tempEditedByOptions.add(element.last_edited_by || '-');
                });
                Array.from(tempEditedByOptions).forEach(function (element) {
                  _this2.editedOptions.push({ title: element });
                });
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](0);

                this.featureFlag.isError = true;

              case 13:
                _context.prev = 13;

                this.featureFlag.isLoading = false;
                return _context.finish(13);

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10, 13, 16]]);
      }));

      function getFeatureFlagData() {
        return _ref.apply(this, arguments);
      }

      return getFeatureFlagData;
    }(),
    updateIndividualFeatureFlag: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(event, selectedFeatureFlag) {
        var respData, updatedFeatureFlag;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                selectedFeatureFlag.is_enabled = event;
                _context2.prev = 1;
                _context2.next = 4;
                return (0, _featureFlagService.updateFeatureFlag)(this.idToken, selectedFeatureFlag);

              case 4:
                respData = _context2.sent;
                updatedFeatureFlag = respData.feature_flag;

                this.featureFlag.data.map(function (featureData) {
                  return featureData.id === updatedFeatureFlag.id ? updatedFeatureFlag : featureData;
                });
                _vue2.default.toasted.show(updatedFeatureFlag.name + ' is ' + (updatedFeatureFlag.is_enabled ? 'Disabled' : 'Enabled'), { type: 'success' });
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](1);

                this.featureFlag.isError = true;
                _vue2.default.toasted.show('Error Please Try Again', { type: 'error' });

              case 14:
                _context2.prev = 14;
                return _context2.finish(14);

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 10, 14, 16]]);
      }));

      function updateIndividualFeatureFlag(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return updateIndividualFeatureFlag;
    }(),
    customLabel: function customLabel(_ref3) {
      var title = _ref3.title;

      return '' + title;
    },
    isSelected: function isSelected(currentTitle) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.editedByValue[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var element = _step2.value;

          if (element.title === currentTitle) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return false;
    }
  }
};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svg = __webpack_require__(28);

var _svg2 = _interopRequireDefault(_svg);

var _vueMultiselect = __webpack_require__(36);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    Multiselect: _vueMultiselect2.default
  },
  data: function data() {
    return {
      svg: _svg2.default,
      showClear: false,
      selectedEditedBy: []
    };
  },

  props: {
    title: String,
    editedByValue: Array,
    editedOptions: Array
  },
  methods: {
    emitInput: function emitInput(input) {
      this.$emit('filterInput', input);
      if (input !== '') this.showClear = true;else this.showClear = false;
    },
    optionAdded: function optionAdded(input) {
      this.selectedEditedBy = [].concat(_toConsumableArray(this.editedByValue), [input]);
      this.$emit('update:editByValue', this.selectedEditedBy);
    },
    optionRemoved: function optionRemoved(input) {
      this.selectedEditedBy = this.selectedEditedBy.filter(function (value) {
        return value.title !== input.title;
      });
      this.$emit('update:editByValue', this.selectedEditedBy);
    },
    clearFilter: function clearFilter() {
      this.$refs.searchInput.$el.value = '';
      this.emitInput('');
      this.showClear = false;
    },
    customLabel: function customLabel(_ref) {
      var title = _ref.title;

      return '' + title;
    },
    isSelected: function isSelected(currentTitle) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.editedByValue[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var element = _step.value;

          if (element.title === currentTitle) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    }
  }
};

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svg = __webpack_require__(28);

var _svg2 = _interopRequireDefault(_svg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Page404',
  data: function data() {
    return {
      svg: _svg2.default
    };
  }
}; //
//
//
//
//
//

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _UsersSearchBar = __webpack_require__(1217);

var _UsersSearchBar2 = _interopRequireDefault(_UsersSearchBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      usersLoaded: false,
      tableFields: [{ key: 'id', sortable: true }, { key: 'username', sortable: true, label: 'COMMON.NAME' }, { key: 'email', sortable: true, label: 'Email' }, { key: 'account_name', sortable: true, label: 'COMMON.ACCOUNT' }, { key: 'role', sortable: true, label: 'USERS.ROLE' },
      // { key: 'team', sortable: false, label: 'TEAMS.TEAM' },
      { key: 'edit_link', sortable: false, label: 'COMMON.ACTIONS' }],
      accounts: [],
      roles: [],
      users: [],
      filter: null,
      selected_user: null
    };
  },

  components: {
    UsersSearchBar: _UsersSearchBar2.default
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'isAdmin', 'isAdminRole', 'isSuperAdmin', 'accountId', 'currentUserId']), {
    tempHide: function tempHide() {
      return false;
    }
  }),
  created: function created() {
    var _this = this;

    if (this.isSuperAdmin) {
      _vue2.default.axios.get('/admin/accounts/', {
        headers: { Authorization: 'Bearer ' + this.idToken }
      }).then(function (res) {
        _this.accounts = [{ text: 'All', value: -1 }].concat(res.data.accounts.map(function (account) {
          return { text: account.name, value: account.id };
        }));
        _this.roles = [{ text: 'Admin', value: 2 }, { 'text': 'Super Admin', value: 1 }];
      });
    } else if (this.isAdmin) {
      this.getRolesByAccount(this.accountId);
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var _this2 = this;

    next(function (vm) {
      if (vm.isAdminRole) {
        var accountId = -1;
        var roleId = vm.isSuperAdmin ? 2 : -1;
        _vue2.default.axios.get('/admin/users/users_by_roles?role_id=' + roleId + '&account_id=' + accountId, {
          headers: {
            Authorization: 'Bearer ' + vm.idToken,
            'Cache-Control': 'no-cache, no-store',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        }).then(function (res) {
          vm.users = res.data.users;
          vm.usersLoaded = true;
          next();
        }).catch(function (error) {
          if (error.status === 401) {
            _vue2.default.toasted.show(vm.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
            console.log(_this2.$t('COMMON.MSG_EXPIRED'));
          } else {
            _vue2.default.toasted.show(vm.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
            next(false);
          }
        });
      } else {
        _router2.default.replace('/Not-Found-404');
      }
    });
  },

  methods: {
    setFilter: function setFilter(filter) {
      this.filter = filter;
    },
    filterByAccount: function filterByAccount(accountId, roleId) {
      if (accountId === -1) {
        this.roles = [{ text: 'Admin', value: 2 }, { 'text': 'Super Admin', value: 1 }];
      } else {
        this.getRolesByAccount(accountId);
      }
      this.fetchUsers(accountId, roleId);
    },
    filterByRole: function filterByRole(accountId, roleId) {
      this.fetchUsers(accountId, roleId);
    },
    getRolesByAccount: function getRolesByAccount(accountId) {
      var _this3 = this;

      _vue2.default.axios.get('/admin/users/' + accountId + '/account_roles/', {
        headers: {
          Authorization: 'Bearer ' + this.idToken,
          'Cache-Control': 'no-cache, no-store',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      }).then(function (res) {
        _this3.roles = [{ text: 'All', value: -1 }].concat(res.data.roles.map(function (role) {
          return { text: _this3.$options.filters.titlize(role.name), value: role.id };
        }));
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this3.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    fetchUsers: function fetchUsers(accountId, roleId) {
      var _this4 = this;

      this.usersLoaded = false;
      this.filter = '';
      _vue2.default.axios.get('/admin/users/users_by_roles?role_id=' + roleId + '&account_id=' + accountId, {
        headers: {
          Authorization: 'Bearer ' + this.idToken,
          'Cache-Control': 'no-cache, no-store',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      }).then(function (res) {
        _this4.users = res.data.users;
        _this4.usersLoaded = true;
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this4.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this4.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    confirmDeleteUser: function confirmDeleteUser(data) {
      this.selected_user = data.item.id;
      this.$refs.deleteUserModal.show();
    },
    cancelDelete: function cancelDelete() {
      this.selected_user = null;
    },
    deleteUser: function deleteUser() {
      var _this5 = this;

      if (this.selected_user) {
        _vue2.default.axios.delete('/admin/users/' + this.selected_user, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
          if (res.data.success) {
            _this5.users = _this5.users.filter(function (user) {
              return user.id !== res.data.id;
            });
            _vue2.default.toasted.show(res.data.msg);
          } else {
            _vue2.default.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' });
          }
        }).catch(function (error) {
          if (error.status === 401) {
            _vue2.default.toasted.show(_this5.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
            console.log(_this5.$t('COMMON.MSG_EXPIRED'));
          } else {
            _vue2.default.toasted.show(_this5.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      }
    },
    deactivateUser: function deactivateUser(userId) {
      var _this6 = this;

      _vue2.default.axios.post('/admin/users/' + userId + '/deactivate', {}, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.data.success) {
          _this6.users = _this6.users.map(function (user) {
            if (user.id === userId) {
              user['status'] = 'INACTIVE';
            }
            return user;
          });
          _vue2.default.toasted.show(res.data.msg);
        } else {
          _vue2.default.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this6.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this6.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this6.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    unblockUser: function unblockUser(userId) {
      var _this7 = this;

      _vue2.default.axios.post('/admin/users/' + userId + '/unblock', {}, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.data.success) {
          _this7.users = _this7.users.map(function (user) {
            if (user.id === userId) {
              user['is_blocked'] = false;
            }
            return user;
          });
          _vue2.default.toasted.show(res.data.msg);
        } else {
          _vue2.default.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this7.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          _router2.default.replace('/sign_in');
        } else {
          _vue2.default.toasted.show(_this7.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    checkAdmin: function checkAdmin(data) {
      return data.role !== 'Super Admin' || this.isSuperAdmin;
    }
  }
};

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _svg = __webpack_require__(28);

var _svg2 = _interopRequireDefault(_svg);

var _vuex = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      selectedRole: null,
      selectedAccount: null,
      svg: _svg2.default,
      showClear: false
    };
  },

  props: {
    title: String,
    roles: Array,
    accounts: Array
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['isAdmin', 'isSuperAdmin', 'accountId'])),
  created: function created() {
    if (this.isSuperAdmin) {
      this.selectedAccount = -1;
      this.selectedRole = 2;
    } else if (this.isAdmin) {
      this.selectedAccount = this.accountId;
      this.selectedRole = -1;
    }
  },

  methods: {
    filterByRole: function filterByRole() {
      this.$emit('filterByRole', this.selectedAccount, this.selectedRole);
    },
    filterByAccount: function filterByAccount() {
      this.selectedRole = this.selectedAccount === -1 ? 2 : -1;
      this.$emit('filterByAccount', this.selectedAccount, this.selectedRole);
    },
    emitInput: function emitInput(input) {
      this.$emit('filterInput', input);
      if (input !== '') this.showClear = true;else this.showClear = false;
    },
    clearFilter: function clearFilter() {
      this.$refs.searchInput.$el.value = '';
      this.emitInput('');
      this.showClear = false;
    }
  }
};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _vuex = __webpack_require__(5);

var _userForm = __webpack_require__(495);

var _userForm2 = _interopRequireDefault(_userForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    'user-form': _userForm2.default
  },
  data: function data() {
    return {
      user: {
        username: '',
        email: '',
        password: null,
        repeat_password: null,
        role_id: '',
        account_id: '',
        notify: false,
        team_id: ''
      },
      roles: [],
      accounts: [],
      teams: []
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'isSuperAdmin', 'isAdminRole', 'isAdmin'])),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var _this = this;

    next(function (vm) {
      if (vm.isAdminRole) {
        _vue2.default.axios.get('/admin/users/accounts_and_roles', { headers: { Authorization: 'Bearer ' + vm.idToken } }).then(function (res) {
          vm.roles = res.data.roles;
          vm.accounts = res.data.accounts;
          vm.teams = res.data.teams;
          next();
        }).catch(function (error) {
          if (error.status === 401) {
            _vue2.default.toasted.show(vm.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
            console.log(_this.$t('COMMON.MSG_EXPIRED'));
          } else {
            _vue2.default.toasted.show(vm.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
            next(false);
          }
        });
      } else {
        _router2.default.replace('/Not-Found-404');
      }
    });
  },

  methods: {
    createUser: function createUser() {
      var _this2 = this;

      var data = new window.FormData();
      var domain = window.location.origin;
      data.append('username', this.user.username);
      data.append('email', this.user.email);
      data.append('password', this.user.password);
      data.append('role_id', this.user.role_id);
      data.append('account_id', this.user.account_id);
      data.append('notify', this.user.notify);
      data.append('domain', domain);
      data.append('team_id', this.user.team_id);
      _vue2.default.axios.post('/admin/users', data, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.data.error) {
          _vue2.default.toasted.show(res.data.error, { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_USER_CREATE'));
          _router2.default.push('/admin/users');
        }
      }).catch(function (error) {
        _vue2.default.toasted.show(_this2.$t('COMMON.MSG_SIGNUP_FAIL'), { icon: 'chain-broken', type: 'error' });
        console.log(error);
      });
    },
    resetForm: function resetForm() {
      this.user.username = '';
      this.user.email = '';
      this.user.password = null;
      this.user.repeat_password = null;
      this.user.role_id = '';
      this.user.notify = false;
      this.user.account_id = '';
      this.user.team_id = '';
    }
  }
};

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userForm_vue__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userForm_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userForm_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userForm_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19933a20_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userForm_vue__ = __webpack_require__(1224);
function injectStyle (ssrContext) {
  __webpack_require__(1223)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19933a20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userForm_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19933a20_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validators = __webpack_require__(32);

var _Switch = __webpack_require__(70);

var _Switch2 = _interopRequireDefault(_Switch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ['user', 'roles', 'teams', 'accounts', 'isSuperAdmin', 'isAdmin', 'editUser'],
  computed: {
    passwordRequired: function passwordRequired() {
      return !this.editUser;
    }
  },
  components: {
    'c-switch': _Switch2.default
  },
  validations: {
    user: {
      email: {
        required: _validators.required,
        email: _validators.email
      },
      username: {
        required: _validators.required,
        alphaNum: _validators.alphaNum,
        minLen: (0, _validators.minLength)(5)
      },
      // password: {
      //   required: requiredIf(function () { return !this.editUser }),
      //   minLen: minLength(8)
      // },
      // repeat_password: {
      //   required: requiredIf(function () { return !this.editUser }),
      //   sameAs: sameAs(vm => { return vm.password })
      // },
      role_id: {
        required: _validators.required
      },
      account_id: {
        required: (0, _validators.requiredIf)(function () {
          return this.isSuperAdmin;
        })
      }
    }
  },
  methods: {
    pSwitchChanged: function pSwitchChanged() {
      this.user.notify = !this.user.notify;
    },

    formSubmit: function formSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit('formSubmit', this.user);
      }
    },
    resetForm: function resetForm() {
      this.$emit('formReset');
    },
    cancelForm: function cancelForm() {
      this.$emit('cancelForm');
    }
  }
};

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _vuex = __webpack_require__(5);

var _userForm = __webpack_require__(495);

var _userForm2 = _interopRequireDefault(_userForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    'user-form': _userForm2.default
  },
  data: function data() {
    return {
      user: {
        id: '',
        username: '',
        email: '',
        password: null,
        repeat_password: null,
        role_id: null,
        account_id: '',
        team_id: ''
      },
      roles: [],
      accounts: [],
      teams: []
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'isSuperAdmin', 'isAdminRole', 'isAdmin'])),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var _this = this;

    next(function (vm) {
      if (vm.isAdminRole) {
        _vue2.default.axios.get('/admin/users/' + vm.$route.params.id, { headers: { Authorization: 'Bearer ' + vm.idToken } }).then(function (res) {
          var user = res.data.user;
          vm.user.id = user.id;
          vm.user.username = user.username;
          vm.user.email = user.email;
          vm.user.role_id = user.role_id;
          vm.user.team_id = user.team_id;
          if (vm.user.role_id === 2 && vm.isAdmin) {
            _vue2.default.toasted.show(vm.$t('COMMON.MSG_EDIT_N_A'), { type: 'error' });
            next(false);
            _router2.default.push('/admin/users');
          }
          vm.user.account_id = user.account_id;
          vm.roles = user.roles;
          vm.accounts = user.accounts;
          vm.teams = user.teams;
          next();
        }).catch(function (error) {
          if (error.status === 401) {
            _vue2.default.toasted.show(vm.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
            console.log(_this.$t('COMMON.MSG_EXPIRED'));
          } else {
            _vue2.default.toasted.show(vm.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
            next(false);
          }
        });
      } else {
        _router2.default.replace('/Not-Found-404');
      }
    });
  },

  methods: {
    updateUser: function updateUser() {
      var _this2 = this;

      var data = new window.FormData();
      data.append('username', this.user.username);
      data.append('email', this.user.email);
      data.append('role_id', this.user.role_id);
      data.append('account_id', this.user.account_id);
      data.append('team_id', this.user.team_id);
      if (this.user.password) {
        data.append('password', this.user.password);
      }

      _vue2.default.axios.patch('/admin/users/' + this.user.id, data, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.data.error) {
          _vue2.default.toasted.show(res.data.error, { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_USER_UPDATE'));
          _router2.default.push('/admin/users');
        }
      }).catch(function (error) {
        _vue2.default.toasted.show(_this2.$t('COMMON.MSG_SIGNUP_FAIL'), { icon: 'chain-broken', type: 'error' });
        console.log(error);
      });
    },
    cancelForm: function cancelForm() {
      _router2.default.push('/admin/users');
    }
  }
};

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import teams from '@/components/settings/teams'

// import ortfMap from '@/components/settings/ortfMap'
// import hl7Map from '../../components/settings/hl7Map.vue'


var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _confidenceColors = __webpack_require__(1231);

var _confidenceColors2 = _interopRequireDefault(_confidenceColors);

var _processOrder = __webpack_require__(1242);

var _processOrder2 = _interopRequireDefault(_processOrder);

var _roleOrder = __webpack_require__(1247);

var _roleOrder2 = _interopRequireDefault(_roleOrder);

var _processType = __webpack_require__(1251);

var _processType2 = _interopRequireDefault(_processType);

var _externalServiceMaps = __webpack_require__(1255);

var _externalServiceMaps2 = _interopRequireDefault(_externalServiceMaps);

var _externalServiceValidations = __webpack_require__(1258);

var _externalServiceValidations2 = _interopRequireDefault(_externalServiceValidations);

var _manageFields = __webpack_require__(1261);

var _manageFields2 = _interopRequireDefault(_manageFields);

var _autoCorrect = __webpack_require__(1264);

var _autoCorrect2 = _interopRequireDefault(_autoCorrect);

var _authConfig = __webpack_require__(1267);

var _authConfig2 = _interopRequireDefault(_authConfig);

var _localTime = __webpack_require__(1270);

var _localTime2 = _interopRequireDefault(_localTime);

var _autoProcessing = __webpack_require__(1273);

var _autoProcessing2 = _interopRequireDefault(_autoProcessing);

var _docRetention = __webpack_require__(1276);

var _docRetention2 = _interopRequireDefault(_docRetention);

var _docEscalationTime = __webpack_require__(1279);

var _docEscalationTime2 = _interopRequireDefault(_docEscalationTime);

var _customValidations = __webpack_require__(1283);

var _customValidations2 = _interopRequireDefault(_customValidations);

var _apiResponseJsonFormatter = __webpack_require__(1286);

var _apiResponseJsonFormatter2 = _interopRequireDefault(_apiResponseJsonFormatter);

var _brands = __webpack_require__(1306);

var _brands2 = _interopRequireDefault(_brands);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      local_time: null,
      is_auto_processing: false,
      retentionTime: null,
      escalationTime: null,
      retentionDaysCount: 0,
      escalationDaysCount: 0
    };
  },

  components: {
    'confidence-colors': _confidenceColors2.default,
    'process-order': _processOrder2.default,
    'role-order': _roleOrder2.default,
    'process-type': _processType2.default,
    // 'teams': teams,
    'external-service-maps': _externalServiceMaps2.default,
    'external-service-validations': _externalServiceValidations2.default,
    'manageFields': _manageFields2.default,
    'authConfig': _authConfig2.default,
    // 'ortfMap': ortfMap,
    // 'hl7Map': hl7Map,
    'autoCorrect': _autoCorrect2.default,
    'local-time': _localTime2.default,
    'auto-processing': _autoProcessing2.default,
    'docRetention': _docRetention2.default,
    'doc-escalation-time': _docEscalationTime2.default,
    'custom-validations': _customValidations2.default,
    'api-response-json-formatter': _apiResponseJsonFormatter2.default,
    'brands': _brands2.default
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['isAdmin', 'isAdminRole', 'idToken'])),
  created: function created() {
    var _this = this;

    _vue2.default.axios.get('/admin/accounts/settings_config', { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
      _this.local_time = res.data.local_time;
      _this.is_auto_processing = res.data.is_auto_processing;
      _this.retentionTime = res.data.doc_retention_period;
      if (_this.retentionTime.includes('day') || _this.retentionTime.includes('days')) {
        _this.retentionDaysCount = _this.retentionTime.split(' ')[0];
      }
      _this.escalationTime = res.data.doc_escaltion_time;
      if (_this.escalationTime.includes('day') || _this.escalationTime.includes('days')) {
        _this.escalationDaysCount = _this.escalationTime.split(' ')[0];
      }
    }).catch(function (error) {
      if (error.status === 401) {
        console.log(_this.$t('COMMON.MSG_EXPIRED'));
      } else {
        _vue2.default.toasted.show(_this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
      }
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.isAdminRole) {
        next();
      } else {
        _router2.default.replace('/Not-Found-404');
      }
    });
  }
};

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _range = __webpack_require__(1234);

var _range2 = _interopRequireDefault(_range);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      rangeColors: null,
      originalColors: null,
      fields: [{ key: 'color_code' }]
    };
  },

  components: {
    range: _range2.default
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'selectedRolesData', 'isAdminRole'])),
  created: function created() {
    var _this = this;

    var vm = this;
    _vue2.default.axios.get('/settings/confidence_colors', { headers: { Authorization: 'Bearer ' + vm.idToken } }).then(function (res) {
      vm.rangeColors = res.data.colors.map(function (color) {
        return Object.assign({}, color);
      });
      vm.originalColors = res.data.colors.map(function (color) {
        return Object.assign({}, color);
      });
    }).catch(function (error) {
      if (error.status === 401) {
        _vue2.default.toasted.show(_this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        console.log(_this.$t('COMMON.MSG_EXPIRED'));
      } else {
        _vue2.default.toasted.show(_this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
      }
    });
  },

  methods: {
    resetColors: function resetColors() {
      this.rangeColors = this.originalColors.map(function (color) {
        return Object.assign({}, color);
      });
    },
    updateColors: function updateColors() {
      var _this2 = this;

      var formData = new window.FormData();
      formData.append('confidence_colors', JSON.stringify(this.rangeColors));
      _vue2.default.axios.post('/settings/confidence_colors/batch_update', formData, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        _vue2.default.toasted.show(_this2.$t('CONFIGURED.CC_SUCCESS'));
      }, function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this2.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
        console.log(error);
      });
      this.originalColors = this.rangeColors.map(function (color) {
        return Object.assign({}, color);
      });
    }
  }
};

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ColorPicker = __webpack_require__(1236);

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    start: Number,
    end: Number,
    color: String
  },
  data: function data() {
    return {
      dataColor: this.color
    };
  },

  components: {
    ColorPicker: _ColorPicker2.default
  },
  watch: {
    color: function color() {
      this.dataColor = this.color;
    }
  },
  methods: {
    setColor: function setColor(color) {
      this.dataColor = color;
      this.$emit('colorSelected', this.dataColor);
    },
    focusPicker: function focusPicker() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs.colorpicker.$el.focus();
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = __webpack_require__(1238);

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      colors: _colors2.default.colors
    };
  },

  methods: {
    emitColor: function emitColor(color) {
      this.$emit('colorSelected', color);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _vuedraggable = __webpack_require__(192);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      processingOrders: []
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['idToken'])),
  components: {
    draggable: _vuedraggable2.default
  },
  created: function created() {
    var _this = this;

    var vm = this;
    _vue2.default.axios.get('/settings/processing_orders', { headers: { Authorization: 'Bearer ' + vm.idToken } }).then(function (res) {
      vm.processingOrders = res.data.orders;
    }).catch(function (error) {
      if (error.status === 401) {
        console.log(_this.$t('COMMON.MSG_EXPIRED'));
      } else {
        _vue2.default.toasted.show(_this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
      }
    });
  },

  methods: {
    updateOrder: function updateOrder() {
      var _this2 = this;

      var formData = new window.FormData();
      formData.append('processing_orders', JSON.stringify(this.processingOrders));
      _vue2.default.axios.post('/settings/processing_orders/batch_update', formData, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        _vue2.default.toasted.show(_this2.$t('CONFIGURED.PROCESS_ORDER_SUCCESS'));
      }).catch(function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this2.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
        console.log(error);
      });
    },
    getName: function getName(name) {
      if (name === 'Barcode') {
        return this.$t('PROCESS_ROLES.BARCODE');
      } else if (name === 'Image Match') {
        return this.$t('PROCESS_ROLES.IMAGE_MATCH');
      } else if (name === 'Force Template') {
        return this.$t('PROCESS_ROLES.FORCE_TEMPLATE');
      } else if (name === 'Plain Text') {
        return this.$t('PROCESS_ROLES.PLAIN_TEXT');
      } else {
        return name;
      }
    }
  }
};

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _vuedraggable = __webpack_require__(192);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

var _validators = __webpack_require__(32);

var _lodash = __webpack_require__(45);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      selectedRoles: [],
      selectedRole: '',
      newRoleName: ''
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['idToken'])),
  components: {
    draggable: _vuedraggable2.default
  },
  created: function created() {
    this.selectedRoles = this.$store.state.selectedRoles;
  },

  methods: {
    clearRoleModal: function clearRoleModal() {
      var _this = this;

      this.newRoleName = '';
      this.$nextTick(function () {
        _this.$v.$reset();
      });
    },
    hideCreateRoleModal: function hideCreateRoleModal() {
      this.newRoleName = '';
      this.$refs.newRoleModal.hide();
    },
    setEditRole: function setEditRole(role) {
      this.selectedRole = role;
      this.newRoleName = this.$options.filters.titlize(role['name']);
    },
    hideEditRoleModal: function hideEditRoleModal() {
      this.selectedRole = '';
      this.newRoleName = '';
      this.$refs.editRoleModal.hide();
    },
    setDeleteRole: function setDeleteRole(role) {
      this.selectedRole = role;
    },
    hideDeleteRoleModal: function hideDeleteRoleModal() {
      this.selectedRole = '';
      this.$refs.deleteRoleModal.hide();
    },
    updateRoleOrder: function updateRoleOrder() {
      var _this2 = this;

      var formData = new window.FormData();
      formData.append('selected_roles', JSON.stringify(this.selectedRoles));
      _vue2.default.axios.post('/settings/account_roles/update_roles', formData, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        _vue2.default.toasted.show(_this2.$t('CONFIGURED.ROLE_SUCCESS'));
        _this2.updateRoleAndOrder(response.data.selected_roles, response.data.user_role_order);
      }, function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this2.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    createRole: function createRole() {
      var _this3 = this;

      if (this.newRoleName.trim() === '') {
        this.$v.$touch();
      } else if (!this.$v.$invalid) {
        var updateData = new window.FormData();
        updateData.append('role', this.newRoleName);
        _vue2.default.axios.post('/settings/account_roles/create_role', updateData, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
          _this3.updateRoleAndOrder(response.data.selected_roles, response.data.user_role_order);
          _vue2.default.toasted.show(_this3.newRoleName + _this3.$t('CONFIGURED.ROLE_CREATED'));
          _this3.hideCreateRoleModal();
        }, function (error) {
          if (error.status === 401) {
            _vue2.default.toasted.show(_this3.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
            console.log(_this3.$t('COMMON.MSG_EXPIRED'));
          } else if (error.status === 400) {
            _vue2.default.toasted.show(error.data.message, { icon: 'chain-broken', type: 'error' });
          } else {
            _vue2.default.toasted.show(_this3.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      }
    },
    editRole: function editRole() {
      var _this4 = this;

      var updateData = new window.FormData();
      updateData.append('new_role_name', this.newRoleName);
      updateData.append('role', JSON.stringify(this.selectedRole));
      _vue2.default.axios.post('/settings/account_roles/edit_role', updateData, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        if (response.data.success) {
          _this4.updateRoleAndOrder(response.data.selected_roles, response.data.user_role_order);
          _vue2.default.toasted.show(_this4.selectedRole.name + ' is changed to ' + _this4.newRoleName);
          _this4.hideEditRoleModal();
        } else {
          _vue2.default.toasted.show(response.data.msg, { icon: 'chain-broken', type: 'error' });
        }
      }, function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this4.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this4.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this4.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    deleteRole: function deleteRole() {
      var _this5 = this;

      var updateData = new window.FormData();
      updateData.append('role', JSON.stringify(this.selectedRole));
      _vue2.default.axios.post('/settings/account_roles/delete_role', updateData, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        if (response.data.success) {
          _this5.updateRoleAndOrder(response.data.selected_roles, response.data.user_role_order);
          _vue2.default.toasted.show(_this5.selectedRole.name + ' is deleted');
          _this5.hideDeleteRoleModal();
        } else {
          _vue2.default.toasted.show(response.data.msg, { icon: 'chain-broken', type: 'error' });
        }
      }, function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this5.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this5.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this5.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    updateRoleAndOrder: function updateRoleAndOrder(selectedRoles, userRoleOrder) {
      this.selectedRoles = selectedRoles;
      this.$store.commit('setSelectedRoles', selectedRoles);
      this.$store.commit('setUserRoleOrder', userRoleOrder);
      window.localStorage.setItem('userRoleOrder', userRoleOrder);
      window.localStorage.setItem('selectedRoles', JSON.stringify(selectedRoles));
    }
  },
  validations: {
    newRoleName: {
      required: _validators.required,
      maxLength: (0, _validators.maxLength)(15),
      minLength: (0, _validators.minLength)(3),
      valid: function valid(value) {
        var regexExp = /^[a-zA-Z0-9 _-]*$/.test(value);
        return regexExp;
      },
      isUnique: function isUnique(value, vm) {
        value = value.trim().replace(/\s+/g, ' ').toLowerCase();
        if (!value || this.selectedRole.name === value) return true;
        return new Promise(function (resolve, reject) {
          setTimeout(function () {
            var selectedRoles = vm.selectedRoles.slice().concat({ 'name': 'admin' }, { 'name': 'super admin' });
            resolve(!_lodash2.default.some(selectedRoles, { 'name': value }));
          }, 350 + Math.random() * 300);
        });
      }
    }
  }
};

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      accountCategories: [],
      unsubscribedCategories: [{ text: 'Select a process type', value: null }],
      selectedCategory: null
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'isSuperAdmin'])),
  created: function created() {
    this.fetchCategories();
  },

  methods: {
    fetchCategories: function fetchCategories() {
      var _this = this;

      _vue2.default.axios.get('/settings/process_types/account_categories', { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this.accountCategories = res.data.account_categories;
        _this.unsubscribedCategories = _this.unsubscribedCategories.concat(res.data.unsubscribed_categories.map(function (category) {
          return { text: category, value: category };
        }));
      }).catch(function (error) {
        if (error.status === 401) {
          console.log(_this.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    handleSubscribeModal: function handleSubscribeModal() {
      this.$refs.subscribeModal.show();
    },
    handleUnsubscribeModal: function handleUnsubscribeModal(category) {
      this.selectedCategory = category;
      this.$refs.unsubscribeModal.show();
    },
    hideSubscribeModal: function hideSubscribeModal() {
      this.selectedCategory = null;
      this.$refs.subscribeModal.hide();
    },
    hideUnSubscribeModal: function hideUnSubscribeModal() {
      this.selectedCategory = null;
      this.$refs.unsubscribeModal.hide();
    },
    subscribeNewCategory: function subscribeNewCategory(event) {
      var _this2 = this;

      event.preventDefault();
      if (this.selectedCategory) {
        var payload = { category: this.selectedCategory };
        _vue2.default.axios.post('/settings/process_types/subscribe', payload, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
          _this2.hideSubscribeModal();
          if (res.data.success) {
            var subscribedCategory = res.data.category;
            _this2.accountCategories = _this2.accountCategories.slice().concat([subscribedCategory]);
            _this2.unsubscribedCategories = _this2.unsubscribedCategories.filter(function (category) {
              return category.value !== subscribedCategory;
            });
            _vue2.default.toasted.show(_this2.$t('CONFIGURED.SUBSCRIBE_PT'));
          } else {
            _vue2.default.toasted.show(_this2.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        }).catch(function (error) {
          _this2.hideSubscribeModal();
          if (error.status === 401) {
            _vue2.default.toasted.show(_this2.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          } else {
            _vue2.default.toasted.show(_this2.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      }
    },
    unsubscribeCategory: function unsubscribeCategory(event) {
      var _this3 = this;

      event.preventDefault();
      if (this.selectedCategory) {
        var payload = { category: this.selectedCategory };
        _vue2.default.axios.post('/settings/process_types/unsubscribe', payload, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
          _this3.hideUnSubscribeModal();
          if (res.data.success) {
            var unsubscribedCategory = res.data.category;
            _this3.accountCategories = _this3.accountCategories.slice().filter(function (category) {
              return category !== unsubscribedCategory;
            });
            _this3.unsubscribedCategories = _this3.unsubscribedCategories.slice().concat([{ text: unsubscribedCategory, value: unsubscribedCategory }]);
            _vue2.default.toasted.show(_this3.$t('CONFIGURED.UNSUBSCRIBE_PT'));
          } else {
            _vue2.default.toasted.show(_this3.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        }).catch(function (error) {
          _this3.hideUnSubscribeModal();
          if (error.status === 401) {
            _vue2.default.toasted.show(_this3.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          } else {
            _vue2.default.toasted.show(_this3.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      }
    }
  }
};

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _vuedraggable = __webpack_require__(192);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

var _vueSearchSelect = __webpack_require__(193);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      demoMode: true,
      externalServiceMaps: [],
      availableTemplateDocs: [],
      availableTemplates: [],
      availableTemplateVersions: [],
      selectedTemplate: null,
      selectedTemplateVersion: null,
      text: '',
      file: '',
      isFileSelected: false,
      processTypes: [{ text: 'Templates', value: 'Templates' }, { text: 'Insurance Card', value: '-2' }, { text: 'Driving License', value: '-5' }],
      integrationTypes: [{ text: 'Default', value: 'Default' }, { text: 'MuleSoft', value: 'MuleSoft' }, { text: 'Informatica', value: 'Informatica' }, { text: 'Dell Boomi', value: 'Dell Boomi' }, { text: 'Custom', value: 'Custom' }],
      connectionTypes: [{ text: 'Select Service', value: null, disabled: true }, { text: 'Salesforce', value: 'Salesforce' }, { text: 'EHR', value: 'EHR' }, { text: 'LIMS', value: 'LIMS' }, { text: 'Other', value: 'Other' }],
      showObjectRow: false,
      showTemplateRow: false,
      showVersionsRow: false,
      showEFM: false,
      template_doc_id: null,
      extServiceData: {
        integration_type: 'Default',
        connection_type: null,
        process_type: null,
        name: '',
        description: '',
        external_service_url: '',
        external_service_title: '',
        username: '',
        password: '',
        created: true
      },
      templateDoc: {
        selectedTemplateDocId: null,
        tmpFields: []
      },
      extConnection: {
        extObjects: [],
        selectedObj: null,
        extFields: [],
        reqFields: [],
        allReqFields: [],
        reqStr: ''
      },
      externalServiceMap: {
        externalServiceMapId: '',
        externalFieldMappings: [],
        selectedTmpField: '',
        selectedExtField: ''
      },
      mappingType: null,
      mappingTypeOptions: [],
      defaultValue: '',
      sectionsList: [],
      sectionName: '',
      selectedSection: ''
    };
  },

  components: {
    draggable: _vuedraggable2.default,
    ModelSelect: _vueSearchSelect.ModelSelect
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'selectedRolesData', 'isAdminRole', 'accountId']), {
    shouldShowDownload: function shouldShowDownload() {
      var integrationType = this.extServiceData.integration_type;
      var efm = this.externalServiceMap.externalFieldMappings;
      return integrationType === 'MuleSoft' && efm.length > 0;
    }
  }),
  watch: {
    'extConnection.selectedObj': function extConnectionSelectedObj() {
      this.fetchObjectFields();
    },
    'mappingType': function mappingType() {
      this.defaultValue = '';
    },
    'extConnection.reqFields': function extConnectionReqFields() {
      this.extConnection.reqStr = '';
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.extConnection.reqFields.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = _slicedToArray(_ref, 2);

          var index = _ref2[0];
          var req = _ref2[1];

          this.extConnection.reqStr += req.text;
          if (index !== this.extConnection.reqFields.length - 1) {
            this.extConnection.reqStr += ', ';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    'extConnection.extFields': function extConnectionExtFields() {
      this.defaultValue = '';
    }
  },
  created: function created() {
    var _this = this;

    var vm = this;
    vm.mappingTypeOptions = [{ text: 'Select Mapping Type', value: null, disabled: true }, { text: 'Default value', value: 'DEFAULT' }, { text: 'Template Fields', value: 'TEMPLATE_FIELD' }];
    _vue2.default.axios.get('/settings/external_service_maps', { headers: { Authorization: 'Bearer ' + vm.idToken } }).then(function (res) {
      vm.externalServiceMaps = res.data.external_service_maps;
      vm.availableTemplateDocs = [{ text: 'Select Template', value: null, disabled: true }].concat(res.data.available_templates);
    }).catch(function (error) {
      if (error.status === 401) {
        console.log(_this.$t('COMMON.MSG_EXPIRED'));
      } else {
        _vue2.default.toasted.show(_this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
      }
    });
    _vue2.default.axios.get('/settings/external_service_maps/fetch_external_url', { headers: { Authorization: 'Bearer ' + vm.idToken } }).then(function (res) {
      vm.extServiceData.external_service_url = res.data.external_url;
      vm.extServiceData.external_service_title = res.data.external_title;
    }).catch(function (error) {
      if (error.status === 401) {
        console.log(_this.$t('COMMON.MSG_EXPIRED'));
      } else {
        _vue2.default.toasted.show(_this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
      }
    });
  },

  methods: {
    handleFileUpload: function handleFileUpload() {
      var _this2 = this;

      this.file = this.$refs.file.files[0];
      this.isFileSelected = true;
      var reader = new window.FileReader();
      reader.onload = function (evt) {
        try {
          _this2.text = JSON.parse(evt.target.result);
        } catch (error) {
          _this2.isFileSelected = false;
          _vue2.default.toasted.show(_this2.$t('COMMON.FILE_ERROR'), { icon: 'chain-broken', type: 'error' });
          return;
        }
        var payload = {
          integration_type: _this2.extServiceData.integration_type,
          connection_type: _this2.extServiceData.connection_type,
          name: _this2.extServiceData.name,
          template_doc_id: _this2.templateDoc.selectedTemplateDocId,
          template_id: _this2.selectedTemplate,
          revision_id: _this2.selectedTemplateVersion,
          description: _this2.extServiceData.description,
          external_service_url: _this2.extServiceData.external_service_url,
          username: _this2.extServiceData.username,
          password: _this2.extServiceData.password,
          mapping_data: _this2.text,
          account_id: _this2.accountId
        };
        _this2.mappingPayload = payload;
        console.log(_this2.mappingPayload);
      };
      reader.readAsText(this.file);
    },
    hideImportModal: function hideImportModal() {
      this.$refs.externalServiceImportModal.hide();
    },
    saveImportMappings: function saveImportMappings() {
      var _this3 = this;

      _vue2.default.axios.post('/settings/external_service_maps/save_import_mappings', this.mappingPayload, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.data.status === 'SUCCESS') {
          _vue2.default.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' });
          _this3.$refs.externalServiceImportModal.hide();
          if (!res.data.error) {
            _router2.default.go();
          }
        } else {
          _vue2.default.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this3.$t('COMMON.MSG_EXPIRED'));
        } else if (error.status === 500) {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    downloadEsmappings: function downloadEsmappings() {
      var _this4 = this;

      var id = this.externalServiceMap.externalServiceMapId;
      _vue2.default.axios.get('/settings/external_service_maps/' + id + '/download_esmappings', { headers: {
          Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this4.mappingData = res;
        var data = JSON.stringify(_this4.mappingData.data.mappings);
        var templateName = JSON.stringify(_this4.mappingData.data.template_name).replace(/\s+/g, '_');
        var filename = templateName + '_external_service_mappings' + '_version' + _this4.selectedTemplateVersion + '.txt';
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(data));
        element.setAttribute('Download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this4.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this4.$t('COMMON.MSG_EXPIRED'));
        } else if (error.status === 500) {
          _vue2.default.toasted.show(_this4.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    showDeleteModal: function showDeleteModal(templateDocId) {
      this.template_doc_id = templateDocId;
      this.$refs['deleteModal'].show();
    },
    cancel: function cancel() {
      this.$refs['deleteModal'].hide();
    },
    addSectionName: function addSectionName() {
      this.sectionsList.push(this.sectionName);
      this.sectionName = '';
    },
    deleteSectionName: function deleteSectionName(name) {
      this.sectionsList = this.sectionsList.filter(function (section) {
        return section !== name;
      });
      this.sectionName = '';
    },
    onHidingExtSerModal: function onHidingExtSerModal() {
      this.resetData();
    },
    updateSectionOrder: function updateSectionOrder() {
      var _this5 = this;

      var formData = new window.FormData();
      formData.append('template_doc_id', this.templateDoc.selectedTemplateDocId);
      formData.append('section_list', JSON.stringify(this.sectionsList));
      _vue2.default.axios.post('/settings/external_field_maps/update_section_order', formData, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        _vue2.default.toasted.show(_this5.$t('CONFIGURED.SECTION_ORDER_SUCCESS'));
      }, function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this5.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this5.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this5.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    resetData: function resetData() {
      var esmDataOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!esmDataOnly) {
        this.extServiceData = {
          integration_type: 'Default',
          connection_type: null,
          process_type: null,
          name: '',
          description: '',
          external_service_url: this.extServiceData.external_service_url,
          external_service_title: this.extServiceData.external_service_title,
          username: '',
          password: '',
          created: true
        };
        this.templateDoc = {
          selectedTemplateDocId: null,
          tmpFields: []
        };
      }
      this.availableTemplates = [];
      this.availableTemplateVersions = [];
      this.selectedTemplate = null;
      this.selectedTemplateVersion = null;
      this.showEFM = false;
      this.showObjectRow = false;
      this.showVersionsRow = false;
      this.extConnection = {
        extObjects: [],
        selectedObj: null,
        extFields: [],
        reqFields: [],
        allReqFields: []
      };
      this.externalServiceMap = {
        externalServiceMapId: '',
        externalFieldMappings: [],
        selectedTmpField: '',
        selectedExtField: ''
      };
    },
    handleSelectedIntegrationType: function handleSelectedIntegrationType(newValue) {
      if (newValue === 'Default') {
        this.connectionTypes = [{ text: 'Select Service', value: null }, { text: 'Salesforce', value: 'Salesforce' }, { text: 'EHR', value: 'EHR' }, { text: 'LIMS', value: 'LIMS' }, { text: 'Other', value: 'Other' }];
        this.extServiceData.connection_type = null;
        this.extServiceData.created = true;
      } else {
        this.connectionTypes = [{ text: 'Salesforce', value: 'Salesforce' }];
        this.extServiceData.connection_type = 'Salesforce';
        this.extServiceData.created = true;
      }
      this.resetData(true);
    },
    handleSelectedTemplate: function handleSelectedTemplate(newValue) {
      this.extServiceData.created = true;
      this.resetData(true);
      this.fetchData(newValue);
    },
    handleSelectedConnectionType: function handleSelectedConnectionType() {
      this.extServiceData.created = true;
      this.resetData(true);
    },
    handleSelectedProcessType: function handleSelectedProcessType(newValue) {
      if (newValue === 'Templates') {
        this.showTemplateRow = true;
      } else {
        if (newValue === '-2') {
          this.showTemplateRow = true;
          this.showVersionsRow = true;
        } else {
          this.selectedTemplate = '-5';
          this.templateDoc.selectedTemplateDocId = '-5';
          this.showTemplateRow = false;
          this.showVersionsRow = false;
        }
      }
      this.extServiceData.created = true;
    },
    fetchData: function fetchData(newValue) {
      var _this6 = this;

      var params = new window.FormData();
      params.append('template_doc_id', newValue);
      params.append('external_service_url', this.extServiceData.external_service_url);
      _vue2.default.axios.post('/settings/external_service_maps/fetch_templates', params, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        var result = res.data;
        _this6.showVersionsRow = true;
        _this6.availableTemplates = [{ text: 'Select Page', value: null, disabled: true }].concat(result.templates);
        _this6.extConnection.extObjects = [].concat(result.objects);
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this6.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this6.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    fetchTemplateVersion: function fetchTemplateVersion(newValue) {
      var _this7 = this;

      this.showObjectRow = false;
      this.showEFM = false;
      this.selectedTemplateVersion = null;
      if (newValue) {
        _vue2.default.axios.get('/settings/external_service_maps/fetch_versions?template_id=' + newValue, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
          var result = res.data;
          _this7.availableTemplateVersions = [{ text: 'Select Page', value: null, disabled: true }].concat(result.versions);
        }).catch(function (error) {
          if (error.status === 401) {
            _vue2.default.toasted.show(_this7.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          } else {
            _vue2.default.toasted.show(_this7.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      }
    },
    resetObjectRow: function resetObjectRow() {
      this.showObjectRow = false;
      this.showEFM = false;
    },
    createMapping: function createMapping() {
      var _this8 = this;

      this.showObjectRow = false;
      this.showEFM = false;
      if (this.extServiceData.connection_type === 'Salesforce') {
        var mappingData = new window.FormData();
        mappingData.append('integration_type', this.extServiceData.integration_type);
        mappingData.append('connection_type', this.extServiceData.connection_type);
        mappingData.append('name', this.extServiceData.name);
        mappingData.append('template_doc_id', this.templateDoc.selectedTemplateDocId);
        mappingData.append('template_id', this.selectedTemplate);
        mappingData.append('revision_id', this.templateDoc.selectedTemplateDocId === '-2' ? '1' : this.selectedTemplateVersion);
        mappingData.append('description', this.extServiceData.description);
        mappingData.append('external_service_url', this.extServiceData.external_service_url);
        mappingData.append('username', this.extServiceData.username);
        mappingData.append('password', this.extServiceData.password);
        _vue2.default.axios.post('/settings/external_service_maps', mappingData, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
          if (response.data.status === 'SUCCESS') {
            var result = response.data;
            _this8.extServiceData.created = result.external_service_maps.created;
            _this8.externalServiceMap.externalServiceMapId = result.external_service_maps.id;
            _this8.externalServiceMap.externalFieldMappings = result.external_field_mappings;
            _this8.sectionsList = result.sections ? result.sections : [];
            _this8.templateDoc.tmpFields = result.template_fields;
            if (_this8.templateDoc.tmpFields) {
              _this8.templateDoc.tmpFields.sort(function (a, b) {
                return a.text.toLowerCase() > b.text.toLowerCase() ? 1 : b.text.toLowerCase() > a.text.toLowerCase() ? -1 : 0;
              });
            }
            _this8.extConnection.extFields = result.external_fields;
            _this8.extConnection.extObjects = [].concat(result.objects);
            _this8.extConnection.selectedObj = null;
            _this8.showObjectRow = true;
            if (result.external_service_maps.created) {
              var newMaps = _this8.externalServiceMaps.filter(function (esm, index) {
                return esm.template_doc_id !== _this8.templateDoc.selectedTemplateDocId;
              }).concat([result.external_service_maps]);
              _this8.externalServiceMaps = newMaps;
            }
            _vue2.default.toasted.show(response.data.message);
          } else {
            _vue2.default.toasted.show(response.data.message, { icon: 'chain-broken', type: 'error' });
          }
        }).catch(function (error) {
          if (error.response.status === 401) {
            _vue2.default.toasted.show(_this8.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
            console.log(_this8.$t('COMMON.MSG_EXPIRED'));
          } else {
            _vue2.default.toasted.show(_this8.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      } else {
        _vue2.default.toasted.show(this.$t('COMMON.MSG_INACTIVE'), { icon: 'chain-broken', type: 'error' });
      }
    },
    fetchObjectFields: function fetchObjectFields() {
      var _this9 = this;

      if (this.extConnection.selectedObj) {
        this.showEFM = false;
        _vue2.default.axios.get('/settings/external_service_maps/object_fields?object_type=' + this.extConnection.selectedObj, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
          _this9.extConnection.extFields = res.data.external_fields[0];
          _this9.extConnection.extFields.sort(function (a, b) {
            return a.text.toLowerCase() > b.text.toLowerCase() ? 1 : b.text.toLowerCase() > a.text.toLowerCase() ? -1 : 0;
          });
          _this9.extConnection.reqFields = res.data.external_fields[1];
          _this9.extConnection.allReqFields = JSON.parse(JSON.stringify(res.data.external_fields[1]));

          var _loop = function _loop(extField) {
            _this9.extConnection.reqFields = _this9.extConnection.reqFields.filter(function (req, index) {
              return req.value !== extField.ext_field_api;
            });
          };

          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = _this9.externalServiceMap.externalFieldMappings[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var extField = _step2.value;

              _loop(extField);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          _this9.showEFM = true;
        }).catch(function (error) {
          if (error.response.status === 401) {
            _vue2.default.toasted.show(_this9.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
            console.log(_this9.$t('COMMON.MSG_EXPIRED'));
          } else {
            _vue2.default.toasted.show(_this9.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      }
    },
    addFieldMapping: function addFieldMapping() {
      var _this10 = this;

      var selectedTmpObj = this.templateDoc.tmpFields.filter(function (tmpField) {
        return tmpField.value === _this10.externalServiceMap.selectedTmpField;
      })[0];
      var selectedExtFieldObj = this.extConnection.extFields.filter(function (extField) {
        return extField.value === _this10.externalServiceMap.selectedExtField;
      })[0];
      var mappingData = new window.FormData();
      mappingData.append('template_doc_id', this.templateDoc.selectedTemplateDocId);
      mappingData.append('template_id', this.selectedTemplate);
      mappingData.append('revision_id', this.selectedTemplateVersion);
      mappingData.append('external_service_map_id', this.externalServiceMap.externalServiceMapId);
      var templateMappingId = selectedTmpObj && selectedTmpObj.value ? selectedTmpObj.value : null;
      var templateMappingKey = selectedTmpObj && selectedTmpObj.text ? selectedTmpObj.text : null;
      mappingData.append('template_mapping_id', templateMappingId);
      mappingData.append('template_mapping_key', templateMappingKey);
      mappingData.append('external_field_key', selectedExtFieldObj.value);
      mappingData.append('external_field_label', selectedExtFieldObj.text);
      mappingData.append('external_field_type', this.extConnection.selectedObj);
      mappingData.append('ef_datatype', selectedExtFieldObj.data_type);
      mappingData.append('default_value', this.defaultValue.trim());
      mappingData.append('section', this.selectedSection);
      mappingData.append('section_order', this.sectionsList.indexOf(this.selectedSection) + 1);
      _vue2.default.axios.post('/settings/external_field_maps', mappingData, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        if (response.data.status === 'SUCCESS') {
          _this10.externalServiceMap.externalFieldMappings.push({ id: response.data.id, 'tmp_id': templateMappingId, 'tmp_key': templateMappingKey, 'ext_field_api': response.data.ext_field_api, 'ext_field_object': response.data.ext_field_object, default_value: _this10.defaultValue, section: _this10.selectedSection });
          _this10.extConnection.reqFields = _this10.extConnection.reqFields.filter(function (req, index) {
            return req.value !== response.data.ext_field_api;
          });
          _this10.externalServiceMap.selectedTmpField = '';
          _this10.externalServiceMap.selectedExtField = '';
          _this10.defaultValue = '';
          _this10.selectedSection = '';
          _this10.defaultValue = '';
          _vue2.default.toasted.show(response.data.message);
        } else {
          _vue2.default.toasted.show(response.data.message, { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this10.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this10.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this10.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    editExternalServiceMap: function editExternalServiceMap(templateDocId) {
      var _this11 = this;

      _vue2.default.axios.get('/settings/external_service_maps/' + templateDocId, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        var result = response.data;
        _this11.extServiceData.connection_type = result.external_service_maps ? result.external_service_maps.connection_type : 'Salesforce';
        _this11.extServiceData.integration_type = result.external_service_maps ? result.external_service_maps.integration_type : 'Default';
        _this11.availableTemplates = [{ text: 'Select Page', value: null, disabled: true }].concat(result.templates);
        _this11.availableTemplateVersions = [{ text: 'Select Versions', value: null, disabled: true }].concat(result.versions);
        _this11.extServiceData.process_type = templateDocId === '-2' || templateDocId === -2 ? '-2' : '-5';
        if (templateDocId !== -2 && templateDocId !== -5) {
          _this11.extServiceData.process_type = 'Templates';
          _this11.showVersionsRow = true;
          if (result.efm_template_id != null) {
            _this11.selectedTemplate = result.efm_template_id;
          } else {
            _this11.selectedTemplate = result.templates[0]['value'];
          }
          _this11.selectedTemplateVersion = result.versions[0]['value'];
        }
        _this11.extConnection.extObjects = result.objects ? [].concat(result.objects) : [];
        _this11.externalServiceMap.externalFieldMappings = result.external_field_mappings;
        _this11.templateDoc.selectedTemplateDocId = templateDocId;
        _this11.templateDoc.tmpFields = result.template_fields || [];
        _this11.sectionsList = result.sections ? result.sections : [];
        if (_this11.templateDoc.tmpFields) {
          _this11.templateDoc.tmpFields.sort(function (a, b) {
            return a.text.toLowerCase() > b.text.toLowerCase() ? 1 : b.text.toLowerCase() > a.text.toLowerCase() ? -1 : 0;
          });
        }
        if (result.external_service_maps) {
          _this11.extConnection.connection_type = result.external_service_maps.connection_type;
          _this11.externalServiceMap.externalServiceMapId = result.external_service_maps.id;
          _this11.showObjectRow = true;
        } else {
          _vue2.default.toasted.show('No service found for the latest version. Create it now', { icon: 'chain-broken', type: 'error' });
        }
        _this11.$refs.externalServiceModal.show();
      }).catch(function (error) {
        console.log(error);
        if (error.response && error.response.status === 401) {
          _vue2.default.toasted.show(_this11.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this11.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this11.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    deleteExternalServiceMap: function deleteExternalServiceMap() {
      var _this12 = this;

      _vue2.default.axios.delete('/settings/external_service_maps/' + this.template_doc_id, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        if (response.data.deleted) {
          _this12.externalServiceMaps = _this12.externalServiceMaps.filter(function (esm, index) {
            return esm.template_doc_id !== _this12.template_doc_id;
          });
          _vue2.default.toasted.show(_this12.$t('COMMON.MSG_DELETE'));
        } else {
          _vue2.default.toasted.show(_this12.$t('COMMON.MSG_DELETE_ERR'), { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this12.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this12.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this12.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    deleteExternalFieldMap: function deleteExternalFieldMap(fieldMapId, fieldExtApi) {
      var _this13 = this;

      _vue2.default.axios.delete('/settings/external_field_maps/' + fieldMapId, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        _this13.externalServiceMap.externalFieldMappings = _this13.externalServiceMap.externalFieldMappings.filter(function (efm, index) {
          return efm.id !== fieldMapId;
        });
        var presentExtMap = _this13.externalServiceMap.externalFieldMappings.filter(function (efm, index) {
          return efm.ext_field_api === fieldExtApi;
        });
        var presentReqMap = _this13.extConnection.allReqFields.filter(function (req, index) {
          return req.value === fieldExtApi;
        });
        if (presentReqMap.length && !presentExtMap.length) {
          _this13.extConnection.reqFields.push(presentReqMap[0]);
        }
        _vue2.default.toasted.show(_this13.$t('COMMON.MSG_FIELD_DEL'));
      }).catch(function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this13.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this13.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this13.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    downloadESM: function downloadESM() {
      var esmId = this.externalServiceMap.externalServiceMapId;
      _vue2.default.axios.get('/settings/external_service_maps/' + esmId + '/download', { headers: {
          Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        var data = res.data.efm_data;
        var processedData = data;
        var mimeType = 'application/json';
        var fileType = '.json';
        var blob = new window.Blob([JSON.stringify(processedData)], {
          type: mimeType
        });

        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = res.data.title + fileType;
        document.body.appendChild(link);
        link.click();
      });
    }
  }
};

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _vueSearchSelect = __webpack_require__(193);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      conditions: [{ text: 'Alphabatic', value: 'alphabatic' }, { text: 'Numeric', value: 'numeric' }, { text: 'Email', value: 'email' }, { text: 'Length', value: 'lengthmeasurement' }, { text: 'Phone Number', value: 'phonenumber' }, { text: 'Date', value: 'date' }, { text: 'Date with future', value: 'date_future' }, { text: 'Reg Ex', value: 'regex' }, { text: 'State', value: 'state' }],
      fields: [{ key: 'tmp_key', label: 'Template Field', tdClass: 'text-left', thClass: 'text-left' }, { key: 'value', label: 'Value', tdClass: 'text-left', thClass: 'text-left' }, { key: 'error_message', label: 'Error Msg', tdClass: 'text-left', thClass: 'text-left' }, { key: 'actions', label: 'Actions' }],
      externalServiceValidations: [],
      isFileSelected: false,
      availableTemplateDocs: [],
      availableTemplates: [],
      availableTemplateVersions: [],
      selectedTemplate: null,
      selectedTemplateVersion: null,
      showVersionsRow: false,
      showFetchButton: false,
      showESV: false,
      template_doc_id: null,
      extServiceValidation: {
        created: true
      },
      templateDoc: {
        selectedTemplateDocId: null,
        tmpFields: []
      },
      externalServiceValidation: {
        selectedTmpField: '',
        selectedCondition: '',
        errorMessage: '',
        conditionValue: '',
        externalServiceValidations: [],
        editValidationId: null
      }
    };
  },

  components: {
    ModelSelect: _vueSearchSelect.ModelSelect
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'selectedRolesData', 'isAdminRole', 'accountId'])),
  watch: {
    'templateDoc.selectedTemplateDocId': function templateDocSelectedTemplateDocId() {
      this.resetData(true);
      this.fetchData(this.templateDoc.selectedTemplateDocId);
    }
  },
  created: function created() {
    var _this = this;

    var vm = this;
    _vue2.default.axios.get('/settings/external_service_validations', { headers: { Authorization: 'Bearer ' + vm.idToken } }).then(function (res) {
      vm.externalServiceValidations = res.data.external_service_validations;
      vm.availableTemplateDocs = [].concat(res.data.available_templates);
    }).catch(function (error) {
      if (error.status === 401) {
        console.log(_this.$t('COMMON.MSG_EXPIRED'));
      } else {
        _vue2.default.toasted.show(_this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
      }
    });
  },

  methods: {
    handleFileUpload: function handleFileUpload() {
      var _this2 = this;

      this.file = this.$refs.file.files[0];
      this.isFileSelected = true;
      var reader = new window.FileReader();
      reader.onload = function (evt) {
        try {
          _this2.text = JSON.parse(evt.target.result);
        } catch (error) {
          _this2.isFileSelected = false;
          _vue2.default.toasted.show(_this2.$t('COMMON.FILE_ERROR'), { icon: 'chain-broken', type: 'error' });
          return;
        }
        var payload = {
          template_doc_id: _this2.templateDoc.selectedTemplateDocId,
          template_id: _this2.selectedTemplate,
          revision_id: _this2.selectedTemplateVersion,
          validation_data: _this2.text
        };
        _this2.validationPayload = payload;
      };
      reader.readAsText(this.file);
    },
    showDeleteModal: function showDeleteModal(templateDocId) {
      this.template_doc_id = templateDocId;
      this.$refs['deleteModal'].show();
    },
    cancel: function cancel() {
      this.$refs['deleteModal'].hide();
    },
    onHidingExtSerValModal: function onHidingExtSerValModal() {
      this.templateDoc.selectedTemplateDocId = null;
      this.resetData();
    },
    hideImportValidations: function hideImportValidations() {
      this.$refs.externalServiceImportValidationModal.hide();
    },
    resetData: function resetData() {
      this.availableTemplates = [];
      this.availableTemplateVersions = [];
      this.selectedTemplate = null;
      this.selectedTemplateVersion = null;
      this.showVersionsRow = false;
      this.showESV = false;
      this.showFetchButton = false;
      this.extServiceValidation = {
        created: true
      };
      this.templateDoc.tmpFields = [];
      this.externalServiceValidation = {
        selectedTmpField: '',
        selectedCondition: '',
        errorMessage: '',
        conditionValue: '',
        externalServiceValidations: []
      };
      this.editValidationId = null;
    },
    handleSelectedVersion: function handleSelectedVersion() {
      this.showESV = false;
      this.showFetchButton = true;
    },
    fetchData: function fetchData(newValue) {
      var _this3 = this;

      this.showVersionsRow = false;
      _vue2.default.axios.get('/settings/external_service_validations/fetch_templates?template_doc_id=' + newValue, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        var result = res.data;
        _this3.showVersionsRow = true;
        _this3.availableTemplates = [{ text: 'Select Page', value: null, disabled: true }].concat(result.templates);
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    fetchTemplateVersion: function fetchTemplateVersion(newValue) {
      var _this4 = this;

      this.showESV = false;
      this.selectedTemplateVersion = null;
      if (newValue) {
        _vue2.default.axios.get('/settings/external_service_validations/fetch_versions?template_id=' + newValue, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
          var result = res.data;
          _this4.availableTemplateVersions = [{ text: 'Select version', value: null, disabled: true }].concat(result.versions);
        }).catch(function (error) {
          if (error.status === 401) {
            _vue2.default.toasted.show(_this4.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          } else {
            _vue2.default.toasted.show(_this4.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      }
    },
    fetchValidations: function fetchValidations() {
      var _this5 = this;

      var validationData = new window.FormData();
      validationData.append('template_doc_id', this.templateDoc.selectedTemplateDocId);
      validationData.append('template_id', this.selectedTemplate);
      validationData.append('revision_id', this.selectedTemplateVersion);
      _vue2.default.axios.post('/settings/external_service_validations/fetch_validations', validationData, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        if (response.data.status === 'SUCCESS') {
          _this5.showFetchButton = false;
          var result = response.data;
          _this5.showESV = true;
          _this5.externalServiceValidation.externalServiceValidations = result.external_field_validations;
          _this5.templateDoc.tmpFields = result.template_fields;
          _this5.templateDoc.tmpFields.sort(function (a, b) {
            return a.text.toLowerCase() > b.text.toLowerCase() ? 1 : b.text.toLowerCase() > a.text.toLowerCase() ? -1 : 0;
          });
          _vue2.default.toasted.show(response.data.message);
        } else {
          _vue2.default.toasted.show(response.data.message, { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this5.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this5.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this5.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    addFieldValidation: function addFieldValidation() {
      var _this6 = this;

      if (this.externalServiceValidation.selectedTmpField === '' || this.externalServiceValidation.selectedCondition === '' || this.externalServiceValidation.selectedTmpField === undefined) {
        _vue2.default.toasted.show('Template and Condition fields are required.', { icon: 'chain-broken', type: 'error' });
        return;
      } else if (['lengthmeasurement', 'regex', 'date', 'date_future'].includes(this.externalServiceValidation.selectedCondition) && this.externalServiceValidation.conditionValue === '') {
        _vue2.default.toasted.show('Value field is required.', { icon: 'chain-broken', type: 'error' });
        return;
      } else if (!['lengthmeasurement', 'regex', 'date', 'date_future'].includes(this.externalServiceValidation.selectedCondition) && this.externalServiceValidation.conditionValue !== '') {
        _vue2.default.toasted.show('Value field must be empty.', { icon: 'chain-broken', type: 'error' });
        return;
      }
      var validationData = new window.FormData();
      var mappingElement = this.templateDoc.tmpFields.filter(function (element) {
        return element.value === _this6.externalServiceValidation.selectedTmpField;
      });
      validationData.append('template_doc_id', this.templateDoc.selectedTemplateDocId);
      validationData.append('template_id', this.selectedTemplate);
      validationData.append('revision_id', this.selectedTemplateVersion);
      validationData.append('template_mapping_id', this.externalServiceValidation.selectedTmpField);
      validationData.append('template_mapping_key', mappingElement[0].text);
      validationData.append('condition', this.externalServiceValidation.selectedCondition);
      validationData.append('value', this.externalServiceValidation.conditionValue.trim());
      validationData.append('error_message', this.externalServiceValidation.errorMessage.trim());
      if (this.editValidationId === null) {
        _vue2.default.axios.post('/settings/external_service_validations', validationData, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
          if (response.data.status === 'SUCCESS') {
            var result = response.data;
            _this6.externalServiceValidation.externalServiceValidations.push({ 'id': result.id, 'tmp_id': result.tmp_id, 'tmp_key': result.tmp_key, 'condition': result.condition, 'value': result.value, 'error_message': result.error_message });
            _this6.externalServiceValidations = _this6.externalServiceValidations.filter(function (key, index) {
              return key.template_doc_id !== result.external_service_validation.template_doc_id;
            }).concat(result.external_service_validation);
            _this6.externalServiceValidation.errorMessage = '';
            _this6.externalServiceValidation.conditionValue = '';
            _this6.externalServiceValidation.selectedTmpField = '';
            _this6.externalServiceValidation.selectedCondition = '';
            _vue2.default.toasted.show(response.data.message);
          } else {
            _vue2.default.toasted.show(response.data.message, { icon: 'chain-broken', type: 'error' });
          }
        }).catch(function (error) {
          if (error.response.status === 401) {
            _vue2.default.toasted.show(_this6.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
            console.log(_this6.$t('COMMON.MSG_EXPIRED'));
          } else {
            _vue2.default.toasted.show(_this6.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      } else {
        _vue2.default.axios.patch('/settings/external_service_validations/' + this.editValidationId, validationData, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
          if (response.data.status === true) {
            var result = response.data;
            _this6.externalServiceValidation.externalServiceValidations = _this6.externalServiceValidation.externalServiceValidations.filter(function (esv, index) {
              return esv.id !== _this6.editValidationId;
            });
            _this6.externalServiceValidation.externalServiceValidations.push({ 'id': _this6.editValidationId, 'tmp_id': _this6.externalServiceValidation.selectedTmpField, 'tmp_key': result.tmp_key, 'condition': result.condition, 'value': _this6.externalServiceValidation.conditionValue, 'error_message': _this6.externalServiceValidation.errorMessage });
            _this6.externalServiceValidation.errorMessage = '';
            _this6.externalServiceValidation.conditionValue = '';
            _this6.externalServiceValidation.selectedTmpField = '';
            _this6.externalServiceValidation.selectedCondition = '';
            _this6.editValidationId = null;
            _vue2.default.toasted.show(response.data.message);
          } else {
            _vue2.default.toasted.show(response.data.message, { icon: 'chain-broken', type: 'error' });
          }
        }).catch(function (error) {
          if (error.response.status === 401) {} else {
            _vue2.default.toasted.show(_this6.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      }
    },
    editExternalFieldMap: function editExternalFieldMap(validationData) {
      var field = this.templateDoc.tmpFields.filter(function (obj) {
        return obj.text === validationData.tmp_key;
      });
      this.externalServiceValidation.selectedTmpField = field[0].value;
      var condition = void 0;
      if (validationData.condition === 'lengthmeasurement') {
        condition = 'lengthmeasurement';
      } else {
        condition = validationData.condition;
      }
      this.externalServiceValidation.selectedCondition = condition;
      this.externalServiceValidation.conditionValue = validationData.value.trim();
      this.externalServiceValidation.errorMessage = validationData.error_message.trim();
      this.editValidationId = validationData.id;
    },
    editExternalServiceValidation: function editExternalServiceValidation(templateDocId) {
      var _this7 = this;

      _vue2.default.axios.get('/settings/external_service_validations/' + templateDocId, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        var result = response.data;
        _this7.availableTemplates = [{ text: 'Select Page', value: null, disabled: true }].concat(result.templates);
        _this7.availableTemplateVersions = [{ text: 'Select Versions', value: null, disabled: true }].concat(result.versions);
        _this7.selectedTemplate = result.templates[0]['value'];
        _this7.selectedTemplateVersion = result.versions[0]['value'];
        _this7.showVersionsRow = true;
        _this7.externalServiceValidation.externalServiceValidations = result.external_field_validations;
        _this7.templateDoc.selectedTemplateDocId = result.template_doc_id;
        _this7.templateDoc.tmpFields = result.template_fields;
        _this7.templateDoc.tmpFields.sort(function (a, b) {
          return a.text.toLowerCase() > b.text.toLowerCase() ? 1 : b.text.toLowerCase() > a.text.toLowerCase() ? -1 : 0;
        });
        _this7.showESV = true;
        _this7.$refs.externalServiceValidationModal.show();
      }).catch(function (error) {
        if (error.response && error.response.status === 401) {
          _vue2.default.toasted.show(_this7.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this7.$t('COMMON.MSG_EXPIRED'));
        } else {
          console.log(error);
          _vue2.default.toasted.show(_this7.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    deleteExternalServiceValidation: function deleteExternalServiceValidation() {
      var _this8 = this;

      var validationData = new window.FormData();
      validationData.append('template_doc_id', this.template_doc_id);
      _vue2.default.axios.post('/settings/external_service_validations/delete_template_validations', validationData, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        if (response.data.deleted) {
          _this8.externalServiceValidations = _this8.externalServiceValidations.filter(function (key, index) {
            return key.template_doc_id !== _this8.template_doc_id;
          });
          _vue2.default.toasted.show(_this8.$t('COMMON.MSG_DELETE'));
        } else {
          _vue2.default.toasted.show(_this8.$t('COMMON.MSG_DELETE_ERR'), { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this8.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this8.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this8.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    deleteExternalFieldMap: function deleteExternalFieldMap(validationId) {
      var _this9 = this;

      _vue2.default.axios.delete('/settings/external_service_validations/' + validationId, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        _this9.externalServiceValidation.externalServiceValidations = _this9.externalServiceValidation.externalServiceValidations.filter(function (esv, index) {
          return esv.id !== validationId;
        });
        _vue2.default.toasted.show(_this9.$t('COMMON.MSG_FIELD_DEL'));
      }).catch(function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this9.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this9.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this9.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    saveImportValidations: function saveImportValidations() {
      var _this10 = this;

      _vue2.default.axios.post('/settings/external_service_validations/save_import_validations', this.validationPayload, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.data.status === 'SUCCESS') {
          _vue2.default.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' });
          _this10.$refs.externalServiceImportValidationModal.hide();
          if (!res.data.error) {
            _router2.default.go();
          }
        } else {
          _vue2.default.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (error) {
        if (error.status === 401) {} else if (error.status === 500) {
          _vue2.default.toasted.show(_this10.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    downloadEsvalidations: function downloadEsvalidations() {
      var _this11 = this;

      var parameters = {
        template_doc_id: this.templateDoc.selectedTemplateDocId,
        template_id: this.selectedTemplate,
        revision_id: this.selectedTemplateVersion
      };
      _vue2.default.axios.get('/settings/external_service_validations/download_esvalidations', { headers: { Authorization: 'Bearer ' + this.idToken }, params: parameters }).then(function (res) {
        _this11.validationData = res;
        var data = JSON.stringify(_this11.validationData.data.validations);
        var templateName = JSON.stringify(_this11.validationData.data.template_name).replace(/\s+/g, '_');
        var filename = templateName + '_external_service_validations' + '_version' + _this11.selectedTemplateVersion + '.txt';
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(data));
        element.setAttribute('Download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      }).catch(function (error) {
        if (error.status === 401) {
          console.log(error);
        } else if (error.status === 500) {
          _vue2.default.toasted.show(_this11.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    }
  }
};

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _validators = __webpack_require__(32);

var _vueMultiselect = __webpack_require__(36);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      fieldTypes: null,
      fieldChildren: [],
      processTypes: null,
      selectedFieldType: null,
      selectedFieldChildren: [],
      newFieldAliasName: '',
      errorFieldDup: false,
      currentFieldAliases: null,
      selectedFieldAlias: null,
      currentField: { id: null },
      filter: '',
      newFieldName: '',
      fields: [],
      fetched_fields: [],
      selectedFilterProcessType: 'insurance_cards',
      fieldsLoaded: false,
      fieldAliasLoaded: true,
      isRequired: false,
      extract: true,
      editQuery: '',
      newFieldAlias: ''
    };
  },
  created: function created() {
    this.getFields();
    this.fieldTypes = [{ text: 'Select Field Type', value: null, disabled: true }, { text: 'Alphabets', value: 'alphabets' }, { text: 'Alphanumeric', value: 'alphanumeric' }, { text: 'Character', value: 'character' }, { text: 'Currency', value: 'currency' }, { text: 'Date', value: 'date' }, { text: 'One word', value: 'one_word' }, { text: 'One word alphanumeric', value: 'one_word_alphanumeric' }, { text: 'String', value: 'string' }, { text: 'Number', value: 'number' }, { text: 'Payment terms', value: 'payment_terms' }, { text: 'Vertical multiple lines', value: 'vertical_multiple_lines' }, { text: 'Name', value: 'name' }];
    this.processTypes = [{ text: 'Select Process Type', value: null, disabled: true }, { text: this.$t('UPLOAD_DROPDOWN.DL'), value: 'driving_licence' }, { text: this.$t('UPLOAD_DROPDOWN.INSURANCE'), value: 'insurance_cards' }, { text: this.$t('UPLOAD_DROPDOWN.INVOICE'), value: 'invoice' }];
  },

  components: {
    Multiselect: _vueMultiselect2.default
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['idToken'])),
  watch: {
    selectedFilterProcessType: function selectedFilterProcessType() {
      this.getFields();
      this.currentFieldAliases = null;
    },
    selectedFieldType: function selectedFieldType(newVal) {
      if (newVal === 'name') {
        this.getFieldChildren(this.fields);
      }
    }
  },
  methods: {
    showAddFieldModal: function showAddFieldModal() {
      this.newFieldName = '';
      this.currentField = {
        id: null
      };
      this.selectProcessType = null;
      this.selectedFieldType = null;
      this.selectedFieldChildren = [];
      this.editQuery = '';
      this.newFieldAlias = '';
      this.$refs.addFieldModal.show();
    },
    getFields: function getFields() {
      var _this = this;

      this.fieldsLoaded = false;
      _vue2.default.axios.get('settings/process_field', { headers: { Authorization: 'Bearer ' + this.idToken },
        params: { process_type: this.selectedFilterProcessType } }).then(function (res) {
        _this.fields = res.data.fields;
        _this.fetched_fields = res.data.fields;
        _this.getFieldAlias(res.data.fields[0]);
        if (_this.filter.length > 1) {
          _this.searchByText();
        }
        _this.fieldsLoaded = true;
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this.$t('COMMON.MSG_EXPIRED'));
        } else if (error.status === 500) {
          _vue2.default.toasted.show(_this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    getFieldChildren: function getFieldChildren(fields) {
      var _this2 = this;

      this.fieldChildren = [];
      fields.forEach(function (field) {
        if (field.extract === false) {
          _this2.fieldChildren.push({ text: field.alias, value: field.alias });
        }
      });
    },
    openEditField: function openEditField(processField) {
      var _this3 = this;

      this.currentField = processField;
      this.newFieldName = processField.field.replace(/_/g, ' ');
      this.editQuery = processField.query;
      this.isRequired = processField.required;
      this.extract = processField.extract;
      this.selectedFieldChildren = [];
      if (processField.children && processField.children.length > 0) {
        processField.children.forEach(function (value) {
          _this3.selectedFieldChildren.push({ text: value, value: value });
        });
      }
      this.newFieldAlias = processField.alias;
      this.selectedFieldType = processField.field_type;
      this.$refs.editGroupModal.show();
    },
    editFieldName: function editFieldName() {
      var _this4 = this;

      var group = {
        new_field: this.newFieldName.trim().replace(/\s+/g, '_').toLowerCase(),
        field_type: this.selectedFieldType,
        field_alias: this.newFieldAlias,
        required: this.isRequired,
        field_query: this.editQuery,
        extract: this.extract,
        field_children: this.selectedFieldChildren.map(function (ele) {
          return ele.value;
        })
      };
      _vue2.default.axios.patch('settings/process_field/' + this.currentField.id, group, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.data.success) {
          var newFields = _this4.fields.map(function (field) {
            if (field.id === res.data.field.id) {
              return res.data.field;
            } else {
              return field;
            }
          });
          _this4.fields = newFields;
          _this4.$refs.editGroupModal.hide();
          _vue2.default.toasted.show('Sucessfully Updated');
        } else {
          _vue2.default.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this4.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this4.$t('COMMON.MSG_EXPIRED'));
        } else if (error.status === 500) {
          _vue2.default.toasted.show(_this4.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    addFieldAlias: function addFieldAlias() {
      var _this5 = this;

      var newFieldAlias = {
        field_alias_name: this.newFieldAliasName.trim().toLowerCase(),
        field_id: this.currentField.id,
        process_type: this.selectedFilterProcessType
      };
      _vue2.default.axios.post('settings/process_field_alias', newFieldAlias, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.data.success) {
          _this5.currentFieldAliases.push(res.data.field_alias);
          _this5.$refs.FieldAliasModal.hide();
          _vue2.default.toasted.show('Added Sucessfully');
        } else {
          _vue2.default.toasted.show(res.data.msg, { type: 'error' });
        }
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this5.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this5.$t('COMMON.MSG_EXPIRED'));
        } else if (error.status === 500) {
          _vue2.default.toasted.show(_this5.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    editFieldAlias: function editFieldAlias() {
      var _this6 = this;

      var newFieldAlias = {
        new_field: this.newFieldAliasName.trim().toLowerCase(),
        process_type: this.selectedFilterProcessType
      };
      _vue2.default.axios.patch('settings/process_field_alias/' + this.selectedFieldAlias.id, newFieldAlias, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.data.success) {
          _this6.currentFieldAliases = _this6.currentFieldAliases.map(function (fieldAlias) {
            return fieldAlias.id === res.data.field_alias.id ? res.data.field_alias : fieldAlias;
          });
          _this6.$refs.editFieldAliasModal.hide();
          _vue2.default.toasted.show('Updated Sucessfully');
        } else {
          _vue2.default.toasted.show(res.data.msg, { type: 'error' });
        }
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this6.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this6.$t('COMMON.MSG_EXPIRED'));
        } else if (error.status === 500) {
          _vue2.default.toasted.show(_this6.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    deleteFieldAlias: function deleteFieldAlias() {
      var _this7 = this;

      _vue2.default.axios.delete('settings/process_field_alias/' + this.selectedFieldAlias.id, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.data.success) {
          for (var i = 0; i < _this7.currentFieldAliases.length; i++) {
            if (_this7.currentFieldAliases[i].id === res.data.field_alias.id) {
              _this7.currentFieldAliases.splice(i, 1);
            }
          }
          _this7.$refs.ConfirmModal.hide();
          _vue2.default.toasted.show('Deleted Sucessfully');
        }
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this7.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this7.$t('COMMON.MSG_EXPIRED'));
        } else if (error.status === 500) {
          _vue2.default.toasted.show(_this7.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    addField: function addField() {
      var _this8 = this;

      var field = {
        process_type: this.selectedFilterProcessType,
        field: this.newFieldName.trim().replace(/\s+/g, '_').toLowerCase(),
        field_type: this.selectedFieldType,
        extract: this.extract,
        template_doc_id: this.selectedFilterProcessType === 'insurance_cards' ? -2 : null,
        query: this.editQuery,
        alias: this.newFieldAlias,
        required: this.isRequired
      };
      if (this.selectedFieldChildren && this.selectedFieldChildren.value) {
        field.field_children = this.selectedFieldChildren.value;
      } else {
        field.field_children = [];
      }
      _vue2.default.axios.post('settings/process_field', field, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.data.success) {
          _this8.currentField = res.data.field;
          _this8.fields.push(res.data.field);
          _this8.currentFieldAliases = [];
          _this8.$refs.addFieldModal.hide();
          _this8.scrollFieldToBottom();
          _vue2.default.toasted.show('Sucessfully Added');
        } else {
          _vue2.default.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this8.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this8.$t('COMMON.MSG_EXPIRED'));
        } else if (error.status === 500) {
          _vue2.default.toasted.show(_this8.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    scrollFieldToBottom: function scrollFieldToBottom() {
      setTimeout(function () {
        var fieldsGroup = document.getElementById('groups');
        document.getElementById('groups').scrollTo(0, fieldsGroup.scrollHeight + 100);
      }, 100);
    },
    checkDuplicateAlias: function checkDuplicateAlias() {
      var _this9 = this;

      var fields = this.currentFieldAliases.filter(function (field) {
        if (_this9.newFieldAliasName === field.name && field.id !== _this9.selectedFieldAlias.id) {
          return true;
        }
      });
      this.errorFieldDup = !(fields.length === 0);
    },
    showDeleteFieldAliasModal: function showDeleteFieldAliasModal(fieldAlias) {
      this.selectedFieldAlias = fieldAlias;
      this.$refs.ConfirmModal.show();
    },
    showEditFieldAliasModal: function showEditFieldAliasModal(fieldAlias) {
      this.selectedFieldAlias = fieldAlias;
      this.newFieldAliasName = fieldAlias.name;
      this.$refs.editFieldAliasModal.show();
    },
    showAddFieldAliasModal: function showAddFieldAliasModal() {
      this.newFieldAliasName = '';
      this.selectedFieldAlias = {
        id: null
      };
      this.$refs.FieldAliasModal.show();
    },
    searchByText: function searchByText() {
      var _this10 = this;

      this.fields = this.fetched_fields.filter(function (record) {
        return record.field.includes(_this10.filter.replace(/\s+/g, '_').toLowerCase());
      });
    },
    getFieldAlias: function getFieldAlias(processField) {
      var _this11 = this;

      this.currentField = processField;
      this.fieldAliasLoaded = false;
      _vue2.default.axios.get('/settings/process_field_alias/' + processField.id, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this11.currentFieldAliases = res.data.field_alias;
        _this11.fieldAliasLoaded = true;
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this11.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this11.$t('COMMON.MSG_EXPIRED'));
        } else if (error.status === 500) {
          _vue2.default.toasted.show(_this11.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    confirmDeleteField: function confirmDeleteField(processField) {
      this.currentField = processField;
      this.$refs.deleteGrp.show();
    },
    deleteField: function deleteField() {
      var _this12 = this;

      _vue2.default.axios.delete('settings/process_field/' + this.currentField.id, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.data.success) {
          for (var i = 0; i < _this12.fields.length; i++) {
            if (_this12.fields[i].id === res.data.field.id) {
              _this12.fields.splice(i, 1);
            }
          }
          _this12.currentFieldAliases = null;
          _vue2.default.toasted.show('Sucessfully delete');
          _this12.$refs.deleteGrp.hide();
        } else {
          _vue2.default.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this12.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this12.$t('COMMON.MSG_EXPIRED'));
        } else if (error.status === 500) {
          _vue2.default.toasted.show(_this12.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    }
  },
  validations: {
    newFieldName: {
      required: _validators.required,
      isUnique: function isUnique(value, vm) {
        var _this13 = this;

        value = value.trim().replace(/\s+/g, '_').toLowerCase();
        if (!value || this.newFieldName.name === value) return true;
        return new Promise(function (resolve, reject) {
          setTimeout(function () {
            var groupNames = [];
            groupNames = _this13.fields.filter(function (field) {
              return field.field === value && field.id !== _this13.currentField.id;
            });
            resolve(!groupNames.length > 0);
          }, 350 + Math.random() * 300);
        });
      }
    }
  }
};

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      name: '',
      accountTokens: [],
      token_id: null,
      availableTemplateDocs: [],
      availableTemplates: [],
      selectedTemplateDocId: null,
      selectedTemplateId: null,
      showVersionsRow: false,
      selectedTemplateVersion: null,
      availableTemplateVersions: [],
      wordMappings: [],
      currentDeleteWord: {},
      loaded: false
    };
  },
  mounted: function mounted() {
    this.fetchTemplateDocs();
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['idToken'])),
  methods: {
    handleSelectedTemplate: function handleSelectedTemplate(newValue) {
      this.fetchData(newValue);
    },
    displayWarning: function displayWarning(word) {
      this.currentDeleteWord = word;
      this.$refs['deleteModal'].show();
    },
    cancel: function cancel() {
      this.$refs['deleteModal'].hide();
    },
    displayClearWarning: function displayClearWarning() {
      this.$refs['deleteAllModal'].show();
    },
    cancelClearWarning: function cancelClearWarning() {
      this.$refs['deleteAllModal'].hide();
    },
    deleteAccountToken: function deleteAccountToken() {
      var _this = this;

      _vue2.default.axios.post('/settings/word_dataset/delete_auto_correct_mappings', this.currentDeleteWord, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        _this.$refs['deleteModal'].hide();
        if (response.data.status) {
          _this.wordMappings = _this.wordMappings.filter(function (word, index) {
            return word.id !== _this.currentDeleteWord.id;
          });
          _vue2.default.toasted.show(_this.$t('COMMON.MSG_DELETE'));
        } else {
          _vue2.default.toasted.show(_this.$t('COMMON.MSG_DELETE_ERR'), { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    deleteFromWordDataSetDictinory: function deleteFromWordDataSetDictinory() {
      var _this2 = this;

      var params = new window.FormData();
      params.append('template_id', this.selectedTemplateId);
      params.append('revision_id', this.selectedTemplateVersion);
      _vue2.default.axios.post('/settings/word_dataset/delete_all_auto_correct_mappings', params, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        _this2.$refs['deleteAllModal'].hide();
        if (response.data.status) {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_DELETE_HISTORY'));
        } else {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_DELETE_ERR'), { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this2.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    fetchData: function fetchData(newValue) {
      var _this3 = this;

      var params = new window.FormData();
      params.append('template_doc_id', newValue);
      _vue2.default.axios.post('/settings/word_dataset/fetch_templates', params, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        var result = res.data;
        _this3.showVersionsRow = true;
        _this3.availableTemplates = [{ text: 'Select Page', value: null, disabled: true }].concat(result.templates);
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    fetchTemplateVersion: function fetchTemplateVersion(newValue) {
      var _this4 = this;

      this.selectedTemplateVersion = null;
      if (newValue) {
        _vue2.default.axios.get('/settings/word_dataset/fetch_versions?template_id=' + newValue, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
          var result = res.data;
          _this4.availableTemplateVersions = [{ text: 'Select Page Version', value: null, disabled: true }].concat(result.versions);
        }).catch(function (error) {
          if (error.status === 401) {
            _vue2.default.toasted.show(_this4.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          } else {
            _vue2.default.toasted.show(_this4.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      }
    },
    fetchTemplateDocs: function fetchTemplateDocs() {
      var _this5 = this;

      _vue2.default.axios.get('/settings/word_dataset', { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this5.availableTemplateDocs = [{ text: 'Select Template', value: null, disabled: true }].concat(res.data.available_templates);
      }).catch(function (error) {
        if (error.status === 401) {
          console.log(_this5.$t('COMMON.MSG_EXPIRED'));
          console.log(_this5.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this5.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    fetchAutoCorrectData: function fetchAutoCorrectData() {
      var _this6 = this;

      _vue2.default.axios.get('/settings/word_dataset/get_template_mappings', { headers: { Authorization: 'Bearer ' + this.idToken }, params: { template_id: this.selectedTemplateId, revision_id: this.selectedTemplateVersion } }).then(function (res) {
        _this6.loaded = true;
        _this6.wordMappings = res.data.word_mapping;
      }).catch(function (error) {
        if (error.status === 401) {
          console.log(_this6.$t('COMMON.MSG_EXPIRED'));
          console.log(_this6.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this6.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    }
  }
};

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _validators = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      name: '',
      accountTokens: [],
      token_id: null
    };
  },
  mounted: function mounted() {
    this.fetchTeams();
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['idToken']), {
    nameIsValid: function nameIsValid() {
      return !this.$v.name.$error;
    }
  }),
  validations: {
    name: {
      required: _validators.required,
      maxLength: (0, _validators.maxLength)(15),
      minLength: (0, _validators.minLength)(3),
      valid: function valid(value) {
        var regexExp = /^[a-zA-Z0-9 _-]*$/.test(value);
        return regexExp;
      }
    }
  },
  methods: {
    showDeleteModal: function showDeleteModal(tokenId) {
      this.token_id = tokenId;
      this.$refs['deleteModal'].show();
    },
    cancel: function cancel() {
      this.$refs['deleteModal'].hide();
    },
    fetchTeams: function fetchTeams() {
      var _this = this;

      _vue2.default.axios.get('settings/account_tokens', { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this.accountTokens = res.data.tokens;
      }).catch(function (error) {
        if (error.status === 401) {
          console.log(_this.$t('COMMON.MSG_EXPIRED'));
        } else if (error.status === 500) {
          _vue2.default.toasted.show(_this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    createKeys: function createKeys() {
      var _this2 = this;

      _vue2.default.axios.post('settings/account_tokens', { name: this.name }, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.data.status) {
          _this2.accountTokens.push(res.data.account_token);
          _this2.$refs.generateKeys.hide();
        } else {
          _vue2.default.toasted.show(res.data.message, { type: 'error' });
        }
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else if (error.status === 500) {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    deleteAccountToken: function deleteAccountToken() {
      var _this3 = this;

      _vue2.default.axios.delete('/settings/account_tokens/' + this.token_id, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        if (response.data.deleted) {
          _this3.accountTokens = _this3.accountTokens.filter(function (token, index) {
            return token.id !== _this3.token_id;
          });
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_DELETE'));
        } else {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_DELETE_ERR'), { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this3.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    }
  }
};

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _Switch = __webpack_require__(70);

var _Switch2 = _interopRequireDefault(_Switch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['local_time'],
  computed: _extends({}, (0, _vuex.mapGetters)(['idToken'])),
  components: {
    'c-switch': _Switch2.default
  },
  methods: {
    changeTimeSettings: function changeTimeSettings(event) {
      this.local_time = event;
      this.switchTimeSettings();
    },
    switchTimeSettings: function switchTimeSettings() {
      var _this = this;

      var payload = {
        switchValue: this.local_time
      };
      _vue2.default.axios.post('/admin/accounts/time_settings', payload, {
        headers: {
          Authorization: 'Bearer ' + this.idToken,
          'Cache-Control': 'no-cache, no-store',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      }).then(function (res) {
        _vue2.default.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' });
        _this.$store.commit('setLocalTime', _this.local_time);
        if (!res.data.error) {
          _router2.default.go();
        }
      }).catch(function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
        console.log(error);
      });
    }
  }
};

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _Switch = __webpack_require__(70);

var _Switch2 = _interopRequireDefault(_Switch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['is_auto_processing'],
  computed: _extends({}, (0, _vuex.mapGetters)(['idToken'])),
  components: {
    'c-switch': _Switch2.default
  },
  methods: {
    autoProcessing: function autoProcessing(event) {
      this.is_auto_processing = event;
      this.autoProcessingSwitchChange();
    },
    autoProcessingSwitchChange: function autoProcessingSwitchChange() {
      var _this = this;

      var payload = {
        switchValue: this.is_auto_processing
      };
      _vue2.default.axios.post('/admin/accounts/auto_processing', payload, {
        headers: {
          Authorization: 'Bearer ' + this.idToken,
          'Cache-Control': 'no-cache, no-store',
          'Pragma': 'no-cache',
          'Expires': '0'
        } }).then(function (res) {
        _vue2.default.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' });
        if (!res.data.error) {
          // router.go()
        }
      }).catch(function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    }
  }
};

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _vue2Timepicker = __webpack_require__(513);

var _vue2Timepicker2 = _interopRequireDefault(_vue2Timepicker);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['retentionTime', 'retentionDaysCount'],
  data: function data() {
    return {
      doc_retention_period: this.retentionTime,
      selectedDay: this.retentionDaysCount,
      availableDays: Array.from({ length: 100 }, function (_, i) {
        return i;
      })
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['idToken'])),
  components: { VueTimepicker: _vue2Timepicker2.default },
  watch: {
    retentionTime: function retentionTime(value) {
      this.doc_retention_period = value;
    },
    retentionDaysCount: function retentionDaysCount(value) {
      this.selectedDay = value;
    }
  },
  methods: {
    updateRetentionPeriod: function updateRetentionPeriod() {
      var duration = _moment2.default.duration(this.doc_retention_period);
      var time = _moment2.default.utc(duration.asMilliseconds()).format('HH:mm');
      var res = {
        time: this.selectedDay + ' days ' + time
      };
      _vue2.default.axios.post('/admin/accounts/update_doc_retention_period', res, {
        headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _vue2.default.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' });
      }).catch(function (err) {
        console.log(err);
        _vue2.default.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' });
      });
    }
  }
};

/***/ }),
/* 513 */,
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _vue2Timepicker = __webpack_require__(513);

var _vue2Timepicker2 = _interopRequireDefault(_vue2Timepicker);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['escalationTime', 'escalationDaysCount'],
  data: function data() {
    return {
      new_form_notify_time: this.escalationTime,
      selectedDay: this.escalationDaysCount,
      availableDays: Array.from({ length: 100 }, function (_, i) {
        return i;
      })
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['idToken'])),
  components: { VueTimepicker: _vue2Timepicker2.default },
  watch: {
    escalationTime: function escalationTime(value) {
      this.new_form_notify_time = value;
    },
    escalationDaysCount: function escalationDaysCount(value) {
      this.selectedDay = value;
    }
  },
  methods: {
    saveTimers: function saveTimers() {
      var duration = _moment2.default.duration(this.new_form_notify_time);
      var time = _moment2.default.utc(duration.asMilliseconds()).format('HH:mm');
      var res = {
        time: this.selectedDay + ' days ' + time
      };
      _vue2.default.axios.post('/admin/accounts/update_doc_escalation_time', res, {
        headers: {
          Authorization: 'Bearer ' + this.idToken,
          'Cache-Control': 'no-cache, no-store',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      }).then(function (res) {
        _vue2.default.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' });
      }).catch(function (err) {
        console.log(err);
        _vue2.default.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' });
      });
    }
  }
};

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _vueSearchSelect = __webpack_require__(193);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      externalServiceValidations: [],
      availableTemplateDocs: [],
      availableTemplates: [],
      availableTemplateVersions: [],
      selectedTemplate: null,
      selectedTemplateVersion: null,
      showVersionsRow: false,
      showFetchButton: false,
      showESV: false,
      template_doc_id: null,
      extServiceValidation: {
        created: true
      },
      isFileSelected: false,
      templateDoc: {
        selectedTemplateDocId: null,
        tmpFields: []
      },
      externalServiceValidation: {
        selectedTmpField: '',
        selectedCondition: '',
        errorMessage: '',
        conditionValue: '',
        externalServiceValidations: []
      },
      customValidations: [],
      isEditValidation: false,
      editRule: '',
      editValidationName: '',
      editErrorMessage: '',
      editedValidation: null,
      isOptional: false
    };
  },

  components: {
    ModelSelect: _vueSearchSelect.ModelSelect
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'selectedRolesData', 'isAdminRole', 'accountId'])),
  watch: {
    'templateDoc.selectedTemplateDocId': function templateDocSelectedTemplateDocId() {
      this.resetData(true);
      this.fetchData(this.templateDoc.selectedTemplateDocId);
    }
  },
  created: function created() {
    var _this = this;

    var vm = this;
    _vue2.default.axios.get('/settings/custom_validations', { headers: { Authorization: 'Bearer ' + vm.idToken } }).then(function (res) {
      vm.externalServiceValidations = res.data.external_service_validations;
      vm.availableTemplateDocs = [].concat(res.data.available_templates);
    }).catch(function (error) {
      if (error.status === 401) {
        console.log(_this.$t('COMMON.MSG_EXPIRED'));
      } else {
        _vue2.default.toasted.show(_this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
      }
    });
  },

  methods: {
    handleFileUpload: function handleFileUpload() {
      var _this2 = this;

      this.file = this.$refs.file.files[0];
      this.isFileSelected = true;
      var reader = new window.FileReader();
      reader.onload = function (evt) {
        try {
          _this2.text = JSON.parse(evt.target.result);
        } catch (error) {
          _this2.isFileSelected = false;
          _vue2.default.toasted.show(_this2.$t('COMMON.FILE_ERROR'), { icon: 'chain-broken', type: 'error' });
          return;
        }
        var payload = {
          template_doc_id: _this2.templateDoc.selectedTemplateDocId,
          template_id: _this2.selectedTemplate,
          revision_id: _this2.selectedTemplateVersion,
          validation_data: _this2.text
        };
        _this2.validationPayload = payload;
      };
      reader.readAsText(this.file);
    },
    hideImportValidations: function hideImportValidations() {
      this.$refs.externalCustomImportValidationModal.hide();
    },
    clearValidations: function clearValidations() {
      this.editRule = null;
      this.editValidationName = null;
      this.editErrorMessage = null;
      this.isEditValidation = false;
      this.isOptional = false;
    },
    saveValidations: function saveValidations() {
      if (this.isEditValidation) {
        this.updateValidation();
      } else {
        this.addFieldValidation();
      }
    },
    updateValidation: function updateValidation() {
      var _this3 = this;

      console.log('save valdition');
      var params = {
        validation_name: this.editValidationName,
        error_message: this.editErrorMessage,
        rules: JSON.parse(this.editRule),
        is_optional: this.isOptional
      };
      _vue2.default.axios.patch('/settings/custom_validations/' + this.editedValidation.id, params, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        var result = res.data;
        console.log(result);
        _this3.isEditValidation = false;
        _this3.editErrorMessage = '';
        _this3.editRule = '';
        _this3.editValidationName = '';
        _this3.showVersionsRow = true;
        _this3.isOptional = false;
        _this3.customValidations.map(function (validation) {
          if (validation.id === _this3.editedValidation.id) {
            validation['rules'] = JSON.stringify(params.rules);
            validation['error_message'] = params.error_message;
            validation['validation_name'] = params.validation_name;
            validation['is_optional'] = params.is_optional;
          }
          return validation;
        });
        // this.availableTemplates = [{text: 'Select Page', value: null, disabled: true}].concat(result.templates)
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    editCustomValidation: function editCustomValidation(index, validation) {
      console.log(index);
      console.log(validation);
      this.isEditValidation = true;
      this.editedValidation = validation;
      this.editRule = validation.rules;
      this.editErrorMessage = validation.error_message;
      this.editValidationName = validation.validation_name;
      this.isOptional = validation.is_optional;
    },
    showDeleteModal: function showDeleteModal(templateDocId) {
      this.template_doc_id = templateDocId;
      this.$refs['deleteModal'].show();
    },
    cancel: function cancel() {
      this.$refs['deleteModal'].hide();
    },
    onHidingExtSerValModal: function onHidingExtSerValModal() {
      this.resetData();
    },
    resetData: function resetData() {
      this.availableTemplates = [];
      this.availableTemplateVersions = [];
      this.selectedTemplate = null;
      this.selectedTemplateVersion = null;
      this.showVersionsRow = false;
      this.showESV = false;
      this.showFetchButton = false;
      this.extServiceValidation = {
        created: true
      };
      this.templateDoc.tmpFields = [];
      this.externalServiceValidation = {
        selectedTmpField: '',
        selectedCondition: '',
        errorMessage: '',
        conditionValue: '',
        externalServiceValidations: []
      };
      this.editRule = '';
      // this.customValidations = []
      this.isEditValidation = false;
      this.editRule = '';
      this.editValidationName = '';
      this.editErrorMessage = '';
      this.editedValidation = null;
    },
    handleSelectedVersion: function handleSelectedVersion() {
      this.showESV = false;
      this.showFetchButton = true;
    },
    fetchData: function fetchData(newValue) {
      var _this4 = this;

      this.showVersionsRow = false;
      _vue2.default.axios.get('/settings/custom_validations/fetch_templates?template_doc_id=' + newValue, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        var result = res.data;
        _this4.showVersionsRow = true;
        _this4.availableTemplates = [{ text: 'Select Page', value: null, disabled: true }].concat(result.templates);
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this4.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this4.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    fetchTemplateVersion: function fetchTemplateVersion(newValue) {
      var _this5 = this;

      this.showESV = false;
      this.selectedTemplateVersion = null;
      if (newValue) {
        _vue2.default.axios.get('/settings/custom_validations/fetch_versions?template_id=' + newValue, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
          var result = res.data;
          _this5.availableTemplateVersions = [{ text: 'Select version', value: null, disabled: true }].concat(result.versions);
        }).catch(function (error) {
          if (error.status === 401) {
            _vue2.default.toasted.show(_this5.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          } else {
            _vue2.default.toasted.show(_this5.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      }
    },
    fetchValidations: function fetchValidations() {
      var _this6 = this;

      var validationData = new window.FormData();
      this.isOptional = false;
      validationData.append('template_doc_id', this.templateDoc.selectedTemplateDocId);
      validationData.append('template_id', this.selectedTemplate);
      validationData.append('revision_id', this.selectedTemplateVersion);
      _vue2.default.axios.post('/settings/custom_validations/fetch_validations', validationData, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        console.log(response);
        if (response.data.status === 'SUCCESS') {
          _this6.showFetchButton = false;
          var result = response.data;
          _this6.showESV = true;
          _this6.externalServiceValidation.externalServiceValidations = result.external_field_validations;
          var lop = result.external_field_validations.map(function (validation) {
            validation['rules'] = JSON.stringify(validation['rules']);
            return validation;
          });
          _this6.customValidations = JSON.parse(JSON.stringify(lop));
          _vue2.default.toasted.show(response.data.message);
        } else {
          _vue2.default.toasted.show(response.data.message, { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this6.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this6.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this6.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    addFieldValidation: function addFieldValidation() {
      var _this7 = this;

      var params = {
        template_doc_id: this.templateDoc.selectedTemplateDocId,
        template_id: this.selectedTemplate,
        revision_id: this.selectedTemplateVersion,
        rules: JSON.parse(this.editRule),
        validation_name: this.editValidationName,
        error_message: this.editErrorMessage,
        is_optional: this.isOptional
      };
      _vue2.default.axios.post('/settings/custom_validations', params, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        if (response.data.status === 'SUCCESS') {
          var result = response.data.custom_validation;
          result['rules'] = JSON.stringify(result['rules']);
          _this7.customValidations.push(result);
          _this7.externalServiceValidations = _this7.externalServiceValidations.filter(function (key, index) {
            console.log(key);console.log(response.data.external_service_validation);return key.template_doc_id !== response.data.external_service_validation.template_doc_id;
          }).concat(response.data.external_service_validation);
          _this7.editErrorMessage = '';
          _this7.editRule = '';
          _this7.editValidationName = '';
          _this7.isOptional = false;
          _vue2.default.toasted.show(response.data.message);
        } else {
          _vue2.default.toasted.show(response.data.message, { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (error) {
        console.log(error);
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this7.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this7.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this7.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    editExternalServiceValidation: function editExternalServiceValidation(templateDocId) {
      var _this8 = this;

      _vue2.default.axios.get('/settings/custom_validations/' + templateDocId, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        var result = response.data;
        _this8.availableTemplates = [{ text: 'Select Page', value: null, disabled: true }].concat(result.templates);
        _this8.availableTemplateVersions = [{ text: 'Select Versions', value: null, disabled: true }].concat(result.versions);
        _this8.selectedTemplate = result.templates[0]['value'];
        _this8.selectedTemplateVersion = result.versions[0]['value'];
        _this8.showVersionsRow = true;
        _this8.externalServiceValidation.externalServiceValidations = result.external_field_validations;
        _this8.isOptional = false;
        console.log(result);
        _this8.templateDoc.selectedTemplateDocId = result.template_doc_id;
        _this8.templateDoc.tmpFields = result.template_fields;
        _this8.templateDoc.tmpFields.sort(function (a, b) {
          return a.text.toLowerCase() > b.text.toLowerCase() ? 1 : b.text.toLowerCase() > a.text.toLowerCase() ? -1 : 0;
        });
        _this8.showESV = true;
        _this8.$refs.externalServiceValidationModal.show();
      }).catch(function (error) {
        if (error.response && error.response.status === 401) {
          _vue2.default.toasted.show(_this8.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this8.$t('COMMON.MSG_EXPIRED'));
        } else {
          console.log(error);
          _vue2.default.toasted.show(_this8.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    deleteExternalServiceValidation: function deleteExternalServiceValidation() {
      var _this9 = this;

      var validationData = new window.FormData();
      validationData.append('template_doc_id', this.template_doc_id);
      _vue2.default.axios.post('/settings/custom_validations/delete_template_validations', validationData, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        if (response.data.deleted) {
          _this9.externalServiceValidations = _this9.externalServiceValidations.filter(function (key, index) {
            return key.template_doc_id !== _this9.template_doc_id;
          });
          _vue2.default.toasted.show(_this9.$t('COMMON.MSG_DELETE'));
        } else {
          _vue2.default.toasted.show(_this9.$t('COMMON.MSG_DELETE_ERR'), { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this9.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this9.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this9.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    deleteCustomValidation: function deleteCustomValidation(validationId) {
      var _this10 = this;

      _vue2.default.axios.delete('/settings/custom_validations/' + validationId, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        _this10.customValidations = _this10.customValidations.filter(function (csv, index) {
          return csv.id !== validationId;
        });
        _vue2.default.toasted.show('Validation is Deleted');
      }).catch(function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this10.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this10.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this10.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    saveImportValidations: function saveImportValidations() {
      var _this11 = this;

      _vue2.default.axios.post('/settings/custom_validations/save_import_validations', this.validationPayload, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.data.status === 'SUCCESS') {
          _vue2.default.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' });
          _this11.$refs.externalCustomImportValidationModal.hide();
          if (!res.data.error) {
            _router2.default.go();
          }
        } else {
          _vue2.default.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (error) {
        if (error.status === 401) {} else if (error.status === 500) {
          _vue2.default.toasted.show(_this11.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    downloadCsvalidations: function downloadCsvalidations() {
      var _this12 = this;

      var parameters = {
        id: this.templateDoc.selectedTemplateDocId,
        template_id: this.selectedTemplate,
        revision_id: this.selectedTemplateVersion
      };
      _vue2.default.axios.get('/settings/custom_validations/download_csvalidations', { headers: { Authorization: 'Bearer ' + this.idToken }, params: parameters }).then(function (res) {
        _this12.validationData = res;
        var data = JSON.stringify(_this12.validationData.data.validations);
        var templateName = JSON.stringify(_this12.validationData.data.template_name).replace(/\s+/g, '_');
        var filename = templateName + '_custom_validations' + '_version' + _this12.selectedTemplateVersion + '.txt';
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(data));
        element.setAttribute('Download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      }).catch(function (error) {
        if (error.status === 401) {
          console.log(error);
        } else if (error.status === 500) {
          _vue2.default.toasted.show(_this12.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    }
  }
};

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(112);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ApiResponseJsonFormatter',
  data: function data() {
    return {
      templates: [],
      formData: {},
      editedFields: {}
    };
  },
  mounted: function mounted() {
    this.loadStructureAndData();
  },

  methods: {
    loadStructureAndData: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var structureRes;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _axios2.default.get('settings/api_response_json_formatter/api_response_keys');

              case 3:
                structureRes = _context.sent;


                this.templates = structureRes.data;
                this.initializeFormData();
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                console.error('Error loading form data:', _context.t0);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function loadStructureAndData() {
        return _ref.apply(this, arguments);
      }

      return loadStructureAndData;
    }(),
    initializeFormData: function initializeFormData() {
      var _this = this;

      this.templates.forEach(function (template) {
        _this.$set(_this.formData, template.title, {});
        _this.$set(_this.editedFields, template.title, {});

        // Handle both single page and array of pages
        var pages = Array.isArray(template.pages) ? template.pages : [template.pages];

        pages.forEach(function (page) {
          _this.$set(_this.formData[template.title], page.page_no, {});
          _this.$set(_this.editedFields[template.title], page.page_no, {});

          page.mappings.forEach(function (mapping) {
            _this.$set(_this.formData[template.title][page.page_no], mapping.json_key, mapping.json_key);
            _this.$set(_this.editedFields[template.title][page.page_no], mapping.json_key, false);
          });
        });
      });
    },
    markEdited: function markEdited(templateTitle, pageNo, jsonKey) {
      this.editedFields[templateTitle][pageNo][jsonKey] = true;
    },
    isFieldEdited: function isFieldEdited(templateTitle, pageNo, jsonKey) {
      return this.editedFields && this.editedFields[templateTitle] && this.editedFields[templateTitle][pageNo] && this.editedFields[templateTitle][pageNo][jsonKey];
    },
    handleSubmit: function handleSubmit(templateTitle, pageNo) {
      var _this2 = this;

      var updatedFields = {};
      var pageData = this.formData[templateTitle][pageNo];
      var edited = this.editedFields[templateTitle][pageNo];

      // Find the current template and page to get mapping information
      var currentTemplate = this.templates.find(function (t) {
        return t.title === templateTitle;
      });
      var pages = Array.isArray(currentTemplate.pages) ? currentTemplate.pages : [currentTemplate.pages];
      var currentPage = pages.find(function (p) {
        return p.page_no === pageNo;
      });

      var _loop = function _loop(key) {
        if (edited[key]) {
          // Find the mapping to get the template_mapping_key
          var mapping = currentPage.mappings.find(function (m) {
            return m.json_key === key;
          });
          if (mapping) {
            updatedFields[mapping.template_mapping_key] = pageData[key];
          }
        }
      };

      for (var key in edited) {
        _loop(key);
      }

      if (Object.keys(updatedFields).length === 0) {
        window.alert('No changes to save.');
        return;
      }

      _axios2.default.post('settings/api_response_json_formatter/update_keys', {
        template_title: templateTitle,
        page_no: pageNo,
        data: updatedFields
      }).then(function () {
        window.alert('Changes saved!');
        for (var key in edited) {
          _this2.editedFields[templateTitle][pageNo][key] = false;
        }
      }).catch(function (err) {
        console.error(err);
        window.alert('Failed to save changes.');
      });
    }
  }
};

/***/ }),
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      brands: [],
      loading: true,
      brandName: '',
      selectedBrand: null,
      duplicateError: false
    };
  },


  computed: _extends({}, (0, _vuex.mapGetters)(['idToken']), {
    modalTitle: function modalTitle() {
      return this.selectedBrand ? 'Edit Brand' : 'Add Brand';
    }
  }),

  mounted: function mounted() {
    this.fetchBrands();
  },


  methods: {
    fetchBrands: function fetchBrands() {
      var _this = this;

      this.loading = true;
      _vue2.default.axios.get('/brands').then(function (res) {
        _this.brands = res.data;
        _this.loading = false;
      });
    },
    openAddModal: function openAddModal() {
      this.brandName = '';
      this.selectedBrand = null;
      this.duplicateError = false;
      this.$refs.brandModal.show();
    },
    openEditModal: function openEditModal(brand) {
      this.brandName = brand.name;
      this.selectedBrand = brand;
      this.duplicateError = false;
      this.$refs.brandModal.show();
    },
    checkDuplicate: function checkDuplicate() {
      var _this2 = this;

      this.duplicateError = this.brands.some(function (b) {
        return b.name.toLowerCase() === _this2.brandName.toLowerCase() && (!_this2.selectedBrand || b.id !== _this2.selectedBrand.id);
      });
    },
    saveBrand: function saveBrand() {
      var _this3 = this;

      var payload = { brand: { name: this.brandName } };

      if (this.selectedBrand) {
        _vue2.default.axios.patch('/brands/' + this.selectedBrand.id, payload, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
          _this3.fetchBrands();
          _this3.$refs.brandModal.hide();
          if (res.status === 200) {
            _vue2.default.toasted.show('Brand Updated', { type: 'success' });
          } else {
            _vue2.default.toasted.show(_this3.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          }
        });
      } else {
        _vue2.default.axios.post('/brands', payload).then(function (res) {
          _this3.fetchBrands();
          _this3.$refs.brandModal.hide();
          if (res.status === 201) {
            _vue2.default.toasted.show('Brand Created', { type: 'success' });
          } else {
            _vue2.default.toasted.show(_this3.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          }
        });
      }
    }
  }
};

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      status: false,
      templateDocs: [],
      templateFields: [{ key: 'id', sortable: true }, { key: 'title', sortable: true }, { key: 'enabled', label: 'Enable' }]
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'isAdmin'])),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var _this = this;

    next(function (vm) {
      if (vm.isAdmin) {
        _vue2.default.axios.get('/admin/template_docs', { headers: { Authorization: 'Bearer ' + vm.idToken } }).then(function (res) {
          vm.templateDocs = res.data.template_docs;
          next();
        }).catch(function (error) {
          if (error.status === 401) {
            _vue2.default.toasted.show(vm.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
            console.log(_this.$t('COMMON.MSG_EXPIRED'));
          } else {
            _vue2.default.toasted.show(vm.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      } else {
        console.log(_this.$t('COMMON.MSG_EXPIRED'));
      }
    });
  },

  methods: {
    updateStatus: function updateStatus(formDoc) {
      var _this2 = this;

      var formData = new window.FormData();
      formData.append('enabled', formDoc.enabled);

      _vue2.default.axios.patch('/admin/template_docs/' + formDoc.id, formData, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (response) {
        _vue2.default.toasted.show(_this2.$t('COMMON.MSG_DATA_UPDATE'));
      }, function (error) {
        if (error.response.status === 401) {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this2.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_RETRY'));
        }
        console.log(error);
      });
    }
  }
};

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _SearchBar = __webpack_require__(185);

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _svg = __webpack_require__(28);

var _svg2 = _interopRequireDefault(_svg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      accounts: [],
      accountsLoaded: false,
      accountFields: [{ label: 'Id', key: 'id' }, { label: this.$t('COMMON.NAME'), key: 'name' }, { label: '#' + this.$t('COMMON.USERS'), key: 'users_count' }, { label: this.$t('COMMON.ACCOUNT_TYPE'), key: 'account_type' }, { label: this.$t('COMMON.EXPIRES_AT'), key: 'expires_at' }, { label: this.$t('COMMON.STATUS'), key: 'status' }],
      filter: null,
      selectedAccount: null,
      popOverContent: [],
      usersLoaded: false,
      currentAccountId: null,
      svg: _svg2.default
    };
  },

  components: {
    SearchBar: _SearchBar2.default
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'isSuperAdmin'])),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var _this = this;

    next(function (vm) {
      if (vm.isSuperAdmin) {
        _vue2.default.axios.get('/admin/accounts', { headers: { Authorization: 'Bearer ' + vm.idToken } }).then(function (res) {
          vm.$store.state.accounts = res.data.accounts;
          vm.accounts = vm.$store.state.accounts;
          vm.accountsLoaded = true;
          next();
        }).catch(function (error) {
          if (error.status === 401) {
            _vue2.default.toasted.show(vm.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
            console.log(_this.$t('COMMON.MSG_EXPIRED'));
          } else {
            _vue2.default.toasted.show(vm.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      } else {
        _router2.default.replace('/Not-Found-404');
      }
    });
  },

  methods: {
    closePopOver: function closePopOver() {
      this.$root.$emit('bv::hide::popover');
    },
    fetchUsers: function fetchUsers(id) {
      var _this2 = this;

      if (id !== this.currentAccountId) {
        this.popOverContent = [];
        this.usersLoaded = false;
        this.currentAccountId = id;
        this.$root.$emit('bv::hide::popover');
        this.$root.$emit('bv::show::popover', 'account' + id);
        _vue2.default.axios.get('/admin/users/users_by_roles?role_id=' + '-1' + '&account_id=' + id, {
          headers: {
            Authorization: 'Bearer ' + this.idToken,
            'Cache-Control': 'no-cache, no-store',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        }).then(function (res) {
          _this2.popOverContent = res.data.users;
          _this2.usersLoaded = true;
        }).catch(function (error) {
          if (error.status === 401) {
            _vue2.default.toasted.show(_this2.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
            console.log(_this2.$t('COMMON.MSG_EXPIRED'));
          } else {
            _vue2.default.toasted.show(_this2.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      }
    },
    setFilter: function setFilter(filter) {
      this.filter = filter;
    },
    handleAccountStatus: function handleAccountStatus(data) {
      var _this3 = this;

      var id = data.item.id;
      var status = data.value === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
      var accountData = new window.FormData();
      accountData.append('status', status);
      _vue2.default.axios.post('/admin/accounts/' + id + '/update_status', accountData, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this3.$store.state.accounts = _this3.updateAccounts(res.data);
        _vue2.default.toasted.show(res.data.msg);
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this3.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    updateAccounts: function updateAccounts(data) {
      return this.accounts.slice().map(function (account) {
        if (account.id === data.id) {
          account.status = data.status;
        }
        return account;
      });
    },
    confirmDeleteAccount: function confirmDeleteAccount(data) {
      this.selectedAccount = data.item.id;
      this.$refs.deleteAccountModal.show();
    },
    cancelDelete: function cancelDelete() {
      this.selectedAccount = null;
    },
    deleteAccount: function deleteAccount() {
      var _this4 = this;

      if (this.selectedAccount) {
        _vue2.default.axios.delete('/admin/accounts/' + this.selectedAccount, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
          _this4.$store.state.accounts = _this4.updateAccounts(res.data);
          _this4.accounts = _this4.$store.state.accounts;
          _vue2.default.toasted.show(res.data.msg);
        }).catch(function (error) {
          if (error.status === 401) {
            _vue2.default.toasted.show(_this4.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
            console.log(_this4.$t('COMMON.MSG_EXPIRED'));
          } else {
            _vue2.default.toasted.show(_this4.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      }
    }
  }
};

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _lodash = __webpack_require__(45);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _validators = __webpack_require__(32);

var _vueMultiselect = __webpack_require__(36);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _Switch = __webpack_require__(70);

var _Switch2 = _interopRequireDefault(_Switch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { Multiselect: _vueMultiselect2.default, 'c-switch': _Switch2.default },
  data: function data() {
    return {
      account: {
        name: null,
        account_type: null,
        ocr_engine: null,
        expires_at: null,
        integration_emails: [],
        notification_emails: [],
        process_categories: [],
        salesforce_auto_export: false,
        confidenceScore: 90,
        salesforce_system: null,
        mulesoft_system: null
      },
      integration_emails: '',
      notification_emails: '',
      account_types: [{ text: this.$t('PROFILE.ROLES.TYPE_SELECT'), value: null }, { text: this.$t('PROFILE.ROLES.TRIAL'), value: 'trial' }, { text: this.$t('PROFILE.ROLES.SUBS_ACC'), value: 'subscribed' }],
      ocr_engines: [{ text: 'Select Ocr Engine', value: null }, { text: 'Google Vision', value: 1 }, { text: 'AWS Rekognition', value: 2 }, { text: 'AWS Textract + AWS Rekognition', value: 3 }, { text: 'AWS Textract', value: 4 }],
      currDate: (0, _moment2.default)().format('YYYY-MM-DD').toString(),
      errors: [],
      processCategories: [],
      salesforceExternalSystems: [],
      mulesoftExternalSystems: []
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['isSuperAdmin', 'idToken'])),
  watch: {
    'account.account_type': function accountAccount_type() {
      if (this.account.account_type === 'trial') {
        this.account.expires_at = (0, _moment2.default)().add(2, 'weeks').format('YYYY-MM-DD').toString();
      } else if (this.account.account_type === 'subscribed') {
        this.account.expires_at = (0, _moment2.default)().add(1, 'years').format('YYYY-MM-DD').toString();
      } else {
        this.account.expires_at = null;
      }
    },
    'integration_emails': function integration_emails() {
      this.account.integration_emails = this.integration_emails.split(',');
    },
    'notification_emails': function notification_emails() {
      this.account.notification_emails = this.notification_emails.split(',');
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var _this = this;

    next(function (vm) {
      if (!vm.isSuperAdmin) {
        _router2.default.replace('/Not-Found-404');
      } else {
        _vue2.default.axios.get('/settings/process_types/categories', { headers: { Authorization: 'Bearer ' + vm.idToken }
        }).then(function (res) {
          vm.processCategories = res.data.categories;
          vm.account.process_categories = vm.processCategories;
          vm.salesforceExternalSystems = res.data.salesforce_systems.map(function (es) {
            return { text: es.title, value: es.id };
          });
          vm.account.salesforce_system = vm.salesforceExternalSystems[0];
          vm.mulesoftExternalSystems = res.data.mulesoft_systems.map(function (es) {
            return { text: es.title, value: es.id };
          });
          vm.account.mulesoft_system = vm.mulesoftExternalSystems[0];
        }).catch(function (error) {
          console.log(error);
          if (error.status === 401) {
            _vue2.default.toasted.show(vm.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
            console.log(_this.$t('COMMON.MSG_EXPIRED'));
          } else {
            _vue2.default.toasted.show(vm.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
            next(false);
          }
        });
      }
    });
  },

  methods: {
    dropDownLabel: function dropDownLabel(_ref) {
      var text = _ref.text;

      return '' + text;
    },
    createAccount: function createAccount() {
      var _this2 = this;

      this.$v.$touch();
      if (!this.$v.$invalid) {
        var vm = this;
        var accountFormData = new window.FormData();
        accountFormData.append('name', this.account.name);
        accountFormData.append('account_type', this.account.account_type);
        accountFormData.append('ocr_engine', this.account.ocr_engine);
        accountFormData.append('expires_at', this.account.expires_at);
        accountFormData.append('integration_emails', JSON.stringify(this.account.integration_emails));
        accountFormData.append('notification_emails', JSON.stringify(this.account.notification_emails));
        accountFormData.append('process_categories', JSON.stringify(this.account.process_categories));
        accountFormData.append('salesforce_auto_export', this.account.salesforce_auto_export);
        accountFormData.append('salesforce_system', this.account.salesforce_system.value);
        accountFormData.append('mulesoft_system', this.account.mulesoft_system.value);
        if (this.account.salesforce_auto_export) {
          accountFormData.append('confidence_score', this.account.confidenceScore);
        }
        if (this.$refs.file.files.length === 1) {
          accountFormData.append('image', this.$refs.file.files[0]);
        }
        _vue2.default.axios.post('/admin/accounts', accountFormData, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
          if (res.data.success) {
            vm.$store.state.accounts.push(res.data.account);
            _router2.default.push('/super_admin/accounts');
            _vue2.default.toasted.show(_this2.$t('COMMON.MSG_ACC_CREATE'));
          } else {
            if (res.data.msg) {
              _vue2.default.toasted.show(_this2.$t('COMMON.MSG_SIGNUP_FAIL'), { icon: 'chain-broken', type: 'error' });
            } else {
              _this2.errors = res.data.errors;
              _this2.$refs.errorsModal.show();
            }
          }
        }).catch(function (error) {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_SIGNUP_FAIL'), { icon: 'chain-broken', type: 'error' });
          console.log(error);
        });
      }
    },

    changeAutoExportStatus: function changeAutoExportStatus(event) {
      this.account.salesforce_auto_export = event;
    },
    resetForm: function resetForm() {
      this.account = {
        name: null,
        account_type: null,
        ocr_engine: null,
        expires_at: null,
        integration_emails: [],
        notification_emails: [],
        process_categories: this.processCategories,
        salesforce_auto_export: false
      };
      this.integration_emails = '';
      this.notification_emails = '';
      this.$v.account.$reset();
      this.$refs.file.value = null;
    },
    removeFile: function removeFile() {
      if (this.$refs.file.files.length === 1) {
        this.$refs.logoDeleteModal.show();
      }
    },
    deleteFile: function deleteFile() {
      this.$refs.file.value = null;
      this.$refs.logoDeleteModal.hide();
    },
    hideErrorsModal: function hideErrorsModal() {
      this.errors = [];
      this.$refs.errorsModal.hide();
    }
  },
  validations: {
    account: {
      name: {
        required: _validators.required,
        minLen: (0, _validators.minLength)(5),
        isUnique: function isUnique(value, vm) {
          var _this3 = this;

          if (value === '') return true;
          return new Promise(function (resolve, reject) {
            setTimeout(function () {
              resolve(!_lodash2.default.some(_this3.$store.state.accounts, { 'name': value }));
            }, 350 + Math.random() * 300);
          });
        }
      },
      account_type: {
        required: _validators.required
      },
      ocr_engine: {
        required: _validators.required
      },
      expires_at: {
        required: _validators.required,
        isValid: function isValid(value, vm) {
          return (0, _moment2.default)(value) >= (0, _moment2.default)(vm.currDate);
        }
      },
      integration_emails: {
        $each: {
          email: _validators.email
        }
      },
      notification_emails: {
        $each: {
          email: _validators.email
        }
      },
      process_categories: {
        isValid: function isValid(value, vm) {
          return value.length > 0;
        }
      }
    }
  }
};

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _validators = __webpack_require__(32);

var _vueMultiselect = __webpack_require__(36);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _Switch = __webpack_require__(70);

var _Switch2 = _interopRequireDefault(_Switch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { Multiselect: _vueMultiselect2.default, 'c-switch': _Switch2.default },
  data: function data() {
    return {
      account: {
        id: null,
        name: null,
        integration_emails: [],
        notification_emails: [],
        account_type: null,
        ocr_engine: null,
        expires_at: null,
        process_categories: [],
        salesforce_auto_export: false,
        confidenceScore: 90,
        salesforce_system: null,
        mulesoft_system: null
      },
      account_logo_url: null,
      file_image: null,
      logo_delete: false,
      integration_emails: '',
      notification_emails: '',
      account_types: [{ text: 'Select Account type', value: null }, { text: 'Trial Account', value: 'trial' }, { text: 'Subscribed Account', value: 'subscribed' }],
      ocr_engines: [{ text: 'Select Ocr Engine', value: null }, { text: 'Google Vision', value: 1 }, { text: 'AWS Rekognition', value: 2 }, { text: 'AWS Textract + AWS Rekognition', value: 3 }, { text: 'AWS Textract', value: 4 }],
      currDate: (0, _moment2.default)().format('YYYY-MM-DD').toString(),
      errors: [],
      processCategories: [],
      salesforceExternalSystems: [],
      mulesoftExternalSystems: []
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['isSuperAdmin', 'idToken'])),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var _this = this;

    next(function (vm) {
      if (vm.isSuperAdmin) {
        _vue2.default.axios.get('/settings/process_types/categories', { headers: { Authorization: 'Bearer ' + vm.idToken }
        }).then(function (res) {
          vm.processCategories = res.data.categories;
        }).catch(function (error) {
          if (error.status === 401) {
            _vue2.default.toasted.show(vm.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
            console.log(_this.$t('COMMON.MSG_EXPIRED'));
          } else {
            _vue2.default.toasted.show(vm.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
            next(false);
          }
        });
        _vue2.default.axios.get('/admin/accounts/' + vm.$route.params.id, { headers: { Authorization: 'Bearer ' + vm.idToken } }).then(function (res) {
          var account = res.data.account;
          vm.account.id = account.id;
          vm.account.name = account.name;
          vm.account.integration_emails = account.integration_emails;
          vm.account.notification_emails = account.notification_emails;
          vm.integration_emails = account.integration_emails.join(',');
          vm.notification_emails = account.notification_emails.join(',');
          vm.account.account_type = account.account_type;
          vm.account.ocr_engine = account.ocr_engine;
          vm.account.expires_at = (0, _moment2.default)(account.expires_at).format('YYYY-MM-DD').toString();
          vm.account.process_categories = account.process_categories;
          vm.account_logo_url = account.logo;
          vm.account.salesforce_auto_export = account.export_tosalesforce;
          vm.account.confidenceScore = account.confidence_score == null ? 90 : account.confidence_score;
          vm.salesforceExternalSystems = account.salesforce_systems.map(function (es) {
            return { text: es.title, value: es.id };
          });
          vm.account.salesforce_system = vm.salesforceExternalSystems.filter(function (es) {
            return es.value === account.salesforce_external_system;
          })[0];
          vm.mulesoftExternalSystems = account.mulesoft_systems.map(function (es) {
            return { text: es.title, value: es.id };
          });
          vm.account.mulesoft_system = vm.mulesoftExternalSystems.filter(function (es) {
            return es.value === account.mulesoft_external_system;
          })[0];
        }).catch(function (error) {
          if (error.status === 401) {
            _vue2.default.toasted.show(vm.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          } else {
            _vue2.default.toasted.show(vm.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
            next(false);
          }
          console.log(error);
        });
      } else {
        _router2.default.replace('/Not-Found-404');
      }
    });
  },

  watch: {
    'account.account_type': function accountAccount_type(newValue, oldValue) {
      if (oldValue) {
        if (this.account.account_type === 'trial') {
          this.account.expires_at = (0, _moment2.default)().add(2, 'weeks').format('YYYY-MM-DD').toString();
        } else if (this.account.account_type === 'subscribed') {
          this.account.expires_at = (0, _moment2.default)().add(1, 'years').format('YYYY-MM-DD').toString();
        } else {
          this.account.expires_at = null;
        }
      }
    },
    'integration_emails': function integration_emails() {
      this.account.integration_emails = this.integration_emails && this.integration_emails.split(',') || [];
    },
    'notification_emails': function notification_emails() {
      this.account.notification_emails = this.notification_emails && this.notification_emails.split(',') || [];
    }
  },
  methods: {
    handle_logo_modal: function handle_logo_modal() {
      this.$refs.logoUrlModal.show();
    },
    dropDownLabel: function dropDownLabel(_ref) {
      var text = _ref.text;

      return '' + text;
    },
    logoUrlDelete: function logoUrlDelete() {
      this.logo_delete = true;
    },
    delete_file_modal: function delete_file_modal() {
      if (this.$refs.file.files.length === 1) {
        this.$refs.logoDeleteModal.show();
      }
    },
    delete_file: function delete_file() {
      this.file_image = null;
      this.$refs.file.value = null;
    },
    updateAccount: function updateAccount() {
      var _this2 = this;

      this.$v.$touch();
      if (!this.$v.$invalid) {
        var accountFormData = new window.FormData();
        accountFormData.append('name', this.account.name);
        accountFormData.append('account_type', this.account.account_type);
        accountFormData.append('ocr_engine', this.account.ocr_engine);
        accountFormData.append('expires_at', this.account.expires_at);
        accountFormData.append('integration_emails', JSON.stringify(this.account.integration_emails));
        accountFormData.append('notification_emails', JSON.stringify(this.account.notification_emails));
        accountFormData.append('process_categories', JSON.stringify(this.account.process_categories));
        accountFormData.append('salesforce_auto_export', this.account.salesforce_auto_export);
        accountFormData.append('salesforce_system', this.account.salesforce_system.value);
        accountFormData.append('mulesoft_system', this.account.mulesoft_system.value);
        if (this.account.salesforce_auto_export) {
          accountFormData.append('confidence_score', this.account.confidenceScore);
        }
        if (this.logo_delete === true) {
          accountFormData.append('delete_logo', this.logo_delete);
        }
        if (this.$refs.file.files.length === 1) {
          accountFormData.append('image', this.$refs.file.files[0]);
        }
        _vue2.default.axios.patch('/admin/accounts/' + this.$route.params.id, accountFormData, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
          if (res.data.success) {
            var accounts = _this2.$store.state.accounts.slice().map(function (account) {
              return account.id === res.data.account.id ? res.data.account : account;
            });
            _this2.$store.state.accounts = accounts;
            _router2.default.push('/super_admin/accounts');
            _vue2.default.toasted.show(_this2.$t('COMMON.MSG_ACC_SUCESS'));
          } else {
            if (res.data.msg) {
              _vue2.default.toasted.show(_this2.$t('COMMON.MSG_UPD_FAIL'), { icon: 'chain-broken', type: 'error' });
            } else {
              _this2.errors = res.data.errors;
              _this2.$refs.errorsModal.show();
            }
          }
        }).catch(function (error) {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_UPD_FAIL'), { icon: 'chain-broken', type: 'error' });
          console.log(error);
        });
      }
    },

    changeAutoExportStatus: function changeAutoExportStatus(event) {
      this.account.salesforce_auto_export = event;
    },
    resetForm: function resetForm() {
      this.account = {
        name: null,
        account_type: null,
        ocr_engine: null,
        expires_at: null,
        integration_emails: [],
        notification_emails: [],
        process_categories: [],
        salesforce_auto_export: false
      };
      this.integration_emails = '';
      this.notification_emails = '';
      this.$v.account.$reset();
      this.$refs.file.value = null;
      this.file_image = null;
    },
    hideErrorsModal: function hideErrorsModal() {
      this.errors = [];
      this.$refs.errorsModal.hide();
    },
    fileHandle: function fileHandle() {
      var _this3 = this;

      this.file = this.$refs.file.files[0];
      var reader = new window.FileReader();
      reader.onload = function (evt) {
        _this3.file_image = evt.target.result;
      };
      reader.readAsDataURL(this.file);
    }
  },
  validations: {
    account: {
      name: {
        required: _validators.required,
        minLen: (0, _validators.minLength)(5),
        isUnique: function isUnique(value, vm) {
          var _this4 = this;

          if (value === '') return true;
          var isUniqueName = true;
          this.$store.state.accounts.forEach(function (account) {
            if (account.id !== _this4.account.id && account.name === value) {
              isUniqueName = false;
            }
          });
          return isUniqueName;
        }
      },
      account_type: {
        required: _validators.required
      },
      ocr_engine: {
        required: _validators.required
      },
      expires_at: {
        required: _validators.required,
        isValid: function isValid(value, vm) {
          return (0, _moment2.default)(value) >= (0, _moment2.default)(vm.currDate);
        }
      },
      integration_emails: {
        $each: {
          email: _validators.email
        }
      },
      notification_emails: {
        $each: {
          email: _validators.email
        }
      },
      process_categories: {
        isValid: function isValid(value, vm) {
          return value.length > 0;
        }
      }
    }
  }
};

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _validators = __webpack_require__(32);

var _lodash = __webpack_require__(45);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      model_name: '',
      polling: null,
      model_status: [],
      model_id: null,
      undeployed_models: null,
      tempOptions: [],
      options: [],
      selected_model: null
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'isSuperAdmin']), {
    setOptions: function setOptions() {
      var arrayStatus = [];
      this.model_status.forEach(function (element) {
        arrayStatus.push(element.model_id);
      });
      this.tempOptions = this.tempOptions.filter(function (element) {
        return !arrayStatus.includes(element.value);
      });
      this.options = [{ text: this.$t('FORMS.SELECT_MODEL'), value: null, disabled: true }];
      this.options = this.options.concat(this.tempOptions.map(function (modelType) {
        return { text: modelType.text, value: modelType.value };
      }));
      return this.options;
    }
  }),
  validations: {
    model_name: {
      required: _validators.required,
      isUnique: function isUnique(value, vm) {
        var _this = this;

        if (value === '') return true;
        return new Promise(function (resolve, reject) {
          resolve(!_lodash2.default.some(_this.model_status, { 'name': value.toUpperCase() }));
        });
      }
    },
    model_id: {
      required: _validators.required
    }
  },
  created: function created() {
    var _this2 = this;

    this.polling = setInterval(function () {
      _this2.fetchModelStatus();
    }, 60000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.polling);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var _this3 = this;

    next(function (vm) {
      if (vm.isSuperAdmin) {
        _vue2.default.axios.get('admin/manage_models', { headers: { Authorization: 'Bearer ' + vm.idToken } }).then(function (res) {
          vm.model_status = res.data.status;
          vm.undeployed_models = res.data.undeployed_models;
          for (var key in vm.undeployed_models) {
            if (vm.undeployed_models.hasOwnProperty(key)) {
              var option = {};
              option.text = vm.undeployed_models[key].name;
              option.value = key;
              vm.tempOptions.push(option);
            }
          }
          next();
        }).catch(function (error) {
          if (error.status === 401) {
            _vue2.default.toasted.show(vm.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
            console.log(_this3.$t('COMMON.MSG_EXPIRED'));
          } else {
            _vue2.default.toasted.show(vm.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      } else {
        _router2.default.replace('/Not-Found-404');
      }
    });
  },

  methods: {
    resetModal: function resetModal() {
      this.model_name = '';
      this.model_id = null;
    },
    handleOk: function handleOk(bvModalEvt) {
      if (this.model_id && this.model_name) {
        this.handleSubmit();
      } else {
        this.$v.model_name.$touch();
        this.$v.model_id.$touch();
        bvModalEvt.preventDefault();
      }
    },
    handleSubmit: function handleSubmit() {
      var _this4 = this;

      var newModel = {};
      newModel.model_id = this.model_id;
      newModel.default_name = this.undeployed_models[this.model_id].name;
      newModel.name = this.model_name.toUpperCase();
      newModel.status = this.undeployed_models[this.model_id].status;
      _vue2.default.axios.post('admin/manage_models/add_model', { newModel: newModel }, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.data.msg === 'success') {
          _vue2.default.toasted.show(res.data.msg);
          _this4.model_status.push(res.data.model);
        } else {
          _vue2.default.toasted.show(res.data.error, { type: 'error' });
        }
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this4.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this4.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this4.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
      this.$nextTick(function () {
        _this4.$refs.modal.hide();
      });
    },

    deploy: function deploy(id) {
      var _this5 = this;

      _vue2.default.axios.post('admin/manage_models/' + id + '/deploy', {}, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.data.state === 'deploy') {
          _vue2.default.toasted.show(res.data.msg);
          for (var i = 0; i < _this5.model_status.length; i = i + 1) {
            if (_this5.model_status[i].id === id) {
              _this5.model_status[i].status = 'DEPLOYING';
            }
          }
        } else {
          _vue2.default.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this5.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this5.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this5.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    undeploy: function undeploy(id) {
      var _this6 = this;

      _vue2.default.axios.post('admin/manage_models/' + id + '/undeploy', {}, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.data.state === 'undeploy') {
          _vue2.default.toasted.show(res.data.msg);
          for (var i = 0; i < _this6.model_status.length; i = i + 1) {
            if (_this6.model_status[i].id === id) {
              _this6.model_status[i].status = 'UNDEPLOYING';
            }
          }
        } else {
          _vue2.default.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' });
        }
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this6.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this6.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this6.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    fetchModelStatus: function fetchModelStatus() {
      var _this7 = this;

      if (this.isSuperAdmin) {
        _vue2.default.axios.get('admin/manage_models', { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
          _this7.model_status = res.data.status;
        }).catch(function (error) {
          if (error.status === 401) {
            _vue2.default.toasted.show(_this7.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
            console.log(_this7.$t('COMMON.MSG_EXPIRED'));
          } else {
            _vue2.default.toasted.show(_this7.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      } else {
        _router2.default.replace('/Not-Found-404');
      }
    },
    confirmDeleteModel: function confirmDeleteModel(id) {
      this.selected_model = id;
      this.$refs.delete_model.show();
    },
    cancelDelete: function cancelDelete() {
      this.selected_model = null;
    },
    deleteModel: function deleteModel() {
      var _this8 = this;

      if (this.selected_model) {
        _vue2.default.axios.post('admin/manage_models/delete_model?id=' + this.selected_model, {}, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
          if (res.data.status === 'success') {
            _this8.model_status.forEach(function (element) {
              if (element.id === _this8.selected_model) {
                _this8.tempOptions.push({ 'text': element.default_name, 'value': element.model_id });
              }
            });
            _this8.model_status = _this8.model_status.filter(function (model) {
              return model.id !== parseInt(res.data.id, 10);
            });
            _vue2.default.toasted.show(res.data.status);
          } else {
            _vue2.default.toasted.show(res.data.status, { icon: 'chain-broken', type: 'error' });
          }
        }).catch(function (error) {
          if (error.status === 401) {
            _vue2.default.toasted.show(_this8.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
            console.log(_this8.$t('COMMON.MSG_EXPIRED'));
          } else {
            _vue2.default.toasted.show(_this8.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          }
        });
      }
    }
  }
};

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _svg = __webpack_require__(28);

var _svg2 = _interopRequireDefault(_svg);

var _animatedNumberVue = __webpack_require__(191);

var _animatedNumberVue2 = _interopRequireDefault(_animatedNumberVue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      totalTemplate: 0,
      svg: _svg2.default,
      boxes: [{ name: 'Reports', icon: 'reports', path: '/reports/form', show: true }, { name: 'Models', icon: 'Models', path: '/super_admin/models', show: false }, { name: 'Users', icon: 'users', path: '/admin/users', show: false }, { name: 'Logs', icon: 'logs', path: 'audits/trail', show: false }, { name: 'Settings', icon: 'settings', path: '/settings/configure', show: false }],
      processForms: null,
      teamID: null,
      userID: null
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['isAdmin', 'isSuperAdmin', 'idToken', 'isAdminRole']), {
    show_all: function show_all() {
      return this.isAdmin || this.isSuperAdmin;
    }
  }),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var _this = this;

    next(function (vm) {
      vm.boxes.slice(1).forEach(function (box, index) {
        if (box['name'] === 'Settings') {
          box['show'] = vm.isAdmin;
        } else if (box['name'] === 'Models') {
          box['show'] = vm.isSuperAdmin;
        } else {
          box['show'] = vm.isAdmin || vm.isSuperAdmin;
        }
      });
      _vue2.default.axios.get('/reports/teams_and_users', { headers: { Authorization: 'Bearer ' + vm.idToken } }).then(function (res) {
        vm.userID = vm.isAdminRole ? null : res.data.user_id;
        vm.teamID = vm.isAdminRole ? -1 : res.data.team_id;
        vm.fetchReports();
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(vm.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(vm.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          next(false);
        }
      });
    });
  },
  created: function created() {
    this.fetchDailyReports();
  },

  methods: {
    formatNumber: function formatNumber(value) {
      return value.toFixed(0);
    },
    fetchDailyReports: function fetchDailyReports() {
      var _this2 = this;

      _vue2.default.axios.get('reports/daily_report', { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {}).catch(function (error) {
        console.log(error);
        if (error.status === 401) {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    },
    fetchReports: function fetchReports() {
      var _this3 = this;

      _vue2.default.axios.get('/template_docs', { headers: { Authorization: 'Bearer ' + this.idToken }, params: { teamID: this.teamID, userID: this.userID } }).then(function (res) {
        _this3.totalTemplate = res.data.template_docs.length;
        _this3.processForms = res.data.processed_forms;
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this3.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    }
  },
  components: {
    AnimatedNumber: _animatedNumberVue2.default
  }
};

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

var _svg = __webpack_require__(28);

var _svg2 = _interopRequireDefault(_svg);

var _validators = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      user: {
        role: '',
        username: '',
        email: '',
        password: '',
        password_new: '',
        password_confirm: ''
      },
      changePassword: true,
      teamName: '',
      lastLogin: '',
      selected: '',
      accountName: '',
      members: '',
      svg: _svg2.default,
      showPassword: false
    };
  },

  validations: {
    user: {
      password: {
        required: _validators.required,
        minLen: (0, _validators.minLength)(8)
      },
      password_new: {
        required: _validators.required,
        minLen: (0, _validators.minLength)(8)
      },
      password_confirm: {
        required: _validators.required,
        sameAs: (0, _validators.sameAs)(function (vm) {
          return vm.password_new;
        })
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var _this = this;

    next(function (vm) {
      _vue2.default.axios.get('/users/' + vm.currentUserId, { headers: { Authorization: 'Bearer ' + vm.idToken } }).then(function (res) {
        var user = res.data.user;
        vm.user.username = user.username;
        vm.user.email = user.email;
        vm.user.role = vm.userRole;
        vm.accountName = user.account_name;
        vm.members = user.account_members;
        vm.teamName = user.team_id ? user.teams.filter(function (team) {
          return team.id === user.team_id;
        })[0].name : 'N/A';
        vm.lastLogin = user.last_login_at;
        next();
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(vm.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(vm.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
          next(false);
        }
      });
    });
  },

  methods: {
    resetUpdatePassword: function resetUpdatePassword() {
      this.user.password = '';
      this.user.password_new = '';
      this.user.password_confirm = '';
      this.changePassword = !this.changePassword;
    },
    updatePassword: function updatePassword() {
      var _this2 = this;

      var data = new window.FormData();
      data.append('username', this.user.username);
      data.append('current_password', this.user.password);
      data.append('password', this.user.password_new);
      data.append('password_confirmation', this.user.password_confirm);
      _vue2.default.axios.patch('/users/' + this.currentUserId, data, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        if (res.data.error) {
          _vue2.default.toasted.show(res.data.error, { icon: 'chain-broken', type: 'error' });
        } else if (res.data.status === 101) {
          _vue2.default.toasted.show(_this2.$t('PROFILE.WRONG_PASSWORD'), { icon: 'chain-broken', type: 'error' });
        } else {
          _vue2.default.toasted.show(_this2.$t('PROFILE.UPDATE_SUCCESS'));
          _this2.changePassword = !_this2.changePassword;
        }
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' });
          console.log(_this2.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show(_this2.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' });
        }
      });
    }
  },
  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'currentUserId', 'userRole', 'currentUserEmail']), {
    getPasswordIcon: function getPasswordIcon() {
      var passwordIcon = void 0;
      if (this.showPassword) {
        passwordIcon = _svg2.default.eyeSlash;
      } else {
        passwordIcon = _svg2.default.eye;
      }
      return passwordIcon;
    },
    getRoles: function getRoles() {
      if (this.user.role === 'super admin') {
        return this.$t('PROFILE.ROLES.SUPERADMIN');
      } else if (this.user.role === 'admin') {
        return this.$t('PROFILE.ROLES.ADMIN');
      } else {
        return this.user.role;
      }
    },
    getAccountName: function getAccountName() {
      if (this.accountName === 'default') {
        return this.$t('PROFILE.ACCNAME.DEFAULT');
      } else {
        return this.accountName;
      }
    }
  })
};

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _svg = __webpack_require__(28);

var _svg2 = _interopRequireDefault(_svg);

var _vue2Dropzone = __webpack_require__(186);

var _vue2Dropzone2 = _interopRequireDefault(_vue2Dropzone);

__webpack_require__(188);

var _vuex = __webpack_require__(5);

var _micpHeaderAccount = __webpack_require__(270);

var _micpHeaderAccount2 = _interopRequireDefault(_micpHeaderAccount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'micpDemo',
  components: {
    vueDropzone: _vue2Dropzone2.default,
    MicpHeaderAccount: _micpHeaderAccount2.default
  },
  data: function data() {
    return {
      svg: _svg2.default,
      currentState: 'upload',
      isDropzoneBlank: false,
      isUploadEnabled: false,
      dropzoneOptions: {
        url: "/api" + '/micp',
        dictDefaultMessage: 'Click here / Drag and drop a file here to process',
        autoProcessQueue: false,
        thumbnailWidth: 100,
        thumbnailHeight: 100,
        parallelUploads: 1,
        maxFilesize: 10,
        maxFiles: 1,
        timeout: 300000,
        acceptedFiles: 'application/pdf, image/*',
        headers: { 'Authorization': '' },
        init: function init() {
          this.on('addedfile', function (file) {
            file.previewElement.querySelector('.dz-details').style.backgroundColor = '#0b192d';
            var removeButton = document.createElement('div');
            removeButton.className = 'removeFormButton';
            removeButton.style.cssText = 'opacity:1;z-index:1000;position:absolute;top:5px;right:5px;color:white;';
            removeButton.innerHTML = '<i class="fa fa-trash"></i>';
            var _this = this;
            removeButton.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();

              _this.removeFile(file);
            });
            file.previewElement.appendChild(removeButton);
          });
        }
      },
      results: {},
      processedResults: {
        'provider': '',
        'name': '',
        'id': '',
        'group number': '',
        'pcp': '',
        'pcp phone': '',
        'rxbin': '',
        'rxpcn': '',
        'rxgrp': '',
        'copay': ''
      }
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['idToken', 'accountId']), {
    canShowDropZone: function canShowDropZone() {
      this.dropzoneOptions.headers['Authorization'] = 'Bearer ' + this.idToken;
      return this.idToken !== '';
    },
    currentYear: function currentYear() {
      return new Date().getFullYear();
    },
    isDownloadEnabled: function isDownloadEnabled() {
      return this.results.processed_values && this.results.processed_values.length > 0;
    },
    buttonState: function buttonState() {
      if (this.currentState === 'upload') {
        return 'Upload & Process';
      } else if (this.currentState === 'processing') {
        return 'Uploading & Processing...';
      } else if (this.currentState === 'processed') {
        return 'Try another document';
      }
    },
    imageUrl: function imageUrl() {
      return 'data:image/jpg;base64,' + this.results.image;
    }
  }),
  methods: {
    processFile: function processFile() {
      if (this.currentState === 'upload') {
        var myDropzone = this.$refs.micpProcessDropZone.dropzone;
        myDropzone.processQueue();
        myDropzone.on('complete', function (file) {
          myDropzone.removeFile(file);
        });
      } else {
        this.currentState = 'upload';
        this.isUploadEnabled = false;
        this.isDropzoneBlank = false;
        this.results = {};
        this.processedResults = {
          'provider': '',
          'name': '',
          'id': '',
          'group number': '',
          'pcp': '',
          'pcp phone': '',
          'rxbin': '',
          'rxpcn': '',
          'rxgrp': '',
          'copay': ''
        };
      }
    },
    processResponse: function processResponse(file, response) {
      this.currentState = 'processed';
      this.results = response;
      var processedValues = Object.assign({}, this.processedResults);
      response.processed_values.forEach(function (pv, index) {
        if (processedValues.hasOwnProperty(pv['key'])) {
          processedValues[pv['key']] = pv['text'];
        }
      });
      this.processedResults = processedValues;
      this.isUploadEnabled = true;
      this.isDropzoneBlank = false;
    },
    displayError: function displayError(file, message, xhr) {
      _vue2.default.toasted.show('Something went wrong! Please try again.', { icon: 'chain-broken', type: 'error' });
      this.currentState = 'upload';
      this.isUploadEnabled = false;
      this.isDropzoneBlank = false;
      this.results = {
        'provider': '',
        'name': '',
        'id': '',
        'group number': '',
        'pcp': '',
        'pcp phone': '',
        'rxbin': '',
        'rxpcn': '',
        'rxgrp': '',
        'copay': ''
      };
    },
    downloadJSON: function downloadJSON() {
      var processedData = this.results.processed_values.map(function (pv) {
        return { key: pv.key, value: pv.text };
      });
      var fileName = this.results.image.split('/')[this.results.image.split('/').length - 1];
      fileName = fileName.split('_').slice(1).join('_');
      fileName = fileName.replace('-page-1.jpg', '');
      var mimeType = 'application/json';
      var fileType = '.json';
      var blob = new window.Blob([JSON.stringify(processedData)], { type: mimeType });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName.replace('.jpg', '') + fileType;
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    onAddingFile: function onAddingFile() {
      var myDropzone = this.$refs.micpProcessDropZone.dropzone;
      this.isUploadEnabled = myDropzone.files.length === 1;
      this.isDropzoneBlank = false;
    },
    sendingEvent: function sendingEvent(file, xhr, formData) {
      this.currentState = 'processing';
      this.isUploadEnabled = false;
    },
    onExceedingMaxFiles: function onExceedingMaxFiles() {
      _vue2.default.toasted.show('Max files allowed is 1', { icon: 'chain-broken', type: 'error' });
    },
    onRemovingFile: function onRemovingFile() {
      var myDropzone = this.$refs.micpProcessDropZone.dropzone;
      if (this.currentState === 'upload') {
        this.isDropzoneBlank = myDropzone.files.length === 0;
        this.isUploadEnabled = myDropzone.files.length === 1;
      }
      if (myDropzone.getRejectedFiles().length > 0 && myDropzone.getAcceptedFiles().length < myDropzone.options.maxFiles) {
        myDropzone.getRejectedFiles()[0]['status'] = 'queued';
        myDropzone.getRejectedFiles()[0]['previewTemplate']['classList'].remove('dz-error');
        myDropzone.getRejectedFiles()[0]['previewTemplate']['classList'].remove('dz-complete');
        myDropzone.getRejectedFiles()[0]['accepted'] = true;
      }
    }
  }
};

/***/ }),
/* 531 */,
/* 532 */,
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(534);
module.exports = __webpack_require__(736);


/***/ }),
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapVue = __webpack_require__(739);

var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);

var _vuelidate = __webpack_require__(877);

var _vuelidate2 = _interopRequireDefault(_vuelidate);

var _vueGravatar = __webpack_require__(879);

var _vueGravatar2 = _interopRequireDefault(_vueGravatar);

var _vue2Filters = __webpack_require__(880);

var _vue2Filters2 = _interopRequireDefault(_vue2Filters);

var _vueTreeHalower = __webpack_require__(881);

var _vueTreeHalower2 = _interopRequireDefault(_vueTreeHalower);

var _vueMatchHeights = __webpack_require__(882);

var _vueMatchHeights2 = _interopRequireDefault(_vueMatchHeights);

__webpack_require__(883);

__webpack_require__(884);

var _vueContentPlaceholders = __webpack_require__(885);

var _vueContentPlaceholders2 = _interopRequireDefault(_vueContentPlaceholders);

var _vue2Transitions = __webpack_require__(887);

var _vue2Transitions2 = _interopRequireDefault(_vue2Transitions);

var _vuexI18n = __webpack_require__(888);

var _vuexI18n2 = _interopRequireDefault(_vuexI18n);

var _en = __webpack_require__(889);

var _en2 = _interopRequireDefault(_en);

var _fr = __webpack_require__(890);

var _fr2 = _interopRequireDefault(_fr);

var _es = __webpack_require__(891);

var _es2 = _interopRequireDefault(_es);

var _App = __webpack_require__(892);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(133);

var _store2 = _interopRequireDefault(_store);

__webpack_require__(1331);

__webpack_require__(1333);

var _vueRippleDirective = __webpack_require__(1335);

var _vueRippleDirective2 = _interopRequireDefault(_vueRippleDirective);

__webpack_require__(1336);

__webpack_require__(1337);

__webpack_require__(1338);

var _cryptoJs = __webpack_require__(320);

var _cryptoJs2 = _interopRequireDefault(_cryptoJs);

__webpack_require__(1339);

var _axios = __webpack_require__(112);

var _axios2 = _interopRequireDefault(_axios);

var _vueAxios = __webpack_require__(531);

var _vueAxios2 = _interopRequireDefault(_vueAxios);

var _axiosAuthRefresh = __webpack_require__(532);

var _axiosAuthRefresh2 = _interopRequireDefault(_axiosAuthRefresh);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


var refresherAxiosInstance = _axios2.default.create();

_vue2.default.use(_bootstrapVue2.default);
_vue2.default.use(_vuelidate2.default);
_vue2.default.use(_vue2Filters2.default);
_vue2.default.use(_vueTreeHalower2.default);
_vue2.default.use(_vueMatchHeights2.default, {});
_vue2.default.use(_vueContentPlaceholders2.default);
_vue2.default.use(_vue2Transitions2.default);
_vue2.default.use(_vuexI18n2.default.plugin, _store2.default);
_vue2.default.directive('ripple', _vueRippleDirective2.default);
_vue2.default.use(_vueAxios2.default, _axios2.default);
_vue2.default.axios.defaults.baseURL = "/api";
var refreshAuthLogic = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(failedRequest) {
    var refreshToken, data, headers;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!failedRequest.request.responseURL.includes('/logout')) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return', Promise.reject(new Error('Error')));

          case 2:
            refreshToken = _store2.default.getters.refreshToken;
            data = new window.FormData();

            data.append('auth[refresh_token]', refreshToken);
            headers = { headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0'
              } };
            _context.next = 8;
            return refresherAxiosInstance.post('/refresh', data, headers).then(function (res) {
              var _ref2 = res.data || {},
                  _ref2$enc_data = _ref2.enc_data;

              _ref2$enc_data = _ref2$enc_data === undefined ? {} : _ref2$enc_data;
              var _ref2$enc_data$iv = _ref2$enc_data.iv,
                  iv = _ref2$enc_data$iv === undefined ? null : _ref2$enc_data$iv,
                  _ref2$enc_data$data = _ref2$enc_data.data,
                  data = _ref2$enc_data$data === undefined ? null : _ref2$enc_data$data;

              if (iv && data) {
                var key = _cryptoJs2.default.enc.Base64.parse("el+Wp8rTW1hOJCr6XHJa2xMRo24NgT0wl+I1tWWQO0E=".replace(/\n/g, ''));
                iv = _cryptoJs2.default.enc.Base64.parse(iv.replace(/\n/g, ''));
                data = data.replace(/\n/g, '');
                var decrypted = _cryptoJs2.default.AES.decrypt(data, key, { iv: iv });
                try {
                  var jsonPayload = _cryptoJs2.default.enc.Utf8.stringify(decrypted);
                  res.data = JSON.parse(jsonPayload);
                } catch (error) {
                  console.error(error);
                }
              }
              var token = res.data.token.token;
              if (token) {
                _store2.default.dispatch('updateToken', { token: token });
                failedRequest.response.config.baseURL = '';
                failedRequest.response.config.headers['Authorization'] = 'Bearer ' + token;
                return Promise.resolve();
              } else {
                return Promise.reject(new Error('Error'));
              }
            });

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function refreshAuthLogic(_x) {
    return _ref.apply(this, arguments);
  };
}();
(0, _axiosAuthRefresh2.default)(_vue2.default.axios, refreshAuthLogic);
_vue2.default.axios.interceptors.request.use(function (config) {
  // console.log(config)
  if (config.url.startsWith('/api')) {
    config.url = config.url.replace(/^\/api(\/api)?/, '');
    config.baseURL = "/api";
  }
  if (config.url.includes('/admin') || config.url.includes('/users')) {
    config.headers['Cache-Control'] = 'no-cache, no-store';
    config.headers['Pragma'] = 'no-cache';
    config.headers['Expires'] = '0';
  }
  var token = _store2.default.getters.idToken;
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token;
  }
  vueApp.$Progress.start();
  return config;
}, function (error) {
  vueApp.$Progress.fail();
  return error;
});
_vue2.default.axios.interceptors.response.use(function (config) {
  var _ref3 = config.data || {},
      _ref3$enc_data = _ref3.enc_data;

  _ref3$enc_data = _ref3$enc_data === undefined ? {} : _ref3$enc_data;
  var _ref3$enc_data$iv = _ref3$enc_data.iv,
      iv = _ref3$enc_data$iv === undefined ? null : _ref3$enc_data$iv,
      _ref3$enc_data$data = _ref3$enc_data.data,
      data = _ref3$enc_data$data === undefined ? null : _ref3$enc_data$data;

  if (iv && data) {
    var key = _cryptoJs2.default.enc.Base64.parse("el+Wp8rTW1hOJCr6XHJa2xMRo24NgT0wl+I1tWWQO0E=".replace(/\n/g, ''));
    iv = _cryptoJs2.default.enc.Base64.parse(iv.replace(/\n/g, ''));
    data = data.replace(/\n/g, '');
    var decrypted = _cryptoJs2.default.AES.decrypt(data, key, { iv: iv });
    try {
      var jsonPayload = _cryptoJs2.default.enc.Utf8.stringify(decrypted);
      config.data = JSON.parse(jsonPayload);
    } catch (error) {
      console.error(error);
    }
  }
  vueApp.$Progress.finish();
  return config;
}, function (error) {
  var apiPattern = /^\/api\/api/;
  var url = error.response.config.url;
  if (apiPattern.test(url)) {
    error.response.config.url = error.response.config.url.replace(apiPattern, '/api');
    error.response.config.baseURL = '';
  }
  vueApp.$Progress.fail();
  if (error.response && error.response.status === 401 && _router2.default.currentRoute.path !== '/sign_in') {
    _vue2.default.toasted.clear();
    _vue2.default.toasted.show('Session expired, please login to continue', { icon: 'chain-broken', type: 'error', singleton: true });
    _store2.default.dispatch('logOut');
    console.log('sing in route');
    _router2.default.replace('/sign_in?redirect_to=' + encodeURIComponent(_router2.default.currentRoute.fullPath));
  }
  return Promise.reject(error.response);
});

_vue2.default.i18n.add('en', _en2.default);
_vue2.default.i18n.add('fr', _fr2.default);
_vue2.default.i18n.add('es', _es2.default);
_vue2.default.i18n.set('en');
_vue2.default.i18n.fallback('en');

// TODO: This is a temporary implementation
_vue2.default.component('v-gravatar', _vueGravatar2.default);
window.addEventListener('storage', function (event) {
  if (event.key === 'logout-event') {
    _store2.default.commit('logOut');
    _router2.default.replace('/log_in');
  }
});
/* Application initialize */
var vueApp = new _vue2.default({
  el: '#app',
  router: _router2.default,
  store: _store2.default,
  template: '<App/>',
  components: {
    App: _App2.default
  }
});

// Initilize Axios and setup Interceptors
exports.default = { vueApp: vueApp };

/***/ }),
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(809)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 809 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(817)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 817 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(834)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 834 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(856)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 856 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(861)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 861 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 884 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 885 */,
/* 886 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 887 */,
/* 888 */,
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'AUTH': {
    'CONFIRM_PASSWORD': 'Confirm Password',
    'EMAIL': 'Email',
    'EMPTY_EMAIL': 'Email cannot be empty.',
    'EMPTY_PASSWORD': 'Password cannot be empty.',
    'FORGOT_PASSWORD': 'Forgot Password',
    'INVALID_EMAIL': 'Please provide a valid email.',
    'INVALID_PASSWORD': 'Password should have atleast {MINIMUM} characters.',
    'IDENTICAL_PASSWORD': 'Passwords must be identical.',
    'LINK_EXPIRED': 'Link expired.',
    'LINK_USED': 'Someone has already used this link. If its not you, please reset password again.',
    'LOGIN': 'Login',
    'NEW_PASSWORD': 'New Password',
    'PASSWORD': 'Password',
    'PASSWORD_UPDATED': 'Successfully updated the password.',
    'RESET_LINK_SENT': 'Reset link has been sent to registered email.',
    'RESET_PASSWORD': 'Reset Password',
    'SUBMIT': 'Submit',
    'USER_LOGIN': 'User Login',
    'USER_NOT_FOUND': 'No user found. Please contact admin.',
    'PWD_CHANGE': 'Change Password',
    'PWD_CURRENT': 'Current Password'
  },
  'ERROR': {
    'COMMON': 'Error occurred. Please try again.'
  },
  'HEADER': {
    'TRIAL_USER': 'You are a trial user. Trial Period ends on {END_DATE}.',
    'NOTIFY_MSG': 'You have {len} notifications',
    'CLEAR': 'Clear',
    'TEMPLATES': 'Templates',
    'FORMS': 'Forms',
    'UPLOAD_FORM': 'Upload Form',
    'REPORTS': 'Reports',
    'PROFILE': 'Profile',
    'USERS': 'Users',
    'LOGS': 'Logs',
    'SETTINGS': 'Settings',
    'LOGOUT': 'Logout',
    'ACCOUNTS': 'Accounts',
    'MODELS': 'Models',
    'Features': 'Features'
  },
  'TEMPLATE': {
    'DATE_CATEGORY': 'Date Category',
    'DATE_FORMAT': 'Date Format',
    'ADD_NEW': 'Add a New Template',
    'ENABLE_AUTO_CORRECT': 'Enable Auto Correct: ',
    'CLONE': 'Clone a template from other account.',
    'CREATE_NPI_GROUP': 'Create NPI Group',
    'DATA_TYPE': 'Data Type',
    'DELETE_CONTENT': "Do you want to delete this '{TEMPLATE_TITLE}' template?",
    'DELETE_MAP': 'Delete Mapping (Cmd + d)',
    'DELETE_MODAL': 'Delete Mappings',
    'DELETE_MODAL_CONTENT': 'Are you sure, Do you want to remove the Field?',
    'DRAW': 'Draw',
    'DISABLE_FORM': 'Disable For Form Submission',
    'ENABLE_FORM': 'Enable For Form Submission',
    'ENTER_TITLE': 'Enter title....',
    'ENTER_DESCR': 'Enter template description',
    'GRP_NAME': 'Group Name',
    'GRP_TYPE': 'Group Type',
    'KEY': 'Key',
    'MAPPING_CATEGORY': 'Category',
    'ORDER_OF_OCCUR': 'Order of Occurance',
    'CASE': 'Case',
    'MAPPINGS': 'Mappings:',
    'MSG_ADDED': 'Added template successfully.',
    'MSG_REMOVED': 'Removed template successfully.',
    'MSG_SAVED': 'Editor changes are successfully saved.',
    'MSG_SAVE_FAIL': 'Something went wrong. Saving failed...',
    'NEXT_PAGE': 'Go to next page',
    'NOTHING': 'No templates found!',
    'ESMMAPPINGS': 'External Service Mappings',
    'TEMPLATE_VERSION_UPDATE': 'Do you want to clone the Fields mappings for new template version?',
    'ESM_CLONING': 'External Service Mappings will be cloned',
    'ORTF_CLONING': 'ORTF Mappings will be cloned',
    'SV_CLONING': 'Service Validations will be cloned',
    'HL7_CLONING': 'HL7 Mappings will be cloned',
    'CV_CLONING': 'Custom Validations will be cloned',
    'NPI_GROUP': 'NPI Group',
    'OLDER_VERSIONS': 'Older versions cannot be edited',
    'PREV_PAGE': 'Go to previous page',
    'REDO': 'Redo (Cmd + Shift + z)',
    'REQ': 'Required',
    'EXT': 'Extraction',
    'EXT_BY_WORDS': 'Extract By Words',
    'REDACT_FIELD': 'Redact Field',
    'SHOW_FIELD': 'Show Field',
    'SENS_DATA': 'Sensitive Data',
    'REQ_TYPE': 'Select Process type',
    'REQ_FILE': "File can't be blank",
    'REQ_TITLE': "Title can't be blank",
    'SAVE': 'Save (Cmd + s)',
    'SAVE_CHANGES': 'Do you like to save changes before leaving editor?',
    'SELECT': 'Select (Esc)',
    'SELECT_DATA_TYPE': 'Please select data type',
    'SELECT_DATE_FORMAT': 'Please select date format',
    'SELECT_TYPE': 'Please select type',
    'SELECT_FROM_ACCOUNT': 'From Account',
    'SELECT_TO_ACCOUNT': 'To Account',
    'SELECT_ACCOUNT': 'Select Account',
    'SELECT_TEMPLATE': 'Select Template',
    'SELECT_CASE': 'Select Case',
    'TEMPLATE': 'Template',
    'THEME': 'Theme',
    'THUMBNAIL': 'Thumbnail',
    'TRAIN': 'Train',
    'TRAIN_BASE': 'Train Base Template:',
    'TYPE': 'Type',
    'UPDATE_MAP': 'Update Mapping',
    'UPDATE_GRP': 'Update Group',
    'UNDO': 'Undo (Cmd + z)',
    'UNSAVE': 'Unsaved Changes',
    'ZOOM_IN': 'Zoom In (Cmd+ +)',
    'ZOOM_OUT': 'Zoom Out (Cmd+ -)',
    'IMPORT': 'Import',
    'EXPORT': 'Export',
    'ALIAS': 'Alias',
    'UPLOAD_MAPPINGS': 'Upload Mappings File'
  },
  'TEMPLATE_VIEW': {
    'ID': 'ID',
    'PAGES': ' PAGE(S)',
    'TOTAL_PAGES': 'Total Page(s)',
    'UPDATED_AT': 'Updated at',
    'VIEW': 'VIEW:',
    'BRAND': 'Brand'
  },
  'DATA_TYPE': {
    'ALPHA': 'Alphabets',
    'ALPHANUM': 'Alphanumeric',
    'ALPHANUMSPC': 'Alphanumeric With Spaces',
    'NUMERICDEC': 'Numeric With Decimal',
    'BLOCK': 'Block',
    'CHECKBOX': 'Checkbox',
    'CITY': 'City',
    'COMBINE_DATA': 'Combine Data',
    'NAME': 'name',
    'CHECKBOX_TEXT': 'Checkbox Text',
    'DATE': 'Date',
    'DEFAULT': 'Default',
    'EITHER': 'Either-or Choice',
    'LOGICAL': 'Logical',
    'MULTI_CHOICE': 'Multiple Choice',
    'NPI': 'NPI',
    'NUMERIC': 'Numeric',
    'STATE': 'State',
    'TABLE_COLUMN': 'Table ( Column Data )',
    'TABLE_ENTRY': 'Table Entry',
    'TABLE_HEADER': 'Table Header',
    'TABLE_ROW': 'Table ( Row Data )',
    'TEXT': 'Text',
    'ZIPCODE': 'Zipcode',
    'CAPITALIZE': 'Capitalize the First Letter of Field',
    'UPPER_CASE': 'Upper Case',
    'LOWER_CASE': 'Lower Case',
    'SECTION': 'Section'
  },
  'COLOR': {
    'BLUE': 'Blue',
    'GREEN': 'Green',
    'RED': 'Red'
  },
  'UPLOAD_DROPDOWN': {
    'ENROLLMENT_FORMS': 'Enrollment forms',
    'SELECT': 'Select',
    'AUTO': 'Auto match',
    'PLAIN': 'Plain text',
    'INSURANCE': 'Insurance card',
    'INSU_F_B': 'Front and back insurance cards',
    'MANUAL': 'Manual',
    'DL': 'Drivers License/Voter ID',
    'INVOICE': 'Invoice',
    'EXCEL': 'Excel Workbook',
    'LEASE': 'Lease Document',
    'SLA': 'Software Licensing Agreement',
    'AUS_LEASE': 'Australian Lease Document',
    'MEDTRONIC': 'Medtronic',
    'MEDTRONIC2': 'Medtronic-2',
    'BIOTRONIK': 'Biotronik',
    'BOSTON': 'Boston Scientific',
    'TRIAGING': 'Triaging'
  },
  'FORMS': {
    'ROTATE_LEFT': 'Rotate Left',
    'ROTATE_RIGHT': 'Rotate Right',
    'IMAGE_ROTATE_SUCCESS': 'Image rotation successful',
    'IMAGE_ROTATE_FAIL': 'Image Rotation Failed',
    'MULTI_USER_MODAL': 'WARNING',
    'MULTI_USER_ALERT_MSG': 'Currently another user is viewing this Document. Kindly validate other document',
    'ACCEPT_PERMISSION_ERROR': 'Cannot accept form permission required!',
    'NEXT_FORM': '<< Next document',
    'PREV_FORM': 'Previous document >>',
    'SELECT_MODEL': 'Select Model',
    'MODEL_NAME': 'Model name',
    'MODEL_NAME_ERR': 'Model name can\'t be blank',
    'USE_TITLE': 'Use same title for all forms',
    'CONF_RANGE': 'Confidence Range',
    'CHECK_ELIG_BTN_LABEL': 'Check Eligibility',
    'CHECK_ELIG_SUCC_MESSAGE': 'Eligibility Check Successful',
    'CHECKING_ELIG_BTN_LABEL': 'Checking Eligibility',
    'AVG_CONF': 'Average Confidence',
    'COMP_IMAGES': 'Compare with uploaded images',
    'NO_LINE_ITEMS': 'No Line Items to Display...',
    'ACCEPT': 'Export',
    'VERIFY': 'Verify',
    'APPROVED': 'APPROVED',
    'ADD_FIELD': 'Add Field',
    'ALL': 'For all the Forms',
    'CON_SCORE': 'Confidence Score',
    'CHANGE_LABEL': 'Change Label',
    'CHOOSE': 'Choose a form...',
    'DELETE_CONTENT': 'Do you want to delete {FIELD_NAME} field?',
    'DESCRIPT_PLACE': 'Enter Form Description',
    'DROP_SCANNED': 'Click here / Drag and drop files here to process',
    'DROP_TEMP_SCANNED': 'Click here / drag and drop files to upload',
    'EDITED': 'Edited',
    'AUTO_CORRECT': 'Auto Correct',
    'AUTO_CORRECT_CONTENT': 'Updated value will be used futhur ,are you sure you want to save ?',
    'EXPORT_ERROR': 'Salesforce Export Mappings Error',
    'FORCED_TEMPLATE': 'Forced template',
    'LABEL': 'Label',
    'LABEL_NAME': 'Label Name',
    'MATCH': 'Match',
    'MATCHING_TEMPLATE': 'View Matching Template',
    'MSG_ACCEPT': 'Form accepted',
    'MSG_DEL': 'Data deleted successfully',
    'MSG_LABEL': 'Label changed successfully',
    'MSG_SUCESS': 'Data updated successfully',
    'MSG_WARN': 'Uploaded form is not processed',
    'NOTHING': 'No data to display...',
    'ONLY': 'Only for this Form',
    'PENDING': 'PENDING',
    'PAGES_WITH_DATA': 'Pages with data',
    'PROCESS_TYPE': 'Process Type',
    'PROCESSED_DATA': 'Processed Data',
    'PROCESSING_STAT': 'Uploaded forms are being processed... Please wait',
    'PROCESSED_STAT_ONE': 'New form has been processed. Click to refresh',
    'PROCESSED_STAT_MANY': 'New forms have been processed. Click to refresh',
    'REJECTED': 'REJECTED',
    'REQ_TITLE': "Title can't be blank",
    'REQ_LABEL': "Name can't be blank",
    'REQ_FILE': "File can't be blank",
    'SELECT_PAGE_NUM': 'Page: ',
    'TABLE_DATA': 'Table Data',
    'TEMPLATE': 'Template',
    'TITLE_PLACE': 'Form Title...',
    'UPLOAD_PROCESS': 'Upload and processing...',
    'UPLOADING': 'Uploading...',
    'UPLOAD_A_FORM': 'Upload A Scanned Form',
    'UPLOAD_MULTI_FORMS': 'Upload Scanned Forms',
    'VALUE': 'Value',
    'VALIDATION_HEADER': 'Please correct / fix the following fields',
    'VALIDATE_SIGNATURE': 'Please approve / reject signature to verify',
    'VALIDATIONS': 'Validation Errors',
    'REQUIRED_FIELDS_VALIDATION': 'Required Fields Errors',
    'SERVICE_VALIDATION': 'Service Validation Errors',
    'VALIDATION_ERROR': 'Validation Errors',
    'SERACH_PLACEHOLDER': 'Search for Process Value',
    'OPTIONAL_FIELDS_VALIDATION': 'Optional Fields Errors'
  },
  'WORKFLOW': {
    'ACTIONS': 'Actions',
    'ANALYSE': 'Analyse',
    'ANALYSIS': 'Analysis',
    'TITLE': 'File Name',
    'INVOICE': 'Invoice',
    'DOWNLOAD': 'Download',
    'FILTER': 'Filters',
    'FILTERS': 'Filters',
    'MATCH': 'Match',
    'GROUP_ID': 'Group ID',
    'PROCESSED_FORMS': 'Processed Forms',
    'PROCESS_PAGE_COUNT': 'Processed Page Count',
    'PAGE_COUNT': 'Page Count',
    'MATCHED_PAGE_COUNT': 'Matched Page Count',
    'REJECT_PAGE_COUNT': 'Rejected Page Count',
    'SEARCH': 'Type to Search',
    'UPDATED_AT': 'Updated at',
    'CREATED_AT': 'Created at',
    'DOC_RECIEVED_AT': 'Document Recieved at',
    'TIME_DIFF': 'Time Difference',
    'TURN_AROU_TIME': 'Turnaround Time',
    'DELETE_FORM': "Do you want to delete this '{FORM_TITLE}' form?",
    'FAX_NUMBER': 'Fax Number',
    'ENTER_FAX_NUMBER': 'Enter Fax Number',
    'DELETE': 'Delete Forms',
    'FORM_INFO_HEADER': 'Processed Forms Details',
    'DELETE_MULTIPLE': 'Delete Mutliple Forms',
    'REPROCESS': 'Reprocess',
    'MAX_RETRIES': 'Reached Max retries count.',
    'MOVE_TO_MATCHED': 'Move to matched queue',
    'SF_STATUS': 'Status',
    'LOCK_TITLE': 'Locked by {userName}',
    'LOCK_ALERT_MSG': 'Do you want to unlock this record ?',
    'DOCUMENT_TYPE': 'Document Type',
    'PRODUCT': 'Product',
    'REPORT': 'Report'
  },
  'ANALYTICS': {
    'TOTAL_FORMS': 'Total Received Forms',
    'CONFIDENCE': 'Confidence (%)',
    'CONFIDENCE_AVG': 'Template Page Confidence Average (%)',
    'DAILY_REPORT': 'Daily Report',
    'FILTER_TEMPLATES': 'Filter by Templates',
    'FORM_WORKFLOW_STATS': 'Form Workflow Statistics',
    'IDENTIFIED': 'Identified',
    'RECENT_FORMS': 'Recent Forms',
    'FORMS_INSIGHTS': 'Forms Insights',
    'FAXES_RECEIVED': 'Total Number Of Patient Forms Received',
    'FAXES_IDENTIFIED': 'Total Number Of Patient Forms Identified',
    'FAXES_READABLE': 'Total Number Of Patient Forms Readable',
    'FAXES_REJECTED_ORIGIN': 'Total Patient Forms Rejected Based On Country',
    'FAXES_REJECTED_BY_REASON': 'Total Patient Forms Rejected Due To Readability',
    'FAXES_UNPROCESSED': 'Total Patient Forms Not Matched To Template',
    'REJECTED': 'Rejected Reason',
    'WEEKLY_REPORT': 'Weekly Report',
    'TOTAL_PROCESSED': 'Processed',
    'TOTAL_REJECTED': 'Rejected',
    'TEMPLATE': 'Template',
    'PROCESS_TYPE': 'Process Type',
    'SELECT_PROCESS_TYPE': 'Process Type',
    'PAGES': 'Page(s)',
    'RECENT_FORM_MSG': 'Recent forms generated in the CSV will belong to selected date range only.',
    'REPORT_CONTENT': 'Report Content',
    'TOTAL_FIELDS': 'Total Field(s)',
    'TRANSCRIBED_FIELDS': 'Transcribed Field(s)',
    'ACCURACY_PERCENTAGE': 'Accuracy Percentage (%)',
    'EDITED_FIELDS': 'Edited Field(s)'
  },
  'CONFIGURED': {
    'ADD_ROLE': 'Add Role',
    'ADD_GROUP': 'Add Field',
    'ADD_ALIAS': 'Add Alias',
    'ADD_FIELD_ALIAS': 'Add Field aliases',
    'ADD_NEW_KEYS': 'Add New Keys',
    'B_PREVIEW': 'Border Preview',
    'CONFIDENCE_COLORS': 'Confidence Colors',
    'CC_SUCCESS': 'Confidence colors are updated successfully',
    'COLOR': 'Color',
    'CREATE': 'Create',
    'IMPORT_MAPPINGS': 'Import Mappings',
    'EDIT_GROUP': 'Edit Field',
    'EDIT_ALIAS': 'Edit Alias',
    'FORM_ORDER': 'Form Processing Order',
    'FIELD_TYPE': 'Field Type',
    'FIELD_EXISTS': 'Already field exists',
    'FIELDS': 'Fields',
    'FIELDS_ALIASES': 'Field aliases',
    'NEW_ROLE': 'New Role',
    'NOTE': 'Note: Drag/drop the items to change the form processing order',
    'PREVIEW': 'Preview',
    'PROCESS_ORDER_SUCCESS': 'Processing order updated successfully',
    'RANGE': 'Range',
    'ROLE_CREATED': ' role is created successfully',
    'ROLE_MANAGE': 'Role Management',
    'ROLE_NAME': 'Role Name',
    'ROLE_NOTE': 'Note: Drag/drop the items to change the role order',
    'ROLE_ORDER': 'Role Order',
    'ROLE_ORDER_SUCCESS': 'Role Order is updated successfully',
    'ROLE_SUCCESS': 'Roles are updated successfully',
    'SELECT_ROLE': 'Select Role',
    'PROCESS_TYPE': 'Subscribed Process Types',
    'FIELD': 'Field Name',
    'SUBSCRIBE_MODAL': 'Subscribe a New Process Type',
    'UNSUBSCRIBE_MODAL': 'Unsubscribe a Process Type',
    'SUBSCRIBE_PT': 'Successfully subscribed a new process type',
    'UNSUBSCRIBE_PT': 'Successfully unsubscribed',
    'ENTER_SECTION_NAME': 'Enter Section Name',
    'SECTION_ORDER': 'Section Order',
    'SECTION_NOTE': 'Note: Drag/drop the items to change the Section Order',
    'SECTION_ORDER_SUCCESS': 'Section Order is updated successfully',
    'HL7_TEMPLATES': 'HL7 Templates',
    'DOC_RETENTION': 'Rejection Time Period',
    'REQ': 'Required',
    'QUERY': 'Query',
    'FIELD_ALIAS': 'Field Alias'
  },
  'TRAILS': {
    'AUDIT_TRAILS': 'Audit Trails',
    'LOGGED_AT': 'Logged At',
    'LOCATION': 'Location',
    'PATH': 'Path',
    'CUSTOM_DATE_LOGS': 'Custom Date Logs'
  },
  'USERS': {
    'ACCOUNT': 'Account',
    'ADD_NEW': 'Add New User',
    'EMAIL': 'Email',
    'PASSWORD': 'Password',
    'PASS_CONFIRM': 'Password Confirmation',
    'REPEAT': 'Repeat Password',
    'LINK': 'Link',
    'LIST': 'Users List',
    'LOGOUT': 'Logout',
    'REQ_USERNAME': "Username can't be blank",
    'REQ_MIN_LENGTH': 'Username must be of minimum 5 characters length',
    'REQ_ONLY_ALPHANUM': 'Username can be only alphanumeric characters',
    'REQ_EMAIL': "Email can't be blank",
    'REQ_VALID_EMAIL': 'Please provide a valid email address',
    'REQ_PASS': "Password can't be blank",
    'REQ_PASS_MIN_LENGHT': 'Password must be of minimum 8 characters length',
    'REQ_NO_MATCH': 'Password and Repeated Password are not matching',
    'REQ_ACCOUNT': "Account can't be blank",
    'CREATE_ROLE': 'Atleast 1 role must be created in settings to create users.',
    'REQ_ROLE': "Role can't be blank",
    'ROLE': 'Role',
    'ROLES': 'Roles',
    'SELECT_ROLE': 'Please select a role',
    'SELECT_TEAM': 'Please select a team',
    'TEAM': 'Team',
    'T_END_DATE': 'Trial End Date',
    'USERNAME': 'Username',
    'LAST_LOGIN': 'Last Login'
  },
  'ACCOUNT': {
    'ADD_NEW': 'Add New Account',
    'CURRENT_SALESFORCE_ORG': 'Current Salesforce Organization:',
    'CURRENT_SALESFORCE_URL': 'URL:',
    'NAME': 'Account Name',
    'LIST': 'Accounts List',
    'VALID_BLANK': "Account name can't be blank.",
    'VALID_EXIST': 'Account name is already exist.',
    'VALID_MIN': 'Account name must be of minimum 5 characters length.',
    'ACCOUNT_TYPE': 'Account Type',
    'OCR_ENGINE': 'Ocr Engine',
    'PROCESS_TYPE': 'Process Type',
    'END_DATE': 'End Date',
    'VALID_OCR_ENGINE': 'Select an Ocr Engine.',
    'VALID_ACCOUNT_TYPE': 'Select an account type.',
    'VALID_END_DATE': 'Provide a valid end date.',
    'VALID_EMAIL': 'Provide a valid email(s).',
    'VALID_PROCESS_TYPE': 'Select atleast 1 process type.',
    'EDIT_ACCOUNT': 'Edit Account',
    'EMAIL': 'Email',
    'REASON': 'Reason',
    'ERRORS': 'ERRORS',
    'EMAIL_FORMAT': 'Invalid email format.',
    'EMAIL_DIFF_ACC': 'Email used with a different account.',
    'UPLOAD_LOGO': 'Upload Logo',
    'ACCOUNT_LOGO': 'Account Logo',
    'DELETE_CONTENT': 'Do you want to delete?'
  },
  'USER_DROPDOWN': {
    'PROFILE': 'Profile',
    'ADMINS': 'Admins',
    'LOGS': 'Logs',
    'SETTINGS': 'Settings',
    'LOGOUT': 'Logout'
  },
  'FAB_TITLES': {
    'ADD_NEW_USER': 'Add a New User',
    'ADD_TEMPLATE': 'Add Template',
    'EXPORT': 'Export',
    'NEW_ACCOUNT': 'New Account',
    'UPLOAD_FORM': 'Upload Form'
  },
  'ROUTE_NAME': {
    'Accounts': 'Accounts',
    'Admin': 'Admin',
    'Users': 'Users',
    'Add a New User': 'Add a New User',
    'Add New Account': 'Add New Account',
    'Configure': 'Configure',
    'Dashboard': 'Dashboard',
    'Edit Account': 'Edit Account',
    'Edit User': 'Edit User',
    'Form Status': 'Form Status',
    'Log History': 'Log History',
    'New Template': 'New Template',
    'Reports': 'Reports',
    'Reports Insights': 'Reports Insights',
    'Register': 'Register',
    'Template Listing': 'Template Listing',
    'Train': 'Train',
    'Sign In': 'Sign In',
    'Upload Form': 'Upload Form',
    'Form Doc': 'Verification',
    'Verification': 'Verification',
    'Triaging': 'Triaging',
    'Forms': 'Forms',
    'Audit Log Report': 'Audit Log Report',
    'My Profile': 'My Profile',
    'MODELS': 'Models',
    'page-not-found': '',
    'Features': 'Features'
  },
  'PROFILE': {
    'ROLES': {
      'UNMATCHED': 'Unmatched',
      'SUPERADMIN': 'Super Admin',
      'ADMIN': 'Admin',
      'TYPE_SELECT': 'Select Account type',
      'TRIAL': 'Trial Account',
      'SUBS_ACC': 'Subscribed Account'
    },
    'ACCNAME': {
      'DEFAULT': 'default'
    },
    'ACCOUNT_INFO': 'Account Information',
    'ACCOUNT_SET': 'Account Settings',
    'EMAIL_NOTIFY': 'Notify User via email',
    'ENTER_USER': 'Enter username',
    'ENTER_PASS': 'Enter new password',
    'INFO': 'Profile Information',
    'MEMBERS': 'Members',
    'UPDATE_SUCCESS': 'Profile updated successfully',
    'WRONG_PASSWORD': 'The credentials you supplied were not correct'
  },
  'COMMON': {
    'GO_BACK': 'GoBack',
    'OKAY': 'Ok',
    'FILE_ERROR': 'Error while parsing the file',
    'PROCESS_ORDER_INFO': 'Docx uses two techniques to find a matching template for an uploaded form. They are Barcode and Image Match. Barcode technique is where system looks for the templates which have similar barcode type as of form and Image Match is where it looks for similar features between template and form images. Depending on the processing order, system prioritizes the techinique which to be used. For example, If Barcode\'s processing order is 1, Barcode technique is preferred first and then Image Match.',
    'MODEL_EXIST': 'Model name already exists',
    'ADD_MODEL': 'Add new model',
    'NEW_MODEL': 'New model',
    'VERSION': 'Version',
    'CHOOSE_FILE': 'Choose File',
    'ACCEPT': 'Accept',
    'ACCEPTED': 'Accepted',
    'ACCOUNT': 'Account',
    'ACCOUNT_TYPE': 'Account type',
    'ACTION': 'Action',
    'ACTIONS': 'Actions',
    'ACTIVATE': 'Click to Activate',
    'ADD': 'Add',
    'ALERT': 'ALERT',
    'APPROVE': 'Approve',
    'APPLY': 'Apply',
    'CANCEL': 'Cancel',
    'CHANGE': 'Change',
    'CLEAR': 'Clear',
    'CLOSE': 'Close',
    'CLONE': 'Clone',
    'CONFIRM': 'Confirmation',
    'DATE_RANGE': 'Date Range',
    'DATE_START': 'Start Date',
    'DATE_END': 'End Date',
    'DAY': 'Day',
    'DEACTIVATE': 'Click to Deactivate',
    'DELETE': 'Delete',
    'DELETE_CONFIRM': 'Delete Confirmation',
    'DELETE_PERMANENTLY': 'Delete Permanently',
    'QBS': 'Export to QuickBooks',
    'SLSFRC': 'Export to Salesforce',
    'REMS': 'Export to Rems',
    'CSV': 'Download as CSV',
    'HL7': 'Download as 837',
    'FTP': 'Download as FTP',
    'OTRF': 'Download as ORTF',
    'EHR': 'Export to EHR',
    'FHIR': 'View FHIR data',
    'EDT_USR': 'Edit User',
    'MSG_PERM': 'User will be permanently removed from the system.',
    'MSG_PERM_DEL': 'You cannot undo this action. Are you sure you want to delete?',
    'MSG_DEL': 'This action will delete account\'s users, roles, templates, forms, service maps, settings etc...',
    'DEL_AUTHCONFIG': 'You cannot use this Client Id and Client Secret after deletion. Are you sure you want to delete?',
    'DEL_AUTO_CORRECT': 'This action will delete auto correct features and History for this field. Are you sure you want to delete?',
    'DEL_AUTO_CORRECT_HISTORY': 'This action will delete all the auto correct fields from the dictonary. Are you sure you want to delete?',
    'DEL_ORTFMAPPING': 'This action will permanently delete all ORTF field mappings of this template. Are you sure you want to delete?',
    'DEL_HL7MAPPING': 'This action will permanently delete HL7 field mappings of this template. Are you sure you want to delete?',
    'DEL_SERVICEMAPPING': 'This action will permanently delete all external field mappings of this template. Are you sure you want to delete?',
    'DEL_SERVICEVALIDATION': 'This action will permanently delete all service validations of this template. Are you sure you want to delete?',
    'DEL_CUSTOMVALIDATION': 'This action will permanently delete all Custom Validations of this template. Are you sure you want to delete?',
    'DESCRIPTION': 'Description',
    'ESM': 'Template Fields are not mapped with Salesforce object. Kindly check the settings',
    'TM': 'Template fields are not created. Kindly create fields in template',
    'DONE': 'Done',
    'EDIT': 'Edit',
    'EXPIRES_AT': 'Expires at',
    'EXPORT': 'Export',
    'FILE': 'File',
    'FORM': 'Form',
    'GENERATE': 'Generate',
    'GROUP_NAME': 'Group Name',
    'FILTER_BY': 'Filter By',
    'INTEGRATION_EMAILS': 'Integration Emails',
    'INVALID_FILE': 'Invalid File. (File must be format of .jpg, .jpeg, .png, .pdf, .tiff)',
    'LIST': 'List',
    'MARK_VERIFIED': 'Mark Verified',
    'MSG_CSV_LOG_DAYS': 'Maximum allowed Range is one month',
    'MSG_CSV_LOG_DAYS_ERROR': 'Please select range less than 31 days ',
    'MSG_ERROR_DATE': 'Invalid Date',
    'MSG_EXPIRED': 'Session expired, please login to continue',
    'MSG_RETRY': 'Something went wrong. Please retry',
    'MSG_REPROS': 'Requested form is being reprocessed.Please wait.',
    'MSG_DRAW': 'Please enable draw before creating shapes...',
    'MSG_INACTIVE': 'Currently requested service is not active. Sorry for the inconvenience.',
    'MSG_CREATE': 'Successfully created.',
    'MSG_UPDATE': 'Successfully updated.',
    'MSG_DELETE': 'Successfully deleted.',
    'MSG_DELETE_HISTORY': 'Successfully deleted from the dictionary',
    'MSG_DELETE_ERR': 'Error deleting. Please try again.',
    'MSG_FIELD_DEL': 'Field map is deleted',
    'MSG_LOGIN': 'Please login to access the requested page',
    'MSG_LOGIN_SUCESS': 'Logged in successfully. Welcome ',
    'MSG_USER_NF': 'User not Found!',
    'MSG_SERVER_UA': 'Server Unavailable!',
    'MSG_LOGIN_FAIL': 'Something went wrong. Login is failed',
    'MSG_LOGOUT': 'Logged out successfully',
    'MSG_USER_UPDATE': 'User updated successfully.',
    'MSG_SIGNUP_FAIL': 'Something went wrong. Sign Up is failed',
    'MSG_DATA_UPDATE': 'Data updated successfully',
    'MSG_USER_CREATE': 'User created successfully.',
    'MSG_ERROR': 'Error Occured. Try again.',
    'MSG_FORM_REQ': 'Either you do not have access to view form / Requested form not found.',
    'MSG_FETCH_ERR': 'Something went wrong while fetching form data.',
    'MSG_PROCESS_FAIL': 'Processing Failed, please try again.',
    'MSG_FILE_LIMIT': 'Maximum limit of files is 5.',
    'MSG_TEMP_FILE_LIMIT': 'Maximum limit of files is 1.',
    'MSG_TEMP_NAME_LIMIT': 'Title is too short (minimum is 3 characters). you cannot upload file',
    'MSG_TEMP_NAME_SUCCESS': 'Template Uploaded Successfully',
    'MSG_ACC_CREATE': 'Account created successfully.',
    'MSG_SUCESS_ACC': 'Account created successfully. Please sign in',
    'MSG_EDIT_N_A': 'Not Allowed to edit Admin',
    'MSG_ACC_SUCESS': 'Account updated successfully.',
    'MSG_UPD_FAIL': 'Something went wrong. Update failed.',
    'MSG_REQ_FIELD': 'This is a required field',
    'MSG_KEY_UNIQUE': 'Key must be unique.',
    'MSG_SELECT_TYPE': 'Please select type',
    'MSG_SELECT_CHILD': 'Select the children to delete along with the group:',
    'NAME': 'Name',
    'NEW': 'New',
    'NO': 'No',
    'ADD_NPI_GROUPING': 'Add NPI Grouping',
    'NOTIFICATION_EMAILS': 'Notification Emails',
    'ENTER_MULTIPLE_EMAILS': 'Enter a comma-separated email(s)',
    'NOTIFY_MSG': 'You have {len} notifications',
    'NO_RECORD': 'There are no records to show',
    'OF': 'of',
    'PENDING': 'Pending',
    'IN_PROGRESS': 'In Progress',
    'VALIDATED': 'Validated',
    'RECALLED': 'Recalled',
    'INTEGRATION_SUCCESS': 'Integration Success',
    'INTEGRATION_FAILED': 'Integration Failed',
    'DOCUMENT_MOVED_TO_SF': 'Document Moved To SF',
    'PC_INTEG_SUCCESS': 'Pc Integration Success',
    'PC_INTEG_FAILED': 'Pc Integration Failed',
    'TRIAGED': 'Triaged',
    'COMPLETED': 'Completed',
    'NEW_DOC': 'New',
    'PARTIALLY_COMPLETED': 'Partially Completed',
    'PROCESS': 'Process',
    'PROCESSED': 'Processed',
    'PRESCRIBER_FIRST_NAME': 'Prescriber First Name',
    'PRESCRIBER_LAST_NAME': 'Prescriber Last Name',
    'PRESCRIBER_NAME': 'Prescriber Name',
    'REJECT': 'Reject',
    'REJECTED': 'Rejected',
    'REQ_FIELD_WARNING': ' mandatory fields yet to be mapped',
    'RESET': 'Reset',
    'RESIZE': 'Resize',
    'SELECT': 'Select',
    'SAVE': 'Save',
    'SAVE_ALERT': 'There are some unsaved changes, please save them before leaving.',
    'SHOW_TABLE': 'Show Table',
    'STATUS': 'Status',
    'SUBMIT': 'Submit',
    'TITLE': 'Template Name',
    'USERNAME': 'Username',
    'UPDATE': 'Update',
    'UPLOAD': 'Upload',
    'UNBLOCK': 'Unblock',
    'UNMATCHED': 'Unmatched',
    'USERS': 'Users',
    'VALIDATE_UPDATE': 'Validate & Update',
    'VERIFY': 'Verify',
    'VERIFY_DOCUMENT': 'Verify Document',
    'VERIFIED': 'Verified',
    'VIEW_FORMS': 'View Forms',
    'YES': 'Yes',
    'SUBSCRIBE': 'Subscribe',
    'UNSUBSCRIBE': 'Unsubscribe',
    'UNAUTHORIZED': 'Unauthorized!',
    'UNMATCH': 'Form is not matched with any template',
    'WEEK': 'Week',
    'ENTER_PASSWORD': 'Enter Password',
    'WRONG_PASSWORD': 'Wrong Password',
    'Last Edited By': 'Last Edited By',
    'Enabled': 'Enabled'
  },
  'PROCESS_ROLES': {
    'BARCODE': 'Barcode',
    'IMAGE_MATCH': 'Image Match',
    'FORCE_TEMPLATE': 'Force Template',
    'PLAIN_TEXT': 'Plain Text'
  },
  'INVOICE': {
    'SIGN_INVOICE': 'SIGN INVOICE',
    'SIGN': 'Sign',
    'ACCOUNT': 'Account',
    'ACCOUNTING_UNIT': 'Accounting Unit',
    'TOTAL_AMOUNT': 'Total Amount',
    'ACC_REQ': 'Select an account',
    'ACC_UNIT_REQ': 'Select an accounting unit',
    'AMT_REQ': 'Total Amount is required',
    'MIN_AMT': 'Total Amount must be greater than or equal to zero',
    'SIGN_SUCCESSFUL': 'Successfully signed the invoice',
    'APPROVAL_SUCCESSFUL': 'Successfully approved the signature',
    'APPROVE_SIGN': 'APPROVE VERIFICATION',
    'APPROVE': 'Approve',
    'NOTES': 'Notes'
  },
  'TEAMS': {
    'TEAM': 'Team',
    'TEAMS': 'Teams',
    'ADD_NEW_TEAM': 'Add new team',
    'CREATE_TEAM': 'Create Team',
    'CREATE': 'Create',
    'NAME': 'Name',
    'DESCRIPTION': 'Description',
    'REQUIRED_FIELD': 'Required Field',
    'NO_USER_FOUND': 'No {ROLE}s found. Please add a new {ROLE}.',
    'NO_USER_ADDED': 'No {ROLE}s added to the team. Please add a {ROLE}.',
    'INCOMPLETE': 'Team is Incomplete. Some of the roles are missing in the hierarchy.',
    'DELETE_CONFIRM': 'Are you sure you want to delete this team permanently ?'
  },
  'Accounts': 'Accounts',
  'Add New': 'Add New',
  'Add User': 'Add User',
  'Admin': 'Admin',
  'Admins': 'Admins',
  'Aduit': 'Audit',
  'Analytics': 'Analytics',
  'Configure': 'Configure',
  'Forms': 'Forms',
  'Home': 'Home',
  'List': 'List',
  'Logs': 'Logs',
  'New': 'New',
  'New User': 'New User',
  'Processed': 'Processed',
  'Reports': 'Reports',
  'Settings': 'Settings',
  'Models': 'Models',
  'Super Admin': 'Super Admin',
  'Templates': 'Templates',
  'Trails': 'Trails',
  'Upload Form': 'Upload Form',
  'Users': 'Users',
  'Verification': 'Verification',
  'Workflow': 'Workflow',
  'Mappings': 'Mappings',
  'Add new mapping': 'Add new mapping'
};

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'AUTH': {
    'CONFIRM_PASSWORD': 'Confirmez le mot de passe',
    'EMAIL': 'Email',
    'EMPTY_EMAIL': 'Le courrier électronique ne peut pas être vide.',
    'EMPTY_PASSWORD': 'Le mot de passe ne peut être vide.',
    'FORGOT_PASSWORD': 'Mot de passe oublié',
    'INVALID_EMAIL': "S'il vous plaît fournir un email valide.",
    'INVALID_PASSWORD': 'Le mot de passe doit avoir au moins {MINIMUM} caractères.',
    'IDENTICAL_PASSWORD': 'Les mots de passe doivent être identiques.',
    'LINK_EXPIRED': 'Le lien a expiré.',
    'LINK_USED': "Quelqu'un a déjà utilisé ce lien. Si ce n'est pas vous, veuillez réinitialiser le mot de passe à nouveau.",
    'LOGIN': "S'identifier",
    'NEW_PASSWORD': 'nouveau mot de passe',
    'PASSWORD': 'Mot de passe',
    'PASSWORD_UPDATED': 'Mis à jour avec succès le mot de passe.',
    'RESET_LINK_SENT': "Le lien de réinitialisation a été envoyé à l'e-mail enregistré.",
    'RESET_PASSWORD': 'réinitialiser le mot de passe',
    'SUBMIT': 'Soumettre',
    'USER_LOGIN': 'Utilisateur en ligne',
    'USER_NOT_FOUND': "Aucun utilisateur trouvé. S'il vous plaît contacter admin.",
    'PWD_CHANGE': 'changer le mot de passe',
    'PWD_CURRENT': 'Mot de passe actuel'
  },
  'ERROR': {
    'COMMON': 'Erreur est survenue. Veuillez réessayer.'
  },
  'HEADER': {
    'TRIAL_USER': "Vous êtes un utilisateur à l'essai. La période d'essai se termine le {END_DATE}.",
    'NOTIFY_MSG': 'Vous avez {len} notifications',
    'CLEAR': 'Clair',
    'TEMPLATES': 'Modèles',
    'FORMS': 'Formes',
    'UPLOAD_FORM': 'Formulaire de téléchargement',
    'REPORTS': 'Rapports',
    'PROFILE': 'Profil',
    'USERS': 'Utilisateurs',
    'LOGS': 'Les journaux',
    'SETTINGS': 'Réglages',
    'LOGOUT': 'Connectez - Out',
    'ACCOUNTS': 'Comptes',
    'MODELS': 'DES MODÈLES',
    'Features': 'Caractéristiques'
  },
  'TEMPLATE': {
    'DATE_FORMAT': 'Format de date',
    'ADD_NEW': 'Ajouter un nouveau modèle',
    'ENABLE_AUTO_CORRECT': 'Activer la correction automatique: ',
    'CLONE': 'Cloner un modèle depuis un autre compte.',
    'CREATE_NPI_GROUP': 'Créer un groupe NPI',
    'DATA_TYPE': 'Données Type',
    'DELETE_CONTENT': "Voulez-vous supprimer ce '{TEMPLATE_TITLE}' modèle?",
    'DELETE_MAP': 'Effacer Mapping (Cmd + d)',
    'DELETE_MODAL': 'Supprimer les mappages',
    'DELETE_MODAL_CONTENT': 'Êtes-vous sûr de vouloir supprimer le champ?',
    'DRAW': 'Dessiner',
    'DISABLE_FORM': 'Désactiver pour la soumission de formulaire',
    'ENABLE_FORM': 'Activer pour la soumission de formulaire',
    'ENTER_TITLE': 'Entrez titre....',
    'ENTER_DESCR': 'Entrez modèle description',
    'GRP_NAME': 'Groupe Prénom',
    'GRP_TYPE': 'Groupe Type',
    'REDACT_FIELD': 'Redact Field',
    'SHOW_FIELD': 'Show Field',
    'KEY': 'Clé',
    'MAPPING_CATEGORY': 'Catégorie',
    'MAPPINGS': 'Cartographies:',
    'CASE': 'Cas',
    'MSG_ADDED': 'Modèle ajouté avec succès',
    'MSG_REMOVED': 'Modèle Supprimé avec succès..',
    'MSG_SAVED': "Les modifications de l'éditeur sont enregistrées avec succès.",
    'MSG_SAVE_FAIL': 'Quelque chose a mal tourné. Échec de la sauvegarde...',
    'NEXT_PAGE': 'Aller à page suivante',
    'NOTHING': 'No se encontraron plantillas!',
    'NPI_GROUP': 'NPI Groupe',
    'OLDER_VERSIONS': 'Les anciennes versions ne peuvent pas être modifiées',
    'PREV_PAGE': 'Aller à page précédente',
    'ESMMAPPINGS': 'Mappages de services externes',
    'TEMPLATE_VERSION_UPDATE': 'Voulez-vous cloner les mappages de champs dans l"écran de mappage de service vers une nouvelle version de modèle?',
    'ESM_CLONING': 'Les mappages de services externes seront clonés',
    'ORTF_CLONING': 'Les mappages ORTF seront clonés',
    'SV_CLONING': 'Les validations de service seront clonées',
    'Hl7_CLONING': 'Les mappages HL7 seront clonés',
    'CV_CLONING': 'Les mappages Custom Validations seront clonés',
    'REDO': 'Refaire (Cmd + Shift + z)',
    'REQ': 'Obligatoires',
    'REQ_TYPE': 'Sélectionner type de processus',
    'REQ_FILE': 'Le fichier ne peut pas être vide',
    'REQ_TITLE': 'Le titre ne peut pas être vide',
    'SAVE': 'Sauvegarder (Cmd + s)',
    'SAVE_CHANGES': "Aimez-vous enregistrer les modifications avant de quitter l'éditeur?",
    'SELECT': 'Sélect (Esc)',
    'SELECT_DATA_TYPE': 'Veuillez sélectionner le type de données',
    'SELECT_DATE_FORMAT': 'Veuillez sélectionner le format de date',
    'SELECT_TYPE': 'Veuillez sélectionner le type',
    'SELECT_FROM_ACCOUNT': 'Du compte',
    'SELECT_TO_ACCOUNT': 'Estimer',
    'SELECT_ACCOUNT': 'Sélectionner un compte',
    'SELECT_TEMPLATE': 'Choisir un modèle',
    'SELECT_CASE': 'Sélectionnez le cas',
    'TEMPLATE': 'Modèle',
    'THUMBNAIL': 'La vignette',
    'THEME': 'Thème',
    'TRAIN': 'Train',
    'TRAIN_BASE': 'Train Base Template:',
    'TYPE': 'Type',
    'UPDATE_MAP': 'Mise à jour du Mappage',
    'UPDATE_GRP': 'Groupe de mise à jour',
    'UNDO': 'Annuler (Cmd + z)',
    'UNSAVE': 'Changements non enregistrés',
    'ZOOM_IN': 'Zoom avant (Cmd + +)',
    'ZOOM_OUT': 'Zoom arrière (Cmd + -)',
    'IMPORT': 'Importer',
    'EXPORT': 'Exportation',
    'UPLOAD_MAPPINGS': 'Télécharger le fichier de mappages'
  },
  'TEMPLATE_VIEW': {
    'ID': 'ID',
    'PAGES': ' PAGE(S)',
    'TOTAL_PAGES': 'Pages totales',
    'UPDATED_AT': 'Updated à',
    'VIEW': 'VUE:'
  },
  'DATA_TYPE': {
    'ALPHA': 'Alphabets',
    'ALPHANUM': 'Alphanumérique',
    'ALPHANUMSPC': 'Alphanumérique With Spaces',
    'BLOCK': 'Bloc',
    'CHECKBOX': 'Case à cocher',
    'CITY': 'Ville',
    'COMBINE_DATA': 'Combiner des données',
    'CHECKBOX_TEXT': 'Texte de la case à cocher',
    'DATE': 'Rendez-vous amoureux',
    'DEFAULT': 'Défaut',
    'EITHER': 'Ou-ou Choix',
    'LOGICAL': 'Logique',
    'MULTI_CHOICE': 'Plusieurs Choix',
    'NPI': 'NPI',
    'NUMERIC': 'Numérique',
    'STATE': 'État',
    'TABLE_COLUMN': 'Tableau ( Données de colonne )',
    'TABLE_ENTRY': 'Entrée de table',
    'TABLE_HEADER': 'En-tête de table',
    'TABLE_ROW': 'Tableau ( Données de ligne )',
    'TEXT': 'Texte',
    'ZIPCODE': 'Code postal',
    'CAPITALIZE': 'Mettre en majuscule la première lettre de champ',
    'UPPER_CASE': 'Haut de casse',
    'LOWER_CASE': 'Minuscules'
  },
  'COLOR': {
    'BLUE': 'Bleu',
    'GREEN': 'Vert',
    'RED': 'Rouge'
  },
  'UPLOAD_DROPDOWN': {
    'ENROLLMENT_FORMS': 'Formulaires d\'inscription',
    'SELECT': 'Sélectionner',
    'AUTO': 'Match automatique',
    'PLAIN': 'Texte brut',
    'INSURANCE': 'Carte d\'assurance',
    'INSU_F_B': 'Cartes d\'assurance recto et verso',
    'MANUAL': 'Manuel',
    'DL': 'Permis de conduire/ID électeur',
    'INVOICE': 'Facture d\'achat',
    'EXCEL': 'Classeur Excel',
    'LEASE': 'Document de location',
    'SLA': 'Contrat de licence de logiciel',
    'AUS_LEASE': 'Document de location australien',
    'BIOTRONIK': 'Biotronik',
    'MEDTRONIC': 'Medtronic',
    'MEDTRONIC2': 'Medtronic-2',
    'BOSTON': 'Boston Scientific',
    'TRIAGING': 'sorting'
  },
  'FORMS': {
    'ROTATE_LEFT': 'Tourne à gauche',
    'ROTATE_RIGHT': 'Tourner à droite',
    'IMAGE_ROTATE_SUCCESS': 'Rotation d"image réussie',
    'IMAGE_ROTATE_FAIL': 'La rotation de l"image a échoué',
    'MULTI_USER_MODAL': 'ATTENTION',
    'MULTI_USER_ALERT_MSG': 'Actuellement, un autre utilisateur consulte ce document. Veuillez valider un autre document',
    'ACCEPT_PERMISSION_ERROR': 'Impossible d"accepter l"autorisation de formulaire requise!',
    'NEXT_FORM': '<< Document suivant',
    'PREV_FORM': 'Document précédent >>',
    'SELECT_MODEL': 'Sélectionnez le modèle',
    'MODEL_NAME': 'Nom du modèle',
    'MODEL_NAME_ERR': 'Le nom du modèle ne peut pas être vide',
    'USE_TITLE': 'Utilisez le même titre pour tous les formulaires',
    'CONF_RANGE': 'Gamme de confiance',
    'CHECK_ELIG_BTN_LABEL': 'Vérifier l\'éligibilité',
    'CHECK_ELIG_SUCC_MESSAGE': 'Contrôle d\'admissibilité réussi',
    'CHECKING_ELIG_BTN_LABEL': 'Vérification de l\'admissibilité',
    'AVG_CONF': 'Confiance moyenne',
    'COMP_IMAGES': 'Comparer avec les images téléchargées',
    'NO_LINE_ITEMS': 'Aucun élément de ligne à afficher ...',
    'AUTO_CORRECT': 'Correction automatique',
    'AUTO_CORRECT_CONTENT': 'La valeur mise à jour sera utilisée ultérieurement, êtes-vous sûr de vouloir enregistrer?',
    'ACCEPT': 'Acceptez',
    'VERIFY': 'Vérifier',
    'APPROVED': 'APPROUVÉ',
    'ADD_FIELD': 'Ajouter Field',
    'ALL': 'Pour toutes les formes',
    'CON_SCORE': 'Confiance Score',
    'CHANGE_LABEL': 'Changer Etiquette',
    'CHOOSE': 'Choisissez un formulaire...',
    'DELETE_CONTENT': 'Voulez-vous supprimer ce {FIELD_NAME} field?',
    'DESCRIPT_PLACE': 'Entrez formulaire description',
    'DROP_SCANNED': 'Cliquez ici / Glissez-déposez les fichiers ici pour les traiter',
    'DROP_TEMP_SCANNED': 'Cliquez ici / glissez et déposez les fichiers à télécharger',
    'EDITED': 'EDITED',
    'EXPORT_ERROR': "Erreur de mappage d'exportation Salesforce",
    'FORCED_TEMPLATE': 'Modèle forcé',
    'LABEL': 'Etiquette',
    'LABEL_NAME': 'Etiquette Nom',
    'MATCH': 'Rencontre',
    'MATCHING_TEMPLATE': 'Voir le modèle correspondant',
    'MSG_ACCEPT': 'Formulaire accepté',
    'MSG_DEL': 'Données supprimées avec succès',
    'MSG_LABEL': 'Étiquette modifiée avec succès',
    'MSG_SUCESS': 'Données mises à jour avec succès',
    'MSG_WARN': "Le formulaire de téléchargement n'est pas traité",
    'NOTHING': 'Aucune donnée à afficher...',
    'ONLY': 'Seulement pour ce formulaire',
    'PENDING': 'EN ATTENDANT',
    'PAGES_WITH_DATA': 'Pages avec données',
    'PROCESS_TYPE': 'Type de processus',
    'PROCESSED_DATA': 'Données traitées',
    'PROCESSING_STAT': 'Les formulaires téléchargés sont en cours de traitement ... Veuillez patienter',
    'PROCESSED_STAT_ONE': 'Le nouveau formulaire a été traité. Cliquez pour rafraîchir',
    'PROCESSED_STAT_MANY': 'Les nouveaux formulaires ont été traités. Cliquez pour rafraîchir',
    'REJECTED': 'REJECTED',
    'REQ_TITLE': 'Titre ne peut pas être vide',
    'REQ_LABEL': 'Nom ne peut pas être vide',
    'REQ_FILE': 'Fichier ne peut pas être vide',
    'SELECT_PAGE_NUM': 'Page: ',
    'TABLE_DATA': 'Données de table',
    'TEMPLATE': 'Modèle',
    'TITLE_PLACE': 'Titre du formulaire...',
    'UPLOAD_PROCESS': 'Téléchargement et Traitement...',
    'UPLOADING': 'Téléchargement ...',
    'UPLOAD_A_FORM': 'Télécharger un formulaire scanné',
    'UPLOAD_MULTI_FORMS': 'Télécharger formulaires numérisés',
    'VALUE': 'Valeur',
    'VALIDATION_HEADER': 'Veuillez corriger / corriger les champs suivants',
    'VALIDATE_SIGNATURE': 'Veuillez approuver / rejeter la signature pour vérifier',
    'VALIDATIONS': 'Erreurs de validation',
    'REQUIRED_FIELDS_VALIDATION': 'Erreurs de champs obligatoires',
    'SERVICE_VALIDATION': 'Erreurs de validation de service',
    'VALIDATION_ERROR': 'Erreurs de validation',
    'OPTIONAL_FIELDS_VALIDATION': 'Erreurs de champs optionnels'
  },
  'WORKFLOW': {
    'LOCK_TITLE': 'Verrouillé par {userName}',
    'LOCK_ALERT_MSG': '¿Quieres desbloquear este registro? ?',
    'ACTIONS': 'Actes',
    'ANALYSE': 'Analyser',
    'ANALYSIS': 'Une analyse',
    'TITLE': 'Nom du patient',
    'INVOICE': "Facture d'achat",
    'DOWNLOAD': 'Télécharger',
    'FILTER': 'filtres',
    'FILTERS': 'Filtres',
    'MATCH': 'Rencontre',
    'GROUP_ID': 'ID du groupe',
    'PROCESSED_FORMS': 'Formulaires traités',
    'PROCESS_PAGE_COUNT': 'Nombre de pages traitées',
    'MATCHED_PAGE_COUNT': 'Nombre de pages assorties',
    'REJECT_PAGE_COUNT': 'Nombre de pages rejetées',
    'SEARCH': 'Type à Rechercher',
    'UPDATED_AT': 'Updated à',
    'DELETE_FORM': "Voulez-vous supprimer ce formulaire '{FORM_TITLE}'?",
    'FAX_NUMBER': 'Numéro de fax',
    'ENTER_FAX_NUMBER': 'Entrez le numéro de fax',
    'DELETE': 'Effacer',
    'FORM_INFO_HEADER': 'Détails des formulaires traités',
    'DELETE_MULTIPLE': 'Supprimer les formulaires multiples',
    'REPROCESS': 'Retraiter',
    'MAX_RETRIES': 'Atteint le nombre de tentatives maximum.',
    'MOVE_TO_MATCHED': 'Déplacer vers la file d\'attente correspondante',
    'STATUS': 'Statut',
    'DOCUMENT_TYPE': 'Type de document',
    'PRODUCT': 'Produit',
    'REPORT': 'Signaler'
  },
  'ANALYTICS': {
    'TOTAL_FORMS': 'Total des formulaires reçus',
    'CONFIDENCE': 'Confiance (%)',
    'CONFIDENCE_AVG': 'Valeur de confiance de la page modèle (%)',
    'DAILY_REPORT': 'Rapport journalier',
    'FILTER_TEMPLATES': 'Filtrer par modèles',
    'FORM_WORKFLOW_STATS': 'Statistiques de flux de travail de formulaire',
    'IDENTIFIED': 'Identifié',
    'RECENT_FORMS': 'Formulaires récents',
    'FAXES_RECEIVED': 'Nombre total de Formes de patients reçus',
    'FAXES_IDENTIFIED': 'Nombre total de Formes de patient identifiés',
    'FAXES_READABLE': 'Nombre total de Formes patient lisibles',
    'FAXES_REJECTED_ORIGIN': 'Formulaires de patients totaux rejetés selon le pays',
    'FAXES_REJECTED_BY_REASON': 'Nombre total de formulaires de patients rejetés en raison de leur lisibilité',
    'FAXES_UNPROCESSED': 'Nombre total de formulaires patient non associés au modèle',
    'REJECTED': 'Raison rejetée',
    'WEEKLY_REPORT': 'Rapport hebdomadaire',
    'TOTAL_PROCESSED': 'Traité',
    'TOTAL_REJECTED': 'Rejeté',
    'TEMPLATE': 'Modèle',
    'PROCESS_TYPE': 'Type de processus',
    'SELECT_PROCESS_TYPE': 'type processus',
    'PAGES': 'Pages',
    'RECENT_FORM_MSG': 'Les formulaires récents générés dans le fichier CSV nappartiendront quà la plage de dates sélectionnée.',
    'REPORT_CONTENT': 'Signaler le contenu'
  },
  'CONFIGURED': {
    'ADD_ROLE': 'Ajouter Rôle',
    'ADD_GROUP': 'Ajouter un champs',
    'ADD_ALIAS': 'Ajouter un alias',
    'ADD_FIELD_ALIAS': 'Ajouter des alias de champs',
    'ADD_NEW_KEYS': 'Ajouter de nouvelles clés',
    'B_PREVIEW': 'Bordure Aperçu',
    'CONFIDENCE_COLORS': 'Couleurs de confiance',
    'CC_SUCCESS': 'Les couleurs de confiance sont mises à jour avec succès',
    'COLOR': 'Couleur',
    'CREATE': 'Créer',
    'IMPORT_MAPPINGS': 'Importer des mappages',
    'EDIT_GROUP': 'Editer le groupe',
    'EDIT_ALIAS': 'Modifier lalias',
    'FORM_ORDER': 'Ordre de traitement de formulaire',
    'FIELD_TYPE': 'Type de champ',
    'FIELD_EXISTS': 'Déjà le champ existe',
    'FIELDS': 'Des champs',
    'FIELDS_ALIASES': 'Alias de terrain',
    'NEW_ROLE': 'Nouveau rôle',
    'NOTE': "Remarque: Glissez / déposez les éléments pour modifier l'ordre de traitement du formulaire",
    'PREVIEW': 'Aperçu',
    'PROCESS_ORDER_SUCCESS': 'Ordre de traitement mis à jour avec succès',
    'RANGE': 'Gamme',
    'ROLE_CREATED': ' le rôle est créé avec succès',
    'ROLE_MANAGE': 'Rôles La gestion',
    'ROLE_NAME': 'Nom de rôle',
    'ROLE_NOTE': "Remarque: Glissez / déposez les éléments pour modifier l'ordre des rôles.",
    'ROLE_ORDER': 'Ordre de Rôle ',
    'ROLE_ORDER_SUCCESS': "L'ordre des rôles est mis à jour avec succès",
    'ROLE_SUCCESS': 'Les rôles sont mis à jour avec succès',
    'SELECT_ROLE': 'Sélectionner un rôle',
    'PROCESS_TYPE': 'Types de processus abonnés',
    'FIELD': 'Nom de domaine',
    'SUBSCRIBE_MODAL': 'Souscrire un nouveau type de processus',
    'UNSUBSCRIBE_MODAL': 'Se désabonner d\'un type de processus',
    'SUBSCRIBE_PT': 'Abonné avec succès un nouveau type de processus',
    'UNSUBSCRIBE_PT': 'Désabonné avec succès',
    'ENTER_SECTION_NAME': 'Entrez le nom de la section',
    'SECTION_ORDER': 'Ordre des sections',
    'SECTION_NOTE': "Remarque: faites glisser / déposez les éléments pour modifier l'ordre des sections",
    'SECTION_ORDER_SUCCESS': "L'ordre des sections a été mis à jour avec succès",
    'HL7_TEMPLATES': 'Modèles HL7'
  },
  'TRAILS': {
    'AUDIT_TRAILS': 'Des pistes de vérification',
    'LOGGED_AT': 'Enregistré à',
    'LOCATION': 'Emplacement',
    'PATH': 'Chemin',
    'CUSTOM_DATE_LOGS': 'Journaux de date personnalisés'
  },
  'USERS': {
    'ACCOUNT': 'Compte',
    'ADD_NEW': 'Ajouter de nouveaux utilisateurs',
    'EMAIL': 'Email',
    'PASSWORD': 'Mot de passe',
    'PASS_CONFIRM': 'Confirmation mot de passe',
    'REPEAT': 'Répéter de passe',
    'LINK': 'Lien',
    'LIST': 'Liste des utilisateurs',
    'LOGOUT': 'Logout',
    'REQ_USERNAME': "Nom d'utilisateur ne peut pas être vide",
    'REQ_MIN_LENGTH': "Le nom d'utilisateur doit comporter au moins 5 caractères",
    'REQ_ONLY_ALPHANUM': "Le nom d'utilisateur ne peut être que des caractères alphanumériques",
    'REQ_EMAIL': 'Email ne peut pas être vide',
    'REQ_VALID_EMAIL': 'Veuillez fournir une adresse email valide',
    'REQ_PASS': "Mot de passe d'utilisateur ne peut pas être vide",
    'REQ_PASS_MIN_LENGHT': 'Le mot de passe doit comporter au minimum 8 caractères',
    'REQ_NO_MATCH': 'Le mot de passe et le mot de passe répété ne correspondent pas',
    'REQ_ACCOUNT': 'Le Compte ne peut pas être vide',
    'CREATE_ROLE': 'Au moins un rôle doit être créé dans les paramètres pour créer des utilisateurs.',
    'REQ_ROLE': 'Le Rôle ne peut pas être vide',
    'ROLE': 'Rôle',
    'ROLES': 'Rôles',
    'SELECT_ROLE': 'Veuillez sélectionner un rôle',
    'SELECT_TEAM': 'Veuillez sélectionner une équipe',
    'TEAM': 'Équipe',
    'T_END_DATE': "Date de fin d'essai",
    'USERNAME': "Nom d'utilisateur",
    'LAST_LOGIN': 'Dernière connexion'
  },
  'ACCOUNT': {
    'ADD_NEW': 'Ajouter un nouveau compte',
    'CURRENT_SALESFORCE_ORG': 'Organisation Salesforce actuelle:',
    'CURRENT_SALESFORCE_URL': 'URL',
    'NAME': 'Compte Nom ',
    'LIST': 'Compte Liste',
    'VALID_BLANK': 'Le nom du compte ne peut pas être vide',
    'VALID_EXIST': 'Le nom du compte existe déjà.',
    'VALID_MIN': 'Le nom du compte doit comporter au moins 5 caractères.',
    'ACCOUNT_TYPE': 'Type de compte',
    'OCR_ENGINE': 'Ocr Engine',
    'PROCESS_TYPE': 'Type de processus',
    'END_DATE': 'Date de fin',
    'VALID_OCR_ENGINE': 'Select an Ocr Engine.',
    'VALID_ACCOUNT_TYPE': 'Sélectionnez un type de compte.',
    'VALID_END_DATE': 'Fournissez une date de fin valide.',
    'VALID_EMAIL': 'Fournissez un email valide.',
    'VALID_PROCESS_TYPE': 'Sélectionnez au moins 1 type de processus.',
    'EDIT_ACCOUNT': 'Modifier le compte',
    'EMAIL': 'Email',
    'REASON': 'Raison',
    'ERRORS': 'LES ERREURS',
    'EMAIL_FORMAT': 'Format d\'email invalide.',
    'EMAIL_DIFF_ACC': 'Email utilisé avec un compte différent.',
    'UPLOAD_LOGO': 'Télécharger le logo',
    'ACCOUNT_LOGO': 'Logo du compte',
    'DELETE_CONTENT': 'Voulez-vous supprimer?'

  },
  'USER_DROPDOWN': {
    'PROFILE': 'Profil',
    'ADMINS': 'administrateurs',
    'LOGS': 'registre',
    'SETTINGS': 'réglages',
    'LOGOUT': 'déconnexion'
  },
  'FAB_TITLES': {
    'ADD_NEW_USER': 'ajouter un nouvel utilisateur',
    'ADD_TEMPLATE': 'ajouter un modèle',
    'EXPORT': 'exportation',
    'NEW_ACCOUNT': 'Nouveau compte',
    'UPLOAD_FORM': 'formulaire de téléchargement'
  },
  'ROUTE_NAME': {
    'Accounts': 'comptes',
    'Admin': 'Admin',
    'Users': 'Utilisateurs',
    'Add a New User': 'ajouter un nouvel utilisateur',
    'Add New Account': 'Ajouter un nouveau compte',
    'Configure': 'Configurer',
    'Dashboard': 'Tableau de bord',
    'Edit Account': 'Modifier le compte',
    'Edit User': 'Modifier l\'utilisateur',
    'Form Status': 'Statut du formulaire',
    'Log History': 'historique du journal',
    'New Template': 'Nouveau modèle',
    'Reports': 'rapports',
    'Register': 'enregistrer',
    'Template Listing': 'liste de modèle',
    'Train': 'former',
    'Sign In': 'Se connecter',
    'Upload Form': 'formulaire de téléchargement',
    'Form Doc': 'vérification',
    'Verification': 'vérification',
    'Forms': 'formes',
    'Reports Insights': 'Reports Insights',
    'My Profile': 'mon profil',
    'MODELS': 'DES MODÈLES',
    'page-not-found': '',
    'Features': 'Caractéristiques'
  },
  'PROFILE': {
    'ROLES': {
      'UNMATCHED': 'Incomparable',
      'SUPERADMIN': 'super administrateur',
      'ADMIN': 'administrateur',
      'TYPE_SELECT': 'sélectionnez le type de compte',
      'TRIAL': 'Compte d\'essai',
      'SUBS_ACC': 'Compte souscritmodifier'
    },
    'ACCNAME': {
      'DEFAULT': 'défaut'
    },
    'ACCOUNT_INFO': 'Information sur le compte',
    'ACCOUNT_SET': 'Paramètres du compte',
    'EMAIL_NOTIFY': 'Notifier lutilisateur par email',
    'ENTER_USER': "Entrez votre nom d'utilisateur",
    'ENTER_PASS': 'Entrez un nouveau mot de passe',
    'INFO': 'Informations sur le profil',
    'MEMBERS': 'Membres',
    'UPDATE_SUCCESS': 'Mise à jour du profil réussie',
    'WRONG_PASSWORD': 'Les informations d\'identification que vous avez fournies n\'étaient pas correctes'
  },
  'COMMON': {
    'GO_BACK': 'Retourner',
    'OKAY': "D'ACCORD",
    'FILE_ERROR': 'Erreur lors de l"analyse du fichier"',
    'PROCESS_ORDER_INFO': 'Docx utilise deux techniques pour trouver un modèle correspondant à un formulaire téléchargé. Ils sont Barcode et Image Match. La technique de code à barres est où le système cherche les modèles qui ont un type de code à barres similaire à celui du formulaire et Image Match est où il recherche des caractéristiques similaires entre les modèles et les images de formulaire. En fonction de l\'ordre de traitement, le système priorise la technique à utiliser. Par exemple, si l\'ordre de traitement du code à barres est 1, la technique du code à barres est privilégiée en premier lieu, puis la correspondance des images.',
    'MODEL_EXIST': 'Le nom du modèle existe déjà',
    'ADD_MODEL': 'Ajouter un nouveau modèle',
    'NEW_MODEL': 'Nouveau modèle',
    'VERSION': 'Version',
    'CHOOSE_FILE': 'Choisir le fichier',
    'ACCEPT': 'Acceptez',
    'ACCEPTED': 'Accepté',
    'ACCOUNT': 'Compte',
    'ACCOUNT_TYPE': 'Type de compte',
    'ACTION': 'Action',
    'ACTIONS': 'Actes',
    'ACTIVATE': 'Cliquez pour activer',
    'ADD': 'Ajouter',
    'ALERT': 'ALERTE',
    'APPROVE': 'Approuver',
    'CANCEL': 'Annuler',
    'CHANGE': 'Changement',
    'CLEAR': 'Clair',
    'CLOSE': 'Fermer',
    'CLONE': 'Cloner',
    'CONFIRM': 'Confirmation',
    'DATE_RANGE': 'Plage de dates',
    'DATE_START': 'Date de début',
    'DATE_END': 'Date de fin',
    'DAY': 'journée',
    'ESM': 'Les champs de modèle ne sont pas mappés avec l"objet Salesforce. Veuillez vérifier les paramètres',
    'TM': 'Les champs de modèle ne sont pas créés. Veuillez créer des champs dans le modèle',
    'DEACTIVATE': 'Cliquez pour désactiver',
    'DELETE': 'Effacer',
    'DELETE_CONFIRM': 'Eliminar confirmación',
    'DELETE_PERMANENTLY': 'supprimer définitivement',
    'DEL_AUTHCONFIG': 'Vous ne pouvez pas utiliser cet ID client et ce secret client après la suppression. Etes-vous sûr que vous voulez supprimer?',
    'DEL_AUTO_CORRECT': 'Cette action supprimera les fonctionnalités de correction automatique et lhistorique de ce champ. Etes-vous sûr que vous voulez supprimer?',
    'DEL_AUTO_CORRECT_HISTORY': 'Cette action supprimera tous les champs de correction automatique du dictionnaire. Etes-vous sûr que vous voulez supprimer?',
    'DEL_ORTFMAPPING': 'Cette action supprimera définitivement tous les mappages de champs ORTF de ce modèle. Etes-vous sûr que vous voulez supprimer?',
    'DEL_HL7MAPPING': 'Cette action supprimera définitivement tous les mappages de champs HL7 de ce modèle. Etes-vous sûr que vous voulez supprimer?',
    'DEL_SERVICEMAPPING': 'Cette action supprimera définitivement tous les mappages de champs externes de ce modèle. Etes-vous sûr que vous voulez supprimer?',
    'DEL_SERVICEVALIDATION': 'Cette action supprimera définitivement toutes les validations de service de ce modèle. Etes-vous sûr que vous voulez supprimer?',
    'DEL_CUSTOMVALIDATION': 'Cette action supprimera définitivement toutes les validations de service de ce modèle. Etes-vous sûr que vous voulez supprimer?',
    'QBS': 'Exporter vers QuickBooks',
    'SLSFRC': 'Exporter vers Salesforce',
    'REMS': 'Exporter vers Rems',
    'CSV': 'Télécharger en CSV',
    'HL7': 'Télécharger en HL7',
    'FTP': 'Télécharger en format FTP',
    'OTRF': 'Télécharger en format OTRF',
    'FILTER_BY': 'Filtrer par',
    'EHR': 'Exporter vers EHR',
    'FHIR': 'Voir les données FHIR',
    'EDT_USR': 'Modifier l\'utilisateur',
    'MSG_ERROR_DATE': 'Date invalide',
    'MSG_PERM': 'L\'utilisateur sera définitivement supprimé du système.',
    'MSG_PERM_DEL': 'Vous ne pouvez pas annuler cette action. Etes-vous sûr que vous voulez supprimer?',
    'MSG_DEL': 'Cette action supprimera les utilisateurs, rôles, modèles, formulaires, cartes de service, paramètres, etc. du compte.',
    'DESCRIPTION': 'Description',
    'DONE': 'Terminé',
    'EDIT': 'Modifier',
    'EXPIRES_AT': 'Expire à',
    'EXPORT': 'exportation',
    'FILE': 'Fichier',
    'FORM': 'Forme',
    'GENERATE': 'produire',
    'GROUP_NAME': 'Nom de groupe',
    'INTEGRATION_EMAILS': 'Courriels d\'intégration',
    'INVALID_FILE': 'Fichier non valide. (Le fichier doit être au format .jpg, .jpeg, .png, .pdf, .tiff)',
    'LIST': 'Liste',
    'MARK_VERIFIED': 'Mark vérifié',
    'MSG_CSV_LOG_DAYS': 'La plage maximale autorisée est dun mois',
    'MSG_CSV_LOG_DAYS_ERROR': 'Veuillez sélectionner moins de 31 jours',
    'MSG_EXPIRED': 'Session expirée, veuillez vous connecter pour continuer',
    'MSG_RETRY': 'Quelque chose a mal tourné. Veuillez réessayer',
    'MSG_REPROS': 'Le formulaire demandé est en cours de traitement.Veuillez patienter.',
    'MSG_DRAW': 'Activez s\'il vous plaît dessiner avant de créer des formes ...',
    'MSG_INACTIVE': 'Le service actuellement demandé n\'est pas actif. Désolé pour le dérangement.',
    'MSG_CREATE': 'Créé avec succès.',
    'MSG_UPDATE': 'Mise à jour réussie.',
    'MSG_DELETE': 'Supprimé avec succès.',
    'MSG_DELETE_HISTORY': 'Suppression réussie du dictionnaire',
    'MSG_DELETE_ERR': 'Erreur lors de la suppression. Veuillez réessayer.',
    'MSG_FIELD_DEL': 'La carte de terrain est supprimée',
    'MSG_LOGIN': 'Veuillez vous connecter pour accéder à la page demandée',
    'MSG_LOGIN_SUCESS': 'Connecté avec succès. Bienvenue ',
    'MSG_USER_NF': 'Utilisateur non trouvé!',
    'MSG_SERVER_UA': 'Serveur indisponible!',
    'MSG_LOGIN_FAIL': 'Quelque chose s\'est mal passé. La connexion a échoué',
    'MSG_LOGOUT': 'Déconnecté avec succès',
    'MSG_USER_UPDATE': 'Utilisateur mis à jour avec succès.',
    'MSG_SIGNUP_FAIL': 'Quelque chose s\'est mal passé. L\'inscription a échoué',
    'MSG_DATA_UPDATE': 'Données mises à jour avec succès',
    'MSG_USER_CREATE': 'Utilisateur créé avec succès.',
    'MSG_ERROR': 'Ocurrió un error. Inténtalo de nuevo.',
    'MSG_FORM_REQ': 'Soit vous n’avez pas accès au formulaire / formulaire demandé non trouvé.',
    'MSG_FETCH_ERR': 'Une erreur s\'est produite lors de la récupération des données de formulaire.',
    'MSG_PROCESS_FAIL': 'Échec du traitement, veuillez réessayer.',
    'MSG_FILE_LIMIT': 'La limite maximale de fichiers est de 5.',
    'MSG_TEMP_FILE_LIMIT': 'La limite maximale de fichiers est de 1.',
    'MSG_ACC_CREATE': 'Compte créé avec succès.',
    'MSG_SUCESS_ACC': 'Compte créé avec succès. Veuillez vous connecter',
    'MSG_EDIT_N_A': 'Non autorisé à modifier Admin',
    'MSG_ACC_SUCESS': 'Compte mis à jour avec succès.',
    'MSG_UPD_FAIL': 'Quelque chose s\'est mal passé. Mise à jour a échoué.',
    'MSG_REQ_FIELD': 'Ceci est un champ obligatoire',
    'MSG_KEY_UNIQUE': 'La clé doit être unique.',
    'MSG_SELECT_TYPE': 'Veuillez sélectionner le type',
    'MSG_SELECT_CHILD': 'Sélectionnez les enfants à supprimer avec le groupe:',
    'NAME': 'Prénom',
    'NEW': 'Nouveau',
    'NO': 'No',
    'ADD_NPI_GROUPING': 'Ajouter un groupement NPI',
    'NOTIFICATION_EMAILS': 'Emails de notification',
    'ENTER_MULTIPLE_EMAILS': 'Entrez un email séparé par des virgules',
    'NOTIFY_MSG': 'Vous avez {len} notifications',
    'NO_RECORD': "Il n'y a pas de disques à montrer",
    'OF': 'de',
    'PENDING': 'En attendant',
    'PROCESS': 'Processus',
    'PROCESSED': 'Traité',
    'PRESCRIBER_FIRST_NAME': 'Prénom du prescripteur',
    'PRESCRIBER_LAST_NAME': 'Nom de famille prescripteur',
    'PRESCRIBER_NAME': 'Nom du prescripteur',
    'REJECT': 'Rejeter',
    'REJECTED': 'Rejeté',
    'REQ_FIELD_WARNING': ' champs externes obligatoires à mapper',
    'RESET': 'Réinitialiser',
    'RESIZE': 'Redimensionner',
    'SELECT': 'Sélectionner',
    'SAVE': 'Sauvegarder',
    'SAVE_ALERT': 'Il y a des modifications non enregistrées, veuillez les enregistrer avant de partir.',
    'SHOW_TABLE': 'Afficher table',
    'STATUS': 'Statut',
    'SUBMIT': 'Soumettre',
    'TITLE': 'Nom du modèle',
    'UPDATE': 'Mettre à jour',
    'UPLOAD': 'Télécharger',
    'UNBLOCK': 'Débloquer',
    'UNMATCHED': 'Incomparable',
    'USERS': 'Utilisateurs',
    'VALIDATE_UPDATE': 'Valider et mettre à jour',
    'VERIFY': 'Vérifier',
    'VERIFY_DOCUMENT': 'Vérifier le document',
    'VERIFIED': 'Vérifié',
    'VIEW_FORMS': 'Voir les formulaires',
    'YES': 'Oui',
    'SUBSCRIBE': 'Souscrire',
    'UNSUBSCRIBE': 'Se désabonner',
    'UNAUTHORIZED': 'Non autorisé!',
    'UNMATCH': 'Le formulaire ne correspond à aucun modèle',
    'WEEK': 'la semaine',
    'ENTER_PASSWORD': 'Entrer le mot de passe',
    'WRONG_PASSWORD': 'Mauvais mot de passe',
    'Last Edited By': 'Last Edited By',
    'Enabled': 'Activé'
  },
  'PROCESS_ROLES': {
    'BARCODE': 'code à barre',
    'IMAGE_MATCH': 'Correspondance d\'image',
    'FORCE_TEMPLATE': 'Modèle de force',
    'PLAIN_TEXT': 'Texte brut'
  },
  'INVOICE': {
    'SIGN_INVOICE': 'SIGNER UNE FACTURE',
    'SIGN': 'Signe',
    'ACCOUNT': 'Compte',
    'ACCOUNTING_UNIT': 'Unité de comptabilité',
    'TOTAL_AMOUNT': 'Montant total',
    'ACC_REQ': 'Sélectionnez un compte',
    'ACC_UNIT_REQ': 'Sélectionnez une unité de comptabilité',
    'AMT_REQ': 'Le montant total est requis',
    'MIN_AMT': 'Le montant total doit être supérieur ou égal à zéro',
    'SIGN_SUCCESSFUL': 'Signé avec succès la facture',
    'APPROVAL_SUCCESSFUL': 'Approuvé avec succès la signature',
    'APPROVE_SIGN': 'APPROUVER LA VÉRIFICATION',
    'APPROVE': 'Approuver',
    'NOTES': 'Remarques'
  },
  'TEAMS': {
    'TEAM': 'Équipe',
    'TEAMS': 'Les équipes',
    'ADD_NEW_TEAM': 'Ajouter une nouvelle équipe',
    'CREATE_TEAM': 'Créer une équipe',
    'CREATE': 'Créer',
    'NAME': 'Nom',
    'DESCRIPTION': 'La description',
    'REQUIRED_FIELD': 'Champs requis',
    'NO_USER_FOUND': 'Aucun {ROLE} n\'a été trouvé. Veuillez ajouter un nouveau {ROLE}.',
    'NO_USER_ADDED': 'Aucun {ROLE} n\'a été ajouté à l\'équipe. Veuillez ajouter un {ROLE}.',
    'INCOMPLETE': 'L\'équipe est incomplète. Certains des rôles sont manquants dans la hiérarchie.',
    'DELETE_CONFIRM': 'Êtes-vous sûr de vouloir supprimer cette équipe de manière permanente?'
  },
  'Accounts': 'Comptes',
  'Add New': 'Ajouter un nouveau',
  'Add User': 'Ajouter un utilisateur',
  'Admin': 'Admin',
  'Admins': 'Les admins',
  'Aduit': 'Vérification',
  'Analytics': 'Analytique',
  'Configure': 'Configurer',
  'Forms': 'Formulaires',
  'Home': 'Accueil',
  'List': 'Liste',
  'Logs': 'Enregistrements',
  'New': 'Nouveau',
  'New User': 'Nouvel Utilisateur',
  'Processed': 'Traité',
  'Reports': 'Rapports',
  'Settings': 'Paramètres',
  'Models': 'Des modèles',
  'Super Admin': 'super administrateur',
  'Templates': 'Modèles',
  'Trails': 'Les sentiers',
  'Upload Form': 'formulaire de téléchargement',
  'Users': 'Utilisateurs',
  'Verification': 'Vérification',
  'Workflow': 'Flux de travail',
  'Mappings': 'Cartographies',
  'Add new mapping': 'Ajouter un nouveau mappage'
};

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'AUTH': {
    'CONFIRM_PASSWORD': 'Confirmar contraseña',
    'EMAIL': 'Email',
    'EMPTY_EMAIL': 'El correo electrónico no puede estar vacío.',
    'EMPTY_PASSWORD': 'La contraseña no puede estar vacía.',
    'FORGOT_PASSWORD': 'Se te olvidó tu contraseña',
    'INVALID_EMAIL': 'Por favor, proporcione un correo electrónico válido.',
    'INVALID_PASSWORD': 'La contraseña debe tener al menos {MINIMUM} caracteres.',
    'IDENTICAL_PASSWORD': 'Las contraseñas deben ser idénticas.',
    'LINK_EXPIRED': 'Enlace expirado.',
    'LINK_USED': 'Alguien ya ha usado este enlace. Si no es usted, vuelva a restablecer la contraseña.',
    'LOGIN': 'Iniciar sesión',
    'NEW_PASSWORD': 'Nueva contraseña',
    'PASSWORD': 'Contraseña',
    'PASSWORD_UPDATED': 'Se actualizó con éxito la contraseña.',
    'RESET_LINK_SENT': 'El enlace de restablecimiento ha sido enviado a un correo electrónico registrado.',
    'RESET_PASSWORD': 'Restablecer la contraseña',
    'SUBMIT': 'Enviar',
    'USER_LOGIN': 'Inicio de sesión de usuario',
    'USER_NOT_FOUND': 'Usuario no encontrado. Por favor, póngase en contacto con el administrador.',
    'PWD_CHANGE': 'Cambia la contraseña',
    'PWD_CURRENT': 'contraseña actual'
  },
  'ERROR': {
    'COMMON': 'Se produjo un error. Inténtalo de nuevo.'
  },
  'HEADER': {
    'TRIAL_USER': 'Eres un usuario de prueba. El período de prueba finaliza en {END_DATE}.',
    'NOTIFY_MSG': 'Tienes {len} notificaciones',
    'CLEAR': 'Claro',
    'TEMPLATES': 'Plantillas',
    'FORMS': 'Formularios',
    'UPLOAD_FORM': 'Cargar Formulario',
    'REPORTS': 'Informes',
    'PROFILE': 'Perfil',
    'USERS': 'Usuarios',
    'LOGS': 'Historial',
    'SETTINGS': 'Ajustes',
    'LOGOUT': 'Cerrar sesión',
    'ACCOUNTS': 'Cuentas',
    'MODELS': 'Modelos',
    'Features': 'Características'
  },
  'TEMPLATE': {
    'DATE_FORMAT': 'Formato de fecha',
    'ADD_NEW': 'Agregar una nueva plantilla',
    'ENABLE_AUTO_CORRECT': 'Habilitar corrección automática: ',
    'CLONE': 'Clona una plantilla desde otra cuenta.',
    'CREATE_NPI_GROUP': 'Crear grupo NPI',
    'DATA_TYPE': 'Datos Tipo',
    'DELETE_CONTENT': "¿Desea eliminar esta  '{TEMPLATE_TITLE}' plantilla?",
    'DELETE_MAP': 'Borrar Mapping (Cmd + d)',
    'DELETE_MODAL': 'Eliminar asignaciones',
    'DELETE_MODAL_CONTENT': '¿Estás seguro, quieres eliminar el campo? ?',
    'DRAW': 'Dibu',
    'DISABLE_FORM': 'Deshabilitar para envío de formulario',
    'ENABLE_FORM': 'Habilitar para envío de formulario',
    'ENTER_TITLE': 'Ingrese título....',
    'ENTER_DESCR': 'Introduzca  plantilla descripción',
    'GRP_NAME': 'Grupo Nombre',
    'GRP_TYPE': 'Grupo Tipo',
    'KEY': 'Llave',
    'MAPPING_CATEGORY': 'Categoría',
    'MAPPINGS': 'Mapeos:',
    'CASE': 'Caso',
    'MSG_ADDED': 'Plantilla agregada con éxito.',
    'MSG_REMOVED': 'Plantilla eliminada con éxito..',
    'MSG_SAVED': 'Los cambios del editor se guardan con éxito.',
    'MSG_SAVE_FAIL': 'Algo salió mal. El ahorro falló...',
    'NEXT_PAGE': 'Ir a la página siguiente',
    'NOTHING': 'Aucun modèle trouvé!',
    'ESMMAPPINGS': 'Asignaciones de servicios externos',
    'REDACT_FIELD': 'Redact Field',
    'SHOW_FIELD': 'Show Field',
    'TEMPLATE_VERSION_UPDATE': '¿Desea clonar las asignaciones de campos en la pantalla de asignación de servicios a la nueva versión de la plantilla?',
    'ESM_CLONING': 'Se clonarán las asignaciones de servicios externos',
    'ORTF_CLONING': 'Las asignaciones ORTF se clonarán',
    'SV_CLONING': 'Las validaciones de servicio se clonarán',
    'HL7_CLONING': 'Las asignaciones HL7 se clonarán',
    'CV_CLONING': 'Las asignaciones Custom Validations se clonarán',
    'NPI_GROUP': 'NPI grupo',
    'OLDER_VERSIONS': 'Las versiones anteriores no se pueden editar',
    'PREV_PAGE': 'Regresar a la pagina anterior',
    'REDO': 'Rehacer (Cmd + Shift + z)',
    'REQ': 'Necesario',
    'REQ_TYPE': 'Seleccionar tipo de proceso',
    'REQ_FILE': 'El archivo no puede estar en blanco',
    'REQ_TITLE': 'El título no puede estar en blanco',
    'SAVE': 'Salvar (Cmd + s)',
    'SAVE_CHANGES': '¿Te gusta guardar los cambios antes de salir del editor?',
    'SELECT': 'Seleccionar (Esc)',
    'SELECT_DATA_TYPE': 'Por favor, verifique el tipo de datos',
    'SELECT_DATE_FORMAT': 'Por favor seleccione formato de fecha',
    'SELECT_TYPE': 'Por favor selecciona tipo',
    'SELECT_FROM_ACCOUNT': 'De la cuenta',
    'SELECT_TO_ACCOUNT': 'A la cuenta',
    'SELECT_ACCOUNT': 'Seleccionar cuenta',
    'SELECT_TEMPLATE': 'Seleccionar plantilla',
    'SELECT_CASE': 'Seleccione el caso',
    'TEMPLATE': 'Modelo',
    'THEME': 'Tema',
    'THUMBNAIL': 'Miniatura',
    'TRAIN': 'Entrenar',
    'TRAIN_BASE': 'Train Base Template:',
    'TYPE': 'Tipo',
    'UPDATE_MAP': 'Actualización de mapeo',
    'UPDATE_GRP': 'Actualizar grupo',
    'UNDO': 'Deshacer (Cmd + z)',
    'UNSAVE': 'Cambios no guardados',
    'ZOOM_IN': 'Acercar (Cmd + +)',
    'ZOOM_OUT': 'Alejar (Cmd + -)',
    'IMPORT': 'Importar',
    'EXPORT': 'Exportar',
    'UPLOAD_MAPPINGS': 'Cargar archivo de asignaciones'
  },
  'TEMPLATE_VIEW': {
    'ID': 'Carné de identidad',
    'PAGES': ' PÁGINA(S)',
    'TOTAL_PAGES': 'Paginas totales',
    'UPDATED_AT': 'Actualizado en',
    'VIEW': 'VER:'
  },
  'DATA_TYPE': {
    'ALPHA': 'Alfabetos',
    'ALPHANUM': 'Alfanumérico',
    'ALPHANUMSPC': 'Alfanumérico With Spaces',
    'BLOCK': 'Bloquear',
    'CHECKBOX': 'Casilla de verificación',
    'CITY': 'Ciudad',
    'COMBINE_DATA': 'Datos combinados',
    'CHECKBOX_TEXT': 'Texto de casilla de verificación',
    'DATE': 'Fecha',
    'DEFAULT': 'Defecto',
    'EITHER': 'Cualquiera o Elección',
    'LOGICAL': 'Lógico',
    'MULTI_CHOICE': 'Múltiple Elección',
    'NPI': 'NPI',
    'NUMERIC': 'Numérico',
    'STATE': 'Estado',
    'TABLE_COLUMN': 'Tabla ( Datos de la columna )',
    'TABLE_ENTRY': 'Entrada de tabla',
    'TABLE_HEADER': 'Encabezado de tabla',
    'TABLE_ROW': 'Tabla ( Datos de la fila )',
    'TEXT': 'Texto',
    'ZIPCODE': 'Código postal',
    'CAPITALIZE': 'Ponga en mayúscula la primera letra de campo',
    'UPPER_CASE': 'Mayúscula',
    'LOWER_CASE': 'Minúscula'
  },
  'COLOR': {
    'BLUE': 'Azul',
    'GREEN': 'Verde',
    'RED': 'Rojo'
  },
  'UPLOAD_DROPDOWN': {
    'ENROLLMENT_FORMS': 'Formularios de inscripción',
    'SELECT': 'Seleccionar',
    'AUTO': 'Partido automático',
    'PLAIN': 'Texto sin formato',
    'INSURANCE': 'Tarjeta de seguro',
    'INSU_F_B': 'Tarjetas de seguro delanteras y traseras',
    'MANUAL': 'Manual',
    'DL': 'Licencia de conducir/ID del votante',
    'INVOICE': 'Factura',
    'EXCEL': 'Libro de Excel',
    'LEASE': 'Documento de arrendamiento',
    'SLA': 'Acuerdo de licencia de software',
    'AUS_LEASE': 'Documento de arrendamiento australiano',
    'TRIAGING': 'triaje',
    'BIOTRONIK': 'Biotronik',
    'MEDTRONIC2': 'Medtronic-2',
    'BOSTON': 'Boston Scientific',
    'MEDTRONIC': 'Medtronic'
  },
  'FORMS': {
    'ROTATE_LEFT': 'Girar a la izquierda',
    'ROTATE_RIGHT': 'Gira a la derecha',
    'IMAGE_ROTATE_SUCCESS': 'Rotación de imagen exitosa',
    'IMAGE_ROTATE_FAIL': 'Falló la rotación de la imagen',
    'MULTI_USER_MODAL': 'ADVERTENCIA',
    'MULTI_USER_ALERT_MSG': 'Actualmente, otro usuario está viendo este documento. Valide amablemente otro documento',
    'ACCEPT_PERMISSION_ERROR': 'No se puede aceptar el formulario que se requiere permiso.',
    'NEXT_FORM': '<< Documento siguiente',
    'PREV_FORM': 'Documento anterior >>',
    'SELECT_MODEL': 'Seleccionar modelo',
    'MODEL_NAME': 'Nombre del modelo',
    'MODEL_NAME_ERR': 'El nombre del modelo no puede estar en blanco',
    'USE_TITLE': 'Use el mismo título para todas las formas',
    'CONF_RANGE': 'Rango de confianza',
    'CHECK_ELIG_BTN_LABEL': 'Verificar elegibilidad',
    'CHECK_ELIG_SUCC_MESSAGE': 'Verificación de elegibilidad exitosa',
    'CHECKING_ELIG_BTN_LABEL': 'Comprobación de elegibilidad',
    'AVG_CONF': 'Confianza media',
    'COMP_IMAGES': 'Comparar con las imágenes subidas',
    'NO_LINE_ITEMS': 'No hay elementos de línea para mostrar ...',
    'AUTO_CORRECT': "Corrección automática'",
    'AUTO_CORRECT_CONTENT': 'El valor actualizado se utilizará en el futuro, ¿está seguro de que desea ahorrar?',
    'ACCEPT': 'Aceptar',
    'VERIFY': 'Verificar',
    'APPROVED': 'APROBADO',
    'ADD_FIELD': 'Agregue Field',
    'ALL': 'Para todas las Formas',
    'CON_SCORE': 'Confianza Score',
    'CHANGE_LABEL': 'Cambiar Etiqueta',
    'CHOOSE': 'Elija un formulario...',
    'DELETE_CONTENT': '¿Desea eliminar esta {FIELD_NAME} field?',
    'DESCRIPT_PLACE': 'Ingresa descripción del formulario',
    'DROP_SCANNED': 'Haga clic aquí / Arrastra y suelta archivos aquí para procesar',
    'DROP_TEMP_SCANNED': 'Haga clic aquí / arrastre y suelte archivos para cargar',
    'EDITED': 'EDITED',
    'EXPORT_ERROR': 'Error de asignaciones de exportación de Salesforce',
    'FORCED_TEMPLATE': 'Plantilla forzada',
    'LABEL': 'Etiqueta',
    'LABEL_NAME': 'Etiqueta Nombre',
    'MATCH': 'Coincidencia',
    'MATCHING_TEMPLATE': 'Ver plantilla a juego',
    'MSG_ACCEPT': 'Formulario aceptado',
    'MSG_DEL': 'Datos borrados con éxito',
    'MSG_LABEL': 'Etiqueta cambiada con éxito',
    'MSG_SUCESS': 'Datos actualizados con éxito',
    'MSG_WARN': 'El formulario cargado no se procesa',
    'NOTHING': 'No hay datos para mostrar......',
    'ONLY': 'Solo para esta forma',
    'PENDING': 'PENDIENTE',
    'PAGES_WITH_DATA': 'Paginas con datos',
    'PROCESS_TYPE': 'Tipo de proceso',
    'PROCESSED_DATA': 'Datos procesados',
    'PROCESSING_STAT': 'Los formularios subidos se están procesando ... Por favor, espere',
    'PROCESSED_STAT_ONE': 'Nuevo formulario ha sido procesado. Haga clic para actualizar',
    'PROCESSED_STAT_MANY': 'Se han procesado nuevos formularios. Haga clic para actualizar',
    'REJECTED': 'REJECTED',
    'REQ_TITLE': 'Título no puede estar en blanco',
    'REQ_LABEL': 'Nombre no puede estar en blanco',
    'REQ_FILE': 'Archivo no puede estar en blanco',
    'SELECT_PAGE_NUM': 'Página: ',
    'TABLE_DATA': 'Datos de tabla',
    'TEMPLATE': 'Modelo',
    'TITLE_PLACE': 'Título del formulario ...',
    'UPLOAD_PROCESS': 'Cargar y Procesar ...',
    'UPLOADING': 'Cargando ...',
    'UPLOAD_A_FORM': 'Cargar un formulario escaneado',
    'UPLOAD_MULTI_FORMS': 'Carga de formularios',
    'VALUE': 'Valor',
    'VALIDATION_HEADER': 'Por favor corrija / arregle los siguientes campos',
    'VALIDATE_SIGNATURE': 'Por favor apruebe / rechace la firma para verificar',
    'VALIDATIONS': 'Errores de validación',
    'REQUIRED_FIELDS_VALIDATION': 'Errores de campos obligatorios',
    'SERVICE_VALIDATION': 'Errores de validación del servicio',
    'VALIDATION_ERROR': 'Errores de validación',
    'OPTIONAL_FIELDS_VALIDATION': 'Errores de campos opcionales'
  },
  'WORKFLOW': {
    'LOCK_TITLE': 'Bloqueado por {userName}',
    'LOCK_ALERT_MSG': 'Voulez-vous déverrouiller cet enregistrement?',
    'ACTIONS': 'Acción',
    'ANALYSE': 'Analizar',
    'ANALYSIS': 'Análisis',
    'TITLE': 'Nombre del paciente',
    'INVOICE': 'Factura',
    'DOWNLOAD': 'Descargar',
    'FILTER': 'Aplicar filtros',
    'FILTERS': 'filtros',
    'MATCH': 'Coincidencia',
    'GROUP_ID': 'ID de Grupo',
    'PROCESSED_FORMS': 'Formularios procesados',
    'PROCESS_PAGE_COUNT': 'Recuento de páginas procesadas',
    'MATCHED_PAGE_COUNT': 'Número de páginas coincidentes',
    'REJECT_PAGE_COUNT': 'Recuento de páginas rechazadas',
    'SEARCH': 'Busqueda',
    'UPDATED_AT': 'Actualizado en',
    'DELETE_FORM': "¿Quieres borrar este formulario '{FORM_TITLE}'?",
    'FAX_NUMBER': 'Número de fax',
    'ENTER_FAX_NUMBER': 'Ingrese el número de fax',
    'DELETE': 'Borrar',
    'FORM_INFO_HEADER': 'Detalles de formularios procesados',
    'DELETE_MULTIPLE': 'Eliminar formas mutliples',
    'REPROCESS': 'Reprocesar',
    'MAX_RETRIES': 'Alcanzado Max cuenta de reintentos.',
    'MOVE_TO_MATCHED': 'Mover a la cola coincidente',
    'SF_STATUS': 'Estado',
    'DOCUMENT_TYPE': 'Tipo de Documento',
    'PRODUCT': 'Producto',
    'REPORT': 'Informe'
  },
  'ANALYTICS': {
    'TOTAL_FORMS': 'Total de formularios recibidos',
    'CONFIDENCE': 'Confianza (%)',
    'CONFIDENCE_AVG': 'Promedio de confianza por plantilla',
    'DAILY_REPORT': 'Reporte diario',
    'FILTER_TEMPLATES': 'Filtrar por Plantillas',
    'FORM_WORKFLOW_STATS': 'Estadísticas del flujo de trabajo',
    'IDENTIFIED': 'Identificado',
    'RECENT_FORMS': 'Formularios recientes',
    'FAXES_RECEIVED': 'Número total de Formularios de pacientes recibidos',
    'FAXES_IDENTIFIED': 'Número total de Formularios de pacientes identificados',
    'FAXES_READABLE': 'Número total de Formularios de pacientes legibles',
    'FAXES_REJECTED_ORIGIN': 'Total de pacientes rechazados según el país',
    'FAXES_REJECTED_BY_REASON': 'Total de formularios de pacientes rechazados debido a la legibilidad',
    'FAXES_UNPROCESSED': 'Total de formularios de pacientes no coincidentes con la plantilla',
    'REJECTED': 'Razón Rechazada',
    'WEEKLY_REPORT': 'Reporte semanal',
    'TOTAL_PROCESSED': 'Procesado',
    'TOTAL_REJECTED': 'Rechazado',
    'TEMPLATE': 'Modelo',
    'PROCESS_TYPE': 'Tipo de proceso',
    'SELECT_PROCESS_TYPE': 'tipo de proceso',
    'PAGES': 'Páginas',
    'RECENT_FORM_MSG': 'Los formularios recientes generados en el CSV pertenecerán únicamente al intervalo de fechas seleccionado.  ',
    'REPORT_CONTENT': 'Reportar contenido'
  },
  'CONFIGURED': {
    'ADD_ROLE': 'Agregar Rol',
    'ADD_GROUP': 'Agregar nuevo Campos',
    'ADD_ALIAS': 'Agregar alias',
    'ADD_FIELD_ALIAS': 'Añadir alias de campo',
    'ADD_NEW_KEYS': 'Agregar nuevas claves',
    'B_PREVIEW': 'Vista previa borde',
    'CONFIDENCE_COLORS': 'Colores de confianza',
    'CC_SUCCESS': 'Los colores de confianza se actualizan con éxito',
    'COLOR': 'Color',
    'CREATE': 'Crear',
    'IMPORT_MAPPINGS': 'Importar asignaciones',
    'EDIT_GROUP': 'Editar grupo',
    'EDIT_ALIAS': 'Editar alias',
    'FORM_ORDER': 'Orden de procesamiento de formulario',
    'FIELD_TYPE': 'Tipo de campo',
    'FIELD_EXISTS': 'Ya existe el campo',
    'FIELDS': 'Campos',
    'FIELDS_ALIASES': 'Alias de campo',
    'NEW_ROLE': 'Nuevo rol',
    'NOTE': 'Nota: Arrastra / suelta los elementos para cambiar el orden de procesamiento del formulario',
    'PREVIEW': 'Avance',
    'PROCESS_ORDER_SUCCESS': 'La orden de procesamiento se actualizó correctamente',
    'RANGE': 'Distancia',
    'ROLE_CREATED': ' el rol se crea con éxito',
    'ROLE_MANAGE': 'Gestión de roles',
    'ROLE_NAME': 'Nombre de rol',
    'ROLE_NOTE': 'Nota: Arrastre / suelte los elementos para cambiar el orden de los roles',
    'ROLE_ORDER': 'Orden de roles',
    'ROLE_ORDER_SUCCESS': 'Role Order se actualiza con éxito',
    'ROLE_SUCCESS': 'Los roles se actualizan con éxito',
    'SELECT_ROLE': 'Seleccionar rol',
    'PROCESS_TYPE': 'Tipos de procesos suscritos',
    'FIELD': 'Nombre del campo',
    'SUBSCRIBE_MODAL': 'Suscríbase a un nuevo tipo de proceso',
    'UNSUBSCRIBE_MODAL': 'Darse de baja un tipo de proceso',
    'SUBSCRIBE_PT': 'Suscrito con éxito un nuevo tipo de proceso',
    'UNSUBSCRIBE_PT': 'Cancelada exitosamente',
    'ENTER_SECTION_NAME': 'Ingrese el nombre de la sección',
    'SECTION_ORDER': 'Orden de sección',
    'SECTION_NOTE': 'Nota: Arrastre / suelte los elementos para cambiar el orden de la sección',
    'SECTION_ORDER_SUCCESS': 'El orden de la sección se ha actualizado correctamente',
    'HL7_TEMPLATES': 'Plantillas HL7'
  },
  'TRAILS': {
    'AUDIT_TRAILS': 'Pistas de Auditoría',
    'CREATED_AT': 'Registrado en',
    'LOCATION': 'Ubicación',
    'PATH': 'Camino',
    'CUSTOM_DATE_LOGS': 'Registros de fecha personalizados'
  },
  'USERS': {
    'ACCOUNT': 'Cuenta',
    'ADD_NEW': 'Agregar nuevos usuarios',
    'EMAIL': 'Correo electrónico',
    'PASSWORD': 'Contraseña',
    'PASS_CONFIRM': 'Confirmación de contraseña',
    'REPEAT': 'Repite Contraseña',
    'LINK': 'Enlace',
    'LIST': 'Lista de usuarios',
    'LOGOUT': 'Cerrar sesión',
    'REQ_USERNAME': 'Nombre de usuario no puede estar en blanco',
    'REQ_MIN_LENGTH': 'El nombre de usuario debe tener al menos 5 caracteres',
    'REQ_ONLY_ALPHANUM': 'El nombre de usuario puede ser solo caracteres alfanuméricos',
    'REQ_EMAIL': 'Email no puede estar vacío',
    'REQ_VALID_EMAIL': 'Por favor ingrese su dirección de correo electrónico válida',
    'REQ_PASS': 'Contraseña de usuario no puede estar en blanco',
    'REQ_PASS_MIN_LENGHT': 'La contraseña debe tener un mínimo de 8 caracteres de longitud',
    'REQ_NO_MATCH': 'La contraseña y la contraseña repetida no coinciden',
    'REQ_ACCOUNT': 'La Cuenta no puede estar vacía',
    'CREATE_ROLE': 'La función Atleast 1 debe crearse en la configuración para crear usuarios.',
    'REQ_ROLE': 'El rol no puede estar vacío',
    'ROLE': 'Papel',
    'ROLES': 'Roles',
    'SELECT_ROLE': 'Por favor seleccione un rol',
    'SELECT_TEAM': 'Por favor seleccione un equipo',
    'TEAM': 'Equipo',
    'T_END_DATE': 'Datos finales de prueba',
    'USERNAME': 'Usuario',
    'LAST_LOGIN': 'Último acceso'
  },
  'ACCOUNT': {
    'ADD_NEW': 'Agregar nueva cuenta',
    'CURRENT_SALESFORCE_ORG': 'Organización actual de Salesforce:',
    'CURRENT_SALESFORCE_URL': 'URL',
    'NAME': 'Cuenta Nombre',
    'LIST': 'Cuenta Lista',
    'VALID_BLANK': 'El nombre de la cuenta no puede estar en blanco.',
    'VALID_EXIST': 'Nombre de cuenta ya existe.',
    'VALID_MIN': 'El nombre de la cuenta debe tener una longitud mínima de 5 caracteres.',
    'ACCOUNT_TYPE': 'Tipo de cuenta',
    'OCR_ENGINE': 'Ocr Engine',
    'PROCESS_TYPE': 'Tipo de proceso',
    'END_DATE': 'Fecha final',
    'VALID_OCR_ENGINE': 'Select an Ocr Engine.',
    'VALID_ACCOUNT_TYPE': 'Seleccione un tipo de cuenta.',
    'VALID_END_DATE': 'Proporcionar una fecha de finalización válida.',
    'VALID_EMAIL': 'Proporcionar un correo electrónico válido (s).',
    'VALID_PROCESS_TYPE': 'Seleccione al menos 1 tipo de proceso.',
    'EDIT_ACCOUNT': 'Editar cuenta',
    'EMAIL': 'Email',
    'REASON': 'Razón',
    'ERRORS': 'ERRORES',
    'EMAIL_FORMAT': 'Formato de correo inválido.',
    'EMAIL_DIFF_ACC': 'Correo electrónico utilizado con una cuenta diferente.',
    'UPLOAD_LOGO': 'Subir logotipo',
    'ACCOUNT_LOGO': 'Logotipo de la cuenta',
    'DELETE_CONTENT': '¿Quieres borrar?'
  },
  'USER_DROPDOWN': {
    'PROFILE': 'Perfil',
    'ADMINS': 'administradores',
    'LOGS': 'bitácora',
    'SETTINGS': 'ajustes',
    'LOGOUT': 'cerrar sesión'
  },
  'FAB_TITLES': {
    'ADD_NEW_USER': 'añadir nuevo usuario',
    'ADD_TEMPLATE': 'añadir plantilla',
    'EXPORT': 'Exportar',
    'NEW_ACCOUNT': 'Nueva cuenta',
    'UPLOAD_FORM': 'cargar formulario'
  },
  'ROUTE_NAME': {
    'Accounts': 'Cuentas',
    'Admin': 'Administración',
    'Users': 'Usuarios',
    'Add a New User': 'Añadir un nuevo usuario',
    'Add New Account': 'Añadir nueva cuenta',
    'Configure': 'Configurar',
    'Dashboard': 'tablero de mandos',
    'Edit Account': 'Editar cuenta',
    'Edit User': 'editar usuario',
    'Form Status': 'Estado del formulario',
    'Log History': 'Historial de registro',
    'New Template': 'Nueva plantilla',
    'Reports': 'Flujo de trabajo',
    'Register': 'Registrar',
    'Template Listing': 'Listado de plantillas',
    'Train': 'Entrenar',
    'Sign In': 'Registrarse',
    'Upload Form': 'cargar formulario',
    'Form Doc': 'Verificación',
    'Verification': 'Verificación',
    'Forms': 'formas',
    'Reports Insights': 'Reports Insights',
    'My Profile': 'mi perfil',
    'MODELS': 'Modelos',
    'page-not-found': '',
    'Features': 'Características'
  },
  'PROFILE': {
    'ROLES': {
      'UNMATCHED': 'No Coincidente',
      'SUPERADMIN': 'súper administrador',
      'ADMIN': 'administrador',
      'TYPE_SELECT': 'Seleccione el tipo de cuenta',
      'TRIAL': 'Cuenta de prueba',
      'SUBS_ACC': 'Cuenta suscrita'
    },
    'ACCNAME': {
      'DEFAULT': 'defecto'
    },
    'ACCOUNT_INFO': 'Información de la cuenta',
    'ACCOUNT_SET': 'Configuraciones de la cuenta',
    'EMAIL_NOTIFY': 'Notificar al usuario por correo electrónico',
    'ENTER_USER': 'Introduzca su nombre de usuario',
    'ENTER_PASS': 'Introduzca nueva contraseña',
    'INFO': 'información del perfil',
    'MEMBERS': 'Miembros',
    'UPDATE_SUCCESS': 'perfil actualizado con éxito',
    'WRONG_PASSWORD': 'Las credenciales que proporcionó no eran correctas'
  },
  'COMMON': {
    'GO_BACK': 'Regresa',
    'OKAY': 'BUENO',
    'FILE_ERROR': 'Error al analizar el archivo',
    'PROCESS_ORDER_INFO': 'Docx utiliza dos técnicas para encontrar una plantilla coincidente para un formulario cargado. Son código de barras y coincidencia de imagen. La técnica de código de barras es donde el sistema busca las plantillas que tienen un tipo de código de barras similar al del formulario y Image Match es donde busca características similares entre la plantilla y las imágenes del formulario. Dependiendo del orden de procesamiento, el sistema prioriza la técnica que se utilizará. Por ejemplo, si el orden de procesamiento de Barcode es 1, se prefiere primero la técnica de Barcode y luego Image Match.',
    'MODEL_EXIST': 'El nombre del modelo ya existe',
    'ADD_MODEL': 'Agregar nuevo modelo',
    'NEW_MODEL': 'Nuevo modelo',
    'VERSION': 'Versión',
    'CHOOSE_FILE': 'Elija el archivo',
    'ACCEPT': 'Aceptar',
    'ACCEPTED': 'Aceptado',
    'ACCOUNT': 'Cuenta',
    'ACCOUNT_TYPE': 'Tipo de cuenta',
    'ACTION': 'Acción',
    'ACTIONS': 'Comportamiento',
    'ACTIVATE': 'Haga clic para activar',
    'ADD': 'Añadir',
    'ALERT': 'ALERTA',
    'APPROVE': 'Aprobar',
    'CANCEL': 'Cancelar',
    'CHANGE': 'Cambio',
    'CLEAR': 'Claro',
    'CLOSE': 'Cerca',
    'CLONE': 'Clon',
    'CONFIRM': 'Confirmación',
    'DATE_RANGE': 'Rango de fechas',
    'DATE_START': 'Fecha de inicio',
    'DATE_END': 'Fecha final',
    'DAY': 'Día',
    'DEACTIVATE': 'Haga clic para desactivar',
    'DELETE': 'Borrar',
    'DELETE_CONFIRM': 'Supprimer la confirmation',
    'DELETE_PERMANENTLY': 'borrar permanentemente',
    'DEL_AUTHCONFIG': 'No puede utilizar este Id. De cliente y este secreto de cliente después de la eliminación. ¿Estas seguro que quieres borrarlo?',
    'DEL_AUTO_CORRECT': 'Esta acción eliminará las funciones de corrección automática y el historial de este campo. ¿Estas seguro que quieres borrarlo?',
    'DEL_AUTO_CORRECT_HISTORY': 'Esta acción eliminará todos los campos de autocorrección del diccionario. ¿Estas seguro que quieres borrarlo?',
    'DEL_ORTFMAPPING': 'Esta acción eliminará permanentemente todas las asignaciones de campo ORTF de esta plantilla. ¿Estas seguro que quieres borrarlo?',
    'DEL_HL7MAPPING': 'Esta acción eliminará permanentemente todas las asignaciones de campo HL7 de esta plantilla. ¿Estas seguro que quieres borrarlo?',
    'DEL_SERVICEVALIDATION': 'Esta acción eliminará permanentemente todas las validaciones de servicio de esta plantilla. ¿Estas seguro que quieres borrarlo?',
    'DEL_CUSTOMVALIDATION': 'Esta acción eliminará permanentemente todas las validaciones de servicio de esta plantilla. ¿Estas seguro que quieres borrarlo?',
    'DEL_SERVICEMAPPING': 'Esta acción eliminará permanentemente todas las asignaciones de campos externos de esta plantilla. ¿Estas seguro que quieres borrarlo?',
    'QBS': 'Exportar a QuickBooks',
    'SLSFRC': 'Exportar a Salesforce',
    'REMS': 'Exportar a Rems',
    'CSV': 'Descargar como CSV',
    'HL7': 'Descargar como HL7',
    'FTP': 'Descargar como FTP',
    'OTRF': 'Descargar como OTRF',
    'EHR': 'Exportar a EHR',
    'FHIR': 'Ver datos FHIR',
    'FILTER_BY': 'Filtrado por',
    'EDT_USR': 'editar usuario',
    'MSG_ERROR_DATE': 'Fecha invalida',
    'MSG_PERM': 'El usuario será eliminado permanentemente del sistema.',
    'MSG_PERM_DEL': 'No puedes deshacer esta acción. ¿Estas seguro que quieres borrarlo?',
    'MSG_DEL': 'Esta acción eliminará los usuarios, roles, plantillas, formularios, mapas de servicio, configuración, etc. de la cuenta.',
    'DESCRIPTION': 'Descripción',
    'ESM': 'Los campos de plantilla no se asignan con el objeto de Salesforce. Por favor revise la configuración',
    'TM': 'Los campos de plantilla no se crean. Amablemente cree campos en la plantilla',
    'DONE': 'Terminado',
    'EDIT': 'Editar',
    'EXPIRES_AT': 'Vence a las',
    'EXPORT': 'Exportar',
    'FILE': 'Archivo',
    'FORM': 'Formar',
    'GENERATE': 'Generar',
    'GROUP_NAME': 'Nombre del grupo',
    'INTEGRATION_EMAILS': 'Correos electrónicos de integración',
    'INVALID_FILE': 'Archivo inválido. (El archivo debe estar en formato de .jpg, .jpeg, .png, .pdf, .tiff)',
    'LIST': 'Lista',
    'MARK_VERIFIED': 'Marca verificada',
    'MSG_CSV_LOG_DAYS': 'El rango máximo permitido es de un mes',
    'MSG_CSV_LOG_DAYS_ERROR': 'Por favor seleccione menos de 31 días',
    'MSG_EXPIRED': 'La sesión expiró, por favor inicie sesión para continuar',
    'MSG_RETRY': 'Algo salió mal. Por favor, intenta de nuevo',
    'MSG_REPROS': 'El formulario solicitado está siendo reprocesado. Por favor, espere.',
    'MSG_DRAW': 'Por favor habilite dibujar antes de crear formas ...',
    'MSG_INACTIVE': 'El servicio solicitado actualmente no está activo. Lo siento por los inconvenientes ocasionados.',
    'MSG_CREATE': 'Creado con éxito',
    'MSG_UPDATE': 'Actualizado exitosamente.',
    'MSG_DELETE': 'Se ha eliminado correctamente.',
    'MSG_DELETE_HISTORY': 'Eliminado correctamente del diccionario',
    'MSG_DELETE_ERR': 'Error al eliminar. Inténtalo de nuevo.',
    'MSG_FIELD_DEL': 'Se elimina el mapa de campo',
    'MSG_LOGIN': 'Por favor inicie sesión para acceder a la página solicitada',
    'MSG_LOGIN_SUCESS': 'Ha iniciado sesión con éxito. Bienvenido ',
    'MSG_USER_NF': '¡Usuario no encontrado!',
    'MSG_SERVER_UA': '¡Servidor no disponible!',
    'MSG_LOGIN_FAIL': 'Algo salió mal. El inicio de sesión ha fallado',
    'MSG_LOGOUT': 'Desconectado con éxito',
    'MSG_USER_UPDATE': 'Usuario actualizado correctamente.',
    'MSG_SIGNUP_FAIL': 'Algo salió mal. El registro ha fallado',
    'MSG_DATA_UPDATE': 'Datos actualizados exitosamente',
    'MSG_USER_CREATE': 'Usuario creado con éxito.',
    'MSG_ERROR': 'Ocurrió un error. Inténtalo de nuevo.',
    'MSG_FORM_REQ': 'O bien, no tiene acceso para ver el formulario / Formulario solicitado no encontrado.',
    'MSG_FETCH_ERR': 'Algo salió mal al buscar datos de formulario.',
    'MSG_PROCESS_FAIL': 'Procesamiento fallido, por favor intente de nuevo.',
    'MSG_FILE_LIMIT': 'El límite máximo de archivos es 5.',
    'MSG_TEMP_FILE_LIMIT': 'El límite máximo de archivos es 1.',
    'MSG_ACC_CREATE': 'Cuenta creada con éxito.',
    'MSG_SUCESS_ACC': 'Cuenta creada con éxito. Por favor, registrese',
    'MSG_EDIT_N_A': 'No permitido editar administrador',
    'MSG_ACC_SUCESS': 'Cuenta actualizada con éxito.',
    'MSG_UPD_FAIL': 'Algo salió mal. Actualización fallida.',
    'MSG_REQ_FIELD': 'Este es un campo obligatorio',
    'MSG_KEY_UNIQUE': 'La clave debe ser única.',
    'MSG_SELECT_TYPE': 'Por favor seleccione tipo',
    'MSG_SELECT_CHILD': 'Seleccione los hijos para eliminar junto con el grupo:',
    'NAME': 'Nombre',
    'NEW': 'Nuevo',
    'NO': 'No',
    'ADD_NPI_GROUPING': 'Agregar agrupación de NPI',
    'NOTIFICATION_EMAILS': 'Emails de notificación',
    'ENTER_MULTIPLE_EMAILS': 'Ingrese un correo electrónico separado por comas',
    'NOTIFY_MSG': 'Tienes {len} notificaciones',
    'NO_RECORD': 'No hay registros para mostrar',
    'OF': 'de',
    'PENDING': 'Pendiente',
    'PROCESS': 'Procesar',
    'PROCESSED': 'Procesada',
    'PRESCRIBER_FIRST_NAME': 'primer nombre del prescriptor',
    'PRESCRIBER_LAST_NAME': 'Apellido del prescriptor',
    'PRESCRIBER_NAME': 'Nombre del prescriptor',
    'REJECT': 'Rechazar',
    'REJECTED': 'Rechazado',
    'REQ_FIELD_WARNING': ' campos externos obligatorios para ser mapeados',
    'RESET': 'Reiniciar',
    'RESIZE': 'Redimensionar',
    'SELECT': 'Seleccionar',
    'SAVE': 'Salvar',
    'SAVE_ALERT': 'Hay algunos cambios no guardados, guárdelos antes de salir.',
    'SHOW_TABLE': 'Mostrar tabla',
    'STATUS': 'Estado',
    'SUBMIT': 'Enviar',
    'TITLE': 'Nombre del la plantilla',
    'UPDATE': 'Actualizar',
    'UPLOAD': 'Subir',
    'UNBLOCK': 'Desatascar',
    'UNMATCHED': 'No coinciden',
    'USERS': 'Usuarios',
    'VALIDATE_UPDATE': 'Validar y actualizar',
    'VERIFY': 'Verificar',
    'VERIFY_DOCUMENT': 'Verificar documento',
    'VERIFIED': 'Verificado',
    'VIEW_FORMS': 'Ver formularios',
    'YES': 'Sí',
    'SUBSCRIBE': 'Suscribir',
    'UNSUBSCRIBE': 'Darse de baja',
    'UNAUTHORIZED': 'No autorizado!',
    'UNMATCH': 'El formulario no coincide con ninguna plantilla',
    'WEEK': 'Semana',
    'ENTER_PASSWORD': 'Introducir la contraseña',
    'WRONG_PASSWORD': 'Contraseña incorrecta',
    'Last Edited By': 'Última edición por',
    'Enabled': 'Activado'
  },
  'PROCESS_ROLES': {
    'BARCODE': 'Código de barras',
    'IMAGE_MATCH': 'Coincidencia de imagen',
    'FORCE_TEMPLATE': 'Plantilla de fuerza',
    'PLAIN_TEXT': 'Texto sin formato'
  },
  'INVOICE': {
    'SIGN_INVOICE': 'FACTURA DE FIRMA',
    'SIGN': 'Firmar',
    'ACCOUNT': 'Cuenta',
    'ACCOUNTING_UNIT': 'Unidad de contabilidad',
    'TOTAL_AMOUNT': 'Cantidad total',
    'ACC_REQ': 'Seleccione una cuenta',
    'ACC_UNIT_REQ': 'Seleccione una unidad contable',
    'AMT_REQ': 'Se requiere la cantidad total',
    'MIN_AMT': 'La cantidad total debe ser mayor o igual a cero',
    'SIGN_SUCCESSFUL': 'Firmado con éxito la factura.',
    'APPROVAL_SUCCESSFUL': 'Aprobado con éxito la firma.',
    'APPROVE_SIGN': 'APROBAR LA VERIFICACIÓN',
    'APPROVE': 'Aprobar',
    'NOTES': 'Notas'
  },
  'TEAMS': {
    'TEAM': 'Equipo',
    'TEAMS': 'Equipos',
    'ADD_NEW_TEAM': 'Agregar nuevo equipo',
    'CREATE_TEAM': 'Crear equipo',
    'CREATE': 'Crear',
    'NAME': 'Nombre',
    'DESCRIPTION': 'Descripción',
    'REQUIRED_FIELD': 'Campo requerido',
    'NO_USER_FOUND': 'No se han encontrado {ROLE}. Agregue un nuevo {ROLE}.',
    'NO_USER_ADDED': 'No se agregaron {ROLE} al equipo. Agregue un {ROLE}.',
    'INCOMPLETE': 'El equipo está incompleto. Faltan algunos de los roles en la jerarquía.',
    'DELETE_CONFIRM': '¿Estás seguro de que deseas eliminar este equipo de forma permanente?'
  },
  'Accounts': 'Cuentas',
  'Add New': 'Agregar nuevo',
  'Add User': 'Agregar usuario',
  'Admin': 'Administración',
  'Admins': 'Administradores',
  'Aduit': 'Auditoría',
  'Analytics': 'Analítica',
  'Configure': 'Configurar',
  'Forms': 'Formularios',
  'Home': 'Casa',
  'List': 'Lista',
  'Logs': 'Registros',
  'New': 'Nuevo',
  'New User': 'Nuevo Usuario',
  'Processed': 'Procesada',
  'Reports': 'Informes',
  'Settings': 'Configuraciones',
  'Models': 'Modelos',
  'Super Admin': 'súper administrador',
  'Templates': 'Plantillas',
  'Trails': 'Caminos',
  'Upload Form': 'cargar formulario',
  'Users': 'Usuarios',
  'Verification': 'Verificación',
  'Workflow': 'Flujo de trabajo',
  'Mappings': 'Mapeos',
  'Add new mapping': 'Añadir nuevo mapeo'
};

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_224bad90_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(895);
function injectStyle (ssrContext) {
  __webpack_require__(893)
  __webpack_require__(894)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_224bad90_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 893 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 894 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"infinite-wrapper"},[_c('vue-progress-bar'),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 896 */,
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7adcad48_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(924);
function injectStyle (ssrContext) {
  __webpack_require__(898)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7adcad48_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 898 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  items: [{
    name: 'TEMPLATES',
    url: '/templates/list',
    svgIcon: 'templates'
  }, {
    name: 'FORMS',
    url: '/process/processed',
    svgIcon: 'forms'
  },
  // {
  //   name: 'UPLOAD_FORM',
  //   url: '/process/upload',
  //   svgIcon: 'uploadScan'
  // },
  {
    name: 'REPORTS',
    url: '/reports/logs',
    svgIcon: 'reports'
  }]
};

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svg = __webpack_require__(28);

var _svg2 = _interopRequireDefault(_svg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  'Template Listing': {
    title: 'ADD_TEMPLATE',
    url: '/templates/new',
    icon: _svg2.default.add,
    type: 'url'
  },
  'Reports': {
    title: 'EXPORT',
    url: '',
    icon: _svg2.default.export,
    type: 'button'
  },
  'Users': {
    title: 'ADD_NEW_USER',
    url: '/admin/new',
    icon: _svg2.default.add,
    type: 'url'
  },
  'Log History': {
    title: 'EXPORT',
    url: '',
    icon: _svg2.default.export,
    type: 'button'
  },
  'Train': {
    title: 'UPLOAD_FORM',
    url: '/process/upload',
    icon: _svg2.default.upload,
    type: 'url'
  },
  'Accounts': {
    title: 'NEW_ACCOUNT',
    url: '/super_admin/new',
    icon: _svg2.default.add,
    type: 'url'
  }
};

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponsiveNav = exports.PageTitle = exports.Header = exports.Footer = exports.Callout = exports.Breadcrumb = undefined;

var _Breadcrumb = __webpack_require__(902);

var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);

var _Callout = __webpack_require__(904);

var _Callout2 = _interopRequireDefault(_Callout);

var _Footer = __webpack_require__(128);

var _Footer2 = _interopRequireDefault(_Footer);

var _Header = __webpack_require__(907);

var _Header2 = _interopRequireDefault(_Header);

var _ResponsiveNav = __webpack_require__(915);

var _ResponsiveNav2 = _interopRequireDefault(_ResponsiveNav);

var _PageTitle = __webpack_require__(917);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Breadcrumb = _Breadcrumb2.default;
exports.Callout = _Callout2.default;
exports.Footer = _Footer2.default;
exports.Header = _Header2.default;
exports.PageTitle = _PageTitle2.default;
exports.ResponsiveNav = _ResponsiveNav2.default;

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_349e75a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(903);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_349e75a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item,index){return _c('li',{staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.$t(_vm.showName(item))))]):_c('router-link',{attrs:{"to":item}},[_vm._v(_vm._s(_vm.$t(_vm.showName(item))))])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ade4be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(905);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ade4be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer d-flex justify-content-center"},[_c('span',[_vm._v("Wilco Docx © "+_vm._s(_vm.currentYear)+" "),_c('a',{attrs:{"href":"http://wilcosource.com/","target":"_blank"}},[_vm._v("Wilcosource LLC")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49bcb3d4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(914);
function injectStyle (ssrContext) {
  __webpack_require__(908)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49bcb3d4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 908 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{staticClass:"dd-right",attrs:{"right":""}},[_c('template',{slot:"button-content"},[_c('v-gravatar',{staticClass:"img-avatar",attrs:{"email":_vm.currentUserEmail,"alt":_vm.currentUserEmail}})],1),_vm._v(" "),(_vm.isAdminRole)?_c('b-dropdown-item',{attrs:{"to":"/admin/users"}},[_c('div',{staticClass:"dd-icon",domProps:{"innerHTML":_vm._s(_vm.svg.ddAdmin)}}),_c('span',{staticClass:"dd-text"},[_vm._v(_vm._s(_vm.$t('HEADER.USERS')))])]):_vm._e(),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.logOut}},[_c('div',{staticClass:"dd-icon",domProps:{"innerHTML":_vm._s(_vm.svg.ddLogout)}}),_c('span',{staticClass:"dd-text"},[_vm._v(_vm._s(_vm.$t('HEADER.LOGOUT')))])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdownAccnt_vue__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdownAccnt_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdownAccnt_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdownAccnt_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdownAccnt_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a48ec09_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdownAccnt_vue__ = __webpack_require__(911);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdownAccnt_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a48ec09_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdownAccnt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{staticClass:"dd-right",attrs:{"right":""}},[_c('template',{slot:"button-content"},[_c('v-gravatar',{staticClass:"img-avatar",attrs:{"email":_vm.currentUserEmail,"alt":_vm.currentUserEmail}}),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.currentUserEmail.split('@')[0]))])],1),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":"/profile"}},[_c('div',{staticClass:"dd-icon",domProps:{"innerHTML":_vm._s(_vm.svg.ddUser)}}),_c('span',{staticClass:"dd-text"},[_vm._v(" "+_vm._s(_vm.$t('HEADER.PROFILE')))])]),_vm._v(" "),(_vm.isSuperAdmin)?_c('b-dropdown-item',{attrs:{"to":"/super_admin/accounts"}},[_c('div',{staticClass:"dd-icon",domProps:{"innerHTML":_vm._s(_vm.svg.ddAccounts)}}),_c('span',{staticClass:"dd-text"},[_vm._v(" "+_vm._s(_vm.$t('HEADER.ACCOUNTS')))])]):_vm._e(),_vm._v(" "),(_vm.isSuperAdmin)?_c('b-dropdown-item',{attrs:{"to":"/super_admin/features"}},[_c('div',{staticClass:"dd-icon",domProps:{"innerHTML":_vm._s(_vm.svg.featureflag)}}),_c('span',{staticClass:"dd-text"},[_vm._v(" "+_vm._s(_vm.$t('HEADER.Features')))])]):_vm._e(),_vm._v(" "),(_vm.isSuperAdmin)?_c('b-dropdown-item',{attrs:{"to":"/super_admin/models"}},[_c('div',{staticClass:"dd-icon",domProps:{"innerHTML":_vm._s(_vm.svg.ddModels)}}),_c('span',{staticClass:"dd-text"},[_vm._v(" "+_vm._s(_vm.$t('HEADER.MODELS')))])]):_vm._e(),_vm._v(" "),(_vm.isAdminRole)?_c('b-dropdown-item',{attrs:{"to":"/admin/users"}},[_c('div',{staticClass:"dd-icon",domProps:{"innerHTML":_vm._s(_vm.svg.ddAdmin)}}),_c('span',{staticClass:"dd-text"},[_vm._v(_vm._s(_vm.$t('HEADER.USERS')))])]):_vm._e(),_vm._v(" "),(_vm.isAdminRole)?_c('b-dropdown-item',{attrs:{"to":"/audits/trail"}},[_c('div',{staticClass:"dd-icon",domProps:{"innerHTML":_vm._s(_vm.svg.history)}}),_c('span',{staticClass:"dd-text"},[_vm._v(_vm._s(_vm.$t('HEADER.LOGS')))])]):_vm._e(),_vm._v(" "),(_vm.isAdminRole)?_c('b-dropdown-item',{attrs:{"to":"/settings/configure"}},[_c('div',{staticClass:"dd-icon",domProps:{"innerHTML":_vm._s(_vm.svg.ddSettings)}}),_c('span',{staticClass:"dd-text"},[_vm._v(_vm._s(_vm.$t('HEADER.SETTINGS')))])]):_vm._e(),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.logOut}},[_c('div',{staticClass:"dd-icon",domProps:{"innerHTML":_vm._s(_vm.svg.ddLogout)}}),_c('span',{staticClass:"dd-text"},[_vm._v(_vm._s(_vm.$t('HEADER.LOGOUT')))])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavItem_vue__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavItem_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavItem_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavItem_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11f00a3f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavItem_vue__ = __webpack_require__(913);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavItem_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11f00a3f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"menu-item",attrs:{"to":_vm.url},nativeOn:{"click":function($event){_vm.$store.commit('setPrevFormsTab', null)}}},[_c('div',{staticClass:"header-svg",domProps:{"innerHTML":_vm._s(_vm.svg[_vm.svgIcon])}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t(("HEADER." + _vm.name))))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.accountId != 73)?_c('header',{staticClass:"app-header navbar"},[_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('span',{staticClass:"navbar-brand",staticStyle:{"width":"150px!important"},domProps:{"innerHTML":_vm._s(_vm.svg.logo)}}),_vm._v(" "),_c('b-navbar-nav',{staticClass:"header-main",attrs:{"justified":""}},[_vm._l((_vm.headerItems),function(item,index){return [_c('NavItem',{key:index,attrs:{"name":item.name,"url":item.url,"svgIcon":item.svgIcon}})]})],2),_vm._v(" "),_c('b-navbar-nav',{staticClass:"right-menu"},[(_vm.trialUser)?_c('div',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-2x fa-info-circle trial-user mr-5",attrs:{"title":_vm.$t('HEADER.TRIAL_USER', { 'END_DATE': _vm.endDate })}})]):_vm._e(),_vm._v(" "),_c('HeaderDropdownAccnt')],1)],1):_c('div',{staticClass:"app-header navbar p-1",staticStyle:{"background":"#fbfbfb"}},[_c('b-row',{staticStyle:{"width":"100%"}},[_c('b-col',{staticClass:"text-center",attrs:{"sm":"2"}},[_c('router-link',{attrs:{"to":"/medical_insurance_cards/demo"},domProps:{"innerHTML":_vm._s(_vm.svg.logo)}})],1),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"sm":"8"}},[_c('h3',{staticStyle:{"color":"#4d4f52","font-weight":"bolder","padding-top":"10px"}},[_vm._v("\n        Medical Insurance Cards Processing using Document AI\n      ")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-navbar-nav',{staticStyle:{"flex-direction":"column","padding-top":"10px"}},[_c('MicpHeaderAccount')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResponsiveNav_vue__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResponsiveNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResponsiveNav_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResponsiveNav_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResponsiveNav_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8a2ae50_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResponsiveNav_vue__ = __webpack_require__(916);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResponsiveNav_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8a2ae50_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResponsiveNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"responsive-navbar-container"},[(_vm.visible)?_c('div',{staticClass:"responsive-navbar"},_vm._l((_vm.navItems),function(item,index){return _c('div',{key:index},[_c('router-link',{attrs:{"to":item.url},nativeOn:{"click":function($event){_vm.hideMenu($event)}}},[_vm._v(_vm._s(_vm.$t(("HEADER." + (item.name)))))])],1)})):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageTitle_vue__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageTitle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageTitle_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageTitle_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageTitle_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae13269e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageTitle_vue__ = __webpack_require__(920);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageTitle_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae13269e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageTitle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fab_vue__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fab_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fab_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fab_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab48ea32_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Fab_vue__ = __webpack_require__(919);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fab_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab48ea32_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Fab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAdminRole)?_c('div',[_c('div',{staticClass:"fab-title"},[_vm._v(_vm._s(_vm.$t(("FAB_TITLES." + (_vm.getFabLink.title)))))]),_vm._v(" "),(_vm.getFabLink)?_c('div',[(_vm.getFabLink.type === 'url')?_c('router-link',{attrs:{"to":_vm.getFabLink.url}},[_c('div',{staticClass:"fab-circle bg-secondary",domProps:{"innerHTML":_vm._s(_vm.getFabLink.icon)}})]):_c('div',[_c('b-button',{staticClass:"fab-circle bg-secondary",domProps:{"innerHTML":_vm._s(_vm.getFabLink.icon)},on:{"click":function($event){_vm.download(_vm.routeName)}}})],1)],1):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-title"},[_vm._v(_vm._s(_vm.$t(("ROUTE_NAME." + _vm.title)))+"\n  "),(_vm.fabExists)?_c('Fab',{attrs:{"fabList":_vm.fabList,"routeName":_vm.title}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sessionlogout_vue__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sessionlogout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sessionlogout_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sessionlogout_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sessionlogout_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_500e382f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sessionlogout_vue__ = __webpack_require__(923);
function injectStyle (ssrContext) {
  __webpack_require__(922)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-500e382f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sessionlogout_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_500e382f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sessionlogout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 922 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"title":"Session Timeout","no-close-on-backdrop":"","hide-header-close":""},model:{value:(_vm.showPopup),callback:function ($$v) {_vm.showPopup=$$v},expression:"showPopup"}},[_c('p',[_vm._v("Your session is about to expire in")]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(_vm.formatTime(_vm.countdownTime)))]),_vm._v(" "),_c('p',[_vm._v(" To stay logged in, please select \"Continue Session.\"")]),_vm._v(" "),_c('div',{staticClass:"modal-footer-buttons",staticStyle:{"justify-content":"space-between","display":"flex"},attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"modal-footer-left",staticStyle:{"padding-left":"200px"}},[_c('button',{staticClass:"modal-button primary-button",on:{"click":_vm.handleContinueSession}},[_vm._v("Continue Session")])]),_vm._v(" "),_c('div',{staticClass:"modal-footer-right",staticStyle:{"padding-left":"20px"}},[_c('button',{staticClass:"modal-button danger-button",on:{"click":_vm.logoutSession}},[_vm._v("Log Out")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ( _vm.appMode === 'service')?_c('div',{staticClass:"app"},[_c('div',{staticClass:"app-body"},[_c('main',{staticClass:"main"},[_c('div',{staticClass:"p-0 container-fluid"},[_c('router-view')],1)])])]):_c('div',{staticClass:"app"},[_c('AppHeader',{attrs:{"navItems":_vm.nav},on:{"showNavBar":_vm.toggleVisible}}),_vm._v(" "),_c('ResponsiveNav',{attrs:{"visible":_vm.visible,"navItems":_vm.nav},on:{"hideMenu":_vm.hideMenu}}),_vm._v(" "),_c('PageTitle',{attrs:{"title":_vm.name,"fabList":this.fab}}),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('main',{staticClass:"main"},[_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)])]),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d7e902c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(988);
function injectStyle (ssrContext) {
  __webpack_require__(926)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8d7e902c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d7e902c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 926 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{staticClass:"dd-lang",attrs:{"right":""}},[_c('template',{slot:"button-content"},[_c('div',{staticClass:"flag flag-selected",domProps:{"innerHTML":_vm._s(_vm.selectedFlag)}}),_vm._v(" "),_c('span',{staticClass:"selected-lang"},[_vm._v(_vm._s(_vm.selectedLang))])]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"language-drop-down",on:{"click":function($event){_vm.setLang('en')}}},[_c('div',{staticClass:"flag",domProps:{"innerHTML":_vm._s(_vm.svg.en)}}),_vm._v(" English ")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"language-drop-down",on:{"click":function($event){_vm.setLang('fr')}}},[_c('div',{staticClass:"flag",domProps:{"innerHTML":_vm._s(_vm.svg.fr)}}),_vm._v(" Français ")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"language-drop-down",on:{"click":function($event){_vm.setLang('es')}}},[_c('div',{staticClass:"flag",domProps:{"innerHTML":_vm._s(_vm.svg.es)}}),_vm._v(" Español ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _msalBrowser = __webpack_require__(280);

var Msal = _interopRequireWildcard(_msalBrowser);

var _config = __webpack_require__(317);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  mounted: function mounted() {
    var _this = this;

    this.applicationConfig = {
      clientId: _config2.default.clientid,
      authority: _config2.default.authority,
      redirectUri: _config2.default.redirecturl
    };
    this.app = new Msal.PublicClientApplication({ auth: this.applicationConfig });
    this.app.initialize().then(function () {
      _this.app.handleRedirectPromise().then(_this.handleResponse).catch(function (err) {
        console.log('error intilizing MSAl Promise', err);
      });
    });
  },
  data: function data() {
    return {
      app: null
    };
  },

  methods: {
    loginRedirect: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var loginRequest;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loginRequest = {
                  scopes: ['openid', 'profile', 'User.Read']
                };
                _context.next = 3;
                return this.app.loginRedirect(loginRequest);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loginRedirect() {
        return _ref.apply(this, arguments);
      }

      return loginRedirect;
    }(),
    handleResponse: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resp) {
        var accessToken, username, redirectUrl, payload, loginRequest;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(resp !== null)) {
                  _context2.next = 7;
                  break;
                }

                accessToken = resp.accessToken, username = resp.account.username;
                redirectUrl = this.$route.query.redirect_to;
                payload = { authData: { username: username, accessToken: accessToken }, redirectpath: redirectUrl };

                this.$store.dispatch('ssoLogin', payload);
                _context2.next = 10;
                break;

              case 7:
                loginRequest = {
                  scopes: ['openid', 'profile', 'User.Read']
                };
                _context2.next = 10;
                return this.app.loginRedirect(loginRequest);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleResponse(_x) {
        return _ref2.apply(this, arguments);
      }

      return handleResponse;
    }()
  }

};

/***/ }),
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app d-flex flex-column"},[_c('div',{staticClass:"body align-self-center d-flex flex-column justify-content-center align-items-center"},[_c('div',{staticClass:"logo-container"},[_c('div',{staticClass:"signin-logo mb-4",domProps:{"innerHTML":_vm._s(_vm.svg.logo)}})]),_vm._v(" "),_c('b-card',{staticClass:"p-4 mb-0 input-card d-flex flex-column align-items-stretch",attrs:{"no-body":""}},[_c('b-card-body'),_vm._v(" "),_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('span',{staticClass:"ms-label"},[_vm._v("Login with")]),_vm._v(" "),_c('b-img',{attrs:{"src":"../../../static/img/microsoft.png","fluid":"","alt":"Fluid image"},on:{"click":_vm.loginRedirect}})],1)],1)],1)],1),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManualLogin_vue__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManualLogin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManualLogin_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManualLogin_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManualLogin_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df423a22_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManualLogin_vue__ = __webpack_require__(1020);
function injectStyle (ssrContext) {
  __webpack_require__(990)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-df423a22"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManualLogin_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df423a22_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManualLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 990 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _msalBrowser = __webpack_require__(280);

var Msal = _interopRequireWildcard(_msalBrowser);

var _config = __webpack_require__(317);

var _config2 = _interopRequireDefault(_config);

var _store = __webpack_require__(133);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AuthService = function () {
  function AuthService(redirectUrl) {
    var _this = this;

    _classCallCheck(this, AuthService);

    this.redirecturl = redirectUrl;
    this.applicationConfig = {
      clientId: _config2.default.clientid,
      authority: _config2.default.authority,
      redirectUri: _config2.default.redirecturl
    };
    this.app = new Msal.PublicClientApplication({ auth: this.applicationConfig });

    this.app.initialize().then(function () {
      _this.app.handleRedirectPromise().then(_this.handleResponse.bind(_this)).catch(function (err) {
        console.log(err);
      });
    });
  }

  _createClass(AuthService, [{
    key: 'handleResponse',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resp) {
        var accessToken, username, payload;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (resp !== null) {
                  accessToken = resp.accessToken, username = resp.account.username;
                  payload = { authData: { username: username, accessToken: accessToken }, redirectpath: this.app.redirectUrl };

                  _store2.default.dispatch('ssoLogin', payload);
                }

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleResponse(_x) {
        return _ref.apply(this, arguments);
      }

      return handleResponse;
    }()
  }, {
    key: 'signIn',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var loginRequest;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                loginRequest = {
                  scopes: ['openid', 'profile', 'User.Read']
                };
                _context2.next = 4;
                return this.app.loginRedirect(loginRequest);

              case 4:
                _context2.next = 10;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2['catch'](0);

                console.error('error in signIN ', _context2.t0.message);
                throw new Error('Sing in Error');

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 6]]);
      }));

      function signIn() {
        return _ref2.apply(this, arguments);
      }

      return signIn;
    }()
  }]);

  return AuthService;
}();

exports.default = AuthService;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {
    templateList: []
  },
  getters: {
    templateList: function templateList(state) {
      return state.templateList;
    },
    noTemplates: function noTemplates(state) {
      return state.templateList.length === 0;
    }
  },
  mutations: {
    fetchTemplates: function fetchTemplates(state, templateArray) {
      state.templateList = templateArray;
    }
  },
  actions: {
    fetchTemplates: function fetchTemplates(_ref) {
      var commit = _ref.commit,
          rootState = _ref.rootState;

      if (!rootState.idToken) {
        return;
      }
      _vue2.default.axios.get('template_docs', { headers: { Authorization: 'Bearer ' + rootState.idToken } }).then(function (res) {
        commit('fetchTemplates', res.data.template_docs);
      });
    },
    addNewTemplate: function addNewTemplate(_ref2, templateData) {
      var _this = this;

      var commit = _ref2.commit,
          state = _ref2.state,
          rootState = _ref2.rootState;

      if (!rootState.idToken) {
        return;
      }
      var data = new window.FormData();
      data.append('image', templateData.file, templateData.file.name);
      data.append('title', templateData.title);
      data.append('account_id', templateData.accountId);
      _vue2.default.axios.post('template_docs', data, { headers: {
          Authorization: 'Bearer ' + rootState.idToken,
          'content-type': 'multipart/form-data' }
      }).then(function (res) {
        _vue2.default.toasted.show(_this._vm.$i18n.translate('TEMPLATE.MSG_ADDED'));
        _router2.default.push('/templates/list');
      }, function (error) {
        console.log(error);
      });
    },
    removeTemplate: function removeTemplate(_ref3, templateData) {
      var _this2 = this;

      var commit = _ref3.commit,
          state = _ref3.state,
          rootState = _ref3.rootState,
          dispatch = _ref3.dispatch;

      if (!rootState.idToken) {
        return;
      }
      _vue2.default.axios.delete('template_docs/' + templateData.id, { headers: {
          Authorization: 'Bearer ' + rootState.idToken }
      }).then(function (res) {
        dispatch('fetchTemplates');
        _vue2.default.toasted.show(_this2._vm.$i18n.translate('TEMPLATE.MSG_REMOVED'));
      }, function (error) {
        console.log(error);
      });
    }
  }
};

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  state: {
    formData: {},
    processedData: []
  },
  getters: {
    getFormData: function getFormData(state) {
      return state.formData;
    },
    getProcessedData: function getProcessedData(state) {
      return state.processedData;
    }
  },
  mutations: {
    setFormData: function setFormData(state, formData) {
      state.formData = formData;
    },
    SET_PROCESSED_DATA: function SET_PROCESSED_DATA(state, payload) {
      state.processedData = payload;
    }
  },
  actions: {
    updateFormData: function updateFormData(_ref, formData) {
      var commit = _ref.commit;

      commit('setFormData', formData);
    },
    updateProcessedData: function updateProcessedData(_ref2, payload) {
      var commit = _ref2.commit;

      commit('SET_PROCESSED_DATA', payload);
    }
  }
};

/***/ }),
/* 994 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app d-flex flex-column"},[_c('div',{staticClass:"body align-self-center d-flex flex-column justify-content-center align-items-center"},[_c('div',{staticClass:"logo-container"},[_c('div',{staticClass:"signin-logo mb-4",domProps:{"innerHTML":_vm._s(_vm.svg.logo)}})]),_vm._v(" "),_c('b-card',{staticClass:"p-4 mb-0 input-card d-flex flex-column align-items-stretch",attrs:{"no-body":""}},[_c('b-card-body',[_c('div',[_c('h4',[_vm._v(_vm._s(_vm.$t('AUTH.USER_LOGIN')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('AUTH.EMAIL')))]),_vm._v(" "),_c('b-input-group',{staticClass:"mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-user"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.email),expression:"user.email"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.user.email.$error, 'is-valid': !_vm.$v.user.email.$invalid},attrs:{"type":"text","placeholder":_vm.$t('AUTH.EMAIL')},domProps:{"value":(_vm.user.email)},on:{"blur":function($event){_vm.$v.user.email.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "email", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.user.email.required)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('AUTH.EMPTY_EMAIL')))]):_vm._e(),_vm._v(" "),(!_vm.$v.user.email.email)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('AUTH.INVALID_EMAIL')))]):_vm._e()],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('AUTH.PASSWORD')))]),_vm._v(" "),_c('b-input-group',{staticClass:"mb-4"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-lock"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.password),expression:"user.password"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.user.password.$error, 'is-valid': !_vm.$v.user.password.$invalid},attrs:{"type":"password","placeholder":_vm.$t('AUTH.PASSWORD')},domProps:{"value":(_vm.user.password)},on:{"blur":function($event){_vm.$v.user.password.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "password", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.user.password.required)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('AUTH.EMPTY_PASSWORD')))]):_vm._e()],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-button',{staticClass:"login-btn",attrs:{"variant":"secondary","disabled":_vm.$v.$invalid || _vm.isLoginLoading},on:{"click":_vm.loginSubmit}},[_vm._v(_vm._s(_vm.$t('AUTH.LOGIN')))])],1)],1)],1)]),_vm._v(" "),_c('b-col',{staticClass:"text-center mb-2 seperator",attrs:{"cols":"12"}},[_c('h5',[_vm._v("OR")])]),_vm._v(" "),_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('span',{staticClass:"ms-label"},[_vm._v("Login with")]),_vm._v(" "),_c('b-img',{attrs:{"src":"../../../static/img/microsoft.png","fluid":"","alt":"Fluid image"},on:{"click":_vm.msLogin}})],1)],1)],1)],1),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51ebe060_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__(1023);
function injectStyle (ssrContext) {
  __webpack_require__(1022)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51ebe060"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51ebe060_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1022 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app d-flex flex-column"},[_c('div',{staticClass:"body align-self-center d-flex flex-column justify-content-center align-items-center"},[_c('div',{staticClass:"logo-container"},[_c('div',{staticClass:"signin-logo mb-4",domProps:{"innerHTML":_vm._s(_vm.svg.logo)}})]),_vm._v(" "),_c('b-card',{staticClass:"p-4 mb-0 input-card d-flex flex-column align-items-stretch",attrs:{"no-body":""}},[_c('b-card-body',[_c('div',[_c('div',{staticClass:"language-select"},[_c('Language')],1),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t('AUTH.RESET_PASSWORD')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('AUTH.NEW_PASSWORD')))]),_vm._v(" "),_c('b-input-group',{staticClass:"mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-user"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.resetPassword),expression:"resetPassword"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.resetPassword.$error, 'is-valid': !_vm.$v.resetPassword.$invalid},attrs:{"type":"password","placeholder":_vm.$t('AUTH.NEW_PASSWORD')},domProps:{"value":(_vm.resetPassword)},on:{"blur":function($event){_vm.$v.resetPassword.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.resetPassword=$event.target.value}}}),_vm._v(" "),(!_vm.$v.resetPassword.minLength)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('AUTH.INVALID_PASSWORD', { 'MINIMUM': _vm.$v.resetPassword.$params.minLength.min })))]):_vm._e()],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('AUTH.CONFIRM_PASSWORD')))]),_vm._v(" "),_c('b-input-group',{staticClass:"mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-user"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmResetPassword),expression:"confirmResetPassword"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.confirmResetPassword.$error, 'is-valid': !_vm.$v.confirmResetPassword.$invalid},attrs:{"type":"password","placeholder":_vm.$t('AUTH.CONFIRM_PASSWORD')},domProps:{"value":(_vm.confirmResetPassword)},on:{"blur":function($event){_vm.$v.confirmResetPassword.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.confirmResetPassword=$event.target.value}}}),_vm._v(" "),(!_vm.$v.confirmResetPassword.sameAsPassword)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('AUTH.IDENTICAL_PASSWORD')))]):_vm._e()],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-button',{staticClass:"login-btn",attrs:{"variant":"secondary","disabled":_vm.$v.$invalid},on:{"click":_vm.changePassword}},[_vm._v(_vm._s(_vm.$t('AUTH.RESET_PASSWORD')))])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"action-btn-container"},[_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-button',{staticClass:"px-0 mt-2",attrs:{"variant":"link"},on:{"click":_vm.loginClicked}},[_c('h5',[_vm._v(_vm._s(_vm.$t('AUTH.LOGIN')))])])],1)],1)],1)])],1)],1),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Auth_vue__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Auth_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Auth_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Auth_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Auth_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43e6f298_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__ = __webpack_require__(1025);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Auth_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43e6f298_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_submitForm_vue__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_submitForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_submitForm_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_submitForm_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_submitForm_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd3bdd78_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_submitForm_vue__ = __webpack_require__(1034);
function injectStyle (ssrContext) {
  __webpack_require__(1027)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bd3bdd78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_submitForm_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd3bdd78_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_submitForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1027 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formDataTree_vue__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formDataTree_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formDataTree_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formDataTree_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formDataTree_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dfff3b6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formDataTree_vue__ = __webpack_require__(1033);
function injectStyle (ssrContext) {
  __webpack_require__(1029)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2dfff3b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formDataTree_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dfff3b6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formDataTree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1029 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.mappings),function(child){return _c('div',{key:child.path},[(child.map_type === 'shape')?_c('div',[(child.data_type === 'date')?_c('b-row',{staticClass:"pt-2"},[_c('b-col',{attrs:{"cols":"4"}},[_c('label',[_vm._v(_vm._s(child['key']))]),_vm._v(" "),(child.required)?_c('sup',{staticClass:"text-danger required-css"},[_c('i',{staticClass:"fa fa-asterisk"})]):_vm._e(),_vm._v(" "),(_vm.shouldShowError(child.id))?_c('h6',{staticClass:"error-msg"},[_vm._v("This is a required field.")]):_vm._e()]),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('input',{staticClass:"form-control",attrs:{"type":"date"},on:{"input":function($event){_vm.updateFormField($event, child.id, child.data_type)}}})])],1):(child.data_type === 'checkbox')?_c('b-row',{staticClass:"pt-2"},[_c('b-col',{attrs:{"cols":"4"}},[_c('label',[_vm._v(_vm._s(_vm._f("capitalize")(child.key)))]),_vm._v(" "),(child.required)?_c('sup',{staticClass:"text-danger required-css"},[_c('i',{staticClass:"fa fa-asterisk"})]):_vm._e(),_vm._v(" "),(_vm.shouldShowError(child.id))?_c('h6',{staticClass:"error-msg"},[_vm._v("This is a required field.")]):_vm._e()]),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('input',{attrs:{"type":"checkbox"},on:{"input":function($event){_vm.updateFormField($event, child.id, child.data_type)}}})])],1):(child.data_type === 'email')?_c('b-row',{staticClass:"pt-2"},[_c('b-col',{attrs:{"cols":"4"}},[_c('label',[_vm._v(_vm._s(child['key']))]),_vm._v(" "),(child.required)?_c('sup',{staticClass:"text-danger required-css"},[_c('i',{staticClass:"fa fa-asterisk"})]):_vm._e(),_vm._v(" "),(_vm.shouldShowError(child.id))?_c('h6',{staticClass:"error-msg"},[_vm._v("This is a required field.")]):_vm._e()]),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('input',{staticClass:"form-control",attrs:{"type":"email"},on:{"input":function($event){_vm.updateFormField($event, child.id, child.data_type)}}})])],1):(child.data_type === 'numeric' || child.data_type === 'phone' || 
                      child.data_type === 'fax' || child.data_type === 'npi' || child.data_type === 'zip')?_c('b-row',{staticClass:"pt-2"},[_c('b-col',{attrs:{"cols":"4"}},[_c('label',[_vm._v(_vm._s(child['key']))]),_vm._v(" "),(child.required)?_c('sup',{staticClass:"text-danger required-css"},[_c('i',{staticClass:"fa fa-asterisk"})]):_vm._e(),_vm._v(" "),(_vm.shouldShowError(child.id))?_c('h6',{staticClass:"error-msg"},[_vm._v("This is a required field.")]):_vm._e()]),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('input',{staticClass:"form-control",attrs:{"type":"number"},on:{"input":function($event){_vm.updateFormField($event, child.id, child.data_type)}}})])],1):(child.data_type === 'signature')?_c('b-row',{staticClass:"pt-2"},[_c('b-col',{attrs:{"cols":"4"}},[_c('label',[_vm._v(_vm._s(child['key']))]),_vm._v(" "),(child.required)?_c('sup',{staticClass:"text-danger required-css"},[_c('i',{staticClass:"fa fa-asterisk"})]):_vm._e(),_vm._v(" "),(_vm.shouldShowError(child.id))?_c('h6',{staticClass:"error-msg"},[_vm._v("Please save after signing.")]):_vm._e()]),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('VueSignaturePad',{ref:'signaturePad_'+child.id,refInFor:true,staticClass:"signature",attrs:{"width":"100%","height":"100px","options":_vm.options},on:{"input":function($event){_vm.updateFormField($event, child.id, child.data_type)}}}),_vm._v(" "),_c('div',{staticClass:"pt-1 pull-right",attrs:{"syle":"width:100%"}},[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.undoSignature(child.id)}}},[_vm._v("Undo")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){_vm.resetSignature(child.id)}}},[_vm._v("Clear")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.saveSignature(child.id)}}},[_vm._v("Save")])],1)],1)],1):_c('b-row',{staticClass:"pt-2"},[_c('b-col',{attrs:{"cols":"4"}},[_c('label',[_vm._v(_vm._s(child['key']))]),_vm._v(" "),(child.required)?_c('sup',{staticClass:"text-danger required-css"},[_c('i',{staticClass:"fa fa-asterisk"})]):_vm._e(),_vm._v(" "),(_vm.shouldShowError(child.id))?_c('h6',{staticClass:"error-msg"},[_vm._v("This is a required field.")]):_vm._e()]),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('input',{staticClass:"form-control",attrs:{"type":"text"},on:{"input":function($event){_vm.updateFormField($event, child.id, child.data_type)}}})])],1)],1):(child.map_type === 'group')?_c('div',[(child.data_type === 'logical' || child.data_type === 'npi' ||
                  child.data_type === 'combine_data' || child.data_type === 'checkbox_text')?_c('div',{staticClass:"pt-2"},[_c('b-col',{staticClass:"p-0",attrs:{"cols":"12"}},[_c('h4',[_vm._v(_vm._s(_vm._f("capitalize")(child.key)))])]),_vm._v(" "),_c('form-data-tree',{attrs:{"templateId":_vm.templateId,"mappings":child.children,"dataBus":_vm.dataBus,"showErrors":_vm.showErrors,"formErrors":_vm.formErrors}})],1):(child.data_type === 'single_select')?_c('b-row',{staticClass:"pt-2"},[_c('b-col',{attrs:{"cols":"4"}},[_c('label',[_vm._v(_vm._s(_vm._f("capitalize")(child.key)))]),_vm._v(" "),(child.required)?_c('sup',{staticClass:"text-danger required-css"},[_c('i',{staticClass:"fa fa-asterisk"})]):_vm._e(),_vm._v(" "),(_vm.shouldShowError(child.id))?_c('h6',{staticClass:"error-msg"},[_vm._v("Please select an option.")]):_vm._e()]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8"}},_vm._l((child.children),function(radioInput){return _c('div',{key:radioInput.path,staticClass:"single-select"},[_c('input',{attrs:{"type":"radio","name":'child_'+child.id},on:{"input":function($event){_vm.updateFormField($event, radioInput.id, radioInput.data_type, child.id, 'single_select')}}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(radioInput.key))])])}))],1):(child.data_type === 'multi_select')?_c('b-row',{staticClass:"pt-2"},[_c('b-col',{attrs:{"cols":"4"}},[_c('label',[_vm._v(_vm._s(_vm._f("capitalize")(child.key)))]),_vm._v(" "),(child.required)?_c('sup',{staticClass:"text-danger required-css"},[_c('i',{staticClass:"fa fa-asterisk"})]):_vm._e(),_vm._v(" "),(_vm.shouldShowError(child.id))?_c('h6',{staticClass:"error-msg"},[_vm._v("Please select atleast one option.")]):_vm._e()]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8"}},_vm._l((child.children),function(checkboxInput){return _c('div',{key:checkboxInput.path,staticClass:"multi-select"},[_c('input',{attrs:{"type":"checkbox","name":'child_'+child.id},on:{"input":function($event){_vm.updateFormField($event, checkboxInput.id, checkboxInput.data_type)}}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(checkboxInput.key))])])}))],1):_vm._e()],1):_vm._e()])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"submission-form"},[_c('div',{staticClass:"submission-form-header"},[_c('h3',[_vm._v(_vm._s(_vm.templateDoc.title))])]),_vm._v(" "),_c('div',{staticClass:"submission-form-body"},[(_vm.templateLoaded)?_c('div',[_vm._l((_vm.templateDoc['templates']),function(template){return _c('div',[(template.mappings && template.mappings.children)?_c('div',[_c('form-data-tree',{attrs:{"templateId":template.id,"mappings":template.mappings.children,"dataBus":_vm.dataBus,"showErrors":_vm.showErrors,"formErrors":_vm.formErrors}})],1):_vm._e()])}),_vm._v(" "),(_vm.showErrors)?_c('h5',{staticClass:"error-msg"},[_vm._v("Please fill all the required fields.")]):_vm._e()],2):_c('div',[_c('content-placeholders',[_c('content-placeholders-img',{style:({height: '400px'})})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"submission-form-footer"},[_c('b-button',{staticClass:"submit-button",attrs:{"variant":"secondary"},on:{"click":_vm.submitForm}},[_vm._v("Submit")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e024f026_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1039);
function injectStyle (ssrContext) {
  __webpack_require__(1036)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e024f026"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e024f026_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1036 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-primary tab-header"},[_c('h5',{staticClass:"bg-primary p-3 my-auto"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._v(" "),_c('div',{staticClass:"p-3 pr-5 pd-0 col-lg-3 search"},[_vm._m(0),_vm._v(" "),_c('b-input-group',[_c('b-form-input',{ref:"searchInput",staticClass:"search-text",attrs:{"placeholder":_vm.$t('WORKFLOW.SEARCH')},on:{"input":_vm.emitInput}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showClear),expression:"showClear"}],staticClass:"clear-btn",domProps:{"innerHTML":_vm._s(_vm.svg.broom)},on:{"click":_vm.clearFilter}})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-icon"},[_c('i',{staticClass:"fa fa-search"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.templatesLoaded)?_c('b-row',[(_vm.noTemplates)?_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',[_c('div',{staticClass:"d-flex justify-content-center"},[_vm._v(_vm._s(_vm.$t('TEMPLATE.NOTHING')))])])],1):_c('b-col',{attrs:{"lg":"12"}},[_c('div',{staticClass:"pull-right views"},[_c('span',[_vm._v(_vm._s(_vm.$t('TEMPLATE_VIEW.VIEW')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-link",attrs:{"type":"button","disabled":!_vm.gridView}},[_c('i',{staticClass:"fa fa-th-list fa-lg mt-3",on:{"click":function($event){_vm.toggleViews('table')}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-link",attrs:{"type":"button","disabled":_vm.gridView}},[_c('i',{staticClass:"fa fa-th-large fa-lg mt-3",on:{"click":function($event){_vm.toggleViews('grid')}}})])])]),_vm._v(" "),_vm._l((_vm.templateList),function(template){return (_vm.gridView)?_c('b-col',{key:template.id,staticClass:"template-container",attrs:{"lg":"2"}},[_c('zoom-center-transition',[_c('b-card',{attrs:{"show-footer":""}},[_c('img',{staticClass:"card-img",attrs:{"src":_vm._f("withBaseUrl")((template.webp_thumbnail_url || template.thumbnail_url))}}),_vm._v(" "),_c('div',{staticClass:"footer-text",attrs:{"slot":"footer"},slot:"footer"},[_vm._v("\n            "+_vm._s(_vm._f("truncate")(template.title.toUpperCase(),12, '...'))),_c('br'),_vm._v(" "),_c('span',{staticClass:"total-pages"},[_vm._v(_vm._s(template.total_pages + _vm.$t('TEMPLATE_VIEW.PAGES')))])]),_vm._v(" "),_c('div',{staticClass:"card-overlay"},[_c('router-link',{attrs:{"to":{name: 'Train', params: {id: template.first_template_id}}}},[_c('b-button',{attrs:{"size":"sm","variant":"outline-light"}},[_vm._v("MAP TEMPLATE")])],1),_vm._v(" "),(!template.is_public)?_c('div',{staticClass:"btn btn-public"},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-user",attrs:{"title":_vm.$t('TEMPLATE.ENABLE_FORM')},on:{"click":function($event){_vm.openSubmitFormStatusModal(template , true)}}})]):_c('div',{staticClass:"btn btn-public"},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-user-times",attrs:{"title":_vm.$t('TEMPLATE.DISABLE_FORM')},on:{"click":function($event){_vm.disableForm(template.id)}}})]),_vm._v(" "),(_vm.isAdminRole)?_c('div',{staticClass:"btn btn-link"},[_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){_vm.confirmModal(template)}}})]):_vm._e()],1)])],1)],1):_vm._e()}),_vm._v(" "),(!_vm.gridView && !_vm.noTemplates)?_c('b-col',{attrs:{"lg":"12"}},[_c('SearchBar',{attrs:{"title":_vm.$t('ROUTE_NAME.Template Listing')},on:{"filterInput":_vm.setFilter}}),_vm._v(" "),_c('b-table',{attrs:{"striped":"","hover":"","responsive":"sm","items":_vm.templateList,"fields":_vm.tableFields,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event}},scopedSlots:_vm._u([{key:"HEAD_id",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_title",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_total_pages",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_brand",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_updated_at",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_actions",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"actions",fn:function(data){return [_c('div',{staticClass:"btn-group"},[_c('router-link',{attrs:{"to":{ name: 'Train', params: {id: data.item.first_template_id }}}},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"first-button",attrs:{"variant":"primary"}},[_vm._v(" "+_vm._s(_vm.$t('TEMPLATE.TRAIN'))+" ")])],1),_vm._v(" "),(!data.item.is_public)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn-public",attrs:{"title":_vm.$t('TEMPLATE.ENABLE_FORM')},on:{"click":function($event){_vm.openSubmitFormStatusModal(data.item , true)}}},[_c('i',{staticClass:"fa fa-user"})]):_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn-public",attrs:{"title":_vm.$t('TEMPLATE.DISABLE_FORM')},on:{"click":function($event){_vm.disableForm(data.item.id)}}},[_c('i',{staticClass:"fa fa-user-times"})]),_vm._v(" "),(_vm.isAdminRole)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"variant":"primary","title":_vm.$t('COMMON.DELETE')},on:{"click":function($event){_vm.confirmModal(data.item)}}},[_c('i',{staticClass:"fa fa-trash"})]):_vm._e(),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"last-button",attrs:{"title":"Export to Rems"},on:{"click":function($event){_vm.templateApi(data.item.id)}}},[_c('i',{ref:'export-rems-' + data.item.id,staticClass:"icon-cloud-upload"}),_vm._v(" "),_c('i',{ref:'spinner-rems-' + data.item.id,staticClass:"fa fa-spin fa-spinner hide"})])],1)]}}])})],1):_vm._e()],2):_c('b-row',_vm._l((_vm.templateLoadingContents),function(loadingContent){return _c('b-col',{key:loadingContent,staticClass:"c-placeholder",attrs:{"lg":"2"}},[_c('b-card',[_c('content-placeholders',[_c('content-placeholders-img',{staticStyle:{"height":"180px"}}),_vm._v(" "),_c('content-placeholders-text',{attrs:{"lines":2}})],1)],1)],1)})),_vm._v(" "),_c('b-modal',{ref:"tempModal",attrs:{"hide-header-close":"","centered":"","title":_vm.$t('COMMON.DELETE_CONFIRM'),"ok-title":_vm.$t('COMMON.DELETE'),"cancel-title":_vm.$t('COMMON.CANCEL'),"ok-variant":"secondary","cancel-variant":"light"},on:{"ok":_vm.deleteTemplate}},[_vm._v("\n    "+_vm._s(_vm.$t('TEMPLATE.DELETE_CONTENT', {'TEMPLATE_TITLE': _vm.seletedTemplateTitle}))+"\n  ")]),_vm._v(" "),_c('b-modal',{ref:"submitFormStatus",attrs:{"centered":"","hide-header-close":"","title":"Form Submission Configuration"}},[_c('div',[_c('b-row',[_c('b-col',[_c('p',{staticClass:"required"},[_vm._v("Note: Add any one of field to make it as a document title ")])])],1)],1),_vm._v(" "),_c('div',[_c('b-form-group',[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v("Page No")]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")])]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"options":_vm.pages},model:{value:(_vm.selectedPageNo),callback:function ($$v) {_vm.selectedPageNo=$$v},expression:"selectedPageNo"}})],1)],1)],1),_vm._v(" "),(_vm.selectedPageNo)?_c('b-form-group',[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v("Field")]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")])]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"options":_vm.fields},model:{value:(_vm.selectedField),callback:function ($$v) {_vm.selectedField=$$v},expression:"selectedField"}})],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"id":"addNewField","size":"sm","variant":"secondary"},on:{"click":function($event){_vm.enableForm()}}},[_vm._v(_vm._s(_vm.$t('COMMON.SAVE'))+" ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":function($event){_vm.$refs.submitFormStatus.hide()}}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CLOSE'))+" ")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92d59196_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_New_vue__ = __webpack_require__(1043);
function injectStyle (ssrContext) {
  __webpack_require__(1041)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-92d59196"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92d59196_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_New_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1041 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1042 */,
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"md":"6","offset-md":"3"}},[(_vm.preferredMethod === 'upload')?_c('b-card',{staticClass:"py-4 px-5",attrs:{"footer-class":"card-footer-center new-footer"}},[(_vm.isSuperAdmin)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"preferred-method",attrs:{"size":"md","variant":"secondary","title":_vm.$t('TEMPLATE.CLONE')},on:{"click":function($event){_vm.updatePreferredMethod('clone')}}},[_c('i',{staticClass:"fa fa-clone"})]):_vm._e(),_vm._v(" "),_c('b-form-group',{staticClass:"required",attrs:{"label":_vm.$t('COMMON.TITLE'),"label-for":"normalTitle"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.title),expression:"template.title"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.template.title.$error, 'is-valid': !_vm.$v.template.title.$invalid},attrs:{"id":"normalTitle","type":"text","placeholder":_vm.$t('TEMPLATE.ENTER_TITLE')},domProps:{"value":(_vm.template.title)},on:{"blur":function($event){_vm.$v.template.title.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template, "title", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.template.title.required)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('TEMPLATE.REQ_TITLE')))]):_vm._e(),_vm._v(" "),(!_vm.$v.template.title.valid)?_c('b-form-invalid-feedback',[_vm._v("Template Name can't allow symbols")]):_vm._e(),_vm._v(" "),(!_vm.$v.template.title.minLength || !_vm.$v.template.title.maxLength)?_c('b-form-invalid-feedback',[_vm._v("Template Name length should be more than 3 and less than 30 characters")]):_vm._e()],1),_vm._v(" "),_c('b-form-group',{staticClass:"required",attrs:{"label":"Brand","label-for":"basicText"}},[_c('b-form-select',{class:{'is-invalid': _vm.$v.template.brand.$error, 'is-valid': !_vm.$v.template.brand.$invalid},attrs:{"plain":true,"options":_vm.brandNames,"placeholder":"Select a Brand"},on:{"blur":function($event){_vm.$v.template.brand.$touch()}},model:{value:(_vm.template.brand),callback:function ($$v) {_vm.$set(_vm.template, "brand", $$v)},expression:"template.brand"}}),_vm._v(" "),(!_vm.$v.template.brand.required)?_c('b-form-invalid-feedback',[_vm._v("Brand is required")]):_vm._e()],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('COMMON.DESCRIPTION'),"label-for":"basicText"}},[_c('b-form-input',{attrs:{"id":"basicText","type":"text","placeholder":_vm.$t('TEMPLATE.ENTER_DESCR')},model:{value:(_vm.template.description),callback:function ($$v) {_vm.$set(_vm.template, "description", $$v)},expression:"template.description"}})],1),_vm._v(" "),_c('label',{attrs:{"for":"dropzone"}},[_vm._v(_vm._s(_vm.$t('FORMS.UPLOAD_MULTI_FORMS')))]),_vm._v(" "),(_vm.canShowDropZone)?_c('vueDropzone',{ref:"formProcessDropZone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-file-added":_vm.onAddingFile,"vdropzone-sending":_vm.sendingEvent,"vdropzone-max-files-exceeded":_vm.onExceedingMaxFiles,"vdropzone-success":_vm.onSuccess,"vdropzone-removed-file":_vm.onRemovingFile,"vdropzone-error":_vm.onError}}):_vm._e(),_vm._v(" "),(_vm.isDropzoneBlank)?_c('p',{staticClass:"text-danger mt-1"},[_vm._v(_vm._s(_vm.$t('TEMPLATE.REQ_FILE')))]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{staticClass:"padding-x-5",attrs:{"type":"submit","size":"sm","variant":"secondary","disabled":_vm.disableSave},on:{"click":_vm.formUpload}},[(_vm.template.uploading)?_c('i',{staticClass:"fa fa-spinner fa-spin mr-2",staticStyle:{"font-size":"18px"}}):_vm._e(),_c('span',{ref:"uploadText"},[_vm._v(_vm._s(_vm.$t('COMMON.SAVE')))])])],1)],1):_vm._e(),_vm._v(" "),(_vm.preferredMethod === 'clone')?_c('b-card',{staticClass:"py-4 px-5",attrs:{"footer-class":"card-footer-center new-footer"}},[(_vm.isSuperAdmin)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"preferred-method",attrs:{"size":"md","variant":"secondary","title":_vm.$t('COMMON.UPLOAD')},on:{"click":function($event){_vm.updatePreferredMethod('upload')}}},[_c('i',{staticClass:"fa fa-upload"})]):_vm._e(),_vm._v(" "),_c('b-form-group',{staticClass:"required",attrs:{"label":_vm.$t('TEMPLATE.SELECT_FROM_ACCOUNT'),"label-for":"basicText"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.clone.accounts},on:{"input":function($event){_vm.handleAccountChange()}},model:{value:(_vm.clone.selectedFromAccount),callback:function ($$v) {_vm.$set(_vm.clone, "selectedFromAccount", $$v)},expression:"clone.selectedFromAccount"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"required",attrs:{"label":_vm.$t('TEMPLATE.TEMPLATE'),"label-for":"basicText"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.clone.templates},model:{value:(_vm.clone.selectedTemplate),callback:function ($$v) {_vm.$set(_vm.clone, "selectedTemplate", $$v)},expression:"clone.selectedTemplate"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"required",attrs:{"label":_vm.$t('TEMPLATE.SELECT_TO_ACCOUNT'),"label-for":"basicText"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.clone.accounts},model:{value:(_vm.clone.selectedToAccount),callback:function ($$v) {_vm.$set(_vm.clone, "selectedToAccount", $$v)},expression:"clone.selectedToAccount"}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{staticClass:"padding-x-5",attrs:{"type":"submit","size":"sm","variant":"secondary","disabled":_vm.disableClone},on:{"click":_vm.cloneNewTemplate}},[_vm._v(_vm._s(_vm.$t('COMMON.CLONE')))])],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Train_vue__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Train_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Train_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Train_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Train_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7335c745_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Train_vue__ = __webpack_require__(1086);
function injectStyle (ssrContext) {
  __webpack_require__(1045)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7335c745"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Train_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7335c745_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Train_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1045 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      trainTemplateData: '',
      npiGroups: '',
      revisionVersionSelected: null,
      id: this.$route.params.id,
      update_revision_id_status: '',
      esm_status: '',
      sv_status: '',
      cv_status: '',
      status_array: [],
      updatedNoOfMappings: null
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['idToken']), {
    trainTemplate: function trainTemplate() {
      return this.trainTemplateData;
    },
    isLatestVersion: function isLatestVersion() {
      return this.revisionVersionSelected === this.trainTemplateData.revision_ids[0];
    }
  }),
  watch: {
    trainTemplateData: {
      handler: function handler() {
        this.init();
      },
      deep: true
    },
    '$route': function $route() {
      this.id = this.$route.params.id;
      this.fetchTemplateWithOutGaurd();
    }
  },
  mounted: function mounted() {
    // Toggle sidebar for this page
    // TODO: Move to a common place. Remove duplicates
    var classList = document.body.classList;
    if (!classList.contains('sidebar-minimized')) {
      classList.toggle('sidebar-minimized');
      classList.toggle('brand-minimized');
    }
    this.fetchTemplateWithOutGaurd();
  },

  methods: {
    // TODO: Add route guard and refactor the path and other reset options.
    fetchTemplateWithOutGaurd: function fetchTemplateWithOutGaurd(version) {
      var _this = this;

      this.editorDataLoaded = false;
      this.mappingDataLoaded = false;
      var editorClass = this.$refs.canvasEditor.classList;
      var url = version ? 'templates/' + this.id + '?version=' + version : 'templates/' + this.id;
      if (!editorClass.contains('hidden-cn')) {
        editorClass.toggle('hidden-cn');
      }
      _vue2.default.axios.get(url, { headers: { Authorization: 'Bearer ' + this.idToken } }).then(function (res) {
        _this.status_array = [];
        _this.trainTemplateData = res.data.template;
        _this.updatedNoOfMappings = res.data.template.no_of_template_mappings;
        _this.update_revision_id_status = res.data.template.update_revision_id_status;
        _this.esm_status = res.data.template.esm_status;
        _this.sv_status = res.data.template.sv_status;
        _this.cv_status = res.data.template.cv_status;
        _this.npiGroups = res.data.template.npi_group;
        _this.allPageIdMap = res.data.template.all_template_ids;
        _this.revisionVersionSelected = res.data.template.current_revision_id;
        _this.draw = _this.revisionVersionSelected === _this.trainTemplateData.revision_ids[0] || !_this.trainTemplateData.revision_ids.length;
        // TODO: Refactor this reset in to seperate mixin.
        _this.pathCount = 1;
        _this.setPagination('templates');
        _this.resetEditHistory();
        _this.mappingDataLoaded = true;
        if (_this.esm_status) {
          _this.status_array.push(_this.$t('TEMPLATE.ESM_CLONING'));
        }
        if (_this.sv_status) {
          _this.status_array.push(_this.$t('TEMPLATE.SV_CLONING'));
        }
        if (_this.cv_status) {
          _this.status_array.push(_this.$t('TEMPLATE.CV_CLONING'));
        }
      }).catch(function (error) {
        if (error.status === 401) {
          _vue2.default.toasted.show('Session expired, please login to continue', { icon: 'chain-broken', type: 'error' });
          console.log(_this.$t('COMMON.MSG_EXPIRED'));
        } else {
          _vue2.default.toasted.show('Something went wrong. Please retry', { icon: 'chain-broken', type: 'error' });
        }
      });
    }
  }
};

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _konva = __webpack_require__(69);

var _konva2 = _interopRequireDefault(_konva);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      stage: {},
      layer: {},
      tempLayer: null,
      baseRect: {},
      imageObj: null,
      scaleScore: 1,
      containerHeight: 0,
      editorDataLoaded: false
    };
  },

  watch: {
    editorDataLoaded: {
      handler: function handler() {
        var _this = this;

        this.$nextTick(function () {
          if (_this.editorDataLoaded && _this.$refs.drawIcon) {
            _this.$refs.drawIcon.focus();
          }
        });
      }
    }
  },
  methods: {
    init: function init() {
      var vm = this;
      var imageObj = new window.Image();
      var imageUrl = this.trainTemplate.webp_image_url || this.trainTemplate.image_url;
      imageObj.src = "/api".replace('/api', '') + imageUrl;
      imageObj.onload = function () {
        var stageWidth = imageObj.width;
        var stageHeight = imageObj.height;

        vm.imageObj = imageObj;
        vm.stage = new _konva2.default.Stage({
          container: 'container',
          width: stageWidth,
          height: stageHeight
        });
        vm.layer = new _konva2.default.Layer({});

        var baseImage = new _konva2.default.Image({
          image: imageObj,
          width: stageWidth,
          height: stageHeight
        });

        vm.baseRect = new _konva2.default.Rect({
          name: 'baseRect',
          width: stageWidth,
          height: stageHeight,
          stroke: 'black',
          strokeWidth: 1
        });

        vm.layer.add(baseImage);
        vm.layer.add(vm.baseRect);
        vm.stage.add(vm.layer);

        vm.populateMappings(vm.trainTemplate.template_mappings);
        vm.initDrawTool();
        var editorClass = vm.$refs.canvasEditor.classList;
        if (editorClass.contains('hidden-cn')) {
          editorClass.toggle('hidden-cn');
        }
        vm.scaleCanvas();
        vm.bindContextMenuOpen();
        vm.bindContextMenuClose();
        vm.stage.draw();

        vm.containerHeight = imageObj.height;
        vm.editorDataLoaded = true;
      };
    },
    scaleCanvas: function scaleCanvas() {
      var container = document.getElementById('container');
      this.scaleScore = container.offsetWidth / this.stage.width();
      this.stage.width(this.stage.width() * this.scaleScore);
      this.stage.height(this.stage.height() * this.scaleScore);
      this.stage.scale({ x: this.scaleScore, y: this.scaleScore });
      // listening on templateMapping.vue
      this.$root.$emit('setHeightMappings', this.stage.content.offsetHeight + 25);
    }
  }
};

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _konva = __webpack_require__(69);

var _konva2 = _interopRequireDefault(_konva);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      draw: true,
      mouseDown: false,
      drawing: {
        startPos: { x: '', y: '' },
        currentPos: { x: '', y: '' }
      },
      drawAttempt: false,
      showWarning: false,
      showNewMapping: false,
      tempLayer: null
    };
  },

  methods: {
    startDraw: function startDraw(posIn) {
      this.drawing.startPos.x = posIn.x / this.scaleScore;
      this.drawing.startPos.y = posIn.y / this.scaleScore;
      this.drawing.currentPos.x = posIn.x / this.scaleScore;
      this.drawing.currentPos.y = posIn.y / this.scaleScore;
    },
    updateDraw: function updateDraw(posIn, selectionRect) {
      this.drawing.currentPos.x = posIn.x / this.scaleScore;
      this.drawing.currentPos.y = posIn.y / this.scaleScore;
      var posRect = this.selection();
      selectionRect.x(posRect.x1);
      selectionRect.y(posRect.y1);
      selectionRect.width(posRect.x2 - posRect.x1);
      selectionRect.height(posRect.y2 - posRect.y1);
      selectionRect.visible(true);
      this.stage.draw();
      this.draw = true;
    },
    selection: function selection() {
      var startPosx = this.drawing.startPos.x;
      var startPosy = this.drawing.startPos.y;
      var currentPosx = this.drawing.currentPos.x;
      var currentPosy = this.drawing.currentPos.y;
      var distance = void 0;

      if (startPosx > currentPosx) {
        distance = Math.abs(startPosx - currentPosx);
        startPosx = currentPosx;
        currentPosx = startPosx + distance;
      }
      if (startPosy > currentPosy) {
        distance = Math.abs(startPosy - currentPosy);
        startPosy = currentPosy;
        currentPosy = startPosy + distance;
      }
      return {
        x1: startPosx,
        y1: startPosy,
        x2: currentPosx,
        y2: currentPosy
      };
    },
    resetSelectionRect: function resetSelectionRect(selectionRect) {
      selectionRect.setAttrs({
        x: 0,
        y: 0,
        width: 0,
        height: 0
      });
    },
    initDrawTool: function initDrawTool() {
      var vm = this;
      vm.tempLayer = new _konva2.default.Layer({});

      var selectionRect = new _konva2.default.Rect({
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        stroke: vm.theme[vm.selectedTheme].strokeColor,
        dash: [6, 6]
      });
      selectionRect.listening(false);

      vm.tempLayer.add(selectionRect);
      vm.stage.add(vm.tempLayer);

      vm.baseRect.on('mousedown', function (e) {
        if (vm.draw) {
          vm.mouseDown = true;
          vm.clearSelection();
        }
        vm.drawAttempt = true;
        vm.startDraw(vm.stage.getPointerPosition());
      });

      vm.baseRect.on('mousemove', function (e) {
        if (vm.mouseDown === true) {
          vm.updateDraw(vm.stage.getPointerPosition(), selectionRect);
        } else if (vm.drawAttempt) {
          vm.showWarning = true;
        }
      });

      vm.baseRect.on('mouseup', function (e) {
        if (vm.mouseDown) {
          vm.mouseDown = false;
          selectionRect.visible(false);

          var temp = selectionRect.clone({
            id: 'new',
            name: 'crop_rect',
            edit_type: 'creating',
            template_id: vm.id,
            listening: true,
            draggable: true,
            dash: false
          });

          temp.visible(true);

          vm.resetSelectionRect(selectionRect);
          if (vm.draw === true && temp.attrs.width > 0) {
            var groupNodes = vm.groupsInGroup(temp);
            var shapeNodes = vm.shapesInGroup(temp);
            var groupChildren = groupNodes.concat(shapeNodes);
            if (groupChildren.length > 0) {
              vm.createNewGroup(temp);
              vm.groupChildren = groupChildren;
              vm.showNewGrouping = true;
            } else {
              vm.bindListeners(temp);
              vm.tempLayer.add(temp);
              vm.tempLayer.draw();
              vm.showNewMapping = true;
            }
          }
          vm.mouseDown = false;
        } else if (vm.showWarning) {
          _vue2.default.toasted.show('Please enable draw before creating shapes...', { icon: 'chain-broken', type: 'info' });
          this.showWarning = false;
          this.drawAttempt = false;
        }
      });
    }
  }
};

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _konva = __webpack_require__(69);

var _konva2 = _interopRequireDefault(_konva);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      canDelete: false,
      select: false,
      focusedElement: null,
      deletableChildren: [],
      selectedDeletableChildren: [],
      deleteAll: false
    };
  },

  methods: {
    enableSelection: function enableSelection() {
      this.viewMenu = false;
      this.select = true;
      this.draw = false;
      this.focusedElement = null;
      this.clearSelection();
    },
    enableDraw: function enableDraw() {
      if (this.draw) {
        return;
      }
      this.select = false;
      this.canDelete = false;
      this.draw = true;
      this.focusedElement = null;
      this.clearSelection();
    },
    deleteMapping: function deleteMapping() {
      var name = this.highlightShape && this.highlightShape.name();
      var highlightShape = name === 'group_holder' ? this.highlightShape.parent : this.highlightShape;

      if (name === 'group' || name === 'group_holder') {
        this.deletableChildren = highlightShape.children.filter(function (child) {
          return child.name() !== 'group_holder';
        });
        this.$refs.deleteGroupModal.show();
      } else {
        this.removeShape();
      }
    },
    selectAllDeletableChildren: function selectAllDeletableChildren() {
      if (this.deleteAll) {
        this.selectedDeletableChildren = this.deletableChildren.map(function (child) {
          return child.attrs.uniq_id;
        });
      } else {
        this.selectedDeletableChildren = [];
      }
    },
    deleteGroup: function deleteGroup() {
      var _this = this;

      this.drawLayer.find('Transformer').destroy();
      var name = this.highlightShape && this.highlightShape.name();
      var highlightShape = name === 'group_holder' ? this.highlightShape.parent : this.highlightShape;
      var groupChildren = highlightShape.children.slice();
      groupChildren.forEach(function (child) {
        if (child.name() !== 'group_holder') {
          var uniqId = child.attrs.uniq_id;
          if (_this.selectedDeletableChildren.indexOf(uniqId) === -1) {
            var updatedChild = _this.updateChildAttrs(child, 0, 0);
            _this.drawLayer.add(updatedChild);
          }
        }
      });
      this.highlightShape.remove();
      this.canDelete = false;
      this.clearSelection();
      this.drawLayer.draw();
      this.updateMappingData();
      this.pushToHistory();
    },
    updateChildAttrs: function updateChildAttrs(node, parentX, parentY) {
      var _this2 = this;

      var newShape = void 0;
      var updatedAttrs = node.attrs;
      if (node.name() !== 'group_holder') {
        var updatedPath = node.attrs.path.split('.');
        updatedPath.splice(1, 1);
        updatedAttrs.path = updatedPath.join('.');
        updatedAttrs.x = node.attrs.x_pos - parentX;
        updatedAttrs.y = node.attrs.y_pos - parentY;
      }
      if (node.nodeType === 'Group') {
        newShape = new _konva2.default.Group({});
        newShape.setAttrs(Object.assign({}, updatedAttrs));
        var updatedChildren = node.children.map(function (child) {
          return _this2.updateChildAttrs(child, newShape.attrs.x_pos, newShape.attrs.y_pos);
        });
        updatedChildren.forEach(function (child) {
          newShape.add(child);
        });
      } else {
        newShape = new _konva2.default.Rect({});
        newShape.setAttrs(Object.assign({}, updatedAttrs));
      }
      return newShape;
    },
    cancelDeleteGroup: function cancelDeleteGroup() {
      this.deletableChildren = [];
      this.selectedDeletableChildren = [];
    },
    removeShape: function removeShape() {
      this.drawLayer.find('Transformer').destroy();

      if (this.highlightShape && this.highlightShape.name() === 'group_holder') {
        this.highlightShape.parent.remove();
      } else {
        this.highlightShape.remove();
      }
      this.canDelete = false;
      this.clearSelection();
      this.drawLayer.draw();

      this.updateMappingData();
      this.pushToHistory();
    },
    clearSelection: function clearSelection() {
      var vm = this;
      var selected = this.stage.find('Rect').filter(function (shape) {
        return shape.attrs.selected === true;
      });
      selected.forEach(function (shape) {
        shape.setAttrs({
          selected: false,
          stroke: vm.theme[vm.selectedTheme].strokeColor,
          shadowColor: false,
          shadowBlur: false,
          dash: false
        });
      });
      this.stage.draw();
    },


    highlightSelection: function highlightSelection(shape) {
      if (shape.nodeType === 'Group') {
        shape = shape.findOne('.group_holder');
      }
      shape.setAttrs({
        selected: true,
        shadowColor: this.theme[this.selectedTheme].shadowColor,
        shadowBlur: this.theme[this.selectedTheme].shadowBlur,
        dash: [5, 5]
      });
      this.drawLayer.draw();
    },

    repositionGroup: function repositionGroup(group, position) {
      group.setAttrs({
        x: position.x,
        y: position.y,
        x_pos: position.x,
        y_pos: position.y
      });

      var shapes = group.find('.crop_rect');

      shapes.forEach(function (shape) {
        shape.setAttrs({
          x_pos: group.attrs.x + shape.attrs.x,
          y_pos: group.attrs.y + shape.attrs.y
        });
      });
    },

    updateGroupShapes: function updateGroupShapes(group) {
      var shapes = group.find('.crop_rect');

      shapes.forEach(function (shape) {
        shape.setAttrs({
          x_pos: group.attrs.x + shape.attrs.x,
          y_pos: group.attrs.y + shape.attrs.y
        });
      });
    },

    createDupGroup: function createDupGroup(group, position) {
      var _this3 = this;

      var parent = this.drawLayer;

      group.setAttrs({
        x: position.x,
        y: position.y,
        x_pos: position.x,
        y_pos: position.y,
        path: parent.attrs.path + '.' + this.pathCount
      });

      this.pathCount++;

      var shapes = group.find('.crop_rect');

      shapes.forEach(function (shape) {
        shape.setAttrs({
          x_pos: group.attrs.x + shape.attrs.x,
          y_pos: group.attrs.y + shape.attrs.y,
          path: group.attrs.path + '.' + _this3.pathCount
        });

        _this3.pathCount++;
      });

      this.highlightShape = group.findOne('.group_holder');
    }
  }
};

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _konva = __webpack_require__(69);

var _konva2 = _interopRequireDefault(_konva);

var _vuex = __webpack_require__(5);

var _lodash = __webpack_require__(45);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      pathCount: 1,
      drawLayer: null,
      mappingDataLoaded: false,
      transformShape: null
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['idToken']), {
    templateMaps: function templateMaps() {
      return this.trainTemplateData.template_mappings;
    }
  }),
  methods: {
    populateMappings: function populateMappings(pageMapping) {
      this.drawLayer = this.buildPageLayer(pageMapping);
      if (pageMapping && pageMapping.children) {
        this.buildMappingTree(this.drawLayer, pageMapping.children);
      }
      this.stage.add(this.drawLayer);
      this.stage.draw();
      this.setInitStack();

      this.updateMappingData();
    },
    buildMappingTree: function buildMappingTree(parent, childMaps) {
      var _this = this;

      if (_lodash2.default.size(childMaps)) {
        childMaps.forEach(function (map) {
          if (map.map_type === 'group') {
            var newGroup = _this.buildGroup('logical', map);
            var holderShape = _this.groupHolderShape(newGroup.attrs);

            newGroup.add(holderShape);
            parent.add(newGroup);

            if (parent.nodeType === 'Layer') {
              newGroup.setAttrs({
                path: parent.attrs.path + '.' + _this.pathCount,
                x: newGroup.attrs.x_pos - parent.attrs.x,
                y: newGroup.attrs.y_pos - parent.attrs.y
              });
            } else {
              newGroup.setAttrs({
                path: parent.attrs.path + '.' + _this.pathCount,
                x: newGroup.attrs.x_pos - parent.attrs.x_pos,
                y: newGroup.attrs.y_pos - parent.attrs.y_pos
              });
            }

            _this.pathCount++;
            _this.bindListeners(newGroup);
            _this.buildMappingTree(newGroup, map.children);
          } else {
            var newShape = _this.buildShape(map);
            parent.add(newShape);

            if (parent.nodeType === 'Layer') {
              newShape.setAttrs({
                path: parent.attrs.path + '.' + _this.pathCount,
                x: newShape.attrs.x_pos - parent.attrs.x,
                y: newShape.attrs.y_pos - parent.attrs.y
              });
            } else {
              newShape.setAttrs({
                path: parent.attrs.path + '.' + _this.pathCount,
                x: newShape.attrs.x_pos - parent.attrs.x_pos,
                y: newShape.attrs.y_pos - parent.attrs.y_pos
              });
            }

            if (newShape.parent.nodeType === 'Group') {
              newShape.setAttr('draggable', false);
            } else {
              _this.bindListeners(newShape);
            }

            _this.pathCount++;
          }
        });
      }
      return parent;
    },
    buildGroup: function buildGroup(mapType, attrs) {
      switch (mapType) {
        case 'logical':
          return this.buildLogicalGroup(attrs);
      }
    },
    buildPageLayer: function buildPageLayer(attrs) {
      var pageLayer = new _konva2.default.Layer({
        id: 'page_1',
        name: 'page_group',
        path: this.pathCount,
        map_type: 'page',
        edit_type: 'created',
        template_id: this.id,
        x: 0,
        y: 0,
        key: this.trainTemplateData.title,
        uniq_id: Date.now().toString(),
        draggable: false
      });

      this.pathCount++;
      return pageLayer;
    },
    buildLogicalGroup: function buildLogicalGroup(attrs) {
      var newGroup = new _konva2.default.Group({
        id: attrs.id,
        name: 'group',
        map_type: 'group',
        x_pos: Number(attrs.x_pos),
        y_pos: Number(attrs.y_pos),
        width: Number(attrs.width),
        height: Number(attrs.height),
        key: attrs.key,
        order: attrs.order,
        dataType: attrs.data_type,
        edit_type: 'created',
        template_id: attrs.template_id,
        uniq_id: Date.now().toString(),
        draggable: true,
        required: attrs.required,
        show_field: attrs.show_field,
        redact_field: attrs.redact_field
      });
      return newGroup;
    },
    groupHolderShape: function groupHolderShape(attrs) {
      var holderShape = new _konva2.default.Rect({
        id: attrs.id,
        name: 'group_holder',
        map_type: 'group_holder',
        category: attrs.category,
        case: attrs.case_column,
        x: 0,
        y: 0,
        width: Number(attrs.width),
        height: Number(attrs.height),
        edit_type: false,
        template_id: attrs.template_id,
        uniq_id: Date.now().toString(),
        stroke: this.theme[this.selectedTheme].strokeColor,
        strokeWidth: 3,
        draggable: false,
        selected: false
      });
      return holderShape;
    },
    buildShape: function buildShape(shape) {
      var newShape = new _konva2.default.Rect({
        id: shape.id,
        name: 'crop_rect',
        map_type: 'shape',
        category: shape.category,
        order: shape.order,
        case: shape.case_column,
        x_pos: Number(shape.x_pos),
        y_pos: Number(shape.y_pos),
        width: Number(shape.width),
        height: Number(shape.height),
        edit_type: 'created',
        key: shape.key,
        dataType: shape.data_type,
        dateFormat: shape.date_format,
        date_category: shape.date_category,
        description: shape.description,
        required: shape.required,
        extract: shape.extract,
        extract_by_words: shape.extract_by_words,
        redact_field: shape.redact_field,
        show_field: shape.show_field,
        sensitive_data: shape.sensitive_data,
        key_alias: shape.key_alias,
        template_id: shape.template_id,
        uniq_id: Date.now().toString() + shape.key,
        stroke: this.theme[this.selectedTheme].strokeColor,
        strokeWidth: 3,
        draggable: true,
        selected: false
      });
      return newShape;
    },
    bindListeners: function bindListeners(shape) {
      var vm = this;
      shape.on('dragstart', function (evt) {
        vm.clearSelection();
        vm.canDelete = true;
        vm.highlightShape = this;
        vm.highlightSelection(this);
      });

      shape.on('dragend', function (evt) {
        shape.setAttrs({
          x_pos: shape.attrs.x,
          y_pos: shape.attrs.y
        });
        if (shape.name() === 'group') {
          vm.updateGroupShapes(shape);
        }
        vm.pushToHistory();
      });

      shape.on('click', function (el) {
        vm.clearSelection();
        vm.canDelete = true;

        if (this.attrs.map_type === 'shape') {
          vm.transformShape = this;
          vm.attachTransformer();
        }

        vm.highlightShape = this;
        vm.highlightSelection(this);
      });

      shape.on('transformend', function () {
        shape.setAttrs({
          x_pos: this.x(),
          y_pos: this.y(),
          act_width: this.width() * this.scaleX(),
          act_height: this.height() * this.scaleY()
        });
        vm.pushToHistory();
      });
    }
  }
};

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _konva = __webpack_require__(69);

var _konva2 = _interopRequireDefault(_konva);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  methods: {
    attachTransformer: function attachTransformer() {
      if (this.transformShape) {
        var shape = this.transformShape;
        var tr = new _konva2.default.Transformer({
          rotateEnabled: false,
          lineEnabled: false
        });

        this.drawLayer.add(tr);
        tr.attachTo(shape);
        this.drawLayer.draw();
      }
    },
    destroyTransformer: function destroyTransformer() {
      if (this.transformShape) {
        this.transformShape = null;
        this.drawLayer.find('Transformer').destroy();
      }
    }
  }
};

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      zoomCount: 0,
      zoomLimit: 5,
      processingZoom: false
    };
  },

  computed: {
    enableZoomIn: function enableZoomIn() {
      return this.zoomCount < this.zoomLimit && !this.processingZoom;
    },
    enableZoomOut: function enableZoomOut() {
      return this.zoomCount > 0 && !this.processingZoom;
    }
  },
  methods: {
    zoomIn: function zoomIn() {
      if (this.processingZoom) {
        return;
      }
      this.processingZoom = true;
      this.scaleScore = this.scaleScore + 0.1;
      this.stage.width(this.imageObj.width * this.scaleScore);
      this.stage.height(this.imageObj.height * this.scaleScore);
      this.stage.scale({ x: this.scaleScore, y: this.scaleScore });
      this.stage.batchDraw();
      this.zoomCount++;
      this.updateZoomFinish();
    },
    zoomOut: function zoomOut() {
      if (this.processingZoom) {
        return;
      }
      this.processingZoom = true;
      this.scaleScore = this.scaleScore - 0.1;
      this.stage.width(this.imageObj.width * this.scaleScore);
      this.stage.height(this.imageObj.height * this.scaleScore);
      this.stage.scale({ x: this.scaleScore, y: this.scaleScore });
      this.zoomCount--;
      this.stage.batchDraw();
      this.updateZoomFinish();
    },
    updateZoomFinish: function updateZoomFinish() {
      var _this = this;

      this.$nextTick(function () {
        _this.processingZoom = false;
      });
    }
  }
};

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      showThumbnail: false
    };
  },

  methods: {
    selectedAction: function selectedAction(actionType) {
      var variant = 'light';
      switch (actionType) {
        case 'select':
          if (this.select && this.draw === false) {
            variant = 'primary';
          }
          break;
        case 'draw':
          if (this.draw && this.select === false) {
            variant = 'primary';
          }
          break;
        case 'edit':
          if (this.focusedElement) {
            variant = 'light';
          }
          break;
        case 'delete':
          if (this.canDelete) {
            variant = 'danger';
          }
          break;
        case 'save':
          if (this.enableSave()) {
            variant = 'success';
          }
          break;
        default:
          variant = 'light';
      }
      return variant;
    },
    toggleThumbnail: function toggleThumbnail() {
      this.showThumbnail = !this.showThumbnail;
    },
    thumbnailSelected: function thumbnailSelected(id) {
      return Number(id) === Number(this.id);
    }
  }
};

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      viewMenu: false,
      highlightShape: null,
      pasteEnable: false,
      pasteShapeData: null,
      pasteType: null,
      pageX: null,
      pageY: null
    };
  },

  computed: {
    contextMenu: function contextMenu() {
      return {
        cut: { disabled: !this.overShape },
        copy: { disabled: !this.overShape },
        paste: { disabled: this.pasteDisabled, shape: this.listenPasteShape, type: this.listenPasteType, position: { x: null, y: null } },
        destroy: { disabled: !this.overShape }
      };
    },
    overShape: function overShape() {
      return this.highlightShape && (this.highlightShape.attrs.name === 'crop_rect' || this.highlightShape.attrs.name === 'group_holder');
    },
    pasteDisabled: function pasteDisabled() {
      return !this.pasteEnable;
    },
    listenPasteShape: function listenPasteShape() {
      return this.pasteShapeData;
    },
    listenPasteType: function listenPasteType() {
      return this.pasteType;
    }
  },
  methods: {
    bindContextMenuOpen: function bindContextMenuOpen() {
      var vm = this;
      this.stage.on('contentContextmenu', function (e) {
        if (vm.select && this.targetShape) {
          vm.clearSelection();

          if (this.targetShape.parent.name() === 'group') {
            vm.highlightShape = this.targetShape.parent.findOne('.group_holder');
            vm.highlightSelection(vm.highlightShape);
          } else if (this.targetShape.attrs.name === 'crop_rect') {
            vm.highlightShape = this.targetShape;
            vm.highlightSelection(vm.highlightShape);
          }

          vm.contextMenu.paste.position = vm.stage.getPointerPosition();
          vm.showMenu(e.evt);
        }
        e.evt.preventDefault();
      });
    },

    bindContextMenuClose: function bindContextMenuClose() {
      var vm = this;
      this.stage.on('click', function (e) {
        if (vm.select && e.target.attrs.name === 'baseRect') {
          vm.destroyTransformer();
          vm.clearSelection();
          vm.highlightShape = null;
          vm.viewMenu = false;
        }
      });
    },

    showMenu: function showMenu(e) {
      this.pageX = e.pageX;
      this.pageY = e.pageY;
      this.viewMenu = true;
    },

    cutShape: function cutShape() {
      if (this.contextMenu.cut.disabled) {
        return;
      }

      if (this.highlightShape.name() === 'group_holder') {
        this.pasteShapeData = this.highlightShape.parent;
        this.pasteShapeData.hide();
      } else {
        this.pasteShapeData = this.highlightShape;
        this.pasteShapeData.hide();
      }

      this.pasteType = 'cut';
      this.pasteEnable = true;
      this.viewMenu = false;
      this.drawLayer.draw();
    },

    copyShape: function copyShape() {
      if (this.contextMenu.copy.disabled) {
        return;
      }

      if (this.highlightShape.name() === 'group_holder') {
        this.pasteShapeData = this.highlightShape.parent.clone();
      } else {
        this.pasteShapeData = this.highlightShape.clone();
      }

      this.pasteType = 'copy';
      this.pasteEnable = true;
      this.viewMenu = false;
    },

    pasteShape: function pasteShape() {
      if (this.contextMenu.paste.disabled) {
        return;
      }
      var position = {
        x: this.contextMenu.paste.position.x ? this.contextMenu.paste.position.x / this.scaleScore : this.contextMenu.paste.shape.attrs.x + 30,
        y: this.contextMenu.paste.position.y ? this.contextMenu.paste.position.y / this.scaleScore : this.contextMenu.paste.shape.attrs.y + 30
      };
      if (this.contextMenu.paste.type === 'cut') {
        this.repositionShape(position);
        this.pasteEnable = false;
        this.pasteShapeData = null;
        this.highlightShape = null;
      } else {
        this.createShape(position);
      }
      this.viewMenu = false;
      this.pushToHistory();
    },

    createShape: function createShape(position) {
      var shape = this.contextMenu.paste.shape.clone();

      if (shape.name() === 'group') {
        this.createDupGroup(shape, position);
      } else {
        var parent = this.drawLayer;

        shape.setAttrs({
          id: 'new',
          x: position.x,
          y: position.y,
          path: parent.attrs.path + '.' + this.pathCount,
          edit_type: 'created',
          template_id: this.id
        });

        this.highlightShape = shape;
      }

      this.pathCount++;
      this.drawLayer.add(shape);
      this.drawLayer.draw();

      this.updateMappingData();
    },

    repositionShape: function repositionShape(position) {
      var shape = this.pasteShapeData;

      if (shape.name() === 'group') {
        this.repositionGroup(shape, position);
      } else {
        shape.setAttrs({
          x: position.x,
          y: position.y,
          x_pos: position.x,
          y_pos: position.y,
          stroke: this.theme[this.selectedTheme].strokeColor,
          shadowColor: false,
          shadowBlur: false,
          dash: false
        });
      }

      shape.show();
      this.drawLayer.draw();
    },

    destroyShape: function destroyShape() {
      if (this.contextMenu.destroy.disabled) {
        return;
      }
      this.removeShape();
      this.viewMenu = false;
      this.updateMappingData();
      this.pushToHistory();
    }
  }
};

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keyboardjs = __webpack_require__(1056);

var _keyboardjs2 = _interopRequireDefault(_keyboardjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      shiftPressed: false
    };
  },


  methods: {
    isMac: function isMac() {
      return window.navigator.match('Mac');
    }
  },

  mounted: function mounted() {
    var vm = this;
    _keyboardjs2.default.setContext('train-template');

    _keyboardjs2.default.bind('shift', function (e) {
      vm.shiftPressed = true;
    }, function (e) {
      vm.shiftPressed = false;
    });

    _keyboardjs2.default.bind('escape', function (e) {
      if (vm.$route.name !== 'train') {
        return;
      }
      if (!vm.showNewMapping) {
        e.preventDefault();
        vm.enableSelection();
      }
    });

    _keyboardjs2.default.bind('tab', function (e) {
      if (vm.$route.name !== 'train') {
        return;
      }
      if (!vm.showNewMapping) {
        // vm.selectNextShape(e)
        // e.preventDefault()
      }
    });

    _keyboardjs2.default.bind('command > s', null, function (e) {
      if (vm.$route.name !== 'train') {
        return;
      }
      e.preventDefault();
      vm.saveData();
    });

    _keyboardjs2.default.bind('command > +', null, function (e) {
      if (vm.$route.name !== 'train') {
        return;
      }
      e.preventDefault();
      vm.zoomIn();
    });

    _keyboardjs2.default.bind('command > -', null, function (e) {
      if (vm.$route.name !== 'train') {
        return;
      }
      e.preventDefault();
      vm.zoomOut();
    });

    _keyboardjs2.default.bind('command > d', null, function (e) {
      if (vm.$route.name !== 'train') {
        return;
      }
      e.preventDefault();
      vm.removeShape();
    });

    _keyboardjs2.default.bind('command > x', null, function (e) {
      if (vm.$route.name !== 'train') {
        return;
      }
      e.preventDefault();
      vm.cutShape();
    });

    _keyboardjs2.default.bind('command > c', null, function (e) {
      if (vm.$route.name !== 'train') {
        return;
      }
      e.preventDefault();
      vm.copyShape();
    });

    _keyboardjs2.default.bind('command > v', null, function (e) {
      if (vm.$route.name !== 'train') {
        return;
      }
      e.preventDefault();
      vm.pasteShape();
    });

    _keyboardjs2.default.bind('command > z', null, function (e) {
      if (vm.$route.name !== 'train') {
        return;
      }
      e.preventDefault();
      vm.undo();
    });

    _keyboardjs2.default.bind('command + shift > z', null, function (e) {
      if (vm.$route.name !== 'train') {
        return;
      }
      e.preventDefault();
      vm.redo();
    });
  }
};

/***/ }),
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _konva = __webpack_require__(69);

var _konva2 = _interopRequireDefault(_konva);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      editHistory: [],
      currentIndex: -1
    };
  },

  computed: {
    enableUndo: function enableUndo() {
      return this.currentIndex > 0;
    },
    enableRedo: function enableRedo() {
      return this.currentIndex < this.editHistory.length - 1;
    }
  },
  methods: {
    resetEditHistory: function resetEditHistory() {
      this.editHistory = [];
      this.setInitStack();
    },
    undo: function undo() {
      if (this.currentIndex > 0) {
        var vm = this;
        this.currentIndex--;
        var layerData = this.editHistory[this.currentIndex];
        var newLayer = _konva2.default.Node.create(layerData);
        this.drawLayer.destroy();
        newLayer.setAttr('id', 'shape');
        newLayer.children.each(function (shape) {
          vm.bindListeners(shape);
        });
        this.stage.add(newLayer);
        this.stage.draw();
        this.drawLayer = newLayer;
      }
    },
    redo: function redo() {
      if (this.currentIndex < this.editHistory.length - 1) {
        var vm = this;
        this.currentIndex++;
        var layerData = this.editHistory[this.currentIndex];
        var newLayer = _konva2.default.Node.create(layerData);
        this.drawLayer.destroy();
        newLayer.setAttr('id', 'shape');
        newLayer.children.each(function (shape) {
          vm.bindListeners(shape);
        });
        this.stage.add(newLayer);
        this.stage.draw();
        this.drawLayer = newLayer;
      }
    },
    pushToHistory: function pushToHistory() {
      if (this.currentIndex === this.editHistory.length - 1) {
        this.editHistory.push(this.drawLayer.toJSON());
      } else {
        this.editHistory.splice(this.currentIndex + 1);
        this.editHistory.push(this.drawLayer.toJSON());
      }
      this.currentIndex = this.editHistory.length - 1;
    },
    setInitStack: function setInitStack() {
      if (this.drawLayer) {
        this.editHistory.push(this.drawLayer.toJSON());
      }
      this.currentIndex = 0;
    }
  }
};

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      selectedTheme: 'blue',
      theme: {
        blue: {
          strokeColor: '#63c2de',
          shadowColor: '#63c2de',
          shadowStroke: 'white',
          shadowBlur: 5,
          disabledColor: 'lightgrey'
        },
        green: {
          strokeColor: '#4dbd74',
          shadowColor: '#4dbd74',
          shadowStroke: 'white',
          shadowBlur: 5,
          disabledColor: 'lightgrey'
        },
        red: {
          strokeColor: '#f86c6b',
          shadowColor: '#f86c6b',
          shadowStroke: 'white',
          shadowBlur: 5,
          disabledColor: 'lightgrey'
        }
      }
    };
  },


  methods: {
    isThemeSelected: function isThemeSelected(color) {
      return this.selectedTheme === color;
    },
    updateTheme: function updateTheme(color) {
      if (this.isThemeSelected(color)) {
        return;
      }
      this.selectedTheme = color;
      this.tempLayer.findOne('Rect').setAttr('stroke', this.theme[this.selectedTheme].strokeColor);
      this.tempLayer.draw();
      this.updateShapeColor(this.selectedTheme);
    },
    updateShapeColor: function updateShapeColor() {
      var vm = this;
      this.drawLayer.find('Rect').each(function (shape) {
        shape.setAttr('stroke', vm.theme[vm.selectedTheme].strokeColor);
        shape.draw();
      });
      this.drawLayer.draw();
    }
  }
};

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  methods: {
    selectNextShape: function selectNextShape(e) {
      var shapesLayer = this.stage.find('#shape')[0];
      var selectedShape = shapesLayer.children.filter(function (el) {
        return el.attrs.selected === true;
      });

      if (selectedShape.length > 0) {
        var index = shapesLayer.children.indexOf(selectedShape[0]);
        var newShape = shapesLayer.children[index + 1] || shapesLayer.children[0];

        this.clearSelection();
        this.canDelete = true;
        this.focusedElement = newShape.attrs.id;
        this.highlightShape = newShape;
        this.highlightSelection(newShape);
        window.scrollTo(0, newShape.getY());
      }
    }
  }
};

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_templateMappings_vue__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_templateMappings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_templateMappings_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_templateMappings_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_templateMappings_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61fb38d6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_templateMappings_vue__ = __webpack_require__(1064);
function injectStyle (ssrContext) {
  __webpack_require__(1063)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61fb38d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_templateMappings_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61fb38d6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_templateMappings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1063 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template-mapping"},[_c('main',{staticClass:"message"},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(this.$t('TEMPLATE.MAPPINGS')))])]),_vm._v(" "),_c('b-list-group',{style:({ maxHeight: this.containerHeight + 'px' })},[(_vm.blankTemplateMappings)?_c('div',[_c('b-card',[_vm._v("\n          No mappings added\n        ")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"map-tree",attrs:{"role":"tablist"}},[_c('v-tree',{ref:"tree",attrs:{"data":this.templateMappings,"tpl":_vm.customTemplate}})],1)])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newMapping_vue__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newMapping_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newMapping_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newMapping_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newMapping_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd112a66_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newMapping_vue__ = __webpack_require__(1067);
function injectStyle (ssrContext) {
  __webpack_require__(1066)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fd112a66"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newMapping_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd112a66_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newMapping_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1066 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-mapping"},[_c('b-modal',{ref:"mapModalRef",attrs:{"title":'Add Mapping',"hide-header-close":"","centered":""},on:{"hide":_vm.cancelNewMapping,"shown":_vm.focusOnInput}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.KEY')))]),_vm._v(" "),_c('b-col',[_c('b-form-input',{ref:"fieldKey",attrs:{"type":"text","placeholder":_vm.$t('TEMPLATE.KEY')},model:{value:(_vm.mapping.key),callback:function ($$v) {_vm.$set(_vm.mapping, "key", $$v)},expression:"mapping.key"}}),_vm._v(" "),(_vm.mapping.key && !_vm.mapping.isKeyUnique)?_c('div',{staticStyle:{"color":"red"}},[_vm._v("Key must be unique.")]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.DATA_TYPE')))]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.listTypes,"placeholder":"Mapping Type"},on:{"input":function($event){_vm.handleRequired()}},model:{value:(_vm.mapping.type),callback:function ($$v) {_vm.$set(_vm.mapping, "type", $$v)},expression:"mapping.type"}})],1)],1),_vm._v(" "),(_vm.mapping.type == 'date')?_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.DATE_CATEGORY')))]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.dateCategoryList,"placeholder":"Select Date Category"},model:{value:(_vm.mapping.date_category),callback:function ($$v) {_vm.$set(_vm.mapping, "date_category", $$v)},expression:"mapping.date_category"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.mapping.type == 'date')?_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.DATE_FORMAT')))]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.dateFormatList,"placeholder":"Select Date Format"},model:{value:(_vm.mapping.dateFormat),callback:function ($$v) {_vm.$set(_vm.mapping, "dateFormat", $$v)},expression:"mapping.dateFormat"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.MAPPING_CATEGORY')))]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.mappingCategories,"placeholder":"Mapping Category"},model:{value:(_vm.mapping.category),callback:function ($$v) {_vm.$set(_vm.mapping, "category", $$v)},expression:"mapping.category"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.ORDER_OF_OCCUR')))]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.orderOptions,"placeholder":"Mapping Order"},model:{value:(_vm.mapping.order),callback:function ($$v) {_vm.$set(_vm.mapping, "order", $$v)},expression:"mapping.order"}})],1)],1),_vm._v(" "),(_vm.canExtract)?_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.EXT')))]),_vm._v(" "),_c('b-col',[_c('b-form-radio-group',[_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapping.extract),expression:"mapping.extract"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"extractYes"},domProps:{"value":true,"checked":_vm._q(_vm.mapping.extract,true)},on:{"change":function($event){_vm.$set(_vm.mapping, "extract", true)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"extractYes"}},[_vm._v(_vm._s(_vm.$t('COMMON.YES')))])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapping.extract),expression:"mapping.extract"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"extractNo"},domProps:{"value":false,"checked":_vm._q(_vm.mapping.extract,false)},on:{"change":function($event){_vm.$set(_vm.mapping, "extract", false)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"extractNo"}},[_vm._v(_vm._s(_vm.$t('COMMON.NO')))])])])],1)],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.EXT_BY_WORDS')))]),_vm._v(" "),_c('b-col',[_c('b-form-radio-group',[_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapping.extract_by_words),expression:"mapping.extract_by_words"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"extractByWordsYes"},domProps:{"value":true,"checked":_vm._q(_vm.mapping.extract_by_words,true)},on:{"change":function($event){_vm.$set(_vm.mapping, "extract_by_words", true)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"extractByWordsYes"}},[_vm._v(_vm._s(_vm.$t('COMMON.YES')))])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapping.extract_by_words),expression:"mapping.extract_by_words"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"extractByWordsNo"},domProps:{"value":false,"checked":_vm._q(_vm.mapping.extract_by_words,false)},on:{"change":function($event){_vm.$set(_vm.mapping, "extract_by_words", false)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"extractByWordsNo"}},[_vm._v(_vm._s(_vm.$t('COMMON.NO')))])])])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.REDACT_FIELD')))]),_vm._v(" "),_c('b-col',[_c('b-form-radio-group',[_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapping.redact_field),expression:"mapping.redact_field"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"redactFieldYes"},domProps:{"value":true,"checked":_vm._q(_vm.mapping.redact_field,true)},on:{"change":function($event){_vm.$set(_vm.mapping, "redact_field", true)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"redactFieldYes"}},[_vm._v(_vm._s(_vm.$t('COMMON.YES')))])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapping.redact_field),expression:"mapping.redact_field"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"redactFieldNo"},domProps:{"value":false,"checked":_vm._q(_vm.mapping.redact_field,false)},on:{"change":function($event){_vm.$set(_vm.mapping, "redact_field", false)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"redactFieldNo"}},[_vm._v(_vm._s(_vm.$t('COMMON.NO')))])])])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.SHOW_FIELD')))]),_vm._v(" "),_c('b-col',[_c('b-form-radio-group',[_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapping.show_field),expression:"mapping.show_field"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"showFieldYes"},domProps:{"value":true,"checked":_vm._q(_vm.mapping.show_field,true)},on:{"change":function($event){_vm.$set(_vm.mapping, "show_field", true)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"showFieldYes"}},[_vm._v(_vm._s(_vm.$t('COMMON.YES')))])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapping.show_field),expression:"mapping.show_field"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"showFieldNo"},domProps:{"value":false,"checked":_vm._q(_vm.mapping.show_field,false)},on:{"change":function($event){_vm.$set(_vm.mapping, "show_field", false)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"showFieldNo"}},[_vm._v(_vm._s(_vm.$t('COMMON.NO')))])])])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.CASE')))]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.caseCategories,"placeholder":"Case"},model:{value:(_vm.mapping.case),callback:function ($$v) {_vm.$set(_vm.mapping, "case", $$v)},expression:"mapping.case"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.SENS_DATA')))]),_vm._v(" "),_c('b-col',[_c('b-form-radio-group',[_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapping.sensitive_data),expression:"mapping.sensitive_data"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"sensitiveDataYes"},domProps:{"value":true,"checked":_vm._q(_vm.mapping.sensitive_data,true)},on:{"change":function($event){_vm.$set(_vm.mapping, "sensitive_data", true)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"sensitiveDataYes"}},[_vm._v(_vm._s(_vm.$t('COMMON.YES')))])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapping.sensitive_data),expression:"mapping.sensitive_data"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"sensitiveDataNo"},domProps:{"value":false,"checked":_vm._q(_vm.mapping.sensitive_data,false)},on:{"change":function($event){_vm.$set(_vm.mapping, "sensitive_data", false)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"sensitiveDataNo"}},[_vm._v(_vm._s(_vm.$t('COMMON.NO')))])])])],1)],1),_vm._v(" "),(_vm.canShowRequired)?_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.REQ')))]),_vm._v(" "),_c('b-col',[_c('b-form-radio-group',[_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapping.required),expression:"mapping.required"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"requiredNewYes"},domProps:{"value":true,"checked":_vm._q(_vm.mapping.required,true)},on:{"change":function($event){_vm.$set(_vm.mapping, "required", true)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"requiredNewYes"}},[_vm._v(_vm._s(_vm.$t('COMMON.YES')))])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapping.required),expression:"mapping.required"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"requiredNewNo"},domProps:{"value":false,"checked":_vm._q(_vm.mapping.required,false)},on:{"change":function($event){_vm.$set(_vm.mapping, "required", false)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"requiredNewNo"}},[_vm._v(_vm._s(_vm.$t('COMMON.NO')))])])])],1)],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.ALIAS')))]),_vm._v(" "),_c('b-col',[_c('multiselect',{attrs:{"tag-placeholder":"Add this as Alias","placeholder":"Search or add a tag","options":_vm.aliasOptions,"multiple":true,"taggable":true},on:{"tag":_vm.addTag},model:{value:(_vm.selectedAliasData),callback:function ($$v) {_vm.selectedAliasData=$$v},expression:"selectedAliasData"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('COMMON.DESCRIPTION')))]),_vm._v(" "),_c('b-col',[_c('b-form-textarea',{attrs:{"placeholder":_vm.$t('COMMON.DESCRIPTION')},model:{value:(_vm.mapping.description),callback:function ($$v) {_vm.$set(_vm.mapping, "description", $$v)},expression:"mapping.description"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100 d-flex justify-content-end",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"secondary mr-1","disabled":!_vm.mapping.isKeyUnique || (_vm.mapping.type == 'date' && !_vm.mapping.dateFormat)},on:{"click":_vm.createNewMapping}},[_vm._v(_vm._s(_vm.$t('COMMON.ADD')))]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"light"},on:{"click":_vm.cancelMapping}},[_vm._v(_vm._s(_vm.$t('COMMON.CANCEL')))])],1)],1),_vm._v(" "),_c('b-modal',{ref:"agnetNewMappingModal",attrs:{"title":'New Mapping',"hide-header-close":"","centered":"","ok-only":"","ok-variant":"secondary"},on:{"ok":_vm.clearDrawing}},[_c('p',[_vm._v("You are not permitted to access this. Kindly contact administrator")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newGrouping_vue__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newGrouping_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newGrouping_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newGrouping_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newGrouping_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bdec28c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newGrouping_vue__ = __webpack_require__(1070);
function injectStyle (ssrContext) {
  __webpack_require__(1069)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bdec28c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newGrouping_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bdec28c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newGrouping_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1069 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-grouping"},[_c('b-modal',{ref:"mapGroupRef",staticClass:"modal-info",attrs:{"title":'Add Grouping',"centered":""},on:{"hide":_vm.cancelNewGrouping,"shown":_vm.focusOnInput}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v("Name"),_c('i',{staticClass:"required"},[_vm._v("*")])]),_vm._v(" "),_c('b-col',[_c('b-form-input',{ref:"groupName",attrs:{"type":"text","placeholder":"Group Name","required":""},model:{value:(_vm.group.name),callback:function ($$v) {_vm.$set(_vm.group, "name", $$v)},expression:"group.name"}}),_vm._v(" "),(_vm.group.name && !_vm.group.isNameUnique)?_c('div',{staticStyle:{"color":"red"}},[_vm._v("Name must be unique.")]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v("Type"),_c('i',{staticClass:"required"},[_vm._v("*")])]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.groupTypes,"placeholder":"Group Type"},on:{"input":function($event){_vm.handleRequired()}},model:{value:(_vm.group.type),callback:function ($$v) {_vm.$set(_vm.group, "type", $$v)},expression:"group.type"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.ORDER_OF_OCCUR')))]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.orderOptions,"placeholder":"Group Order"},model:{value:(_vm.group.order),callback:function ($$v) {_vm.$set(_vm.group, "order", $$v)},expression:"group.order"}})],1)],1),_vm._v(" "),(_vm.canShowRequired)?_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.REQ')))]),_vm._v(" "),_c('b-col',[_c('b-form-radio-group',[_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.group.required),expression:"group.required"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"requiredGrpNewYes"},domProps:{"value":true,"checked":_vm._q(_vm.group.required,true)},on:{"change":function($event){_vm.$set(_vm.group, "required", true)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"requiredGrpNewYes"}},[_vm._v(_vm._s(_vm.$t('COMMON.YES')))])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.group.required),expression:"group.required"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"requiredGrpNewNo"},domProps:{"value":false,"checked":_vm._q(_vm.group.required,false)},on:{"change":function($event){_vm.$set(_vm.group, "required", false)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"requiredGrpNewNo"}},[_vm._v(_vm._s(_vm.$t('COMMON.NO')))])])])],1)],1):_vm._e(),_vm._v(" "),(_vm.selectedChildren.length > 1)?_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"12"}},[_c('h6',{staticClass:"pull-left select-mappings"},[_vm._v("Select the mappings to include in the group:")])]),_vm._v(" "),_vm._l((_vm.groupChildren),function(child){return _c('b-col',{key:child.attrs.path,attrs:{"cols":"6"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedChildren),expression:"selectedChildren"}],staticClass:"pull-left mt-1 mr-2",attrs:{"type":"checkbox","id":child.attrs.uniq_id},domProps:{"value":child.attrs.uniq_id,"checked":Array.isArray(_vm.selectedChildren)?_vm._i(_vm.selectedChildren,child.attrs.uniq_id)>-1:(_vm.selectedChildren)},on:{"change":function($event){var $$a=_vm.selectedChildren,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=child.attrs.uniq_id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedChildren=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedChildren=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedChildren=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"pull-left",attrs:{"for":child.attrs.uniq_id}},[_vm._v("\n            "+_vm._s(child.attrs.key)+" "+_vm._s(child.attrs.map_type === 'shape' ? null : ("( " + (child.attrs.map_type) + " )"))+"\n          ")])])})],2):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"w-100 d-flex justify-content-end",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary mr-1","disabled":!_vm.validateGroupInfo},on:{"click":_vm.createNewGrouping}},[_vm._v("Add")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"light"},on:{"click":_vm.cancelGrouping}},[_vm._v("Cancel")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"agnetNewGroupingModal",attrs:{"title":'New-Grouping',"hide-header-close":"","centered":"","ok-only":"","ok-variant":"secondary"},on:{"ok":_vm.clearGrouping}},[_c('p',[_vm._v("You are not permitted to access this. Kindly contact administrator")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newNpiGrouping_vue__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newNpiGrouping_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newNpiGrouping_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newNpiGrouping_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newNpiGrouping_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aac9c418_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newNpiGrouping_vue__ = __webpack_require__(1073);
function injectStyle (ssrContext) {
  __webpack_require__(1072)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aac9c418"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newNpiGrouping_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aac9c418_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newNpiGrouping_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1072 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-npi-grouping"},[_c('b-modal',{ref:"mapGroupRef",staticClass:"modal-info",attrs:{"title":_vm.$t('COMMON.ADD_NPI_GROUPING'),"centered":""},on:{"shown":_vm.focusOnInput,"hide":_vm.cancelNewNpiGrouping}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('COMMON.NAME')))]),_vm._v(" "),_c('b-col',[_c('b-form-input',{ref:"groupName",attrs:{"type":"text","placeholder":_vm.$t('COMMON.GROUP_NAME')},model:{value:(_vm.key),callback:function ($$v) {_vm.key=$$v},expression:"key"}}),_vm._v(" "),(_vm.key && !_vm.isKeyUnique)?_c('div',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.$t('COMMON.MSG_KEY_UNIQUE')))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v("NPI")]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.groupTypes,"placeholder":"NPI","state":!_vm.$v.group.npi.$invalid},model:{value:(_vm.group.npi),callback:function ($$v) {_vm.$set(_vm.group, "npi", $$v)},expression:"group.npi"}}),_vm._v(" "),_c('b-form-invalid-feedback',{attrs:{"id":"input2LiveFeedback"}},[_vm._v(_vm._s(_vm.$t('COMMON.MSG_REQ_FIELD'))+"\n            ")])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('COMMON.PRESCRIBER_FIRST_NAME')))]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.groupTypes,"placeholder":"First Name"},model:{value:(_vm.group.firstName),callback:function ($$v) {_vm.$set(_vm.group, "firstName", $$v)},expression:"group.firstName"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('COMMON.PRESCRIBER_LAST_NAME')))]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.groupTypes,"placeholder":"Last Name"},model:{value:(_vm.group.lastName),callback:function ($$v) {_vm.$set(_vm.group, "lastName", $$v)},expression:"group.lastName"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('COMMON.PRESCRIBER_NAME')))]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.groupTypes,"placeholder":"Name"},model:{value:(_vm.group.name),callback:function ($$v) {_vm.$set(_vm.group, "name", $$v)},expression:"group.name"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('DATA_TYPE.CITY')))]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.groupTypes,"placeholder":"City"},model:{value:(_vm.group.city),callback:function ($$v) {_vm.$set(_vm.group, "city", $$v)},expression:"group.city"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('DATA_TYPE.STATE')))]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.groupTypes,"placeholder":"State"},model:{value:(_vm.group.state),callback:function ($$v) {_vm.$set(_vm.group, "state", $$v)},expression:"group.state"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('DATA_TYPE.ZIPCODE')))]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.groupTypes,"placeholder":"ZipCode"},model:{value:(_vm.group.zip),callback:function ($$v) {_vm.$set(_vm.group, "zip", $$v)},expression:"group.zip"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100 d-flex justify-content-end",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary mr-1","disabled":_vm.$v.$invalid || !_vm.isKeyUnique},on:{"click":_vm.createNewNpiGrouping}},[_vm._v(_vm._s(_vm.$t('COMMON.ADD')))]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"light"},on:{"click":_vm.cancelNpiGrouping}},[_vm._v(_vm._s(_vm.$t('COMMON.CANCEL')))])],1)],1),_vm._v(" "),_c('b-modal',{ref:"agnetNewNpiGroupingModal",attrs:{"title":'New-Npi-Grouping',"hide-header-close":"","centered":"","ok-only":"","ok-variant":"secondary"},on:{"ok":_vm.clearGrouping}},[_c('p',[_vm._v("You are not permitted to access this. Kindly contact administrator")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(45);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      mappingsData: [],
      mappingsKeys: [],
      showEditMapping: false,
      editShape: null
    };
  },

  computed: {
    creatingShape: function creatingShape() {
      if (this.tempLayer) {
        return this.tempLayer.children.filter(function (shape) {
          return shape.attrs.edit_type === 'creating';
        })[0];
      }
    }
  },
  methods: {
    updateMappingData: function updateMappingData() {
      var treeData = [];
      treeData.push(this.formTreeData(this.drawLayer));
      this.mappingsData = treeData;
      this.sortMappingData(this.mappingsData[0]);
      this.mappingsKeys = this.tmpMappingsKeys([], treeData[0]);
    },
    sortMappingData: function sortMappingData(mappingData) {
      var _this = this;

      mappingData.children.sort(function (a, b) {
        return a.order - b.order;
      });
      mappingData.children.map(function (child) {
        if (child.children) {
          _this.sortMappingData(child);
        }
      });
    },
    formTreeData: function formTreeData(node) {
      var prop = {
        id: node.attrs.path,
        title: this.formatTitle(node.attrs.key),
        expanded: true,
        order: node.attrs.order,
        type: node.nodeType,
        data_type: node.attrs.dataType,
        x: node.attrs.x,
        y: node.attrs.y,
        date_format: node.attrs.dateFormat,
        required: node.attrs.required !== undefined && node.attrs.required === true
      };
      if (node.children) {
        // create a relation between parent type and child
        // to detech whether to sort by x coordinate / y coordinate
        node.children.forEach(function (child) {
          child.attrs.parentDataType = node.attrs.dataType;
          child.attrs.parentKey = node.attrs.key;
        });

        var children = this.formChildNode(node.children);
        if (this.sortByX(node)) {
          prop.children = _lodash2.default.sortBy(children, 'x');
        } else {
          prop.children = _lodash2.default.sortBy(children, 'y');
        }
      }
      return prop;
    },
    sortByX: function sortByX(node) {
      if (node.attrs.dataType === 'table_column' || node.attrs.dataType === 'table_header' && node.attrs.parentDataType === 'table_row' || node.attrs.dataType === 'table_entry' && node.attrs.parentDataType === 'table_row') {
        return true;
      } else {
        return false;
      }
    },
    formChildNode: function formChildNode(children) {
      var _this2 = this;

      var childProps = [];

      children.forEach(function (child) {
        if (child.attrs.map_type === 'group_holder') {
          return;
        }
        childProps.push(_this2.formTreeData(child));
      });
      return childProps;
    },
    formatTitle: function formatTitle(title) {
      return title.charAt(0).toUpperCase() + title.slice(1);
    },
    tmpMappingsKeys: function tmpMappingsKeys(keys, parent) {
      var _this3 = this;

      if (parent.type !== 'Layer') {
        keys.push(parent.title.toLowerCase().replace(/\s/g, ''));
      }
      if (parent.children) {
        parent.children.forEach(function (child) {
          keys = _this3.tmpMappingsKeys(keys, child);
        });
      }
      return keys;
    },
    selectedShape: function selectedShape(path, type) {
      return this.drawLayer.find(type).filter(function (shape) {
        return shape.attrs.path === path;
      })[0];
    },
    mappingCreated: function mappingCreated(mappingData) {
      var newShape = this.creatingShape;
      var parentPath = this.drawLayer.attrs.path;
      newShape.setAttrs({
        id: 'created',
        key: mappingData.key,
        x_pos: newShape.attrs.x,
        y_pos: newShape.attrs.y,
        map_type: 'shape',
        category: mappingData.category,
        order: mappingData.order,
        case: mappingData.case,
        dataType: mappingData.type,
        dateFormat: mappingData.dateFormat,
        date_category: mappingData.date_category,
        description: mappingData.description,
        required: mappingData.required,
        extract: mappingData.extract,
        extract_by_words: mappingData.extract_by_words,
        redact_field: mappingData.redact_field,
        show_field: mappingData.show_field,
        sensitive_data: mappingData.sensitive_data,
        key_alias: mappingData.key_alias,
        edit_type: 'created',
        uniq_id: Date.now().toString(),
        path: parentPath + '.' + this.pathCount
      });

      this.drawLayer.add(newShape);
      if (mappingData.order <= this.updatedNoOfMappings) {
        this.updateOrderForMappings(mappingData);
      }
      this.showNewMapping = false;
      this.pathCount++;

      this.updateMappingData();
      this.pushToHistory();
      this.updatedNoOfMappings += 1;
    },
    mappingUpdated: function mappingUpdated(mappingData, npiGroup, oldNpiGroup) {
      var _this4 = this;

      var updateShape = this.selectedShape(mappingData.path, mappingData.el_type);
      this.updateOrderForMappings(mappingData);
      updateShape.setAttrs({
        key: mappingData.key,
        category: mappingData.category,
        order: mappingData.order,
        case: mappingData.case,
        dataType: mappingData.type,
        description: mappingData.description,
        required: mappingData.required,
        extract: mappingData.extract,
        extract_by_words: mappingData.extract_by_words,
        show_field: mappingData.show_field,
        redact_field: mappingData.redact_field,
        sensitive_data: mappingData.sensitive_data,
        key_alias: mappingData.key_alias,
        dateFormat: mappingData.dateFormat,
        date_category: mappingData.date_category
      });

      if (updateShape.attrs.dataType === 'npi' && updateShape.attrs.map_type === 'group') {
        npiGroup['old_key'] = mappingData.originalKey;
        var newNpiGroups = this.npiGroups.slice().filter(function (group) {
          return group.npi_group_name !== mappingData.oldKey;
        });
        this.npiGroups = [npiGroup].concat(newNpiGroups);
      }

      if (updateShape.parent.attrs.dataType === 'npi' && updateShape.parent.attrs.map_type === 'group' || updateShape.attrs.dataType === 'npi' && updateShape.attrs.map_type === 'group') {
        updateShape.setAttrs({
          npi_group: npiGroup
        });
      }

      if (updateShape.attrs.map_type === 'group') {
        var groupShapes = this.shapesInGroup(updateShape);
        groupShapes.forEach(function (shape) {
          var required = _this4.updateRequiredField(updateShape, shape);
          shape.setAttrs({
            required: required
          });
        });
      }

      mappingData.replacedNpiMappings.map(function (child) {
        _this4.mappingsSaveData.map(function (previousMappings) {
          if (previousMappings.key === child) {
            previousMappings.path = previousMappings.path.split('.')[0] + '.' + previousMappings.path.split('.').pop();
          }
        });
      });

      if (mappingData.type === 'npi' && mappingData.el_type === 'Group') {
        var fields = Object.keys(npiGroup);
        fields.map(function (field) {
          if (npiGroup[field] !== null && field !== 'npi_group_name' && field !== 'old_key') {
            _this4.mappingsSaveData.map(function (previousMappings) {
              if (previousMappings.key === npiGroup[field]) {
                previousMappings.path = mappingData.path + '.' + previousMappings.path.split('.').pop();
              }
            });
          }
        });
      }

      this.updateMappingData();
      this.pushToHistory();
      this.showEditMapping = false;
    },
    mappingCancelled: function mappingCancelled() {
      this.showNewMapping = false;
      var invalidShape = this.creatingShape;
      if (invalidShape) {
        invalidShape.destroy();
        this.tempLayer.draw();
      }
    },
    showEditNode: function showEditNode(node) {
      if (node.type !== 'Layer') {
        var type = node.type === 'Group' ? 'Group' : 'Rect';
        this.editShape = this.drawLayer.find(type).filter(function (shape) {
          return shape.attrs.path === node.id;
        })[0];
        this.showEditMapping = true;
      }
    },
    updateCancelled: function updateCancelled() {
      this.showEditMapping = false;
    },
    updateOrderForMappings: function updateOrderForMappings(mappingData) {
      this.sortMappings();
      var parentKeyObj = this.getOrderIndex(this.drawLayer, mappingData); // gets the element selected for updation
      this.rearrangeTheMappings(this.drawLayer, parentKeyObj);
    },
    rearrangeTheMappings: function rearrangeTheMappings(drawLayer, parentKeyObj) {
      for (var i = 0; i < drawLayer.children.length; i++) {
        var child = drawLayer.children[i];
        if (child.attrs.parentKey === parentKeyObj.attrs.parentKey) {
          child.attrs.order = i + 1;
        } else if (child.children) {
          this.rearrangeTheMappingsForChild(child, parentKeyObj);
        }
      }
    },
    rearrangeTheMappingsForChild: function rearrangeTheMappingsForChild(child, parentKeyObj) {
      for (var i = 1; i < child.children.length; i++) {
        var subChild = child.children[i];
        if (subChild.attrs.parentKey === parentKeyObj.attrs.parentKey) {
          subChild.attrs.order = i;
        } else if (subChild.children) {
          this.rearrangeTheMappingsForChild(subChild, parentKeyObj);
        }
      }
    },
    sortMappings: function sortMappings() {
      this.drawLayer.children.sort(function (a, b) {
        return a.attrs.order - b.attrs.order;
      });
      this.drawLayer.children.map(function (child) {
        if (child.children) {
          child.children.sort(function (a, b) {
            return a.attrs.order - b.attrs.order;
          });
        }
      });
    },
    getOrderIndex: function getOrderIndex(drawLayer, mappingData) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'parent';

      var foundChild = void 0,
          movedOrder = void 0;
      for (var i = 0; i < drawLayer.children.length; i++) {
        var child = drawLayer.children[i];
        if (child.attrs.key === mappingData.originalKey) {
          foundChild = child;
          movedOrder = drawLayer.children.splice(i, 1)[0];
          if (type === 'child') {
            drawLayer.children.splice(mappingData.order, 0, movedOrder);
          } else {
            drawLayer.children.splice(mappingData.order - 1, 0, movedOrder);
          }
          break;
        }
        if (child.children) {
          var found = this.getOrderIndex(child, mappingData, 'child');
          if (found) {
            foundChild = found;
            break;
          }
        }
      }
      return foundChild;
    }
  }
};

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _konva = __webpack_require__(69);

var _konva2 = _interopRequireDefault(_konva);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      showNewGrouping: false,
      groupChildren: null
    };
  },


  computed: {
    creatingGroup: function creatingGroup() {
      if (this.drawLayer) {
        return this.tempLayer.find('Group').filter(function (group) {
          return group.attrs.edit_type === 'creating';
        })[0];
      }
    }
  },

  methods: {
    shapesInGroup: function shapesInGroup(group) {
      var shapes = this.drawLayer.find('.crop_rect');
      var shapeNodes = [];
      var groupEndPointX = group.attrs.x_pos + group.attrs.width;
      var groupEndPointY = group.attrs.y_pos + group.attrs.height;

      shapes.forEach(function (shape) {
        // if the shape is an orphan, check if it falls in the current group rect or not
        // else if the shape belongs to this group, push it
        if (shape.parent.nodeType === 'Layer') {
          if (shape.attrs.x_pos >= group.attrs.x_pos && shape.attrs.y_pos >= group.attrs.y_pos && shape.attrs.x_pos <= groupEndPointX && shape.attrs.y_pos <= groupEndPointY) {
            shapeNodes.push(shape);
          }
        } else if (shape.parent['_id'] === group['_id']) {
          shapeNodes.push(shape);
        }
      });

      return shapeNodes;
    },
    groupsInGroup: function groupsInGroup(group) {
      if (!group.attrs.x_pos) {
        group.attrs.x_pos = group.attrs.x;
      }
      if (!group.attrs.y_pos) {
        group.attrs.y_pos = group.attrs.y;
      }

      var groups = this.drawLayer.find('Group');
      var groupNodes = [];
      var groupEndPointX = group.attrs.x_pos + group.attrs.width;
      var groupEndPointY = group.attrs.y_pos + group.attrs.height;

      groups.forEach(function (child) {
        if (child['_id'] !== group['_id']) {
          if (child.parent.nodeType === 'Layer') {
            if (child.attrs.x_pos >= group.attrs.x_pos && child.attrs.y_pos >= group.attrs.y_pos && child.attrs.x_pos <= groupEndPointX && child.attrs.y_pos <= groupEndPointY) {
              groupNodes.push(child);
            }
          } else if (child.parent['_id'] === group['_id']) {
            groupNodes.push(child);
          }
        }
      });

      return groupNodes;
    },
    updateRequiredField: function updateRequiredField(group, shape) {
      var groupType = group.attrs.dataType;
      var shapeType = shape.attrs.dataType;
      var required = shape.attrs.required;
      if (groupType === 'single_select' || groupType === 'multi_select') {
        if (shapeType === 'checkbox') {
          required = false;
        }
      }
      return required;
    },
    buildPath: function buildPath(group) {
      var _this = this;

      var groupNodes = this.groupsInGroup(group);
      var shapeNodes = this.shapesInGroup(group);
      var groupChildren = groupNodes.concat(shapeNodes);

      groupChildren.forEach(function (child) {
        var newPath = child.attrs.path.split('.').pop();
        var required = _this.updateRequiredField(group, child);
        child.setAttrs({
          x: child.attrs.x_pos - group.attrs.x_pos,
          y: child.attrs.y_pos - group.attrs.y_pos,
          path: group.attrs.path + '.' + newPath,
          draggable: false,
          required: required
        });

        if (child.nodeType === 'Group') {
          _this.buildPath(child);
        }

        group.add(child);
      });
    },
    createNewGroup: function createNewGroup(shape) {
      var holderShape = shape;
      var parentPath = this.drawLayer.attrs.path;

      var newGroup = new _konva2.default.Group({
        x: shape.attrs.x,
        y: shape.attrs.y,
        width: shape.attrs.width,
        height: shape.attrs.height,
        draggable: true,
        id: 'new',
        edit_type: 'creating',
        name: 'group',
        path: parentPath + '.' + this.pathCount,
        template_id: shape.attrs.template_id,
        map_type: 'group',
        required: shape.attrs.required
      });

      holderShape.setAttrs({
        x: 0,
        y: 0,
        draggable: false,
        name: 'group_holder',
        map_type: 'group_holder'
      });

      this.pathCount++;
      newGroup.add(holderShape);

      this.tempLayer.add(newGroup);
      this.tempLayer.draw();
    },
    groupCreated: function groupCreated(mappingData, selectedChildren) {
      var _this2 = this;

      var newGroup = this.creatingGroup;

      newGroup.setAttrs({
        id: 'created',
        key: mappingData.name,
        dataType: mappingData.type,
        x_pos: newGroup.attrs.x,
        y_pos: newGroup.attrs.y,
        edit_type: 'created',
        uniq_id: Date.now().toString(),
        required: mappingData.required,
        order: mappingData.order > this.updatedNoOfMappings ? this.updateOrderForGroup(selectedChildren) : mappingData.order
      });

      var groupChildren = this.groupChildren.filter(function (child) {
        return selectedChildren.indexOf(child.attrs.uniq_id) > -1;
      });
      groupChildren.sort(function (a, b) {
        return a.attrs.order - b.attrs.order;
      });

      groupChildren.forEach(function (child, index) {
        var newPath = child.attrs.path.split('.').pop();
        var required = _this2.updateRequiredField(newGroup, child);
        child.setAttrs({
          x: child.attrs.x_pos - newGroup.attrs.x_pos,
          y: child.attrs.y_pos - newGroup.attrs.y_pos,
          path: newGroup.attrs.path + '.' + newPath,
          draggable: false,
          required: required,
          order: index + 1
        });

        if (child.nodeType === 'Group') {
          _this2.buildPath(child);
        }
        newGroup.add(child);
      });

      this.drawLayer.add(newGroup);
      if (mappingData.order <= this.updatedNoOfMappings) {
        this.updateOrderForMappings(mappingData);
      }

      newGroup.draw();

      this.bindListeners(newGroup);
      this.groupChildren = null;
      this.showNewGrouping = false;
      this.updateMappingData();
      this.pushToHistory();
    },
    groupCancelled: function groupCancelled() {
      this.showNewMapping = false;
      var invalidGroup = this.creatingGroup;
      if (invalidGroup) {
        invalidGroup.destroy();
        this.tempLayer.draw();
        this.showNewGrouping = false;
      }
    },
    updateOrderForGroup: function updateOrderForGroup(selectedChildren) {
      var noOfMappings = this.updatedNoOfMappings;
      var originalChildren = this.groupChildren;
      if (originalChildren.length === selectedChildren.length) {
        return noOfMappings - (selectedChildren.length - 1);
      } else {
        return noOfMappings - selectedChildren.length;
      }
    }
  }
};

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// import Konva from 'konva'

exports.default = {
  methods: {
    createGroups: function createGroups(shape) {
      this.canDelete = true;
      this.focusedElement = shape.attrs.id;
      this.highlightShape = shape;
      this.highlightSelection(shape);
    }
  }
};

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contextMenu_vue__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contextMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contextMenu_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contextMenu_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contextMenu_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd9c0ade_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contextMenu_vue__ = __webpack_require__(1079);
function injectStyle (ssrContext) {
  __webpack_require__(1078)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cd9c0ade"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contextMenu_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd9c0ade_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contextMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1078 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contextMenu"}},[(_vm.viewMenu)?_c('ul',{ref:"rightMenu",style:({top: _vm.top, left: _vm.left}),attrs:{"id":"right-click-menu","tabindex":"-1"}},[_c('li',{attrs:{"disabled":_vm.disableCut},on:{"click":_vm.cut}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"cm-text"},[_vm._v("Cut")]),_vm._v(" "),_c('div',{staticClass:"cm-key"},[_vm._v("Cmd + x")])]),_vm._v(" "),_c('li',{attrs:{"disabled":_vm.disableCopy},on:{"click":_vm.copy}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"cm-text"},[_vm._v("Copy")]),_vm._v(" "),_c('div',{staticClass:"cm-key"},[_vm._v("Cmd + c")])]),_vm._v(" "),_c('li',{staticClass:"cm-group-end",attrs:{"disabled":_vm.disablePaste},on:{"click":_vm.paste}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"cm-text"},[_vm._v("Paste here")]),_vm._v(" "),_c('div',{staticClass:"cm-key"},[_vm._v("Cmd + v")])]),_vm._v(" "),_c('li',{attrs:{"disabled":_vm.disableDelete},on:{"click":_vm.destroy}},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"cm-text"},[_vm._v("Delete")]),_vm._v(" "),_c('div',{staticClass:"cm-key"},[_vm._v("Cmd + d")])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-icon"},[_c('i',{staticClass:"fa fa-cut"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-icon"},[_c('i',{staticClass:"fa fa-copy"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-icon"},[_c('i',{staticClass:"fa fa-paste"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cm-icon"},[_c('i',{staticClass:"fa fa-trash"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _vuex = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      redirectPath: null
    };
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.enableSave()) {
      this.redirectPath = to.path;
      if (this.isAdminRole) {
        this.$refs.saveAlertModal.show();
      } else {
        this.discardData();
      }
    } else {
      next();
    }
  },


  computed: _extends({
    mappingsSaveData: function mappingsSaveData() {
      var layers = this.stage.find('Layer').filter(function (layer) {
        return layer.attrs.edit_type === 'created';
      });
      var groups = this.stage.find('Group').filter(function (group) {
        return group.attrs.edit_type === 'created';
      });
      var shapes = this.stage.find('Rect').filter(function (shape) {
        return shape.attrs.edit_type === 'created';
      });

      var mappings = layers.concat(groups, shapes);

      return mappings.map(function (map) {
        return map.attrs;
      });
    }
  }, (0, _vuex.mapGetters)(['isAdminRole'])),

  methods: {
    enableSave: function enableSave() {
      return this.currentIndex > 0;
    },
    discardData: function discardData() {
      this.resetEditHistory();
      _router2.default.push(this.redirectPath);
    },
    saveData: function saveData(formStatus, esmPresentStatus, svPresentStatus, cvPresentStatus) {
      var _this = this;

      var vm = this;
      var updateEsmStatus = formStatus;
      var esmStatus = esmPresentStatus;
      var svStatus = svPresentStatus;
      var cvStatus = cvPresentStatus;
      var data = new window.FormData();
      var mapData = JSON.stringify(this.mappingsSaveData);
      data.append('mappings', mapData);
      data.append('template_id', this.id);
      data.append('form_status', updateEsmStatus);
      data.append('esm_status', esmStatus);
      data.append('sv_status', svStatus);
      data.append('cv_status', cvStatus);
      this.mappingDataLoaded = false;
      this.editorDataLoaded = false;
      _vue2.default.axios.post('/template_mappings/save_editor', data, { headers: { Authorization: 'Bearer ' + vm.idToken } }).then(function (response) {
        _vue2.default.toasted.show(response.data.message, { type: response.data.error ? 'error' : 'success' });
        // Vue.toasted.show(this.$t('TEMPLATE.MSG_SAVED'))
        _this.resetEditHistory();
        if (_this.redirectPath) {
          _router2.default.push(_this.redirectPath);
        } else {
          _this.fetchTemplateWithOutGaurd();
        }
      }, function (error) {
        _vue2.default.toasted.show(_this.$t('TEMPLATE.MSG_SAVE_FAIL'), { icon: 'chain-broken', type: 'error' });
        console.log(error);
        _this.mappingDataLoaded = true;
      });
    }
  }
};

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editMapping_vue__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editMapping_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editMapping_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editMapping_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editMapping_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bf74831_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editMapping_vue__ = __webpack_require__(1082);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editMapping_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bf74831_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editMapping_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-mapping"},[_c('b-modal',{ref:"mapEditModalRef",attrs:{"title":_vm.modalTitle(),"hide-header-close":"","centered":""},on:{"hide":_vm.cancelUpdateMapping,"shown":_vm.focusOnInput}},[_c('b-container',{attrs:{"fluid":""}},[(this.element.el_type === 'Shape')?_c('div',[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.KEY')))]),_vm._v(" "),_c('b-col',[_c('b-form-input',{ref:"updateFieldKey",attrs:{"type":"text","placeholder":"Key"},model:{value:(_vm.element.key),callback:function ($$v) {_vm.$set(_vm.element, "key", $$v)},expression:"element.key"}}),_vm._v(" "),(_vm.element.key && !_vm.isKeyUnique)?_c('div',{staticStyle:{"color":"red"}},[_vm._v("Key must be unique.")]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.DATA_TYPE')))]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.listTypes,"placeholder":"Mapping Type"},on:{"input":function($event){_vm.handleRequired()}},model:{value:(_vm.element.type),callback:function ($$v) {_vm.$set(_vm.element, "type", $$v)},expression:"element.type"}})],1)],1),_vm._v(" "),(_vm.element.type == 'date')?_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.DATE_CATEGORY')))]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.dateCategoryList,"placeholder":"Select Date Category"},model:{value:(_vm.element.date_category),callback:function ($$v) {_vm.$set(_vm.element, "date_category", $$v)},expression:"element.date_category"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.element.type == 'date')?_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.DATE_FORMAT')))]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.dateFormatList,"placeholder":"Select Date Format"},model:{value:(_vm.element.dateFormat),callback:function ($$v) {_vm.$set(_vm.element, "dateFormat", $$v)},expression:"element.dateFormat"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.MAPPING_CATEGORY')))]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.mappingCategories,"placeholder":"Mapping Category"},model:{value:(_vm.element.category),callback:function ($$v) {_vm.$set(_vm.element, "category", $$v)},expression:"element.category"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.ORDER_OF_OCCUR')))]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.orderOptions,"placeholder":"Mapping Order"},model:{value:(_vm.element.order),callback:function ($$v) {_vm.$set(_vm.element, "order", $$v)},expression:"element.order"}})],1)],1),_vm._v(" "),(_vm.canExtract)?_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.EXT')))]),_vm._v(" "),_c('b-col',[_c('b-form-radio-group',[_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.element.extract),expression:"element.extract"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"extEditYes"},domProps:{"value":true,"checked":_vm._q(_vm.element.extract,true)},on:{"change":function($event){_vm.$set(_vm.element, "extract", true)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"extEditYes"}},[_vm._v(_vm._s(_vm.$t('COMMON.YES')))])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.element.extract),expression:"element.extract"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"extEditNo"},domProps:{"value":false,"checked":_vm._q(_vm.element.extract,false)},on:{"change":function($event){_vm.$set(_vm.element, "extract", false)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"extEditNo"}},[_vm._v(_vm._s(_vm.$t('COMMON.NO')))])])])],1)],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.EXT_BY_WORDS')))]),_vm._v(" "),_c('b-col',[_c('b-form-radio-group',[_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.element.extract_by_words),expression:"element.extract_by_words"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"extractByWordEditYes"},domProps:{"value":true,"checked":_vm._q(_vm.element.extract_by_words,true)},on:{"change":function($event){_vm.$set(_vm.element, "extract_by_words", true)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"extractByWordEditYes"}},[_vm._v(_vm._s(_vm.$t('COMMON.YES')))])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.element.extract_by_words),expression:"element.extract_by_words"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"extractByWordEditNo"},domProps:{"value":false,"checked":_vm._q(_vm.element.extract_by_words,false)},on:{"change":function($event){_vm.$set(_vm.element, "extract_by_words", false)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"extractByWordEditNo"}},[_vm._v(_vm._s(_vm.$t('COMMON.NO')))])])])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.REDACT_FIELD')))]),_vm._v(" "),_c('b-col',[_c('b-form-radio-group',[_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.element.redact_field),expression:"element.redact_field"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"redactFieldsYes"},domProps:{"value":true,"checked":_vm._q(_vm.element.redact_field,true)},on:{"change":function($event){_vm.$set(_vm.element, "redact_field", true)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"redactFieldsYes"}},[_vm._v(_vm._s(_vm.$t('COMMON.YES')))])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.element.redact_field),expression:"element.redact_field"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"redactFieldsNo"},domProps:{"value":false,"checked":_vm._q(_vm.element.redact_field,false)},on:{"change":function($event){_vm.$set(_vm.element, "redact_field", false)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"redactFieldsNo"}},[_vm._v(_vm._s(_vm.$t('COMMON.NO')))])])])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.SHOW_FIELD')))]),_vm._v(" "),_c('b-col',[_c('b-form-radio-group',[_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.element.show_field),expression:"element.show_field"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"showFieldTrue"},domProps:{"value":true,"checked":_vm._q(_vm.element.show_field,true)},on:{"change":function($event){_vm.$set(_vm.element, "show_field", true)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"showFieldTrue"}},[_vm._v(_vm._s(_vm.$t('COMMON.YES')))])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.element.show_field),expression:"element.show_field"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"showFieldFalse"},domProps:{"value":false,"checked":_vm._q(_vm.element.show_field,false)},on:{"change":function($event){_vm.$set(_vm.element, "show_field", false)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"showFieldFalse"}},[_vm._v(_vm._s(_vm.$t('COMMON.NO')))])])])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.CASE')))]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.caseCategories,"placeholder":"Mapping Case"},model:{value:(_vm.element.case),callback:function ($$v) {_vm.$set(_vm.element, "case", $$v)},expression:"element.case"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.SENS_DATA')))]),_vm._v(" "),_c('b-col',[_c('b-form-radio-group',[_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.element.sensitive_data),expression:"element.sensitive_data"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"editSensitiveDataYes"},domProps:{"value":true,"checked":_vm._q(_vm.element.sensitive_data,true)},on:{"change":function($event){_vm.$set(_vm.element, "sensitive_data", true)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"editSensitiveDataYes"}},[_vm._v(_vm._s(_vm.$t('COMMON.YES')))])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.element.sensitive_data),expression:"element.sensitive_data"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"editSensitiveDataNo"},domProps:{"value":false,"checked":_vm._q(_vm.element.sensitive_data,false)},on:{"change":function($event){_vm.$set(_vm.element, "sensitive_data", false)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"editSensitiveDataNo"}},[_vm._v(_vm._s(_vm.$t('COMMON.NO')))])])])],1)],1),_vm._v(" "),(_vm.canShowRequired)?_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.REQ')))]),_vm._v(" "),_c('b-col',[_c('b-form-radio-group',[_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.element.required),expression:"element.required"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"requiredEditYes"},domProps:{"value":true,"checked":_vm._q(_vm.element.required,true)},on:{"change":function($event){_vm.$set(_vm.element, "required", true)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"requiredEditYes"}},[_vm._v(_vm._s(_vm.$t('COMMON.YES')))])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.element.required),expression:"element.required"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"requiredEditNo"},domProps:{"value":false,"checked":_vm._q(_vm.element.required,false)},on:{"change":function($event){_vm.$set(_vm.element, "required", false)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"requiredEditNo"}},[_vm._v(_vm._s(_vm.$t('COMMON.NO')))])])])],1)],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.ALIAS')))]),_vm._v(" "),_c('b-col',[_c('multiselect',{attrs:{"tag-placeholder":"Add this as Alias","placeholder":"Search or add a tag","options":_vm.aliasOptions,"multiple":true,"taggable":true},on:{"tag":_vm.addTag},model:{value:(_vm.selectedAliasData),callback:function ($$v) {_vm.selectedAliasData=$$v},expression:"selectedAliasData"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('COMMON.DESCRIPTION')))]),_vm._v(" "),_c('b-col',[_c('b-form-textarea',{attrs:{"placeholder":_vm.$t('COMMON.DESCRIPTION')},model:{value:(_vm.element.description),callback:function ($$v) {_vm.$set(_vm.element, "description", $$v)},expression:"element.description"}})],1)],1)],1):(_vm.element.type !== 'npi')?_c('div',[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('COMMON.NAME')))]),_vm._v(" "),_c('b-col',[_c('b-form-input',{ref:"updateFieldKey",attrs:{"type":"text","placeholder":_vm.$t('TEMPLATE.GRP_NAME')},model:{value:(_vm.element.key),callback:function ($$v) {_vm.$set(_vm.element, "key", $$v)},expression:"element.key"}})],1),_vm._v(" "),(_vm.element.key && !_vm.isKeyUnique)?_c('div',{staticStyle:{"color":"red"}},[_vm._v("Key must be unique.")]):_vm._e()],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.TYPE')))]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.groupTypes,"placeholder":_vm.$t('TEMPLATE.GRP_TYPE')},on:{"input":function($event){_vm.handleRequired()}},model:{value:(_vm.element.type),callback:function ($$v) {_vm.$set(_vm.element, "type", $$v)},expression:"element.type"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"modal-label",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.ORDER_OF_OCCUR')))]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.orderOptions,"placeholder":"Mapping Order"},model:{value:(_vm.element.order),callback:function ($$v) {_vm.$set(_vm.element, "order", $$v)},expression:"element.order"}})],1)],1),_vm._v(" "),(_vm.canShowRequired)?_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.REQ')))]),_vm._v(" "),_c('b-col',[_c('b-form-radio-group',[_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.element.required),expression:"element.required"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"requiredGrpEditYes"},domProps:{"value":true,"checked":_vm._q(_vm.element.required,true)},on:{"change":function($event){_vm.$set(_vm.element, "required", true)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"requiredGrpEditYes"}},[_vm._v(_vm._s(_vm.$t('COMMON.YES')))])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.element.required),expression:"element.required"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"requiredGrpEditNo"},domProps:{"value":false,"checked":_vm._q(_vm.element.required,false)},on:{"change":function($event){_vm.$set(_vm.element, "required", false)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"requiredGrpEditNo"}},[_vm._v(_vm._s(_vm.$t('COMMON.NO')))])])])],1)],1):_vm._e()],1):_c('div',[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v("Name")]),_vm._v(" "),_c('b-col',[_c('b-form-input',{ref:"updateFieldKey",attrs:{"type":"text","placeholder":"Group Name"},model:{value:(_vm.element.key),callback:function ($$v) {_vm.$set(_vm.element, "key", $$v)},expression:"element.key"}}),_vm._v(" "),(_vm.element.key && !_vm.isKeyUnique)?_c('div',{staticStyle:{"color":"red"}},[_vm._v("Key must be unique.")]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v("NPI")]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.npiFields,"placeholder":"NPI","state":!_vm.$v.group.npi.$invalid},on:{"change":function($event){_vm.npiFieldChanged('npi')}},model:{value:(_vm.group.npi),callback:function ($$v) {_vm.$set(_vm.group, "npi", $$v)},expression:"group.npi"}}),_vm._v(" "),_c('b-form-invalid-feedback',{attrs:{"id":"input2LiveFeedback"}},[_vm._v("This is a required field\n              ")])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v("Prescriber First Name")]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.npiFields,"placeholder":"First Name"},on:{"change":function($event){_vm.npiFieldChanged('first_name')}},model:{value:(_vm.group.first_name),callback:function ($$v) {_vm.$set(_vm.group, "first_name", $$v)},expression:"group.first_name"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v("Prescriber Last Name")]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.npiFields,"placeholder":"Last Name"},on:{"change":function($event){_vm.npiFieldChanged('last_name')}},model:{value:(_vm.group.last_name),callback:function ($$v) {_vm.$set(_vm.group, "last_name", $$v)},expression:"group.last_name"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v("Prescriber Name")]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.npiFields,"placeholder":"Name"},on:{"change":function($event){_vm.npiFieldChanged('name')}},model:{value:(_vm.group.name),callback:function ($$v) {_vm.$set(_vm.group, "name", $$v)},expression:"group.name"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v("City")]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.npiFields,"placeholder":"City"},on:{"change":function($event){_vm.npiFieldChanged('city')}},model:{value:(_vm.group.city),callback:function ($$v) {_vm.$set(_vm.group, "city", $$v)},expression:"group.city"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v("State")]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.npiFields,"placeholder":"State"},on:{"change":function($event){_vm.npiFieldChanged('state')}},model:{value:(_vm.group.state),callback:function ($$v) {_vm.$set(_vm.group, "state", $$v)},expression:"group.state"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v("Zipcode")]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.npiFields,"placeholder":"ZipCode"},on:{"change":function($event){_vm.npiFieldChanged('zipcode')}},model:{value:(_vm.group.zipcode),callback:function ($$v) {_vm.$set(_vm.group, "zipcode", $$v)},expression:"group.zipcode"}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"w-100 d-flex justify-content-end",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"secondary mr-1","disabled":!_vm.isKeyUnique || (_vm.element.type == 'date' && !_vm.element.dateFormat)},on:{"click":_vm.updateMapping}},[_vm._v(_vm._s(_vm.$t('COMMON.UPDATE')))]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"light"},on:{"click":_vm.cancelMapping}},[_vm._v(_vm._s(_vm.$t('COMMON.CANCEL')))])],1)],1),_vm._v(" "),_c('b-modal',{ref:"agnetEditMappingModal",attrs:{"title":'Edit Mapping',"hide-header-close":"","centered":"","ok-only":"","ok-variant":"secondary"},on:{"ok":_vm.editDrawing}},[_c('p',[_vm._v("You are not permitted to access this. Kindly contact administrator")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      barcodeFields: ['barcode_type', 'value'],
      showMoreBarcode: true
    };
  },

  computed: {
    barCodePresent: function barCodePresent() {
      return this.trainTemplateData.barcodes.length > 0;
    },
    multipleBarCode: function multipleBarCode() {
      return this.trainTemplateData.barcodes.length > 1;
    },
    showMoreText: function showMoreText() {
      return this.showMoreBarcode ? ' >>' : ' <<';
    }
  },
  methods: {
    toggleShowMoreBarcode: function toggleShowMoreBarcode() {
      this.showMoreBarcode = !this.showMoreBarcode;
    }
  }
};

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      showNewNpiGrouping: false
    };
  },

  methods: {
    showCreateNpiModal: function showCreateNpiModal() {
      this.showNewNpiGrouping = true;
    },
    npiGroupCreated: function npiGroupCreated(key, group) {
      var _this = this;

      var npiGroupKeys = group;
      npiGroupKeys['npi_group_name'] = key;
      var npiGroup = {
        dataType: 'npi',
        draggable: true,
        edit_type: 'created',
        height: 0,
        id: 'created',
        key: key,
        map_type: 'group',
        name: 'group',
        path: 1 + '.' + this.pathCount,
        required: false,
        template_id: this.trainTemplateData.id,
        uniq_id: Date.now().toString(),
        width: 0,
        x: 0,
        x_pos: 0,
        y: 0,
        y_pos: 0,
        npi_group: npiGroupKeys
      };
      this.mappingsSaveData.push(npiGroup);
      var fields = Object.keys(group);
      fields.map(function (field) {
        if (group[field] !== null) {
          _this.mappingsSaveData.map(function (previousMappings) {
            if (previousMappings.key === group[field] && previousMappings.map_type !== 'group') {
              previousMappings.path = npiGroup.path + '.' + previousMappings.path.split('.').pop();
            }
          });
        }
      });
      this.pathCount++;
      this.saveData();
      this.showNewNpiGrouping = false;
    },
    npiGroupCancelled: function npiGroupCancelled() {
      this.showNewNpiGrouping = false;
    }
  }
};

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",attrs:{"id":"train-template"}},[_c('b-row',{staticClass:"email-app"},[_c('b-col',{attrs:{"lg":"12"}},[(!_vm.editorDataLoaded)?_c('main',{staticClass:"message bg-primary"},[_c('div',[_c('strong',[_vm._v(_vm._s(_vm.$t('TEMPLATE.TRAIN_BASE')))])])]):_vm._e(),_vm._v(" "),(!_vm.editorDataLoaded)?_c('b-card',[_c('content-placeholders',[_c('content-placeholders-img',{staticStyle:{"height":"765px"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.editorDataLoaded && _vm.trainTemplate.is_public)?_c('div',{staticClass:"pull-right"},[_c('b-button',{staticClass:"mt-2",attrs:{"variant":"secondary","target":"_blank","href":'/submit/'+_vm.trainTemplate.template_doc_id}},[_vm._v("Submit Form")])],1):_vm._e(),_vm._v(" "),_c('main',{staticClass:"message bg-primary"},[(_vm.editorDataLoaded)?_c('div',[_c('strong',[_vm._v(" "+_vm._s(_vm.$t('TEMPLATE.TRAIN_BASE')))]),_vm._v("   "+_vm._s(_vm.trainTemplate.title)+"\n        "),_c('span',{staticClass:"badge badge-info mr-4"},[_vm._v(" "+_vm._s(_vm.trainTemplate.status ? ('COMMON.DONE') : _vm.$t('COMMON.NEW'))+" ")]),_vm._v(" "),(_vm.trainTemplateData.revision_ids.length)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.revisionVersionSelected),expression:"revisionVersionSelected"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.revisionVersionSelected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.fetchTemplateWithOutGaurd($event.target.value)}]}},_vm._l((_vm.trainTemplateData.revision_ids),function(option,index){return _c('option',{key:index,domProps:{"value":option}},[_vm._v("\n            "+_vm._s(_vm.$t('COMMON.VERSION'))+" "+_vm._s(option)+"\n          ")])})):_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.revisionVersionSelected),expression:"revisionVersionSelected"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.revisionVersionSelected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("\n            "+_vm._s(_vm.$t('COMMON.VERSION'))+" 1\n          ")])]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('TEMPLATE.ENABLE_AUTO_CORRECT')))]),_vm._v(" "),_c('c-switch',{attrs:{"type":"3d","variant":"success","checked":_vm.trainTemplate.auto_correct_flag},on:{"change":function($event){_vm.autoCorrectSwitchChange($event)}}}),_vm._v(" "),_c('span',{staticClass:"up-dn-btn"},[_c('div',{staticClass:"btn-group import-export"},[_c('b-button',{staticClass:"import-export-button",attrs:{"href":_vm.axios.defaults.baseURL.replace('/api', '') + _vm.trainTemplateData.image_url,"target":"_blank"}},[_c('i',{staticClass:"fa fa-download"})])],1),_vm._v(" "),(_vm.isAdminRole)?_c('div',{staticClass:"btn-group import-export"},[_c('b-button',{staticClass:"import-export-button",on:{"click":_vm.mappingDownload}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.EXPORT')))])],1):_vm._e(),_vm._v(" "),(_vm.isAdminRole)?_c('div',{staticClass:"btn-group import-export"},[_c('b-button',{staticClass:"import-export-button",on:{"click":_vm.showImportModal}},[_vm._v(" "+_vm._s(_vm.$t('TEMPLATE.IMPORT'))+" ")])],1):_vm._e()]),_vm._v(" "),(_vm.barCodePresent)?_c('span',{staticClass:"float-right"},[_c('strong',[_vm._v(" Barcode: ")]),_vm._v(" "),_c('span',{staticClass:"mr-4"},[_vm._v(" "+_vm._s(_vm.trainTemplate.barcodes[0].value)+" ")]),_vm._v(" "),_c('strong',[_vm._v(" Barcode Type: ")]),_vm._v(" "+_vm._s(_vm.trainTemplate.barcodes[0].barcode_type)+"\n          "),(_vm.multipleBarCode)?_c('span',{staticClass:"barcode-info",attrs:{"id":"barcodeInfo"},on:{"click":_vm.toggleShowMoreBarcode}},[_c('b',[_c('i',[_c('u',[_vm._v(_vm._s(_vm.showMoreText))])])])]):_vm._e(),_vm._v(" "),_c('b-popover',{attrs:{"target":"barcodeInfo","triggers":"click"}},[[_c('b-table',{attrs:{"hover":"","fields":_vm.barcodeFields,"items":_vm.trainTemplate.barcodes}})]],2)],1):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"3"}},[(!_vm.mappingDataLoaded)?_c('div',{staticClass:"template-mapping"},[_c('main',{staticClass:"message"},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{attrs:{"className":"fa fa-align-justify"}}),_c('strong',[_vm._v(_vm._s(_vm.$t('TEMPLATE.MAPPINGS')))])]),_vm._v(" "),_c('content-placeholders',[_c('content-placeholders-text',{attrs:{"lines":29}})],1)],1)],1)]):_c('template-mappings',{attrs:{"template-mappings":this.mappingsData,"mappings":this.stage,"is-latest-version":this.isLatestVersion},on:{"updated":_vm.mappingUpdated,"nodeSelected":_vm.showEditNode}}),_vm._v(" "),_c('new-mapping',{attrs:{"mappings-keys":this.mappingsKeys,"show-new-mapping":this.showNewMapping,"order-options":this.orderOptionsForNewMapping},on:{"created":_vm.mappingCreated,"cancelled":_vm.mappingCancelled}}),_vm._v(" "),_c('new-grouping',{attrs:{"mappings-keys":this.mappingsKeys,"show-new-grouping":this.showNewGrouping,"group-children":this.groupChildren,"order-options":this.orderOptionsForNewMapping},on:{"created":_vm.groupCreated,"cancelled":_vm.groupCancelled}}),_vm._v(" "),_c('edit-mapping',{attrs:{"mappings-keys":this.mappingsKeys,"show-edit-mapping":this.showEditMapping,"canvasElement":this.editShape,"npi-groups":this.npiGroups,"stage":this.stage,"order-options":this.orderOptionsForUpdateMapping},on:{"updated":_vm.mappingUpdated,"cancelled":_vm.updateCancelled}}),_vm._v(" "),_c('new-npiGrouping',{attrs:{"mappings-keys":this.mappingsKeys,"show-new-npi-grouping":this.showNewNpiGrouping,"templateMappings":this.stage},on:{"created":_vm.npiGroupCreated,"cancelled":_vm.npiGroupCancelled}})],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"9"}},[_c('main',{staticClass:"message content-holder"},[(_vm.editorDataLoaded)?_c('div',{staticClass:"d-flex justify-content-between toolbar-bg"},[(this.isLatestVersion || !this.trainTemplateData.revision_ids.length)?_c('div',{staticClass:"action-bar-row"},[_c('div',{staticClass:"btn-group"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"variant":_vm.selectedAction('save'),"disabled":!this.enableSave(),"title":_vm.$t('TEMPLATE.SAVE')},on:{"click":_vm.saveDataFunction}},[_c('i',{staticClass:"fa fa-floppy-o"})])],1),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"variant":"light","title":_vm.$t('TEMPLATE.THUMBNAIL')},on:{"click":_vm.toggleThumbnail}},[_c('i',{staticClass:"fa fa-image"})])],1),_vm._v(" "),_c('b-dropdown',{staticClass:"theme",attrs:{"variant":"light"}},[_c('template',{slot:"button-content"},[_c('span',{},[_vm._v(_vm._s(_vm.$t('TEMPLATE.THEME'))+" ")])]),_vm._v(" "),_c('b-dropdown-item',{class:{selected: _vm.isThemeSelected('blue')},attrs:{"href":"#"},on:{"click":function($event){_vm.updateTheme('blue')}}},[_vm._v(" "+_vm._s(_vm.$t('COLOR.BLUE'))+" "),_c('b-badge',{attrs:{"variant":"info"}},[_vm._v(" "+_vm._s(_vm.$t('COLOR.BLUE')))])],1),_vm._v(" "),_c('b-dropdown-item',{class:{selected: _vm.isThemeSelected('green')},attrs:{"href":"#"},on:{"click":function($event){_vm.updateTheme('green')}}},[_vm._v(" "+_vm._s(_vm.$t('COLOR.GREEN'))+" "),_c('b-badge',{attrs:{"variant":"success"}},[_vm._v(" "+_vm._s(_vm.$t('COLOR.GREEN')))])],1),_vm._v(" "),_c('b-dropdown-item',{class:{selected: _vm.isThemeSelected('red')},attrs:{"href":"#"},on:{"click":function($event){_vm.updateTheme('red')}}},[_vm._v(" "+_vm._s(_vm.$t('COLOR.RED'))+" "),_c('b-badge',{attrs:{"variant":"danger"}},[_vm._v(" "+_vm._s(_vm.$t('COLOR.RED')))])],1)],2),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"variant":"light","title":_vm.$t('TEMPLATE.CREATE_NPI_GROUP')},on:{"click":_vm.showCreateNpiModal}},[_vm._v(_vm._s(_vm.$t('TEMPLATE.NPI_GROUP')))])],1)],1):_c('div',{staticClass:"older-version-message"},[_c('strong',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('TEMPLATE.OLDER_VERSIONS')))])]),_vm._v(" "),_c('div',{staticClass:"action-bar-row paginate-page"},[_c('b-button',{attrs:{"title":_vm.$t('TEMPLATE.PREV_PAGE'),"variant":'link',"disabled":_vm.canGoToPrev},on:{"click":function($event){_vm.goToPage(_vm.prevPage)}}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-arrow-left"})]),_vm._v(" "),_c('span',{staticClass:"holder"},[_c('span',{staticClass:"h4"},[_vm._v(_vm._s(_vm.getCurrentPage))]),_vm._v(" "+_vm._s(_vm.$t('COMMON.OF'))+" "+_vm._s(_vm.totalPages))]),_vm._v(" "),_c('b-button',{attrs:{"title":_vm.$t('TEMPLATE.NEXT_PAGE'),"variant":'link',"disabled":_vm.canGoToNext},on:{"click":function($event){_vm.goToPage(_vm.nextPage)}}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-arrow-right"})])],1),_vm._v(" "),(this.isLatestVersion || !this.trainTemplateData.revision_ids.length)?_c('div',{staticClass:"action-bar-row"},[(_vm.isAdminRole)?_c('div',{staticClass:"btn-group"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],ref:"selectIcon",attrs:{"variant":_vm.selectedAction('select'),"title":_vm.$t('TEMPLATE.SELECT')},on:{"click":_vm.enableSelection}},[_c('i',{staticClass:"fa fa-mouse-pointer"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],ref:"drawIcon",attrs:{"variant":_vm.selectedAction('draw'),"title":_vm.$t('TEMPLATE.DRAW')},on:{"click":_vm.enableDraw}},[_c('i',{staticClass:"fa fa-pencil"})])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('b-button',{attrs:{"variant":"light"},on:{"click":_vm.zoomIn}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-search-plus",attrs:{"title":_vm.$t('TEMPLATE.ZOOM_IN')}})]),_vm._v(" "),_c('b-button',{attrs:{"variant":"light"},on:{"click":_vm.zoomOut}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-search-minus",attrs:{"title":_vm.$t('TEMPLATE.ZOOM_OUT')}})])],1),_vm._v(" "),(_vm.isAdminRole)?_c('div',{staticClass:"btn-group"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"disabled":!_vm.enableUndo,"variant":"light","title":_vm.$t('TEMPLATE.UNDO')},on:{"click":_vm.undo}},[_c('i',{staticClass:"fa fa-undo"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"disabled":!_vm.enableRedo,"variant":"light","title":_vm.$t('TEMPLATE.REDO')},on:{"click":_vm.redo}},[_c('i',{staticClass:"fa fa-repeat"})])],1):_vm._e(),_vm._v(" "),(_vm.isAdminRole)?_c('div',{staticClass:"btn-group"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"disabled":!_vm.canDelete,"variant":_vm.selectedAction('delete'),"title":_vm.$t('TEMPLATE.DELETE_MAP')},on:{"click":_vm.showDeleteModal}},[_c('i',{staticClass:"fa fa-trash"})])],1):_vm._e()]):_c('div')]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showThumbnail)?_c('b-card',{staticClass:"thumbnail-holder"},[_c('div',{staticClass:"scrolling-wrapper-flexbox"},_vm._l((this.trainTemplateData.doc_thumbnails),function(thumbnail,index){return _c('b-card',{key:thumbnail['id'],class:{ 'thumbnail-card shadow': true, 'thumbnail-selected': _vm.thumbnailSelected(thumbnail['id']) },on:{"click":function($event){_vm.goToPage(index)}}},[_c('img',{staticClass:"card-img-top",attrs:{"src":_vm._f("withBaseUrl")(thumbnail['url'])}}),_vm._v(" "),_c('div',{staticClass:"page-number"},[_c('h4',[_vm._v(_vm._s(index + 1))])])])}))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"details"},[_c('div',{staticClass:"content"},[_c('b-card',[_c('div',{ref:"canvasEditor",staticClass:"hidden_cn",class:{draw_mode: this.draw},style:({ maxHeight: this.containerHeight + 'px' }),attrs:{"id":"container"}})]),_vm._v(" "),_c('new-mapping')],1)])],1)])],1)],1)],1),_vm._v(" "),_c('context-menu',{attrs:{"viewMenu":this.viewMenu,"disableCut":this.contextMenu.cut.disabled,"disableCopy":this.contextMenu.copy.disabled,"disablePaste":this.contextMenu.paste.disabled,"disableDelete":this.contextMenu.destroy.disabled,"pageX":this.pageX,"pageY":this.pageY},on:{"cut":_vm.cutShape,"copy":_vm.copyShape,"paste":_vm.pasteShape,"delete":_vm.destroyShape}}),_vm._v(" "),_c('b-modal',{ref:"saveAlertModal",attrs:{"title":_vm.$t('TEMPLATE.UNSAVE'),"ok-title":_vm.$t('COMMON.YES'),"cancel-title":_vm.$t('COMMON.NO'),"ok-variant":"secondary","cancel-variant":"light","hide-header-close":"","centered":""},on:{"ok":function($event){_vm.saveDataFunction()},"cancel":function($event){_vm.discardData()}}},[_vm._v("\n    "+_vm._s(_vm.$t('TEMPLATE.SAVE_CHANGES'))+"\n  ")]),_vm._v(" "),_c('b-modal',{ref:"deleteGroupModal",attrs:{"title":"Delete Group","ok-title":"Delete","cancel-title":"Cancel","ok-variant":"secondary","cancel-variant":"light","hide-header-close":"","centered":""},on:{"ok":_vm.deleteGroup,"cancel":_vm.cancelDeleteGroup,"hide":_vm.cancelDeleteGroup}},[(_vm.deletableChildren.length > 0)?_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"12"}},[_c('h6',{staticClass:"pull-left select-mappings"},[_vm._v(_vm._s(_vm.$t('COMMON.MSG_SELECT_CHILD')))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.deleteAll),expression:"deleteAll"}],staticClass:"pull-left mt-1 mr-2",attrs:{"type":"checkbox","id":"delete_all"},domProps:{"checked":Array.isArray(_vm.deleteAll)?_vm._i(_vm.deleteAll,null)>-1:(_vm.deleteAll)},on:{"change":[function($event){var $$a=_vm.deleteAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.deleteAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.deleteAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.deleteAll=$$c}},_vm.selectAllDeletableChildren]}}),_vm._v(" "),_c('label',{staticClass:"pull-left",attrs:{"for":"delete_all"}},[_vm._v("\n          Delete All\n        ")])]),_vm._v(" "),_vm._l((_vm.deletableChildren),function(child){return _c('b-col',{key:child.attrs.path,attrs:{"cols":"6"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDeletableChildren),expression:"selectedDeletableChildren"}],staticClass:"pull-left mt-1 mr-2",attrs:{"type":"checkbox","id":child.attrs.uniq_id},domProps:{"value":child.attrs.uniq_id,"checked":Array.isArray(_vm.selectedDeletableChildren)?_vm._i(_vm.selectedDeletableChildren,child.attrs.uniq_id)>-1:(_vm.selectedDeletableChildren)},on:{"change":function($event){var $$a=_vm.selectedDeletableChildren,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=child.attrs.uniq_id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedDeletableChildren=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedDeletableChildren=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedDeletableChildren=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"pull-left",attrs:{"for":child.attrs.uniq_id}},[_vm._v("\n          "+_vm._s(child.attrs.key)+" "+_vm._s(child.attrs.map_type === 'shape' ? null : ("( " + (child.attrs.map_type) + " )"))+"\n        ")])])})],2):_vm._e()],1),_vm._v(" "),_c('b-modal',{ref:"importModal",staticClass:"import-export-modal",attrs:{"id":"modal","title":_vm.$t('TEMPLATE.UPLOAD_MAPPINGS')}},[_c('input',{ref:"file",attrs:{"id":"fileUpload","type":"file"},on:{"change":function($event){_vm.handleFileUpload()}}}),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"secondary","disabled":!_vm.isFileSelected},on:{"click":_vm.saveImportMappings}},[_vm._v(" "+_vm._s(_vm.$t('CONFIGURED.CREATE'))+" ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":_vm.hideImportModal}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CLOSE'))+" ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"updateEsmAlert",attrs:{"title":_vm.$t('TEMPLATE.ESMMAPPINGS'),"ok-title":_vm.$t('COMMON.YES'),"cancel-title":_vm.$t('COMMON.NO'),"ok-variant":"secondary","cancel-variant":"light","hide-header-close":"","centered":""},on:{"ok":function($event){_vm.saveData(_vm.update_esm_status, _vm.esm_status, _vm.sv_status, _vm.cv_status)},"cancel":function($event){_vm.dontSaveEsmData()}}},[_c('p',[_vm._v(_vm._s(_vm.$t('TEMPLATE.TEMPLATE_VERSION_UPDATE')))]),_vm._v(" "),_vm._l((_vm.status_array),function(status,index){return _c('p',{key:status,staticClass:"text-left m-auto ml-md-auto"},[_c('b-row',[_c('b-col',{attrs:{"cols":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"10"}},[_c('p',[_vm._v(_vm._s(index+1)+"."+_vm._s(status))])])],1)],1)})],2),_vm._v(" "),_c('b-modal',{ref:"deleteMappings",attrs:{"title":_vm.$t('TEMPLATE.DELETE_MODAL'),"ok-title":_vm.$t('COMMON.YES'),"cancel-title":_vm.$t('COMMON.NO'),"ok-variant":"secondary","cancel-variant":"light","hide-header-close":"","centered":""},on:{"ok":function($event){_vm.deleteMapping()},"cancel":function($event){_vm.hideDeleteModal()}}},[_vm._v("\n    "+_vm._s(_vm.$t('TEMPLATE.DELETE_MODAL_CONTENT'))+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Upload_vue__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Upload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Upload_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Upload_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Upload_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77a07b78_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Upload_vue__ = __webpack_require__(1089);
function injectStyle (ssrContext) {
  __webpack_require__(1088)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77a07b78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Upload_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77a07b78_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Upload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1088 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"md":"6","offset-md":"3"}},[_c('b-card',{staticClass:"py-4 px-5"},[(_vm.showContentPlaceholder)?_c('content-placeholders',[_c('content-placeholders-img',{staticStyle:{"height":"350px"}})],1):_c('div',[_c('b-form-group',{attrs:{"label":_vm.$t('COMMON.TITLE'),"label-for":"normalTitle"}},[_c('b-form-input',{attrs:{"id":"normalTitle","type":"text","placeholder":_vm.$t('FORMS.TITLE_PLACE')},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"required",attrs:{"label":_vm.$t('FORMS.PROCESS_TYPE'),"label-for":"basicText"}},[_c('b-form-select',{class:{'is-invalid': _vm.$v.form.match_type.$error, 'is-valid': !_vm.$v.form.match_type.$invalid},attrs:{"plain":true,"options":_vm.setOptions,"placeholder":_vm.$t('FORMS.MATCH')},on:{"input":function($event){_vm.handleMatchSelect(),_vm.$v.form.match_type.$touch()}},model:{value:(_vm.form.match_type),callback:function ($$v) {_vm.$set(_vm.form, "match_type", $$v)},expression:"form.match_type"}}),_vm._v(" "),(!_vm.$v.form.match_type.required)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('TEMPLATE.REQ_TYPE')))]):_vm._e()],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[(_vm.canShowImgPreview)?_c('b-form-group',{attrs:{"label":_vm.$t('FORMS.FORCED_TEMPLATE'),"label-for":"basicText"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.templateOptions,"placeholder":_vm.$t('FORMS.TEMPLATE')},on:{"input":function($event){_vm.handleTemplateSelect()}},model:{value:(_vm.form.forced_template_doc_id),callback:function ($$v) {_vm.$set(_vm.form, "forced_template_doc_id", $$v)},expression:"form.forced_template_doc_id"}})],1):_vm._e()],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"2"}},[_c('zoom-center-transition',[(_vm.canShowImgPreview)?_c('img',{staticClass:"shadow preview-image",attrs:{"src":_vm.previewImageUrl}}):_vm._e()])],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"saveButtonContainer"},[_c('b-button',{staticClass:"saveButton",attrs:{"type":"submit","size":"sm","variant":"secondary","disabled":_vm.disableButton},on:{"click":_vm.formUpload}},[(_vm.form.uploading)?_c('i',{staticClass:"fa fa-spinner fa-spin mr-2",staticStyle:{"font-size":"18px"}}):_vm._e(),_c('span',{ref:"uploadText"},[_vm._v(_vm._s(_vm.$t('COMMON.PROCESS')))])])],1)]),_vm._v(" "),((_vm.file_length > 1) && _vm.form.title)?_c('b-form-group',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked),expression:"checked"}],attrs:{"type":"checkbox","id":"name_checkbox"},domProps:{"checked":Array.isArray(_vm.checked)?_vm._i(_vm.checked,null)>-1:(_vm.checked)},on:{"change":function($event){var $$a=_vm.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checked=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"ml-1",staticStyle:{"color":"blue"},attrs:{"for":"name_checkbox"}},[_vm._v(_vm._s(_vm.$t('FORMS.USE_TITLE')))])]):_vm._e(),_vm._v(" "),_c('label',{attrs:{"for":"dropzone"}},[_vm._v(_vm._s(_vm.$t('FORMS.UPLOAD_MULTI_FORMS')))]),_vm._v(" "),_c('b-modal',{ref:"zip-password-modal",attrs:{"centered":"","id":"zip-password","title":"Enter Password","no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","ok-title":"submit"},on:{"cancel":_vm.cancel,"show":_vm.resetZipModal,"hidden":_vm.resetZipModal,"ok":_vm.handleZipPasswordSubmit},nativeOn:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.handleZipPasswordSubmit($event)}}},[_c('form',{ref:"zip-form",attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();_vm.handleZipFormSubmit($event)}}},[_c('b-form-group',{attrs:{"state":_vm.zipPasswordState,"label":_vm.currentFile.name,"label-for":"password-input","invalid-feedback":_vm.$t('COMMON.WRONG_PASSWORD')}},[_c('b-form-input',{attrs:{"id":"password-input","type":"password","state":_vm.zipPasswordState,"required":""},model:{value:(_vm.passwordInput),callback:function ($$v) {_vm.passwordInput=$$v},expression:"passwordInput"}})],1)],1)]),_vm._v(" "),(_vm.canShowDropZone)?_c('vueDropzone',{ref:"formProcessDropZone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-file-added":_vm.onAddingFile,"vdropzone-success":_vm.onSuccess,"vdropzone-sending":_vm.sendingEvent,"vdropzone-max-files-exceeded":_vm.onExceedingMaxFiles,"vdropzone-removed-file":_vm.onRemovingFile}}):_vm._e(),_vm._v(" "),(_vm.isDropzoneBlank)?_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('TEMPLATE.REQ_FILE')))]):_vm._e(),_vm._v(" "),(_vm.isPdf)?_c('div',_vm._l((_vm.pdfsources),function(src,index){return _c('pdf',{key:index,ref:"pdfComponent",refInFor:true,staticStyle:{"display":"none"},attrs:{"src":src},on:{"password":_vm.pdfPasswordEvent,"error":_vm.pdfError,"page-loaded":_vm.pdfLoaded}})})):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessedForms_vue__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessedForms_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessedForms_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessedForms_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessedForms_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0f1330a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessedForms_vue__ = __webpack_require__(1097);
function injectStyle (ssrContext) {
  __webpack_require__(1091)
  __webpack_require__(1092)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b0f1330a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessedForms_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0f1330a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessedForms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1091 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormsSearchBar_vue__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormsSearchBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormsSearchBar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormsSearchBar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormsSearchBar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61778619_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormsSearchBar_vue__ = __webpack_require__(1096);
function injectStyle (ssrContext) {
  __webpack_require__(1094)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61778619"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormsSearchBar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61778619_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormsSearchBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1094 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 343,
	"./af.js": 343,
	"./ar": 344,
	"./ar-dz": 345,
	"./ar-dz.js": 345,
	"./ar-kw": 346,
	"./ar-kw.js": 346,
	"./ar-ly": 347,
	"./ar-ly.js": 347,
	"./ar-ma": 348,
	"./ar-ma.js": 348,
	"./ar-sa": 349,
	"./ar-sa.js": 349,
	"./ar-tn": 350,
	"./ar-tn.js": 350,
	"./ar.js": 344,
	"./az": 351,
	"./az.js": 351,
	"./be": 352,
	"./be.js": 352,
	"./bg": 353,
	"./bg.js": 353,
	"./bm": 354,
	"./bm.js": 354,
	"./bn": 355,
	"./bn.js": 355,
	"./bo": 356,
	"./bo.js": 356,
	"./br": 357,
	"./br.js": 357,
	"./bs": 358,
	"./bs.js": 358,
	"./ca": 359,
	"./ca.js": 359,
	"./cs": 360,
	"./cs.js": 360,
	"./cv": 361,
	"./cv.js": 361,
	"./cy": 362,
	"./cy.js": 362,
	"./da": 363,
	"./da.js": 363,
	"./de": 364,
	"./de-at": 365,
	"./de-at.js": 365,
	"./de-ch": 366,
	"./de-ch.js": 366,
	"./de.js": 364,
	"./dv": 367,
	"./dv.js": 367,
	"./el": 368,
	"./el.js": 368,
	"./en-au": 369,
	"./en-au.js": 369,
	"./en-ca": 370,
	"./en-ca.js": 370,
	"./en-gb": 371,
	"./en-gb.js": 371,
	"./en-ie": 372,
	"./en-ie.js": 372,
	"./en-il": 373,
	"./en-il.js": 373,
	"./en-nz": 374,
	"./en-nz.js": 374,
	"./eo": 375,
	"./eo.js": 375,
	"./es": 376,
	"./es-do": 377,
	"./es-do.js": 377,
	"./es-us": 378,
	"./es-us.js": 378,
	"./es.js": 376,
	"./et": 379,
	"./et.js": 379,
	"./eu": 380,
	"./eu.js": 380,
	"./fa": 381,
	"./fa.js": 381,
	"./fi": 382,
	"./fi.js": 382,
	"./fo": 383,
	"./fo.js": 383,
	"./fr": 384,
	"./fr-ca": 385,
	"./fr-ca.js": 385,
	"./fr-ch": 386,
	"./fr-ch.js": 386,
	"./fr.js": 384,
	"./fy": 387,
	"./fy.js": 387,
	"./gd": 388,
	"./gd.js": 388,
	"./gl": 389,
	"./gl.js": 389,
	"./gom-latn": 390,
	"./gom-latn.js": 390,
	"./gu": 391,
	"./gu.js": 391,
	"./he": 392,
	"./he.js": 392,
	"./hi": 393,
	"./hi.js": 393,
	"./hr": 394,
	"./hr.js": 394,
	"./hu": 395,
	"./hu.js": 395,
	"./hy-am": 396,
	"./hy-am.js": 396,
	"./id": 397,
	"./id.js": 397,
	"./is": 398,
	"./is.js": 398,
	"./it": 399,
	"./it.js": 399,
	"./ja": 400,
	"./ja.js": 400,
	"./jv": 401,
	"./jv.js": 401,
	"./ka": 402,
	"./ka.js": 402,
	"./kk": 403,
	"./kk.js": 403,
	"./km": 404,
	"./km.js": 404,
	"./kn": 405,
	"./kn.js": 405,
	"./ko": 406,
	"./ko.js": 406,
	"./ky": 407,
	"./ky.js": 407,
	"./lb": 408,
	"./lb.js": 408,
	"./lo": 409,
	"./lo.js": 409,
	"./lt": 410,
	"./lt.js": 410,
	"./lv": 411,
	"./lv.js": 411,
	"./me": 412,
	"./me.js": 412,
	"./mi": 413,
	"./mi.js": 413,
	"./mk": 414,
	"./mk.js": 414,
	"./ml": 415,
	"./ml.js": 415,
	"./mr": 416,
	"./mr.js": 416,
	"./ms": 417,
	"./ms-my": 418,
	"./ms-my.js": 418,
	"./ms.js": 417,
	"./mt": 419,
	"./mt.js": 419,
	"./my": 420,
	"./my.js": 420,
	"./nb": 421,
	"./nb.js": 421,
	"./ne": 422,
	"./ne.js": 422,
	"./nl": 423,
	"./nl-be": 424,
	"./nl-be.js": 424,
	"./nl.js": 423,
	"./nn": 425,
	"./nn.js": 425,
	"./pa-in": 426,
	"./pa-in.js": 426,
	"./pl": 427,
	"./pl.js": 427,
	"./pt": 428,
	"./pt-br": 429,
	"./pt-br.js": 429,
	"./pt.js": 428,
	"./ro": 430,
	"./ro.js": 430,
	"./ru": 431,
	"./ru.js": 431,
	"./sd": 432,
	"./sd.js": 432,
	"./se": 433,
	"./se.js": 433,
	"./si": 434,
	"./si.js": 434,
	"./sk": 435,
	"./sk.js": 435,
	"./sl": 436,
	"./sl.js": 436,
	"./sq": 437,
	"./sq.js": 437,
	"./sr": 438,
	"./sr-cyrl": 439,
	"./sr-cyrl.js": 439,
	"./sr.js": 438,
	"./ss": 440,
	"./ss.js": 440,
	"./sv": 441,
	"./sv.js": 441,
	"./sw": 442,
	"./sw.js": 442,
	"./ta": 443,
	"./ta.js": 443,
	"./te": 444,
	"./te.js": 444,
	"./tet": 445,
	"./tet.js": 445,
	"./tg": 446,
	"./tg.js": 446,
	"./th": 447,
	"./th.js": 447,
	"./tl-ph": 448,
	"./tl-ph.js": 448,
	"./tlh": 449,
	"./tlh.js": 449,
	"./tr": 450,
	"./tr.js": 450,
	"./tzl": 451,
	"./tzl.js": 451,
	"./tzm": 452,
	"./tzm-latn": 453,
	"./tzm-latn.js": 453,
	"./tzm.js": 452,
	"./ug-cn": 454,
	"./ug-cn.js": 454,
	"./uk": 455,
	"./uk.js": 455,
	"./ur": 456,
	"./ur.js": 456,
	"./uz": 457,
	"./uz-latn": 458,
	"./uz-latn.js": 458,
	"./uz.js": 457,
	"./vi": 459,
	"./vi.js": 459,
	"./x-pseudo": 460,
	"./x-pseudo.js": 460,
	"./yo": 461,
	"./yo.js": 461,
	"./zh-cn": 462,
	"./zh-cn.js": 462,
	"./zh-hk": 463,
	"./zh-hk.js": 463,
	"./zh-tw": 464,
	"./zh-tw.js": 464
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1095;

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-primary tab-header"},[_c('h5',{staticClass:"bg-primary p-3 my-auto col-md-4 col-sm-12"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._v(" "),(_vm.checkAuth)?_c('div',{staticClass:"p-3 pr-4 pd-0 col-md-4 col-sm-6"},[_c('b-button',{staticStyle:{"margin-left":"40%","border-radius":"5px"},attrs:{"variant":"info"},on:{"click":_vm.showFilterModal}},[_vm._v("\n      "+_vm._s(_vm.$t('WORKFLOW.FILTER'))+" "),_c('i',{staticClass:"fa fa-filter"})])],1):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"filterModal",staticClass:"multi-form-del-modal",attrs:{"size":"md","title":_vm.$t('WORKFLOW.FILTERS')}},[_c('div',{staticClass:"p-3 pr-5 pd-0 search"},[_c('b-input-group',{staticClass:"search_type"},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.setOptions},model:{value:(_vm.search_type),callback:function ($$v) {_vm.search_type=$$v},expression:"search_type"}})],1),_vm._v(" "),_c('b-input-group',{staticClass:"search-text"},[_c('b-form-input',{ref:"searchInput",attrs:{"placeholder":_vm.searchPlaceholder},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})],1)],1),_vm._v(" "),(_vm.checkAuth && _vm.order === -2)?_c('div',{staticClass:"p-3 pr-5 pd-0 search"},[_c('multiselect',{attrs:{"options":_vm.triageStatuses,"track-by":"value","label":"text","placeholder":"status","multiple":true},model:{value:(_vm.selectedTriageStatus),callback:function ($$v) {_vm.selectedTriageStatus=$$v},expression:"selectedTriageStatus"}})],1):(_vm.checkAuth && _vm.order ==  1)?_c('div',{staticClass:"p-3 pr-5 pd-0 search"},[_c('multiselect',{attrs:{"options":_vm.formDocumnetStatuses,"track-by":"value","label":"text","placeholder":"status","multiple":true},model:{value:(_vm.selectedAgentStatus),callback:function ($$v) {_vm.selectedAgentStatus=$$v},expression:"selectedAgentStatus"}})],1):(_vm.checkAuth && _vm.order ==  -1)?_c('div',{staticClass:"p-3 pr-5 pd-0 search"},[_c('multiselect',{attrs:{"options":_vm.unmatchStatuses,"track-by":"value","label":"text","placeholder":"status","multiple":true},model:{value:(_vm.selectedUnmatchStatus),callback:function ($$v) {_vm.selectedUnmatchStatus=$$v},expression:"selectedUnmatchStatus"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"p-3 pr-5 pd-0 search"},[_c('b-input-group',{staticClass:"search_type"},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.dateRangeOptions},model:{value:(_vm.dateRangeDropDown),callback:function ($$v) {_vm.dateRangeDropDown=$$v},expression:"dateRangeDropDown"}})],1)],1),_vm._v(" "),(_vm.dateRangeDropDown === 'custom_range')?_c('div',{staticClass:"p-3 pr-5 pd-0 search"},[_c('b-row',{attrs:{"id":"teamFilter"}},[_c('b-col',{attrs:{"lg":"6"}},[_c('a',[_vm._v(" Start Date")]),_vm._v(" "),_c('b-form-input',{ref:"filterFromDate",attrs:{"type":"date","max":_vm.filterToDate || _vm.currDate},model:{value:(_vm.filterFromDate),callback:function ($$v) {_vm.filterFromDate=$$v},expression:"filterFromDate"}})],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('a',[_vm._v(" End Date")]),_vm._v(" "),_c('b-form-input',{ref:"filterToDate",attrs:{"type":"date","min":_vm.filterFromDate,"max":_vm.currDate},model:{value:(_vm.filterToDate),callback:function ($$v) {_vm.filterToDate=$$v},expression:"filterToDate"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{attrs:{"align":"right"}},[_c('b-button',{attrs:{"id":"reset_button","type":"reset","size":"sm","variant":"light"},on:{"click":function($event){_vm.resetbutton()}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" "+_vm._s(_vm.$t('COMMON.RESET')))])],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer","align":"center"},slot:"modal-footer"},[_c('b-btn',{attrs:{"variant":"secondary","disabled":_vm.dateRangeDropDown === 'custom_range' && !(_vm.filterToDate && _vm.filterFromDate)},on:{"click":_vm.filterModalApply}},[_vm._v("\n        "+_vm._s(_vm.$t('COMMON.APPLY'))+"\n      ")]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"light"},on:{"click":_vm.filterModalClose}},[_vm._v("\n        "+_vm._s(_vm.$t('COMMON.CANCEL'))+"\n      ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"MultiFormDelModal",staticClass:"multi-form-del-modal",attrs:{"size":"lg","hide-footer":"","title":_vm.$t('WORKFLOW.DELETE_MULTIPLE')},on:{"hidden":_vm.onHidden}},[_c('b-col',{attrs:{"md":"6","offset-md":"3"}},[_c('b-input-group',[_c('b-col',{staticClass:"p-1",attrs:{"sm":"3"}},[_c('label',[_vm._v("Title: ")])]),_vm._v(" "),_c('b-col',{staticClass:"p-1",attrs:{"sm":"9"}},[_c('b-form-input',{ref:"deleteTitleFilter",staticClass:"delete-filter",attrs:{"placeholder":"Title of the form"},model:{value:(_vm.deleteFilter),callback:function ($$v) {_vm.deleteFilter=$$v},expression:"deleteFilter"}})],1),_vm._v(" "),_c('b-col',{staticClass:"p-1",attrs:{"sm":"3"}},[_c('label',[_vm._v("From: ")])]),_vm._v(" "),_c('b-col',{staticClass:"p-1",attrs:{"sm":"9"}},[_c('b-form-input',{ref:"deleteFromDate",staticClass:"delete-filter",attrs:{"type":"date","max":_vm.toDate || _vm.currDate},model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}})],1),_vm._v(" "),_c('b-col',{staticClass:"p-1",attrs:{"sm":"3"}},[_c('label',[_vm._v("To: ")])]),_vm._v(" "),_c('b-col',{staticClass:"p-1",attrs:{"sm":"9"}},[_c('b-form-input',{ref:"deleteToDate",staticClass:"delete-filter",attrs:{"type":"date","min":_vm.fromDate,"max":_vm.currDate},model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}})],1)],1)],1),_vm._v(" "),(_vm.invalidInputs)?_c('div',{attrs:{"id":"warn-message"}},[_vm._v("Please provide valid inputs.")]):_vm._e(),_vm._v(" "),(!_vm.showCheck)?_c('div',{attrs:{"id":"info-message"}},[_vm._v("\n      Found "+_vm._s(_vm.deletableForms.length)+" "+_vm._s(_vm.deletableForms === 1 ? 'form.' : 'forms.')+" Please select the forms to be deleted.\n    ")]):_vm._e(),_vm._v(" "),(!_vm.showCheck && _vm.deletableForms.length > 0)?_c('b-row',{staticClass:"m-3"},[_c('b-col',{attrs:{"cols":"12"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAll),expression:"selectedAll"}],staticClass:"pull-left mt-1 mr-2",attrs:{"type":"checkbox","id":"select_all"},domProps:{"checked":Array.isArray(_vm.selectedAll)?_vm._i(_vm.selectedAll,null)>-1:(_vm.selectedAll)},on:{"change":[function($event){var $$a=_vm.selectedAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedAll=$$c}},_vm.handleSelectAll]}}),_vm._v(" "),_c('label',{staticClass:"pull-left",attrs:{"for":"select_all"}},[_vm._v("\n          Select All\n        ")])]),_vm._v(" "),_vm._l((_vm.deletableForms),function(form){return _c('b-col',{key:form.id,attrs:{"sm":"12","md":"4"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedForms),expression:"selectedForms"}],staticClass:"pull-left mt-1 mr-2",attrs:{"type":"checkbox","id":form.id},domProps:{"value":form.id,"checked":Array.isArray(_vm.selectedForms)?_vm._i(_vm.selectedForms,form.id)>-1:(_vm.selectedForms)},on:{"change":function($event){var $$a=_vm.selectedForms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=form.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedForms=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedForms=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedForms=$$c}}}}),_vm._v(" "),_c('a',{staticClass:"pull-left deletable-form",attrs:{"href":'/process/docs/' + form.id,"target":"_blank"}},[_vm._v(_vm._s(form.title))])])})],2):_vm._e(),_vm._v(" "),(_vm.showCheck)?_c('b-button-group',{attrs:{"id":"checkGroup"}},[_c('b-button',{staticClass:"secondary",on:{"click":_vm.checkDeletableForms}},[_vm._v("\n        Fetch Details\n      ")])],1):_vm._e(),_vm._v(" "),(!_vm.showCheck)?_c('b-button-group',{attrs:{"id":"deleteGroup"}},[_c('b-button',{attrs:{"variant":"secondary","disabled":_vm.selectedForms.length === 0},on:{"click":_vm.deleteMultiForms}},[_vm._v("\n        Delete\n      ")]),_vm._v(" "),_c('b-button',{staticStyle:{"margin-left":"10px"},attrs:{"sm":"12","variant":"light"},on:{"click":_vm.hideModal}},[_vm._v("\n        Cancel\n      ")])],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.processing && !_vm.newFormsProcessed)?_c('b-button',{staticClass:"new_forms_processed",attrs:{"size":"sm","variant":"secondary"}},[_vm._v(_vm._s(this.$t('FORMS.PROCESSING_STAT'))+" "),_c('i',{staticClass:"fa fa-spin fa-spinner"})]):_vm._e(),_vm._v(" "),(_vm.newFormsProcessed > 0)?_c('b-button',{staticClass:"new_forms_processed",attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.handleRefresh}},[_vm._v(_vm._s(_vm.newFormsProcessed)+"  "+_vm._s(_vm.newFormsProcessed > 1 ? this.$t('FORMS.PROCESSED_STAT_MANY') : this.$t('FORMS.PROCESSED_STAT_ONE'))+"  ")]):_vm._e(),_vm._v(" "),_c('b-tabs',{staticClass:"processed-form",model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('FormsSearchBar',{attrs:{"title":_vm.$t('WORKFLOW.PROCESSED_FORMS'),"eventBus":_vm.eventBus,"order":_vm.order,"tabIndex":_vm.tabIndex},on:{"filterInput":_vm.setFilter,"refreshTab":_vm.refreshTab,"applyFilters":_vm.applyFilters}}),_vm._v(" "),_vm._l((_vm.tabs),function(tab,index){return _c('b-tab',{key:tab.id,attrs:{"title":_vm._f("titlize")(_vm.getTabName(tab.name)),"disabled":_vm.disable_tab},on:{"click":function($event){_vm.handleTabChange(tab.role_order)}}},[_c('div',{staticClass:"forms-table"},[(_vm.formsLoaded)?_c('b-table',{attrs:{"hover":"","striped":"","show-empty":"","empty-text":_vm.$t('COMMON.NO_RECORD'),"responsive":"sm","items":_vm.$store.getters.getProcessedData,"fields":_vm.tableFields,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event}},scopedSlots:_vm._u([{key:"HEAD_group_id",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_title",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"title",fn:function(data){return [_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.viewport",modifiers:{"viewport":true}}],attrs:{"title":data.item.title}},[_vm._v(_vm._s(data.item.title))])]}},{key:"HEAD_document_type",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_processed",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_rejected",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_match_type",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_updated_at",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"updated_at",fn:function(data){return [_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.viewport",modifiers:{"viewport":true}}],attrs:{"title":data.item.updated_at}},[_vm._v(_vm._s(data.item.updated_at))])]}},{key:"HEAD_created_at",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"created_at",fn:function(data){return [_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.viewport",modifiers:{"viewport":true}}],attrs:{"title":data.item.created_at}},[_vm._v(_vm._s(data.item.created_at))])]}},{key:"HEAD_total_page_count",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_forms_doc_status",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"forms_doc_status",fn:function(data){return [_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.viewport",modifiers:{"viewport":true}}],attrs:{"title":_vm.formDocumnetStatus[data.item.forms_doc_status]}},[_vm._v(_vm._s(_vm.formDocumnetStatus[data.item.forms_doc_status]))])]}},{key:"HEAD_download_link",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"download_link",fn:function(data){return [(data.item.first_form_id && data.item.form_doc_lock === false && _vm.order !== -2 && _vm.order !== -1)?_c('div',{staticClass:"btn-group"},[_c('router-link',{attrs:{"to":{ name: 'Verification', params: {id: data.item.first_form_id }}}},[(_vm.allowedExports(data.item.match_type, index, data.item.status, data.item.forms_doc_status).indexOf('analysis') >= 0 && !data.item.is_rejected)?_c('b-button',{staticClass:"btn btn-primary btn-sm",class:_vm.getCSS(data.item.match_type, index, data.item.status, 'analysis'),attrs:{"variant":"secondary"}},[_vm._v("\n                    "+_vm._s(_vm.$t('WORKFLOW.ANALYSIS'))+"\n                  ")]):_vm._e()],1),_vm._v(" "),(_vm.allowedExports(data.item.match_type, index, data.item.status, data.item.forms_doc_status).indexOf('salesforce') >= 0 && data.item.forms_doc_status !== _vm.formDocStatusEnums['PCSUCCESS'] && !data.item.is_rejected)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.viewport",modifiers:{"hover":true,"viewport":true}}],staticClass:"btn btn-primary btn-sm",class:_vm.getCSS(data.item.match_type, index, data.item.status, 'salesforce'),attrs:{"disabled":data.item.sf_export_status === true,"variant":"primary","title":_vm.$t('COMMON.SLSFRC')},on:{"click":function($event){_vm.processJson(data.item, 'salesforce')}}},[_c('i',{ref:'export-salesforce-' + index + '-' + data.item.id,refInFor:true,staticClass:"icon-cloud-upload"}),_vm._v(" "),_c('i',{ref:'spinner-salesforce-' + index + '-' + data.item.id,refInFor:true,staticClass:"fa fa-spin fa-spinner hide"})]):_vm._e(),_vm._v(" "),(_vm.allowedExports(data.item.match_type, index, data.item.status, data.item.forms_doc_status).indexOf('reject') >= 0 && !data.item.is_rejected && data.item.first_form_id && !data.item.form_doc_lock && _vm.formDocumnetStatus[data.item.forms_doc_status] !== 'Completed')?_c('b-button',{staticClass:"btn btn-primary btn-sm ml-1",attrs:{"variant":"secondary"},on:{"click":function($event){_vm.showRejectFormModal(data.item)}}},[_vm._v("\n                  Reject\n                ")]):_vm._e(),_vm._v(" "),(_vm.allowedExports(data.item.match_type, index, data.item.status, data.item.forms_doc_status).indexOf('recall') >= 0 && data.item.is_rejected && data.item.first_form_id)?_c('b-button',{staticClass:"btn btn-primary btn-sm",attrs:{"variant":"secondary"},on:{"click":function($event){_vm.changeRejectStatus(data.item)}}},[_vm._v("\n                  Recall\n                ")]):_vm._e()],1):(data.item.form_doc_lock)?_c('div',{staticClass:"btn-group"},[_c('b-button',{staticClass:"btn btn-primary btn-sm",attrs:{"variant":"dark"},on:{"click":function($event){_vm.multipleUser(data.item.id, data.item.user_name)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('WORKFLOW.LOCK_TITLE', {'userName': data.item.user_name}))+"\n              "),_c('i',{staticClass:"fa fa-unlock-alt",attrs:{"aria-hidden":"true"}})])],1):(data.item.match_type === 'TRIAGING' && data.item.forms_doc_status === _vm.formDocStatusEnums['COMPLETED'])?_c('div',{staticClass:"btn-group"},[_c('div',{staticClass:"text-center"},[_c('span',[_c('span',{staticStyle:{"color":"green","font-size":"24px","padding":"2px"}},[_c('i',{staticClass:"fa fa-check-circle fa-sm"})])])])]):(data.item.sf_export_status === true)?_c('div',{staticClass:"btn-group"},[_c('div',{staticClass:"text-center"},[_c('span',[_c('span',{staticStyle:{"color":"green","font-size":"24px","padding":"2px"}},[_c('i',{staticClass:"fa fa-check-circle fa-sm"})])])]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.viewport",modifiers:{"hover":true,"viewport":true}}],staticClass:"last-button btn-sm",staticStyle:{"border-radius":"0px"},attrs:{"variant":"dark","title":"View Record"},on:{"click":function($event){_vm.viewRecord(data.item)}}},[_c('i',{staticClass:"fa fa-external-link",attrs:{"aria-hidden":"true"}})])],1):(!data.item.first_form_id)?_c('div',{staticClass:"btn-group"},[_c('div',{staticClass:"text-center"},[_c('span',[_c('span',{staticStyle:{"color":"red","font-size":"24px","padding":"2px"}},[_c('i',{staticClass:"fa fa-check-circle"})])])]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.viewport",modifiers:{"hover":true,"viewport":true}}],staticClass:"last-button btn-sm",staticStyle:{"border-radius":"0px"},attrs:{"variant":"dark","title":"View Record"},on:{"click":function($event){_vm.viewRecord(data.item)}}},[_c('i',{staticClass:"fa fa-external-link",attrs:{"aria-hidden":"true"}})])],1):_c('div',{staticClass:"btn-group"},[_c('router-link',{attrs:{"to":{ name: 'Verification', params: {id: data.item.first_form_id }}}},[(_vm.allowedExports(data.item.match_type, index, data.item.status, data.item.forms_doc_status).indexOf('analysis') >= 0 && !data.item.is_rejected)?_c('b-button',{staticClass:"btn btn-primary btn-sm",class:_vm.getCSS(data.item.match_type, index, data.item.status, 'analysis'),attrs:{"variant":"secondary"}},[_vm._v("\n                    "+_vm._s(_vm.$t('WORKFLOW.ANALYSIS'))+"\n                  ")]):_vm._e()],1),_vm._v(" "),(_vm.allowedExports(data.item.match_type, index, data.item.status, data.item.forms_doc_status).indexOf('salesforce') >= 0)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.viewport",modifiers:{"hover":true,"viewport":true}}],staticClass:"btn btn-primary btn-sm",class:_vm.getCSS(data.item.match_type, index, data.item.status, 'salesforce'),attrs:{"disabled":data.item.sf_export_status === true,"variant":"primary","title":_vm.$t('COMMON.SLSFRC')},on:{"click":function($event){_vm.processJson(data.item, 'salesforce')}}},[_c('i',{ref:'export-salesforce-' + index + '-' + data.item.id,refInFor:true,staticClass:"icon-cloud-upload"}),_vm._v(" "),_c('i',{ref:'spinner-salesforce-' + index + '-' + data.item.id,refInFor:true,staticClass:"fa fa-spin fa-spinner hide"})]):_vm._e(),_vm._v(" "),(data.item.match_type === 'TRIAGING' && data.item.is_rejected === false)?_c('router-link',{attrs:{"to":'modify/'+ data.item.id}},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.viewport",modifiers:{"hover":true,"viewport":true}}],staticClass:"btn btn-primary btn-sm",attrs:{"variant":"secondary","title":"Show"}},[_c('i',{staticClass:"fa fa-eye"})])],1):_vm._e(),_vm._v(" "),(_vm.allowedExports(data.item.match_type, index, data.item.status, data.item.forms_doc_status).indexOf('rotated_docs_sf') >= 0 && (data.item.forms_doc_status !== _vm.formDocStatusEnums['PCSUCCESS'] && data.item.forms_doc_status !== _vm.formDocStatusEnums['REJECTED'] && data.item.forms_doc_status !== _vm.formDocStatusEnums['NEW']) && data.item.is_rotated)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.viewport",modifiers:{"hover":true,"viewport":true}}],staticClass:"btn btn-primary btn-sm",class:_vm.getCSS(data.item.match_type, index, data.item.status, 'rotated_docs_sf'),attrs:{"disabled":data.item.sf_export_status === true,"variant":"primary","title":_vm.$t('COMMON.SLSFRC')},on:{"click":function($event){_vm.processRotatedDoc(data.item, 'rotated_docs_sf')}}},[_c('i',{ref:'export-rotated_docs_sf-' + data.item.id,refInFor:true,staticClass:"icon-cloud-upload"}),_vm._v(" "),_c('i',{ref:'spinner-rotated_docs_sf-' + data.item.id,refInFor:true,staticClass:"fa fa-spin fa-spinner hide"})]):_vm._e(),_vm._v(" "),(_vm.allowedExports(data.item.match_type, index, data.item.status, data.item.forms_doc_status).indexOf('reprocess') >= 0)?_c('b-button',{staticClass:"btn btn-sm btn-primary",attrs:{"variant":"primary","disabled":data.item.retry_count >= 3 || data.item.is_rejected},on:{"click":function($event){_vm.confirmReprocess(data.item)}}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.viewport",modifiers:{"hover":true,"viewport":true}}],staticClass:"icon-refresh",attrs:{"title":data.item.retry_count >= 3 ? _vm.$t('WORKFLOW.MAX_RETRIES') : _vm.$t('WORKFLOW.REPROCESS')}})]):_vm._e(),_vm._v(" "),(_vm.allowedExports(data.item.match_type, index, data.item.status, data.item.forms_doc_status).indexOf('moveToMatched') >= 0)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.viewport",modifiers:{"hover":true,"viewport":true}}],staticClass:"btn btn-primary btn-sm",attrs:{"variant":"secondary","title":_vm.$t('WORKFLOW.MOVE_TO_MATCHED'),"disabled":data.item.is_rejected},on:{"click":function($event){_vm.moveToMatched(data.item)}}},[_c('i',{staticClass:"fa fa-reply"})]):_vm._e(),_vm._v(" "),(_vm.allowedExports(data.item.match_type, index, data.item.status, data.item.forms_doc_status).indexOf('reject') >= 0 && !data.item.is_rejected && data.item.first_form_id && !data.item.form_doc_lock && _vm.formDocumnetStatus[data.item.forms_doc_status] !== 'Completed')?_c('b-button',{staticClass:"btn btn-primary btn-sm ml-1",attrs:{"variant":"secondary"},on:{"click":function($event){_vm.showRejectFormModal(data.item)}}},[_vm._v("\n                  Reject\n              ")]):_vm._e(),_vm._v(" "),(_vm.allowedExports(data.item.match_type, index, data.item.status, data.item.forms_doc_status).indexOf('recall') >= 0 && data.item.is_rejected && data.item.first_form_id)?_c('b-button',{staticClass:"btn btn-primary btn-sm",attrs:{"variant":"secondary"},on:{"click":function($event){_vm.changeRejectStatus(data.item)}}},[_vm._v("\n                  Recall\n              ")]):_vm._e()],1)]}}])}):_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',[_c('content-placeholders',[_c('content-placeholders-img',{style:({height: '400px'})})],1)],1)],1)],1),_vm._v(" "),_c('infinite-loading',{ref:"infiniteLoading",refInFor:true,attrs:{"identifier":_vm.infiniteId,"distance":_vm.distance,"spinner":"spiral"},on:{"infinite":_vm.infiniteHandler}},[_c('div',{attrs:{"slot":"no-more"},slot:"no-more"}),_vm._v(" "),_c('div',{attrs:{"slot":"no-results"},slot:"no-results"})])],1)])})],2),_vm._v(" "),_c('b-modal',{ref:"fhirModal",attrs:{"hide-header-close":"","centered":"","title":'FHIR data',"ok-only":""},on:{"ok":_vm.clearFhirData}},[_c('b-container',{attrs:{"fluid":""}},[_c('strong',[_vm._v("Demographics")]),_vm._v(" "),_vm._l((_vm.fhirValues['demographics']),function(value,key,index){return _c('b-row',{key:'demographics' + index,staticClass:"mb-1 text-center"},[_c('b-col',{attrs:{"cols":"6"}},[_vm._v(_vm._s(_vm._f("capitalize")(key))+" ")]),_vm._v(" "),_c('b-col',{staticStyle:{"word-wrap":"break-word"},attrs:{"cols":"6"}},[_vm._v(_vm._s(value))])],1)}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('strong',[_vm._v("Orders")]),_vm._v(" "),_vm._l((_vm.fhirValues['orders']),function(value,key,index){return _c('b-row',{key:'orders' + index,staticClass:"mb-1 text-center"},[_c('b-col',{attrs:{"cols":"6"}},[_vm._v(_vm._s(_vm._f("capitalize")(key))+" ")]),_vm._v(" "),_c('b-col',{staticStyle:{"word-wrap":"break-word"},attrs:{"cols":"6"}},[_vm._v(_vm._s(value))])],1)}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('strong',[_vm._v("Diagnostics")]),_vm._v(" "),_vm._l((_vm.fhirValues['diagnostics']),function(value,key,index){return _c('b-row',{key:'diagnostics' + index,staticClass:"mb-1 text-center"},[_c('b-col',{attrs:{"cols":"6"}},[_vm._v(_vm._s(_vm._f("capitalize")(key))+" ")]),_vm._v(" "),_c('b-col',{staticStyle:{"word-wrap":"break-word"},attrs:{"cols":"6"}},[_vm._v(_vm._s(value))])],1)})],2)],1),_vm._v(" "),_c('b-modal',{ref:"validationErrorModal",attrs:{"hide-header-close":"","centered":"","title":'Export errors',"ok-only":""},on:{"ok":_vm.clearValidationErrorData}},[_c('b-container',{attrs:{"fluid":""}},[(!_vm.errorKeyAbsent)?_c('strong',[_vm._v("Errors")]):_vm._e(),_vm._v(" "),_vm._l((_vm.validationErrors),function(value,index){return (_vm.errorKeyAbsent)?_c('b-row',{key:index,staticClass:"mb-1 text-center"},[_c('b-col',{staticStyle:{"word-wrap":"break-word"},attrs:{"cols":"12"}},[_vm._v(_vm._s(value.reason))])],1):_vm._l((_vm.validationErrors),function(value,key,index){return _c('b-row',{key:key,staticClass:"mb-1 text-left"},[_c('b-col',{attrs:{"cols":"5"}},[_vm._v(_vm._s(value.key)+" ")]),_vm._v(" "),_c('b-col',{staticStyle:{"word-wrap":"break-word"},attrs:{"cols":"7"}},[_vm._v(_vm._s(value.reason))])],1)})})],2)],1),_vm._v(" "),_c('b-modal',{ref:"exportErrorModal",attrs:{"hide-header-close":"","centered":"","title":'Export errors'}},[_c('b-container',{attrs:{"fluid":""}},[(this.$store.getters.exportErrors && this.$store.getters.exportErrors.length > 0)?_c('div',{staticClass:"mb-3 error_listing"},_vm._l((this.$store.getters.exportErrors),function(error,index){return _c('b-row',{key:index},[_c('b-col',{attrs:{"cols":"12"}},[_vm._v("\n          "+_vm._s(error)+"\n        ")])],1)})):_vm._e(),_vm._v(" "),(this.$store.getters.otherMedErrors && this.$store.getters.otherMedErrors.length > 0)?_c('div',{staticClass:"mb-3 error_listing"},_vm._l((this.$store.getters.otherMedErrors),function(status,index){return _c('b-row',{key:index,staticStyle:{"text-align":"left"}},[_c('b-col',{attrs:{"cols":"12"}},[_vm._v("\n          "+_vm._s(index+1)+"."+_vm._s(status)+"\n        ")])],1)})):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.clearExportErrorData}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.OKAY'))+" ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"reprocessModal",attrs:{"hide-header-close":"","centered":"","title":_vm.$t('WORKFLOW.REPROCESS'),"ok-title":_vm.$t('WORKFLOW.REPROCESS'),"ok-variant":"secondary","cancel-title":_vm.$t('COMMON.CANCEL'),"cancel-variant":"light"},on:{"ok":_vm.reprocessFormDoc}},[_c('b-row',[_c('b-input-group',[_c('b-col',{staticClass:"p-1 col-4 col-sm-4"},[_c('label',[_vm._v(_vm._s(_vm.$t('COMMON.TITLE')))])]),_vm._v(" "),_c('b-col',{staticClass:"p-1 col-8 col-sm-8"},[_c('b-form-input',{staticClass:"reprocess-input",attrs:{"value":_vm.selectedFormTitle,"disabled":""}})],1)],1),_vm._v(" "),_c('b-input-group',[_c('b-col',{staticClass:"p-1 col-4 col-sm-4"},[_c('label',[_vm._v(_vm._s(_vm.$t('FORMS.PROCESS_TYPE'))+":")])]),_vm._v(" "),_c('b-col',{staticClass:"p-1 col-4 col-sm-8"},[_c('b-form-select',{staticClass:"reprocess-input",attrs:{"plain":true,"options":_vm.setOptions,"placeholder":_vm.$t('FORMS.MATCH')},on:{"input":function($event){_vm.handleMatchSelect()}},model:{value:(_vm.match_type),callback:function ($$v) {_vm.match_type=$$v},expression:"match_type"}})],1)],1),_vm._v(" "),(_vm.canShowImgPreview)?_c('b-input-group',[_c('b-col',{staticClass:"p-1 col-4 col-sm-4"},[_c('label',[_vm._v(_vm._s(_vm.$t('FORMS.FORCED_TEMPLATE'))+":")])]),_vm._v(" "),_c('b-col',{staticClass:"p-1 col-8 col-sm-4"},[_c('b-form-select',{staticClass:"reprocess-input",attrs:{"plain":true,"options":_vm.templateOptions,"placeholder":_vm.$t('FORMS.TEMPLATE')},on:{"input":function($event){_vm.handleTemplateSelect()}},model:{value:(_vm.forced_template_doc_id),callback:function ($$v) {_vm.forced_template_doc_id=$$v},expression:"forced_template_doc_id"}})],1),_vm._v(" "),_c('b-col',{staticClass:"p-1 col-12 col-sm-4"},[_c('zoom-center-transition',[_c('img',{staticClass:"shadow preview-image",attrs:{"src":_vm.previewImageUrl}})])],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('b-modal',{ref:"processedformsInfo",attrs:{"size":"lg","title":_vm.$t('WORKFLOW.FORM_INFO_HEADER'),"no-close-on-esc":"","hide-header-close":"","no-close-on-backdrop":"","centered":""}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mb-1 text-center"},[_c('b-col',{attrs:{"cols":"3"}},[_c('strong',[_vm._v("Processed Form Ids")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('strong',[_vm._v("Title")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('strong',[_vm._v("Process Type")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('strong',[_vm._v("Export To Salesforce")])])],1),_vm._v(" "),_vm._l((_vm.processed_form_info),function(info){return _c('b-row',{key:info.id,staticClass:"mb-1 text-center"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(_vm._s(info.id)+" ")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_vm._v(_vm._s(info.title)+" ")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_vm._v(_vm._s(info.match_type)+" ")]),_vm._v(" "),(info.is_export === true)?_c('b-col',{attrs:{"cols":"3"}},[_vm._v(" Export Sucessfull ")]):(info.is_export === false)?_c('b-col',{attrs:{"cols":"3"}},[_vm._v(" Export Unsucessfull ")]):(info.is_export === null)?_c('b-col',{attrs:{"cols":"3"}},[_vm._v(" Not Yet Exported ")]):_vm._e()],1)})],2),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.showFormInfo}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.OKAY'))+" ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"salesforceReport",attrs:{"size":"md","title":"Record Status","hide-footer":"","centered":""}},[_c('div',{staticStyle:{"text-align":"left","overflow":"auto"}},[_c('table',{staticClass:"result",staticStyle:{"width":"100%"}},[_c('tr',{staticClass:"result",staticStyle:{"background-color":"rgb(168 174 179)"}},[_c('th',{staticClass:"result"},[_vm._v(" S.No ")]),_vm._v(" "),_c('th',{staticClass:"result"},[_vm._v(" Record Type ")]),_vm._v(" "),_c('th',{staticClass:"result"},[_vm._v(" Status ")])]),_vm._v(" "),_vm._l((_vm.salesforceResponse),function(record,record_type,index){return _c('tr',[_c('td',{staticClass:"result"},[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('td',{staticClass:"result",staticStyle:{"text-align":"left"}},[(record.success && record.pc_url)?_c('a',{staticStyle:{"color":"blue"},attrs:{"target":"_blank","href":record.pc_url}},[_vm._v(_vm._s(record_type))]):_c('a',[_vm._v(_vm._s(record_type))])]),_vm._v(" "),_c('td',{staticClass:"result"},[(record.pc_url && record.success)?_c('a',[_vm._v("success")]):_c('a',[_vm._v("failed")])])])})],2)])]),_vm._v(" "),_c('b-modal',{ref:"formDelModal",attrs:{"hide-header-close":"","centered":"","title":_vm.$t('COMMON.DELETE_CONFIRM'),"ok-title":_vm.$t('COMMON.DELETE'),"cancel-title":_vm.$t('COMMON.CANCEL'),"ok-variant":"secondary","cancel-variant":"light"},on:{"ok":_vm.deleteFormDoc}},[_vm._v("\n    "+_vm._s(_vm.$t('WORKFLOW.DELETE_FORM', {'FORM_TITLE': _vm.selectedFormTitle}))+"\n  ")]),_vm._v(" "),(_vm.isAdminRole)?_c('b-modal',{ref:"lockedFormDocWarning",attrs:{"title":_vm.$t('FORMS.MULTI_USER_MODAL'),"ok-title":_vm.$t('COMMON.YES'),"cancel-title":_vm.$t('COMMON.NO'),"ok-variant":"secondary","cancel-variant":"light","hide-header-close":"","centered":""},on:{"ok":function($event){_vm.releaseFormDoc()},"cancel":function($event){_vm.stayWithFormDoc()}}},[_c('strong',[_vm._v(_vm._s(_vm.$t('WORKFLOW.LOCK_ALERT_MSG')))])]):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"rejectFormDoc",attrs:{"hide-header-close":"","title":"Reject Form","header-bg-variant":"light","centered":""}},[_c('b-card',{staticClass:"mt-3"},[_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"cols":"12"}},[_c('img',{attrs:{"src":__webpack_require__(190)}}),_vm._v(" "),_c('h5',[_vm._v("Do you want to reject this document?")])])],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){_vm.rejectForm(_vm.currentFormDoc)}}},[_vm._v(" Confirm ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":_vm.hideRejectFormDocModal}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CANCEL'))+" ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"escalatedFormDoc",attrs:{"hide-header-close":"","title":"Error","header-bg-variant":"light","centered":"","ok-only":""},on:{"ok":_vm.hideEscalatedFormDocModal}},[_c('b-card',{staticClass:"mt-3"},[_c('b-row',{staticClass:"form-group",staticStyle:{"height":"5px"}},[_c('p',{staticStyle:{"font-size":"16px"}},[_vm._v(" "+_vm._s(_vm.errorMessage))])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processDoc_vue__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processDoc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processDoc_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processDoc_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processDoc_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d1b817d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processDoc_vue__ = __webpack_require__(1117);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processDoc_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d1b817d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processDoc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1099 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processedDataTree_vue__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processedDataTree_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processedDataTree_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processedDataTree_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processedDataTree_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62850ae4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processedDataTree_vue__ = __webpack_require__(1114);
function injectStyle (ssrContext) {
  __webpack_require__(1101)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-62850ae4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processedDataTree_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62850ae4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processedDataTree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dateField_vue__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dateField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dateField_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dateField_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dateField_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c2b6a34_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dateField_vue__ = __webpack_require__(1104);
function injectStyle (ssrContext) {
  __webpack_require__(1103)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c2b6a34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dateField_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c2b6a34_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dateField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',[_c('label',{attrs:{"for":"date_name"}},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.content.key)))]),_vm._v(" "),(_vm.content.required)?_c('sup',{staticClass:"text-danger required-css"},[_c('i',{staticClass:"fa fa-asterisk"})]):_vm._e(),_vm._v(" "),(_vm.content.current_value)?_c('span',[(_vm.content.date_format)?_c('span',[_c('i',[_vm._v("("+_vm._s(_vm.content.date_format)+")")])]):_vm._e(),_vm._v(" "),(_vm.content.edited)?_c('span',{staticClass:"badge",style:({ color: '#FFFFFF', backgroundColor: '#170c9e' }),attrs:{"title":_vm.$t('FORMS.CON_SCORE')}},[_vm._v("100")]):_c('span',{staticClass:"badge",style:({ backgroundColor: _vm.content.color_code }),attrs:{"title":_vm.$t('FORMS.CON_SCORE')}},[_vm._v(_vm._s(Math.round(_vm.content.confidence * 100)))])]):_vm._e(),_vm._v(" "),(_vm.content.edited)?_c('span',{staticClass:"badge badge-edited"},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(" Edited")]):_vm._e(),_vm._v(" "),(_vm.content.is_auto_correct && _vm.autoCorrectFlag)?_c('span',{staticClass:"badge badge-auto-corrected"},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(" Auto-Corrected")]):(_vm.content.auto_correct_enable && _vm.autoCorrectFlag)?_c('span',{staticClass:"badge badge-auto_correct_enable"},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(" Auto-Correct-Enable")]):_vm._e(),_vm._v(" "),_c('date-picker',{attrs:{"id":"date_name","value-type":"format","lang":"en","format":"MM-DD-YYYY","append-to-body":"","clearable":false,"width":"100%"},on:{"input":_vm.handleDateInput},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contentEditable_vue__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contentEditable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contentEditable_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contentEditable_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contentEditable_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73fa4e74_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contentEditable_vue__ = __webpack_require__(1107);
function injectStyle (ssrContext) {
  __webpack_require__(1106)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73fa4e74"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contentEditable_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73fa4e74_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contentEditable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.fieldEdited)?_c('div',[_c('div',{staticClass:"content-input",style:({ borderColor: _vm.borderColor, backgroundColor: _vm.backgroundColor }),attrs:{"id":this.content.path,"contenteditable":"true","spellcheck":"true"},domProps:{"innerHTML":_vm._s(_vm.editedContent())},on:{"blur":_vm.contentBlurred,"focus":_vm.contentFocused}}),_vm._v(" "),_c('b-tooltip',{attrs:{"disabled":_vm.showOriginalText,"target":this.content.path,"placement":"topright","triggers":"focus"},on:{"update:disabled":function($event){_vm.showOriginalText=$event}}},[_c('strong',[_vm._v("Original Text")]),_vm._v(" "),(this.content.original_value && this.content.original_value.trim() === '')?_c('div',[_vm._v("\n      N/A\n    ")]):_c('div',[_vm._v("\n      "+_vm._s(this.content.original_value)+"\n      "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Modified By")]),_vm._v(" "),_c('br'),_vm._v("\n      "+_vm._s(this.content.edited_by)+"\n    ")])]),_vm._v(" "),(_vm.hidePopOver)?_c('b-popover',{attrs:{"target":this.content.path,"placement":"top","triggers":"focus","boundary":"window"}},[_c('div',{staticClass:"canvas-wrapper"},[_c('canvas',{attrs:{"id":'canvas_' + this.content.path}})])]):_vm._e()],1):_c('div',[_c('div',{staticClass:"content-input",style:({ borderColor: _vm.borderColor, backgroundColor: _vm.backgroundColor }),attrs:{"id":this.content.path,"contenteditable":"true","spellcheck":"true"},on:{"focus":_vm.contentFocused,"blur":_vm.contentBlurred}},_vm._l((this.content.ocr_text && this.content.ocr_text.words),function(word){return _c('span',[(word['characters'])?_c('span',_vm._l((word['characters']),function(character){return _c('span',[(_vm.isNewLine(character['letter']))?_c('span',[_c('br')]):_c('span',{style:({color: _vm.setColor(character)})},[_vm._v(_vm._s(character['letter']))])])})):_c('span',[_c('span',[_vm._v(_vm._s(word['text'] + " "))])])])})),_vm._v(" "),(_vm.hidePopOver)?_c('b-popover',{attrs:{"target":this.content.path,"placement":"top","triggers":"focus","boundary":"window"}},[_c('div',{staticClass:"canvas-wrapper"},[_c('canvas',{attrs:{"id":'canvas_' + this.content.path}})])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processMultiSelectData_vue__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processMultiSelectData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processMultiSelectData_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processMultiSelectData_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processMultiSelectData_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6da68f47_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processMultiSelectData_vue__ = __webpack_require__(1110);
function injectStyle (ssrContext) {
  __webpack_require__(1109)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6da68f47"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processMultiSelectData_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6da68f47_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processMultiSelectData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content.show_field)?_c('b-form-group',[_c('label',{attrs:{"for":"multiselect_name"}},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.content.key)))]),_vm._v(" "),(_vm.content.required)?_c('sup',{staticClass:"text-danger required-css"},[_c('i',{staticClass:"fa fa-asterisk"})]):_vm._e(),_vm._v(" "),(_vm.isEdited())?_c('span',{staticClass:"badge badge-edited"},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(" Edited")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":this.content.path}},[_c('multiselect',{staticClass:"custom-multiselect",attrs:{"id":"multiselect_name","value":_vm.selectedValues,"track-by":"text","label":"text","open-direction":"bottom","multiple":true,"close-on-select":false,"options":_vm.optionsForSelect},on:{"open":function($event){_vm.inputFocused()},"remove":function($event){_vm.optionRemoved($event)},"select":function($event){_vm.optionAdded($event)}}})],1),_vm._v(" "),(_vm.isEdited())?_c('div',[_c('b-tooltip',{attrs:{"target":this.content.path,"placement":"topright"}},[_c('strong',[_vm._v("Original Option")]),_vm._v(" "),(_vm.orgSelectedOptions.length > 0)?_c('div',[_vm._v("\n        "+_vm._s(_vm.orgSelectedOptionsText())+"\n      ")]):_c('div',[_vm._v("\n        N/A\n      ")])])],1):_vm._e(),_vm._v(" "),_c('b-popover',{attrs:{"target":this.content.path,"triggers":"focus","placement":"top","variant":"danger","boundary":"window"}},[_c('div',{staticClass:"canvas-wrapper"},[_c('canvas',{attrs:{"id":'canvas_' + this.content.path}})])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processSingleSelectData_vue__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processSingleSelectData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processSingleSelectData_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processSingleSelectData_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processSingleSelectData_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3059462_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processSingleSelectData_vue__ = __webpack_require__(1113);
function injectStyle (ssrContext) {
  __webpack_require__(1112)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b3059462"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processSingleSelectData_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3059462_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processSingleSelectData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.content.show_field)?_c('b-form-group',[_c('label',{attrs:{"for":"group_name"}},[_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.content.key))+" ")]),_vm._v(" "),(_vm.content.required)?_c('sup',{staticClass:"text-danger required-css"},[_c('i',{staticClass:"fa fa-asterisk"})]):_vm._e(),_vm._v(" "),(_vm.isEdited())?_c('span',{staticClass:"badge badge-edited"},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(" Edited")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":this.content.path}},[_c('multiselect',{staticClass:"custom-multiselect",attrs:{"id":"this.content.path","track-by":"id","label":"text","open-direction":"bottom","value":_vm.selectedOption,"options":_vm.optionsForSelect},on:{"open":function($event){_vm.inputFocused()},"remove":function($event){_vm.optionRemoved($event)},"select":function($event){_vm.optionAdded($event)}}})],1),_vm._v(" "),(_vm.isEdited())?_c('div',[_c('b-tooltip',{attrs:{"target":this.content.path,"placement":"topright"}},[_c('strong',[_vm._v("Original Option")]),_vm._v(" "),(_vm.orgSelectedOption)?_c('div',[_vm._v("\n          "+_vm._s(_vm.orgSelectedOption.key)+"\n        ")]):_c('div',[_vm._v("\n          N/A\n        ")])])],1):_vm._e(),_vm._v(" "),_c('b-popover',{attrs:{"target":this.content.path,"triggers":"focus","placement":"top","variant":"danger","boundary":"window"}},[_c('div',{staticClass:"canvas-wrapper"},[_c('canvas',{attrs:{"id":'canvas_' + this.content.path}})])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"processed-data-tree"},[(!_vm.hasContent())?_c('div',[_c('b-card',[_vm._v("\n      "+_vm._s(_vm.$t('FORMS.NOTHING'))+"\n    ")])],1):_vm._e(),_vm._v(" "),(!_vm.dataPresent)?_c('div',[_c('b-card',{attrs:{"id":"nodatadisplay"}},[_vm._v("\n     No Records Found for the Current Search\n   ")])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.processedData),function(form){return _c('div',[(form)?_c('div',_vm._l((form.children),function(sectionData){return _c('div',{key:sectionData.path},[(sectionData && sectionData.data_type === 'section')?_c('div',[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:(sectionData.key),expression:"sectionData.key"}],attrs:{"id":"mybutton"},on:{"click":function($event){sectionData.show_section = !sectionData.show_section}}},[_c('span',{staticClass:"when-opened"},[_c('i',{staticClass:"fa fa-minus-square",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('i',{staticClass:"fa fa-plus-square",attrs:{"aria-hidden":"true"}})]),_vm._v(" "+_vm._s(sectionData.key)+"\n          ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":sectionData.key},model:{value:(sectionData.show_section),callback:function ($$v) {_vm.$set(sectionData, "show_section", $$v)},expression:"sectionData.show_section"}},[_c('b-card',_vm._l((sectionData.children),function(data){return _c('div',{key:data.path},[(data)?_c('div',[(data.children)?_c('div',[(data.data_type === 'logical' || data.data_type === 'npi')?_c('div',{attrs:{"id":'group_' + data.path}},[_c('b-card',{attrs:{"no-body":""}},[_c('div',{staticClass:"text-center",attrs:{"slot":"header"},slot:"header"},[_c('strong',{on:{"click":function($event){_vm.inputFocused(data.path)}}},[_vm._v(_vm._s(_vm._f("capitalize")(data.key)))])]),_vm._v(" "),_c('b-popover',{attrs:{"target":'group_' + data.path,"triggers":"click","placement":"top","boundary":"window"}},[_c('div',{staticClass:"canvas-wrapper"},[_c('canvas',{attrs:{"id":'canvas_' + data.path}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('processed-data-tree',{attrs:{"minConf":_vm.minConf,"maxConf":_vm.maxConf,"processedData":data.children,"dataBus":_vm.dataBus,"imgBase":_vm.imgBase,"imgUrl":_vm.imgUrl,"currentPage":_vm.currentPage,"docStatus":_vm.docStatus}})],1)],1):_vm._e(),_vm._v(" "),(data.data_type === 'combine_data')?_c('div',[_c('processed-data-tree',{attrs:{"minConf":_vm.minConf,"maxConf":_vm.maxConf,"processedData":[data],"dataBus":_vm.dataBus,"imgBase":_vm.imgBase,"imgUrl":_vm.imgUrl,"currentPage":_vm.currentPage,"docStatus":_vm.docStatus,"dataPresent":true}})],1):(data.data_type === 'single_select')?_c('div',[_c('process-single-select-data',{attrs:{"content":data,"imgBase":_vm.imgBase,"imgUrl":_vm.imgUrl,"currentPage":_vm.currentPage,"docStatus":_vm.docStatus},on:{"focused":_vm.inputFocused,"dataUpdate":_vm.selectChanges}})],1):(data.data_type === 'multi_select')?_c('div',[_c('process-multi-select-data',{attrs:{"content":data,"imgBase":_vm.imgBase,"imgUrl":_vm.imgUrl,"currentPage":_vm.currentPage,"docStatus":_vm.docStatus},on:{"focused":_vm.inputFocused,"dataUpdate":_vm.selectChanges}})],1):_vm._e(),_vm._v(" "),(data.data_type === 'name')?_c('div',[_c('processed-data-tree',{attrs:{"minConf":_vm.minConf,"maxConf":_vm.maxConf,"processedData":[data],"dataBus":_vm.dataBus,"imgBase":_vm.imgBase,"imgUrl":_vm.imgUrl,"processValueText":_vm.processValueText,"dataPresent":_vm.dataPresent,"currentPage":_vm.currentPage,"docStatus":_vm.docStatus}})],1):(data.data_type === 'table_column' || data.data_type === 'table_row')?_c('div',[_c('div',{staticClass:"text-center mt-3",attrs:{"slot":"header"},slot:"header"},[_c('strong',{on:{"click":function($event){_vm.inputFocused(data.path)}}},[_vm._v(_vm._s(_vm._f("capitalize")(data.key)))]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],staticClass:"show-table",attrs:{"variant":"secondary","title":_vm.$t('COMMON.SHOW_TABLE')},on:{"click":function($event){_vm.showTable(data.path)}}},[_c('i',{staticClass:"fa fa-table",attrs:{"aria-hidden":"true"}})])],1),_vm._v(" "),_c('br')]):_vm._e()]):_c('div',[(data.show_field)?_c('div',[(data.data_type === 'signature')?_c('div',[_c('b-form-group',[_c('b-row',[_c('b-col',{attrs:{"sm":"8"}},[_c('div',[_c('span',[_vm._v(_vm._s(_vm._f("capitalize")(data.key)))]),_vm._v(" "),(data.required)?_c('sup',{staticClass:"text-danger required-css"},[_c('i',{staticClass:"fa fa-asterisk"})]):_vm._e(),_vm._v(" "),(data.status == 'pending')?_c('span',{staticClass:"badge",staticStyle:{"backgroundColor":"rgb(195, 187, 187)"}},[_vm._v(_vm._s(_vm.$t('FORMS.PENDING')))]):(data.status == 'approved')?_c('span',{staticClass:"badge badge-success"},[_vm._v(_vm._s(_vm.$t('FORMS.APPROVED')))]):(data.status == 'rejected')?_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.$t('FORMS.REJECTED')))]):_vm._e(),_vm._v(" "),(data.chunk_edited)?_c('span',{staticClass:"badge badge-edited"},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t('FORMS.EDITED')))]):_vm._e()])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"4","align":"right"}},[_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('COMMON.APPROVE')}},[_c('a',{staticClass:"btn text-success signature-actions",class:{disabled: data.status === 'approved'},on:{"click":function($event){_vm.reviewField(data, 'approved')}}},[_c('i',{staticClass:"icon-check"})])]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('COMMON.REJECT')}},[_c('a',{staticClass:"btn text-danger signature-actions",class:{disabled: data.status === 'rejected'},on:{"click":function($event){_vm.reviewField(data, 'rejected')}}},[_c('i',{staticClass:"icon-close"})])]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('COMMON.RESIZE')}},[_c('a',{staticClass:"btn text-primary signature-actions",class:{disabled: data.show_actions},on:{"click":function($event){_vm.enableResize(data)}}},[_c('i',{staticClass:"icon-crop"})])])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b-img',{attrs:{"fluid":"","alt":"Signature Field","src":'data:image/png;base64,' + data.current_img_enc}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(data.show_actions),expression:"data.show_actions"}],staticClass:"text-right",attrs:{"lg":"12"}},[_c('a',{staticClass:"btn btn-sm text-primary signature-edit",on:{"click":function($event){_vm.saveResize(data)}}},[_vm._v(_vm._s(_vm.$t('COMMON.SAVE')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm text-secondary signature-edit",on:{"click":function($event){_vm.resetResize(data)}}},[_vm._v(_vm._s(_vm.$t('COMMON.RESET')))])])],1)],1)],1):(data.data_type === 'barcode')?_c('div',[_c('b-form-group',[_c('b-input-group',{attrs:{"id":data.path}},[_c('div',{staticClass:"input-group-prepend",on:{"click":function($event){_vm.inputFocused(data.path)}}},[_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(data.key))])]),_vm._v(" "),_c('b-form-input',{attrs:{"readonly":"","type":"text","state":"true"},nativeOn:{"focus":function($event){_vm.inputFocused(data.path)}},model:{value:(data.original_value),callback:function ($$v) {_vm.$set(data, "original_value", $$v)},expression:"data.original_value"}})],1)],1)],1):(data.data_type === 'dropdown')?_c('div',[_c('process-single-select',{attrs:{"content":data,"imgBase":_vm.imgBase,"imgUrl":_vm.imgUrl},on:{"focused":_vm.inputFocused,"dataUpdate":_vm.selectChanges}})],1):(data.data_type === 'checkbox')?_c('div',[_c('b-form-group',[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"basicCustomCheckboxes"}},[_c('div',{staticClass:"custom-control custom-checkbox",staticStyle:{"z-index":"auto"},attrs:{"id":'field_' + data.path},on:{"click":function($event){_vm.inputFocused(data.path)},"mouseover":function($event){_vm.inputFocused(data.path)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(data.current_value),expression:"data.current_value"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":data.key,"true-value":'true',"false-value":'false'},domProps:{"value":data.key,"checked":Array.isArray(data.current_value)?_vm._i(data.current_value,data.key)>-1:_vm._q(data.current_value,'true')},on:{"change":[function($event){var $$a=data.current_value,$$el=$event.target,$$c=$$el.checked?('true'):('false');if(Array.isArray($$a)){var $$v=data.key,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(data.current_value=$$a.concat([$$v]))}else{$$i>-1&&(data.current_value=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(data, "current_value", $$c)}},function($event){_vm.checkChanged(data)}]}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":data.key}},[_vm._v(_vm._s(_vm._f("capitalize")(data.key)))]),_vm._v(" "),(data.required)?_c('sup',{staticClass:"text-danger required-css"},[_c('i',{staticClass:"fa fa-asterisk"})]):_vm._e(),_vm._v(" "),(data.edited)?_c('span',{staticClass:"badge badge-edited"},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(" Edited")]):_vm._e()]),_vm._v(" "),(data.path.split('.')[0] === _vm.currentPage.toString())?_c('b-popover',{attrs:{"target":'field_' + data.path,"triggers":"hover","placement":"top","boundary":"window"}},[_c('div',{staticClass:"canvas-wrapper"},[_c('canvas',{attrs:{"id":'canvas_' + data.path}})])]):_vm._e()],1)],1)],1):_c('div',[(((data.confidence * 100 ) <= _vm.maxConf) && ((data.confidence * 100) >= _vm.minConf))?_c('div',[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[(_vm.groupLabel)?_c('span',[_vm._v(_vm._s(_vm.groupLabel))]):_c('span',[_vm._v(_vm._s(_vm._f("capitalize")(data.header ? data.header : data.key)))]),_vm._v(" "),(data.required)?_c('sup',{staticClass:"text-danger required-css"},[_c('i',{staticClass:"fa fa-asterisk"})]):_vm._e(),_vm._v(" "),(data.current_value)?_c('span',[(data.date_format)?_c('span',[_c('i',[_vm._v("("+_vm._s(data.date_format)+")")])]):_vm._e(),_vm._v(" "),(data.edited && !data.is_system_generated)?_c('span',{staticClass:"badge",style:({ color: '#FFFFFF', backgroundColor: '#170c9e' }),attrs:{"title":_vm.$t('FORMS.CON_SCORE')}},[_vm._v("100")]):_c('span',{staticClass:"badge",style:({ backgroundColor: data.color_code }),attrs:{"title":_vm.$t('FORMS.CON_SCORE')}},[_vm._v(_vm._s(Math.round(data.confidence * 100)))]),_vm._v(" "),(data.edited && data.is_system_generated)?_c('span',{staticClass:"badge",style:({ backgroundColor: data.color_code }),attrs:{"title":_vm.$t('FORMS.CON_SCORE')}}):_vm._e()]):_vm._e(),_vm._v(" "),(data.is_system_generated)?_c('span',{staticClass:"badge badge-edited"},[_vm._v("System Edited "),_c('i',{staticClass:"fa fa-exclamation",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(data.edited)?_c('span',{staticClass:"badge badge-edited"},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(" Edited")]):_vm._e(),_vm._v(" "),(data.is_auto_correct && _vm.autoCorrectFlag)?_c('span',{staticClass:"badge badge-auto-corrected"},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(" Auto-Corrected")]):(data.auto_correct_enable && _vm.autoCorrectFlag)?_c('span',{staticClass:"badge badge-auto_correct_enable"},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(" Auto-Correct-Enable")]):_vm._e()]),_vm._v(" "),(_vm.isInsCard)?_c('div',{attrs:{"id":"editLabel"}},[_c('i',{directives:[{name:"b-modal",rawName:"v-b-modal.changeLabel",modifiers:{"changeLabel":true}}],staticClass:"fa fa-pencil",on:{"click":function($event){_vm.setLabelValue(data)}}})]):_vm._e(),_vm._v(" "),_c('content-editable',{attrs:{"content":data,"imgBase":_vm.imgBase,"imgUrl":_vm.imgUrl,"currentPage":_vm.currentPage,"docStatus":_vm.docStatus},on:{"update":_vm.inputChanged,"focused":_vm.inputFocused}})],1)],1):_vm._e()])]):_vm._e()])]):_vm._e()])}))],1)],1):_c('div',[(sectionData)?_c('div',[(sectionData.children)?_c('div',[(sectionData.data_type === 'logical' || sectionData.data_type === 'npi')?_c('div',{attrs:{"id":'group_' + sectionData.path}},[_c('b-card',{attrs:{"no-body":""}},[_c('div',{staticClass:"text-center",attrs:{"slot":"header"},slot:"header"},[_c('strong',{on:{"click":function($event){_vm.inputFocused(sectionData.path)}}},[_vm._v(_vm._s(_vm._f("capitalize")(sectionData.key)))])]),_vm._v(" "),_c('b-popover',{attrs:{"target":'group_' + _vm.data.path,"triggers":"click","placement":"top","boundary":"window"}},[_c('div',{staticClass:"canvas-wrapper"},[_c('canvas',{attrs:{"id":'canvas_' + _vm.data.path}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('processed-data-tree',{attrs:{"minConf":_vm.minConf,"maxConf":_vm.maxConf,"processedData":sectionData.children,"dataBus":_vm.dataBus,"imgBase":_vm.imgBase,"imgUrl":_vm.imgUrl,"currentPage":_vm.currentPage,"docStatus":_vm.docStatus}})],1)],1):_vm._e(),_vm._v(" "),(sectionData.data_type === 'combine_data')?_c('div',[_c('processed-data-tree',{attrs:{"minConf":_vm.minConf,"maxConf":_vm.maxConf,"groupLabel":sectionData.key,"processedData":[sectionData],"dataBus":_vm.dataBus,"imgBase":_vm.imgBase,"imgUrl":_vm.imgUrl,"currentPage":_vm.currentPage,"docStatus":_vm.docStatus,"dataPresent":true}})],1):_vm._e(),_vm._v(" "),(sectionData.data_type === 'name')?_c('div',[_c('processed-data-tree',{attrs:{"minConf":_vm.minConf,"maxConf":_vm.maxConf,"processedData":[sectionData],"dataBus":_vm.dataBus,"imgBase":_vm.imgBase,"imgUrl":_vm.imgUrl,"processValueText":_vm.processValueText,"dataPresent":_vm.dataPresent,"currentPage":_vm.currentPage,"docStatus":_vm.docStatus}})],1):(sectionData.data_type === 'single_select')?_c('div',[_c('process-single-select-data',{attrs:{"content":sectionData,"imgBase":_vm.imgBase,"imgUrl":_vm.imgUrl,"currentPage":_vm.currentPage,"docStatus":_vm.docStatus},on:{"focused":_vm.inputFocused,"dataUpdate":_vm.selectChanges}})],1):(sectionData.data_type === 'multi_select')?_c('div',[_c('process-multi-select-data',{attrs:{"content":sectionData,"imgBase":_vm.imgBase,"imgUrl":_vm.imgUrl,"currentPage":_vm.currentPage,"docStatus":_vm.docStatus},on:{"focused":_vm.inputFocused,"dataUpdate":_vm.selectChanges}})],1):(sectionData.data_type === 'table_column' || sectionData.data_type === 'table_row')?_c('div',[_c('div',{staticClass:"text-center mt-3",attrs:{"slot":"header"},slot:"header"},[_c('strong',{on:{"click":function($event){_vm.inputFocused(sectionData.path)}}},[_vm._v(_vm._s(_vm._f("capitalize")(sectionData.key)))]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],staticClass:"show-table",attrs:{"variant":"secondary","title":_vm.$t('COMMON.SHOW_TABLE')},on:{"click":function($event){_vm.showTable(sectionData.path)}}},[_c('i',{staticClass:"fa fa-table",attrs:{"aria-hidden":"true"}})])],1),_vm._v(" "),_c('br')]):_vm._e()]):_c('div',[(sectionData.show_field)?_c('div',[(sectionData.data_type === 'signature')?_c('div',[_c('b-form-group',[_c('b-row',[_c('b-col',{attrs:{"sm":"8"}},[_c('div',[_c('span',[_vm._v(_vm._s(_vm._f("capitalize")(sectionData.key)))]),_vm._v(" "),(sectionData.required)?_c('sup',{staticClass:"text-danger required-css"},[_c('i',{staticClass:"fa fa-asterisk"})]):_vm._e(),_vm._v(" "),(sectionData.status == 'pending')?_c('span',{staticClass:"badge",staticStyle:{"backgroundColor":"rgb(195, 187, 187)"}},[_vm._v(_vm._s(_vm.$t('FORMS.PENDING')))]):(sectionData.status == 'approved')?_c('span',{staticClass:"badge badge-success"},[_vm._v(_vm._s(_vm.$t('FORMS.APPROVED')))]):(sectionData.status == 'rejected')?_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.$t('FORMS.REJECTED')))]):_vm._e(),_vm._v(" "),(sectionData.chunk_edited)?_c('span',{staticClass:"badge badge-edited"},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t('FORMS.EDITED')))]):_vm._e()])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"4","align":"right"}},[_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('COMMON.APPROVE')}},[_c('a',{staticClass:"btn text-success signature-actions",class:{disabled: sectionData.status === 'approved'},on:{"click":function($event){_vm.reviewField(sectionData, 'approved')}}},[_c('i',{staticClass:"icon-check"})])]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('COMMON.REJECT')}},[_c('a',{staticClass:"btn text-danger signature-actions",class:{disabled: sectionData.status === 'rejected'},on:{"click":function($event){_vm.reviewField(sectionData, 'rejected')}}},[_c('i',{staticClass:"icon-close"})])]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('COMMON.RESIZE')}},[_c('a',{staticClass:"btn text-primary signature-actions",class:{disabled: sectionData.show_actions},on:{"click":function($event){_vm.enableResize(sectionData)}}},[_c('i',{staticClass:"icon-crop"})])])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b-img',{attrs:{"fluid":"","alt":"Signature Field","src":'data:image/png;base64,' + sectionData.current_img_enc}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(sectionData.show_actions),expression:"sectionData.show_actions"}],staticClass:"text-right",attrs:{"lg":"12"}},[_c('a',{staticClass:"btn btn-sm text-primary signature-edit",on:{"click":function($event){_vm.saveResize(sectionData)}}},[_vm._v(_vm._s(_vm.$t('COMMON.SAVE')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm text-secondary signature-edit",on:{"click":function($event){_vm.resetResize(sectionData)}}},[_vm._v(_vm._s(_vm.$t('COMMON.RESET')))])])],1)],1)],1):(sectionData.data_type === 'barcode')?_c('div',[_c('b-form-group',[_c('b-input-group',{attrs:{"id":sectionData.path}},[_c('div',{staticClass:"input-group-prepend",on:{"click":function($event){_vm.inputFocused(sectionData.path)}}},[_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(sectionData.key))])]),_vm._v(" "),_c('b-form-input',{attrs:{"readonly":"","type":"text","state":"true"},nativeOn:{"focus":function($event){_vm.inputFocused(sectionData.path)}},model:{value:(sectionData.original_value),callback:function ($$v) {_vm.$set(sectionData, "original_value", $$v)},expression:"sectionData.original_value"}})],1)],1)],1):(sectionData.data_type === 'checkbox')?_c('div',[_c('b-form-group',[_c('b-form-checkbox-group',{attrs:{"stacked":"","id":"basicCustomCheckboxes"}},[_c('div',{staticClass:"custom-control custom-checkbox",staticStyle:{"z-index":"auto"},attrs:{"id":'field_' + sectionData.path},on:{"click":function($event){_vm.inputFocused(sectionData.path)},"mouseover":function($event){_vm.inputFocused(sectionData.path)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(sectionData.current_value),expression:"sectionData.current_value"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":sectionData.key,"true-value":'true',"false-value":'false'},domProps:{"value":sectionData.key,"checked":Array.isArray(sectionData.current_value)?_vm._i(sectionData.current_value,sectionData.key)>-1:_vm._q(sectionData.current_value,'true')},on:{"change":[function($event){var $$a=sectionData.current_value,$$el=$event.target,$$c=$$el.checked?('true'):('false');if(Array.isArray($$a)){var $$v=sectionData.key,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(sectionData.current_value=$$a.concat([$$v]))}else{$$i>-1&&(sectionData.current_value=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(sectionData, "current_value", $$c)}},function($event){_vm.checkChanged(sectionData)}]}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":sectionData.key}},[_vm._v(_vm._s(_vm._f("capitalize")(sectionData.key)))]),_vm._v(" "),(sectionData.required)?_c('sup',{staticClass:"text-danger required-css"},[_c('i',{staticClass:"fa fa-asterisk"})]):_vm._e(),_vm._v(" "),(sectionData.edited)?_c('span',{staticClass:"badge badge-edited"},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(" Edited")]):_vm._e()])])],1)],1):_c('div',[(((sectionData.confidence * 100 ) <= _vm.maxConf) && ((sectionData.confidence * 100) >= _vm.minConf))?_c('div',[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[(_vm.groupLabel)?_c('span',[_vm._v(_vm._s(_vm.groupLabel))]):_c('span',[_vm._v(_vm._s(_vm._f("capitalize")(sectionData.header ? sectionData.header : sectionData.key)))]),_vm._v(" "),(sectionData.required)?_c('sup',{staticClass:"text-danger required-css"},[_c('i',{staticClass:"fa fa-asterisk"})]):_vm._e(),_vm._v(" "),(sectionData.current_value)?_c('span',[(sectionData.date_format)?_c('span',[_c('i',[_vm._v("("+_vm._s(sectionData.date_format)+")")])]):_vm._e(),_vm._v(" "),(sectionData.edited && !sectionData.is_system_generated)?_c('span',{staticClass:"badge",style:({ color: '#FFFFFF', backgroundColor: '#170c9e' }),attrs:{"title":_vm.$t('FORMS.CON_SCORE')}},[_vm._v("100")]):_c('span',{staticClass:"badge",style:({ backgroundColor: sectionData.color_code }),attrs:{"title":_vm.$t('FORMS.CON_SCORE')}},[_vm._v(_vm._s(Math.round(sectionData.confidence * 100)))]),_vm._v(" "),(sectionData.edited && sectionData.is_system_generated)?_c('span',{staticClass:"badge",style:({ color: '#FFFFFF', backgroundColor: '#170c9e' }),attrs:{"title":_vm.$t('FORMS.CON_SCORE')}}):_vm._e()]):_vm._e(),_vm._v(" "),(sectionData.is_system_generated)?_c('span',{staticClass:"badge badge-edited"},[_vm._v("System edited "),_c('i',{staticClass:"fa fa-exclamation",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(sectionData.edited)?_c('span',{staticClass:"badge badge-edited"},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(" Edited")]):_vm._e(),_vm._v(" "),(sectionData.is_auto_correct && _vm.autoCorrectFlag)?_c('span',{staticClass:"badge badge-auto-corrected"},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(" Auto-Corrected")]):(sectionData.auto_correct_enable && _vm.autoCorrectFlag)?_c('span',{staticClass:"badge badge-auto_correct_enable"},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(" Auto-Correct-Enable")]):_vm._e()]),_vm._v(" "),(_vm.isInsCard)?_c('div',{attrs:{"id":"editLabel"}},[_c('i',{directives:[{name:"b-modal",rawName:"v-b-modal.changeLabel",modifiers:{"changeLabel":true}}],staticClass:"fa fa-pencil",on:{"click":function($event){_vm.setLabelValue(sectionData)}}})]):_vm._e(),_vm._v(" "),_c('content-editable',{attrs:{"content":sectionData,"imgBase":_vm.imgBase,"imgUrl":_vm.imgUrl,"currentPage":_vm.currentPage,"docStatus":_vm.docStatus},on:{"update":_vm.inputChanged,"focused":_vm.inputFocused}})],1)],1):_vm._e()])]):_vm._e()])]):_vm._e()])])})):_vm._e()])}),_vm._v(" "),_c('b-modal',{ref:"changeLabelModal",attrs:{"id":"changeLabel","title":_vm.$t('FORMS.CHANGE_LABEL'),"hide-header-close":"","centered":""}},[_c('b-card',{staticClass:"mb-0"},[_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label":_vm.$t('FORMS.LABEL_NAME'),"label-for":"labelName"}},[_c('b-form-input',{class:{'is-invalid': _vm.$v.newLabelName.$invalid, 'is-valid': !_vm.$v.newLabelName.$invalid},attrs:{"id":"labelName","type":"text","placeholder":_vm.selectedLabel.key},model:{value:(_vm.newLabelName),callback:function ($$v) {_vm.newLabelName=$$v},expression:"newLabelName"}},[_vm._v("\n              @blur=\"$v.newLabelName.$touch()\"\n            ")]),_vm._v(" "),(!_vm.$v.newLabelName.required)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('FORMS.REQ_LABEL')))]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"secondary","disabled":!_vm.$v.newLabelName.required},on:{"click":_vm.changeName}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CHANGE'))+" ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":_vm.hideChangeModal}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CANCEL'))+" ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"fieldDeleteModal",staticClass:"modal-danger",attrs:{"title":_vm.$t('COMMON.DELETE_CONFIRM'),"ok-title":_vm.$t('COMMON.YES'),"cancel-title":_vm.$t('COMMON.NO'),"ok-variant":"danger"},on:{"ok":_vm.deleteField}},[_vm._v("\n    "+_vm._s(_vm.$t('FORMS.DELETE_CONTENT', {'FIELD_NAME': _vm.selectedFieldKey}))+"\n    Do you want to delete "),_c('strong',[_vm._v(" "+_vm._s(_vm.selectedFieldKey)+" ")]),_vm._v(" field?\n  ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  data: function data() {
    return {
      apiValidationFields: [],
      optionalErrorMessages: [],
      exportFormFlag: false,
      errorMessages: [],
      serviceValidationFields: [],
      serviceValidationError: [],
      validateUpdateErrorMessages: [],
      requiredFieldsError: [],
      pathArray: [],
      updateChanges: [],
      validationFields: ['city', 'cod', 'date', 'email', 'fax', 'npi', 'phone', 'state', 'zip'],
      requiredFields: [null, 'alphanumeric', 'checkbox', 'city', 'cod', 'date', 'email', 'fax', 'npi', 'numeric', 'phone', 'signature', 'state', 'text', 'zip', 'alphanumeric_with_space', 'numeric_with_decimal', 'alpha'],
      requiredGroups: ['multi_select', 'single_select'],
      customFields: ['Patient Home Monitor'],
      logicalGroups: ['npi'],
      resParams: false
    };
  },

  methods: {
    validateForm: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(formId) {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', new Promise(function (resolve, reject) {
                  _this.processedDataLoaded = false;
                  _this.resetValidation();
                  _this.getValidationFields(_this.processData);
                  if (_this.apiValidationFields.length === 0) {
                    _this.resetTransformersAndShapes('red');
                    _this.saveData(true);
                    _this.logFormUpdates(formId);
                    _this.exportFormFlag = true;
                    resolve(true);
                  }

                  if (_this.apiValidationFields.length) {
                    var apiData = new window.FormData();
                    apiData.append('validation_fields', JSON.stringify(_this.apiValidationFields));
                    apiData.append('service_validation_fields', JSON.stringify(_this.serviceValidationFields));
                    _vue2.default.axios.post('/forms/validate_form', apiData, { headers: { Authorization: 'Bearer ' + _this.idToken }, params: { id: formId } }).then(function (response) {
                      if (response.data.message) {
                        _vue2.default.toasted.show(response.data.message, { icon: 'chain-broken', type: 'error' });
                        _this.$router.push('/process/processed');
                      } else {
                        _this.exportFormFlag = true;
                        var isVaild = response.data.status.valid && response.data.service_validation_response.validated && response.data.required_fields_response.validated;
                        if (isVaild && response.data.optional_validation.validation_error.length === 0) {
                          _this.resetTransformersAndShapes('red');
                        } else if (isVaild && response.data.optional_validation.validation_error.length > 0) {
                          _this.showAlertMsg(response.data);
                        } else {
                          _this.exportFormFlag = false;
                          _this.showAlertMsg(response.data);
                          resolve(false);
                        }
                        _this.resParams = response.data.valid;
                        _this.saveData(response.data.valid);
                        _this.logFormUpdates(formId);
                        _this.apiValidationFields = [];
                        _this.serviceValidationFields = [];
                      }
                    }, function (error) {
                      _this.apiValidationFields = [];
                      _this.serviceValidationFields = [];
                      _this.processedDataLoaded = true;
                      console.log(error);
                    });
                  }
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function validateForm(_x) {
        return _ref.apply(this, arguments);
      }

      return validateForm;
    }(),

    logsUpdateWithSection: function logsUpdateWithSection(pv, pvIndex, eachFormIndex, spareFormData, sectionIndex) {
      var _this2 = this;

      if (pv.children) {
        if (pv.data_type === 'multi_select' || pv.data_type === 'single_select') {
          var newData = pv.children.filter(function (child) {
            return child.current_value === 'true';
          }).map(function (ele) {
            return ele.key;
          }).join(',').trim();
          var oldData = spareFormData[eachFormIndex].children[sectionIndex].children[pvIndex].children.filter(function (child) {
            return child.current_value === 'true';
          }).map(function (ele) {
            return ele.key;
          }).join(',').trim();
          if (newData !== oldData) {
            this.updateChanges.push({
              key: pv.key,
              data_type: pv.data_type,
              value_before: pv.sensitive_data ? oldData.replace(/./g, '*') : oldData,
              value_after: pv.sensitive_data ? newData.replace(/./g, '*') : newData
            });
          }
        } else if (pv.data_type === 'name') {
          var _oldData = spareFormData[eachFormIndex].children[sectionIndex].children[pvIndex];
          pv.children.forEach(function (pvc, pvcIndex) {
            if (pvc.current_value !== _oldData.children[pvcIndex].current_value) {
              var originalConfidenceScore = parseFloat((_oldData.children[pvcIndex].confidence * 100).toFixed(2));
              _this2.updateChanges.push({
                key: pvc.key,
                data_type: pv.data_type,
                value_before: pvc.sensitive_data ? _oldData.children[pvcIndex].current_value.replace(/./g, '*') : _oldData.children[pvcIndex].current_value,
                value_after: pvc.sensitive_data ? pvc.current_value.replace(/./g, '*') : pvc.current_value,
                original_confidence_score: originalConfidenceScore,
                modified_confidence_score: 100
              });
            }
          });
        }
      } else if (pv.data_type === 'signature') {
        if (pv.status !== spareFormData[eachFormIndex].children[sectionIndex].children[pvIndex].status) {
          var _oldData2 = spareFormData[eachFormIndex].children[sectionIndex].children[pvIndex];
          this.updateChanges.push({
            key: pv.key,
            data_type: pv.data_type,
            value_before: pv.sensitive_data ? _oldData2.status.replace(/./g, '*') : _oldData2.status,
            value_after: pv.sensitive_data ? pv.status.replace(/./g, '*') : pv.status
          });
        }
      } else {
        var _oldData3 = spareFormData[eachFormIndex].children[sectionIndex].children[pvIndex];
        var originalConfidenceScore = parseFloat((_oldData3.confidence * 100).toFixed(2));
        if (pv.current_value !== _oldData3.current_value) {
          this.updateChanges.push({
            key: pv.key,
            data_type: pv.data_type,
            value_before: pv.sensitive_data ? _oldData3.current_value.replace(/./g, '*') : _oldData3.current_value,
            value_after: pv.sensitive_data ? pv.current_value.replace(/./g, '*') : pv.current_value,
            original_confidence_score: pv.data_type === 'checkbox' ? '' : originalConfidenceScore,
            modified_confidence_score: pv.data_type === 'checkbox' ? '' : 100
          });
        }
      }
    },
    logsUpdateWithoutSection: function logsUpdateWithoutSection(pv, pvIndex, eachFormIndex, spareFormData) {
      var _this3 = this;

      if (pv.children) {
        if (pv.data_type === 'multi_select' || pv.data_type === 'single_select') {
          var newData = pv.children.filter(function (child) {
            return child.current_value === 'true';
          }).map(function (ele) {
            return ele.key;
          }).join(',').trim();
          var oldData = spareFormData[eachFormIndex].children[pvIndex].children.filter(function (child) {
            return child.current_value === 'true';
          }).map(function (ele) {
            return ele.key;
          }).join(',').trim();
          if (newData !== oldData) {
            this.updateChanges.push({
              key: pv.key,
              data_type: pv.data_type,
              value_before: pv.sensitive_data ? oldData.replace(/./g, '*') : oldData,
              value_after: pv.sensitive_data ? newData.replace(/./g, '*') : newData
            });
          }
        } else if (pv.data_type === 'name') {
          var _oldData4 = spareFormData[eachFormIndex].children[pvIndex];
          pv.children.forEach(function (pvc, pvcIndex) {
            if (pvc.current_value !== _oldData4.children[pvcIndex].current_value) {
              _this3.updateChanges.push({
                key: pvc.key,
                data_type: pv.data_type,
                value_before: pvc.sensitive_data ? _oldData4.children[pvcIndex].current_value.replace(/./g, '*') : _oldData4.children[pvcIndex].current_value,
                value_after: pvc.sensitive_data ? pvc.current_value.replace(/./g, '*') : pvc.current_value,
                original_confidence_score: _oldData4.children[pvcIndex].confidence ? _oldData4.children[pvcIndex].confidence * 100 : '',
                modified_confidence_score: 100
              });
            }
          });
        }
      } else if (pv.data_type === 'signature') {
        var _oldData5 = spareFormData[eachFormIndex].children[pvIndex];
        if (pv.status !== _oldData5.status) {
          this.updateChanges.push({
            key: pv.key,
            data_type: pv.data_type,
            value_before: pv.sensitive_data ? _oldData5.status.replace(/./g, '*') : _oldData5.status,
            value_after: pv.sensitive_data ? pv.status.replace(/./g, '*') : pv.status
          });
        }
      } else {
        var _oldData6 = spareFormData[eachFormIndex].children[pvIndex];
        if (pv.current_value !== _oldData6.current_value) {
          this.updateChanges.push({
            key: pv.key,
            data_type: pv.data_type,
            value_before: pv.sensitive_data ? _oldData6.current_value.replace(/./g, '*') : _oldData6.current_value,
            value_after: pv.sensitive_data ? pv.current_value.replace(/./g, '*') : pv.current_value,
            original_confidence_score: _oldData6.confidence ? _oldData6.confidence * 100 : '',
            modified_confidence_score: 100
          });
        }
      }
    },
    getUpdateLogs: function getUpdateLogs(formData) {
      var _this4 = this;

      this.updateChanges = [];
      var spareFormData = this.spareFormData.processed_tree_data;
      formData.forEach(function (eachForm, eachFormIndex) {
        if (eachForm && eachForm.children) {
          eachForm.children.forEach(function (sectionData, sectionIndex) {
            if (sectionData.data_type === 'section') {
              sectionData.children.forEach(function (pv, pvIndex) {
                _this4.logsUpdateWithSection(pv, pvIndex, eachFormIndex, spareFormData, sectionIndex);
              });
            } else {
              _this4.logsUpdateWithoutSection(sectionData, sectionIndex, eachFormIndex, spareFormData);
            }
          });
        }
      });
      return this.updateChanges;
    },
    logFormUpdates: function logFormUpdates(formId) {
      var _this5 = this;

      var jsonResult = this.getUpdateLogs(this.formData.processed_tree_data);
      var formDocId = this.formData.form_doc_id;
      var params = {
        formId: formId,
        formDocId: formDocId
      };
      if (jsonResult.length) {
        _vue2.default.axios.post('/form_update_logs', { jsonResult: jsonResult }, { headers: { Authorization: 'Bearer ' + this.idToken }, params: params }).then(function (response) {
          _this5.spareFormData = JSON.parse(JSON.stringify(_this5.formData));
        }, function (error) {
          console.log(error);
          _this5.spareFormData = JSON.parse(JSON.stringify(_this5.formData));
        });
      }
    },
    getNonGroupVaidationFields: function getNonGroupVaidationFields(fieldKey, childData) {
      var vm = this;
      if (childData.required) {
        vm.serviceValidationFields.push(childData);
        if (vm.requiredFields.includes(fieldKey)) {
          childData.current_value = childData.current_value.trim();
          vm.apiValidationFields.push(childData);
        }
      } else {
        vm.serviceValidationFields.push(childData);
        if (vm.validationFields.includes(fieldKey)) {
          childData.current_value = childData.current_value.trim();
          vm.apiValidationFields.push(childData);
        }
      }
      if (childData.children && childData.children.length) {
        vm.getValidationFields(childData.children);
      }
    },
    getValidationFields: function getValidationFields(parentData) {
      var vm = this;
      parentData.forEach(function (data) {
        if (data && data.children && Symbol.iterator in Object(data.children)) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = data.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var sectionData = _step.value;

              if (sectionData.data_type === 'section') {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                  for (var _iterator2 = sectionData.children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var childData = _step2.value;

                    var fieldKey = childData.data_type;
                    if (vm.logicalGroups.includes(fieldKey)) {
                      childData.current_value = childData.current_value.trim();
                      vm.apiValidationFields.push(childData);
                      vm.serviceValidationFields.push(childData);
                    } else if (vm.requiredGroups.includes(fieldKey)) {
                      vm.apiValidationFields.push(childData);
                      vm.serviceValidationFields.push(childData);
                    } else {
                      vm.getNonGroupVaidationFields(fieldKey, childData);
                    }
                  }
                } catch (err) {
                  _didIteratorError2 = true;
                  _iteratorError2 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                      _iterator2.return();
                    }
                  } finally {
                    if (_didIteratorError2) {
                      throw _iteratorError2;
                    }
                  }
                }
              } else {
                var _fieldKey = sectionData.data_type;
                if (vm.logicalGroups.includes(_fieldKey)) {
                  sectionData.current_value = sectionData.current_value.trim();
                  vm.apiValidationFields.push(sectionData);
                  vm.serviceValidationFields.push(sectionData);
                } else if (vm.requiredGroups.includes(_fieldKey)) {
                  vm.apiValidationFields.push(sectionData);
                  vm.serviceValidationFields.push(sectionData);
                } else {
                  vm.getNonGroupVaidationFields(_fieldKey, sectionData);
                }
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      });
    },


    showAlertMsg: function showAlertMsg(errorMsg) {
      this.validateUpdateErrorMessages = errorMsg.status.errors;
      this.serviceValidationError = errorMsg.service_validation_response.validation_error;
      this.requiredFieldsError = errorMsg.required_fields_response.validation_error;
      this.optionalErrorMessages = errorMsg.optional_validation.validation_error;
      this.pathArray = [].concat(_toConsumableArray(this.validateUpdateErrorMessages.flatMap(function (shape) {
        return shape.path;
      })), _toConsumableArray(this.serviceValidationError.flatMap(function (shape) {
        return shape.path;
      })), _toConsumableArray(this.requiredFieldsError.flatMap(function (shape) {
        return shape.path;
      })));
      this.highlightShapeError();
      this.highlightValidationFields(this.processData, false);
      this.$refs.fieldInvalidModal.show();
      this.processedDataLoaded = true;
    },
    resetValidation: function resetValidation() {
      this.apiValidationFields = [];
      this.serviceValidationFields = [];
      this.errorMessages = [];
      this.pathArray = [];
      this.highlightValidationFields(this.processData, true);
    },
    highlightShapeError: function highlightShapeError() {
      var vm = this;
      vm.resetTransformersAndShapes('red');
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.pathArray[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var path = _step3.value;

          var shape = this.baseLayer.find('#' + path);
          shape.setAttrs({
            name: 'selected',
            stroke: 1,
            fill: 'red',
            opacity: 0.2
          });
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      vm.baseLayer.draw();
    },
    highlightValidationFields: function highlightValidationFields(parentData, reset) {
      var vm = this;
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = parentData[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var childData = _step4.value;

          vm.updateValidationState(childData, reset);
          if (childData.children && childData.children.length) {
            vm.highlightValidationFields(childData.children, reset);
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    },
    updateValidationState: function updateValidationState(childData, reset) {
      if (reset) {
        if ((typeof childData === 'undefined' ? 'undefined' : _typeof(childData)) === 'object') {
          childData.invalid = null;
        }
      } else {
        if ((typeof childData === 'undefined' ? 'undefined' : _typeof(childData)) === 'object' && this.pathArray.includes(childData.path)) {
          childData.invalid = true;
        }
      }
    },
    checkSignatureStatus: function checkSignatureStatus(isSignatureValidated, children) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = children[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var childData = _step5.value;

          if (childData.data_type === 'signature') {
            if (childData.status === 'pending') {
              isSignatureValidated = false;
            }
          } else if (childData.map_type === 'group') {
            isSignatureValidated = this.checkSignatureStatus(isSignatureValidated, childData.children);
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return isSignatureValidated;
    },
    validateSignature: function validateSignature() {
      var isSignatureValidated = true;
      if (this.formData.template_id !== '-7') {
        isSignatureValidated = this.checkSignatureStatus(isSignatureValidated, this.processData.children);
      }
      return isSignatureValidated;
    }
  }
};

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"heading"},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"sm":"2"}},[(_vm.next_form_id)?_c('router-link',{attrs:{"to":{ name: 'Verification', params: {id: _vm.next_form_id }}}},[_c('b-button',{attrs:{"variant":"secondary"}},[_vm._v("\n                  "+_vm._s(_vm.$t('FORMS.NEXT_FORM'))+"\n                ")])],1):_vm._e()],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-row',{attrs:{"align-v":"center","align-h":"center"}},[_c('b-col',{attrs:{"sm":"6"}},[_c('h3',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.d100.topleft",modifiers:{"hover":true,"d100":true,"topleft":true}}],staticClass:"ellipsis",attrs:{"title":this.formData.title}},[_vm._v(_vm._s(_vm.$t('COMMON.FORM'))+": "+_vm._s(_vm.formData.title))])]),_vm._v(" "),_c('b-col',[_c('div',{staticClass:"paginate-page float-left"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Go to previous page","variant":'link',"disabled":_vm.canGoToPrev},on:{"click":function($event){_vm.saveAndGoToPage(_vm.prevPage)}}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-arrow-left"})]),_vm._v(" "),_c('span',[_c('span',{staticClass:"h4"},[_vm._v(_vm._s(_vm.getCurrentPage))]),_vm._v(" "+_vm._s(_vm.$t('COMMON.OF'))+" "+_vm._s(_vm.totalPages))]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Go to next page","variant":'link',"disabled":_vm.canGoToNext},on:{"click":function($event){_vm.saveAndGoToPage(_vm.nextPage)}}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-arrow-right"})])],1)])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[(_vm.prev_form_id)?_c('router-link',{attrs:{"to":{ name: 'Verification', params: {id: _vm.prev_form_id }}}},[_c('b-button',{staticClass:"float-right",attrs:{"variant":"secondary"}},[_vm._v("\n                  "+_vm._s(_vm.$t('FORMS.PREV_FORM'))+"\n                ")])],1):_vm._e()],1)],1)],1)])],1),_vm._v(" "),(_vm.processedDataLoaded && _vm.formData.template_id === '-7')?_c('b-card',[_c('div',{staticClass:"p-2"},[_c('strong',[_vm._v(_vm._s(_vm.$t('FORMS.PROCESSED_DATA') + ':'))]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('b-button',{staticClass:"ml-1 mr-1",attrs:{"variant":"primary","size":"sm","disabled":(_vm.updatedPEVIds.length === 0) || (!_vm.checkauth)},on:{"click":function($event){_vm.saveData(true)}}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('COMMON.SAVE'))+"\n          ")]),_vm._v(" "),(this.docStatus !== 'unmatched'&&_vm.checkauth && Object.keys(this.allPageIdMap).length > 1)?_c('b-button',{attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.acceptFormDoc()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.processDone)+" All ")])]):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"ml-1 mr-1",attrs:{"variant":"success","size":"sm","disabled":this.docStatus === 'unmatched'&&!_vm.checkauth},on:{"click":_vm.acceptForm}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "+_vm._s(_vm.processDone)+"\n          ")])],1)]),_vm._v(" "),(_vm.tableHeaders.length > 0)?_c('div',{staticClass:"excel-workbook"},[(_vm.formData.processed_tree_data.headers)?_c('table',{staticClass:"stick-table"},[_c('thead',_vm._l((_vm.tableHeaders),function(header,index){return _c('th',{key:index},[_vm._v(_vm._s(header))])})),_vm._v(" "),_c('tbody',_vm._l((_vm.updatedPEVs),function(entry,pev_id){return _c('tr',{key:pev_id},_vm._l((_vm.tableHeaders),function(header,index){return _c('td',{key:index},[(_vm.editedPEV(pev_id, header))?_c('span',[_c('input',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"table-input table-input-edited",attrs:{"title":'Original Value: ' + _vm.originalPEVs[pev_id][header]},domProps:{"value":entry[header]},on:{"change":function($event){_vm.updateExcelData($event, pev_id, header)}}})]):_c('span',[_c('input',{staticClass:"table-input",domProps:{"value":entry[header]},on:{"change":function($event){_vm.updateExcelData($event, pev_id, header)}}})])])}))}))]):_vm._e()]):_c('div',{staticClass:"no-excel-data"},[_vm._v("\n        "+_vm._s(_vm.$t('FORMS.NO_LINE_ITEMS'))+"\n      ")])]):_c('b-card',{staticClass:"p-4"},[_c('b-row',[_c('b-col',{attrs:{"lg":"4"}},[_c('b-card',{staticClass:"process-data p-2"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.$t('FORMS.PROCESSED_DATA')))]),_vm._v(" "),(_vm.processedDataLoaded)?_c('div',{staticClass:"float-right"},[(_vm.shouldShowSignInvoice && _vm.checkauth)?_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.showSignInvoice()}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('INVOICE.SIGN'))+" ")])]):_vm._e(),_vm._v(" "),(_vm.shouldShowApproveInvoice && _vm.checkauth)?_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.showSignInvoice()}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('INVOICE.APPROVE'))+" ")])]):_vm._e(),_vm._v(" "),(_vm.hideExpandCollapse)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Expand All Sections","size":"sm","variant":"primary"},on:{"click":_vm.expandAllSections}},[_c('span',[_c('i',{staticClass:"fa fa-expand",attrs:{"aria-hidden":"true"}})])]):_vm._e(),_vm._v(" "),(_vm.hideExpandCollapse)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Collapse All Sections","size":"sm","variant":"primary"},on:{"click":_vm.collapseAllSections}},[_c('span',[_c('i',{staticClass:"fa fa-compress",attrs:{"aria-hidden":"true"}})])]):_vm._e(),_vm._v(" "),_c('b-button',{attrs:{"size":"sm","variant":"danger"},on:{"click":_vm.showRejectFormModal}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(" Reject ")])]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm","variant":"success","disabled":!this.exportFormFlag},on:{"click":function($event){_vm.exportSalesforce()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.processDone)+" ")])])],1):_vm._e(),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.processValueText),expression:"processValueText"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('FORMS.SERACH_PLACEHOLDER')},domProps:{"value":(_vm.processValueText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.processValueText=$event.target.value}}})]),_vm._v(" "),(_vm.processedDataLoaded && this.formData.is_ins_card)?_c('div',{staticClass:"float-right add-field-btn"},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.newField",modifiers:{"newField":true}}],attrs:{"type":"submit","size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('FORMS.ADD_FIELD'))+" ")])])],1):_vm._e()]),_vm._v(" "),(_vm.formData.form_doc_status === 'unmatched' && !this.processData.children > 0 && _vm.showAddDataButton)?_c('div',{staticClass:"d-flex justify-content-center mt-3"},[_c('b-button',{on:{"click":_vm.manualData}},[_vm._v("Add Data Manually")])],1):_vm._e(),_vm._v(" "),(_vm.processedDataLoaded)?_c('div',{staticClass:"range-slider"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.minConf),expression:"minConf"}],attrs:{"min":"0","max":"100","step":"1","type":"range"},domProps:{"value":(_vm.minConf)},on:{"change":_vm.slider,"__r":function($event){_vm.minConf=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxConf),expression:"maxConf"}],attrs:{"min":"0","max":"100","step":"1","type":"range"},domProps:{"value":(_vm.maxConf)},on:{"change":_vm.slider,"__r":function($event){_vm.maxConf=$event.target.value}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('FORMS.CONF_RANGE'))+" : "+_vm._s(_vm.minConf)+" - "+_vm._s(_vm.maxConf))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"scrollable-content",style:({ maxHeight: this.scrollHeight + 'px' }),on:{"&scroll":function($event){_vm.handleScroll($event)}}},[(!_vm.processedDataLoaded)?_c('content-placeholders',[_c('content-placeholders-text',{attrs:{"lines":29}})],1):_c('processed-data-tree',{attrs:{"min-conf":this.minConf,"max-conf":this.maxConf,"processedData":this.processData,"autoCorrectFlag":this.formData.template_auto_correct_flag,"dataBus":this.dataBus,"isInsCard":this.formData.is_ins_card,"imgBase":this.imgBase,"imgUrl":this.formData.image_url,"dataPresent":this.dataPresent,"currentPage":this.getCurrentPage,"docStatus":this.docStatus}})],1),_vm._v(" "),(_vm.appMode === 'service')?_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-row',[_c('b-button',{staticClass:"col-1 m-1 pull-left service-btn",attrs:{"size":"sm","variant":"secondary","disabled":_vm.canGoToPrev},on:{"click":function($event){_vm.saveAndGoToPage(_vm.prevPage)}}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-angle-double-left",attrs:{"title":"Prev Page"}})]),_vm._v(" "),_c('b-button',{staticClass:"col-8 m-1 pull-left service-btn",attrs:{"type":"submit","size":"sm","variant":"primary","disabled":!_vm.checkauth},on:{"click":function($event){_vm.validateForm(_vm.id)}}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.VALIDATE_UPDATE'))+" ")]),_vm._v(" "),_c('b-button',{staticClass:"col-1 m-1 pull-left service-btn",attrs:{"size":"sm","variant":"secondary","disabled":_vm.canGoToNext},on:{"click":function($event){_vm.saveAndGoToPage(_vm.nextPage)}}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-angle-double-right",attrs:{"title":"Next Page"}})])],1),_vm._v(" "),_c('b-row',[(_vm.canGoToNext)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"col-6 offset-2 mt-1 service-btn",attrs:{"size":"sm","variant":"secondary","title":_vm.$t('COMMON.SAVE'),"disabled":!_vm.checkauth},on:{"click":_vm.validateToExport}},[_vm._v(_vm._s(_vm.$t('COMMON.SAVE')))]):_vm._e()],1)],1):_c('div',{attrs:{"slot":"footer","align":"center"},slot:"footer"},[_c('b-button',{staticClass:"px-5 save-btn",attrs:{"type":"submit","size":"sm","variant":"primary"},on:{"click":function($event){_vm.validateForm(_vm.id)}}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.VALIDATE_UPDATE'))+" ")])],1)])],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"8"}},[(!_vm.editorDataLoaded)?_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.$t('COMMON.FORM'))+":")])]),_vm._v(" "),_c('content-placeholders',[_c('content-placeholders-img',{staticStyle:{"height":"765px"}})],1)],1):_c('b-card',{staticClass:"canvas-card mb-3"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"d-flex justify-content-between "},[_c('div',{staticStyle:{"padding":"10px"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('FORMS.AVG_CONF'))+" : "),_c('b-badge',{attrs:{"variant":_vm.confidenceVariant}},[_vm._v(_vm._s(_vm.avgConfidenceScore))])],1)]),_vm._v(" "),_c('b-row',[_c('strong',{staticClass:"mr-1",staticStyle:{"margin-top":"11px"}},[_vm._v(_vm._s(_vm.$t('FORMS.SELECT_PAGE_NUM'))+" ")]),_vm._v(" "),_c('b-form-select',{staticClass:"page_numbers",staticStyle:{"width":"75px"},attrs:{"plain":true,"options":_vm.dataPages},model:{value:(_vm.selectedPageNum),callback:function ($$v) {_vm.selectedPageNum=$$v},expression:"selectedPageNum"}})],1),_vm._v(" "),_c('div',{staticClass:"paginate-page"},[(this.formData.export_error)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"variant":"danger","title":_vm.$t('FORMS.EXPORT_ERROR')},on:{"click":_vm.showExportError}},[_c('i',{staticClass:"fa fa-exclamation-triangle",attrs:{"id":"exportError"}})]):_vm._e(),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){!_vm.toShowOriginalImage ? _vm.showOriginalImage(0) : _vm.showOriginalImage(1)}}},[_c('span',[_vm._v(_vm._s(!_vm.toShowOriginalImage ? 'Show Original Doc' : 'Revert Back'))])]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.hideUnhideScreen}},[_c('span',[_vm._v(_vm._s(_vm.ishideUnhideClicked ? 'Unhide' : 'Hide'))])]),_vm._v(" "),_c('b-button',{attrs:{"variant":"secondary"},on:{"click":_vm.showCompareModal}},[_c('div',{staticClass:"compare-icon",domProps:{"innerHTML":_vm._s(_vm.svg.clone)}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('FORMS.COMP_IMAGES')))])]),_vm._v(" "),(_vm.formData.template_id > 0 && _vm.appMode === 'default')?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"variant":"primary","size":"md","title":_vm.$t('FORMS.MATCHING_TEMPLATE')},on:{"click":_vm.redirectToMatchedTemplate}},[_c('i',{staticClass:"fa fa-file-text-o",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.$store.state.role == 'admin')?_c('b-button',{attrs:{"size":"md"},on:{"click":function($event){_vm.showUpdateLogs(1)}}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-table",attrs:{"aria-hidden":"true","title":"Show Update Logs"}})]):_vm._e()],1)],1)]),_vm._v(" "),(_vm.isAdminRole)?_c('div',{attrs:{"id":"canvasShow"}}):_c('div',{attrs:{"oncontextmenu":"return false;","id":"canvasShow"}})]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('b-button',{attrs:{"variant":"primary","disabled":_vm.canGoToPrev},on:{"click":function($event){_vm.saveAndGoToPage(_vm.prevPage)}}},[_vm._v("Previous")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary","disabled":_vm.canGoToNext},on:{"click":function($event){_vm.saveAndGoToPage(_vm.nextPage)}}},[_vm._v("Next")])],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"formUpdateLogsTable",attrs:{"title":"Form Updates","size":"lg","centered":""}},[_c('b-container',{attrs:{"fluid":""}},[(this.formUpdateLogs.length && _vm.isLogsLoaded)?_c('div',[_c('b-table',{attrs:{"bordered":"","hover":"","striped":"","fields":_vm.updateFields,"items":_vm.formUpdateLogs,"filter":_vm.filter,"filter-included-fields":_vm.filterOn},scopedSlots:_vm._u([{key:"original",fn:function(data){return [_c('span',_vm._l((data.value),function(item){return _c('div',[_vm._v(_vm._s(item))])}))]}},{key:"updated",fn:function(data){return [_c('span',_vm._l((data.value),function(item){return _c('div',[_vm._v(_vm._s(item))])}))]}}])}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.totalUpdateLogs,"per-page":_vm.logsPerPage,"align":"center"},on:{"input":_vm.logsPagination},model:{value:(_vm.logsCurrentPage),callback:function ($$v) {_vm.logsCurrentPage=$$v},expression:"logsCurrentPage"}})],1):(_vm.isLogsLoaded)?_c('div',[_vm._v("\n          No logs available\n        ")]):_c('div',[_c('content-placeholders',[_c('content-placeholders-img',{staticStyle:{"height":"765px"}})],1)],1)]),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm"},on:{"click":_vm.closeUpdateLogs}},[_vm._v(" Close ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"autoCorrectModal",attrs:{"title":_vm.$t('FORMS.AUTO_CORRECT'),"ok-title":_vm.$t('COMMON.ADD'),"cancel-title":_vm.$t('COMMON.CANCEL'),"ok-variant":"secondary","cancel-variant":"light","no-close-on-esc":"","hide-header-close":"","centered":"","no-close-on-backdrop":""},on:{"ok":function($event){_vm.saveAutoCorrectStatus()},"cancel":function($event){_vm.dontSaveAutoCorrectStatus()}}},[_c('b-row',[_c('b-col',[_c('p',{staticStyle:{"color":"red"}},[_vm._v("Below selected fields data will use to auto correct for future forms ")])])],1),_vm._v(" "),(_vm.updatedData.length > 0)?_c('b-row',{staticClass:"mb-3"},_vm._l((_vm.updatedData),function(data){return _c('div',{key:data.id,staticStyle:{"padding":"5px"}},[(data.data_type == 'text' && data.present_in_dict !=true)?_c('input',{ref:"CheckboxClicks",refInFor:true,staticClass:"pull-left mt-1 mr-2",attrs:{"type":"checkbox","id":data.id}}):_vm._e(),_vm._v(" "),(data.data_type == 'text' && data.present_in_dict != true)?_c('label',{staticClass:"pull-left",attrs:{"for":data.id}},[_vm._v(" "+_vm._s(data.key)+" ")]):_vm._e()])})):_vm._e()],1),_vm._v(" "),_c('b-modal',{ref:"fieldInvalidModal",attrs:{"size":"xl","title":_vm.$t('FORMS.VALIDATION_HEADER'),"close-on-esc":"","hide-header-close":"","close-on-backdrop":"","centered":""}},[_c('b-container',{staticClass:"error_listing",attrs:{"fluid":""}},[(_vm.combinedErrors.length > 0)?_c('div',{staticClass:"mb-3 error_listing"},[_c('h5',{staticClass:"error_listing"},[_c('strong',[_vm._v(_vm._s(_vm.$t('FORMS.SERVICE_VALIDATION') + ':'))])]),_vm._v(" "),_vm._l((_vm.combinedErrors),function(error,index){return _c('p',{key:error['key'],staticClass:"error_listing"},[_vm._v("\n            "+_vm._s(index + 1)+". "+_vm._s(error['reason'])+"\n          ")])})],2):_vm._e(),_vm._v(" "),(_vm.requiredFieldsError && _vm.requiredFieldsError.length > 0)?_c('div',{staticClass:"mb-3 error_listing"},[_c('h5',{staticClass:"error_listing"},[_c('strong',[_vm._v(_vm._s(_vm.$t('FORMS.REQUIRED_FIELDS_VALIDATION') + ':'))])]),_vm._v(" "),_vm._l((_vm.requiredFieldsError),function(error,index){return _c('p',{key:error['key'],staticClass:"error_listing"},[_vm._v("\n              "+_vm._s(index+1)+". "+_vm._s(error['reason'])+"\n            ")])})],2):_vm._e(),_vm._v(" "),(_vm.validateUpdateErrorMessages && _vm.validateUpdateErrorMessages.length > 0)?_c('div',{staticClass:"mb-3 error_listing"},[_c('h5',{staticClass:"error_listing"},[_c('strong',[_vm._v(_vm._s(_vm.$t('FORMS.VALIDATION_ERROR') + ':'))])]),_vm._v(" "),_c('b-row',{staticClass:"mb-1 error_listing"},[_c('b-col',{attrs:{"cols":"3"}},[_c('strong',[_vm._v("Field")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('strong',[_vm._v("Type")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('strong',[_vm._v("Value")])])],1),_vm._v(" "),_vm._l((_vm.validateUpdateErrorMessages),function(message){return _c('b-row',{key:message.pv_id,staticClass:"mb-1 error_listing"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm._f("capitalize")(message.key))+" ")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm._f("capitalize")(message.type))+" ")]),_vm._v(" "),_c('b-col',{staticStyle:{"word-wrap":"break-word"},attrs:{"cols":"6"}},[_vm._v(_vm._s(message.current_value))])],1)})],2):_vm._e(),_vm._v(" "),(_vm.optionalErrorMessages && _vm.optionalErrorMessages.length > 0)?_c('div',{staticClass:"mb-3 error_listing"},[_c('h5',{staticClass:"error_listing"},[_c('strong',[_vm._v(_vm._s(_vm.$t('FORMS.OPTIONAL_FIELDS_VALIDATION') + ':'))])]),_vm._v(" "),_vm._l((_vm.optionalErrorMessages),function(error,index){return _c('p',{key:error['key'],staticClass:"error_listing"},[_vm._v("\n              "+_vm._s(index+1)+". "+_vm._s(error['reason'])+"\n            ")])})],2):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.showSaveData}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.OKAY'))+" ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"newFieldModal",attrs:{"id":"newField","title":_vm.$t('FORMS.ADD_FIELD'),"hide-header-close":"","centered":""}},[_c('div',[_c('b-card',[_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"cols":"6"}},[_c('label',{attrs:{"for":"name"}},[_vm._v(" "+_vm._s(_vm.$t('FORMS.LABEL'))+" ")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"input1"},model:{value:(_vm.newFieldLabel),callback:function ($$v) {_vm.newFieldLabel=$$v},expression:"newFieldLabel"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('label',{attrs:{"for":"name"}},[_vm._v(" "+_vm._s(_vm.$t('FORMS.VALUE'))+" ")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"input1"},model:{value:(_vm.newFieldValue),callback:function ($$v) {_vm.newFieldValue=$$v},expression:"newFieldValue"}})],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.addNewField}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.ADD'))+" ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":_vm.hideModal}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CANCEL'))+" ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"compareCardsModal",staticClass:"modal-primary",attrs:{"title":"Image Comparison","size":"lg","hide-header-close":"","centered":"","hide-footer":""},on:{"hidden":_vm.onHideCompareModal}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mb-1 text-center"},[_c('b-col',{attrs:{"cols":"6"}},[(_vm.isOpenCompareUploaded)?_c('b-card',{staticClass:"shadow",attrs:{"header":"Uploaded Image"}},[_c('img',{staticClass:"compare-image",attrs:{"oncontextmenu":"return false;","src":this.imgBase + this.formData.original_image_url}})]):_vm._e()],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[(_vm.isOpenCompareUploaded)?_c('b-card',{staticClass:"shadow",attrs:{"header":"Enhanced Image"}},[_c('img',{staticClass:"compare-image",attrs:{"oncontextmenu":"return false;","src":this.imgBase + this.formData.image_url}})]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"exportErrorModal",attrs:{"title":_vm.$t('FORMS.EXPORT_ERROR'),"hide-header-close":"","centered":"","ok-only":"","ok-variant":"secondary"}},[_c('p',[_vm._v(_vm._s(this.formData.short_export_error))])]),_vm._v(" "),_c('b-modal',{ref:"addDataModal",attrs:{"title":"Add Data Manually","size":"md"},on:{"ok":_vm.fetchTemplateMappings}},[_c('b-row',[_c('b-input-group',[_c('b-col',{staticClass:"p-1 col-4 col-sm-4"},[_c('label',[_vm._v("Select Template")])]),_vm._v(" "),_c('b-col',{staticClass:"p-1 col-8 col-sm-4"},[_c('b-form-select',{staticClass:"reprocess-input",attrs:{"plain":true,"options":_vm.templateOptions,"placeholder":_vm.$t('FORMS.TEMPLATE')},on:{"input":function($event){_vm.handleSelectedTemp()}},model:{value:(_vm.selectedTemplate),callback:function ($$v) {_vm.selectedTemplate=$$v},expression:"selectedTemplate"}})],1),_vm._v(" "),_c('b-col',{staticClass:"p-1 col-12 col-sm-4"},[_c('zoom-center-transition',[_c('img',{staticClass:"shadow preview-image",attrs:{"src":_vm.previewImageUrl}})])],1),_vm._v(" "),_c('b-col',{staticClass:"p-1 col-12 col-sm-4"},[_c('zoom-center-transition',[_c('img',{staticClass:"shadow preview-image",attrs:{"src":_vm.pagePrevImgUrl}})])],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"TableDataModal",staticClass:"modal-primary",attrs:{"title":_vm.$t('FORMS.TABLE_DATA'),"size":"lg","centered":"","hide-footer":""},on:{"hidden":_vm.closeTableModal}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('h4',{staticClass:"processedData"},[_c('strong',[_vm._v(_vm._s(_vm.$t('FORMS.PROCESSED_DATA') + ':'))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"1","offset":"9"}},[_c('div',{staticClass:"save-data"},[_c('b-button',{attrs:{"variant":"secondary","size":"sm"},on:{"click":function($event){_vm.saveData(true)}}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('COMMON.SAVE'))+"\n              ")])],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"height":"100px","width":"100%"}},[_c('canvas',{staticStyle:{"border":"1px solid","width":"100%","max-height":"50px"},attrs:{"id":"table-header-canvas"}}),_c('br'),_vm._v(" "),_c('canvas',{staticStyle:{"border":"1px solid","width":"100%","max-height":"50px"},attrs:{"id":"table-row-canvas"}}),_c('br')]),_vm._v(" "),(_vm.selectedTablePath)?_c('b-card',{staticStyle:{"overflow-x":"auto","margin-top":"15px"}},[_c('div',{staticClass:"table-model-y model-scrollbar"},[_c('table',{staticClass:"stick-table",staticStyle:{"table-layout":"auto"}},[_c('thead',_vm._l((_vm.selectedTableData['children'][0]['children']),function(header,index){return _c('th',{key:index},[_vm._v(_vm._s(header['key']))])})),_vm._v(" "),_c('tbody',_vm._l((_vm.selectedTableData['children'].slice(1)),function(row,index){return _c('tr',{key:index,on:{"mouseover":function($event){_vm.hoverRow(row, index)}}},_vm._l((row['children']),function(cell,index){return _c('td',{key:index},[(cell.current_value !== cell.original_value)?_c('span',[_c('input',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],staticClass:"table-input table-input-edited",attrs:{"title":'Original Value: ' + cell.original_value},domProps:{"value":cell.current_value},on:{"click":function($event){_vm.highlightInRow(cell, row, index)},"change":function($event){_vm.updateTableData($event, cell)}}})]):_c('span',[_c('input',{staticClass:"table-input",domProps:{"value":cell.current_value},on:{"click":function($event){_vm.highlightInRow(cell, row, index)},"change":function($event){_vm.updateTableData($event, cell)}}})])])}))}))])])]):_vm._e()],1)],1),_vm._v(" "),_c('b-modal',{ref:"errorsAcknowledgementModal",attrs:{"title":_vm.isFormDocValid ? _vm.$t('COMMON.CONFIRM') : _vm.$t('FORMS.VALIDATION_HEADER'),"hide-header-close":"","centered":"","ok-variant":"secondary","cancel-variant":"primary","ok-title":_vm.$t('COMMON.SAVE')},on:{"hidden":_vm.cancelExport,"ok":_vm.exportDataToService,"cancel":_vm.cancelExport}},[_c('b-container',{attrs:{"fluid":""}},[(this.isFormDocValid)?_c('div',[_c('div',{staticClass:"save-btn"},[_vm._v("\n            Are you sure you want to save data on Salesforce?\n          ")])]):_c('div',[_c('b-row',{staticClass:"mb-1 text-center"},[_c('b-col',{attrs:{"cols":"6"}},[_c('strong',[_vm._v("Page No.")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('strong',[_vm._v("Errors")])])],1),_vm._v(" "),_vm._l((_vm.pageLevelErrors),function(pageErrors){return _c('b-row',{key:pageErrors.page,staticClass:"mb-1 text-center"},[_c('b-col',{attrs:{"cols":"6"}},[_vm._v(_vm._s(pageErrors.page)+" ")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_vm._v(_vm._s(pageErrors.errors.length)+" ")])],1)}),_vm._v(" "),_c('b-row',[_c('div',{staticClass:"error-acknowledgement"},[_vm._v("\n              There are data errors thats needs to be fixed. Do you really want to save data on salesforce without verifiying them?\n            ")])])],2)])],1),_vm._v(" "),_c('b-modal',{ref:"signInvoiceModal",attrs:{"title":_vm.isInvoiceVerified ? _vm.$t('INVOICE.APPROVE_SIGN') : _vm.$t('INVOICE.SIGN_INVOICE'),"hide-header-close":"","centered":"","ok-variant":"secondary","cancel-variant":"primary","ok-title":_vm.isInvoiceVerified ? _vm.$t('INVOICE.APPROVE') : _vm.$t('INVOICE.SIGN')},on:{"hidden":_vm.hideSignInvoice,"ok":_vm.signInvoice,"cancel":_vm.hideSignInvoice}},[_c('b-row',{staticClass:"m-2"},[_c('b-col',{attrs:{"md":"4"}},[_c('label',[_vm._v(_vm._s(_vm.$t('INVOICE.ACCOUNT'))),_c('span',{staticClass:"required"},[_vm._v("*")])])]),_vm._v(" "),_c('b-col',{attrs:{"md":"8"}},[_c('b-form-select',{staticClass:"form-control",class:{'is-invalid': _vm.$v.invoice.selectedAccount.$error, 'is-valid': !_vm.$v.invoice.selectedAccount.$invalid},attrs:{"plain":true,"options":_vm.invoiceSign.accounts},model:{value:(_vm.invoice.selectedAccount),callback:function ($$v) {_vm.$set(_vm.invoice, "selectedAccount", $$v)},expression:"invoice.selectedAccount"}}),_vm._v(" "),(!_vm.$v.invoice.selectedAccount.required)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('INVOICE.ACC_REQ')))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"m-2"},[_c('b-col',{attrs:{"md":"4"}},[_c('label',[_vm._v(_vm._s(_vm.$t('INVOICE.ACCOUNTING_UNIT'))),_c('span',{staticClass:"required"},[_vm._v("*")])])]),_vm._v(" "),_c('b-col',{attrs:{"md":"8"}},[_c('b-form-select',{staticClass:"md -8 form-control",class:{'is-invalid': _vm.$v.invoice.selectedAccountingUnit.$error, 'is-valid': !_vm.$v.invoice.selectedAccountingUnit.$invalid},attrs:{"plain":true,"options":_vm.invoiceSign.accountingUnits},model:{value:(_vm.invoice.selectedAccountingUnit),callback:function ($$v) {_vm.$set(_vm.invoice, "selectedAccountingUnit", $$v)},expression:"invoice.selectedAccountingUnit"}}),_vm._v(" "),(!_vm.$v.invoice.selectedAccountingUnit.required)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('INVOICE.ACC_UNIT_REQ')))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"m-2"},[_c('b-col',{attrs:{"md":"4"}},[_c('label',[_vm._v(_vm._s(_vm.$t('INVOICE.TOTAL_AMOUNT'))),_c('span',{staticClass:"required"},[_vm._v("*")])])]),_vm._v(" "),_c('b-col',{attrs:{"md":"8"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoice.totalAmount),expression:"invoice.totalAmount"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.invoice.totalAmount.$error, 'is-valid': !_vm.$v.invoice.totalAmount.$invalid},attrs:{"type":"number","id":"totalAmount"},domProps:{"value":(_vm.invoice.totalAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.invoice, "totalAmount", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.invoice.totalAmount.required)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('INVOICE.AMT_REQ')))]):_vm._e(),_vm._v(" "),(!_vm.$v.invoice.totalAmount.minLen)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('INVOICE.MIN_AMT')))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"m-2"},[_c('b-col',{attrs:{"md":"4"}},[_c('label',[_vm._v(_vm._s(_vm.$t('INVOICE.NOTES')))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"8"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoice.description),expression:"invoice.description"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.invoice.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.invoice, "description", $event.target.value)}}})])],1)],1),_vm._v(" "),_c('b-modal',{ref:"saveFieldsAlertModel",attrs:{"title":_vm.$t('COMMON.ALERT'),"centered":"","header-text-variant":"danger","ok-variant":"secondary","ok-title":_vm.$t('COMMON.SAVE'),"ok-disabled":!_vm.checkauth,"cancel-variant":"danger"},on:{"ok":function($event){_vm.confirmChanges()},"cancel":function($event){_vm.cancelNavigation(_vm.getCurrentPage)},"hidden":function($event){_vm.cancelNavigation(_vm.getCurrentPage)}}},[_vm._v("\n      "+_vm._s(_vm.$t('COMMON.SAVE_ALERT'))+"\n    ")]),_vm._v(" "),_c('b-modal',{ref:"slaesForceAlertModal",attrs:{"centered":"","title":"Sales Force Validation Error","ok-variant":"secondary","ok-only":""}},[_vm._v("\n      "+_vm._s(_vm.salesForeceValidationError)+"\n    ")]),_vm._v(" "),_c('b-modal',{ref:"multipleUserAlert",attrs:{"title":_vm.$t('FORMS.MULTI_USER_MODAL'),"hide-header-close":"","centered":""}},[_c('strong',[_vm._v(_vm._s(_vm.$t('FORMS.MULTI_USER_ALERT_MSG')))]),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.goBackToFormsPage}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.GO_BACK'))+" ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"rejectFormDoc",attrs:{"hide-header-close":"","title":"Reject Form","header-bg-variant":"light","centered":""}},[_c('b-card',{staticClass:"mt-3"},[_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"cols":"12"}},[_c('img',{attrs:{"src":__webpack_require__(190)}}),_vm._v(" "),_c('h5',[_vm._v("Do you want to reject this document?")])])],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"danger"},on:{"click":_vm.rejectForm}},[_vm._v(" Confirm ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":_vm.hideRejectFormDocModal}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CANCEL'))+" ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.formId)?_c('b-col',{attrs:{"lg":"12"}},[_c('processForm',{attrs:{"form-id":_vm.formId}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modifyProcessType_vue__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modifyProcessType_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modifyProcessType_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modifyProcessType_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modifyProcessType_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd23d61e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modifyProcessType_vue__ = __webpack_require__(1133);
function injectStyle (ssrContext) {
  __webpack_require__(1119)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bd23d61e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modifyProcessType_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd23d61e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modifyProcessType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1120 */,
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var applyDrag = exports.applyDrag = function applyDrag(arr, dragResult) {
  var removedIndex = dragResult.removedIndex,
      addedIndex = dragResult.addedIndex,
      payload = dragResult.payload;

  if (removedIndex === null && addedIndex === null) return arr;

  var result = [].concat(_toConsumableArray(arr));
  var itemToAdd = payload;

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0];
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd);
  }

  return result;
};

var generateItems = exports.generateItems = function generateItems(count, creator) {
  // console.log('creator  = ', creator)
  var result = [];
  for (var i = 0; i < count; i++) {
    result.push(creator(i));
  }
  return result;
};

/***/ }),
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b-row',[_c('b-col',{staticStyle:{"padding-left":"22px"},attrs:{"lg":"2"}},[_c('a',[_vm._v(" "+_vm._s(_vm.$t('WORKFLOW.DOCUMENT_TYPE'))+" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v(" "),(!_vm.isRotatedDoc)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.viewport",modifiers:{"hover":true,"viewport":true}}],staticClass:"btn btn-primary btn-sm",staticStyle:{"margin-left":"5px","border-radius":"6px","margin-bottom":"5px"},attrs:{"variant":"secondary"},on:{"mouseover":function($event){_vm.showTooltip = true},"mouseout":function($event){_vm.showTooltip = false}}},[_c('i',{staticClass:"fa fa-info-circle"})]):_vm._e(),_vm._v(" "),(_vm.showTooltip)?_c('div',{staticClass:"custom-tooltip"},[_c('img',{attrs:{"src":__webpack_require__(1134)}}),_vm._v(" "),_c('h5',[_c('p',[_vm._v("Step 1 - Determine the document category that matches the Start form/HIPAA consent version.")]),_vm._v(" "),_c('p',[_vm._v("Step 2 - Select the thumbnail image representing this particular document.")]),_vm._v(" "),_c('p',[_vm._v("Step 3 - Next, scroll down to the bottom of the page to find and make a note of the Map ID linked to this form.")]),_vm._v(" "),_c('p',[_vm._v("Step 4 - Following that, check the checkbox adjacent to SF/HIPAA and confirm that the document category matches the MAP ID of SF/HIPAA.")])])]):_vm._e()],1),_vm._v(" "),_c('b-form-select',{attrs:{"plain":true,"options":_vm.setFormTypeOptions,"disabled":_vm.isRotatedDoc,"placeholder":"Select Document Type"},on:{"change":_vm.disableCheckboxOnEditedDoc},model:{value:(_vm.formType),callback:function ($$v) {_vm.formType=$$v},expression:"formType"}})],1),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"loading-spinner"})]):_vm._e(),_vm._v(" "),_c('b-col',{staticStyle:{"margin-top":"27px"},attrs:{"lg":"5"}},[(!_vm.isRotatedDoc)?_c('b-button',{staticClass:"addGroupBtn",staticStyle:{"margin-bottom":"5px","padding-bottom":"0px","border-radius":"6px","height":"40px","margin-top":"0px","margin-right":"5px"},attrs:{"size":"sm","variant":"secondary","disabled":_vm.disableSaveButton || this.editAttachmentsEnabled !== null},on:{"click":_vm.CheckboxSave}},[_c('span',[_c('h5',[_vm._v("Save")])])]):_vm._e(),_vm._v(" "),(!_vm.isRotatedDoc)?_c('b-button',{staticClass:"addGroupBtn",staticStyle:{"margin-bottom":"5px","padding-bottom":"0px","border-radius":"6px","height":"40px","margin-top":"0px","margin-right":"5px"},attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){_vm.clearEditedAttachedPages(); _vm.CheckboxClear();}}},[_c('span',[_c('h5',[_vm._v("Reset")])])]):_vm._e(),_vm._v(" "),(!_vm.isRotatedDoc)?_c('b-button',{staticClass:"addGroupBtn",staticStyle:{"margin-bottom":"5px","padding-bottom":"0px","border-radius":"6px","height":"40px","margin-top":"0px","margin-right":"5px"},attrs:{"size":"sm","variant":"secondary","disabled":_vm.processButtonDisabled || this.editAttachmentsEnabled !== null || Object.keys(_vm.selectedTitleDocs).length<=0 || _vm.isEditedDoc},on:{"click":_vm.doProcess}},[_c('span',[_c('h5',[_vm._v("Process "),(_vm.processButtonDisabled)?_c('i',{staticClass:"fa fa-spinner fa-spin mr-2",staticStyle:{"font-size":"16px"}}):_vm._e(),_c('span')])])]):_vm._e(),_vm._v(" "),(_vm.isRotatedDoc)?_c('b-button',{staticClass:"addGroupBtn",staticStyle:{"margin-bottom":"5px","padding-bottom":"0px","border-radius":"6px","height":"40px","margin-top":"0px","margin-right":"5px"},attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.exportRotatedDoc}},[_c('span',[_c('h5',[_vm._v("Export "),(_vm.processButtonDisabled)?_c('i',{staticClass:"fa fa-spinner fa-spin mr-2",staticStyle:{"font-size":"16px"}}):_vm._e(),_c('span')])])]):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"addGroupBtn",staticStyle:{"margin-bottom":"5px","padding-bottom":"0px","border-radius":"6px","height":"40px","margin-top":"0px","margin-right":"5px"},attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.showRejectFormModal}},[_c('span',[_c('h5',[_vm._v("Reject "),_c('i',{staticStyle:{"font-size":"16px"}}),_c('span')])])]),_vm._v(" "),_c('b-button',{staticClass:"addGroupBtn",staticStyle:{"margin-bottom":"5px","padding-bottom":"0px","border-radius":"6px","height":"40px","margin-top":"0px","margin-right":"5px"},attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){_vm.rotateSelectedImgs(-90)}}},[_c('span',[_c('h5',[_vm._v("Rotate Left"),_c('i',{staticStyle:{"font-size":"16px"}}),_c('span')])])]),_vm._v(" "),_c('b-button',{staticClass:"addGroupBtn",staticStyle:{"margin-bottom":"5px","padding-bottom":"0px","border-radius":"6px","height":"40px","margin-top":"0px","margin-right":"5px"},attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){_vm.rotateSelectedImgs(+90)}}},[_c('span',[_c('h5',[_vm._v("Rotate Right"),_c('i',{staticStyle:{"font-size":"16px"}}),_c('span')])])])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('b-row',[_c('b-col',{attrs:{"lg":"3"}})],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"10px"}},[_c('b-col',{attrs:{"sm":"6"}},[_c('b-card',{staticStyle:{"overflow-y":"scroll","height":"60vh"},attrs:{"sm":"6"}},[(_vm.isRotatedDoc)?_c('div',{staticClass:"notes-margin"},[_c('ul',[_c('h5',{staticStyle:{"font-weight":"bold"}},[_vm._v("Note:")]),_vm._v(" "),_c('li',[_vm._v("Kindly choose an image and adjust its orientation as needed.")]),_vm._v(" "),_c('li',[_vm._v("After rotating the pages, hit Export to see the whole document with the changes in Salesforce.")])])]):_c('div',[_c('b-col',{attrs:{"lg":"6"}},[_c('h5',[_vm._v("Triaged Documents")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}}),_vm._v(" "),_c('b-col',{attrs:{"lg":"12"}},[_c('table',{staticClass:"result",staticStyle:{"width":"100%"}},[_c('tr',{staticClass:"result",staticStyle:{"background-color":"rgb(168 174 179)","font-size":"12px"}},[(!_vm.isRotatedDoc)?_c('th',{staticClass:"result"},[_vm._v(" Document Type ")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"result"},[_vm._v(" Page Number(s) ")]),_vm._v(" "),(!_vm.isRotatedDoc)?_c('th',{staticClass:"result"},[_vm._v(" Attached"),_c('br'),_vm._v(" Page Number(s) ")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"result"},[_vm._v(" Action ")])]),_vm._v(" "),_vm._l((_vm.selectedTitleDocs),function(value,key){return _c('tr',{class:_vm.getResultCss(value),staticStyle:{"font-size":"12px"}},[(!_vm.isRotatedDoc)?_c('td',{staticClass:"result"},[_vm._v(_vm._s(value.template_doc.text))]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"result"},[_vm._v(_vm._s(value.pages.join(', ')))]),_vm._v(" "),(!_vm.isRotatedDoc)?_c('td',{staticClass:"result"},[_vm._v("\n                  "+_vm._s(value.attachment_pages && value.attachment_pages.join(', '))+"\n                  "),(value.attachment_pages && value.attachment_pages.join(', '))?_c('br'):_vm._e(),_vm._v(" "),(value.attachment_pages && value.attachment_pages.length > 0)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.viewport",modifiers:{"hover":true,"viewport":true}}],staticStyle:{"border-radius":"5px","padding":"0px 3px 0px 3px"},attrs:{"variant":"secondary","title":"Remove Attachments"},on:{"click":function($event){_vm.removeAttachments(value, key)}}},[_c('i',{staticClass:"fa fa-trash"})]):_vm._e(),_vm._v(" "),(value.attachment_pages && value.attachment_pages.length > 0)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.viewport",modifiers:{"hover":true,"viewport":true}}],staticStyle:{"border-radius":"5px","padding":"0px 3px 0px 3px"},attrs:{"disabled":_vm.isSecondEditButtonDisabled(key),"variant":"secondary","title":"Edit Attachments"},on:{"click":function($event){_vm.editAttachments(value, key)}}},[_c('i',{staticClass:"fa fa-edit"})]):_vm._e(),_vm._v(" "),(!['cover_page', 'attachments'].includes(value.formType))?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.viewport",modifiers:{"hover":true,"viewport":true}}],staticStyle:{"border-radius":"5px","padding":"0px 3px 0px 3px"},attrs:{"disabled":(_vm.selectedTitleDocs !== null && (_vm.editAttachmentsEnabled !== key && _vm.editAttachmentsEnabled !== null)) || _vm.isSecondEditButtonDisabled(key),"variant":"secondary","title":"Add Attachments"},on:{"click":function($event){_vm.addAttachments(value, key)}}},[_c('i',{staticClass:"fa fa-floppy-o"})]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('td',{staticClass:"result"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.viewport",modifiers:{"hover":true,"viewport":true}}],staticStyle:{"border-radius":"5px","padding":"0px 6px 0px 6px"},attrs:{"disabled":(_vm.selectedTitleDocs !== null && _vm.editAttachmentsEnabled !== null) || (_vm.selectedTitleDocs !== null && _vm.editInsCardsEnabled !== null),"variant":"primary","title":"Edit"},on:{"click":function($event){_vm.editPages(value, key)}}},[_c('i',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.viewport",modifiers:{"hover":true,"viewport":true}}],staticStyle:{"border-radius":"5px","padding":"0px 6px 0px 6px"},attrs:{"variant":"danger","title":"Remove"},on:{"click":function($event){_vm.removePages(value, key)}}},[_c('i',{staticClass:"fa fa-trash"})])],1)])})],2)])],1)])],1),_vm._v(" "),_c('b-col',{staticClass:"scrollable-content",staticStyle:{"overflow":"scroll","max-height":"120vh"},attrs:{"sm":"6"}},[_c('Container',{attrs:{"orientation":"horizontal","drag-handle-selector":".column-drag-handle","drop-placeholder":_vm.upperDropPlaceholderOptions},on:{"drop":function($event){_vm.onColumnDrop($event)},"drag-start":_vm.dragStart}},_vm._l((_vm.scene.children),function(column){return _c('Draggable',{key:column.id},[_c('b-card',[_c('div',{class:column.props.className},[_c('div',{staticClass:"card-column-header d-flex justify-content-between",staticStyle:{"padding":"10px 0.5px","background-color":"#a8aeb3"}},[_c('div',{staticClass:"checkbox-padding"},[(column.name === 'Unmatched Pages')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectAllUnmatched),expression:"selectAllUnmatched"}],ref:"selectAllUnmatchedClicks",refInFor:true,staticStyle:{"transform":"scale(1.1)"},attrs:{"type":"checkbox","id":column.id},domProps:{"checked":Array.isArray(_vm.selectAllUnmatched)?_vm._i(_vm.selectAllUnmatched,null)>-1:(_vm.selectAllUnmatched)},on:{"change":[function($event){var $$a=_vm.selectAllUnmatched,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectAllUnmatched=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectAllUnmatched=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectAllUnmatched=$$c}},function($event){_vm.selectAllUnmatchedPages()}]}}):_vm._e(),_vm._v(" "),(column.name === 'Templates')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectAllTemplates),expression:"selectAllTemplates"}],ref:"selectAllTemplateClicks",refInFor:true,staticStyle:{"transform":"scale(1.1)"},attrs:{"type":"checkbox","id":column.id},domProps:{"checked":Array.isArray(_vm.selectAllTemplates)?_vm._i(_vm.selectAllTemplates,null)>-1:(_vm.selectAllTemplates)},on:{"change":[function($event){var $$a=_vm.selectAllTemplates,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectAllTemplates=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectAllTemplates=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectAllTemplates=$$c}},function($event){_vm.selectAllTemplatePages()}]}}):_vm._e()]),_vm._v(" "),_c('div',[_c('span',{staticClass:"column-drag-handle"}),_vm._v("\n                  "+_vm._s(column.name === 'Templates' ? 'Enrollment Forms' : column.name)+"\n                ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"30px"}})]),_vm._v(" "),_c('Container',{staticStyle:{"width":"23.5vw","height":"900px","background-color":"#ebeff3"},attrs:{"group-name":"col","get-child-payload":_vm.getCardPayload(column.id),"drag-class":"card-ghost","drop-class":"card-ghost-drop","drop-placeholder":_vm.dropPlaceholderOptions},on:{"drop":function (e) { return _vm.onCardDrop(column.id, e); },"drag-start":function (e) { return _vm.log('drag start', e); },"drag-end":function (e) { return _vm.log('drag end', e); }}},_vm._l((column.children),function(card){return _c('Draggable',{key:card.id,staticStyle:{"padding":"1px"}},[(_vm.isEditedDoc ? (card.data.form && card.data.form.isEdited === true) :(card.data.form && card.data.form.process!== true))?_c('div',[(card.data.found && card.data.form )?_c('div',{class:card.props.className,style:(card.data.form.process == true ? 'border: 2px solid green' : 'border: none;')},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('div',{staticClass:"checkbox-padding"},[(!card.data.form.isEdited)?_c('input',{ref:"CheckboxClicks",refInFor:true,attrs:{"type":"checkbox","id":card.id},on:{"change":function($event){_vm.updateDisableCheckBox()}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editedCheckedBoxes),expression:"editedCheckedBoxes"}],ref:"CheckboxClicks",refInFor:true,attrs:{"type":"checkbox","id":card.id},domProps:{"value":card.data.form.id,"checked":Array.isArray(_vm.editedCheckedBoxes)?_vm._i(_vm.editedCheckedBoxes,card.data.form.id)>-1:(_vm.editedCheckedBoxes)},on:{"change":[function($event){var $$a=_vm.editedCheckedBoxes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=card.data.form.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.editedCheckedBoxes=$$a.concat([$$v]))}else{$$i>-1&&(_vm.editedCheckedBoxes=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.editedCheckedBoxes=$$c}},function($event){_vm.updateDisableCheckBox()}]}})]),_vm._v(" "),_c('p',[_vm._v("Page: "+_vm._s(card.data.form.original_page_no))])]),_vm._v(" "),_c('img',{staticClass:"card-img",style:({ transform: ("rotate(" + (card.data.form.rotation) + "deg)") }),attrs:{"onContextMenu":"return false;","width":"100","height":"300","src":card.data.form ? _vm.axios.defaults.baseURL.replace('/api', '') + card.data.form.image_thumbnail: '',"id":card.data.form.id + card.data.form.original_title},on:{"load":function($event){_vm.loadingImage($event, card.data.form)},"click":function($event){_vm.viewFullImage(card.data.form, column.name)}}})]):_c('div',[_c('img',{staticClass:"card-img",attrs:{"onContextMenu":"return false;","width":"100","height":"300"}})])]):_c('div',[_c('img',{staticClass:"card-img",attrs:{"onContextMenu":"return false;","width":"100","height":"239"}})])])}))],1)])],1)}))],1)],1),_vm._v(" "),_c('b-modal',{ref:"viewFullImage",staticClass:"modal-primary",attrs:{"size":"lg","centered":"","id":"hideModal","no-close-on-esc":"","hide-header-close":"","no-close-on-backdrop":"","scrollable":""}},[_c('div',{attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('label',[_vm._v(_vm._s(_vm.selectedImage.title))]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.viewport",modifiers:{"hover":true,"viewport":true}}],staticStyle:{"padding":"4px 8px","border-radius":"0px"},attrs:{"size":"sm","variant":"dark","title":_vm.$t('FORMS.ROTATE_LEFT')},on:{"click":function($event){_vm.imageRotateLeft()}}},[_c('i',{staticClass:"fa fa-undo"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.viewport",modifiers:{"hover":true,"viewport":true}}],staticStyle:{"padding":"4px 8px","border-radius":"0px"},attrs:{"size":"sm","variant":"dark","title":_vm.$t('FORMS.ROTATE_RIGHT')},on:{"click":function($event){_vm.imageRotateRight()}}},[_c('i',{staticClass:"fa fa-repeat"})])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":12}},[_c('div',{staticStyle:{"height":"75vh","overflow-y":"auto"}},[(_vm.modelOpen)?_c('img',{staticClass:"card-img",staticStyle:{"width":"80%"},style:({ transform: ("rotate(" + (this.angle) + "deg)") }),attrs:{"onContextMenu":"return false;","src":_vm.selectedImage ? _vm.axios.defaults.baseURL.replace('/api', '') + _vm.selectedImage.image_url: '',"id":_vm.selectedImage.id},on:{"load":function($event){_vm.loadingImage($event,_vm.selectedImage)}}}):_vm._e()])])],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){_vm.saveRotationTemplateImage()}}},[_vm._v(" Save ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":function($event){_vm.closeRotationTemplateImage()}}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CLOSE'))+" ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"rejectFormDoc",attrs:{"hide-header-close":"","title":"Reject Form","header-bg-variant":"light","centered":""}},[_c('b-card',{staticClass:"mt-3"},[_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"cols":"12"}},[_c('img',{attrs:{"src":__webpack_require__(190)}}),_vm._v(" "),_c('h5',[_vm._v("Do you want to reject this document?")])])],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"danger"},on:{"click":_vm.rejectForm}},[_vm._v(" Confirm ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":_vm.hideRejectFormDocModal}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CANCEL'))+" ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"unmatchedPagesAlert",attrs:{"hide-header-close":"","title":"Alert","header-bg-variant":"light","centered":""}},[_c('b-card',{staticClass:"mt-3"},[_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"cols":"12"}},[_c('h5',[_vm._v("The form cannot be processed from the unmatched pages panel, so please drag the image from the Unmatched Pages and drop it into the Enrollment Forms Panel. Then, select the appropriate checkbox and save.")])])],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"dark"},on:{"click":function($event){_vm.$refs.unmatchedPagesAlert.hide()}}},[_vm._v(" Ok ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"rotatePagesAlert",attrs:{"hide-header-close":"","title":"Alert","header-bg-variant":"light","centered":""}},[_c('b-card',{staticClass:"mt-3"},[_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"cols":"12"}},[_c('h5',[_vm._v("Kindly choose at least one form to rotate.")])])],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"dark"},on:{"click":function($event){_vm.$refs.rotatePagesAlert.hide()}}},[_vm._v(" Ok ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"multipleInsAlert",attrs:{"hide-header-close":"","title":"Alert","header-bg-variant":"light","centered":""}},[_c('b-card',{staticClass:"mt-3"},[_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"cols":"12"}},[_c('h5',[_vm._v("Please note that only one insurance card can be processed with the start form. Kindly verify your selection and choose the correct insurance card.")])])],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"dark"},on:{"click":function($event){_vm.$refs.multipleInsAlert.hide()}}},[_vm._v(" Ok ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

module.exports = "../../static/img/templateimg.9b5ff81.png";

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11a73d48_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(1191);
function injectStyle (ssrContext) {
  __webpack_require__(1136)
  __webpack_require__(1137)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11a73d48"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11a73d48_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1138 */,
/* 1139 */,
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.formatValue(Number(_vm.animatedValue))))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn reports"},[_c('b-row',{attrs:{"id":"teamFilter"}},[_c('b-col',{attrs:{"lg":"2","offset":"10"}},[_c('div',[_vm._v("\n      "+_vm._s(_vm.$t('Users'))+"\n        "),_c('div',[_c('b-form-select',{staticStyle:{"text-transform":"capitalize"},attrs:{"options":_vm.users},model:{value:(_vm.userID),callback:function ($$v) {_vm.userID=$$v},expression:"userID"}})],1)])])],1),_vm._v(" "),_c('b-card',{attrs:{"no-body":""}},[_c('b-row',{directives:[{name:"match-heights",rawName:"v-match-heights",value:({el: ['.eq-height']}),expression:"{el: ['.eq-height']}"}]},_vm._l((_vm.reportCards),function(reportCard){return (_vm.showReportCards)?_c('b-col',{key:reportCard['id'],attrs:{"lg":"2"}},[_c('b-card',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"eq-height text-black bg-white",attrs:{"no-body":""},on:{"click":function($event){_vm.pCardFilter(reportCard['text'])}}},[_c('div',{staticClass:"bar",class:reportCard['bg']}),_vm._v(" "),_c('b-card-body',[_c('b-row',{staticClass:"top-layer"},[_c('div',{staticClass:"h1 mb-0"},[_c('animated-number',{attrs:{"value":reportCard['value'] || 0,"formatValue":_vm.formatNumber,"duration":1000}})],1),_vm._v(" "),_c('div',{staticClass:"h1 text-right mb-4",class:reportCard['tc']},[_c('i',{class:reportCard['icon']})])]),_vm._v(" "),_c('small',{staticClass:"text-black text-uppercase font-weight-bold"},[_c('strong',[_c('div',{staticStyle:{"height":"36px"}},[_vm._v(_vm._s(_vm.$t('UPLOAD_DROPDOWN.'+reportCard['key']))),_c('br')])]),_vm._v("\n              "+_vm._s(_vm.$t('ANALYTICS.TOTAL_PROCESSED'))+" : "+_vm._s(reportCard['processed'])),_c('br'),_vm._v("\n              "+_vm._s(_vm.$t('ANALYTICS.TOTAL_REJECTED'))+" : "+_vm._s(reportCard['rejected'])),_c('br')]),_vm._v(" "),_c('b-progress',{staticClass:"progress-black progress-xs mt-3",attrs:{"value":25}})],1)],1)],1):_c('b-col',{attrs:{"lg":"2"}},[_c('b-card',{staticClass:"eq-height text-black bg-white",attrs:{"no-body":""}},[_c('b-card-body',[_c('content-placeholders',[_c('content-placeholders-img',{staticStyle:{"height":"140px"}})],1)],1)],1)],1)})),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"4"}},[_c('b-card',{staticClass:"bg-white",attrs:{"no-body":""}},[_c('b-row',{staticClass:"ml-0",attrs:{"slot":"header"},slot:"header"},[_c('h5',[_vm._v(_vm._s(_vm.$t('ANALYTICS.FORM_WORKFLOW_STATS')))])]),_vm._v(" "),_c('b-card-body',[(_vm.showChart)?_c('timeline',_vm._l((_vm.processWorkflowStat),function(count,processed){return _c('timeline-item',{key:processed,class:'stats-' + processed},[_c('span',{staticClass:"h5 font-weight-bold"},[_c('animated-number',{attrs:{"value":count || 0,"formatValue":_vm.formatNumber,"duration":1000}})],1),_vm._v(" "+_vm._s(_vm.$t('COMMON.'+processed.toUpperCase()))+"\n              ")])})):_c('content-placeholders',[_c('content-placeholders-img',{staticStyle:{"height":"300px"}})],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"8"}},[_c('b-card',{staticClass:"bg-white",attrs:{"no-body":""}},[_c('b-row',{staticClass:"p-0",staticStyle:{"margin-top":"-19px"},attrs:{"slot":"header"},slot:"header"},[_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"3"}},[(_vm.selectedDateFilterType === 'week')?_c('h5',[_vm._v(" "+_vm._s(_vm.$t('ANALYTICS.WEEKLY_REPORT')))]):_c('h5',[_vm._v(" "+_vm._s(_vm.$t('ANALYTICS.DAILY_REPORT')))])]),_vm._v(" "),_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"1.5"}},[_c('h6',[_vm._v(" "+_vm._s(_vm.$t('COMMON.FILTER_BY'))+" ")])]),_vm._v(" "),_c('b-col',{staticClass:"group-by",attrs:{"sm":"2"}},[_c('b-form-select',{attrs:{"options":_vm.setFilterOptions},model:{value:(_vm.selectedDateFilterType),callback:function ($$v) {_vm.selectedDateFilterType=$$v},expression:"selectedDateFilterType"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"1.5"}},[_c('h6',[_vm._v(" "+_vm._s(_vm.$t('COMMON.DATE_RANGE'))+" ")])]),_vm._v(" "),_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"4"}},[_c('date-picker',{attrs:{"range":"","lang":"en","format":"YYYY-MM-DD","append-to-body":"","clearable":false,"width":"220px"},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})],1)],1),_vm._v(" "),_c('b-card-body',[(_vm.showChart)?_c('line-chart',{attrs:{"lineData":_vm.lineData,"lineLabels":_vm.lineLabels,"height":247}}):_c('content-placeholders',[_c('content-placeholders-img',{staticStyle:{"height":"300px"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"id":"recent-forms"}},[_c('b-card',{staticClass:"received-form",attrs:{"no-body":"","bg-variant":"light"}},[_c('b-row',{staticClass:"p-0",attrs:{"slot":"header"},slot:"header"},[_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"3"}},[_c('h5',[_vm._v(_vm._s(_vm.$t('ANALYTICS.RECENT_FORMS')))])]),_vm._v(" "),_c('b-col',{staticClass:"mt-auto",staticStyle:{"margin-left":"-78px"},attrs:{"sm":"0"}},[_c('h6',[_vm._v(_vm._s(_vm.$t('ANALYTICS.PROCESS_TYPE')))])]),_vm._v(" "),_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"3"}},[_c('b-form-select',{staticStyle:{"text-transform":"capitalize"},attrs:{"options":_vm.setOptions},on:{"input":_vm.filterProcessedFormsByType},model:{value:(_vm.selectedProcessType),callback:function ($$v) {_vm.selectedProcessType=$$v},expression:"selectedProcessType"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"0"}},[(_vm.selectedProcessType == 'enrollment forms')?_c('h6',[_vm._v(_vm._s(_vm.$t('ANALYTICS.TEMPLATE')))]):_vm._e()]),_vm._v(" "),_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"2"}},[(_vm.selectedProcessType == 'enrollment forms')?_c('b-form-select',{staticStyle:{"text-transform":"capitalize"},attrs:{"options":_vm.templates},on:{"input":_vm.filterProcessedFormsByTemplate},model:{value:(_vm.selectedTemplate),callback:function ($$v) {_vm.selectedTemplate=$$v},expression:"selectedTemplate"}}):_vm._e()],1),_vm._v(" "),_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"3"}},[_c('b-row',[_c('b-col',{staticClass:"mt-auto",attrs:{"xs":"6"}},[_vm._v("\n                "+_vm._s(_vm.$t('COMMON.PROCESSED'))+"\n                "),_c('c-switch',{attrs:{"type":"3d","variant":"success","checked":_vm.filterProcessed},on:{"change":_vm.pSwitchChanged}})],1),_vm._v(" "),_c('b-col',{staticClass:"mt-auto",attrs:{"xs":"6"}},[_vm._v("\n                "+_vm._s(_vm.$t('COMMON.REJECTED'))+"\n                "),_c('c-switch',{attrs:{"type":"3d","variant":"danger","checked":_vm.filterRejected},on:{"change":_vm.rSwitchChanged}})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"report-table"},[(_vm.showProcessedForms)?_c('b-table',{attrs:{"show-empty":"","striped":"","empty-text":_vm.$t('COMMON.NO_RECORD'),"hover":"","responsive":"sm","variant":"danger","items":_vm.processedForms,"fields":_vm.tableFields,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event}},scopedSlots:_vm._u([{key:"HEAD_title",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_pages",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_confidence_score",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_identified",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_rejection_reason",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_view_link",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}}])}):_c('content-placeholders',[_c('content-placeholders-text',{attrs:{"lines":12}})],1),_vm._v(" "),_c('infinite-loading',{ref:"infiniteLoading",attrs:{"distance":_vm.distance,"spinner":"spiral"},on:{"infinite":_vm.infiniteHandler}},[_c('div',{attrs:{"slot":"no-more"},slot:"no-more"}),_vm._v(" "),_c('div',{attrs:{"slot":"no-results"},slot:"no-results"})])],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"downloadReportsModal",attrs:{"hide-header-close":"","id":"reportContent","title":_vm.$t('ANALYTICS.REPORT_CONTENT'),"header-bg-variant":"light","centered":""}},[_c('b-card',[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.DATE_RANGE'))+" ")]),_vm._v(" "),_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"4"}},[_c('date-picker',{attrs:{"range":"","lang":"en","format":"YYYY-MM-DD","clearable":false,"width":"220px","confirm":""},model:{value:(_vm.dateRangeCSV),callback:function ($$v) {_vm.dateRangeCSV=$$v},expression:"dateRangeCSV"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.FILTER_BY'))+" ")]),_vm._v(" "),_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"4"}},[_c('b-form-select',{attrs:{"id":"filterBy","options":_vm.filterOptions},model:{value:(_vm.selectedDateFilterTypeCSV),callback:function ($$v) {_vm.selectedDateFilterTypeCSV=$$v},expression:"selectedDateFilterTypeCSV"}})],1)],1),_vm._v(" "),(_vm.isAdminRole)?_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(" "+_vm._s(_vm.$t('TEAMS.TEAMS'))+" ")]),_vm._v(" "),_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"4"}},[_c('b-form-select',{staticStyle:{"text-transform":"capitalize"},attrs:{"id":"filterBy","options":_vm.teams},model:{value:(_vm.expTeamID),callback:function ($$v) {_vm.expTeamID=$$v},expression:"expTeamID"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(" "+_vm._s(_vm.$t('Users'))+" ")]),_vm._v(" "),_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"4"}},[_c('b-form-select',{staticStyle:{"text-transform":"capitalize"},attrs:{"id":"filterBy","options":_vm.users},model:{value:(_vm.expUserID),callback:function ($$v) {_vm.expUserID=$$v},expression:"expUserID"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"11"}},[_c('p',{staticStyle:{"text-align":"left","color":"red"}},[_vm._v(" *"+_vm._s(_vm.$t('ANALYTICS.RECENT_FORM_MSG'))+" ")])])],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.generateCSV}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.GENERATE'))+" ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":_vm.hidedownloadReportsModal}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CLOSE'))+" ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formsInsights_vue__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formsInsights_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formsInsights_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formsInsights_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formsInsights_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_677364b4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formsInsights_vue__ = __webpack_require__(1195);
function injectStyle (ssrContext) {
  __webpack_require__(1193)
  __webpack_require__(1194)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-677364b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formsInsights_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_677364b4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formsInsights_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn reports"},[_c('b-card',{attrs:{"no-body":""}},[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',{staticClass:"bg-white",attrs:{"no-body":""}},[_c('b-row',{staticClass:"p-0",attrs:{"slot":"header"},slot:"header"},[_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"3"}},[_c('h5',[_vm._v(" Forms Report")])]),_vm._v(" "),_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"1.5"}},[_c('h6',[_vm._v(" "+_vm._s(_vm.$t('COMMON.DATE_RANGE'))+" ")])]),_vm._v(" "),_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"3"}},[_c('date-picker',{attrs:{"range":"","lang":"en","format":"YYYY-MM-DD","append-to-body":"","clearable":false,"width":"220px"},model:{value:(_vm.formsDateRange),callback:function ($$v) {_vm.formsDateRange=$$v},expression:"formsDateRange"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"1"}},[_c('b-button',{on:{"click":_vm.fetchFormStatusReports}},[_vm._v("Fetch")])],1)],1),_vm._v(" "),_c('b-card-body',[_c('b-row',[_c('b-col',{attrs:{"md":"12","lg":"12"}},[_c('router-link',{attrs:{"to":{ path: '/process/processed'}}},[_c('b-card',{staticClass:"dash-box",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-6"},[_c('b-row',{staticClass:"dash-row"},[_c('b-col',{attrs:{"cols":"10"}},[_c('h1',{staticClass:"mb-0"},[_vm._v("Processed Forms")]),_vm._v(" "),_c('div',{staticClass:"process-datas"},_vm._l((_vm.processedFormsCounts),function(count,processed){return _c('div',[(_vm.processedFormsStatus.includes(processed))?_c('div',{staticClass:"process-data"},[_c('h4',{class:'processed-' + processed},[_c('animated-number',{attrs:{"value":count || 0,"formatValue":_vm.formatNumber,"duration":1500}})],1),_vm._v(" "),_c('h3',{},[_vm._v(" "+_vm._s(_vm.$t('COMMON.'+processed.toUpperCase()))+" ")])]):_vm._e()])}))]),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.svg.forms)}})])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12","lg":"12"}},[_c('router-link',{attrs:{"to":{ path: '/process/processed'}}},[_c('b-card',{staticClass:"dash-box",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-6"},[_c('b-row',{staticClass:"dash-row"},[_c('b-col',{attrs:{"cols":"10"}},[_c('h1',{staticClass:"mb-0"},[_vm._v("Triage Forms")]),_vm._v(" "),_c('div',{staticClass:"process-datas"},_vm._l((_vm.triageFormsCounts),function(count,processed){return _c('div',[(_vm.triagedFormsStatus.includes(processed))?_c('div',{staticClass:"process-data"},[_c('h4',{class:'processed-' + processed},[_c('animated-number',{attrs:{"value":count || 0,"formatValue":_vm.formatNumber,"duration":1500}})],1),_vm._v(" "),_c('h3',{},[_vm._v(" "+_vm._s(_vm.$t('COMMON.'+processed.toUpperCase()))+" ")])]):_vm._e()])}))]),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.svg.forms)}})])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12","lg":"12"}},[_c('router-link',{attrs:{"to":{ path: '/process/processed'}}},[_c('b-card',{staticClass:"dash-box",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-6"},[_c('b-row',{staticClass:"dash-row"},[_c('b-col',{attrs:{"cols":"10"}},[_c('h1',{staticClass:"mb-0"},[_vm._v("Unmatched Forms")]),_vm._v(" "),_c('div',{staticClass:"process-datas"},_vm._l((_vm.unmatchedFormsCounts),function(count,processed){return _c('div',[(_vm.unmatchedFormsStatus.includes(processed))?_c('div',{staticClass:"process-data"},[_c('h4',{class:'processed-' + processed},[_c('animated-number',{attrs:{"value":count || 0,"formatValue":_vm.formatNumber,"duration":1500}})],1),_vm._v(" "),_c('h3',{},[_vm._v(" "+_vm._s(_vm.$t('COMMON.'+processed.toUpperCase()))+" ")])]):_vm._e()])}))]),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.svg.forms)}})])],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"id":"recent-forms"}},[_c('b-card',{staticClass:"received-form",attrs:{"no-body":"","bg-variant":"light"}},[_c('b-row',{staticClass:"p-0",attrs:{"slot":"header"},slot:"header"},[_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"3"}},[_c('h5',[_vm._v(_vm._s(_vm.$t('ANALYTICS.FORMS_INSIGHTS')))])]),_vm._v(" "),_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"1.5"}},[_c('h6',[_vm._v(" "+_vm._s(_vm.$t('COMMON.DATE_RANGE'))+" ")])]),_vm._v(" "),_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"4"}},[_c('date-picker',{attrs:{"range":"","lang":"en","format":"YYYY-MM-DD","append-to-body":"","clearable":false,"width":"220px"},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"1"}},[_c('b-button',{on:{"click":_vm.fetchProcessedForms}},[_vm._v("Fetch")])],1),_vm._v(" "),_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"2"}},[_c('b-button',{on:{"click":_vm.downloadFormsInsights}},[_vm._v("Download")])],1)],1),_vm._v(" "),_c('div',{staticClass:"report-table"},[(_vm.showProcessedForms)?_c('b-table',{attrs:{"show-empty":"","striped":"","empty-text":_vm.$t('COMMON.NO_RECORD'),"hover":"","responsive":"sm","variant":"danger","items":_vm.dailyReports,"fields":_vm.tableFields,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event}},scopedSlots:_vm._u([{key:"HEAD_title",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_username",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_total_page_count",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_average_confidence",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_total_fields",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_transcribed_fields",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_accuracy_percentage",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_edited_fields",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_status",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_created_at",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_updated_at",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_document_recieved_at",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_time_difference",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}}])}):_c('content-placeholders',[_c('content-placeholders-text',{attrs:{"lines":12}})],1),_vm._v(" "),_c('infinite-loading',{ref:"infiniteLoading",attrs:{"distance":_vm.distance,"spinner":"spiral"},on:{"infinite":_vm.dailyReportsInfinetHandler}},[_c('div',{attrs:{"slot":"no-more"},slot:"no-more"}),_vm._v(" "),_c('div',{attrs:{"slot":"no-results"},slot:"no-results"})])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_auditLogs_vue__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_auditLogs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_auditLogs_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_auditLogs_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_auditLogs_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05de6650_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_auditLogs_vue__ = __webpack_require__(1198);
function injectStyle (ssrContext) {
  __webpack_require__(1197)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05de6650"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_auditLogs_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05de6650_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_auditLogs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn reports"},[_c('b-card',{staticClass:"received-form",attrs:{"no-body":"","bg-variant":"light"}},[_c('b-row',{staticClass:"p-0 d-flex align-items-center",attrs:{"slot":"header"},slot:"header"},[_c('b-col',{staticClass:"col",staticStyle:{"z-index":"100"},attrs:{"md":"3"}},[_c('multiselect',{staticClass:"custom-multiselect",attrs:{"limit":1,"placeholder":"Filter by Username","options":_vm.setUsernames,"track-by":"text","label":"text","multiple":true},model:{value:(_vm.usernames),callback:function ($$v) {_vm.usernames=$$v},expression:"usernames"}})],1),_vm._v(" "),_c('b-col',{staticClass:"col",staticStyle:{"z-index":"100"},attrs:{"md":"3"}},[_c('b-input-group',[_c('b-form-input',{ref:"searchInput",attrs:{"placeholder":"Search by File Name/ Status"},on:{"input":_vm.filterBySearch}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"col",attrs:{"md":"3"}},[_c('b-row',{staticClass:"d-flex align-items-center"},[_c('b-col',{staticClass:"mt-auto",attrs:{"md":"1.5"}},[_c('h6',[_vm._v(_vm._s(_vm.$t('COMMON.DATE_RANGE')))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('date-picker',{attrs:{"range":"","lang":"en","shortcuts":_vm.shortcuts,"format":"YYYY-MM-DD","append-to-body":"","clearable":false,"width":"210px"},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"col",attrs:{"md":"3"}},[_c('b-row',[_c('div',[_c('b-button',{staticClass:"mt-auto",staticStyle:{"margin-right":"3px"},on:{"click":_vm.fetchProcessedForms}},[_vm._v("Fetch")]),_vm._v(" "),_c('b-button',{staticClass:"mt-auto",staticStyle:{"margin-right":"3px"},on:{"click":_vm.clearFilters}},[_vm._v("Clear")]),_vm._v(" "),_c('b-dropdown',{staticClass:"mt-1 panel-option",attrs:{"no-caret":""}},[_c('template',{slot:"button-content"},[_c('div',[_c('i',{staticClass:"fa fa-cloud-download",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.downloadFormsInsights}},[_vm._v("Download")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.downloadAllFormLogs}},[_vm._v("Download View Logs")])],2)],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"forms-table"},[(_vm.showProcessedForms)?_c('b-table',{attrs:{"show-empty":"","striped":"","empty-text":_vm.$t('COMMON.NO_RECORD'),"hover":"","responsive":"sm","variant":"danger","filter":_vm.searchFilter,"items":_vm.dailyReports,"fields":_vm.tableFields,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event}},scopedSlots:_vm._u([{key:"HEAD_title",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"title",fn:function(data){return [_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.d100.topleft.viewport",modifiers:{"hover":true,"d100":true,"topleft":true,"viewport":true}}],attrs:{"title":data.item.title}},[_vm._v(_vm._s(data.item.title))])]}},{key:"HEAD_username",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"username",fn:function(data){return [_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.viewport",modifiers:{"viewport":true}}],attrs:{"title":data.item.username}},[_vm._v(_vm._s(data.item.username))])]}},{key:"HEAD_document_type",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"document_type",fn:function(data){return [_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.viewport",modifiers:{"viewport":true}}],attrs:{"title":data.item.document_type}},[_vm._v(_vm._s(data.item.document_type))])]}},{key:"HEAD_total_page_count",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_average_confidence",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_total_fields",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_transcribed_fields",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_accuracy_percentage",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_edited_fields",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_status",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"status",fn:function(data){return [_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.viewport",modifiers:{"viewport":true}}],attrs:{"title":data.item.status}},[_vm._v(_vm._s(data.item.status))])]}},{key:"HEAD_created_at",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"created_at",fn:function(data){return [_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.viewport",modifiers:{"viewport":true}}],attrs:{"title":data.item.created_at}},[_vm._v(_vm._s(data.item.created_at))])]}},{key:"HEAD_updated_at",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"updated_at",fn:function(data){return [_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.viewport",modifiers:{"viewport":true}}],attrs:{"title":data.item.updated_at}},[_vm._v(_vm._s(data.item.updated_at))])]}},{key:"HEAD_document_recieved_at",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"document_recieved_at",fn:function(data){return [_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.viewport",modifiers:{"viewport":true}}],attrs:{"title":data.item.document_recieved_at}},[_vm._v(_vm._s(data.item.document_recieved_at))])]}},{key:"HEAD_time_difference",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_actions",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"actions",fn:function(data){return [_c('div',{staticClass:"btn btn-group"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.viewport",modifiers:{"hover":true,"viewport":true}}],staticClass:"btn-primary btn-sm",staticStyle:{"margin-right":"7px"},attrs:{"title":"View Logs"},on:{"click":function($event){_vm.showLogs(data.item.id, 1)}}},[_c('i',{staticClass:"fa fa-file",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.viewport",modifiers:{"hover":true,"viewport":true}}],staticClass:"btn-primary btn-sm",attrs:{"title":"Download CSV"},on:{"click":function($event){_vm.downloadFormLogs(data.item.id, data.item.title)}}},[_c('i',{staticClass:"icon-cloud-download"})])],1)]}}])}):_c('content-placeholders',[_c('content-placeholders-text',{attrs:{"lines":12}})],1),_vm._v(" "),_c('infinite-loading',{ref:"infiniteLoading",attrs:{"distance":_vm.distance,"spinner":"spiral"},on:{"infinite":_vm.dailyReportsInfinetHandler}},[_c('div',{attrs:{"slot":"no-more"},slot:"no-more"}),_vm._v(" "),_c('div',{attrs:{"slot":"no-results"},slot:"no-results"})])],1)],1),_vm._v(" "),_c('b-modal',{ref:"formLogsTable",attrs:{"title":"Form Logs","size":"lg","centered":""},on:{"hidden":function($event){_vm.auditLogs = [], _vm.isLogsLoaded = false}}},[_c('b-container',{attrs:{"fluid":""}},[(_vm.auditLogs.length && _vm.isLogsLoaded)?_c('div',{staticClass:"forms-table"},[_c('b-table',{attrs:{"striped":"","hover":"","bordered":true,"fields":_vm.logFields,"items":_vm.auditLogs,"per-page":_vm.logsPerPage,"current-page":_vm.logsCurrentPage,"aria-controls":"logs-table"},scopedSlots:_vm._u([{key:"file_name",fn:function(data){return [_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.d100.topleft.viewport",modifiers:{"hover":true,"d100":true,"topleft":true,"viewport":true}}],staticClass:"ellipsis",attrs:{"title":data.item.file_name}},[_vm._v(_vm._s(data.item.file_name))])]}},{key:"field_name",fn:function(data){return [_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.d100.topleft.viewport",modifiers:{"hover":true,"d100":true,"topleft":true,"viewport":true}}],staticClass:"ellipsis",attrs:{"title":data.item.field_name}},[_vm._v(_vm._s(data.item.field_name))])]}},{key:"original_text",fn:function(data){return [_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.d100.topleft.viewport",modifiers:{"hover":true,"d100":true,"topleft":true,"viewport":true}}],staticClass:"ellipsis",attrs:{"title":data.item.original_text}},[_vm._v(_vm._s(data.item.original_text))])]}},{key:"modified_text",fn:function(data){return [_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.d100.topleft.viewport",modifiers:{"hover":true,"d100":true,"topleft":true,"viewport":true}}],staticClass:"ellipsis",attrs:{"title":data.item.modified_text}},[_vm._v(_vm._s(data.item.modified_text))])]}},{key:"updated_by",fn:function(data){return [_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.d100.topleft.viewport",modifiers:{"hover":true,"d100":true,"topleft":true,"viewport":true}}],staticClass:"ellipsis",attrs:{"title":data.item.updated_by}},[_vm._v(_vm._s(data.item.updated_by))])]}},{key:"updated_at",fn:function(data){return [_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.d100.topleft.viewport",modifiers:{"hover":true,"d100":true,"topleft":true,"viewport":true}}],staticClass:"ellipsis",attrs:{"title":data.item.updated_at}},[_vm._v(_vm._s(data.item.updated_at))])]}}])}),_vm._v(" "),_c('b-pagination',{attrs:{"align":"center","id":"logs-table","total-rows":_vm.logsRow,"per-page":_vm.logsPerPage},model:{value:(_vm.logsCurrentPage),callback:function ($$v) {_vm.logsCurrentPage=$$v},expression:"logsCurrentPage"}})],1):(_vm.isLogsLoaded)?_c('div',[_vm._v("\n          No logs available\n        ")]):_c('div',[_c('content-placeholders',[_c('content-placeholders-img',{staticStyle:{"height":"765px"}})],1)],1)]),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"dark"},on:{"click":function($event){_vm.$refs.formLogsTable.hide()}}},[_vm._v(" Close ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Trail_vue__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Trail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Trail_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Trail_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Trail_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36452cf0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Trail_vue__ = __webpack_require__(1201);
function injectStyle (ssrContext) {
  __webpack_require__(1200)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36452cf0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Trail_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36452cf0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Trail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('SearchBar',{attrs:{"title":_vm.$t('ROUTE_NAME.Log History')},on:{"filterInput":_vm.setFilter}}),_vm._v(" "),_c('div',{staticClass:"logs-table"},[(_vm.logsLoaded)?_c('b-table',{attrs:{"striped":"","hover":"","show-empty":"","filter":_vm.filter,"empty-text":_vm.$t('COMMON.NO_RECORD'),"responsive":"sm","items":_vm.getTrailsData,"fields":_vm.tableFields,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event}},scopedSlots:_vm._u([{key:"HEAD_action",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_path",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_location",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_logged_at",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}}])}):_c('b-card',[_c('content-placeholders',[_c('content-placeholders-img',{style:({height: '400px'})})],1)],1),_vm._v(" "),_c('infinite-loading',{ref:"infiniteLoading",attrs:{"distance":_vm.distance,"spinner":"spiral"},on:{"infinite":_vm.infiniteHandler}},[_c('div',{attrs:{"slot":"no-more"},slot:"no-more"}),_vm._v(" "),_c('div',{attrs:{"slot":"no-results"},slot:"no-results"})])],1),_vm._v(" "),_c('b-modal',{ref:"downloadLogsModal",attrs:{"hide-header-close":"","title":_vm.$t('TRAILS.CUSTOM_DATE_LOGS'),"header-bg-variant":"light","centered":""}},[_c('b-card',[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"3"}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.DATE_RANGE'))+" ")]),_vm._v(" "),_c('b-col',{staticClass:"mt-auto",attrs:{"sm":"4"}},[_c('date-picker',{attrs:{"range":"","lang":"en","format":"YYYY-MM-DD","clearable":false,"width":"220px","confirm":"","click":_vm.verifyDateRange()},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})],1)],1),_vm._v(" "),(_vm.verifyDays)?_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.$t('COMMON.MSG_CSV_LOG_DAYS_ERROR')))]):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"text-align":"left","color":"red"}},[_vm._v(" * "+_vm._s(_vm.$t('COMMON.MSG_CSV_LOG_DAYS')))])],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"secondary","disabled":_vm.verifyDays},on:{"click":function($event){_vm.download_logs()}}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.GENERATE'))+" ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":_vm.hidedownloadLogsModal}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CLOSE'))+" ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeatureFlag_vue__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeatureFlag_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeatureFlag_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeatureFlag_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeatureFlag_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e127c61_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeatureFlag_vue__ = __webpack_require__(1211);
function injectStyle (ssrContext) {
  __webpack_require__(1203)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e127c61"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeatureFlag_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e127c61_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeatureFlag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateFeatureFlag = exports.getAllFeatureFlags = undefined;

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var getAllFeatureFlags = exports.getAllFeatureFlags = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(idToken) {
    var response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _vue2.default.axios.get('/feature_flags', { headers: { Authorization: 'Bearer ' + idToken } });

          case 2:
            response = _context.sent;
            return _context.abrupt('return', response.data);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function getAllFeatureFlags(_x) {
    return _ref.apply(this, arguments);
  };
}();

var updateFeatureFlag = exports.updateFeatureFlag = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(idToken, selectedFeatureFlag) {
    var data, response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            data = {
              id: selectedFeatureFlag.id,
              is_enabled: selectedFeatureFlag.is_enabled
            };
            _context2.next = 3;
            return _vue2.default.axios.patch('/feature_flags/' + selectedFeatureFlag.id, data, { headers: { Authorization: 'Bearer ' + idToken } });

          case 3:
            response = _context2.sent;
            return _context2.abrupt('return', response.data);

          case 5:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function updateFeatureFlag(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableLoading_vue__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableLoading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableLoading_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableLoading_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableLoading_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d786b630_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableLoading_vue__ = __webpack_require__(1207);
function injectStyle (ssrContext) {
  __webpack_require__(1206)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d786b630"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableLoading_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d786b630_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableLoading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"tg"},[_c('tr',[_c('th',{staticClass:"tg-cly1"},[_c('div',{staticClass:"line"})]),_vm._v(" "),_c('th',{staticClass:"tg-cly1"},[_c('div',{staticClass:"line"})]),_vm._v(" "),_c('th',{staticClass:"tg-cly1"},[_c('div',{staticClass:"line"})]),_vm._v(" "),_c('th',{staticClass:"tg-cly1"},[_c('div',{staticClass:"line"})])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"tg-cly1"},[_c('div',{staticClass:"line"})]),_vm._v(" "),_c('td',{staticClass:"tg-cly1"},[_c('div',{staticClass:"line"})]),_vm._v(" "),_c('td',{staticClass:"tg-cly1"},[_c('div',{staticClass:"line"})]),_vm._v(" "),_c('td',{staticClass:"tg-cly1"},[_c('div',{staticClass:"line"})])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"tg-cly1"},[_c('div',{staticClass:"line"})]),_vm._v(" "),_c('td',{staticClass:"tg-cly1"},[_c('div',{staticClass:"line"})]),_vm._v(" "),_c('td',{staticClass:"tg-cly1"},[_c('div',{staticClass:"line"})]),_vm._v(" "),_c('td',{staticClass:"tg-cly1"},[_c('div',{staticClass:"line"})])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"tg-cly1"},[_c('div',{staticClass:"line"})]),_vm._v(" "),_c('td',{staticClass:"tg-cly1"},[_c('div',{staticClass:"line"})]),_vm._v(" "),_c('td',{staticClass:"tg-cly1"},[_c('div',{staticClass:"line"})]),_vm._v(" "),_c('td',{staticClass:"tg-cly1"},[_c('div',{staticClass:"line"})])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"tg-cly1"},[_c('div',{staticClass:"line"})]),_vm._v(" "),_c('td',{staticClass:"tg-cly1"},[_c('div',{staticClass:"line"})]),_vm._v(" "),_c('td',{staticClass:"tg-cly1"},[_c('div',{staticClass:"line"})]),_vm._v(" "),_c('td',{staticClass:"tg-cly1"},[_c('div',{staticClass:"line"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeaturesSearchBar_vue__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeaturesSearchBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeaturesSearchBar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeaturesSearchBar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeaturesSearchBar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e1e60f7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeaturesSearchBar_vue__ = __webpack_require__(1210);
function injectStyle (ssrContext) {
  __webpack_require__(1209)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e1e60f7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeaturesSearchBar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e1e60f7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeaturesSearchBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-primary tab-header"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"p-3 d-flex align-items-center flex-container",attrs:{"slot":"header"},slot:"header"},[_c('b-col',{attrs:{"md":"6"}},[_c('h5',{staticClass:"bg-primary p-3 my-auto"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-row',{staticStyle:{"display":"flex","justify-content":"flex-end"}},[_c('b-col',{staticClass:"col",staticStyle:{"z-index":"100"},attrs:{"md":"6"}},[_c('b-input-group',[_c('b-form-input',{ref:"searchInput",staticClass:"search-text",attrs:{"placeholder":_vm.$t('WORKFLOW.SEARCH')},on:{"input":_vm.emitInput}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showClear),expression:"showClear"}],staticClass:"clear-btn",domProps:{"innerHTML":_vm._s(_vm.svg.broom)},on:{"click":_vm.clearFilter}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"col",staticStyle:{"z-index":"100"},attrs:{"md":"6"}},[_c('multiselect',{staticClass:"custom-multiselect",attrs:{"options":_vm.editedOptions,"track-by":"title","label":"title","value":_vm.editedByValue,"close-on-select":true,"custom-label":_vm.customLabel,"show-labels":false,"preselect-first":true,"placeholder":"Edited By","multiple":true},on:{"remove":function($event){_vm.optionRemoved($event)},"select":function($event){_vm.optionAdded($event)}},scopedSlots:_vm._u([{key:"option",fn:function(props){return [_c('div',{staticClass:"option__desc"},[_c('div',{staticClass:"avatar"},[_vm._v(_vm._s(props.option.title[0]))]),_vm._v(" "),_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.isSelected(props.option.title)}}),_vm._v(" "),_c('span',{staticClass:"option__title"},[_vm._v(_vm._s(props.option.title))])])]}}])})],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"animated fadeIn features"},[_c('b-card',{staticClass:"received-form",attrs:{"no-body":""}},[_c('div',{staticClass:"features-table"},[_c('SearchBar',{attrs:{"editedOptions":_vm.editedOptions,"editedByValue":_vm.editedByValue,"title":"Features Flags"},on:{"filterInput":_vm.setFilter,"update:editByValue":_vm.editByUserName}}),_vm._v(" "),_c('b-table',{attrs:{"show-empty":"","striped":"","empty-text":_vm.$t('COMMON.NO_RECORD'),"hover":"","responsive":"sm","variant":"danger","items":_vm.sortedFeatureFlags,"filter":_vm.filter,"fields":_vm.tableFields,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event}},scopedSlots:_vm._u([{key:"HEAD_is_enabled",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"is_enabled",fn:function(data){return [_c('cSwitch',{attrs:{"type":"3d","variant":"success","checked":data.item.is_enabled},on:{"change":function($event){_vm.updateIndividualFeatureFlag($event,data.item)}}})]}}])})],1)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fe0e53e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__ = __webpack_require__(1214);
function injectStyle (ssrContext) {
  __webpack_require__(1213)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fe0e53e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"justify-content-center"},[_c('div',{staticClass:"bg-white not-found",domProps:{"innerHTML":_vm._s(_vm.svg.notFound)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_users_vue__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_users_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_users_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_users_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_users_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_851df58c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_users_vue__ = __webpack_require__(1220);
function injectStyle (ssrContext) {
  __webpack_require__(1216)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-851df58c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_users_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_851df58c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersSearchBar_vue__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersSearchBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersSearchBar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersSearchBar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersSearchBar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67a20993_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersSearchBar_vue__ = __webpack_require__(1219);
function injectStyle (ssrContext) {
  __webpack_require__(1218)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67a20993"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersSearchBar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67a20993_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersSearchBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-primary tab-header"},[_c('h5',{staticClass:"p-3 bg-primary my-auto"},[_vm._v(" "+_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"pr-5 pd-0 col-sm-6 search"},[(_vm.isSuperAdmin)?_c('h5',{staticClass:"p-3 col-sm-3 bg-primary my-auto"},[_vm._v(" "+_vm._s(_vm.$t('USERS.ACCOUNT'))+" ")]):_vm._e(),_vm._v(" "),(_vm.isSuperAdmin)?_c('b-input-group',{staticClass:"p-2 col-sm-3 input-group"},[_c('b-form-select',{staticClass:"selectbox",attrs:{"plain":true,"options":_vm.accounts},on:{"input":_vm.filterByAccount},model:{value:(_vm.selectedAccount),callback:function ($$v) {_vm.selectedAccount=$$v},expression:"selectedAccount"}})],1):_vm._e(),_vm._v(" "),_c('h5',{staticClass:"p-3 col-sm-2 bg-primary my-auto"},[_vm._v(" "+_vm._s(_vm.$t('USERS.ROLE'))+" ")]),_vm._v(" "),_c('b-input-group',{staticClass:"p-2 col-sm-4 input-group"},[_c('b-form-select',{staticClass:"selectbox",attrs:{"plain":true,"options":_vm.roles},on:{"input":_vm.filterByRole},model:{value:(_vm.selectedRole),callback:function ($$v) {_vm.selectedRole=$$v},expression:"selectedRole"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"p-3 pr-5 pd-0 col-lg-3 search"},[_vm._m(0),_vm._v(" "),_c('b-input-group',[_c('b-form-input',{ref:"searchInput",staticClass:"search-text",attrs:{"placeholder":_vm.$t('WORKFLOW.SEARCH')},on:{"input":_vm.emitInput}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showClear),expression:"showClear"}],staticClass:"clear-btn",domProps:{"innerHTML":_vm._s(_vm.svg.broom)},on:{"click":_vm.clearFilter}})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-icon"},[_c('i',{staticClass:"fa fa-search"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('UsersSearchBar',{attrs:{"title":_vm.$t('COMMON.USERS'),"roles":_vm.roles,"accounts":_vm.accounts},on:{"filterInput":_vm.setFilter,"filterByAccount":_vm.filterByAccount,"filterByRole":_vm.filterByRole}}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[(_vm.usersLoaded)?_c('b-table',{attrs:{"hover":"","striped":"","show-empty":"","empty-text":_vm.$t('COMMON.NO_RECORD'),"responsive":"sm","items":_vm.users,"fields":_vm.tableFields,"filter":_vm.filter},scopedSlots:_vm._u([{key:"HEAD_username",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"username",fn:function(data){return [_c('router-link',{attrs:{"id":"users","to":'/admin/users/' + data.item.id}},[_vm._v(" "+_vm._s(data.value)+"\n          ")])]}},{key:"HEAD_account_name",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"account_name",fn:function(data){return [(!_vm.isSuperAdmin)?_c('a',[_vm._v(" "+_vm._s(data.value)+" ")]):_c('router-link',{attrs:{"id":"users","to":'/super_admin/accounts/' + data.item.account_id}},[_vm._v(" "+_vm._s(data.value)+"\n          ")])]}},{key:"HEAD_role",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"HEAD_edit_link",fn:function(data){return [_c('em',[_vm._v(_vm._s(_vm.$t(data.label)))])]}},{key:"edit_link",fn:function(data){return !(data.item.role ==='Admin' && _vm.isAdmin)?[(data.item.status === 'ACTIVE')?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"size":"sm","variant":"success","title":_vm.$t('COMMON.DEACTIVATE')},on:{"click":function($event){_vm.deactivateUser(data.item.id)}}},[_vm._v("\n            "+_vm._s(data.item.status)+"\n          ")]):_c('router-link',{attrs:{"to":'/admin/users/' + data.item.id}},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"size":"sm","variant":"danger","title":_vm.$t('COMMON.ACTIVATE')}},[_vm._v("\n              "+_vm._s(data.item.status)+"\n            ")])],1),_vm._v(" "),(data.item.is_blocked)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"size":"sm","variant":"success","title":_vm.$t('COMMON.UNBLOCK')},on:{"click":function($event){_vm.unblockUser(data.item.id)}}},[_vm._v("\n            UNBLOCK\n          ")]):_vm._e(),_vm._v(" "),_c('router-link',{attrs:{"to":'/admin/users/' + data.item.id}},[(_vm.checkAdmin(data.item))?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"ml-2",attrs:{"size":"sm","variant":"primary","title":_vm.$t('COMMON.EDT_USR')}},[_vm._v(_vm._s(_vm.$t('COMMON.EDIT').toUpperCase()))]):_vm._e()],1)]:undefined}}])}):_c('b-card',[_c('content-placeholders',[_c('content-placeholders-img',{style:({height: '400px'})})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newUser_vue__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newUser_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newUser_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newUser_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newUser_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44b0c5a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newUser_vue__ = __webpack_require__(1225);
function injectStyle (ssrContext) {
  __webpack_require__(1222)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newUser_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44b0c5a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"md":"6","offset-md":"3"}},[_c('b-card',{staticClass:"user-form",attrs:{"header-class":"bg-primary","footer-class":"card-footer-between"}},[_c('div',{staticClass:"user-form-header",attrs:{"slot":"header"},slot:"header"},[(_vm.editUser)?_c('strong',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.$t('COMMON.EDIT'))+" "+_vm._s(_vm.$t('COMMON.USERS')))]):_c('strong',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.$t('USERS.ADD_NEW')))])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('COMMON.NAME')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.username),expression:"user.username"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.user.username.$error, 'is-valid': !_vm.$v.user.username.$invalid},attrs:{"type":"text","placeholder":_vm.$t('COMMON.NAME')},domProps:{"value":(_vm.user.username)},on:{"blur":function($event){_vm.$v.user.username.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "username", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.user.username.required)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('USERS.REQ_USERNAME')))]):_vm._e(),_vm._v(" "),(!_vm.$v.user.username.alphaNum)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('USERS.REQ_ONLY_ALPHANUM')))]):_vm._e(),_vm._v(" "),(!_vm.$v.user.username.minLen)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('USERS.REQ_MIN_LENGTH')))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('USERS.EMAIL')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.email),expression:"user.email"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.user.email.$error, 'is-valid': !_vm.$v.user.email.$invalid},attrs:{"type":"email","placeholder":_vm.$t('USERS.EMAIL')},domProps:{"value":(_vm.user.email)},on:{"blur":function($event){_vm.$v.user.email.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "email", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.user.email.required)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('USERS.REQ_EMAIL')))]):_vm._e(),_vm._v(" "),(!_vm.$v.user.email.email)?_c('b-form-invalid-feedback',[_vm._v(" "+_vm._s(_vm.$t('USERS.REQ_VALID_EMAIL')))]):_vm._e()],1),_vm._v(" "),(_vm.editUser)?_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('COMMON.STATUS'))+" ")]),_vm._v(" "),_c('span',{staticStyle:{"color":"blue","font-style":"italic"}},[_vm._v(" * Deactivated users will be activated with update. ")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":"ACTIVE","disabled":""}})]):_vm._e(),_vm._v(" "),(_vm.isSuperAdmin)?_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('COMMON.ACCOUNT')))]),_vm._v(" "),_c('b-form-select',{class:{'is-invalid': _vm.$v.user.account_id.$error, 'is-valid': !_vm.$v.user.account_id.$invalid},attrs:{"plain":true},model:{value:(_vm.user.account_id),callback:function ($$v) {_vm.$set(_vm.user, "account_id", $$v)},expression:"user.account_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"value":"","disabled":true}},[_vm._v(" Please select an account ")])]),_vm._v(" "),_vm._l((_vm.accounts),function(account){return _c('option',{domProps:{"value":account.id}},[_vm._v(_vm._s(_vm._f("capitalize")(account.name)))])})],2),_vm._v(" "),(!_vm.$v.user.account_id.required)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('USERS.REQ_ACCOUNT')))]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('USERS.ROLE')))]),_vm._v(" "),_c('b-form-select',{class:{'is-invalid': _vm.$v.user.role_id.$error, 'is-valid': !_vm.$v.user.role_id.$invalid},attrs:{"plain":true},model:{value:(_vm.user.role_id),callback:function ($$v) {_vm.$set(_vm.user, "role_id", $$v)},expression:"user.role_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"value":"","disabled":true}},[_vm._v(" "+_vm._s(_vm.$t('USERS.SELECT_ROLE'))+" ")])]),_vm._v(" "),_vm._l((_vm.roles),function(role){return _c('option',{domProps:{"value":role.id}},[_vm._v(_vm._s(_vm._f("capitalize")(role.name)))])})],2),_vm._v(" "),(_vm.roles.length === 0)?_c('div',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.$t('USERS.CREATE_ROLE')))]):_vm._e(),_vm._v(" "),(!_vm.$v.user.role_id.required)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('USERS.REQ_ROLE')))]):_vm._e()],1),_vm._v(" "),(_vm.teams.length > 0 && _vm.isAdmin)?_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('USERS.TEAM')))]),_vm._v(" "),_c('b-form-select',{attrs:{"plain":true},model:{value:(_vm.user.team_id),callback:function ($$v) {_vm.$set(_vm.user, "team_id", $$v)},expression:"user.team_id"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('USERS.SELECT_TEAM')))])]),_vm._v(" "),_vm._l((_vm.teams),function(team){return _c('option',{domProps:{"value":team.id}},[_vm._v(_vm._s(_vm._f("capitalize")(team.name)))])})],2)],1):_vm._e()],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"settings-block"},[(!_vm.editUser)?_c('div',{staticClass:"settings-container"},[_c('p',[_vm._v(_vm._s(_vm.$t('PROFILE.EMAIL_NOTIFY')))]),_vm._v(" "),_c('c-switch',{attrs:{"type":"3d","variant":"success","checked":this.user.notify},on:{"change":_vm.pSwitchChanged}})],1):_vm._e()])],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{staticClass:"padding-x-2",attrs:{"type":"submit","size":"sm","variant":"secondary"},on:{"click":function($event){_vm.formSubmit()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" "+_vm._s(_vm.$t('COMMON.SUBMIT')))]),_vm._v(" "),(this.editUser)?_c('b-button',{staticClass:"padding-x-2",attrs:{"type":"reset","size":"sm","variant":"gray"},on:{"click":function($event){_vm.cancelForm()}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancel")]):_c('b-button',{staticClass:"padding-x-2",attrs:{"type":"reset","size":"sm","variant":"gray"},on:{"click":function($event){_vm.resetForm()}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" "+_vm._s(_vm.$t('COMMON.RESET')))])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('user-form',{attrs:{"user":this.user,"roles":this.roles,"teams":this.teams,"accounts":this.accounts,"isSuperAdmin":this.isSuperAdmin,"isAdmin":this.isAdmin,"editUser":false},on:{"formSubmit":_vm.createUser,"formReset":_vm.resetForm}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editUser_vue__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editUser_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editUser_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editUser_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editUser_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bfdfce0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editUser_vue__ = __webpack_require__(1228);
function injectStyle (ssrContext) {
  __webpack_require__(1227)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editUser_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bfdfce0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('user-form',{attrs:{"user":this.user,"roles":this.roles,"teams":this.teams,"accounts":this.accounts,"isSuperAdmin":this.isSuperAdmin,"isAdmin":this.isAdmin,"editUser":true},on:{"formSubmit":_vm.updateUser,"cancelForm":_vm.cancelForm}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configurations_vue__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configurations_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configurations_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configurations_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configurations_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f7a4afa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_configurations_vue__ = __webpack_require__(1309);
function injectStyle (ssrContext) {
  __webpack_require__(1230)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configurations_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f7a4afa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_configurations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confidenceColors_vue__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confidenceColors_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confidenceColors_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confidenceColors_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confidenceColors_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75d6feaa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confidenceColors_vue__ = __webpack_require__(1241);
function injectStyle (ssrContext) {
  __webpack_require__(1232)
  __webpack_require__(1233)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75d6feaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confidenceColors_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75d6feaa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confidenceColors_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_range_vue__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_range_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_range_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_range_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_range_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa0e2342_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_range_vue__ = __webpack_require__(1240);
function injectStyle (ssrContext) {
  __webpack_require__(1235)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fa0e2342"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_range_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa0e2342_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_range_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ColorPicker_vue__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ColorPicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ColorPicker_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ColorPicker_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ColorPicker_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e06d867_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ColorPicker_vue__ = __webpack_require__(1239);
function injectStyle (ssrContext) {
  __webpack_require__(1237)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e06d867"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ColorPicker_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e06d867_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ColorPicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  colors: [['#F86C6B', '#ea587c', '#cef46b', '#0dcc4b', '#FFA500'], ['#4DBD74', '#63C2DE', '#d28906', '#d4061b', '#01e1eb']]
};

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"no-border-shadow",attrs:{"tabindex":"0"}},_vm._l((_vm.colors),function(colorSets,index){return _c('b-row',{key:index,staticClass:"row-even"},_vm._l((colorSets),function(color,innerIndex){return _c('b-col',{key:innerIndex,staticClass:"p-0",attrs:{"cols":"2"}},[_c('div',{staticClass:"color",style:({backgroundColor: color}),on:{"click":function($event){_vm.emitColor(color)}}})])}))}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"range-container"},[_c('h2',[_vm._v(_vm._s(_vm.start)+" "),_c('span',[_vm._v("-")]),_vm._v(" "+_vm._s(_vm.end))]),_vm._v(" "),_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"text-right p-0 m-auto",attrs:{"cols":"1"}},[_vm._v("\n        0\n      ")]),_vm._v(" "),_c('b-col',{staticClass:"m-auto",attrs:{"cols":"8"}},[_c('div',[_c('b-progress',{attrs:{"max":100}},[_c('b-progress-bar',{attrs:{"value":_vm.start,"variant":"white"}}),_vm._v(" "),_c('b-progress-bar',{staticClass:"progress-slider",style:({backgroundColor: _vm.color}),attrs:{"value":(_vm.end - _vm.start)}}),_vm._v(" "),_c('b-progress-bar',{attrs:{"value":(100 - _vm.end),"variant":"white"}})],1)],1)]),_vm._v(" "),_c('b-col',{staticClass:"m-auto p-0 text-left",attrs:{"cols":"1"}},[_vm._v("\n        100\n      ")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('div',{staticClass:"selected-color",style:({backgroundColor: _vm.dataColor}),attrs:{"id":'popColorPick-'+_vm.start},on:{"click":_vm.focusPicker}},[_c('b-popover',{attrs:{"target":'popColorPick-'+_vm.start,"triggers":"click blur"}},[_c('ColorPicker',{ref:"colorpicker",on:{"colorSelected":_vm.setColor}})],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-row',{staticClass:"color_config_header"},[_c('b-col',{staticClass:"text-left",attrs:{"cols":"9"}},[_c('h4',[_vm._v(_vm._s(_vm.$t('CONFIGURED.RANGE')))])]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"cols":"3"}},[_c('h4',[_vm._v(_vm._s(_vm.$t('CONFIGURED.COLOR')))])])],1),_vm._v(" "),_c('b-table',{staticClass:"config-table",attrs:{"show-empty":"","empty-text":_vm.$t('COMMON.NO_RECORD'),"items":_vm.rangeColors,"fields":_vm.fields,"thead-class":"hidden_header"},scopedSlots:_vm._u([{key:"color_code",fn:function(data){return [_c('range',{attrs:{"start":data.item.min_range,"end":data.item.max_range,"color":data.item.color_code},on:{"colorSelected":function($event){data.item.color_code = $event}}})]}}])}),_vm._v(" "),_c('div',{attrs:{"slot":"footer","align":"center"},slot:"footer"},[_c('b-button',{staticClass:"button-style",attrs:{"type":"reset","variant":"gray"},on:{"click":_vm.resetColors}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" "+_vm._s(_vm.$t('COMMON.RESET')))]),_vm._v(" "),_c('b-button',{staticClass:"button-style",attrs:{"type":"submit","variant":"secondary"},on:{"click":_vm.updateColors}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('COMMON.SAVE'))+" ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processOrder_vue__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processOrder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processOrder_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processOrder_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processOrder_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1838d86c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processOrder_vue__ = __webpack_require__(1246);
function injectStyle (ssrContext) {
  __webpack_require__(1243)
  __webpack_require__(1244)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1838d86c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processOrder_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1838d86c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1245 */,
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-card',{staticClass:"multi-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('h5',[_vm._v(_vm._s(_vm.$t('CONFIGURED.FORM_ORDER')))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('div',{staticClass:"float-right add-field-btn"},[_c('i',{staticClass:"fa fa-lg mr-1 fa-info-circle",attrs:{"id":"popover-target"}},[_c('b-popover',{attrs:{"target":"popover-target","triggers":"hover","placement":"top"}},[_vm._v("\n                "+_vm._s(_vm.$t('COMMON.PROCESS_ORDER_INFO'))+"\n              ")])],1),_vm._v(" "),_c('b-button',{staticClass:"mt-0",attrs:{"type":"submit","size":"sm","variant":"secondary"},on:{"click":_vm.updateOrder}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('COMMON.SAVE')))])],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"timeline-div"},[_c('ul',{staticClass:"timeline timeline-horizontal"},[_c('draggable',{staticClass:"flex-container",attrs:{"options":{ group:'processing'}},model:{value:(_vm.processingOrders),callback:function ($$v) {_vm.processingOrders=$$v},expression:"processingOrders"}},_vm._l((_vm.processingOrders),function(processingOrder,index){return _c('li',{key:processingOrder.name,staticClass:"timeline-item"},[_c('div',{staticClass:"timeline-badge bg-primary"},[_c('strong',[_vm._v(_vm._s(index + 1))])]),_vm._v(" "),_c('div',{staticClass:"timeline-panel"},[_c('p',[_vm._v(_vm._s(_vm.getName(processingOrder.name)))])])])}))],1)]),_vm._v(" "),_c('em',{staticClass:"italic"},[_vm._v(_vm._s(_vm.$t('CONFIGURED.NOTE')))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_roleOrder_vue__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_roleOrder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_roleOrder_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_roleOrder_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_roleOrder_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac862a2a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_roleOrder_vue__ = __webpack_require__(1250);
function injectStyle (ssrContext) {
  __webpack_require__(1248)
  __webpack_require__(1249)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ac862a2a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_roleOrder_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac862a2a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_roleOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-card',{staticClass:"multi-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('h5',[_vm._v(_vm._s(_vm.$t('CONFIGURED.ROLE_ORDER')))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"float-right add-field-btn"},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.newRole",modifiers:{"newRole":true}}],staticClass:"mt-0",attrs:{"type":"submit","size":"sm","variant":"secondary"},on:{"click":_vm.clearRoleModal}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('CONFIGURED.ADD_ROLE'))+" ")])]),_vm._v(" "),_c('b-button',{staticClass:"mt-0",attrs:{"type":"submit","variant":"secondary","size":"sm"},on:{"click":_vm.updateRoleOrder}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('COMMON.SAVE')))])],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"timeline-div"},[_c('ul',{staticClass:"timeline timeline-horizontal"},[_c('draggable',{staticClass:"flex-container",attrs:{"options":{ group:'roles'}},model:{value:(_vm.selectedRoles),callback:function ($$v) {_vm.selectedRoles=$$v},expression:"selectedRoles"}},_vm._l((_vm.selectedRoles),function(role,index){return _c('li',{key:index,staticClass:"timeline-item"},[_c('div',{staticClass:"timeline-badge bg-primary"},[_c('strong',[_vm._v(_vm._s(index + 1))])]),_vm._v(" "),_c('div',{staticClass:"timeline-panel role-panel"},[_c('p',[_vm._v(_vm._s(_vm._f("titlize")(role['name'])))]),_vm._v(" "),_c('b-dropdown',{staticClass:"panel-option",attrs:{"no-caret":""}},[_c('template',{slot:"button-content"},[_c('div',[_c('i',{staticClass:"fa fa-ellipsis-v"})])]),_vm._v(" "),_c('b-dropdown-item',{directives:[{name:"b-modal",rawName:"v-b-modal.editRole",modifiers:{"editRole":true}}],on:{"click":function($event){_vm.setEditRole(role)}}},[_vm._v(_vm._s(_vm.$t('COMMON.EDIT')))]),_vm._v(" "),_c('b-dropdown-item',{directives:[{name:"b-modal",rawName:"v-b-modal.deleteRole",modifiers:{"deleteRole":true}}],on:{"click":function($event){_vm.setDeleteRole(role)}}},[_vm._v(_vm._s(_vm.$t('COMMON.DELETE')))])],2)],1)])}))],1)]),_vm._v(" "),_c('em',{staticClass:"italic"},[_vm._v(_vm._s(_vm.$t('CONFIGURED.ROLE_NOTE')))]),_vm._v(" "),_c('b-modal',{ref:"newRoleModal",attrs:{"hide-header-close":"","id":"newRole","title":_vm.$t('CONFIGURED.NEW_ROLE'),"header-bg-variant":"light","centered":""}},[_c('b-card',{staticClass:"mb-0 p-3"},[_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label":_vm.$t('CONFIGURED.ROLE_NAME'),"label-for":"roleName"}},[_c('b-form-input',{staticClass:"rolename",class:{'is-invalid': _vm.$v.newRoleName.$error, 'is-valid': !_vm.$v.newRoleName.$invalid},attrs:{"id":"roleName","type":"text","placeholder":_vm.$t('CONFIGURED.ROLE_NAME')},on:{"input":function($event){_vm.$v.newRoleName.$touch()}},model:{value:(_vm.newRoleName),callback:function ($$v) {_vm.newRoleName=$$v},expression:"newRoleName"}}),_vm._v(" "),(!_vm.$v.newRoleName.required)?_c('b-form-invalid-feedback',[_vm._v("Role Name can't be blank")]):_vm._e(),_vm._v(" "),(!_vm.$v.newRoleName.valid)?_c('b-form-invalid-feedback',[_vm._v("Role Name can't accept symbols")]):_vm._e(),_vm._v(" "),(!_vm.$v.newRoleName.minLength || !_vm.$v.newRoleName.maxLength)?_c('b-form-invalid-feedback',[_vm._v("Role Name length should be more than 3 and less than 15 characters")]):_vm._e(),_vm._v(" "),(!_vm.$v.newRoleName.isUnique)?_c('b-form-invalid-feedback',[_vm._v("Either role is already registered or not allowed.")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.createRole}},[_vm._v(" "+_vm._s(_vm.$t('CONFIGURED.CREATE'))+" ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":_vm.hideCreateRoleModal}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CLOSE'))+" ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"deleteRoleModal",attrs:{"hide-header-close":"","id":"deleteRole","title":"Role Delete Confirmation","header-bg-variant":"light","centered":""}},[_c('b-card',{staticClass:"mb-0"},[_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"cols":"12"}},[_c('p',[_vm._v("Are you sure you want to delete the role '"),_c('strong',{staticClass:"text-capitalize"},[_vm._v(_vm._s(_vm.selectedRole.name))]),_vm._v("' ?")]),_vm._v(" "),_c('p',[_vm._v("This may affect the forms and users under this role.")])])],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"danger"},on:{"click":_vm.deleteRole}},[_vm._v(" Delete ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":_vm.hideDeleteRoleModal}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CLOSE'))+" ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"editRoleModal",attrs:{"hide-header-close":"","id":"editRole","title":"Edit Role Name","header-bg-variant":"light","centered":""}},[_c('b-card',{staticClass:"mb-0 p-3"},[_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label":_vm.$t('CONFIGURED.ROLE_NAME'),"label-for":"roleName"}},[_c('b-form-input',{staticClass:"rolename",class:{'is-invalid': _vm.$v.newRoleName.$error, 'is-valid': !_vm.$v.newRoleName.$invalid},attrs:{"id":"roleName","type":"text","placeholder":_vm.$t('CONFIGURED.ROLE_NAME')},on:{"input":function($event){_vm.$v.newRoleName.$touch()}},model:{value:(_vm.newRoleName),callback:function ($$v) {_vm.newRoleName=$$v},expression:"newRoleName"}}),_vm._v(" "),(!_vm.$v.newRoleName.required)?_c('b-form-invalid-feedback',[_vm._v("Role Name can't be blank")]):_vm._e(),_vm._v(" "),(!_vm.$v.newRoleName.valid)?_c('b-form-invalid-feedback',[_vm._v("Role Name can't accept symbols")]):_vm._e(),_vm._v(" "),(!_vm.$v.newRoleName.minLength || !_vm.$v.newRoleName.maxLength)?_c('b-form-invalid-feedback',[_vm._v("Role Name length should be more than 3 and less than 15 characters")]):_vm._e(),_vm._v(" "),(!_vm.$v.newRoleName.isUnique)?_c('b-form-invalid-feedback',[_vm._v("Either role is already registered or not allowed.")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"secondary","disabled":_vm.$v.newRoleName.$error},on:{"click":_vm.editRole}},[_vm._v(" Change ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":_vm.hideEditRoleModal}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CLOSE'))+" ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processType_vue__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processType_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processType_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processType_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processType_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97144f24_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processType_vue__ = __webpack_require__(1254);
function injectStyle (ssrContext) {
  __webpack_require__(1252)
  __webpack_require__(1253)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-97144f24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processType_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97144f24_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-card',{staticClass:"multi-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('h5',[_vm._v(_vm._s(_vm.$t('CONFIGURED.PROCESS_TYPE')))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('div',{staticClass:"float-right add-field-btn"},[_c('b-button',{attrs:{"size":"sm","variant":"secondary","disabled":_vm.unsubscribedCategories.length === 1},on:{"click":_vm.handleSubscribeModal}},[_c('i',{staticClass:"fa fa-plus"}),_c('span',[_vm._v(" "+_vm._s(_vm.$t('COMMON.SUBSCRIBE'))+" ")])])],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"timeline-div"},[_c('ul',{staticClass:"timeline timeline-horizontal"},[_c('div',{staticClass:"flex-container"},_vm._l((_vm.accountCategories),function(category,index){return _c('li',{key:category,staticClass:"timeline-item"},[_c('div',{staticClass:"timeline-badge bg-primary"},[_c('strong',[_vm._v(_vm._s(index + 1))])]),_vm._v(" "),_c('div',{staticClass:"timeline-panel role-panel"},[_c('p',[_vm._v(_vm._s(_vm._f("titlize")(category)))]),_vm._v(" "),_c('b-dropdown',{staticClass:"panel-option",attrs:{"no-caret":""}},[_c('template',{slot:"button-content"},[_c('div',[_c('i',{staticClass:"fa fa-ellipsis-v"})])]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.handleUnsubscribeModal(category)}}},[_vm._v(_vm._s(_vm.$t('COMMON.UNSUBSCRIBE')))])],2)],1)])}))])])]),_vm._v(" "),_c('b-modal',{ref:"subscribeModal",attrs:{"hide-header-close":"","centered":"","title":_vm.$t('CONFIGURED.SUBSCRIBE_MODAL'),"ok-title":_vm.$t('COMMON.SUBSCRIBE'),"cancel-title":_vm.$t('COMMON.CANCEL'),"ok-variant":"secondary","cancel-variant":"light"},on:{"ok":_vm.subscribeNewCategory,"hidden":_vm.hideSubscribeModal}},[_c('b-card',{staticClass:"mb-0"},[_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-select',{staticClass:"form-control",attrs:{"plain":true,"options":_vm.unsubscribedCategories},model:{value:(_vm.selectedCategory),callback:function ($$v) {_vm.selectedCategory=$$v},expression:"selectedCategory"}})],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"unsubscribeModal",attrs:{"hide-header-close":"","centered":"","title":_vm.$t('CONFIGURED.UNSUBSCRIBE_MODAL'),"ok-title":_vm.$t('COMMON.UNSUBSCRIBE'),"cancel-title":_vm.$t('COMMON.CANCEL'),"ok-variant":"secondary","cancel-variant":"light"},on:{"ok":_vm.unsubscribeCategory,"hidden":_vm.hideUnSubscribeModal}},[_c('b-card',{staticClass:"mb-0"},[_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"cols":"12"}},[_c('p',[_vm._v("Are you sure want unscubscribe '"),_c('strong',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.selectedCategory)))]),_vm._v("' ?")]),_vm._v(" "),_c('p',[_vm._v("This will no longer be available for processing documents.")])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_externalServiceMaps_vue__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_externalServiceMaps_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_externalServiceMaps_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_externalServiceMaps_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_externalServiceMaps_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdb589ba_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_externalServiceMaps_vue__ = __webpack_require__(1257);
function injectStyle (ssrContext) {
  __webpack_require__(1256)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bdb589ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_externalServiceMaps_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdb589ba_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_externalServiceMaps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('div',[_c('b-row',{staticClass:"temp_mapping"},[_c('b-col',{attrs:{"md":"8"}},[_c('h4',[_vm._v(_vm._s(_vm.$t('Mappings')))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('div',{staticClass:"float-right add-field-btn"},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.externalService",modifiers:{"externalService":true}}],staticClass:"mt-0",attrs:{"type":"submit","size":"sm","variant":"secondary"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('Add new mapping'))+" ")])]),_vm._v(" "),_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.importMappings",modifiers:{"importMappings":true}}],staticClass:"mt-0",attrs:{"type":"submit","size":"sm","variant":"secondary"}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('CONFIGURED.IMPORT_MAPPINGS'))+" ")])])],1)])],1)],1)]),_vm._v(" "),_c('b-card',[_c('div',[_c('b-row',{staticClass:"temp_mapping"},[_c('b-col',{attrs:{"md":"6"}},[_c('b-row',[_c('b-col',{attrs:{"md":"5"}},[_vm._v("\n            "+_vm._s(_vm.$t('ACCOUNT.CURRENT_SALESFORCE_ORG'))+"\n          ")]),_vm._v(" "),_c('b-col',{attrs:{"md":"7"}},[_vm._v("\n            "+_vm._s(_vm.extServiceData.external_service_title)+"\n          ")])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-row',[_c('b-col',{attrs:{"md":"2"}},[_vm._v("\n            "+_vm._s(_vm.$t('ACCOUNT.CURRENT_SALESFORCE_URL'))+"\n          ")]),_vm._v(" "),_c('b-col',{attrs:{"md":"7"}},[_vm._v("\n            "+_vm._s(_vm.extServiceData.external_service_url)+"\n          ")])],1)],1)],1)],1)]),_vm._v(" "),_c('b-row',_vm._l((this.externalServiceMaps),function(map){return _c('b-col',{key:map.id,attrs:{"cols":"6"}},[_c('b-card',[_c('b-card',{attrs:{"border-variant":"info","align":"left"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('h5',[_vm._v(_vm._s(map.name))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('div',{staticClass:"float-right add-field-btn"},[_c('b-button',{staticClass:"mt-0",attrs:{"type":"submit","size":"sm","variant":"primary"},on:{"click":function($event){_vm.editExternalServiceMap(map.template_doc_id)}}},[_c('i',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('b-button',{staticClass:"mt-0",attrs:{"type":"submit","size":"sm","variant":"danger"},on:{"click":function($event){_vm.showDeleteModal(map.template_doc_id)}}},[_c('i',{staticClass:"fa fa-trash"})])],1)])],1)],1),_vm._v(" "),_c('p',{staticClass:"card-text"},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Integration Type:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_vm._v(_vm._s(map.integration_type))])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Connection Type:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_vm._v(_vm._s(map.connection_type))])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("External Url:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_vm._v(_vm._s(map.external_service_url))])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Template:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_vm._v(_vm._s(map.template))])],1),_vm._v(" "),(!_vm.demoMode)?_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Username:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_vm._v(_vm._s(map.username))])],1):_vm._e(),_vm._v(" "),(!_vm.demoMode)?_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Password:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_vm._v(_vm._s(map.password))])],1):_vm._e(),_vm._v(" "),(!_vm.demoMode)?_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Description:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_vm._v(_vm._s(map.description))])],1):_vm._e()],1)])],1)],1)})),_vm._v(" "),_c('b-modal',{ref:"externalServiceModal",staticClass:"external-service-modal",attrs:{"id":"externalService","size":"lg","title":_vm.extServiceData.created ? 'New Mapping' : 'Edit Mapping',"hide-footer":"","header-bg-variant":"light"},on:{"hidden":_vm.onHidingExtSerModal}},[(_vm.extServiceData.integration_type)?_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"2"}},[_vm._v("Connection Type:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"4 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.connectionTypes},on:{"change":_vm.handleSelectedConnectionType},model:{value:(_vm.extServiceData.connection_type),callback:function ($$v) {_vm.$set(_vm.extServiceData, "connection_type", $$v)},expression:"extServiceData.connection_type"}})],1),_vm._v(" "),(_vm.extServiceData.connection_type === 'Salesforce')?_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("External Url:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-form-input',{ref:"fieldKey",attrs:{"type":"text","placeholder":"external url","disabled":""},model:{value:(_vm.extServiceData.external_service_url),callback:function ($$v) {_vm.$set(_vm.extServiceData, "external_service_url", $$v)},expression:"extServiceData.external_service_url"}})],1)],1)],1):_vm._e()],1),_vm._v(" "),(!_vm.demoMode)?_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Name:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-form-input',{ref:"fieldKey",attrs:{"type":"text","placeholder":"external url"},model:{value:(_vm.extServiceData.name),callback:function ($$v) {_vm.$set(_vm.extServiceData, "name", $$v)},expression:"extServiceData.name"}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.demoMode)?_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Username:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-form-input',{ref:"fieldKey",attrs:{"type":"text","placeholder":"username"},model:{value:(_vm.extServiceData.username),callback:function ($$v) {_vm.$set(_vm.extServiceData, "username", $$v)},expression:"extServiceData.username"}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.demoMode)?_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Password:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-form-input',{ref:"fieldKey",attrs:{"type":"text","placeholder":"password"},model:{value:(_vm.extServiceData.password),callback:function ($$v) {_vm.$set(_vm.extServiceData, "password", $$v)},expression:"extServiceData.password"}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.demoMode)?_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Description:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-form-input',{ref:"fieldKey",attrs:{"type":"text","placeholder":"description"},model:{value:(_vm.extServiceData.description),callback:function ($$v) {_vm.$set(_vm.extServiceData, "description", $$v)},expression:"extServiceData.description"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-row'),_vm._v(" "),(!_vm.demoMode)?_c('b-row',[_c('b-col',{attrs:{"cols":"3"}},[_vm._v("Fields:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"9 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.extConnection.extFields}})],1)],1):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.extServiceData.connection_type === 'Salesforce')?_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Integration type:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.integrationTypes},on:{"change":_vm.handleSelectedIntegrationType},model:{value:(_vm.extServiceData.integration_type),callback:function ($$v) {_vm.$set(_vm.extServiceData, "integration_type", $$v)},expression:"extServiceData.integration_type"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Process Type:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.processTypes},on:{"change":_vm.handleSelectedProcessType},model:{value:(_vm.extServiceData.process_type),callback:function ($$v) {_vm.$set(_vm.extServiceData, "process_type", $$v)},expression:"extServiceData.process_type"}}),_vm._v(" "),(_vm.extServiceData.process_type == null)?_c('div',{staticStyle:{"color":"red"}},[_vm._v("Please select Process Type.")]):_vm._e()],1)],1)],1),_vm._v(" "),(_vm.showTemplateRow)?_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Select Template:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.availableTemplateDocs},on:{"change":_vm.handleSelectedTemplate},model:{value:(_vm.templateDoc.selectedTemplateDocId),callback:function ($$v) {_vm.$set(_vm.templateDoc, "selectedTemplateDocId", $$v)},expression:"templateDoc.selectedTemplateDocId"}})],1)],1)],1):_vm._e()],1):_c('b-row'),_vm._v(" "),(_vm.extServiceData.process_type != null)?_c('div',[_c('b-row'),_vm._v(" "),(_vm.showVersionsRow)?_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Select Page:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-form-select',{attrs:{"cols":"8","plain":true,"options":_vm.availableTemplates},on:{"change":_vm.fetchTemplateVersion},model:{value:(_vm.selectedTemplate),callback:function ($$v) {_vm.selectedTemplate=$$v},expression:"selectedTemplate"}}),_vm._v(" "),(_vm.selectedTemplate == null)?_c('div',{staticStyle:{"color":"red"}},[_vm._v("Please select a page.")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Select Version:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.availableTemplateVersions},on:{"change":_vm.resetObjectRow},model:{value:(_vm.selectedTemplateVersion),callback:function ($$v) {_vm.selectedTemplateVersion=$$v},expression:"selectedTemplateVersion"}}),_vm._v(" "),(_vm.selectedTemplateVersion == null)?_c('div',{staticStyle:{"color":"red"}},[_vm._v("Please select a version.")]):_vm._e()],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"4"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"4 text-left"}},[_c('b-btn',{staticClass:"float-right create-button",attrs:{"size":"sm","variant":"secondary mr-1","disabled":!(_vm.extServiceData.process_type)},on:{"click":_vm.createMapping}},[_vm._v("Create/Fetch")])],1)],1),_vm._v(" "),_c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',{attrs:{"card":""}},[_c('b-tab',{staticStyle:{"background-color":"white"},attrs:{"title":"Mappings","active":""}},[(_vm.showObjectRow)?_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Select Object:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('model-select',{staticClass:"modelSelect",attrs:{"plain":true,"options":_vm.extConnection.extObjects,"placeholder":"Select External Object"},model:{value:(_vm.extConnection.selectedObj),callback:function ($$v) {_vm.$set(_vm.extConnection, "selectedObj", $$v)},expression:"extConnection.selectedObj"}}),_vm._v(" "),(!_vm.extConnection.selectedObj)?_c('div',{staticStyle:{"color":"red"}},[_vm._v("Please select an object.")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.extConnection.selectedObj))])],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.showEFM)?_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_c('b-card',{attrs:{"border-variant":"info","header":"Map Fields","align":"center"}},[_c('p',{staticClass:"card-text"},[_c('b-row',[_c('b-col',{attrs:{"cols":"11 text-left"}},[_c('label',[_vm._v("External Fields")]),_vm._v(" "),_c('model-select',{staticClass:"modelSelect",attrs:{"plain":true,"options":_vm.extConnection.extFields,"placeholder":"Select External Field"},model:{value:(_vm.externalServiceMap.selectedExtField),callback:function ($$v) {_vm.$set(_vm.externalServiceMap, "selectedExtField", $$v)},expression:"externalServiceMap.selectedExtField"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11 text-left"}},[_c('label',[_vm._v("Mapping Type")]),_vm._v(" "),_c('b-form-select',{attrs:{"plain":true,"options":_vm.mappingTypeOptions},model:{value:(_vm.mappingType),callback:function ($$v) {_vm.mappingType=$$v},expression:"mappingType"}})],1)],1),_vm._v(" "),_c('b-row',[(_vm.mappingType === 'TEMPLATE_FIELD')?_c('b-col',{attrs:{"cols":"11 text-left"}},[_c('label',[_vm._v("Template Fields")]),_vm._v(" "),_c('model-select',{staticClass:"modelSelect",attrs:{"plain":true,"options":_vm.templateDoc.tmpFields},model:{value:(_vm.externalServiceMap.selectedTmpField),callback:function ($$v) {_vm.$set(_vm.externalServiceMap, "selectedTmpField", $$v)},expression:"externalServiceMap.selectedTmpField"}})],1):_vm._e()],1),_vm._v(" "),_c('b-row',[(_vm.mappingType === 'DEFAULT')?_c('b-col',{attrs:{"cols":"11 text-left"}},[_c('label',[_vm._v("Default Value")]),_vm._v(" "),_c('b-form-input',{attrs:{"placeholder":"Enter Default Value"},model:{value:(_vm.defaultValue),callback:function ($$v) {_vm.defaultValue=$$v},expression:"defaultValue"}})],1):_vm._e()],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11 text-left"}},[_c('label',[_vm._v("Section")]),_vm._v(" "),_c('b-form-select',{attrs:{"plain":true,"options":_vm.sectionsList},model:{value:(_vm.selectedSection),callback:function ($$v) {_vm.selectedSection=$$v},expression:"selectedSection"}})],1),_vm._v(" "),(_vm.mappingType)?_c('b-col',{attrs:{"cols":"2 text-left"}},[_c('label',[_vm._v("Action")]),_vm._v(" "),_c('b-btn',{staticStyle:{"padding":"1px 10px","border-radius":"10px"},attrs:{"size":"sm","variant":"secondary","disabled":_vm.selectedSection.length < 1},on:{"click":_vm.addFieldMapping}},[_c('i',{staticClass:"fa fa-plus"})])],1):_vm._e()],1),_vm._v(" "),_c('b-row',[(this.extConnection.reqFields.length)?_c('p',{staticStyle:{"color":"red","padding":"1px 15px"},attrs:{"id":"displayReqFields"}},[_vm._v("\n                      Note: In External fields combo box, "+_vm._s(this.extConnection.reqFields.length)+_vm._s(_vm.$t('COMMON.REQ_FIELD_WARNING')))]):_vm._e(),_vm._v(" "),(!this.extConnection.reqFields.length)?_c('p',{attrs:{"id":"displayReqFields"}},[_vm._v(" ")]):_vm._e(),_vm._v(" "),_c('b-popover',{attrs:{"target":"displayReqFields","triggers":"hover","placement":"left"}},[_vm._v("\n                        "+_vm._s(this.extConnection.reqStr)+"\n                      ")])],1)],1)])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"8"}},[_c('b-card',{attrs:{"border-variant":"info","align":"left"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b-row',{staticStyle:{"margin":"0px"}},[_c('b-col',{attrs:{"md":"10"}},[_c('h6',{staticStyle:{"margin":"1px 0px 0px 0px"}},[_vm._v("Mapped Fields")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-download download-efm fa-lg",attrs:{"title":"Download ExternalServiceMappings"},on:{"click":_vm.downloadEsmappings}})]),_vm._v(" "),(_vm.shouldShowDownload)?_c('b-col',{attrs:{"md":"2"}},[_c('div',{staticClass:"float-right"},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-download download-efm",attrs:{"title":"Download Mappings"},on:{"click":_vm.downloadESM}})])]):_vm._e()],1)],1),_vm._v(" "),_c('p',{staticClass:"card-text"},_vm._l((this.sectionsList ? this.sectionsList.concat([null]) : []),function(section,index){return _c('b-row',{key:index},[_c('b-col',{attrs:{"cols":"12"}},[(_vm.externalServiceMap.externalFieldMappings.filter(function (mapping){ return mapping.section === section; }).length > 0)?_c('strong',[_vm._v(_vm._s(section === null ? ' NA ': section)+" :")]):_vm._e(),_vm._v(" "),_vm._l((_vm.externalServiceMap.externalFieldMappings.filter(function (mapping){ return mapping.section === section; })),function(map){return _c('b-row',{key:map.id},[_c('b-col',{attrs:{"sm":"5"}},[_vm._v("\n                            "+_vm._s(map.ext_field_api)+"   ( "+_vm._s(map.ext_field_object)+" )\n                             \n                          ")]),_vm._v(" "),_c('b-col',{attrs:{"sm":"5"}},[_c('i',{staticClass:"fa fa-link"}),_vm._v("  \n                            "+_vm._s(map.tmp_key && map.tmp_key != null && map.tmp_key !== 'null' ? map.tmp_key : ' (DEFAULT) ' + map.default_value)+"\n                          ")]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"red","cursor":"pointer"},on:{"click":function($event){_vm.deleteExternalFieldMap(map.id, map.ext_field_api)}}})])],1)})],2)],1)}))])],1)],1):_vm._e()],1),_vm._v(" "),_c('b-tab',{staticStyle:{"background-color":"white"},attrs:{"title":"Sections"}},[_c('b-card',[_c('b-card',{staticClass:"multi-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('h5',[_vm._v(_vm._s(_vm.$t('CONFIGURED.SECTION_ORDER')))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"8"}},[_c('span',[_c('b-form-input',{staticStyle:{"max-width":"50%","display":"inline"},attrs:{"size":"md","placeholder":_vm.$t('CONFIGURED.ENTER_SECTION_NAME')},model:{value:(_vm.sectionName),callback:function ($$v) {_vm.sectionName=$$v},expression:"sectionName"}})],1),_vm._v(" "),_c('span',[_c('b-button',{staticStyle:{"margin-bottom":"5px","padding-bottom":"0px","border-radius":"6px","padding":"4px 10px 4px 11px"},attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){_vm.addSectionName()}}},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),_c('b-button',{staticStyle:{"margin-bottom":"5px","padding-bottom":"0px","border-radius":"6px","padding":"4px 10px 4px 11px"},attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){_vm.updateSectionOrder()}}},[_c('i',{staticClass:"fa fa-save"},[_vm._v(_vm._s(_vm.$t('COMMON.SAVE'))+" ")])])],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"timeline-div"},[_c('ul',{staticClass:"timeline timeline-horizontal"},[_c('draggable',{staticClass:"flex-container",attrs:{"options":{ group:'sections'}},model:{value:(_vm.sectionsList),callback:function ($$v) {_vm.sectionsList=$$v},expression:"sectionsList"}},_vm._l((_vm.sectionsList),function(section,index){return _c('li',{key:index,staticClass:"timeline-item"},[_c('div',{staticClass:"timeline-badge bg-primary"},[_c('strong',[_vm._v(_vm._s(index + 1))])]),_vm._v(" "),_c('div',{staticClass:"timeline-panel role-panel"},[_c('p',[_vm._v(_vm._s(section))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"red","cursor":"pointer"},on:{"click":function($event){_vm.deleteSectionName(section)}}})])])])}))],1)]),_vm._v(" "),_c('em',{staticClass:"italic"},[_vm._v(_vm._s(_vm.$t('CONFIGURED.SECTION_NOTE')))])])],1)],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('b-modal',{ref:"externalServiceImportModal",staticClass:"external-service-modal",attrs:{"id":"importMappings","size":"lg","title":"Import Mappings","hide-footer":"","header-bg-variant":"light"},on:{"hidden":_vm.onHidingExtSerModal}},[(_vm.extServiceData.integration_type)?_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"2"}},[_vm._v("Connection Type:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"4 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.connectionTypes},on:{"change":_vm.handleSelectedConnectionType},model:{value:(_vm.extServiceData.connection_type),callback:function ($$v) {_vm.$set(_vm.extServiceData, "connection_type", $$v)},expression:"extServiceData.connection_type"}})],1),_vm._v(" "),(_vm.extServiceData.connection_type === 'Salesforce')?_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("External Url:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-form-input',{ref:"fieldKey",attrs:{"type":"text","placeholder":"external url","disabled":""},model:{value:(_vm.extServiceData.external_service_url),callback:function ($$v) {_vm.$set(_vm.extServiceData, "external_service_url", $$v)},expression:"extServiceData.external_service_url"}})],1)],1)],1):_vm._e()],1),_vm._v(" "),(!_vm.demoMode)?_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Name:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-form-input',{ref:"fieldKey",attrs:{"type":"text","placeholder":"external url"},model:{value:(_vm.extServiceData.name),callback:function ($$v) {_vm.$set(_vm.extServiceData, "name", $$v)},expression:"extServiceData.name"}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.demoMode)?_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Username:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-form-input',{ref:"fieldKey",attrs:{"type":"text","placeholder":"username"},model:{value:(_vm.extServiceData.username),callback:function ($$v) {_vm.$set(_vm.extServiceData, "username", $$v)},expression:"extServiceData.username"}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.demoMode)?_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Password:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-form-input',{ref:"fieldKey",attrs:{"type":"text","placeholder":"password"},model:{value:(_vm.extServiceData.password),callback:function ($$v) {_vm.$set(_vm.extServiceData, "password", $$v)},expression:"extServiceData.password"}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.demoMode)?_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Description:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-form-input',{ref:"fieldKey",attrs:{"type":"text","placeholder":"description"},model:{value:(_vm.extServiceData.description),callback:function ($$v) {_vm.$set(_vm.extServiceData, "description", $$v)},expression:"extServiceData.description"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-row'),_vm._v(" "),(!_vm.demoMode)?_c('b-row',[_c('b-col',{attrs:{"cols":"3"}},[_vm._v("Fields:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"9 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.extConnection.extFields}})],1)],1):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.extServiceData.connection_type === 'Salesforce')?_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Integration type:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.integrationTypes},on:{"change":_vm.handleSelectedIntegrationType},model:{value:(_vm.extServiceData.integration_type),callback:function ($$v) {_vm.$set(_vm.extServiceData, "integration_type", $$v)},expression:"extServiceData.integration_type"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Process Type:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.processTypes},on:{"change":_vm.handleSelectedProcessType},model:{value:(_vm.extServiceData.process_type),callback:function ($$v) {_vm.$set(_vm.extServiceData, "process_type", $$v)},expression:"extServiceData.process_type"}}),_vm._v(" "),(_vm.extServiceData.process_type == null)?_c('div',{staticStyle:{"color":"red"}},[_vm._v("Please select Process Type.")]):_vm._e()],1)],1)],1),_vm._v(" "),(_vm.showTemplateRow)?_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Select Template:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.availableTemplateDocs},on:{"change":_vm.handleSelectedTemplate},model:{value:(_vm.templateDoc.selectedTemplateDocId),callback:function ($$v) {_vm.$set(_vm.templateDoc, "selectedTemplateDocId", $$v)},expression:"templateDoc.selectedTemplateDocId"}})],1)],1)],1):_vm._e()],1):_c('b-row'),_vm._v(" "),(_vm.extServiceData.process_type != null)?_c('div',[_c('b-row'),_vm._v(" "),(_vm.showVersionsRow)?_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Select Page:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-form-select',{attrs:{"cols":"8","plain":true,"options":_vm.availableTemplates},on:{"change":_vm.fetchTemplateVersion},model:{value:(_vm.selectedTemplate),callback:function ($$v) {_vm.selectedTemplate=$$v},expression:"selectedTemplate"}}),_vm._v(" "),(_vm.selectedTemplate == null)?_c('div',{staticStyle:{"color":"red"}},[_vm._v("Please select a page.")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Select Version:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.availableTemplateVersions},on:{"change":_vm.resetObjectRow},model:{value:(_vm.selectedTemplateVersion),callback:function ($$v) {_vm.selectedTemplateVersion=$$v},expression:"selectedTemplateVersion"}}),_vm._v(" "),(_vm.selectedTemplateVersion == null)?_c('div',{staticStyle:{"color":"red"}},[_vm._v("Please select a version.")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Select File:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('input',{ref:"file",attrs:{"id":"fileUpload","type":"file"},on:{"change":function($event){_vm.handleFileUpload()}}})])],1)],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"3"}}),_vm._v(" "),_c('div',[_c('b-btn',{attrs:{"size":"sm","variant":"secondary","disabled":!_vm.isFileSelected},on:{"click":_vm.saveImportMappings}},[_vm._v(" "+_vm._s(_vm.$t('CONFIGURED.CREATE'))+" ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":_vm.hideImportModal}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CLOSE'))+" ")])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('b-modal',{ref:"deleteModal",attrs:{"centered":"","id":"deleteModal","title":_vm.$t('COMMON.DELETE_CONFIRM'),"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","ok-title":_vm.$t('COMMON.DELETE'),"cancel-title":_vm.$t('COMMON.CANCEL'),"ok-variant":"secondary","cancel-variant":"light"},on:{"cancel":_vm.cancel,"ok":_vm.deleteExternalServiceMap},nativeOn:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.deleteExternalServiceMap($event)}}},[_c('div',{staticClass:"delete-warning"},[_c('p',[_vm._v(_vm._s(_vm.$t('COMMON.DEL_SERVICEMAPPING')))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_externalServiceValidations_vue__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_externalServiceValidations_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_externalServiceValidations_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_externalServiceValidations_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_externalServiceValidations_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1012bc30_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_externalServiceValidations_vue__ = __webpack_require__(1260);
function injectStyle (ssrContext) {
  __webpack_require__(1259)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1012bc30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_externalServiceValidations_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1012bc30_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_externalServiceValidations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-row',{staticClass:"temp_mapping"},[_c('b-col',{staticClass:"text-left",attrs:{"cols":"8"}},[_c('h4',[_vm._v(_vm._s(_vm.$t('Validations')))])]),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"cols":"4"}},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.externalServiceValidation",modifiers:{"externalServiceValidation":true}}],staticClass:"mt-0",attrs:{"type":"submit","size":"sm","variant":"secondary"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('Add new validation'))+" ")])]),_vm._v(" "),_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.importValidations",modifiers:{"importValidations":true}}],staticClass:"mt-0",attrs:{"type":"submit","size":"sm","variant":"secondary"}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('Import validations'))+" ")])])],1)],1)],1),_vm._v(" "),_c('b-row',_vm._l((_vm.externalServiceValidations),function(validation){return _c('b-col',{key:validation.id,attrs:{"cols":"6"}},[_c('b-card',[_c('b-card',{attrs:{"border-variant":"info","align":"left"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('h5',[_vm._v("Validation")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('div',{staticClass:"float-right add-field-btn"},[_c('b-button',{staticClass:"mt-0",attrs:{"type":"submit","size":"sm","variant":"primary"},on:{"click":function($event){_vm.editExternalServiceValidation(validation.template_doc_id)}}},[_c('i',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('b-button',{staticClass:"mt-0",attrs:{"type":"submit","size":"sm","variant":"danger"},on:{"click":function($event){_vm.showDeleteModal(validation.template_doc_id)}}},[_c('i',{staticClass:"fa fa-trash"})])],1)])],1)],1),_vm._v(" "),_c('p',{staticClass:"card-text"},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Template:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_vm._v(_vm._s(validation.template))])],1)],1)])],1)],1)})),_vm._v(" "),_c('b-modal',{ref:"externalServiceValidationModal",staticClass:"external-service-validation-modal",attrs:{"id":"externalServiceValidation","size":"lg","title":_vm.extServiceValidation.created ? 'New Validation' : 'Edit Validation',"hide-footer":"","header-bg-variant":"light"},on:{"hidden":_vm.onHidingExtSerValModal}},[_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_vm._v("Select Template:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7 text-left"}},[_c('model-select',{staticClass:"modelSelect",attrs:{"plain":true,"options":_vm.availableTemplateDocs,"placeholder":"Select Template"},model:{value:(_vm.templateDoc.selectedTemplateDocId),callback:function ($$v) {_vm.$set(_vm.templateDoc, "selectedTemplateDocId", $$v)},expression:"templateDoc.selectedTemplateDocId"}})],1)],1)],1)],1)],1),_vm._v(" "),(_vm.showVersionsRow)?_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_vm._v("Select Page:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.availableTemplates},on:{"change":_vm.fetchTemplateVersion},model:{value:(_vm.selectedTemplate),callback:function ($$v) {_vm.selectedTemplate=$$v},expression:"selectedTemplate"}})],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_vm._v("Select Version:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.availableTemplateVersions},on:{"change":_vm.handleSelectedVersion},model:{value:(_vm.selectedTemplateVersion),callback:function ($$v) {_vm.selectedTemplateVersion=$$v},expression:"selectedTemplateVersion"}})],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.showFetchButton)?_c('b-row',[_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"secondary mr-1","disabled":!(_vm.templateDoc.selectedTemplateDocId && _vm.selectedTemplate && _vm.selectedTemplateVersion)},on:{"click":_vm.fetchValidations}},[_vm._v("Fetch")])],1)],1):_vm._e(),_vm._v(" "),(_vm.showESV)?_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_c('b-card',{attrs:{"border-variant":"info","header":"Map Fields","align":"center"}},[_c('p',{staticClass:"card-text"},[_c('b-row',[_c('b-col',{attrs:{"cols":"11 text-left"}},[_c('label',[_vm._v("Template Fields")]),_vm._v(" "),_c('model-select',{staticClass:"modelSelect",attrs:{"plain":true,"options":_vm.templateDoc.tmpFields,"placeholder":"Select Template Field"},model:{value:(_vm.externalServiceValidation.selectedTmpField),callback:function ($$v) {_vm.$set(_vm.externalServiceValidation, "selectedTmpField", $$v)},expression:"externalServiceValidation.selectedTmpField"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11 text-left"}},[_c('label',[_vm._v("Condition")]),_vm._v(" "),_c('b-form-select',{attrs:{"plain":true,"options":_vm.conditions},model:{value:(_vm.externalServiceValidation.selectedCondition),callback:function ($$v) {_vm.$set(_vm.externalServiceValidation, "selectedCondition", $$v)},expression:"externalServiceValidation.selectedCondition"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11 text-left"}},[_c('label',[_vm._v("Value")]),_vm._v(" "),_c('b-form-input',{attrs:{"plain":true},model:{value:(_vm.externalServiceValidation.conditionValue),callback:function ($$v) {_vm.$set(_vm.externalServiceValidation, "conditionValue", $$v)},expression:"externalServiceValidation.conditionValue"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"11 text-left"}},[_c('label',[_vm._v("Error Message")]),_vm._v(" "),_c('b-form-input',{attrs:{"plain":true},model:{value:(_vm.externalServiceValidation.errorMessage),callback:function ($$v) {_vm.$set(_vm.externalServiceValidation, "errorMessage", $$v)},expression:"externalServiceValidation.errorMessage"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"2 text-left"}},[_c('label',[_vm._v("Action")]),_vm._v(" "),_c('b-btn',{staticStyle:{"padding":"1px 10px","border-radius":"10px"},attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.addFieldValidation}},[(this.editValidationId !== null)?_c('span',[_vm._v("Update")]):_c('span',[_vm._v("Add")])])],1)],1)],1)])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"8"}},[_c('b-card',{attrs:{"border-variant":"info","align":"left"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b-row',{staticStyle:{"margin":"0px"}},[_c('b-col',{attrs:{"md":"10"}},[_c('h6',{staticStyle:{"margin":"1px 0px 0px 0px"}},[_vm._v("Validation Fields")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-download download-efm fa-lg",attrs:{"title":"Download ExternalValidations"},on:{"click":_vm.downloadEsvalidations}})])],1)],1)]),_vm._v(" "),_c('b-card',{attrs:{"border-variant":"info","align":"left"}},[_c('p',{staticClass:"card-text"},[_c('b-table',{attrs:{"hover":"","fields":_vm.fields,"items":this.externalServiceValidation.externalServiceValidations},scopedSlots:_vm._u([{key:"tmp_key",fn:function(data){return [_vm._v(_vm._s(data.item.tmp_key)+" ("+_vm._s(data.item.condition)+")")]}},{key:"actions",fn:function(data){return [_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"red","cursor":"pointer"},on:{"click":function($event){_vm.deleteExternalFieldMap(data.item.id)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-edit",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.editExternalFieldMap(data.item)}}})]}}])})],1)])],1)],1):_vm._e()],1),_vm._v(" "),_c('b-modal',{ref:"externalServiceImportValidationModal",staticClass:"external-service-validation-modal",attrs:{"id":"importValidations","size":"lg","title":"Import Validations","hide-footer":"","header-bg-variant":"light"},on:{"hidden":_vm.onHidingExtSerValModal}},[_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_vm._v("Select Template:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7 text-left"}},[_c('b-form-select',{staticClass:"modelSelect",attrs:{"plain":true,"options":_vm.availableTemplateDocs,"placeholder":"Select Template"},model:{value:(_vm.templateDoc.selectedTemplateDocId),callback:function ($$v) {_vm.$set(_vm.templateDoc, "selectedTemplateDocId", $$v)},expression:"templateDoc.selectedTemplateDocId"}})],1)],1)],1)],1)],1),_vm._v(" "),(_vm.showVersionsRow)?_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_vm._v("Select Page:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.availableTemplates},on:{"change":_vm.fetchTemplateVersion},model:{value:(_vm.selectedTemplate),callback:function ($$v) {_vm.selectedTemplate=$$v},expression:"selectedTemplate"}})],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_vm._v("Select Version:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.availableTemplateVersions},on:{"change":_vm.handleSelectedVersion},model:{value:(_vm.selectedTemplateVersion),callback:function ($$v) {_vm.selectedTemplateVersion=$$v},expression:"selectedTemplateVersion"}})],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Select File:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('input',{ref:"file",attrs:{"id":"fileUpload","type":"file"},on:{"change":function($event){_vm.handleFileUpload()}}})])],1)],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"4"}}),_vm._v(" "),_c('div',[_c('b-btn',{attrs:{"size":"sm","variant":"secondary","disabled":!_vm.isFileSelected},on:{"click":_vm.saveImportValidations}},[_vm._v(" "+_vm._s(_vm.$t('CONFIGURED.CREATE'))+" ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":_vm.hideImportValidations}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CLOSE'))+" ")])],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"deleteModal",attrs:{"centered":"","id":"deleteModal","title":_vm.$t('COMMON.DELETE_CONFIRM'),"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","ok-title":_vm.$t('COMMON.DELETE'),"cancel-title":_vm.$t('COMMON.CANCEL'),"ok-variant":"secondary","cancel-variant":"light"},on:{"cancel":_vm.cancel,"ok":_vm.deleteExternalServiceValidation},nativeOn:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.deleteExternalServiceValidation($event)}}},[_c('div',{staticClass:"delete-warning"},[_c('p',[_vm._v(_vm._s(_vm.$t('COMMON.DEL_SERVICEVALIDATION')))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_manageFields_vue__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_manageFields_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_manageFields_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_manageFields_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_manageFields_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8825d64_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_manageFields_vue__ = __webpack_require__(1263);
function injectStyle (ssrContext) {
  __webpack_require__(1262)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c8825d64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_manageFields_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8825d64_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_manageFields_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"selProType"},[_c('h5',{staticClass:"processTypeLabel"},[_vm._v(_vm._s(_vm.$t('ANALYTICS.SELECT_PROCESS_TYPE')))]),_vm._v(" "),_c('b-col',[_c('b-form-select',{staticClass:"formselectPT",attrs:{"options":_vm.processTypes},model:{value:(_vm.selectedFilterProcessType),callback:function ($$v) {_vm.selectedFilterProcessType=$$v},expression:"selectedFilterProcessType"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_c('b-card',[[_c('b-row',{staticClass:"headers"},[_c('h5',[_vm._v(_vm._s(_vm.$t('CONFIGURED.FIELDS')))]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-input',{staticClass:"searchBox",attrs:{"placeholder":"Search"},on:{"input":function($event){_vm.searchByText()}},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1),_vm._v(" "),_c('b-col',{staticClass:"text-right",staticStyle:{"padding-right":"0px"}},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"addGroupBtn",attrs:{"size":"sm","variant":"secondary","title":_vm.$t('CONFIGURED.ADD_GROUP')},on:{"click":function($event){_vm.showAddFieldModal()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.ADD'))+" ")])])],1)],1)],_vm._v(" "),_c('div',{attrs:{"id":"groups"}},[(!_vm.fieldsLoaded)?_c('div',[_c('content-placeholders',[_c('content-placeholders-img',{style:({height: '280px'})})],1)],1):_vm._e(),_vm._v(" "),(_vm.selectedFilterProcessType === null && _vm.fieldsLoaded )?_c('div',[_c('b-row',[_c('b-col',[_c('br'),_vm._v(" "),_c('a',{staticStyle:{"color":"red"}},[_vm._v("Please Select Process type")])])],1)],1):(_vm.fields.length === 0 && _vm.fieldsLoaded)?_c('div',[_c('b-row',[_c('b-col',[_c('br'),_vm._v(" "),_c('h4',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.$t('FORMS.NOTHING')))])])],1)],1):_vm._e(),_vm._v(" "),_vm._l((_vm.fields),function(processField){return (_vm.fieldsLoaded)?_c('div',[(_vm.currentField.id === processField.id)?_c('b-row',{staticClass:"groupName",on:{"click":function($event){_vm.getFieldAlias(processField)}}},[_c('a',{staticClass:"selectedField"},[_vm._v(_vm._s(_vm._f("capitalize")(processField.field.replace(/_/g, ' '))))]),_vm._v(" "),_c('b-col',{staticClass:"text-right"},[_c('div',{staticClass:"actionBtn"},[_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"editBtnSelect",attrs:{"title":_vm.$t('COMMON.EDIT')},on:{"click":function($event){_vm.openEditField(processField)}}},[_c('i',{staticClass:"fa fa-pencil",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('COMMON.DELETE_PERMANENTLY')},on:{"click":function($event){_vm.confirmDeleteField(processField)}}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"red"},attrs:{"aria-hidden":"true"}})])])])],1):_c('b-row',{on:{"click":function($event){_vm.getFieldAlias(processField)}}},[_c('a',{staticClass:"unselectedRows"},[_vm._v(_vm._s(_vm._f("capitalize")(processField.field.replace(/_/g, ' '))))]),_vm._v(" "),_c('b-col',{staticClass:"text-right"},[_c('div',{staticClass:"actionBtn"},[_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"editBtnSelect",attrs:{"title":_vm.$t('COMMON.EDIT')},on:{"click":function($event){_vm.openEditField(processField)}}},[_c('i',{staticClass:"fa fa-pencil",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('COMMON.DELETE_PERMANENTLY')},on:{"click":function($event){_vm.confirmDeleteField(processField)}}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"red"},attrs:{"aria-hidden":"true"}})])])])],1)],1):_vm._e()})],2)],2)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"8"}},[_c('b-card',[[_c('b-row',{staticClass:"headers"},[_c('b-col',[_c('h5',[_vm._v(_vm._s(_vm.$t('CONFIGURED.FIELDS_ALIASES')))])]),_vm._v(" "),(_vm.currentFieldAliases !== null)?_c('b-col',{staticClass:"text-right"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"addGroupBtn",attrs:{"size":"sm","variant":"secondary","title":_vm.$t('CONFIGURED.ADD_FIELD_ALIAS')},on:{"click":function($event){_vm.showAddFieldAliasModal()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.ADD'))+" ")])])],1):_vm._e()],1)],_vm._v(" "),_c('div',{staticClass:"labelBody"},[(!_vm.fieldAliasLoaded)?_c('div',[_c('content-placeholders',[_c('content-placeholders-img',{style:({height: '250px'})})],1)],1):_vm._l((_vm.currentFieldAliases),function(fieldAlias,index){return _c('div',[(fieldAlias.name !== null)?_c('div',{staticClass:"currFields"},[_vm._v("\n            "+_vm._s(fieldAlias.name)+"\n            "),_c('div',{staticClass:"pull-right"},[_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fieldEditBtn",attrs:{"title":_vm.$t('COMMON.EDIT')},on:{"click":function($event){_vm.showEditFieldAliasModal(fieldAlias)}}},[_c('i',{staticClass:"fa fa-pencil",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('COMMON.DELETE_PERMANENTLY')},on:{"click":function($event){_vm.showDeleteFieldAliasModal(fieldAlias)}}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"red"},attrs:{"aria-hidden":"true"}})])])]):_vm._e()])})],2)],2)],1)],1),_vm._v(" "),_c('b-modal',{ref:"deleteGrp",attrs:{"centered":"","hide-header-close":"","id":"DeleteConfirmationGrp","title":_vm.$t('COMMON.DELETE_CONFIRM')}},[_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.$t('COMMON.MSG_PERM_DEL')))]),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"id":"addNewField","size":"sm","variant":"secondary"},on:{"click":function($event){_vm.deleteField()}}},[_vm._v(_vm._s(_vm.$t('COMMON.DELETE'))+" ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":function($event){_vm.$refs.deleteGrp.hide()}}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CLOSE'))+" ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"ConfirmModal",attrs:{"centered":"","hide-header-close":"","id":"DeleteConfirmationField","title":_vm.$t('COMMON.DELETE_CONFIRM')}},[_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.$t('COMMON.MSG_PERM_DEL')))]),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"id":"addNewField","size":"sm","variant":"secondary"},on:{"click":function($event){_vm.deleteFieldAlias()}}},[_vm._v(_vm._s(_vm.$t('COMMON.DELETE'))+" ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":function($event){_vm.$refs.ConfirmModal.hide()}}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CLOSE'))+" ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"FieldAliasModal",attrs:{"centered":"","hide-header-close":"","id":"FieldAliasModal","title":_vm.$t('CONFIGURED.ADD_ALIAS')}},[_c('b-form-group',[_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v(_vm._s(_vm.$t('COMMON.NAME')))]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-input',{attrs:{"placeholder":"Enter"},on:{"input":_vm.checkDuplicateAlias},model:{value:(_vm.newFieldAliasName),callback:function ($$v) {_vm.newFieldAliasName=$$v},expression:"newFieldAliasName"}}),_vm._v(" "),(_vm.errorFieldDup)?_c('a',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.$t('CONFIGURED.FIELD_EXISTS'))+" ")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"id":"addNewField","size":"sm","variant":"secondary","disabled":_vm.errorFieldDup || _vm.newFieldAliasName === ''},on:{"click":function($event){_vm.addFieldAlias()}}},[_vm._v(_vm._s(_vm.$t('COMMON.SAVE'))+" ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":function($event){_vm.$refs.FieldAliasModal.hide()}}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CLOSE'))+" ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"editFieldAliasModal",attrs:{"centered":"","hide-header-close":"","id":"editFieldAliasModal","title":_vm.$t('CONFIGURED.EDIT_ALIAS')}},[_c('b-form-group',[_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v(_vm._s(_vm.$t('COMMON.NAME')))]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-input',{attrs:{"placeholder":"Enter"},on:{"input":_vm.checkDuplicateAlias},model:{value:(_vm.newFieldAliasName),callback:function ($$v) {_vm.newFieldAliasName=$$v},expression:"newFieldAliasName"}}),_vm._v(" "),(_vm.errorFieldDup)?_c('a',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.$t('CONFIGURED.FIELD_EXISTS'))+" ")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"id":"addNewField","size":"sm","variant":"secondary","disabled":_vm.errorFieldDup || _vm.newFieldAliasName === ''},on:{"click":function($event){_vm.editFieldAlias()}}},[_vm._v(_vm._s(_vm.$t('COMMON.SAVE'))+" ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":function($event){_vm.$refs.editFieldAliasModal.hide()}}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CLOSE'))+" ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"addFieldModal",attrs:{"centered":"","hide-header-close":"","title":_vm.$t('CONFIGURED.ADD_GROUP')}},[_c('div',[_c('b-form-group',[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v(_vm._s(_vm.$t('CONFIGURED.FIELD')))]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-input',{staticClass:"rolename",class:{'is-invalid': _vm.$v.newFieldName.$error, 'is-valid': !_vm.$v.newFieldName.$invalid},attrs:{"id":"roleName","type":"text","placeholder":_vm.$t('CONFIGURED.FIELD')},on:{"input":function($event){_vm.$v.newFieldName.$touch()}},model:{value:(_vm.newFieldName),callback:function ($$v) {_vm.newFieldName=$$v},expression:"newFieldName"}}),_vm._v(" "),(!_vm.$v.newFieldName.isUnique)?_c('b-form-invalid-feedback',[_vm._v("Either Group is already registered or not allowed.")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-form-group',[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v(_vm._s(_vm.$t('CONFIGURED.FIELD_TYPE')))]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")])]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"options":_vm.fieldTypes},model:{value:(_vm.selectedFieldType),callback:function ($$v) {_vm.selectedFieldType=$$v},expression:"selectedFieldType"}})],1)],1)],1),_vm._v(" "),(this.selectedFieldType === 'name')?_c('b-form-group',[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v("Field Children")]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")])]),_vm._v(" "),_c('b-col',[_c('multiselect',{staticClass:"custom-multiselect",staticStyle:{"z-index":"99"},attrs:{"options":_vm.fieldChildren,"track-by":"value","label":"text","multiple":true},model:{value:(_vm.selectedFieldChildren),callback:function ($$v) {_vm.selectedFieldChildren=$$v},expression:"selectedFieldChildren"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-form-radio-group',[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v("Extract")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extract),expression:"extract"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"extractYes"},domProps:{"value":true,"checked":_vm._q(_vm.extract,true)},on:{"change":function($event){_vm.extract=true}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"extractYes"}},[_vm._v(_vm._s(_vm.$t('COMMON.YES')))])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extract),expression:"extract"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"extractNo"},domProps:{"value":false,"checked":_vm._q(_vm.extract,false)},on:{"change":function($event){_vm.extract=false}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"extractNo"}},[_vm._v(_vm._s(_vm.$t('COMMON.NO')))])])])],1)],1),_vm._v(" "),(this.selectedFilterProcessType === 'insurance_cards')?_c('div',[_c('b-form-group',[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v(_vm._s(_vm.$t('CONFIGURED.FIELD_ALIAS')))]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-input',{staticClass:"rolename",attrs:{"id":"roleName","type":"text","placeholder":_vm.$t('CONFIGURED.FIELD_ALIAS')},model:{value:(_vm.newFieldAlias),callback:function ($$v) {_vm.newFieldAlias=$$v},expression:"newFieldAlias"}})],1)],1)],1),_vm._v(" "),_c('b-form-radio-group',[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v(_vm._s(_vm.$t('CONFIGURED.REQ')))])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isRequired),expression:"isRequired"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"requiredNewYes"},domProps:{"value":true,"checked":_vm._q(_vm.isRequired,true)},on:{"change":function($event){_vm.isRequired=true}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"requiredNewYes"}},[_vm._v(_vm._s(_vm.$t('COMMON.YES')))])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isRequired),expression:"isRequired"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"requiredNewNo"},domProps:{"value":false,"checked":_vm._q(_vm.isRequired,false)},on:{"change":function($event){_vm.isRequired=false}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"requiredNewNo"}},[_vm._v(_vm._s(_vm.$t('COMMON.NO')))])])])],1)],1),_vm._v(" "),_c('b-form-group',[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v(_vm._s(_vm.$t('CONFIGURED.QUERY')))]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-form-textarea',{attrs:{"placeholder":"Query","rows":"4"},model:{value:(_vm.editQuery),callback:function ($$v) {_vm.editQuery=$$v},expression:"editQuery"}})],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"secondary","disabled":!_vm.$v.newFieldName.isUnique || _vm.selectedFieldType === null || _vm.newFieldName === '' || _vm.editQuery === '' || _vm.newFieldAlias === '' || (_vm.selectedFieldType === 'name' ? _vm.selectedFieldChildren === [] : false)},on:{"click":function($event){_vm.addField()}}},[_vm._v(" Save ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":function($event){_vm.$refs.addFieldModal.hide()}}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CLOSE'))+" ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"editGroupModal",attrs:{"centered":"","hide-header-close":"","title":_vm.$t('CONFIGURED.EDIT_GROUP')}},[_c('div',[_c('b-form-group',[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v(_vm._s(_vm.$t('CONFIGURED.FIELD')))]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-input',{staticClass:"rolename",class:{'is-invalid': _vm.$v.newFieldName.$error, 'is-valid': !_vm.$v.newFieldName.$invalid},attrs:{"id":"roleName","type":"text","placeholder":_vm.$t('CONFIGURED.FIELD')},on:{"input":function($event){_vm.$v.newFieldName.$touch()}},model:{value:(_vm.newFieldName),callback:function ($$v) {_vm.newFieldName=$$v},expression:"newFieldName"}}),_vm._v(" "),(!_vm.$v.newFieldName.isUnique)?_c('b-form-invalid-feedback',[_vm._v("Either Group is already registered or not allowed.")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-form-group',[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v(_vm._s(_vm.$t('CONFIGURED.FIELD_TYPE')))]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")])]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"options":_vm.fieldTypes},model:{value:(_vm.selectedFieldType),callback:function ($$v) {_vm.selectedFieldType=$$v},expression:"selectedFieldType"}})],1)],1)],1),_vm._v(" "),(this.selectedFieldType === 'name')?_c('b-form-group',[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v("Field Children")]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")])]),_vm._v(" "),_c('b-col',[_c('multiselect',{staticClass:"custom-multiselect",staticStyle:{"z-index":"99"},attrs:{"options":_vm.fieldChildren,"track-by":"text","label":"text","multiple":true},model:{value:(_vm.selectedFieldChildren),callback:function ($$v) {_vm.selectedFieldChildren=$$v},expression:"selectedFieldChildren"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-form-radio-group',[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v("Extract")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extract),expression:"extract"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"extractYes"},domProps:{"value":true,"checked":_vm._q(_vm.extract,true)},on:{"change":function($event){_vm.extract=true}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"extractYes"}},[_vm._v(_vm._s(_vm.$t('COMMON.YES')))])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extract),expression:"extract"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"extractNo"},domProps:{"value":false,"checked":_vm._q(_vm.extract,false)},on:{"change":function($event){_vm.extract=false}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"extractNo"}},[_vm._v(_vm._s(_vm.$t('COMMON.NO')))])])])],1)],1),_vm._v(" "),(this.selectedFilterProcessType === 'insurance_cards')?_c('div',[_c('b-form-group',[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v(_vm._s(_vm.$t('CONFIGURED.FIELD_ALIAS')))]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-input',{staticClass:"rolename",attrs:{"id":"roleName","type":"text","placeholder":_vm.$t('CONFIGURED.FIELD_ALIAS')},model:{value:(_vm.newFieldAlias),callback:function ($$v) {_vm.newFieldAlias=$$v},expression:"newFieldAlias"}})],1)],1)],1),_vm._v(" "),_c('b-form-radio-group',[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v(_vm._s(_vm.$t('CONFIGURED.REQ')))])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isRequired),expression:"isRequired"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"requiredNewYes"},domProps:{"value":true,"checked":_vm._q(_vm.isRequired,true)},on:{"change":function($event){_vm.isRequired=true}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"requiredNewYes"}},[_vm._v(_vm._s(_vm.$t('COMMON.YES')))])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isRequired),expression:"isRequired"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"requiredNewNo"},domProps:{"value":false,"checked":_vm._q(_vm.isRequired,false)},on:{"change":function($event){_vm.isRequired=false}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"requiredNewNo"}},[_vm._v(_vm._s(_vm.$t('COMMON.NO')))])])])],1)],1),_vm._v(" "),_c('b-form-group',[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v(_vm._s(_vm.$t('CONFIGURED.QUERY')))]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-form-textarea',{attrs:{"placeholder":"Query","rows":"4"},model:{value:(_vm.editQuery),callback:function ($$v) {_vm.editQuery=$$v},expression:"editQuery"}})],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"size":"sm","variant":"secondary","disabled":!_vm.$v.newFieldName.isUnique || _vm.selectedFieldType === null || _vm.newFieldName === '' || _vm.editQuery === '' || _vm.newFieldAlias === ''},on:{"click":function($event){_vm.editFieldName()}}},[_vm._v(" Save ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":function($event){_vm.$refs.editGroupModal.hide()}}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CLOSE'))+" ")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autoCorrect_vue__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autoCorrect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autoCorrect_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autoCorrect_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autoCorrect_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c349ad2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_autoCorrect_vue__ = __webpack_require__(1266);
function injectStyle (ssrContext) {
  __webpack_require__(1265)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c349ad2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autoCorrect_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c349ad2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_autoCorrect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Select Template:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.availableTemplateDocs},on:{"change":_vm.handleSelectedTemplate},model:{value:(_vm.selectedTemplateDocId),callback:function ($$v) {_vm.selectedTemplateDocId=$$v},expression:"selectedTemplateDocId"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Select Page:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.availableTemplates},on:{"change":_vm.fetchTemplateVersion},model:{value:(_vm.selectedTemplateId),callback:function ($$v) {_vm.selectedTemplateId=$$v},expression:"selectedTemplateId"}}),_vm._v(" "),(_vm.selectedTemplateId == null)?_c('div',{staticStyle:{"color":"red"}},[_vm._v("Please select Page.")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Select Version:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.availableTemplateVersions},model:{value:(_vm.selectedTemplateVersion),callback:function ($$v) {_vm.selectedTemplateVersion=$$v},expression:"selectedTemplateVersion"}})],1),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"secondary","disabled":!(_vm.selectedTemplateDocId && _vm.selectedTemplateId && _vm.selectedTemplateVersion)},on:{"click":_vm.fetchAutoCorrectData}},[_vm._v(" Fetch ")])],1)],1)],1),_vm._v(" "),_c('b-row')],1),_vm._v(" "),_c('b-card',[_c('h4',[_vm._v("Auto Correct Fields:\n        "),_c('div',{staticClass:"float-right add-field-btn"},[_c('b-button',{staticClass:"mt-0",attrs:{"type":"submit","size":"md","variant":"secondary","disabled":!(_vm.selectedTemplateDocId && _vm.selectedTemplateId && _vm.selectedTemplateVersion)},on:{"click":function($event){_vm.displayClearWarning()}}},[_vm._v(" Clear History ")])],1)])]),_vm._v(" "),(_vm.wordMappings.length > 0)?_c('b-row',_vm._l((_vm.wordMappings),function(word){return _c('b-col',{key:word.id,attrs:{"sm":"3"}},[_c('b-card',{attrs:{"border-variant":"secondary"}},[_c('h6',[_vm._v(_vm._s(word.key)+"\n      "),_c('div',{staticClass:"float-right add-field-btn"},[_c('b-button',{staticClass:"mt-0",attrs:{"type":"submit","size":"sm","variant":"danger"},on:{"click":function($event){_vm.displayWarning(word)}}},[_c('i',{staticClass:"fa fa-trash"})])],1)])])],1)})):_vm._e(),_vm._v(" "),(_vm.wordMappings.length < 1 && _vm.loaded)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('center',[_c('h5',[_vm._v("No Data Found")])])],1)],1):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"deleteModal",attrs:{"centered":"","id":"deleteModal","title":_vm.$t('COMMON.DELETE_CONFIRM'),"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","ok-title":_vm.$t('COMMON.DELETE'),"cancel-title":_vm.$t('COMMON.CANCEL'),"ok-variant":"secondary","cancel-variant":"light"},on:{"cancel":_vm.cancel,"ok":_vm.deleteAccountToken},nativeOn:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.deleteAccountToken($event)}}},[_c('div',{staticClass:"delete-warning"},[_c('p',[_vm._v(_vm._s(_vm.$t('COMMON.DEL_AUTO_CORRECT')))])])]),_vm._v(" "),_c('b-modal',{ref:"deleteAllModal",attrs:{"centered":"","id":"deleteAllModal","title":_vm.$t('COMMON.DELETE_CONFIRM'),"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","ok-title":_vm.$t('COMMON.CLEAR'),"cancel-title":_vm.$t('COMMON.CANCEL'),"ok-variant":"secondary","cancel-variant":"light"},on:{"cancel":_vm.cancelClearWarning,"ok":_vm.deleteFromWordDataSetDictinory},nativeOn:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.deleteFromWordDataSetDictinory($event)}}},[_c('div',{staticClass:"delete-warning"},[_c('p',[_vm._v(_vm._s(_vm.$t('COMMON.DEL_AUTO_CORRECT_HISTORY')))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_authConfig_vue__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_authConfig_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_authConfig_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_authConfig_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_authConfig_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d950d06_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_authConfig_vue__ = __webpack_require__(1269);
function injectStyle (ssrContext) {
  __webpack_require__(1268)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d950d06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_authConfig_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d950d06_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_authConfig_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-row',{staticClass:"create_team"},[_c('b-col',{staticClass:"text-left",attrs:{"cols":"8"}},[_c('h4',[_vm._v("Auth Configuration")])]),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"cols":"4"}},[_c('b-button',{staticClass:"mt-0",attrs:{"type":"submit","size":"sm","variant":"secondary"},on:{"click":function($event){_vm.$refs.generateKeys.show()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "),_c('span',[_vm._v(" GENERATE KEYS ")])])],1)],1)],1),_vm._v(" "),_c('b-row',_vm._l((_vm.accountTokens),function(token){return _c('b-col',{key:token.id,attrs:{"cols":"12"}},[_c('b-card',[_c('b-card',{attrs:{"border-variant":"info","align":"left"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('h5',[_vm._v(_vm._s(token.name))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('div',{staticClass:"float-right add-field-btn"},[_c('b-button',{staticClass:"mt-0",attrs:{"type":"submit","size":"sm","variant":"danger"},on:{"click":function($event){_vm.showDeleteModal(token.id)}}},[_c('i',{staticClass:"fa fa-trash"})])],1)])],1)],1),_vm._v(" "),_c('p',{staticClass:"card-text"},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Client ID:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_vm._v(_vm._s(token.client_id))])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Client secret:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_vm._v(_vm._s(token.client_secret))])],1)],1)])],1)],1)})),_vm._v(" "),_c('b-modal',{ref:"generateKeys",attrs:{"centered":"","hide-header-close":"","id":"addKeys","title":_vm.$t('CONFIGURED.ADD_NEW_KEYS')}},[_c('b-card',{staticClass:"mb-0 p-3"},[_c('b-row',{staticClass:"form-group"},[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label":_vm.$t('COMMON.NAME'),"label-for":"roleName"}},[_c('b-form-input',{class:{'is-invalid': _vm.$v.name.$error, 'is-valid': !_vm.$v.name.$invalid},attrs:{"type":"text","placeholder":"Key Name"},on:{"input":function($event){_vm.$v.name.$touch()}},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),(!_vm.$v.name.required)?_c('b-form-invalid-feedback',[_vm._v("Key Name can't be blank")]):_vm._e(),_vm._v(" "),(!_vm.$v.name.minLength || !_vm.$v.name.maxLength)?_c('b-form-invalid-feedback',[_vm._v("Key Name length should be more than 3 and less than 15 characters")]):_vm._e(),_vm._v(" "),(!_vm.$v.name.valid)?_c('b-form-invalid-feedback',[_vm._v("Key Name can't accept symbols")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"id":"addNewField","size":"sm","variant":"secondary","disabled":_vm.name === '' || !_vm.nameIsValid},on:{"click":function($event){_vm.createKeys()}}},[_vm._v(_vm._s(_vm.$t('COMMON.SAVE'))+" ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":function($event){_vm.$refs.generateKeys.hide()}}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CLOSE'))+" ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"deleteModal",attrs:{"centered":"","id":"deleteModal","title":_vm.$t('COMMON.DELETE_CONFIRM'),"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","ok-title":_vm.$t('COMMON.DELETE'),"cancel-title":_vm.$t('COMMON.CANCEL'),"ok-variant":"secondary","cancel-variant":"light"},on:{"cancel":_vm.cancel,"ok":_vm.deleteAccountToken},nativeOn:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.deleteAccountToken($event)}}},[_c('div',{staticClass:"delete-warning"},[_c('p',[_vm._v(_vm._s(_vm.$t('COMMON.DEL_AUTHCONFIG')))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_localTime_vue__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_localTime_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_localTime_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_localTime_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_localTime_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12769d8a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_localTime_vue__ = __webpack_require__(1272);
function injectStyle (ssrContext) {
  __webpack_require__(1271)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12769d8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_localTime_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12769d8a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_localTime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-row',{staticClass:"create_team"},[_c('b-col',{staticClass:"text-left",attrs:{"cols":"8"}},[_c('h4',[_vm._v("Local Time ")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('c-switch',{attrs:{"type":"3d","variant":"success","checked":_vm.local_time},on:{"change":function($event){_vm.changeTimeSettings($event)}}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autoProcessing_vue__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autoProcessing_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autoProcessing_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autoProcessing_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autoProcessing_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_402711d4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_autoProcessing_vue__ = __webpack_require__(1275);
function injectStyle (ssrContext) {
  __webpack_require__(1274)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-402711d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autoProcessing_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_402711d4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_autoProcessing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-row',{staticClass:"create_team"},[_c('b-col',{staticClass:"text-left",attrs:{"cols":"8"}},[_c('h4',[_vm._v("AutoProcessing ")])]),_vm._v(" "),_c('b-col',{staticClass:"float-right",attrs:{"md":"4"}},[_c('c-switch',{attrs:{"type":"3d","variant":"success","checked":_vm.is_auto_processing},on:{"change":function($event){_vm.autoProcessing($event)}}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_docRetention_vue__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_docRetention_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_docRetention_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_docRetention_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_docRetention_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2af35267_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_docRetention_vue__ = __webpack_require__(1278);
function injectStyle (ssrContext) {
  __webpack_require__(1277)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2af35267"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_docRetention_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2af35267_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_docRetention_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-row',{staticClass:"create_team mb-1"},[_c('b-col',{attrs:{"cols":"7"}},[_c('h5',[_vm._v(_vm._s(_vm.$t('CONFIGURED.DOC_RETENTION')))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.availableDays},model:{value:(_vm.selectedDay),callback:function ($$v) {_vm.selectedDay=$$v},expression:"selectedDay"}})],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('vue-timepicker',{staticClass:"float-right",attrs:{"format":"HH:mm","placeholder":"HH:MM","close-on-complete":""},model:{value:(_vm.doc_retention_period),callback:function ($$v) {_vm.doc_retention_period=$$v},expression:"doc_retention_period"}})],1)],1),_vm._v(" "),_c('div',{attrs:{"align":"center"}},[_c('b-btn',{staticClass:"mt-auto",attrs:{"size":"md","variant":"secondary"},on:{"click":_vm.updateRetentionPeriod}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('COMMON.SAVE')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_docEscalationTime_vue__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_docEscalationTime_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_docEscalationTime_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_docEscalationTime_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_docEscalationTime_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dec5cd4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_docEscalationTime_vue__ = __webpack_require__(1282);
function injectStyle (ssrContext) {
  __webpack_require__(1280)
  __webpack_require__(1281)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4dec5cd4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_docEscalationTime_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dec5cd4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_docEscalationTime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-row',{staticClass:"create_team mb-1"},[_c('b-col',{attrs:{"cols":"7"}},[_c('h5',[_vm._v("Document Escalation Time")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.availableDays},model:{value:(_vm.selectedDay),callback:function ($$v) {_vm.selectedDay=$$v},expression:"selectedDay"}})],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('vue-timepicker',{staticClass:"float-right",attrs:{"format":"HH:mm","placeholder":"HH:MM","close-on-complete":""},model:{value:(_vm.new_form_notify_time),callback:function ($$v) {_vm.new_form_notify_time=$$v},expression:"new_form_notify_time"}})],1)],1),_vm._v(" "),_c('div',{attrs:{"align":"center"}},[_c('b-btn',{staticClass:"ml-auto",attrs:{"size":"md","variant":"secondary"},on:{"click":_vm.saveTimers}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" "+_vm._s(_vm.$t('COMMON.SAVE')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customValidations_vue__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customValidations_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customValidations_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customValidations_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customValidations_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3de6b574_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customValidations_vue__ = __webpack_require__(1285);
function injectStyle (ssrContext) {
  __webpack_require__(1284)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3de6b574"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customValidations_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3de6b574_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customValidations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-row',{staticClass:"temp_mapping"},[_c('b-col',{staticClass:"text-left",attrs:{"cols":"8"}},[_c('h4',[_vm._v(_vm._s(_vm.$t('Validations')))])]),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"cols":"4"}},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.customValidation",modifiers:{"customValidation":true}}],staticClass:"mt-0",attrs:{"type":"submit","size":"sm","variant":"secondary"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('Add new validation'))+" ")])]),_vm._v(" "),_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.importValidations",modifiers:{"importValidations":true}}],staticClass:"mt-0",attrs:{"type":"submit","size":"sm","variant":"secondary"}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('Import validations'))+" ")])])],1)],1)],1),_vm._v(" "),_c('b-row',_vm._l((_vm.externalServiceValidations),function(validation){return _c('b-col',{key:validation.id,attrs:{"cols":"6"}},[_c('b-card',[_c('b-card',{attrs:{"border-variant":"info","align":"left"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('h5',[_vm._v("Validation")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('div',{staticClass:"float-right add-field-btn"},[_c('b-button',{staticClass:"mt-0",attrs:{"type":"submit","size":"sm","variant":"primary"},on:{"click":function($event){_vm.editExternalServiceValidation(validation.template_doc_id)}}},[_c('i',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('b-button',{staticClass:"mt-0",attrs:{"type":"submit","size":"sm","variant":"danger"},on:{"click":function($event){_vm.showDeleteModal(validation.template_doc_id)}}},[_c('i',{staticClass:"fa fa-trash"})])],1)])],1)],1),_vm._v(" "),_c('p',{staticClass:"card-text"},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Template:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_vm._v(_vm._s(validation.template))])],1)],1)])],1)],1)})),_vm._v(" "),_c('b-modal',{ref:"externalServiceValidationModal",staticClass:"external-service-validation-modal",attrs:{"id":"customValidation","size":"lg","title":_vm.extServiceValidation.created ? 'New Validation' : 'Edit Validation',"hide-footer":"","header-bg-variant":"light"},on:{"hidden":_vm.onHidingExtSerValModal}},[_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_vm._v("Select Template:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7 text-left"}},[_c('model-select',{staticClass:"modelSelect",attrs:{"plain":true,"options":_vm.availableTemplateDocs,"placeholder":"Select Template"},model:{value:(_vm.templateDoc.selectedTemplateDocId),callback:function ($$v) {_vm.$set(_vm.templateDoc, "selectedTemplateDocId", $$v)},expression:"templateDoc.selectedTemplateDocId"}})],1)],1)],1)],1)],1),_vm._v(" "),(_vm.showVersionsRow)?_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_vm._v("Select Page:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.availableTemplates},on:{"change":_vm.fetchTemplateVersion},model:{value:(_vm.selectedTemplate),callback:function ($$v) {_vm.selectedTemplate=$$v},expression:"selectedTemplate"}})],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_vm._v("Select Version:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.availableTemplateVersions},on:{"change":_vm.handleSelectedVersion},model:{value:(_vm.selectedTemplateVersion),callback:function ($$v) {_vm.selectedTemplateVersion=$$v},expression:"selectedTemplateVersion"}})],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.showFetchButton)?_c('b-row',[_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"secondary mr-1","disabled":!(_vm.templateDoc.selectedTemplateDocId && _vm.selectedTemplate && _vm.selectedTemplateVersion)},on:{"click":_vm.fetchValidations}},[_vm._v("Fetch")])],1)],1):_vm._e(),_vm._v(" "),(_vm.showESV)?_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"border-variant":"info","align":"left"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b-row',{staticStyle:{"margin":"0px"}},[_c('b-col',{attrs:{"md":"10"}},[_c('h6',{staticStyle:{"margin":"1px 0px 0px 0px"}},[_vm._v("Edit Validation")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-download download-efm fa-lg",attrs:{"title":"Download ExternalValidations"},on:{"click":_vm.downloadCsvalidations}})])],1)],1)]),_vm._v(" "),_c('b-card',{attrs:{"border-variant":"info","align":"left"}},[_c('p',{staticClass:"card-text"},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_c('b-col',[_c('label',[_vm._v("Validation Name")]),_vm._v(" "),_c('b-form-input',{attrs:{"plain":true},model:{value:(_vm.editValidationName),callback:function ($$v) {_vm.editValidationName=$$v},expression:"editValidationName"}})],1),_vm._v(" "),_c('b-col',[_c('label',[_vm._v("Error Message")]),_vm._v(" "),_c('b-form-input',{attrs:{"plain":true},model:{value:(_vm.editErrorMessage),callback:function ($$v) {_vm.editErrorMessage=$$v},expression:"editErrorMessage"}})],1),_vm._v(" "),_c('b-col',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isOptional),expression:"isOptional"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isOptional)?_vm._i(_vm.isOptional,null)>-1:(_vm.isOptional)},on:{"change":function($event){var $$a=_vm.isOptional,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isOptional=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isOptional=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isOptional=$$c}}}}),_vm._v(" "),_c('label',[_vm._v("Optional Validation")])])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"8"}},[_c('label',[_vm._v("Rules")]),_vm._v(" "),_c('b-form-textarea',{attrs:{"placeholder":"Rules","rows":"4"},model:{value:(_vm.editRule),callback:function ($$v) {_vm.editRule=$$v},expression:"editRule"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"align":"center"}},[_c('b-btn',{attrs:{"size":"sm","variant":"secondary mr-1","disabled":!(_vm.templateDoc.selectedTemplateDocId && _vm.selectedTemplate && _vm.selectedTemplateVersion)},on:{"click":_vm.clearValidations}},[_vm._v("Clear")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"secondary mr-1","disabled":!(_vm.editValidationName && _vm.editErrorMessage)},on:{"click":_vm.saveValidations}},[_vm._v("Save")])],1)],1)],1)],1),_vm._v(" "),_vm._l((this.customValidations),function(validation,index){return _c('b-col',{key:validation.id,attrs:{"cols":"6"}},[_c('b-card',[_c('b-card',{attrs:{"border-variant":"info","align":"left"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('h5',[_vm._v(_vm._s(validation.validation_name))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('div',{staticClass:"float-right add-field-btn"},[_c('b-btn',{staticStyle:{"padding":"1px 10px","border-radius":"10px"},attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){_vm.editCustomValidation(index, validation)}}},[_c('i',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('b-btn',{staticStyle:{"padding":"1px 10px","border-radius":"10px"},attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){_vm.deleteCustomValidation(validation.id)}}},[_c('i',{staticClass:"fa fa-trash"})])],1)])],1)],1),_vm._v(" "),_c('p',{staticClass:"card-text"},[_c('b-col',[_c('label',[_vm._v("Error Message")]),_vm._v(" "),_c('b-form-input',{attrs:{"plain":true,"readonly":""},model:{value:(validation.error_message),callback:function ($$v) {_vm.$set(validation, "error_message", $$v)},expression:"validation.error_message"}})],1),_vm._v(" "),_c('b-col',[_c('label',[_vm._v("Rules")]),_vm._v(" "),_c('b-form-textarea',{attrs:{"placeholder":"Rules","readonly":"","rows":"4"},model:{value:(validation.rules),callback:function ($$v) {_vm.$set(validation, "rules", $$v)},expression:"validation.rules"}})],1)],1)])],1)],1)})],2):_vm._e()],1),_vm._v(" "),_c('b-modal',{ref:"externalCustomImportValidationModal",staticClass:"external-service-validation-modal",attrs:{"id":"importValidations","size":"lg","title":"Import Validations","hide-footer":"","header-bg-variant":"light"},on:{"hidden":_vm.onHidingExtSerValModal}},[_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_vm._v("Select Template:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7 text-left"}},[_c('b-form-select',{staticClass:"modelSelect",attrs:{"plain":true,"options":_vm.availableTemplateDocs,"placeholder":"Select Template"},model:{value:(_vm.templateDoc.selectedTemplateDocId),callback:function ($$v) {_vm.$set(_vm.templateDoc, "selectedTemplateDocId", $$v)},expression:"templateDoc.selectedTemplateDocId"}})],1)],1)],1)],1)],1),_vm._v(" "),(_vm.showVersionsRow)?_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_vm._v("Select Page:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.availableTemplates},on:{"change":_vm.fetchTemplateVersion},model:{value:(_vm.selectedTemplate),callback:function ($$v) {_vm.selectedTemplate=$$v},expression:"selectedTemplate"}})],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_vm._v("Select Version:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7 text-left"}},[_c('b-form-select',{attrs:{"plain":true,"options":_vm.availableTemplateVersions},on:{"change":_vm.handleSelectedVersion},model:{value:(_vm.selectedTemplateVersion),callback:function ($$v) {_vm.selectedTemplateVersion=$$v},expression:"selectedTemplateVersion"}})],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_vm._v("Select File:")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8 text-left"}},[_c('input',{ref:"file",attrs:{"id":"fileUpload","type":"file"},on:{"change":function($event){_vm.handleFileUpload()}}})])],1)],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"4"}}),_vm._v(" "),_c('div',[_c('b-btn',{attrs:{"size":"sm","variant":"secondary","disabled":!_vm.isFileSelected},on:{"click":_vm.saveImportValidations}},[_vm._v(" "+_vm._s(_vm.$t('CONFIGURED.CREATE'))+" ")]),_vm._v(" "),_c('b-btn',{attrs:{"size":"sm","variant":"light"},on:{"click":_vm.hideImportValidations}},[_vm._v(" "+_vm._s(_vm.$t('COMMON.CLOSE'))+" ")])],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"deleteModal",attrs:{"centered":"","id":"deleteModal","title":_vm.$t('COMMON.DELETE_CONFIRM'),"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","ok-title":_vm.$t('COMMON.DELETE'),"cancel-title":_vm.$t('COMMON.CANCEL'),"ok-variant":"secondary","cancel-variant":"light"},on:{"cancel":_vm.cancel,"ok":_vm.deleteExternalServiceValidation},nativeOn:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.deleteExternalServiceValidation($event)}}},[_c('div',{staticClass:"delete-warning"},[_c('p',[_vm._v(_vm._s(_vm.$t('COMMON.DEL_CUSTOMVALIDATION')))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_apiResponseJsonFormatter_vue__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_apiResponseJsonFormatter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_apiResponseJsonFormatter_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_apiResponseJsonFormatter_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_apiResponseJsonFormatter_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5d149a0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_apiResponseJsonFormatter_vue__ = __webpack_require__(1305);
function injectStyle (ssrContext) {
  __webpack_require__(1287)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b5d149a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_apiResponseJsonFormatter_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5d149a0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_apiResponseJsonFormatter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-col',{attrs:{"cols":"6"}},[_c('h4',[_vm._v("API-Response Json Formatter")])])],1),_vm._v(" "),_c('b-tabs',_vm._l((_vm.templates),function(template){return _c('b-tab',{key:template.title,attrs:{"title":template.title}},[_c('b-tabs',{attrs:{"pills":""}},_vm._l((template.pages),function(page){return _c('b-tab',{key:page.page_no,attrs:{"title":("Page " + (page.page_no))}},[_c('div',{staticClass:"field-wrapper"},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.handleSubmit(template.title, page.page_no)}}},[_vm._l((page.mappings),function(mapping,index){return _c('b-row',{key:index},[_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"label-for":((template.title) + "_" + (page.page_no) + "_" + (mapping.json_key))}},[[_vm._v("\n                      "+_vm._s(mapping.template_mapping_key)+":\n                      "),(_vm.isFieldEdited(template.title, page.page_no, mapping.json_key))?_c('span',{staticClass:"text-success ml-2"},[_vm._v("✔ Edited")]):_vm._e()],_vm._v(" "),_c('b-form-input',{attrs:{"id":((template.title) + "_" + (page.page_no) + "_" + (mapping.json_key)),"placeholder":("Enter " + (mapping.template_mapping_key.toLowerCase()))},on:{"input":function($event){_vm.markEdited(template.title, page.page_no, mapping.json_key)}},model:{value:(_vm.formData[template.title][page.page_no][mapping.json_key]),callback:function ($$v) {_vm.$set(_vm.formData[template.title][page.page_no], mapping.json_key, $$v)},expression:"formData[template.title][page.page_no][mapping.json_key]"}})],2)],1)],1)}),_vm._v(" "),_c('b-button',{staticClass:"btn mt-auto btn-secondary btn-md",attrs:{"type":"submit","size":"sm"}},[_vm._v("Save")])],2)],1)])}))],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_brands_vue__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_brands_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_brands_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_brands_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_brands_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25e412e4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_brands_vue__ = __webpack_require__(1308);
function injectStyle (ssrContext) {
  __webpack_require__(1307)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25e412e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_brands_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25e412e4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_brands_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-row',{staticClass:"mb-3 header"},[_c('b-col',[_c('h5',[_vm._v("Brands")])]),_vm._v(" "),_c('b-col',{staticClass:"text-right"},[_c('b-button',{attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.openAddModal}},[_vm._v("\n          + Add\n        ")])],1)],1),_vm._v(" "),(_vm.loading)?_c('content-placeholders',_vm._l((6),function(n){return _c('content-placeholders-img',{key:n,style:({ height: '60px', marginBottom: '10px' })})})):_c('b-row',{staticClass:"labelBody"},_vm._l((_vm.brands),function(brand){return _c('div',{key:brand.id,staticClass:"currFields"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_vm._v("\n          "+_vm._s(brand.name)+"\n          "),_c('a',{on:{"click":function($event){_vm.openEditModal(brand)}}},[_c('i',{staticClass:"fa fa-pencil"})])])])}))],1),_vm._v(" "),_c('b-modal',{ref:"brandModal",attrs:{"title":_vm.modalTitle,"hide-footer":""}},[_c('b-form-group',{attrs:{"label":"Brand name"}},[_c('b-form-input',{on:{"input":_vm.checkDuplicate},model:{value:(_vm.brandName),callback:function ($$v) {_vm.brandName=$$v},expression:"brandName"}}),_vm._v(" "),(_vm.duplicateError)?_c('small',{staticClass:"text-danger"},[_vm._v("\n        Brand already exists\n      ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('b-button',{attrs:{"size":"sm","variant":"secondary","disabled":_vm.duplicateError || !_vm.brandName},on:{"click":_vm.saveBrand}},[_vm._v("\n        Save\n      ")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm","variant":"light"},on:{"click":function($event){_vm.$refs.brandModal.hide()}}},[_vm._v("\n        Cancel\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',{staticClass:"configurations",attrs:{"content-class":"pt-1"}},[_c('b-tab',{attrs:{"title":"System"}},[_c('b-row',{attrs:{"justify-content-md":""}},[_c('b-col',{attrs:{"md":"12","lg":"6"}},[_c('confidence-colors'),_vm._v(" "),_c('brands')],1),_vm._v(" "),_c('b-col',{attrs:{"md":"12","lg":"6"}},[_c('doc-retention',{attrs:{"retentionTime":this.retentionTime,"retentionDaysCount":this.retentionDaysCount}}),_vm._v(" "),_c('doc-escalation-time',{attrs:{"escalation-time":this.escalationTime,"escalationDaysCount":this.escalationDaysCount}}),_vm._v(" "),_c('process-type'),_vm._v(" "),_c('process-order'),_vm._v(" "),_c('role-order'),_vm._v(" "),_c('auto-processing',{attrs:{"is_auto_processing":this.is_auto_processing}}),_vm._v(" "),_c('local-time',{attrs:{"local_time":this.local_time}}),_vm._v(" "),_c('authConfig')],1)],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Service Mappings"}},[_c('b-row',{attrs:{"justify-content-md":""}},[_c('b-col',{attrs:{"md":"12"}},[_c('external-service-maps')],1)],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Service Validations"}},[_c('b-row',{attrs:{"justify-content-md":""}},[_c('b-col',{attrs:{"md":"12"}},[_c('external-service-validations')],1)],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Custom Validations"}},[_c('b-row',{attrs:{"justify-content-md":""}},[_c('b-col',{attrs:{"md":"12"}},[_c('custom-validations')],1)],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Manage Fields"}},[_c('b-row',{attrs:{"justify-content-md":""}},[_c('b-col',{attrs:{"md":"12"}},[_c('manageFields')],1)],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Auto Correct"}},[_c('b-row',{attrs:{"justify-content-md":""}},[_c('b-col',{attrs:{"md":"12"}},[_c('autoCorrect')],1)],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"API-Response Json Formatter"}},[_c('b-row',{attrs:{"justify-content-md":""}},[_c('b-col',{attrs:{"md":"12"}},[_c('api-response-json-formatter')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formStatus_vue__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formStatus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formStatus_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formStatus_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formStatus_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13257a4c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formStatus_vue__ = __webpack_require__(1311);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formStatus_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13257a4c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-table',{attrs:{"striped":"","items":_vm.templateDocs,"fields":_vm.templateFields},scopedSlots:_vm._u([{key:"enabled",fn:function(data){return [_c('label',{staticClass:"switch switch-3d switch-success"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(data.item.enabled),expression:"data.item.enabled"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(data.item.enabled)?_vm._i(data.item.enabled,null)>-1:(data.item.enabled)},on:{"change":[function($event){var $$a=data.item.enabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(data.item.enabled=$$a.concat([$$v]))}else{$$i>-1&&(data.item.enabled=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(data.item, "enabled", $$c)}},function($event){_vm.updateStatus(data.item)}]}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accounts_vue__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accounts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accounts_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accounts_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accounts_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3e69ce2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_accounts_vue__ = __webpack_require__(1314);
function injectStyle (ssrContext) {
  __webpack_require__(1313)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b3e69ce2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accounts_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3e69ce2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_accounts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"md":"10","offset-md":"1"}},[_c('SearchBar',{attrs:{"title":_vm.$t('ACCOUNT.LIST')},on:{"filterInput":_vm.setFilter}}),_vm._v(" "),(_vm.accountsLoaded)?_c('b-table',{attrs:{"show-empty":"","empty-text":_vm.$t('COMMON.NO_RECORD'),"responsive":"sm","items":_vm.accounts,"fields":_vm.accountFields,"filter":_vm.filter},scopedSlots:_vm._u([{key:"name",fn:function(data){return [_c('router-link',{attrs:{"id":"accountLink","to":'/super_admin/accounts/' + data.item.id}},[_vm._v("\n            "+_vm._s(data.value)+"\n          ")])]}},{key:"users_count",fn:function(data){return [_c('a',{key:data.item.id,staticClass:"container",attrs:{"id":'account' + data.item.id},on:{"mouseover":function($event){_vm.fetchUsers(data.item.id)}}},[_vm._v(" "+_vm._s(data.value)+"\n            "),_c('b-popover',{attrs:{"target":'account' + data.item.id}},[_c('b-row',{staticClass:"closePopOver"},[_c('i',{staticClass:"fa fa-close popOverClose",attrs:{"aria-hidden":"true"},on:{"click":_vm.closePopOver}})]),_vm._v(" "),_c('b-row',{staticClass:"userlist"},[(!_vm.usersLoaded)?_c('div',[_c('i',{staticClass:"fa fa-spinner fa-pulse fa-2x fa-fw"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"popOverBody"}},_vm._l((_vm.popOverContent),function(user){return (_vm.usersLoaded)?_c('div',{staticClass:"userlink"},[_c('router-link',{attrs:{"id":"users","to":'/admin/users/' + user.id}},[_vm._v("\n                      "+_vm._s(user.email)+"\n                    ")])],1):_vm._e()})),_vm._v(" "),(_vm.popOverContent.length === 0 && _vm.usersLoaded)?_c('div',[_vm._v("\n                     No Users found\n                ")]):_vm._e()])],1)],1)]}},{key:"account_type",fn:function(data){return [_vm._v(_vm._s(data.value))]}},{key:"expires_at",fn:function(data){return [_vm._v(_vm._s(data.value))]}},{key:"status",fn:function(data){return data.item.id > 1?[_c('router-link',{attrs:{"to":'/admin/new'}},[_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-user-plus mr-2",attrs:{"title":_vm.$t('USERS.ADD_NEW')}})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"size":"sm","variant":data.value === 'ACTIVE' ? 'success' : 'danger',"title":data.value === 'ACTIVE' ? _vm.$t('COMMON.DEACTIVATE') : _vm.$t('COMMON.ACTIVATE'),"disabled":data.value === 'DELETING' || data.item.inactive_type === 'date'},on:{"click":function($event){_vm.handleAccountStatus(data)}}},[_vm._v("\n            "+_vm._s(data.value)+"\n          ")]),_vm._v(" "),_c('router-link',{attrs:{"to":'/super_admin/accounts/' + data.item.id}},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"ml-2",attrs:{"size":"sm","variant":"primary","title":_vm.$t('COMMON.EDIT'),"disabled":data.value === 'DELETING'}},[_vm._v("\n              "+_vm._s(_vm.$t('COMMON.EDIT').toUpperCase())+"\n            ")])],1),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"ml-2",attrs:{"size":"sm","variant":"danger","title":_vm.$t('COMMON.DELETE_PERMANENTLY'),"disabled":data.value === 'DELETING'},on:{"click":function($event){_vm.confirmDeleteAccount(data)}}},[_c('i',{staticClass:"fa fa-trash"})])]:undefined}}])}):_c('b-card',[_c('content-placeholders',[_c('content-placeholders-img',{style:({height: '400px'})})],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"deleteAccountModal",attrs:{"hide-header-close":"","centered":"","title":_vm.$t('COMMON.DELETE_CONFIRM'),"ok-title":_vm.$t('COMMON.DELETE'),"cancel-title":_vm.$t('COMMON.CANCEL'),"ok-variant":"secondary","cancel-variant":"light"},on:{"hidden":_vm.cancelDelete,"ok":_vm.deleteAccount}},[_c('div',{staticClass:"delete-warning"},[_c('p',[_vm._v(_vm._s(_vm.$t('COMMON.MSG_DEL')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('COMMON.MSG_PERM_DEL')))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newAccount_vue__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newAccount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newAccount_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newAccount_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newAccount_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_379de56f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newAccount_vue__ = __webpack_require__(1317);
function injectStyle (ssrContext) {
  __webpack_require__(1316)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-379de56f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newAccount_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_379de56f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newAccount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-col',{attrs:{"xl":"4","md":"6","offset-xl":"4","offset-md":"3"}},[_c('b-card',{attrs:{"bg-variant":"light","header-tag":"h5","header":_vm.$t('ACCOUNT.ADD_NEW'),"header-class":"card-header-center card-header-primary card-header-uppercase","footer-class":"card-footer-between"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('COMMON.NAME')))]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.name),expression:"account.name"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.account.name.$error, 'is-valid': !_vm.$v.account.name.$invalid},attrs:{"type":"text","placeholder":_vm.$t('ACCOUNT.NAME')},domProps:{"value":(_vm.account.name)},on:{"blur":function($event){_vm.$v.account.name.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "name", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.account.name.required)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('ACCOUNT.VALID_BLANK')))]):_vm._e(),_vm._v(" "),(!_vm.$v.account.name.isUnique)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('ACCOUNT.VALID_EXIST')))]):_vm._e(),_vm._v(" "),(!_vm.$v.account.name.minLen)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('ACCOUNT.VALID_MIN')))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"account_type"}},[_vm._v(_vm._s(_vm.$t('ACCOUNT.ACCOUNT_TYPE')))]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")]),_vm._v(" "),_c('b-form-select',{staticClass:"form-control",class:{'is-invalid': _vm.$v.account.account_type.$error, 'is-valid': !_vm.$v.account.account_type.$invalid},attrs:{"plain":true,"options":_vm.account_types},model:{value:(_vm.account.account_type),callback:function ($$v) {_vm.$set(_vm.account, "account_type", $$v)},expression:"account.account_type"}}),_vm._v(" "),(!_vm.$v.account.account_type.required)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('ACCOUNT.VALID_ACCOUNT_TYPE')))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"ocr_engine"}},[_vm._v(_vm._s(_vm.$t('ACCOUNT.OCR_ENGINE')))]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")]),_vm._v(" "),_c('b-form-select',{staticClass:"form-control",class:{'is-invalid': _vm.$v.account.ocr_engine.$error, 'is-valid': !_vm.$v.account.ocr_engine.$invalid},attrs:{"plain":true,"options":_vm.ocr_engines},model:{value:(_vm.account.ocr_engine),callback:function ($$v) {_vm.$set(_vm.account, "ocr_engine", $$v)},expression:"account.ocr_engine"}}),_vm._v(" "),(!_vm.$v.account.ocr_engine.required)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('ACCOUNT.VALID_OCR_ENGINE')))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"expires_at"}},[_vm._v(_vm._s(_vm.$t('ACCOUNT.END_DATE')))]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.expires_at),expression:"account.expires_at"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.account.expires_at.$error, 'is-valid': !_vm.$v.account.expires_at.$invalid},attrs:{"type":"date","min":_vm.currDate,"value":"account.expires_at"},domProps:{"value":(_vm.account.expires_at)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "expires_at", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.account.expires_at.required || !_vm.$v.account.expires_at.isValid)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('ACCOUNT.VALID_END_DATE')))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"process_categories"}},[_vm._v(_vm._s(_vm.$t('ACCOUNT.PROCESS_TYPE')))]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.processCategories,"multiple":true,"max-height":200},model:{value:(_vm.account.process_categories),callback:function ($$v) {_vm.$set(_vm.account, "process_categories", $$v)},expression:"account.process_categories"}}),_vm._v(" "),_c('input',{staticClass:"form-control",class:{'is-invalid': _vm.$v.account.process_categories.$error, 'is-valid': !_vm.$v.account.process_categories.$invalid},attrs:{"hidden":""}}),_vm._v(" "),(!_vm.$v.account.process_categories.isValid)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('ACCOUNT.VALID_PROCESS_TYPE')))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"process_categories"}},[_vm._v("Salesforce System")]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.salesforceExternalSystems,"multiple":false,"max-height":200,"custom-label":_vm.dropDownLabel},model:{value:(_vm.account.salesforce_system),callback:function ($$v) {_vm.$set(_vm.account, "salesforce_system", $$v)},expression:"account.salesforce_system"}}),_vm._v(" "),_c('input',{staticClass:"form-control",class:{'is-invalid': _vm.$v.account.process_categories.$error, 'is-valid': !_vm.$v.account.process_categories.$invalid},attrs:{"hidden":""}}),_vm._v(" "),(!_vm.$v.account.process_categories.isValid)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('ACCOUNT.VALID_PROCESS_TYPE')))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"process_categories"}},[_vm._v("Mulesoft System")]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.mulesoftExternalSystems,"multiple":false,"max-height":200,"custom-label":_vm.dropDownLabel},model:{value:(_vm.account.mulesoft_system),callback:function ($$v) {_vm.$set(_vm.account, "mulesoft_system", $$v)},expression:"account.mulesoft_system"}}),_vm._v(" "),_c('input',{staticClass:"form-control",class:{'is-invalid': _vm.$v.account.process_categories.$error, 'is-valid': !_vm.$v.account.process_categories.$invalid},attrs:{"hidden":""}}),_vm._v(" "),(!_vm.$v.account.process_categories.isValid)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('ACCOUNT.VALID_PROCESS_TYPE')))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"integration_emails"}},[_vm._v(_vm._s(_vm.$t('COMMON.INTEGRATION_EMAILS')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.integration_emails),expression:"integration_emails"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.account.integration_emails.$error, 'is-valid': !_vm.$v.account.integration_emails.$invalid},attrs:{"placeholder":_vm.$t('COMMON.ENTER_MULTIPLE_EMAILS')},domProps:{"value":(_vm.integration_emails)},on:{"input":function($event){if($event.target.composing){ return; }_vm.integration_emails=$event.target.value}}}),_vm._v(" "),(_vm.$v.account.integration_emails.$invalid)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('ACCOUNT.VALID_EMAIL')))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"notification_emails"}},[_vm._v(_vm._s(_vm.$t('COMMON.NOTIFICATION_EMAILS')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.notification_emails),expression:"notification_emails"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.account.notification_emails.$error, 'is-valid': !_vm.$v.account.notification_emails.$invalid},attrs:{"placeholder":_vm.$t('COMMON.ENTER_MULTIPLE_EMAILS')},domProps:{"value":(_vm.notification_emails)},on:{"input":function($event){if($event.target.composing){ return; }_vm.notification_emails=$event.target.value}}}),_vm._v(" "),(_vm.$v.account.notification_emails.$invalid)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('ACCOUNT.VALID_EMAIL')))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"notification_emails"}},[_vm._v(_vm._s(_vm.$t('ACCOUNT.ACCOUNT_LOGO')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{ref:"file",attrs:{"id":"fileUpload","type":"file","accept":"image/png, image/jpeg","required":"true"}}),_vm._v(" "),_c('span',{on:{"click":function($event){_vm.removeFile()}}},[_c('i',{staticClass:"fa fa-times"})])]),_vm._v(" "),_c('b-form-group',[_c('c-switch',{attrs:{"type":"3d","variant":"success"},on:{"change":function($event){_vm.changeAutoExportStatus($event)}}}),_vm._v(" Auto Export to Salesforce\n      ")],1),_vm._v(" "),(_vm.account.salesforce_auto_export)?_c('b-form-group',[_c('div',{staticClass:"range-slider"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.confidenceScore),expression:"account.confidenceScore"}],attrs:{"min":"0","max":"100","step":"1","type":"range"},domProps:{"value":(_vm.account.confidenceScore)},on:{"__r":function($event){_vm.$set(_vm.account, "confidenceScore", $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v(" Select "+_vm._s(_vm.$t('FORMS.CONF_RANGE'))+" : "+_vm._s(_vm.account.confidenceScore)+" - 100")])]),_vm._v(" "),_c('div',{staticClass:"note"},[_vm._v("Note: Select Confidence Range to auto export Data to Sales force if confidence range meets the criteria. Default Range is 90-100")])]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{staticClass:"padding-x-2",attrs:{"type":"submit","size":"sm","variant":"secondary"},on:{"click":function($event){_vm.createAccount()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" "+_vm._s(_vm.$t('COMMON.SUBMIT'))+" ")]),_vm._v(" "),_c('b-button',{staticClass:"padding-x-2",attrs:{"type":"reset","size":"sm","variant":"gray"},on:{"click":function($event){_vm.resetForm()}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" "+_vm._s(_vm.$t('COMMON.RESET'))+" ")])],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"errorsModal",attrs:{"title":_vm.$t('ACCOUNT.ERRORS'),"centered":"","hide-footer":""},on:{"hidden":_vm.hideErrorsModal}},[_c('b-container',{attrs:{"fluid":""}},[_c('div',[_c('b-row',{staticClass:"mb-1 text-center"},[_c('b-col',{attrs:{"cols":"6"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('ACCOUNT.EMAIL')))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('ACCOUNT.REASON')))])])],1),_vm._v(" "),_vm._l((_vm.errors),function(error,index){return _c('b-row',{key:error.email + index,staticClass:"mb-1 text-center"},[_c('b-col',{staticClass:"warning",attrs:{"cols":"6"}},[_vm._v(_vm._s(error.email)+" ")]),_vm._v(" "),_c('b-col',{staticClass:"warning",attrs:{"cols":"6"}},[_vm._v(_vm._s(_vm.$t(("ACCOUNT." + (error.reason))))+" ")])],1)})],2)])],1),_vm._v(" "),_c('b-modal',{ref:"logoDeleteModal",attrs:{"title":_vm.$t('COMMON.DELETE_CONFIRM'),"id":"modal-center","centered":"","cancel-title":_vm.$t('COMMON.NO'),"ok-title":_vm.$t('COMMON.YES')},on:{"ok":_vm.deleteFile}},[_c('p',{staticClass:"my-4"},[_vm._v(" "+_vm._s(_vm.$t('ACCOUNT.DELETE_CONTENT')))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editAccount_vue__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editAccount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editAccount_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editAccount_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editAccount_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25b241d6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editAccount_vue__ = __webpack_require__(1320);
function injectStyle (ssrContext) {
  __webpack_require__(1319)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25b241d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editAccount_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25b241d6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editAccount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-col',{attrs:{"xl":"4","md":"6","offset-xl":"4","offset-md":"3"}},[_c('b-card',{attrs:{"bg-variant":"light","header-tag":"h5","header":_vm.$t('ACCOUNT.EDIT_ACCOUNT'),"header-class":"card-header-center card-header-primary card-header-uppercase","footer-class":"card-footer-between"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('COMMON.NAME')))]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.name),expression:"account.name"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.account.name.$error, 'is-valid': !_vm.$v.account.name.$invalid},attrs:{"type":"text","placeholder":_vm.$t('ACCOUNT.NAME'),"value":"account.name"},domProps:{"value":(_vm.account.name)},on:{"blur":function($event){_vm.$v.account.name.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "name", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.account.name.required)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('ACCOUNT.VALID_BLANK')))]):_vm._e(),_vm._v(" "),(!_vm.$v.account.name.isUnique)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('ACCOUNT.VALID_EXIST')))]):_vm._e(),_vm._v(" "),(!_vm.$v.account.name.minLen)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('ACCOUNT.VALID_MIN')))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"account_type"}},[_vm._v(_vm._s(_vm.$t('ACCOUNT.ACCOUNT_TYPE')))]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")]),_vm._v(" "),_c('b-form-select',{staticClass:"form-control",class:{'is-invalid': _vm.$v.account.account_type.$error, 'is-valid': !_vm.$v.account.account_type.$invalid},attrs:{"plain":true,"options":_vm.account_types},model:{value:(_vm.account.account_type),callback:function ($$v) {_vm.$set(_vm.account, "account_type", $$v)},expression:"account.account_type"}}),_vm._v(" "),(!_vm.$v.account.account_type.required)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('ACCOUNT.VALID_ACCOUNT_TYPE')))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"ocr_engine"}},[_vm._v(_vm._s(_vm.$t('ACCOUNT.OCR_ENGINE')))]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")]),_vm._v(" "),_c('b-form-select',{staticClass:"form-control",class:{'is-invalid': _vm.$v.account.ocr_engine.$error, 'is-valid': !_vm.$v.account.ocr_engine.$invalid},attrs:{"plain":true,"options":_vm.ocr_engines},model:{value:(_vm.account.ocr_engine),callback:function ($$v) {_vm.$set(_vm.account, "ocr_engine", $$v)},expression:"account.ocr_engine"}}),_vm._v(" "),(!_vm.$v.account.ocr_engine.required)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('ACCOUNT.VALID_OCR_ENGINE')))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"expires_at"}},[_vm._v(_vm._s(_vm.$t('ACCOUNT.END_DATE')))]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.expires_at),expression:"account.expires_at"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.account.expires_at.$error, 'is-valid': !_vm.$v.account.expires_at.$invalid},attrs:{"type":"date","min":_vm.currDate,"value":"account.expires_at"},domProps:{"value":(_vm.account.expires_at)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "expires_at", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.account.expires_at.required || !_vm.$v.account.expires_at.isValid)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('ACCOUNT.VALID_END_DATE')))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"process_categories"}},[_vm._v(_vm._s(_vm.$t('ACCOUNT.PROCESS_TYPE')))]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.processCategories,"multiple":true,"max-height":200},model:{value:(_vm.account.process_categories),callback:function ($$v) {_vm.$set(_vm.account, "process_categories", $$v)},expression:"account.process_categories"}}),_vm._v(" "),_c('input',{staticClass:"form-control",class:{'is-invalid': _vm.$v.account.process_categories.$error, 'is-valid': !_vm.$v.account.process_categories.$invalid},attrs:{"hidden":""}}),_vm._v(" "),(!_vm.$v.account.process_categories.isValid)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('ACCOUNT.VALID_PROCESS_TYPE')))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"process_categories"}},[_vm._v("Salesforce System")]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.salesforceExternalSystems,"multiple":false,"max-height":200,"custom-label":_vm.dropDownLabel},model:{value:(_vm.account.salesforce_system),callback:function ($$v) {_vm.$set(_vm.account, "salesforce_system", $$v)},expression:"account.salesforce_system"}}),_vm._v(" "),_c('input',{staticClass:"form-control",class:{'is-invalid': _vm.$v.account.process_categories.$error, 'is-valid': !_vm.$v.account.process_categories.$invalid},attrs:{"hidden":""}}),_vm._v(" "),(!_vm.$v.account.process_categories.isValid)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('ACCOUNT.VALID_PROCESS_TYPE')))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"process_categories"}},[_vm._v("Mulesoft System")]),_vm._v(" "),_c('span',{staticClass:"required"},[_vm._v("*")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.mulesoftExternalSystems,"multiple":false,"max-height":200,"custom-label":_vm.dropDownLabel},model:{value:(_vm.account.mulesoft_system),callback:function ($$v) {_vm.$set(_vm.account, "mulesoft_system", $$v)},expression:"account.mulesoft_system"}}),_vm._v(" "),_c('input',{staticClass:"form-control",class:{'is-invalid': _vm.$v.account.process_categories.$error, 'is-valid': !_vm.$v.account.process_categories.$invalid},attrs:{"hidden":""}}),_vm._v(" "),(!_vm.$v.account.process_categories.isValid)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('ACCOUNT.VALID_PROCESS_TYPE')))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"integration_emails"}},[_vm._v(_vm._s(_vm.$t('COMMON.INTEGRATION_EMAILS')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.integration_emails),expression:"integration_emails"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.account.integration_emails.$error, 'is-valid': !_vm.$v.account.integration_emails.$invalid},attrs:{"value":"integration_emails","placeholder":_vm.$t('COMMON.ENTER_MULTIPLE_EMAILS')},domProps:{"value":(_vm.integration_emails)},on:{"input":function($event){if($event.target.composing){ return; }_vm.integration_emails=$event.target.value}}}),_vm._v(" "),(_vm.$v.account.integration_emails.$invalid)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('ACCOUNT.VALID_EMAIL')))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"notification_emails"}},[_vm._v(_vm._s(_vm.$t('COMMON.NOTIFICATION_EMAILS')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.notification_emails),expression:"notification_emails"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.account.notification_emails.$error, 'is-valid': !_vm.$v.account.notification_emails.$invalid},attrs:{"value":"notification_emails","placeholder":_vm.$t('COMMON.ENTER_MULTIPLE_EMAILS')},domProps:{"value":(_vm.notification_emails)},on:{"input":function($event){if($event.target.composing){ return; }_vm.notification_emails=$event.target.value}}}),_vm._v(" "),(_vm.$v.account.notification_emails.$invalid)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('ACCOUNT.VALID_EMAIL')))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"notification_emails"}},[_vm._v(_vm._s(_vm.$t('ACCOUNT.ACCOUNT_LOGO')))]),_vm._v(" "),(_vm.account_logo_url)?_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"cols":"8"}},[(this.file_image !== null)?_c('b-card',{staticClass:"image-container"},[_c('b-img',{attrs:{"fluid":"","src":_vm.file_image,"alt":"Image"}}),_vm._v(" "),_c('div',{staticClass:"card-overlay"},[_c('div',{staticClass:"btn btn-link"},[_c('i',{staticClass:"fa fa-times-circle fa-2x",on:{"click":function($event){_vm.delete_file_modal()}}})])])],1):_c('div',[(!this.logo_delete)?_c('div',{staticClass:"image-container"},[_c('b-img',{attrs:{"fluid":"","src":_vm._f("withBaseUrl")(_vm.account_logo_url),"alt":"Image"}}),_vm._v(" "),_c('div',{staticClass:"card-overlay"},[_c('div',{staticClass:"btn btn-link"},[_c('i',{staticClass:"fa fa-times-circle fa-2x",on:{"click":function($event){_vm.handle_logo_modal()}}})])])],1):_vm._e()])],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-container',[_c('b-row',[_c('b-col',[_c('b-row',[_c('input',{ref:"file",attrs:{"id":"fileUpload","type":"file","variant":"secondary","accept":"image/png, image/jpeg","required":"true/"},on:{"change":function($event){_vm.fileHandle()}}}),_vm._v(" "),_c('span',{on:{"click":function($event){_vm.delete_file_modal()}}},[_c('i',{staticClass:"fa fa-times"})])])],1)],1)],1)],1),_vm._v(" "),_c('b-form-group',[_c('c-switch',{attrs:{"type":"3d","variant":"success","checked":_vm.account.salesforce_auto_export},on:{"change":function($event){_vm.changeAutoExportStatus($event)}}}),_vm._v(" Auto Export to Salesforce\n      ")],1),_vm._v(" "),(_vm.account.salesforce_auto_export)?_c('b-form-group',[_c('div',{staticClass:"range-slider"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.confidenceScore),expression:"account.confidenceScore"}],attrs:{"min":"0","max":"100","step":"1","type":"range"},domProps:{"value":(_vm.account.confidenceScore)},on:{"__r":function($event){_vm.$set(_vm.account, "confidenceScore", $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v(" Select "+_vm._s(_vm.$t('FORMS.CONF_RANGE'))+" : "+_vm._s(_vm.account.confidenceScore)+" - 100")])]),_vm._v(" "),_c('div',{staticClass:"note"},[_vm._v("Note: Select Confidence Range to auto export Data to Sales force if confidence range meets the criteria. Default Range is 90-100")])]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{staticClass:"padding-x-2",attrs:{"type":"submit","size":"sm","variant":"secondary"},on:{"click":function($event){_vm.updateAccount()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" "+_vm._s(_vm.$t('COMMON.SUBMIT'))+" ")]),_vm._v(" "),_c('b-button',{staticClass:"padding-x-2",attrs:{"type":"reset","size":"sm","variant":"gray"},on:{"click":function($event){_vm.resetForm()}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" "+_vm._s(_vm.$t('COMMON.RESET'))+" ")])],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"errorsModal",attrs:{"title":_vm.$t('ACCOUNT.ERRORS'),"centered":"","hide-footer":""},on:{"hidden":_vm.hideErrorsModal}},[_c('b-container',{attrs:{"fluid":""}},[_c('div',[_c('b-row',{staticClass:"mb-1 text-center"},[_c('b-col',{attrs:{"cols":"6"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('ACCOUNT.EMAIL')))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('ACCOUNT.REASON')))])])],1),_vm._v(" "),_vm._l((_vm.errors),function(error,index){return _c('b-row',{key:error.email + index,staticClass:"mb-1 text-center"},[_c('b-col',{staticClass:"warning",attrs:{"cols":"6"}},[_vm._v(_vm._s(error.email)+" ")]),_vm._v(" "),_c('b-col',{staticClass:"warning",attrs:{"cols":"6"}},[_vm._v(_vm._s(_vm.$t(("ACCOUNT." + (error.reason))))+" ")])],1)})],2)])],1),_vm._v(" "),_c('b-modal',{ref:"logoDeleteModal",attrs:{"title":_vm.$t('COMMON.DELETE_CONFIRM'),"id":"modal-center","centered":"","cancel-title":_vm.$t('COMMON.NO'),"ok-title":_vm.$t('COMMON.YES')},on:{"ok":_vm.delete_file}},[_c('p',{staticClass:"my-4"},[_vm._v(" "+_vm._s(_vm.$t('ACCOUNT.DELETE_CONTENT')))])]),_vm._v(" "),_c('b-modal',{ref:"logoUrlModal",attrs:{"title":_vm.$t('COMMON.DELETE_CONFIRM'),"id":"modal-center","centered":"","cancel-title":_vm.$t('COMMON.NO'),"ok-title":_vm.$t('COMMON.YES')},on:{"ok":_vm.logoUrlDelete}},[_c('p',{staticClass:"my-4"},[_vm._v(" "+_vm._s(_vm.$t('ACCOUNT.DELETE_CONTENT')))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_models_vue__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_models_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_models_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_models_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_models_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd481f6e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_models_vue__ = __webpack_require__(1322);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_models_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd481f6e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_models_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('COMMON.NEW_MODEL')))]),_vm._v(" "),_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.addModal",modifiers:{"addModal":true}}],attrs:{"variant":"primary"}},[_vm._v(" + "+_vm._s(_vm.$t('COMMON.ADD_MODEL')))])],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.model_status),function(model){return _c('div',{key:model.id,staticClass:"col-sm-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v(_vm._s(model.name))]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('small',{staticClass:"card-subtitle"},[_c('i',[_vm._v(_vm._s(model.default_name))])])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[(model.status === 'UNDEPLOYED')?[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){_vm.deploy(model.id)}}},[_vm._v(" DEPLOY ")])]:_vm._e(),_vm._v(" "),(model.status === 'DEPLOYED')?[_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){_vm.undeploy(model.id)}}},[_vm._v(" UNDEPLOY ")])]:_vm._e(),_vm._v(" "),(model.status === 'DEPLOYING')?[_c('b-button',{attrs:{"disabled":"","variant":"success"}},[_vm._v(" DEPLOYING ")])]:_vm._e(),_vm._v(" "),(model.status === 'UNDEPLOYING')?[_c('b-button',{attrs:{"disabled":"","variant":"danger"}},[_vm._v(" UNDEPLOYING ")])]:_vm._e(),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"variant":"danger","title":_vm.$t('COMMON.DELETE_PERMANENTLY')},on:{"click":function($event){_vm.confirmDeleteModel(model.id)}}},[_c('i',{staticClass:"fa fa-trash"})])],2)],1)],1)])])})),_vm._v(" "),_c('b-modal',{ref:"modal",attrs:{"id":"addModal","title":"Add New Model"},on:{"show":_vm.resetModal,"hidden":_vm.resetModal,"ok":_vm.handleOk}},[_c('form',{ref:"form",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();_vm.handleOk($event)}}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_c('label',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.$t('FORMS.MODEL_NAME')))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8"}},[_c('b-form-group',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model_name),expression:"model_name"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.model_name.$error, 'is-valid': !_vm.$v.model_name.$invalid},attrs:{"type":"text","placeholder":_vm.$t('COMMON.NAME')},domProps:{"value":(_vm.model_name)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.model_name=$event.target.value},function($event){_vm.$v.model_name.$touch()}]}}),_vm._v(" "),(!_vm.$v.model_name.isUnique)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('COMMON.MODEL_EXIST')))]):_vm._e(),_vm._v(" "),(!_vm.$v.model_name.required)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('FORMS.MODEL_NAME_ERR')))]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_c('label',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.$t('FORMS.SELECT_MODEL')))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8"}},[_c('b-form-group',{attrs:{"invalid-feedback":_vm.$t('FORMS.SELECT_MODEL')}},[_c('b-form-select',{staticClass:"form-control",class:{'is-invalid': _vm.$v.model_id.$error, 'is-valid': !_vm.$v.model_id.$invalid},attrs:{"options":_vm.setOptions},model:{value:(_vm.model_id),callback:function ($$v) {_vm.model_id=$$v},expression:"model_id"}})],1)],1)],1)],1)]),_vm._v(" "),_c('b-modal',{ref:"delete_model",attrs:{"hide-header-close":"","centered":"","title":_vm.$t('COMMON.DELETE_CONFIRM'),"ok-title":_vm.$t('COMMON.DELETE'),"cancel-title":_vm.$t('COMMON.CANCEL'),"ok-variant":"secondary","cancel-variant":"light"},on:{"hidden":_vm.cancelDelete,"ok":_vm.deleteModel}},[_c('div',{staticClass:"delete-warning"},[_c('p',[_vm._v("The Model will be deleted from the system")]),_vm._v(" "),_c('p',[_vm._v("Are you sure you want to delete?")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae72de1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(1324);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae72de1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn dash-main"},[_c('b-row',[_c('b-col',{attrs:{"md":"12","lg":"4"}},[_c('router-link',{attrs:{"to":{ path: '/templates'}}},[_c('b-card',{staticClass:"dash-box",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"p-6"},[_c('b-row',{staticClass:"dash-row"},[_c('b-col',{staticClass:"pr-0",attrs:{"xs":"9"}},[_c('h1',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.$t('Templates')))]),_vm._v(" "),_c('h4',[_c('animated-number',{attrs:{"value":_vm.totalTemplate || 0,"formatValue":_vm.formatNumber,"duration":1000}})],1)]),_vm._v(" "),_c('b-col',{attrs:{"xs":"9"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.svg.templates)}})])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"12","lg":"8"}},[_c('router-link',{attrs:{"to":{ path: '/process/processed'}}},[_c('b-card',{staticClass:"dash-box",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-6"},[_c('b-row',{staticClass:"dash-row"},[_c('b-col',{attrs:{"cols":"10"}},[_c('h1',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.$t('Forms')))]),_vm._v(" "),_c('div',{staticClass:"process-datas"},_vm._l((_vm.processForms),function(count,processed){return _c('div',{staticClass:"process-data"},[_c('h4',{class:'processed-' + processed},[_c('animated-number',{attrs:{"value":count || 0,"formatValue":_vm.formatNumber,"duration":1500}})],1),_vm._v(" "),_c('h3',{},[_vm._v(" "+_vm._s(_vm.$t('COMMON.'+processed.toUpperCase()))+" ")])])}))]),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.svg.forms)}})])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"second-row"},_vm._l((_vm.boxes),function(box,index){return (box.show)?_c('b-col',{key:index,attrs:{"md":"6","lg":"3"}},[_c('router-link',{attrs:{"to":{ path: box.path }}},[_c('b-card',{staticClass:"dash-box",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-6"},[_c('b-row',{staticClass:"dash-row"},[_c('b-col',{attrs:{"xs":"7"}},[_c('h1',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.$t(box.name)))])]),_vm._v(" "),_c('b-col',{attrs:{"xs":"5"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.svg[box.icon])}})])],1)],1)],1)],1)],1):_vm._e()}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddd75c4e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1327);
function injectStyle (ssrContext) {
  __webpack_require__(1326)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ddd75c4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddd75c4e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"profile-row"},[_c('b-col',{attrs:{"sm":"10","offset-sm":"1"}},[_c('b-card',[_c('b-row',[(_vm.changePassword)?_c('b-col',{attrs:{"sm":"9"}},[_c('b-container',{staticClass:"divider"},[_c('b-row',[_c('b-col',{staticClass:"profile-block"},[_c('h2',[_vm._v(_vm._s(_vm.$t('PROFILE.INFO')))]),_vm._v(" "),_c('div',{staticClass:"account-info"},[_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('p',{staticClass:"mb-3"},[_c('b',[_vm._v(_vm._s(_vm.$t('USERS.USERNAME'))+":")])])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('p',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.user.username))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('p',{staticClass:"mb-3"},[_c('b',[_vm._v(_vm._s(_vm.$t('USERS.EMAIL'))+":")])])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('p',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.user.email))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('p',{staticClass:"mb-3"},[_c('b',[_vm._v(_vm._s(_vm.$t('USERS.ROLE'))+":")])])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('p',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.getRoles)))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('p',{staticClass:"mb-3"},[_c('b',[_vm._v(_vm._s(_vm.$t('USERS.LAST_LOGIN'))+":")])])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('p',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.lastLogin))])])],1)],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"account-block"},[_c('h2',[_vm._v(_vm._s(_vm.$t('PROFILE.ACCOUNT_INFO')))]),_vm._v(" "),_c('div',{staticClass:"account-info"},[_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('p',{staticClass:"mb-3"},[_c('b',[_vm._v(_vm._s(_vm.$t('ACCOUNT.NAME'))+":")])])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('p',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.getAccountName)))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('PROFILE.MEMBERS')))])])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('p',[_vm._v(_vm._s(_vm.members))])])],1)],1)])],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.changePassword)?_c('b-col',{attrs:{"sm":"9"}},[_c('b-container',{staticClass:"divider"},[_c('b-row',[_c('b-col',{staticClass:"profile-block"},[_c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('AUTH.PWD_CHANGE')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('AUTH.PWD_CURRENT')))]),_vm._v(" "),_c('b-input-group',{staticClass:"mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"icon-lock"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.password),expression:"user.password"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.user.password.$error, 'is-valid': !_vm.$v.user.password.$invalid},attrs:{"type":"password","placeholder":_vm.$t('AUTH.PWD_CURRENT')},domProps:{"value":(_vm.user.password)},on:{"blur":function($event){_vm.$v.user.password.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "password", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.user.password.required)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('USERS.REQ_PASS')))]):_vm._e(),_vm._v(" "),(!_vm.$v.user.password.minLen)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('USERS.REQ_PASS_MIN_LENGHT')))]):_vm._e()],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('AUTH.NEW_PASSWORD')))]),_vm._v(" "),_c('b-input-group',{staticClass:"mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"icon-lock"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.password_new),expression:"user.password_new"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.user.password_new.$error, 'is-valid': !_vm.$v.user.password_new.$invalid},attrs:{"type":"password","placeholder":_vm.$t('AUTH.NEW_PASSWORD')},domProps:{"value":(_vm.user.password_new)},on:{"blur":function($event){_vm.$v.user.password_new.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "password_new", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.user.password_new.required)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('USERS.REQ_PASS')))]):_vm._e(),_vm._v(" "),(!_vm.$v.user.password_new.minLen)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('USERS.REQ_PASS_MIN_LENGHT')))]):_vm._e()],1),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(_vm.$t('AUTH.CONFIRM_PASSWORD'))+" ")]),_vm._v(" "),_c('b-input-group',{staticClass:"mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"icon-lock"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.password_confirm),expression:"user.password_confirm"}],staticClass:"form-control",class:{'is-invalid': _vm.$v.user.password_confirm.$error, 'is-valid': !_vm.$v.user.password_confirm.$invalid},attrs:{"type":"password","placeholder":_vm.$t('AUTH.CONFIRM_PASSWORD')},domProps:{"value":(_vm.user.password_confirm)},on:{"blur":function($event){_vm.$v.user.password_confirm.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "password_confirm", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.user.password_confirm.SameAs)?_c('b-form-invalid-feedback',[_vm._v(_vm._s(_vm.$t('USERS.REQ_NO_MATCH')))]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"text-center"},[_c('b-btn',{staticClass:"save-btn",attrs:{"variant":"light"},on:{"click":_vm.resetUpdatePassword}},[_vm._v(_vm._s(_vm.$t('COMMON.CANCEL')))])],1),_vm._v(" "),_c('b-col',[_c('b-btn',{staticClass:"save-btn",attrs:{"disabled":_vm.$v.$invalid},on:{"click":_vm.updatePassword}},[_vm._v(_vm._s(_vm.$t('COMMON.SAVE')))])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('div',{staticClass:"pfp-container"},[_c('v-gravatar',{staticClass:"pfp",attrs:{"email":_vm.user.email,"alt":_vm.user.email}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.currentUserEmail.split('@')[0])))])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button-group',{staticClass:"d-flex justify-content-center"})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_micpDemo_vue__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_micpDemo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_micpDemo_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_micpDemo_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_micpDemo_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9684d284_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_micpDemo_vue__ = __webpack_require__(1330);
function injectStyle (ssrContext) {
  __webpack_require__(1329)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9684d284"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_micpDemo_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9684d284_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_micpDemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('div',{staticClass:"app-header navbar p-1"},[_c('b-row',{staticStyle:{"width":"100%"}},[_c('b-col',{staticClass:"text-center",attrs:{"sm":"2"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.svg.logo)}})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"sm":"8"}},[_c('h3',{staticClass:"header-title"},[_vm._v("Medical Insurance Cards Processing using Document AI")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-navbar-nav',{staticStyle:{"flex-direction":"column","padding-top":"10px"}},[_c('MicpHeaderAccount')],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('div',{staticClass:"container-fluid p-0"},[_c('b-row',{staticClass:"m-0",staticStyle:{"width":"100%"}},[_c('b-col',{staticClass:"col-sm-12 p-0"},[_c('b-card',{staticClass:"m-0",staticStyle:{"font-size":"16px"}},[_c('b-row',[_c('b-col',{staticClass:"col-sm-12 col-md-10 text-center",attrs:{"offset-md":"1"}},[_vm._v("\n                This solution processes insurance card images that are uploaded, and it extracts the data using Google Document AI. For demonstration purposes, we are processing / extracting limited fields. This solution can be extended to different types of inputs like driver licenses, large forms, invoices and more.\n              ")])],1)],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"m-0",staticStyle:{"width":"100%"}},[_c('b-col',{staticClass:"col-sm-12 col-md-8 p-0 pt-1 pr-1",staticStyle:{"height":"520px"}},[_c('b-card',{staticStyle:{"height":"100%"}},[_c('b-card-body',[_c('div',{staticStyle:{"height":"350px","overflow-y":"scroll"}},[_c('div',{staticClass:"p-3 text-center text-secondary"},[_c('h4',[_vm._v("Upload a scanned copy of insurance card to process")]),_vm._v(" "),_c('h6',[_vm._v("Note: Allowed formats are only pdf and image ( jpg, jpeg, png )")])]),_vm._v(" "),_c('div',{staticClass:"m-3"},[(_vm.isDropzoneBlank)?_c('p',{staticClass:"text-danger upload-file-error"},[_c('b',[_vm._v("Please add a file.")])]):_vm._e(),_vm._v(" "),(_vm.canShowDropZone)?_c('vueDropzone',{ref:"micpProcessDropZone",class:_vm.currentState === 'upload' ? null : 'd-none',attrs:{"id":"dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-file-added":_vm.onAddingFile,"vdropzone-sending":_vm.sendingEvent,"vdropzone-max-files-exceeded":_vm.onExceedingMaxFiles,"vdropzone-removed-file":_vm.onRemovingFile,"vdropzone-success":_vm.processResponse,"vdropzone-error":_vm.displayError}}):_vm._e(),_vm._v(" "),_c('b-row',{class:_vm.currentState === 'processing' ? null : 'd-none'},[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{staticClass:"process-loading"},[_c('content-placeholders',[_c('content-placeholders-img',{style:({height: '150px'})})],1)],1)],1)],1),_vm._v(" "),(_vm.currentState === 'processed')?_c('div',{staticClass:"p-3"},[_c('img',{staticClass:"processed-image",attrs:{"src":_vm.imageUrl}})]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('b-button',{staticClass:"upload-button",attrs:{"variant":"secondary","disabled":!_vm.isUploadEnabled},on:{"click":_vm.processFile}},[(_vm.currentState === 'processing')?_c('i',{staticClass:"fa fa-spinner fa-spin mr-2",staticStyle:{"font-size":"18px"}}):_vm._e(),_vm._v("\n                  "+_vm._s(_vm.buttonState)+"\n                ")])],1)])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"col-sm-12 col-md-4 p-0 pt-1 pl-1",staticStyle:{"height":"520px"}},[_c('b-card',{staticStyle:{"height":"100%"}},[_c('b-card-header',[_c('b-row',[_c('b-col',{staticClass:"col-10 pull-left"},[_c('h5',[_vm._v("Results")])]),_vm._v(" "),_c('b-col',{staticClass:"col-2"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"download-button",attrs:{"title":"Download JSON","variant":"secondary","size":"sm","disabled":!_vm.isDownloadEnabled},on:{"click":_vm.downloadJSON}},[_c('i',{staticClass:"fa fa-download"})])],1)],1)],1),_vm._v(" "),_c('b-card-body',{staticClass:"process-results"},_vm._l((_vm.processedResults),function(value,key){return _c('b-row',{key:key,staticClass:"processed-value"},[_c('b-col',{staticClass:"col-4"},[_vm._v("\n                  "+_vm._s(_vm._f("titlize")(key))+"\n                ")]),_vm._v(" "),_c('b-col',{staticClass:"col-8"},[_vm._v("\n                  : "+_vm._s(value)+"\n                ")])],1)}))],1)],1)],1)],1)]),_vm._v(" "),_c('div',[_c('footer',{staticClass:"app-footer d-flex footer-style"},[_c('b-row',{staticStyle:{"width":"100%"}},[_c('b-col',{attrs:{"sm":"2"}},[_c('h5',{staticClass:"contact-us"},[_vm._v("Contact Us:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('h5',[_c('a',{staticClass:"mail-to",attrs:{"href":"mailto:sureshr@wilcolabz.com"}},[_vm._v("sureshr@wilcolabz.com")]),_vm._v(" "),_c('br'),_vm._v("4677 Old Ironsides Dr, Santa Clara, CA 95054")])])],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vueProgressbar = __webpack_require__(1332);

var _vueProgressbar2 = _interopRequireDefault(_vueProgressbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueProgressbar2.default, {
  color: '#20c997',
  failedColor: 'red',
  height: '2px'
});

/***/ }),
/* 1332 */,
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vueToasted = __webpack_require__(1334);

var _vueToasted2 = _interopRequireDefault(_vueToasted);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toasterOptions = {
  position: 'top-right',
  iconPack: 'fontawesome',
  duration: 3000,
  icon: 'check-circle-o',
  type: 'success'
};

_vue2.default.use(_vueToasted2.default, toasterOptions);
_vue2.default.use(_vueToasted2.default, { router: _router2.default });

/***/ }),
/* 1334 */,
/* 1335 */,
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.filter('withBaseUrl', function (value) {
  if (!value) return '';
  // TODO: This will be used in kubernetes pods. Use env variable
  // return process.env.STATIC_URL + value
  return _vue2.default.axios.defaults.baseURL.replace('/api', '') + value;
});

_vue2.default.filter('titlize', function (value) {
  var stringArray = value.split(' ');
  stringArray = stringArray.map(function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  });
  return stringArray.join(' ');
});

/***/ }),
/* 1337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _interceptors = __webpack_require__(1340);

Object.defineProperty(exports, 'setupInterceptors', {
  enumerable: true,
  get: function get() {
    return _interceptors.setupInterceptors;
  }
});

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(112);

var _axios2 = _interopRequireDefault(_axios);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vueAxios = __webpack_require__(531);

var _vueAxios2 = _interopRequireDefault(_vueAxios);

var _store = __webpack_require__(133);

var _store2 = _interopRequireDefault(_store);

var _axiosAuthRefresh = __webpack_require__(532);

var _axiosAuthRefresh2 = _interopRequireDefault(_axiosAuthRefresh);

var _router = __webpack_require__(15);

var _router2 = _interopRequireDefault(_router);

var _refresh = __webpack_require__(1341);

var _refresh2 = _interopRequireDefault(_refresh);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Axios Configuration
_vue2.default.use(_vueAxios2.default, _axios2.default);

function setupInterceptors(vueApp) {
  (0, _axiosAuthRefresh2.default)(_vue2.default.axios, _refresh2.default);
  _vue2.default.axios.defaults.baseURL = "/api";
  _vue2.default.axios.interceptors.request.use(function (config) {
    if (config.url.includes('/admin') || config.url.includes('/users')) {
      config.headers['Cache-Control'] = 'no-cache, no-store';
      config.headers['Pragma'] = 'no-cache';
      config.headers['Expires'] = '0';
    }
    var token = _store2.default.getters.idToken;
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    vueApp.$Progress.start();
    return config;
  }, function (error) {
    vueApp.$Progress.fail();
    return error;
  });
  _vue2.default.axios.interceptors.response.use(function (config) {
    vueApp.$Progress.finish();
    return config;
  }, function (error) {
    vueApp.$Progress.fail();
    if (error.response && error.response.status === 401 && _router2.default.currentRoute.path !== '/sign_in') {
      _vue2.default.toasted.clear();
      _vue2.default.toasted.show('Session expired, please login to continue', { icon: 'chain-broken', type: 'error', singleton: true });
      _store2.default.dispatch('logOut');
      console.log('sing in route');
      _router2.default.replace('/sign_in?redirect_to=' + encodeURIComponent(_router2.default.currentRoute.fullPath));
    }
    return Promise.reject(error.response);
  });
}

exports.default = setupInterceptors;

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _store = __webpack_require__(133);

var _store2 = _interopRequireDefault(_store);

var _refresh_client = __webpack_require__(1342);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var refreshAuthLogic = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(failedRequest) {
    var refreshToken, data, headers;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!failedRequest.request.responseURL.includes('/logout')) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return', Promise.reject(new Error('Error')));

          case 2:
            refreshToken = _store2.default.getters.refreshToken;
            data = new window.FormData();

            data.append('auth[refresh_token]', refreshToken);
            headers = { headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0'
              } };
            _context.next = 8;
            return _refresh_client.refresherAxiosInstance.post('/refresh', data, headers).then(function (res) {
              var token = res.data.token.token;
              if (token) {
                _store2.default.dispatch('updateToken', { token: token });
                failedRequest.response.config.headers['Authorization'] = 'Bearer ' + token;
                return Promise.resolve();
              } else {
                return Promise.reject(new Error('Error'));
              }
            });

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function refreshAuthLogic(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.default = refreshAuthLogic;

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refresherAxiosInstance = undefined;

var _axios = __webpack_require__(112);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var refresherAxiosInstance = _axios2.default.create();

exports.refresherAxiosInstance = refresherAxiosInstance;

/***/ })
],[533]);


// WEBPACK FOOTER //
// static/js/app.fa7d41e0146cae2a6e21.js